'use strict';

var _regeneratorRuntime = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/regenerator/index.js");
var _toConsumableArray3 = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _taggedTemplateLiteral = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _objectWithoutProperties3 = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _defineProperty3 = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/helpers/defineProperty.js");
var _slicedToArray = require("/home/runner/work/support-site/support-site/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _templateObject;
var _excluded = ["ariaProps", "dataProps"],
  _excluded2 = ["additionalClassName", "ariaProps", "dataProps", "innerElement", "lines", "text"],
  _excluded3 = ["additionalClassName", "metaData", "lines", "__css"],
  _excluded4 = ["datePublished", "lexileRange", "source"],
  _excluded5 = ["datePublished", "duration", "source"],
  _excluded6 = ["dismissOnMouseout", "isOpenByDefault"],
  _excluded7 = ["lifeSpan"],
  _excluded8 = ["assetCount", "datePublished"],
  _excluded9 = ["anchorAriaProps", "datePublished", "source"],
  _excluded10 = ["datePublished", "source"],
  _excluded11 = ["assetCount", "datePublished", "duration"],
  _excluded12 = ["assetCount", "datePublished"],
  _excluded13 = ["title"],
  _excluded14 = ["role"],
  _excluded15 = ["onClick", "key"],
  _excluded16 = ["datePublished", "duration", "source"];
function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _ownKeys(Object(source), !0).forEach(function (key) { _defineProperty3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require("core-js/modules/esnext.global-this.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.flags.js");
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var ui = {
  darkBlue: {
    700: '#001125',
    500: '#031E3E',
    300: '#1F4E85',
    100: '',
    50: ''
  },
  greyDark: {
    700: '#1D1D1D',
    500: '#333333',
    300: '',
    100: '',
    50: ''
  },
  grey: {
    700: '#545454',
    500: '#767676',
    300: '#878787',
    100: '#B6B6B6',
    50: '#DDDDDD'
  },
  greyLight: {
    700: '#767676',
    500: '#959595',
    300: '#BCBCBE',
    100: '#DDDDDD',
    50: '#EAEBEC'
  },
  coreBlue: {
    700: '#0052C4',
    500: '#106FF3',
    300: '#2C83FB',
    100: '#85B8FD',
    50: '#DBEAFF'
  },
  lightBlue: {
    700: '#007AC2',
    500: '#069BF4',
    300: '#28ABFA',
    100: '#83D0FF',
    50: '#D5EFFF'
  },
  green: {
    700: '#3A870F',
    500: '#52A821',
    300: '#64CD28',
    100: '#ABF680',
    50: '#DFFFCD'
  },
  orange: {
    700: '#CA5804',
    500: '#E76A0E',
    300: '#FE971E',
    100: '#FBC27E',
    50: '#FFE1BF'
  },
  red: {
    700: '#C32113',
    500: '#D54235',
    300: '#FF5E4F',
    100: '#FFA49C',
    50: '#FFD6D2'
  },
  yellow: {
    700: '#BFA302',
    500: '#E1C316',
    300: '#FEDD1E',
    100: '#FFF3AF',
    50: '#FFF9DA'
  },
  greyExtraLight: {
    700: '#F8F8F8',
    500: '#F8F8F8',
    300: '#F8F8F8',
    100: '#F8F8F8'
  },
  white: {
    700: '#FFFFFF',
    500: '#FFFFFF',
    300: '#FFFFFF',
    100: '#FFFFFF'
  }
};
var brand = {
  newselaBlue: {
    500: '#1273FA',
    300: '#4C96FB',
    100: '#88B9FB',
    50: '#C4DCFE'
  },
  proBlue: {
    500: '#031E3E',
    300: '#445475',
    100: '#828CA2',
    50: '#C0C6D1'
  },
  lightBlue: {
    500: '#9BE7FF',
    300: '#B4EDFF',
    100: '#CDF3FF',
    50: '#E2FAFF'
  },
  orange: {
    500: '#FE971E',
    300: '#FEB056',
    100: '#FFCB8F',
    50: '#FFE5C8'
  },
  yellow: {
    500: '#FEDD1E',
    300: '#FEE656',
    100: '#FEEE8F',
    50: '#FFF7C7'
  },
  black: {
    500: '#000000',
    300: '#333333',
    100: '#BCBCBE',
    50: '#EAEBEC'
  }
};
var category = {
  newselaBlue: {
    500: '#1273FA'
  },
  warAndPeaceOrange: {
    500: '#FF6900'
  },
  moneyRed: {
    500: '#FA0045'
  },
  kidsPurple: {
    500: '#5908F7'
  },
  scienceTeal: {
    500: '#55BCA6'
  },
  lawDarkBlue: {
    500: '#031E3E'
  },
  healthGreen: {
    500: '#03A43C'
  },
  artsYellow: {
    500: '#FEDD1E'
  },
  sportsGrey: {
    500: '#333333'
  },
  opinionBlue: {
    500: '#0027F5'
  }
};
var status = {
  primary: ui.coreBlue,
  secondary: ui.grey,
  info: ui.lightBlue,
  success: ui.green,
  danger: ui.red,
  warning: ui.orange
};
var colors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ui: ui,
  brand: brand,
  category: category,
  status: status
});
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var inheritsLoose = _inheritsLoose;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */

  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  return tag;
}
var StyleSheet = /*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "development" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);
      var before;
      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }
      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule,
        // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();
function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f += e.charAt(l);
          }
          g = 59;
        }
        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;
            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;
                case 125:
                  k--;
                  break;
                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }
                        l = u;
                      }
                  }
                  break;
                case 91:
                  g++;
                case 40:
                  g++;
                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {}
              }
              if (0 === k) break;
              l++;
            }
            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);
                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;
                  default:
                    r = O;
                }
                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);
                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;
                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;
                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;
              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }
            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;
          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;
              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }
              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }
      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;
        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }
        default:
          z++;
          y = e.charAt(l);
          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;
                default:
                  32 !== g && (y = ' ');
              }
              break;
            case 0:
              y = '\\0';
              break;
            case 12:
              y = '\\f';
              break;
            case 11:
              y = '\\v';
              break;
            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;
            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                case 8:
                  111 === K && (E = K);
              }
              break;
            case 58:
              0 === n + b + m && (u = l);
              break;
            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;
            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;
            case 91:
              0 === n + b + v && m++;
              break;
            case 93:
              0 === n + b + v && m--;
              break;
            case 41:
              0 === n + b + m && v--;
              break;
            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;
                  default:
                    q = 1;
                }
                v++;
              }
              break;
            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;
                    case 220:
                      t = l, b = 42;
                  }
                  break;
                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }
          0 === b && (f += y);
      }
      K = x;
      x = g;
      l++;
    }
    t = p.length;
    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';
      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);
        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;
          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }
        E = 0;
      }
    }
    return G + p + F;
  }
  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
      m = d.length;
    switch (m) {
      case 0:
      case 1:
        var b = 0;
        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }
        break;
      default:
        var v = b = 0;
        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }
    }
    return c;
  }
  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());
      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());
      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }
    return d + c;
  }
  function P(d, c, e, h) {
    var a = d + ';',
      m = 2 * c + 3 * e + 4 * h;
    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }
    if (0 === w || 2 === w && !L(a, 1)) return a;
    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return '-webkit-' + a + a;
      case 978:
        return '-webkit-' + a + '-moz-' + a + a;
      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;
      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;
        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;
          case 232:
            b = a.replace(G, 'tb-rl');
            break;
          case 220:
            b = a.replace(G, 'lr');
            break;
          default:
            return a;
        }
        return '-webkit-' + a + '-ms-' + b + a;
      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;
      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;
          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;
          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }
        return a + ';';
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;
      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }
    return a;
  }
  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
      h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }
  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }
  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          x = w;
      }
    }
    if (x !== c) return x;
  }
  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;
      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }
    return T;
  }
  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }
  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];
    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }
    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }
  var ca = /^\0+/g,
    N = /[\0\r\f]/g,
    aa = /: */g,
    ka = /zoo|gra/,
    ma = /([,: ])(transform)/g,
    ia = /,\r+?/g,
    F = /([\t\r\n ])*\f?&/g,
    fa = /@(k\w+)\s*(\S*)\s*/,
    Q = /::(place)/g,
    ha = /:(read-only)/g,
    G = /[svh]\w+-[tblr]{2}/,
    da = /\(\s*(.*)\s*\)/g,
    oa = /([\s\S]*?);/g,
    ba = /-self|flex-/g,
    na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    la = /stretch|:\s*\w+\-(?:conte|avail)/,
    ja = /([^-])(image-set\()/,
    z = 1,
    D = 1,
    E = 0,
    w = 1,
    O = [],
    S = [],
    A = 0,
    R = null,
    Y = 0,
    V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';
function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}
var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }
        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }
          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }
    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 &&
  // charcode for l
  content.charCodeAt(0) === 108 &&
  // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
    return '';
  }
};
var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }
    if (prefix === false) {
      return prefixFalseCache;
    }
    return getCache(prefix);
  };
});
var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;
  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }
  var stylis = new stylis_min(stylisOptions);
  {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }
  var inserted = {}; // $FlowFixMe

  var container;
  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });
      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }
  var _insert;
  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;
      if (serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }
      stylis(selector, serialized.styles);
      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;
    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        if (
        // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        serialized.map !== undefined) {
          return rules + serialized.map;
        }
        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;
              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }
              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }
            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);
                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }
            break;
          }
      }
    });
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};
var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false ||
  // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
    i = 0,
    len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array

  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.

  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
{
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var shouldWarnAboutInterpolatingClassNameFromCss = true;
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    if (interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          if (interpolation.map !== undefined) {
            styles += interpolation.map;
          }
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }
        break;
      }
    case 'string':
      {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }
      break;
  } // finalize string values (regular strings and functions interpolated into css calls)

  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  if (couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }
  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "development" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                if (_key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;
{
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }
    styles += strings[0];
  } // we start at 1 since we've already handled the first arg

  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
    if (stringMode) {
      if (strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles += strings[i];
    }
  }
  var sourceMap;
  {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time

  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    // $FlowFixMe we know it's not null
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
};
function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var isBrowser$2 = typeof document !== 'undefined';
var EmotionCacheContext = React.createContext(
// we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = React.createContext({});
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe

  return React.forwardRef(render);
};
if (!isBrowser$2) {
  var BasicProvider = /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose(BasicProvider, _React$Component);
    function BasicProvider(props, context, updater) {
      var _this;
      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }
    var _proto = BasicProvider.prototype;
    _proto.render = function render() {
      return React.createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };
    return BasicProvider;
  }(React.Component);
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return React.createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return React.createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles);
  if (serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }
  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && key !== labelPropName) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = React.createElement(type, newProps);
  if (!isBrowser$2 && rules !== undefined) {
    var _ref;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    return React.createElement(React.Fragment, null, React.createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }
  return ele;
};
var Emotion = /* #__PURE__ */
withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }
  return render(cache, props, null, ref);
});
{
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe

var jsx = function jsx(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return React.createElement.apply(undefined, args);
  }
  if (typeof props.css === 'string' &&
  // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  {
    var error = new Error();
    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }
      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }
  createElementArgArray[1] = newProps;
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe

  return React.createElement.apply(null, createElementArgArray);
};
var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var ClassNames = withEmotionCache(function (props, context) {
  return React.createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;
    var css = function css() {
      if (hasRendered && "development" !== 'production') {
        throw new Error('css can only be used during render');
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var serialized = serializeStyles(args, context.registered);
      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);
        if (res !== undefined) {
          rules += res;
        }
      }
      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }
      return context.key + "-" + serialized.name;
    };
    var cx = function cx() {
      if (hasRendered && "development" !== 'production') {
        throw new Error('cx can only be used during render');
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return merge(context.registered, css, classnames(args));
    };
    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;
      return React.createElement(React.Fragment, null, React.createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }
    return ele;
  });
});

/**
 * We want to ensure that our products are as accessible as possible,
 * that means making our text scale with the user's browser's settings.
 * To that end we should use rem where we can.
 */

/********************************************************************
 * FONT FAMILIES
 * include styles for the font family, THEN include font size if needed
 ********************************************************************/

var family = {
  /********************************************************************
   * NOTO SERIF
   * used for diagetic text other than content body text, e.g. titles
   * regular, bold, italic, and bold+italic available
   ********************************************************************/
  noto: {
    name: "463as8-noto",
    styles: "font-family:'Noto Serif',Georgia,serif;font-size:1rem;line-height:1.375rem;;label:noto;"
  },
  /********************************************************************
   * CIRCULAR
   * primary UI font, e.g. modals, buttons, menus, labels, forms etc
   * regular and bold available
   ********************************************************************/
  circular: {
    name: "1gk9k8t-circular",
    styles: "font-family:Circular,Helvetica,Arial,sans-serif;font-size:1rem;line-height:1.375rem;;label:circular;"
  },
  /********************************************************************
   * GEORGIA
   * used exclusively for content text body
   * all weights and styles available
   * note: medium font size is different than the other two
   ********************************************************************/
  georgia: {
    name: "7e2s2r-georgia",
    styles: "font-family:Georgia,serif;font-size:1.15rem;line-height:1.953125rem;;label:georgia;"
  }
};
/********************************************************************
 * FONT SIZES
 ********************************************************************/

var size = {
  // H1 / article headlines / page titles
  XXL: {
    name: "1rat7s6-XXL",
    styles: "font-size:2.375rem;line-height:3.125rem;;label:XXL;"
  },
  // H2 / article feed headlines
  XL: {
    name: "1lh0sig-XL",
    styles: "font-size:1.75rem;line-height:38px;;label:XL;"
  },
  // H3 / section titles
  L: {
    name: "1ux4kd9-L",
    styles: "font-size:1.313rem;line-height:1.75rem;;label:L;"
  },
  // Note: medium font sizes are included with the font declaration
  // ui text / bylines
  S: {
    name: "1m1vh7a-S",
    styles: "font-size:0.875rem;line-height:1.25rem;;label:S;"
  },
  // Buttons (similar to FONT_S but with different line height)
  button: {
    name: "19jt96z-button",
    styles: "font-weight:700;font-size:0.875rem;line-height:0.875rem;;label:button;"
  },
  // Captions / credits / ancillary text
  XS: {
    name: "pqr0a-XS",
    styles: "font-size:0.75rem;line-height:1.125rem;;label:XS;"
  }
};
var typography = /*#__PURE__*/Object.freeze({
  __proto__: null,
  family: family,
  size: size
});

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
  nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs,
      thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime,
      timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
      timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(),
      isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var defaultProps = {
  time: 100
};
function useWindowSize() {
  var debounceObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps;
  var time = debounceObj.time;
  var isClient = typeof window === 'object';
  var getSize = React.useCallback(function () {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }, [isClient]);
  var _React$useState3 = React.useState(getSize),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    windowSize = _React$useState4[0],
    setWindowSize = _React$useState4[1];
  React.useEffect(function () {
    if (!isClient) {
      return;
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    var debouncedResize = debounce(handleResize, time);
    window.addEventListener('resize', debouncedResize);
    return function () {
      return window.removeEventListener('resize', debouncedResize);
    };
  }, [getSize, isClient]);
  return windowSize;
}
var lg = 1440;
var md = 1024;
var sm = 768;
var xs = 375;
/**
 * 0 - 375
 * 376 - 768
 * 769 - 1024
 * 1025 - 1440
 * 1441 - infinity
 */

var Breakpoints = {
  lg: lg,
  md: md,
  sm: sm,
  xs: xs
};
var generateBreakpointNames = function generateBreakpointNames() {
  var result = {};
  Object.keys(Breakpoints).forEach(function (key) {
    return result[key] = key;
  });
  return result;
};
var BreakpointNames = generateBreakpointNames();
var BreakpointRanges = {
  lgToInfinity: 'lg to infinity',
  mdToLg: 'md to lg',
  smToMd: 'sm to md',
  xsToSm: 'xs to sm',
  zeroToXs: 'zero to xs'
};
var getBreakpointRange = function getBreakpointRange(screenSize) {
  if (screenSize <= xs) {
    return BreakpointRanges.zeroToXs;
  } else if (screenSize > xs && screenSize <= sm) {
    return BreakpointRanges.xsToSm;
  } else if (screenSize > sm && screenSize <= md) {
    return BreakpointRanges.smToMd;
  } else if (screenSize > md && screenSize <= lg) {
    return BreakpointRanges.mdToLg;
  } else {
    return BreakpointRanges.lgToInfinity;
  }
};
var breakpoints = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Breakpoints: Breakpoints,
  BreakpointNames: BreakpointNames,
  BreakpointRanges: BreakpointRanges,
  getBreakpointRange: getBreakpointRange,
  useWindowSize: useWindowSize
});
var constants = {
  colors: colors,
  typography: typography,
  breakpoints: breakpoints
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function commonjsRequire() {
  throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
}
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var reactIs_development = createCommonjsModule(function (module, exports) {
  {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1 = reactIs_development.AsyncMode;
var reactIs_development_2 = reactIs_development.ConcurrentMode;
var reactIs_development_3 = reactIs_development.ContextConsumer;
var reactIs_development_4 = reactIs_development.ContextProvider;
var reactIs_development_5 = reactIs_development.Element;
var reactIs_development_6 = reactIs_development.ForwardRef;
var reactIs_development_7 = reactIs_development.Fragment;
var reactIs_development_8 = reactIs_development.Lazy;
var reactIs_development_9 = reactIs_development.Memo;
var reactIs_development_10 = reactIs_development.Portal;
var reactIs_development_11 = reactIs_development.Profiler;
var reactIs_development_12 = reactIs_development.StrictMode;
var reactIs_development_13 = reactIs_development.Suspense;
var reactIs_development_14 = reactIs_development.isAsyncMode;
var reactIs_development_15 = reactIs_development.isConcurrentMode;
var reactIs_development_16 = reactIs_development.isContextConsumer;
var reactIs_development_17 = reactIs_development.isContextProvider;
var reactIs_development_18 = reactIs_development.isElement;
var reactIs_development_19 = reactIs_development.isForwardRef;
var reactIs_development_20 = reactIs_development.isFragment;
var reactIs_development_21 = reactIs_development.isLazy;
var reactIs_development_22 = reactIs_development.isMemo;
var reactIs_development_23 = reactIs_development.isPortal;
var reactIs_development_24 = reactIs_development.isProfiler;
var reactIs_development_25 = reactIs_development.isStrictMode;
var reactIs_development_26 = reactIs_development.isSuspense;
var reactIs_development_27 = reactIs_development.isValidElementType;
var reactIs_development_28 = reactIs_development.typeOf;
var reactIs = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$2.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var printWarning = function printWarning() {};
{
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function () {
  {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function printWarning$1() {};
{
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.');
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  {
    var ReactIs = reactIs;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  }
});
var propTypes_1 = propTypes.array;
var propTypes_4 = propTypes.number;
var propTypes_7 = propTypes.symbol;
var propTypes_10 = propTypes.element;
var propTypes_11 = propTypes.elementType;
var propTypes_12 = propTypes.instanceOf;
var propTypes_14 = propTypes.objectOf;
var propTypes_15 = propTypes.oneOf;
var propTypes_17 = propTypes.shape;
var propTypes_18 = propTypes.exact;
var propTypes_19 = propTypes.checkPropTypes;
var propTypes_20 = propTypes.resetWarningCache;
var propTypes_21 = propTypes.PropTypes;
var style = function style(_ref8) {
  var src = _ref8.src,
    xPos = _ref8.xPos,
    yPos = _ref8.yPos;
  return {
    backgroundImage: "url(".concat(src, ")"),
    backgroundSize: 'cover',
    width: '100%',
    height: '100%',
    backgroundPosition: "".concat(xPos, " ").concat(yPos),
    backgroundRepeat: 'no-repeat',
    borderRadius: 'inherit'
  };
};
var AngelouProps = {
  /** A object representing css rules to override the default
   * values of the component. should be written in camelCase
   */
  __css: propTypes.oneOfType([propTypes.object, propTypes.string, propTypes.array]),
  /**
   * Optional className that will be appended to the component classname
   */
  additionalClassName: propTypes.string
};
var imgProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * alt for the image
   */
  alt: propTypes.string,
  /**
   * The aria props that will be spread on the component
  */
  ariaProps: propTypes.object.isRequired,
  /**
   * role for the image. defaults to img
   */
  role: propTypes.string,
  /**
   * The source of the image
   */
  src: propTypes.string.isRequired,
  /**
   * handles the x position for the background image on the div
   */
  xPos: propTypes.string,
  /**
   * handles the y position for the background image on the div
   */
  yPos: propTypes.string
});
var BackgroundImg = function BackgroundImg(_ref9) {
  var ariaProps = _ref9.ariaProps,
    dataProps = _ref9.dataProps,
    props = _objectWithoutProperties3(_ref9, _excluded);
  return jsx("div", _extends({
    css: /*#__PURE__*/css([style(props), props.__css], ";label:BackgroundImg;"),
    className: props.additionalClassName,
    role: props.role
  }, ariaProps, dataProps, {
    alt: props.alt
  }));
};
BackgroundImg.propTypes = imgProps;
BackgroundImg.defaultProps = {
  role: 'img',
  xPos: 'center',
  yPos: 'center'
};
BackgroundImg.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BackgroundImg",
  "props": {
    "role": {
      "defaultValue": {
        "value": "'img'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "role for the image. defaults to img"
    },
    "xPos": {
      "defaultValue": {
        "value": "'center'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "handles the x position for the background image on the div"
    },
    "yPos": {
      "defaultValue": {
        "value": "'center'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "handles the y position for the background image on the div"
    },
    "alt": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "alt for the image"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": true,
      "description": "The aria props that will be spread on the component"
    },
    "src": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The source of the image"
    }
  },
  "composes": ["interfaces/angelouProps"]
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
  reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$4.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$5.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$1 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$1(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0,
    length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}
var transitionValues = 'all 0.3s ease-in-out';
var color = 'rgba(0, 0, 0, 0.15)';
/**
 * For better performance, we change the pseudo element's opacity instead of animating the box shadow
 * Reference: http://tobiasahlin.com/blog/how-to-animate-box-shadow/
 */

var style$1 = function style$1(isLink) {
  var _ref10;
  // if there is an a tag as the first child let's assume its our link
  var afterSelector = function afterSelector() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return isLink ? ">a".concat(selector, ":first-of-type:after") : "&".concat(selector, ":after");
  };
  return _ref10 = {
    color: ui.greyDark['500'],
    border: "1px ".concat(ui.greyLight['100'], " solid"),
    backgroundColor: ui.white['500'],
    position: 'relative',
    borderRadius: '4px',
    transition: transitionValues
  }, _defineProperty3(_ref10, afterSelector(), {
    boxShadow: "0 16px 24px 0 ".concat(color, ", 0 4px 4px 0 ").concat(color),
    content: '" "',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    opacity: '0',
    transition: 'opacity 0.3s ease-in-out',
    pointerEvents: 'none',
    borderRadius: '4px'
  }), _defineProperty3(_ref10, ":hover ".concat(afterSelector(), ", :focus-within ").concat(afterSelector(), ", ").concat(afterSelector(':hover'), ", ").concat(afterSelector(':focus')), {
    opacity: '1',
    pointerEvents: 'none'
  }), _ref10;
};
/**
 * Renders the entire Card clickable while maintaining accessibility
 * the intense ~ rules are targeting all siblings that have some sort
 * of action about them and allows them to be clickable by default.
 * to do this we set position relative and elevate their z-index.
 */

var clickableCardStyle = {
  content: '" "',
  position: 'absolute',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
  zIndex: '1',
  ' ~ * button, ~ button, ~ * [role="button"], ~ [role="button"], ~ * [href], ~ [href], ~ * [role="link"], ~ [role="link"]': {
    zIndex: 1,
    position: 'relative'
  }
};
var cardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want
   * to apply aria attributes directly to the anchor tag.
   *
   * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
   *
   * **Example**:
   * `anchorAriaProps = {{
   * 'aria-label' : 'some-value',
   * 'aria-pressed : 'some-value'
   * }}`
   */
  anchorAriaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
   * Pass anchorDataProps an object containing data attributes if you have set the href prop and you want
   * to apply data attributes directly to the anchor tag.
   *
   * **Example**:
   * `dataProps = {{ 'data-qa-selector' : 'some-value' }}`
   */
  anchorDataProps: propTypes.objectOf(propTypes.string),
  /**
   * Pass ariaProps an object containing aria attributes.
   * If you have set the href prop you want to apply aria attributes directly to the anchor tag, use ariaAnchorProps.
   *
   * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
   *
   * **Example**:
   * `ariaProps = {{
   * 'aria-label' : 'some-value',
   * 'aria-pressed : 'some-value'
   * }}`
   *
   */
  ariaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
   * Renders child elements.
   *
   * Buttons can be children elements on cards with a link, however you must declare `position: relative` on the button.
   */
  children: propTypes.node,
  /**
   * Pass dataProps an object containing data attributes.
   * If you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.
   *
   * **Example**:
   * `dataProps = {{ 'data-qa-selector' : 'some-value' }}`
   */
  dataProps: propTypes.objectOf(propTypes.string),
  /**
   * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
   * If rendering the card using a <Link />, an object can be passed.
   *
   * **String example**:
   * `href='http://newsela.com'`
   *
   * **Object example**:
   *  `href={{
          pathname: /path/to/url},
          state: {
            ...
          }
        }}`
   */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * Pass the onClick prop a function.
   *
   * **Example**:
   * `onClick={() => console.log('clicked')}`
   */
  onClick: propTypes.func,
  /**
   * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseEnter={() => console.log('mouseEntered')}`
   */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * Pass __renderCustomLink a function to render the Card with a React Router Link.
   *
   * **Example**:
    `__renderCustomLink={(props) => (
      <Link
        css={props.css}
        to={props.href}
      />
    )}`
  */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
   )}`
  */
  __renderCustomWrapper: propTypes.func
});
var Card = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  Card.displayName = 'Card';
  var additionalClassName = props.additionalClassName,
    anchorAriaProps = props.anchorAriaProps,
    anchorDataProps = props.anchorDataProps,
    ariaProps = props.ariaProps,
    children = props.children,
    dataProps = props.dataProps,
    href = props.href,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    __renderCustomLink = props.__renderCustomLink,
    __renderCustomWrapper = props.__renderCustomWrapper,
    __css = props.__css;
  var cardProps = _objectSpread3(_objectSpread3(_objectSpread3({}, ariaProps), {}, {
    css: [style$1(href || __renderCustomLink), __css],
    className: additionalClassName
  }, dataProps), {}, {
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: ref
  });
  var anchorTagProps = _objectSpread3(_objectSpread3({}, anchorAriaProps), anchorDataProps);
  var linkTagWithChildren = children;
  if (href || __renderCustomLink) {
    var linkTag;
    if (__renderCustomLink) {
      linkTag = __renderCustomLink(_objectSpread3(_objectSpread3({
        css: clickableCardStyle,
        href: href
      }, anchorAriaProps), anchorDataProps));
    } else {
      linkTag = jsx("a", _extends({
        href: href
      }, anchorTagProps, {
        css: clickableCardStyle
      }));
    }
    linkTagWithChildren = jsx(React__default.Fragment, null, linkTag, children);
  }
  return __renderCustomWrapper ? __renderCustomWrapper(cardProps, linkTagWithChildren) : jsx("div", cardProps, linkTagWithChildren);
});
Card.propTypes = cardProps;
Card.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Card",
  "props": {
    "anchorAriaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want\nto apply aria attributes directly to the anchor tag.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`anchorAriaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "anchorDataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass anchorDataProps an object containing data attributes if you have set the href prop and you want\nto apply data attributes directly to the anchor tag.\n\n**Example**:\n`dataProps = {{ 'data-qa-selector' : 'some-value' }}`"
    },
    "ariaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass ariaProps an object containing aria attributes.\nIf you have set the href prop you want to apply aria attributes directly to the anchor tag, use ariaAnchorProps.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`ariaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Renders child elements.\n\nButtons can be children elements on cards with a link, however you must declare `position: relative` on the button."
    },
    "dataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass dataProps an object containing data attributes.\nIf you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.\n\n**Example**:\n`dataProps = {{ 'data-qa-selector' : 'some-value' }}`"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n          pathname: /path/to/url},\n          state: {\n            ...\n          }\n        }}`"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onClick prop a function.\n\n**Example**:\n`onClick={() => console.log('clicked')}`"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomLink a function to render the Card with a React Router Link.\n\n**Example**:\n    `__renderCustomLink={(props) => (\n      <Link\n        css={props.css}\n        to={props.href}\n      />\n    )}`"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n   )}`"
    }
  },
  "composes": ["interfaces/angelouProps"]
};

/* eslint-disable no-param-reassign */
var index = function index(breakpoints) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    literal = _ref.literal,
    overlap = _ref.overlap;
  var mq = literal ? breakpoints : ['&'].concat(breakpoints);
  function flatten(obj) {
    if (typeof obj !== 'object' || obj == null) {
      return [];
    }
    if (Array.isArray(obj)) {
      return obj.map(flatten);
    }
    var slots = {};
    var objects = {};
    var props = {};
    Object.keys(obj).forEach(function (key) {
      // Check if value is an array, but skip if it looks like a selector.
      // key.indexOf('&') === 0

      var item = obj[key];
      if (!Array.isArray(item) && literal) item = [item];
      if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
        var prior = void 0;
        item.forEach(function (v, index) {
          // Optimize by removing duplicated media query entries
          // when they are explicitly known to overlap.
          if (overlap && prior === v) {
            return;
          }
          if (v == null) {
            // Do not create entries for undefined values as this will
            // generate empty media media quries
            return;
          }
          prior = v;
          if (index === 0 && !literal) {
            props[key] = v;
          } else if (slots[mq[index]] === undefined) {
            var _slots$mq$index;
            slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
          } else {
            slots[mq[index]][key] = v;
          }
        });
      } else if (typeof item === 'object') {
        objects[key] = flatten(item);
      } else {
        props[key] = item;
      }
    });

    // Ensure that all slots and then child objects are pushed to the end
    mq.forEach(function (el) {
      if (slots[el]) {
        props[el] = slots[el];
      }
    });
    Object.assign(props, objects);
    return props;
  }
  return function () {
    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.map(flatten);
  };
};
var getBreakpointNumber = function getBreakpointNumber(bp) {
  var addition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (Breakpoints[bp]) {
    return "".concat(Breakpoints[bp] + addition, "px");
  } else {
    if (typeof bp === 'number') {
      return "".concat(bp, "px");
    } else {
      return bp;
    }
  }
};
var mediaQuery = {
  upTo: function upTo(bp) {
    return "@media(max-width: ".concat(getBreakpointNumber(bp), ")");
  },
  downTo: function downTo(bp) {
    return "@media(min-width: ".concat(getBreakpointNumber(bp, 1), ")");
  },
  between: function between(start, end) {
    return "@media(min-width: ".concat(getBreakpointNumber(start, 1), ") and (max-width: ").concat(getBreakpointNumber(end), ")");
  }
}; // Const paintedMediaQueries = facepaint([mq.between(sm, md), mq.downTo(md)]);

var mobileFirstCss = function mobileFirstCss(cssObj) {
  var fp = index([mediaQuery.downTo(BreakpointNames.xs), mediaQuery.downTo(BreakpointNames.sm), mediaQuery.downTo(BreakpointNames.md), mediaQuery.downTo(BreakpointNames.lg)]);
  return /*#__PURE__*/css(fp(cssObj));
};
var mediaQueryStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  mediaQuery: mediaQuery,
  BreakpointNames: BreakpointNames,
  BreakpointRanges: BreakpointRanges,
  Breakpoints: Breakpoints,
  getBreakpointRange: getBreakpointRange,
  mobileFirstCss: mobileFirstCss
});
var md$1 = BreakpointNames.md,
  sm$1 = BreakpointNames.sm;
var base = {
  fontFamily: 'Circular, Helvetica, Arial, sans-serif'
}; // Mobile first

var paintedMediaQueries = index([mediaQuery.between(sm$1, md$1), mediaQuery.downTo(md$1)]);
var typeScaling = function typeScaling(fontSizeArray) {
  return _objectSpread3(_objectSpread3({}, base), paintedMediaQueries({
    fontSize: fontSizeArray
  })[0]);
};
/**
 * Here is thet order for the fontSizes for facepaint
 * T<NUM>FontSizes = [sm, sm-md, md-infinity]
 */

/**
 * D1 scaling
 */

var display1FontSizes = ['2rem', '2.5rem', '4rem'];
var display1Obj = typeScaling(display1FontSizes);
var display1 = /*#__PURE__*/css(display1Obj, ";label:display1;");
/**
 * D2 scaling
 */

var display2FontSizes = ['2rem', '2.5rem', '3rem'];
var display2Obj = typeScaling(display2FontSizes);
var display2 = /*#__PURE__*/css(display2Obj, ";label:display2;");
/**
 * H1 scaling
 */

var heading1FontSizes = ['2rem', '2.5rem', '2.5rem'];
var heading1Obj = typeScaling(heading1FontSizes);
var heading1 = /*#__PURE__*/css(heading1Obj, ";label:heading1;");
/**
 * H2 scaling
 */

var heading2FontSizes = ['1.5rem', '2rem', '2rem'];
var heading2Obj = typeScaling(heading2FontSizes);
var heading2 = /*#__PURE__*/css(heading2Obj, ";label:heading2;");
/**
 * H3 scaling
 */

var heading3FontSizes = ['1.25rem', '1.5rem', '1.5rem'];
var heading3Obj = typeScaling(heading3FontSizes);
var heading3 = /*#__PURE__*/css(heading3Obj, ";label:heading3;");
/**
 * H4 scaling
 */

var heading4FontSizes = ['1.25rem', '1.25rem', '1.25rem'];
var heading4Obj = typeScaling(heading4FontSizes);
var heading4 = /*#__PURE__*/css(heading4Obj, ";label:heading4;");
/**
 * H5 scaling
 */

var heading5FontSizes = ['1rem', '1rem', '1rem'];
var heading5Obj = typeScaling(heading5FontSizes);
var heading5 = /*#__PURE__*/css(heading5Obj, ";label:heading5;");
/**
 * H6 scaling
 */

var heading6FontSizes = ['0.875rem', '0.875rem', '0.875rem'];
var heading6Obj = typeScaling(heading6FontSizes);
var heading6 = /*#__PURE__*/css(heading6Obj, ";label:heading6;");
/**
 * Text1 scaling
 */

var text1FontSizes = ['1.25rem', '1.25rem', '1.25rem'];
var text1Obj = typeScaling(text1FontSizes);
var text1 = /*#__PURE__*/css(text1Obj, ";label:text1;");
/**
 * Text2 scaling
 */

var text2FontSizes = ['1rem', '1rem', '1rem'];
var text2Obj = typeScaling(text2FontSizes);
var text2 = /*#__PURE__*/css(text2Obj, ";label:text2;");
/**
 * Text3 Scaling
 */

var text3FontSizes = ['1rem', '1rem', '1rem'];
var text3Obj = typeScaling(text3FontSizes);
var text3 = /*#__PURE__*/css(text3Obj, ";label:text3;");
/**
 * Text4 scaling
 */

var text4FontSizes = ['0.75rem', '0.75rem', '0.75rem'];
var text4Obj = typeScaling(text4FontSizes);
var text4 = /*#__PURE__*/css(text4Obj, ";label:text4;");
var typographyStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  display1FontSizes: display1FontSizes,
  display1Obj: display1Obj,
  display1: display1,
  display2FontSizes: display2FontSizes,
  display2Obj: display2Obj,
  display2: display2,
  heading1FontSizes: heading1FontSizes,
  heading1Obj: heading1Obj,
  heading1: heading1,
  heading2FontSizes: heading2FontSizes,
  heading2Obj: heading2Obj,
  heading2: heading2,
  heading3FontSizes: heading3FontSizes,
  heading3Obj: heading3Obj,
  heading3: heading3,
  heading4FontSizes: heading4FontSizes,
  heading4Obj: heading4Obj,
  heading4: heading4,
  heading5FontSizes: heading5FontSizes,
  heading5Obj: heading5Obj,
  heading5: heading5,
  heading6FontSizes: heading6FontSizes,
  heading6Obj: heading6Obj,
  heading6: heading6,
  text1FontSizes: text1FontSizes,
  text1Obj: text1Obj,
  text1: text1,
  text2FontSizes: text2FontSizes,
  text2Obj: text2Obj,
  text2: text2,
  text3FontSizes: text3FontSizes,
  text3Obj: text3Obj,
  text3: text3,
  text4FontSizes: text4FontSizes,
  text4Obj: text4Obj,
  text4: text4
});
var typeSpacer = '8px';
var titleStyle = {
  lineHeight: 1.2,
  margin: "0 0 ".concat(typeSpacer),
  wordBreak: 'break-word',
  fontWeight: 'normal'
};
var textualContainerStyle = {
  name: "13489z4-textualContainerStyle",
  styles: "display:flex;flex-direction:column;justify-content:space-between;;label:textualContainerStyle;"
};
var verticalTitleStyle = heading4Obj;
var horizontalTitleStyle = text2Obj;
var contentTypeStyle = _objectSpread3({
  marginBottom: typeSpacer,
  textTransform: 'uppercase',
  color: ui.grey[500]
}, text4Obj);
var smallHeight = '91.5px';
var largeHeight = '123px';
var horizHeight = '61.5px';
var loadingTitleWrapper = function loadingTitleWrapper(isVertical) {
  return mobileFirstCss({
    display: 'flex',
    flexDirection: 'column',
    height: isVertical ? [smallHeight, smallHeight, largeHeight, largeHeight] : [horizHeight, horizHeight, horizHeight, horizHeight],
    '*': {
      marginBottom: isVertical ? '8px' : '4px'
    }
  });
};
var verticalMarginLeft = '24px';
var verticalMarginRight = '24px;';
var horizontalMarginLeft = '16px';
var horizontalMarginRight = '8px';
var commonMarginTop = '16px';
var commonMarginBottom = '16px';
var verticalImageOverlayMarginLeft = function verticalImageOverlayMarginLeft(isVertical) {
  return {
    marginLeft: isVertical ? verticalMarginLeft : '10px'
  };
};
var verticalImageOverlayMarginRight = function verticalImageOverlayMarginRight(isVertical) {
  return {
    marginRight: isVertical ? verticalMarginRight : horizontalMarginRight
  };
};
var defaultImageOverlayContainer = {
  display: 'flex',
  height: '100%',
  width: '100%'
};
var imageOverlayTextStyle = function imageOverlayTextStyle(isVertical) {
  return _objectSpread3(_objectSpread3(_objectSpread3({
    backgroundColor: 'rgba(51, 51, 51, 0.85)',
    padding: '2px 8px',
    color: ui.white['100'],
    display: 'inline-flex',
    width: 'max-content',
    marginBottom: commonMarginBottom,
    marginTop: commonMarginTop
  }, text4Obj), verticalImageOverlayMarginLeft(isVertical)), verticalImageOverlayMarginRight(isVertical));
};
var imageOverlay = {
  display: 'flex',
  backgroundColor: brand.black[500],
  justifyContent: 'center',
  alignItems: 'center',
  opacity: 0.75
};
var verticalRightImageOverlay = _objectSpread3(_objectSpread3({}, imageOverlay), {}, {
  maxWidth: '70px',
  flex: 1,
  borderTopRightRadius: 'inherit',
  ' *': {
    borderTopRightRadius: 'inherit'
  }
});
var horizontalRightImageOverlay = _objectSpread3(_objectSpread3({}, imageOverlay), {}, {
  padding: '8px'
});
var cardHoverTitle = /*#__PURE__*/css({
  ':hover h2': {
    /* stylelint-disable-line no-descending-specificity */
    textDecoration: 'underline'
  },
  h2: {
    /* stylelint-disable-line no-descending-specificity */
    transition: transitionValues,
    textDecoration: 'underline solid transparent'
  }
}, ";label:cardHoverTitle;");
var focusStyleTitle = {
  name: "1xa06q5-focusStyleTitle",
  styles: "> a:focus + div h2{text-decoration:underline;};label:focusStyleTitle;"
};
var cardDimensions = function cardDimensions(isVertical) {
  // horizontal ones have min width already baked in due to image dimensions
  var minWidth = isVertical ? {
    minWidth: '160px'
  } : {};
  return _objectSpread3({
    width: '100%',
    height: '100%'
  }, minWidth);
};
var marginsObj = function marginsObj(isVertical) {
  return {
    marginLeft: isVertical ? verticalMarginLeft : horizontalMarginLeft,
    marginRight: isVertical ? verticalMarginRight : horizontalMarginRight
  };
};
var textualMargins = function textualMargins(isVertical) {
  return /*#__PURE__*/css(_objectSpread3(_objectSpread3({}, marginsObj(isVertical)), {}, {
    marginTop: commonMarginTop
  }));
};
var footerMargins = function footerMargins(isVertical) {
  var marginLeft = marginsObj(isVertical).marginLeft;
  return /*#__PURE__*/css({
    marginLeft: marginLeft,
    marginRight: isVertical ? verticalMarginRight : '16px',
    marginBottom: commonMarginBottom,
    marginTop: commonMarginTop
  });
};
var imageOverlayContainer = function imageOverlayContainer(isVertical) {
  var _2, _ref11;
  return _ref11 = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  }, _defineProperty3(_ref11, isVertical ? 'borderTopRightRadius' : 'borderBotomtLeftRadius', 'inherit'), _defineProperty3(_ref11, "borderTopLeftRadius", 'inherit'), _defineProperty3(_ref11, '> *', (_2 = {}, _defineProperty3(_2, isVertical ? 'borderTopRightRadius' : 'borderBotomtLeftRadius', 'inherit'), _defineProperty3(_2, "borderTopLeftRadius", 'inherit'), _2)), _ref11;
};
var lib = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    return function (t) {
      var e = {};
      function n(i) {
        if (e[i]) return e[i].exports;
        var r = e[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }
      return n.m = t, n.c = e, n.d = function (t, e, i) {
        n.o(t, e) || Object.defineProperty(t, e, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      }, n.t = function (t, e) {
        if (1 & e && (t = n(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t) for (var r in t) n.d(i, r, function (e) {
          return t[e];
        }.bind(null, r));
        return i;
      }, n.n = function (t) {
        var e = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return n.d(e, "a", e), e;
      }, n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, n.p = "", n(n.s = 2);
    }([function (t, e, n) {
      t.exports = n(3)();
    }, function (t, e) {
      t.exports = React__default;
    }, function (t, e, n) {
      n.r(e), n.d(e, "default", function () {
        return f;
      });
      var i = n(1),
        r = n.n(i),
        o = n(0),
        s = n.n(o);
      function a(t) {
        return (a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
          return typeof t;
        } : function (t) {
          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }
      function l(t, e) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
        }
      }
      function u(t) {
        return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
      }
      function c(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }
      function p(t, e) {
        return (p = Object.setPrototypeOf || function (t, e) {
          return t.__proto__ = e, t;
        })(t, e);
      }
      var f = function (t) {
        function e(t) {
          var n, i, r;
          return function (t, e) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this, e), i = this, (n = !(r = u(e).call(this, t)) || "object" !== a(r) && "function" != typeof r ? c(i) : r).element = null, n.original = t.text, n.watch = !0, n.lineHeight = 0, n.start = 0, n.middle = 0, n.end = 0, n.uuid = t.id, n.state = {
            expanded: !0,
            noClamp: !1,
            text: t.text.substring(0, 20)
          }, n.ssr = "undefined" == typeof window, n.action = n.action.bind(c(n)), n.clickHandler = n.clickHandler.bind(c(n)), n.ssr ? n.state.text = t.text.substring(0, 20) : n.debounced = n.debounce(n.action, t.delay), n;
        }
        var n, o;
        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              writable: !0,
              configurable: !0
            }
          }), e && p(t, e);
        }(e, i["PureComponent"]), n = e, (o = [{
          key: "componentDidMount",
          value: function value() {
            this.props.text && !this.ssr && (this.lineHeight = this.element.clientHeight + 1, this.clampLines(), this.watch && window.addEventListener("resize", this.debounced));
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.ssr || window.removeEventListener("resize", this.debounced);
          }
        }, {
          key: "componentDidUpdate",
          value: function value(t) {
            t.text !== this.props.text && (this.original = this.props.text, this.clampLines());
          }
        }, {
          key: "debounce",
          value: function value(t, e, n) {
            var i,
              r = this,
              o = arguments;
            return function () {
              var s = r,
                a = o,
                l = n && !i;
              clearTimeout(i), i = setTimeout(function () {
                i = null, n || t.apply(s, a);
              }, e), l && t.apply(s, a);
            };
          }
        }, {
          key: "action",
          value: function value() {
            this.watch && (this.setState({
              noClamp: !1
            }), this.clampLines(), this.setState({
              expanded: !this.state.expanded
            }));
          }
        }, {
          key: "clampLines",
          value: function value() {
            if (this.element) {
              this.setState({
                text: ""
              });
              var t = this.lineHeight * this.props.lines + 1;
              for (this.start = 0, this.middle = 0, this.end = this.original.length; this.start <= this.end;) {
                if (this.middle = Math.floor((this.start + this.end) / 2), this.element.innerText = this.original.slice(0, this.middle), this.middle === this.original.length) return void this.setState({
                  text: this.original,
                  noClamp: !0
                });
                this.moveMarkers(t);
              }
              this.element.innerText = this.original.slice(0, this.middle - 5) + this.getEllipsis(), this.setState({
                text: this.original.slice(0, this.middle - 5) + this.getEllipsis()
              });
            }
          }
        }, {
          key: "moveMarkers",
          value: function value(t) {
            this.element.clientHeight <= t ? this.start = this.middle + 1 : this.end = this.middle - 1;
          }
        }, {
          key: "getClassName",
          value: function value() {
            var t = this.props.className || "";
            return "clamp-lines ".concat(t);
          }
        }, {
          key: "getEllipsis",
          value: function value() {
            return this.watch && !this.state.noClamp ? this.props.ellipsis : "";
          }
        }, {
          key: "getButton",
          value: function value() {
            if (!this.state.noClamp && this.props.buttons) {
              var t = this.watch ? this.props.moreText : this.props.lessText;
              return r.a.createElement("button", {
                className: "clamp-lines__button",
                onClick: this.clickHandler,
                "aria-controls": "clamped-content-".concat(this.uuid),
                "aria-expanded": !this.state.expanded
              }, t);
            }
          }
        }, {
          key: "clickHandler",
          value: function value(t) {
            var e = this.props.stopPropagation;
            t.preventDefault(), e && t.stopPropagation(), this.watch = !this.watch, this.watch ? this.clampLines() : this.setState({
              text: this.original
            }), this.setState({
              expanded: !this.state.expanded
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            if (!this.props.text) return null;
            var e = r.a.createElement(this.props.innerElement, {
              ref: function ref(e) {
                t.element = e;
              },
              id: "clamped-content-".concat(this.uuid),
              "aria-hidden": this.state.expanded
            }, this.state.text);
            return r.a.createElement("div", {
              className: this.getClassName()
            }, e, this.getButton());
          }
        }]) && l(n.prototype, o), e;
      }();
      f.propTypes = {
        text: s.a.string.isRequired,
        id: s.a.string.isRequired,
        lines: s.a.number,
        ellipsis: s.a.string,
        buttons: s.a.bool,
        moreText: s.a.string,
        lessText: s.a.string,
        className: s.a.string,
        delay: s.a.number,
        stopPropagation: s.a.bool,
        innerElement: s.a.string
      }, f.defaultProps = {
        lines: 3,
        ellipsis: "...",
        buttons: !0,
        moreText: "Read more",
        lessText: "Read less",
        delay: 300,
        innerElement: "div"
      };
    }, function (t, e, n) {
      var i = n(4);
      function r() {}
      function o() {}
      o.resetWarningCache = r, t.exports = function () {
        function t(t, e, n, r, o, s) {
          if (s !== i) {
            var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw a.name = "Invariant Violation", a;
          }
        }
        function e() {
          return t;
        }
        t.isRequired = t;
        var n = {
          array: t,
          bool: t,
          func: t,
          number: t,
          object: t,
          string: t,
          symbol: t,
          any: t,
          arrayOf: e,
          element: t,
          elementType: t,
          instanceOf: e,
          node: t,
          objectOf: e,
          oneOf: e,
          oneOfType: e,
          shape: e,
          exact: e,
          checkPropTypes: o,
          resetWarningCache: r
        };
        return n.PropTypes = n, n;
      };
    }, function (t, e, n) {
      t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }]);
  });
});
var ClampLines = unwrapExports(lib);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}
var blockStyle = {
  display: 'block'
};
var lineClampProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * aria props to be spread on the html
   */
  ariaProps: propTypes.object,
  /**
   * data props to be spread on the html
   */
  dataProps: propTypes.object,
  /**
   * the wrapper around your text
   */
  innerElement: propTypes.string,
  /**
   * how many lines your text is allowed to be
   */
  lines: propTypes.number.isRequired,
  /**
   * text to be clamped
   */
  text: propTypes.string.isRequired
});
var LineClamp = function LineClamp(props) {
  var additionalClassName = props.additionalClassName,
    ariaProps = props.ariaProps,
    dataProps = props.dataProps,
    innerElement = props.innerElement,
    lines = props.lines,
    text = props.text,
    rest = _objectWithoutProperties3(props, _excluded2);
  var id = "lineClamp".concat(uniqueId());
  var wrapperRef = React.useRef(null);
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    cssFriendly = _React$useState6[0],
    setCssFriendly = _React$useState6[1];
  React.useLayoutEffect(function () {
    if (!wrapperRef.current.style['-webkit-line-clamp']) {
      setCssFriendly(false);
    }
  }, []);
  /**
   * this needs to have a inline style so we can check above
   */

  var element = /*#__PURE__*/React__default.createElement(innerElement, _objectSpread3(_objectSpread3(_objectSpread3(_objectSpread3({
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      WebkitLineClamp: props.lines,
      lineClamp: props.lines,
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical'
    },
    className: additionalClassName
  }, dataProps), ariaProps), rest), {}, {
    ref: wrapperRef
  }), [props.text]);
  return cssFriendly ? element : jsx(ClassNames, null, function (_ref12) {
    var css = _ref12.css;
    return jsx(ClampLines, {
      text: props.text,
      id: id,
      lines: props.lines,
      className: "".concat(css(blockStyle), " ").concat(props.additionalClassName, " ").concat(css(props.css)),
      ellipsis: "...",
      innerElement: innerElement,
      buttons: false
    });
  });
};
LineClamp.propTypes = lineClampProps;
LineClamp.defaultProps = {
  innerElement: 'div',
  dataProps: {},
  ariaProps: {}
};
LineClamp.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LineClamp",
  "props": {
    "innerElement": {
      "defaultValue": {
        "value": "'div'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the wrapper around your text"
    },
    "dataProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "data props to be spread on the html"
    },
    "ariaProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "aria props to be spread on the html"
    },
    "lines": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "how many lines your text is allowed to be"
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "text to be clamped"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var lightGrey = ui.greyLight[100];
var darkGrey = ui.greyLight[300];
var shimmer = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n"])));
var loadingGradient = function loadingGradient() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? lightGrey : _props$backgroundColo,
    _props$shimmerColor = props.shimmerColor,
    shimmerColor = _props$shimmerColor === void 0 ? darkGrey : _props$shimmerColor;
  return [{
    backgroundColor: props.backgroundColor
  }, {
    background: "linear-gradient(to right, ".concat(backgroundColor, " 4%, ").concat(shimmerColor, " 25%, ").concat(backgroundColor, "  36%)")
  }, {
    animation: "".concat(shimmer, " 2s infinite linear"),
    backgroundSize: '1000px',
    height: '100%',
    borderRadius: 'inherit'
  }];
};
var lightGrey$1 = ui.greyLight[100];
var darkGrey$1 = ui.greyLight[300];
var loadingShimmerProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Accepts a string to set the background color. Defaults to lightgrey if no value is passed.
   *
   * **Example**:
   * `backgroundColor="red"`
   */
  backgroundColor: propTypes.string,
  /**
   * Accepts a string to set the shimmer color. Defaults to darkgrey if no value is passed.
   *
   * **Example**:
   * `shimmerColor="blue"`
   */
  shimmerColor: propTypes.string
});
var LoadingShimmer = function LoadingShimmer(props) {
  var backgroundColor = props.backgroundColor,
    shimmerColor = props.shimmerColor;
  return jsx("div", {
    className: props.additionalClassName,
    css: /*#__PURE__*/css([{
      position: 'relative',
      width: '100%',
      overflow: 'hidden',
      height: '100%'
    }, props.__css], ";label:LoadingShimmer;")
  }, jsx("div", {
    css: /*#__PURE__*/css([loadingGradient({
      backgroundColor: backgroundColor,
      shimmerColor: shimmerColor
    }), props.__css], ";label:LoadingShimmer;")
  }));
};
LoadingShimmer.propTypes = loadingShimmerProps;
LoadingShimmer.defaultProps = {
  backgroundColor: lightGrey$1,
  shimmerColor: darkGrey$1
};
LoadingShimmer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LoadingShimmer",
  "props": {
    "backgroundColor": {
      "defaultValue": {
        "value": "ui.greyLight[100]",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Accepts a string to set the background color. Defaults to lightgrey if no value is passed.\n\n**Example**:\n`backgroundColor=\"red\"`"
    },
    "shimmerColor": {
      "defaultValue": {
        "value": "ui.greyLight[300]",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Accepts a string to set the shimmer color. Defaults to darkgrey if no value is passed.\n\n**Example**:\n`shimmerColor=\"blue\"`"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var metaStyle = _objectSpread3(_objectSpread3({}, heading6Obj), {}, {
  textTransform: 'capitalize',
  color: ui.grey[500]
});
var cardMetaDataProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * the number of lines the metaData will clamp
   * to. defaults to 2
   */
  lines: propTypes.number,
  /**
   * strings that will be presented as meta data
   */
  metaData: propTypes.arrayOf(propTypes.string)
});
var CardMetaData = function CardMetaData(_ref13) {
  var additionalClassName = _ref13.additionalClassName,
    metaData = _ref13.metaData,
    lines = _ref13.lines,
    __css = _ref13.__css,
    rest = _objectWithoutProperties3(_ref13, _excluded3);
  // If we get passed undefined from up above lets not render it.
  var trimmedData = metaData ? metaData.filter(function (data) {
    return !!data;
  }) : [];
  return trimmedData.length > 0 ? jsx(LineClamp, _extends({
    text: trimmedData.join(' | '),
    lines: lines,
    css: /*#__PURE__*/css([metaStyle, __css], ";label:CardMetaData;")
  }, rest)) : null;
};
CardMetaData.propTypes = cardMetaDataProps;
CardMetaData.defaultProps = {
  lines: 2
};
CardMetaData.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CardMetaData",
  "props": {
    "lines": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "the number of lines the metaData will clamp\nto. defaults to 2"
    },
    "metaData": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "strings that will be presented as meta data"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var contentCardTextualProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * String that describes what content type we're displaying
   */
  contentType: propTypes.string,
  /**
   * classes that can override individual styles
   */
  classes: propTypes.shape({
    // applied to the contentType portion
    contentType: propTypes.string,
    // applied to the loading wrapper
    loadingWrapper: propTypes.string,
    // classname applied to the metaData wrapper
    metaData: propTypes.string,
    // classname applied to the root element
    root: propTypes.string,
    // classname applied to the h2 title
    title: propTypes.string
  }),
  /**
   * is the card vertical? impacts font size and margins
   */
  isVertical: propTypes.bool,
  /**
   * render prop for the metaData
   */
  metaData: propTypes.arrayOf(propTypes.string),
  /**
   * Title of a contentCard
   */
  title: propTypes.string,
  /**
   * How many lines a title is allowed to be before it becomes
   * truncated
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func
});
var ContentCardTextual = function ContentCardTextual(_ref14) {
  var additionalClassName = _ref14.additionalClassName,
    classes = _ref14.classes,
    contentType = _ref14.contentType,
    isVertical = _ref14.isVertical,
    metaData = _ref14.metaData,
    title = _ref14.title,
    titleLineNum = _ref14.titleLineNum,
    __css = _ref14.__css,
    __renderContentType = _ref14.__renderContentType,
    __renderMetaData = _ref14.__renderMetaData;
  var rootClasses = [additionalClassName, classes.root].join(' ');
  var titleCss = isVertical ? _objectSpread3(_objectSpread3({}, verticalTitleStyle), titleStyle) : _objectSpread3(_objectSpread3({}, horizontalTitleStyle), titleStyle);
  return jsx("div", {
    className: rootClasses,
    css: /*#__PURE__*/css([textualContainerStyle, textualMargins(isVertical), __css], ";label:ContentCardTextual;")
  }, jsx("div", null, __renderContentType ? __renderContentType({
    css: contentTypeStyle,
    className: classes.contentType
  }, contentType) : jsx("div", {
    css: /*#__PURE__*/css([contentTypeStyle], ";label:ContentCardTextual;"),
    className: classes.contentType
  }, contentType), title && jsx(LineClamp, {
    className: classes.title,
    text: title,
    css: titleCss,
    innerElement: "h2",
    lines: titleLineNum
  }), !title && jsx("div", {
    css: loadingTitleWrapper(isVertical),
    className: classes.loadingWrapper
  }, jsx(LoadingShimmer, null), jsx(LoadingShimmer, null), jsx(LoadingShimmer, null))), __renderMetaData ? __renderMetaData({
    className: classes.metaData,
    css: metaStyle
  }, jsx(CardMetaData, null)) : jsx("div", {
    className: classes.metaData
  }, jsx(CardMetaData, {
    metaData: metaData
  })));
};
ContentCardTextual.propTypes = contentCardTextualProps;
ContentCardTextual.defaultProps = {
  titleLineNum: 3,
  classes: {}
};
ContentCardTextual.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentCardTextual",
  "props": {
    "titleLineNum": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "How many lines a title is allowed to be before it becomes\ntruncated"
    },
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "contentType": {
            "name": "string",
            "required": false
          },
          "loadingWrapper": {
            "name": "string",
            "required": false
          },
          "metaData": {
            "name": "string",
            "required": false
          },
          "root": {
            "name": "string",
            "required": false
          },
          "title": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "classes that can override individual styles"
    },
    "contentType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String that describes what content type we're displaying"
    },
    "isVertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical? impacts font size and margins"
    },
    "metaData": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "render prop for the metaData"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Title of a contentCard"
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var scheduler_production_min = createCommonjsModule(function (module, exports) {
  var _f, g, h, k, l;
  if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null,
      q = null,
      t = function t() {
        if (null !== p) try {
          var a = exports.unstable_now();
          p(!0, a);
          p = null;
        } catch (b) {
          throw setTimeout(t, 0), b;
        }
      },
      u = Date.now();
    exports.unstable_now = function () {
      return Date.now() - u;
    };
    _f = function f(a) {
      null !== p ? setTimeout(_f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function g(a, b) {
      q = setTimeout(a, b);
    };
    h = function h() {
      clearTimeout(q);
    };
    k = function k() {
      return !1;
    };
    l = exports.unstable_forceFrameRate = function () {};
  } else {
    var w = window.performance,
      x = window.Date,
      y = window.setTimeout,
      z = window.clearTimeout;
    if ("undefined" !== typeof console) {
      var A = window.cancelAnimationFrame;
      "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
      "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function () {
      return w.now();
    };else {
      var B = x.now();
      exports.unstable_now = function () {
        return x.now() - B;
      };
    }
    var C = !1,
      D = null,
      E = -1,
      F = 5,
      G = 0;
    k = function k() {
      return exports.unstable_now() >= G;
    };
    l = function l() {};
    exports.unstable_forceFrameRate = function (a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var H = new MessageChannel(),
      I = H.port2;
    H.port1.onmessage = function () {
      if (null !== D) {
        var a = exports.unstable_now();
        G = a + F;
        try {
          D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
        } catch (b) {
          throw I.postMessage(null), b;
        }
      } else C = !1;
    };
    _f = function _f(a) {
      D = a;
      C || (C = !0, I.postMessage(null));
    };
    g = function g(a, b) {
      E = y(function () {
        a(exports.unstable_now());
      }, b);
    };
    h = function h() {
      z(E);
      E = -1;
    };
  }
  function J(a, b) {
    var c = a.length;
    a.push(b);
    a: for (;;) {
      var d = c - 1 >>> 1,
        e = a[d];
      if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;else break a;
    }
  }
  function L(a) {
    a = a[0];
    return void 0 === a ? null : a;
  }
  function M(a) {
    var b = a[0];
    if (void 0 !== b) {
      var c = a.pop();
      if (c !== b) {
        a[0] = c;
        a: for (var d = 0, e = a.length; d < e;) {
          var m = 2 * (d + 1) - 1,
            n = a[m],
            v = m + 1,
            r = a[v];
          if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;else break a;
        }
      }
      return b;
    }
    return null;
  }
  function K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
  }
  var N = [],
    O = [],
    P = 1,
    Q = null,
    R = 3,
    S = !1,
    T = !1,
    U = !1;
  function V(a) {
    for (var b = L(O); null !== b;) {
      if (null === b.callback) M(O);else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);else break;
      b = L(O);
    }
  }
  function W(a) {
    U = !1;
    V(a);
    if (!T) if (null !== L(N)) T = !0, _f(X);else {
      var b = L(O);
      null !== b && g(W, b.startTime - a);
    }
  }
  function X(a, b) {
    T = !1;
    U && (U = !1, h());
    S = !0;
    var c = R;
    try {
      V(b);
      for (Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());) {
        var d = Q.callback;
        if (null !== d) {
          Q.callback = null;
          R = Q.priorityLevel;
          var e = d(Q.expirationTime <= b);
          b = exports.unstable_now();
          "function" === typeof e ? Q.callback = e : Q === L(N) && M(N);
          V(b);
        } else M(N);
        Q = L(N);
      }
      if (null !== Q) var m = !0;else {
        var n = L(O);
        null !== n && g(W, n.startTime - b);
        m = !1;
      }
      return m;
    } finally {
      Q = null, R = c, S = !1;
    }
  }
  function Y(a) {
    switch (a) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1E4;
      default:
        return 5E3;
    }
  }
  var Z = l;
  exports.unstable_IdlePriority = 5;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_LowPriority = 4;
  exports.unstable_NormalPriority = 3;
  exports.unstable_Profiling = null;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_cancelCallback = function (a) {
    a.callback = null;
  };
  exports.unstable_continueExecution = function () {
    T || S || (T = !0, _f(X));
  };
  exports.unstable_getCurrentPriorityLevel = function () {
    return R;
  };
  exports.unstable_getFirstCallbackNode = function () {
    return L(N);
  };
  exports.unstable_next = function (a) {
    switch (R) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;
      default:
        b = R;
    }
    var c = R;
    R = b;
    try {
      return a();
    } finally {
      R = c;
    }
  };
  exports.unstable_pauseExecution = function () {};
  exports.unstable_requestPaint = Z;
  exports.unstable_runWithPriority = function (a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a = 3;
    }
    var c = R;
    R = a;
    try {
      return b();
    } finally {
      R = c;
    }
  };
  exports.unstable_scheduleCallback = function (a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
      var e = c.delay;
      e = "number" === typeof e && 0 < e ? d + e : d;
      c = "number" === typeof c.timeout ? c.timeout : Y(a);
    } else c = Y(a), e = d;
    c = e + c;
    a = {
      id: P++,
      callback: b,
      priorityLevel: a,
      startTime: e,
      expirationTime: c,
      sortIndex: -1
    };
    e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, _f(X)));
    return a;
  };
  exports.unstable_shouldYield = function () {
    var a = exports.unstable_now();
    V(a);
    var b = L(N);
    return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
  };
  exports.unstable_wrapCallback = function (a) {
    var b = R;
    return function () {
      var c = R;
      R = b;
      try {
        return a.apply(this, arguments);
      } finally {
        R = c;
      }
    };
  };
});
var scheduler_production_min_1 = scheduler_production_min.unstable_now;
var scheduler_production_min_2 = scheduler_production_min.unstable_forceFrameRate;
var scheduler_production_min_3 = scheduler_production_min.unstable_IdlePriority;
var scheduler_production_min_4 = scheduler_production_min.unstable_ImmediatePriority;
var scheduler_production_min_5 = scheduler_production_min.unstable_LowPriority;
var scheduler_production_min_6 = scheduler_production_min.unstable_NormalPriority;
var scheduler_production_min_7 = scheduler_production_min.unstable_Profiling;
var scheduler_production_min_8 = scheduler_production_min.unstable_UserBlockingPriority;
var scheduler_production_min_9 = scheduler_production_min.unstable_cancelCallback;
var scheduler_production_min_10 = scheduler_production_min.unstable_continueExecution;
var scheduler_production_min_11 = scheduler_production_min.unstable_getCurrentPriorityLevel;
var scheduler_production_min_12 = scheduler_production_min.unstable_getFirstCallbackNode;
var scheduler_production_min_13 = scheduler_production_min.unstable_next;
var scheduler_production_min_14 = scheduler_production_min.unstable_pauseExecution;
var scheduler_production_min_15 = scheduler_production_min.unstable_requestPaint;
var scheduler_production_min_16 = scheduler_production_min.unstable_runWithPriority;
var scheduler_production_min_17 = scheduler_production_min.unstable_scheduleCallback;
var scheduler_production_min_18 = scheduler_production_min.unstable_shouldYield;
var scheduler_production_min_19 = scheduler_production_min.unstable_wrapCallback;
var scheduler_development = createCommonjsModule(function (module, exports) {
  {
    (function () {
      var enableSchedulerDebugging = false;
      var enableProfiling = true;
      var _requestHostCallback;
      var requestHostTimeout;
      var cancelHostTimeout;
      var shouldYieldToHost;
      var requestPaint;
      if (
      // If Scheduler runs in a non-DOM environment, it falls back to a naive
      // implementation using setTimeout.
      typeof window === 'undefined' ||
      // Check if MessageChannel is supported, too.
      typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function _flushCallback() {
          if (_callback !== null) {
            try {
              var currentTime = exports.unstable_now();
              var hasRemainingTime = true;
              _callback(hasRemainingTime, currentTime);
              _callback = null;
            } catch (e) {
              setTimeout(_flushCallback, 0);
              throw e;
            }
          }
        };
        var initialTime = Date.now();
        exports.unstable_now = function () {
          return Date.now() - initialTime;
        };
        _requestHostCallback = function requestHostCallback(cb) {
          if (_callback !== null) {
            // Protect against re-entrancy.
            setTimeout(_requestHostCallback, 0, cb);
          } else {
            _callback = cb;
            setTimeout(_flushCallback, 0);
          }
        };
        requestHostTimeout = function requestHostTimeout(cb, ms) {
          _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function cancelHostTimeout() {
          clearTimeout(_timeoutID);
        };
        shouldYieldToHost = function shouldYieldToHost() {
          return false;
        };
        requestPaint = exports.unstable_forceFrameRate = function () {};
      } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var performance = window.performance;
        var _Date = window.Date;
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
          // TODO: Scheduler no longer requires these methods to be polyfilled. But
          // maybe we want to continue warning if they don't exist, to preserve the
          // option to rely on it in the future?
          var requestAnimationFrame = window.requestAnimationFrame;
          var cancelAnimationFrame = window.cancelAnimationFrame; // TODO: Remove fb.me link

          if (typeof requestAnimationFrame !== 'function') {
            // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support requestAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
          if (typeof cancelAnimationFrame !== 'function') {
            // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support cancelAnimationFrame. " + 'Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
          }
        }
        if (typeof performance === 'object' && typeof performance.now === 'function') {
          exports.unstable_now = function () {
            return performance.now();
          };
        } else {
          var _initialTime = _Date.now();
          exports.unstable_now = function () {
            return _Date.now() - _initialTime;
          };
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.

        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable

        {
          // `isInputPending` is not available. Since we have no way of knowing if
          // there's pending input, always yield at the end of the frame.
          shouldYieldToHost = function shouldYieldToHost() {
            return exports.unstable_now() >= deadline;
          }; // Since we yield every frame regardless, `requestPaint` has no effect.

          requestPaint = function requestPaint() {};
        }
        exports.unstable_forceFrameRate = function (fps) {
          if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']('forceFrameRate takes a positive int between 0 and 125, ' + 'forcing framerates higher than 125 fps is not unsupported');
            return;
          }
          if (fps > 0) {
            yieldInterval = Math.floor(1000 / fps);
          } else {
            // reset the framerate
            yieldInterval = 5;
          }
        };
        var performWorkUntilDeadline = function performWorkUntilDeadline() {
          if (scheduledHostCallback !== null) {
            var currentTime = exports.unstable_now(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
            // cycle. This means there's always time remaining at the beginning of
            // the message event.

            deadline = currentTime + yieldInterval;
            var hasTimeRemaining = true;
            try {
              var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
              if (!hasMoreWork) {
                isMessageLoopRunning = false;
                scheduledHostCallback = null;
              } else {
                // If there's more work, schedule the next message event at the end
                // of the preceding one.
                port.postMessage(null);
              }
            } catch (error) {
              // If a scheduler task throws, exit the current browser task so the
              // error can be observed.
              port.postMessage(null);
              throw error;
            }
          } else {
            isMessageLoopRunning = false;
          } // Yielding to the browser will give it a chance to paint, so we can
        };

        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        _requestHostCallback = function _requestHostCallback(callback) {
          scheduledHostCallback = callback;
          if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            port.postMessage(null);
          }
        };
        requestHostTimeout = function requestHostTimeout(callback, ms) {
          taskTimeoutID = _setTimeout(function () {
            callback(exports.unstable_now());
          }, ms);
        };
        cancelHostTimeout = function cancelHostTimeout() {
          _clearTimeout(taskTimeoutID);
          taskTimeoutID = -1;
        };
      }
      function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
      }
      function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
      }
      function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
          var last = heap.pop();
          if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
          }
          return first;
        } else {
          return null;
        }
      }
      function siftUp(heap, node, i) {
        var index = i;
        while (true) {
          var parentIndex = index - 1 >>> 1;
          var parent = heap[parentIndex];
          if (parent !== undefined && compare(parent, node) > 0) {
            // The parent is larger. Swap positions.
            heap[parentIndex] = node;
            heap[index] = parent;
            index = parentIndex;
          } else {
            // The parent is smaller. Exit.
            return;
          }
        }
      }
      function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while (index < length) {
          var leftIndex = (index + 1) * 2 - 1;
          var left = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.

          if (left !== undefined && compare(left, node) < 0) {
            if (right !== undefined && compare(right, left) < 0) {
              heap[index] = right;
              heap[rightIndex] = node;
              index = rightIndex;
            } else {
              heap[index] = left;
              heap[leftIndex] = node;
              index = leftIndex;
            }
          } else if (right !== undefined && compare(right, node) < 0) {
            heap[index] = right;
            heap[rightIndex] = node;
            index = rightIndex;
          } else {
            // Neither child is smaller. Exit.
            return;
          }
        }
      }
      function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
      }

      // TODO: Use symbols?
      var NoPriority = 0;
      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;
      var runIdCounter = 0;
      var mainThreadIdCounter = 0;
      var profilingStateSize = 4;
      var sharedProfilingBuffer =
      // $FlowFixMe Flow doesn't know about SharedArrayBuffer
      typeof SharedArrayBuffer === 'function' ? new SharedArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) :
      // $FlowFixMe Flow doesn't know about ArrayBuffer
      typeof ArrayBuffer === 'function' ? new ArrayBuffer(profilingStateSize * Int32Array.BYTES_PER_ELEMENT) : null // Don't crash the init path on IE9
      ;

      var profilingState = sharedProfilingBuffer !== null ? new Int32Array(sharedProfilingBuffer) : []; // We can't read this but it helps save bytes for null checks

      var PRIORITY = 0;
      var CURRENT_TASK_ID = 1;
      var CURRENT_RUN_ID = 2;
      var QUEUE_SIZE = 3;
      {
        profilingState[PRIORITY] = NoPriority; // This is maintained with a counter, because the size of the priority queue
        // array might include canceled tasks.

        profilingState[QUEUE_SIZE] = 0;
        profilingState[CURRENT_TASK_ID] = 0;
      } // Bytes per element is 4

      var INITIAL_EVENT_LOG_SIZE = 131072;
      var MAX_EVENT_LOG_SIZE = 524288; // Equivalent to 2 megabytes

      var eventLogSize = 0;
      var eventLogBuffer = null;
      var eventLog = null;
      var eventLogIndex = 0;
      var TaskStartEvent = 1;
      var TaskCompleteEvent = 2;
      var TaskErrorEvent = 3;
      var TaskCancelEvent = 4;
      var TaskRunEvent = 5;
      var TaskYieldEvent = 6;
      var SchedulerSuspendEvent = 7;
      var SchedulerResumeEvent = 8;
      function logEvent(entries) {
        if (eventLog !== null) {
          var offset = eventLogIndex;
          eventLogIndex += entries.length;
          if (eventLogIndex + 1 > eventLogSize) {
            eventLogSize *= 2;
            if (eventLogSize > MAX_EVENT_LOG_SIZE) {
              // Using console['error'] to evade Babel and ESLint
              console['error']("Scheduler Profiling: Event log exceeded maximum size. Don't " + 'forget to call `stopLoggingProfilingEvents()`.');
              stopLoggingProfilingEvents();
              return;
            }
            var newEventLog = new Int32Array(eventLogSize * 4);
            newEventLog.set(eventLog);
            eventLogBuffer = newEventLog.buffer;
            eventLog = newEventLog;
          }
          eventLog.set(entries, offset);
        }
      }
      function startLoggingProfilingEvents() {
        eventLogSize = INITIAL_EVENT_LOG_SIZE;
        eventLogBuffer = new ArrayBuffer(eventLogSize * 4);
        eventLog = new Int32Array(eventLogBuffer);
        eventLogIndex = 0;
      }
      function stopLoggingProfilingEvents() {
        var buffer = eventLogBuffer;
        eventLogSize = 0;
        eventLogBuffer = null;
        eventLog = null;
        eventLogIndex = 0;
        return buffer;
      }
      function markTaskStart(task, ms) {
        {
          profilingState[QUEUE_SIZE]++;
          if (eventLog !== null) {
            // performance.now returns a float, representing milliseconds. When the
            // event is logged, it's coerced to an int. Convert to microseconds to
            // maintain extra degrees of precision.
            logEvent([TaskStartEvent, ms * 1000, task.id, task.priorityLevel]);
          }
        }
      }
      function markTaskCompleted(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCompleteEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskCanceled(task, ms) {
        {
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskCancelEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskErrored(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[QUEUE_SIZE]--;
          if (eventLog !== null) {
            logEvent([TaskErrorEvent, ms * 1000, task.id]);
          }
        }
      }
      function markTaskRun(task, ms) {
        {
          runIdCounter++;
          profilingState[PRIORITY] = task.priorityLevel;
          profilingState[CURRENT_TASK_ID] = task.id;
          profilingState[CURRENT_RUN_ID] = runIdCounter;
          if (eventLog !== null) {
            logEvent([TaskRunEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markTaskYield(task, ms) {
        {
          profilingState[PRIORITY] = NoPriority;
          profilingState[CURRENT_TASK_ID] = 0;
          profilingState[CURRENT_RUN_ID] = 0;
          if (eventLog !== null) {
            logEvent([TaskYieldEvent, ms * 1000, task.id, runIdCounter]);
          }
        }
      }
      function markSchedulerSuspended(ms) {
        {
          mainThreadIdCounter++;
          if (eventLog !== null) {
            logEvent([SchedulerSuspendEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }
      function markSchedulerUnsuspended(ms) {
        {
          if (eventLog !== null) {
            logEvent([SchedulerResumeEvent, ms * 1000, mainThreadIdCounter]);
          }
        }
      }

      /* eslint-disable no-var */
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111

      var maxSigned31BitInt = 1073741823; // Times out immediately

      var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out

      var USER_BLOCKING_PRIORITY = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5000;
      var LOW_PRIORITY_TIMEOUT = 10000; // Never times out

      var IDLE_PRIORITY = maxSigned31BitInt; // Tasks are stored on a min heap

      var taskQueue = [];
      var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.

      var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
      var currentTask = null;
      var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.

      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while (timer !== null) {
          if (timer.callback === null) {
            // Timer was cancelled.
            pop(timerQueue);
          } else if (timer.startTime <= currentTime) {
            // Timer fired. Transfer to the task queue.
            pop(timerQueue);
            timer.sortIndex = timer.expirationTime;
            push(taskQueue, timer);
            {
              markTaskStart(timer, currentTime);
              timer.isQueued = true;
            }
          } else {
            // Remaining timers are pending.
            return;
          }
          timer = peek(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
          if (peek(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            _requestHostCallback(flushWork);
          } else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
          }
        }
      }
      function flushWork(hasTimeRemaining, initialTime) {
        {
          markSchedulerUnsuspended(initialTime);
        } // We'll need a host callback the next time work is scheduled.

        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
          // We scheduled a timeout but it's no longer needed. Cancel it.
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
          if (enableProfiling) {
            try {
              return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
              if (currentTask !== null) {
                var currentTime = exports.unstable_now();
                markTaskErrored(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              throw error;
            }
          } else {
            // No catch in prod codepath.
            return workLoop(hasTimeRemaining, initialTime);
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
          {
            var _currentTime = exports.unstable_now();
            markSchedulerSuspended(_currentTime);
          }
        }
      }
      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
            // This currentTask hasn't expired, and we've reached the deadline.
            break;
          }
          var callback = currentTask.callback;
          if (callback !== null) {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
            markTaskRun(currentTask, currentTime);
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime = exports.unstable_now();
            if (typeof continuationCallback === 'function') {
              currentTask.callback = continuationCallback;
              markTaskYield(currentTask, currentTime);
            } else {
              {
                markTaskCompleted(currentTask, currentTime);
                currentTask.isQueued = false;
              }
              if (currentTask === peek(taskQueue)) {
                pop(taskQueue);
              }
            }
            advanceTimers(currentTime);
          } else {
            pop(taskQueue);
          }
          currentTask = peek(taskQueue);
        } // Return whether there's additional work

        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek(timerQueue);
          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
          }
          return false;
        }
      }
      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;
          default:
            priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_next(eventHandler) {
        var priorityLevel;
        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            // Shift down to normal priority
            priorityLevel = NormalPriority;
            break;
          default:
            // Anything lower than normal priority should remain at the current level.
            priorityLevel = currentPriorityLevel;
            break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function () {
          // This is a fork of runWithPriority, inlined for performance.
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }
      function timeoutForPriorityLevel(priorityLevel) {
        switch (priorityLevel) {
          case ImmediatePriority:
            return IMMEDIATE_PRIORITY_TIMEOUT;
          case UserBlockingPriority:
            return USER_BLOCKING_PRIORITY;
          case IdlePriority:
            return IDLE_PRIORITY;
          case LowPriority:
            return LOW_PRIORITY_TIMEOUT;
          case NormalPriority:
          default:
            return NORMAL_PRIORITY_TIMEOUT;
        }
      }
      function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;
        var timeout;
        if (typeof options === 'object' && options !== null) {
          var delay = options.delay;
          if (typeof delay === 'number' && delay > 0) {
            startTime = currentTime + delay;
          } else {
            startTime = currentTime;
          }
          timeout = typeof options.timeout === 'number' ? options.timeout : timeoutForPriorityLevel(priorityLevel);
        } else {
          timeout = timeoutForPriorityLevel(priorityLevel);
          startTime = currentTime;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
          id: taskIdCounter++,
          callback: callback,
          priorityLevel: priorityLevel,
          startTime: startTime,
          expirationTime: expirationTime,
          sortIndex: -1
        };
        {
          newTask.isQueued = false;
        }
        if (startTime > currentTime) {
          // This is a delayed task.
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);
          if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
            // All tasks are delayed, and this is the task with the earliest delay.
            if (isHostTimeoutScheduled) {
              // Cancel an existing timeout.
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            } // Schedule a timeout.

            requestHostTimeout(handleTimeout, startTime - currentTime);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);
          {
            markTaskStart(newTask, currentTime);
            newTask.isQueued = true;
          } // Schedule a host callback, if needed. If we're already performing work,
          // wait until the next time we yield.

          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            _requestHostCallback(flushWork);
          }
        }
        return newTask;
      }
      function unstable_pauseExecution() {}
      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          _requestHostCallback(flushWork);
        }
      }
      function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
      }
      function unstable_cancelCallback(task) {
        {
          if (task.isQueued) {
            var currentTime = exports.unstable_now();
            markTaskCanceled(task, currentTime);
            task.isQueued = false;
          }
        } // Null out the callback to indicate the task has been canceled. (Can't
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)

        task.callback = null;
      }
      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }
      function unstable_shouldYield() {
        var currentTime = exports.unstable_now();
        advanceTimers(currentTime);
        var firstTask = peek(taskQueue);
        return firstTask !== currentTask && currentTask !== null && firstTask !== null && firstTask.callback !== null && firstTask.startTime <= currentTime && firstTask.expirationTime < currentTask.expirationTime || shouldYieldToHost();
      }
      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = {
        startLoggingProfilingEvents: startLoggingProfilingEvents,
        stopLoggingProfilingEvents: stopLoggingProfilingEvents,
        sharedProfilingBuffer: sharedProfilingBuffer
      };
      exports.unstable_IdlePriority = IdlePriority;
      exports.unstable_ImmediatePriority = ImmediatePriority;
      exports.unstable_LowPriority = LowPriority;
      exports.unstable_NormalPriority = NormalPriority;
      exports.unstable_Profiling = unstable_Profiling;
      exports.unstable_UserBlockingPriority = UserBlockingPriority;
      exports.unstable_cancelCallback = unstable_cancelCallback;
      exports.unstable_continueExecution = unstable_continueExecution;
      exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      exports.unstable_next = unstable_next;
      exports.unstable_pauseExecution = unstable_pauseExecution;
      exports.unstable_requestPaint = unstable_requestPaint;
      exports.unstable_runWithPriority = unstable_runWithPriority;
      exports.unstable_scheduleCallback = unstable_scheduleCallback;
      exports.unstable_shouldYield = unstable_shouldYield;
      exports.unstable_wrapCallback = unstable_wrapCallback;
    })();
  }
});
var scheduler_development_1 = scheduler_development.unstable_now;
var scheduler_development_2 = scheduler_development.unstable_forceFrameRate;
var scheduler_development_3 = scheduler_development.unstable_IdlePriority;
var scheduler_development_4 = scheduler_development.unstable_ImmediatePriority;
var scheduler_development_5 = scheduler_development.unstable_LowPriority;
var scheduler_development_6 = scheduler_development.unstable_NormalPriority;
var scheduler_development_7 = scheduler_development.unstable_Profiling;
var scheduler_development_8 = scheduler_development.unstable_UserBlockingPriority;
var scheduler_development_9 = scheduler_development.unstable_cancelCallback;
var scheduler_development_10 = scheduler_development.unstable_continueExecution;
var scheduler_development_11 = scheduler_development.unstable_getCurrentPriorityLevel;
var scheduler_development_12 = scheduler_development.unstable_getFirstCallbackNode;
var scheduler_development_13 = scheduler_development.unstable_next;
var scheduler_development_14 = scheduler_development.unstable_pauseExecution;
var scheduler_development_15 = scheduler_development.unstable_requestPaint;
var scheduler_development_16 = scheduler_development.unstable_runWithPriority;
var scheduler_development_17 = scheduler_development.unstable_scheduleCallback;
var scheduler_development_18 = scheduler_development.unstable_shouldYield;
var scheduler_development_19 = scheduler_development.unstable_wrapCallback;
var scheduler = createCommonjsModule(function (module) {
  {
    module.exports = scheduler_development;
  }
});
function u(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!React__default) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l);
  } catch (m) {
    this.onError(m);
  }
}
var da = !1,
  ea = null,
  fa = !1,
  ha = null,
  ia = {
    onError: function onError(a) {
      da = !0;
      ea = a;
    }
  };
function ja(a, b, c, d, e, f, g, h, k) {
  da = !1;
  ea = null;
  ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
  ja.apply(this, arguments);
  if (da) {
    if (da) {
      var l = ea;
      da = !1;
      ea = null;
    } else throw Error(u(198));
    fa || (fa = !0, ha = l);
  }
}
var la = null,
  ma = null,
  na = null;
function oa(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = na(c);
  ka(d, b, void 0, a);
  a.currentTarget = null;
}
var pa = null,
  qa = {};
function ra() {
  if (pa) for (var a in qa) {
    var b = qa[a],
      c = pa.indexOf(a);
    if (!(-1 < c)) throw Error(u(96, a));
    if (!sa[c]) {
      if (!b.extractEvents) throw Error(u(97, a));
      sa[c] = b;
      c = b.eventTypes;
      for (var d in c) {
        var e = void 0;
        var f = c[d],
          g = b,
          h = d;
        if (ta.hasOwnProperty(h)) throw Error(u(99, h));
        ta[h] = f;
        var k = f.phasedRegistrationNames;
        if (k) {
          for (e in k) k.hasOwnProperty(e) && ua(k[e], g, h);
          e = !0;
        } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
        if (!e) throw Error(u(98, d, a));
      }
    }
  }
}
function ua(a, b, c) {
  if (va[a]) throw Error(u(100, a));
  va[a] = b;
  wa[a] = b.eventTypes[c].dependencies;
}
var sa = [],
  ta = {},
  va = {},
  wa = {};
function xa(a) {
  var b = !1,
    c;
  for (c in a) if (a.hasOwnProperty(c)) {
    var d = a[c];
    if (!qa.hasOwnProperty(c) || qa[c] !== d) {
      if (qa[c]) throw Error(u(102, c));
      qa[c] = d;
      b = !0;
    }
  }
  b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
  za = null,
  Aa = null,
  Ba = null;
function Ca(a) {
  if (a = ma(a)) {
    if ("function" !== typeof za) throw Error(u(280));
    var b = a.stateNode;
    b && (b = la(b), za(a.stateNode, a.type, b));
  }
}
function Da(a) {
  Aa ? Ba ? Ba.push(a) : Ba = [a] : Aa = a;
}
function Ea() {
  if (Aa) {
    var a = Aa,
      b = Ba;
    Ba = Aa = null;
    Ca(a);
    if (b) for (a = 0; a < b.length; a++) Ca(b[a]);
  }
}
function Fa(a, b) {
  return a(b);
}
function Ha() {}
var Ja = !1;
function La() {
  if (null !== Aa || null !== Ba) Ha(), Ea();
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  Oa = Object.prototype.hasOwnProperty,
  Pa = {},
  Qa = {};
function Ra(a) {
  if (Oa.call(Qa, a)) return !0;
  if (Oa.call(Pa, a)) return !1;
  if (Na.test(a)) return Qa[a] = !0;
  Pa[a] = !0;
  return !1;
}
function Sa(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;
  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;
    default:
      return !1;
  }
}
function Ta(a, b, c, d) {
  if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;
    case 4:
      return !1 === b;
    case 5:
      return isNaN(b);
    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}
function v(a, b, c, d, e, f) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  C[a] = new v(a, 0, !1, a, null, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  C[b] = new v(b, 1, !1, a[1], null, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  C[a] = new v(a, 3, !0, a, null, !1);
});
["capture", "download"].forEach(function (a) {
  C[a] = new v(a, 4, !1, a, null, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  C[a] = new v(a, 6, !1, a, null, !1);
});
["rowSpan", "start"].forEach(function (a) {
  C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);
  C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(Ua, Va);
  C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(Ua, Va);
  C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
["src", "href", "action", "formAction"].forEach(function (a) {
  C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = React__default.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
  current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
  suspense: null
});
function Xa(a, b, c, d) {
  var e = C.hasOwnProperty(b) ? C[b] : null;
  var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
  f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function rb(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;
    default:
      return "";
  }
}
function sb(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function yb(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}
function Bb(a, b) {
  b = b.checked;
  null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
  Bb(a, b);
  var c = rb(b.value),
    d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Db(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Hb(a, b, c, d) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++) b["$" + c[e]] = !0;
    for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
  } else {
    c = "" + rb(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }
      null !== b || a[e].disabled || (b = a[e]);
    }
    null !== b && (b.selected = !0);
  }
}
function Kb(a, b) {
  var c = rb(b.value),
    d = rb(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}
var Mb = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};
var Pb,
  Qb = function (a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
      MSApp.execUnsafeLocalFunction(function () {
        return a(b, c, d, e);
      });
    } : a;
  }(function (a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;else {
      Pb = Pb || document.createElement("div");
      Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
      for (b = Pb.firstChild; a.firstChild;) a.removeChild(a.firstChild);
      for (; b.firstChild;) a.appendChild(b.firstChild);
    }
  });
function Sb(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
  },
  Ub = {},
  Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
  if (Ub[a]) return Ub[a];
  if (!Tb[a]) return a;
  var b = Tb[a],
    c;
  for (c in b) if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
  return a;
}
var Xb = Wb("animationend"),
  Yb = Wb("animationiteration"),
  Zb = Wb("animationstart"),
  $b = Wb("transitionend"),
  bc = new ("function" === typeof WeakMap ? WeakMap : Map)();
function cc(a) {
  var b = bc.get(a);
  void 0 === b && (b = new Map(), bc.set(a, b));
  return b;
}
function dc(a) {
  var b = a,
    c = a;
  if (a.alternate) for (; b.return;) b = b.return;else {
    a = b;
    do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return; while (a);
  }
  return 3 === b.tag ? c : null;
}
function fc(a) {
  if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
  var b = a.alternate;
  if (!b) {
    b = dc(a);
    if (null === b) throw Error(u(188));
    return b !== a ? null : a;
  }
  for (var c = a, d = b;;) {
    var e = c.return;
    if (null === e) break;
    var f = e.alternate;
    if (null === f) {
      d = e.return;
      if (null !== d) {
        c = d;
        continue;
      }
      break;
    }
    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return fc(e), a;
        if (f === d) return fc(e), b;
        f = f.sibling;
      }
      throw Error(u(188));
    }
    if (c.return !== d.return) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }
        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }
        h = h.sibling;
      }
      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }
          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }
          h = h.sibling;
        }
        if (!g) throw Error(u(189));
      }
    }
    if (c.alternate !== d) throw Error(u(190));
  }
  if (3 !== c.tag) throw Error(u(188));
  return c.stateNode.current === c ? a : b;
}
function hc(a) {
  a = gc(a);
  if (!a) return null;
  for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;
    if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;
      for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return null;
}
function ic(a, b) {
  if (null == b) throw Error(u(30));
  if (null == a) return b;
  if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;
    a.push(b);
    return a;
  }
  return Array.isArray(b) ? [a].concat(b) : [a, b];
}
function jc(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
  if (a) {
    var b = a._dispatchListeners,
      c = a._dispatchInstances;
    if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) oa(a, b[d], c[d]);else b && oa(a, b, c);
    a._dispatchListeners = null;
    a._dispatchInstances = null;
    a.isPersistent() || a.constructor.release(a);
  }
}
function mc(a) {
  null !== a && (kc = ic(kc, a));
  a = kc;
  kc = null;
  if (a) {
    jc(a, lc);
    if (kc) throw Error(u(95));
    if (fa) throw a = ha, fa = !1, ha = null, a;
  }
}
function nc(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
  if (!ya) return !1;
  a = "on" + a;
  var b = (a in document);
  b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
  return b;
}
var Wc = {},
  Yc = new Map(),
  Zc = new Map(),
  $c = ["abort", "abort", Xb, "animationEnd", Yb, "animationIteration", Zb, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", $b, "transitionEnd", "waiting", "waiting"];
function ad(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c],
      e = a[c + 1],
      f = "on" + (e[0].toUpperCase() + e.slice(1));
    f = {
      phasedRegistrationNames: {
        bubbled: f,
        captured: f + "Capture"
      },
      dependencies: [d],
      eventPriority: b
    };
    Zc.set(d, b);
    Yc.set(d, f);
    Wc[e] = f;
  }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for (var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++) Zc.set(bd[cd], 0);
var dd = scheduler.unstable_UserBlockingPriority,
  ed = scheduler.unstable_runWithPriority;
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
  kd = ["Webkit", "ms", "Moz", "O"];
Object.keys(jd).forEach(function (a) {
  kd.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    jd[b] = jd[a];
  });
});
var nd = objectAssign({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});
function td(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function yd(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$",
  Ad = "/$",
  Bd = "$?",
  Cd = "$!";
function Kd(a) {
  a = a.previousSibling;
  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;
      if (c === zd || c === Cd || c === Bd) {
        if (0 === b) return a;
        b--;
      } else c === Ad && b++;
    }
    a = a.previousSibling;
  }
  return null;
}
var Ld = Math.random().toString(36).slice(2),
  Md = "__reactInternalInstance$" + Ld,
  Nd = "__reactEventHandlers$" + Ld,
  Od = "__reactContainere$" + Ld;
function tc(a) {
  var b = a[Md];
  if (b) return b;
  for (var c = a.parentNode; c;) {
    if (b = c[Od] || c[Md]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = Kd(a); null !== a;) {
        if (c = a[Md]) return c;
        a = Kd(a);
      }
      return b;
    }
    a = c;
    c = a.parentNode;
  }
  return null;
}
function Nc(a) {
  a = a[Md] || a[Od];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(u(33));
}
function Qd(a) {
  return a[Nd] || null;
}
function Rd(a) {
  do a = a.return; while (a && 5 !== a.tag);
  return a ? a : null;
}
function Sd(a, b) {
  var c = a.stateNode;
  if (!c) return null;
  var d = la(c);
  if (!d) return null;
  c = d[b];
  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;
    default:
      a = !1;
  }
  if (a) return null;
  if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
  return c;
}
function Td(a, b, c) {
  if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b;) c.push(b), b = Rd(b);
    for (b = c.length; 0 < b--;) Td(c[b], "captured", a);
    for (b = 0; b < c.length; b++) Td(c[b], "bubbled", a);
  }
}
function Vd(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Xd(a) {
  jc(a, Ud);
}
var Yd = null,
  Zd = null,
  $d = null;
function ae() {
  if ($d) return $d;
  var a,
    b = Zd,
    c = b.length,
    d,
    e = "value" in Yd ? Yd.value : Yd.textContent,
    f = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++);
  var g = c - a;
  for (d = 1; d <= g && b[c - d] === e[f - d]; d++);
  return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
  return !0;
}
function ce() {
  return !1;
}
function G(a, b, c, d) {
  this.dispatchConfig = a;
  this._targetInst = b;
  this.nativeEvent = c;
  a = this.constructor.Interface;
  for (var e in a) a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
  this.isPropagationStopped = ce;
  return this;
}
objectAssign(G.prototype, {
  preventDefault: function preventDefault() {
    this.defaultPrevented = !0;
    var a = this.nativeEvent;
    a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
  },
  stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;
    a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
  },
  persist: function persist() {
    this.isPersistent = be;
  },
  isPersistent: ce,
  destructor: function destructor() {
    var a = this.constructor.Interface,
      b;
    for (b in a) this[b] = null;
    this.nativeEvent = this._targetInst = this.dispatchConfig = null;
    this.isPropagationStopped = this.isDefaultPrevented = ce;
    this._dispatchInstances = this._dispatchListeners = null;
  }
});
G.Interface = {
  type: null,
  target: null,
  currentTarget: function currentTarget() {
    return null;
  },
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};
G.extend = function (a) {
  function b() {}
  function c() {
    return d.apply(this, arguments);
  }
  var d = this;
  b.prototype = d.prototype;
  var e = new b();
  objectAssign(e, c.prototype);
  c.prototype = e;
  c.prototype.constructor = c;
  c.Interface = objectAssign({}, d.Interface, a);
  c.extend = d.extend;
  de(c);
  return c;
};
de(G);
function ee(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();
    this.call(e, a, b, c, d);
    return e;
  }
  return new this(a, b, c, d);
}
function fe(a) {
  if (!(a instanceof this)) throw Error(u(279));
  a.destructor();
  10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
  a.eventPool = [];
  a.getPooled = ee;
  a.release = fe;
}
var ge = G.extend({
    data: null
  }),
  he = G.extend({
    data: null
  }),
  ie = [9, 13, 27, 32],
  je = ya && "CompositionEvent" in window,
  ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke,
  me = ya && (!je || ke && 8 < ke && 11 >= ke),
  ne = String.fromCharCode(32),
  oe = {
    beforeInput: {
      phasedRegistrationNames: {
        bubbled: "onBeforeInput",
        captured: "onBeforeInputCapture"
      },
      dependencies: ["compositionend", "keypress", "textInput", "paste"]
    },
    compositionEnd: {
      phasedRegistrationNames: {
        bubbled: "onCompositionEnd",
        captured: "onCompositionEndCapture"
      },
      dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
      phasedRegistrationNames: {
        bubbled: "onCompositionStart",
        captured: "onCompositionStartCapture"
      },
      dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
      phasedRegistrationNames: {
        bubbled: "onCompositionUpdate",
        captured: "onCompositionUpdateCapture"
      },
      dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
  },
  pe = !1;
function qe(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== ie.indexOf(b.keyCode);
    case "keydown":
      return 229 !== b.keyCode;
    case "keypress":
    case "mousedown":
    case "blur":
      return !0;
    default:
      return !1;
  }
}
function re(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
  switch (a) {
    case "compositionend":
      return re(b);
    case "keypress":
      if (32 !== b.which) return null;
      pe = !0;
      return ne;
    case "textInput":
      return a = b.data, a === ne && pe ? null : a;
    default:
      return null;
  }
}
function ue(a, b) {
  if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return me && "ko" !== b.locale ? null : b.data;
    default:
      return null;
  }
}
var ve = {
    eventTypes: oe,
    extractEvents: function extractEvents(a, b, c, d) {
      var e;
      if (je) b: {
        switch (a) {
          case "compositionstart":
            var f = oe.compositionStart;
            break b;
          case "compositionend":
            f = oe.compositionEnd;
            break b;
          case "compositionupdate":
            f = oe.compositionUpdate;
            break b;
        }
        f = void 0;
      } else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
      f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
      (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
      return null === e ? b : null === b ? e : [e, b];
    }
  },
  we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
function xe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
  change: {
    phasedRegistrationNames: {
      bubbled: "onChange",
      captured: "onChangeCapture"
    },
    dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
  }
};
function ze(a, b, c) {
  a = G.getPooled(ye.change, a, b, c);
  a.type = "change";
  Da(c);
  Xd(a);
  return a;
}
var Ae = null,
  Be = null;
function Ce(a) {
  mc(a);
}
function De(a) {
  var b = Pd(a);
  if (yb(b)) return a;
}
function Ee(a, b) {
  if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
  Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
  if ("value" === a.propertyName && De(Be)) if (a = ze(Be, a, nc(a)), Ja) mc(a);else {
    Ja = !0;
    try {
      Fa(Ce, a);
    } finally {
      Ja = !1, La();
    }
  }
}
function Ie(a, b, c) {
  "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
  if ("click" === a) return De(b);
}
function Le(a, b) {
  if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = b ? Pd(b) : window,
        f = e.nodeName && e.nodeName.toLowerCase();
      if ("select" === f || "input" === f && "file" === e.type) var g = Ee;else if (xe(e)) {
        if (Fe) g = Le;else {
          g = Je;
          var h = Ie;
        }
      } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
      if (g && (g = g(a, b))) return ze(g, c, d);
      h && h(a, e, b);
      "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
  },
  Ne = G.extend({
    view: null,
    detail: null
  }),
  Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
function Pe(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
  return Pe;
}
var Re = 0,
  Se = 0,
  Te = !1,
  Ue = !1,
  Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(a) {
      return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function movementX(a) {
      if ("movementX" in a) return a.movementX;
      var b = Re;
      Re = a.screenX;
      return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function movementY(a) {
      if ("movementY" in a) return a.movementY;
      var b = Se;
      Se = a.screenY;
      return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
  }),
  We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
  }),
  Xe = {
    mouseEnter: {
      registrationName: "onMouseEnter",
      dependencies: ["mouseout", "mouseover"]
    },
    mouseLeave: {
      registrationName: "onMouseLeave",
      dependencies: ["mouseout", "mouseover"]
    },
    pointerEnter: {
      registrationName: "onPointerEnter",
      dependencies: ["pointerout", "pointerover"]
    },
    pointerLeave: {
      registrationName: "onPointerLeave",
      dependencies: ["pointerout", "pointerover"]
    }
  },
  Ye = {
    eventTypes: Xe,
    extractEvents: function extractEvents(a, b, c, d, e) {
      var f = "mouseover" === a || "pointerover" === a,
        g = "mouseout" === a || "pointerout" === a;
      if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
      f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
      if (g) {
        if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
          var h = dc(b);
          if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
        }
      } else g = null;
      if (g === b) return null;
      if ("mouseout" === a || "mouseover" === a) {
        var k = Ve;
        var l = Xe.mouseLeave;
        var m = Xe.mouseEnter;
        var p = "mouse";
      } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
      a = null == g ? f : Pd(g);
      f = null == b ? f : Pd(b);
      l = k.getPooled(l, g, c, d);
      l.type = p + "leave";
      l.target = a;
      l.relatedTarget = f;
      c = k.getPooled(m, b, c, d);
      c.type = p + "enter";
      c.target = f;
      c.relatedTarget = a;
      d = g;
      p = b;
      if (d && p) a: {
        k = d;
        m = p;
        g = 0;
        for (a = k; a; a = Rd(a)) g++;
        a = 0;
        for (b = m; b; b = Rd(b)) a++;
        for (; 0 < g - a;) k = Rd(k), g--;
        for (; 0 < a - g;) m = Rd(m), a--;
        for (; g--;) {
          if (k === m || k === m.alternate) break a;
          k = Rd(k);
          m = Rd(m);
        }
        k = null;
      } else k = null;
      m = k;
      for (k = []; d && d !== m;) {
        g = d.alternate;
        if (null !== g && g === m) break;
        k.push(d);
        d = Rd(d);
      }
      for (d = []; p && p !== m;) {
        g = p.alternate;
        if (null !== g && g === m) break;
        d.push(p);
        p = Rd(p);
      }
      for (p = 0; p < k.length; p++) Vd(k[p], "bubbled", l);
      for (p = d.length; 0 < p--;) Vd(d[p], "captured", c);
      return 0 === (e & 64) ? [l] : [l, c];
    }
  };
function Ze(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze,
  af = Object.prototype.hasOwnProperty;
function bf(a, b) {
  if ($e(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
    d = Object.keys(b);
  if (c.length !== d.length) return !1;
  for (d = 0; d < c.length; d++) if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
  return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode,
  df = {
    select: {
      phasedRegistrationNames: {
        bubbled: "onSelect",
        captured: "onSelectCapture"
      },
      dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
  },
  ef = null,
  ff = null,
  gf = null,
  hf = !1;
function jf(a, b) {
  var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
  if (hf || null == ef || ef !== td(c)) return null;
  c = ef;
  "selectionStart" in c && yd(c) ? c = {
    start: c.selectionStart,
    end: c.selectionEnd
  } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
    anchorNode: c.anchorNode,
    anchorOffset: c.anchorOffset,
    focusNode: c.focusNode,
    focusOffset: c.focusOffset
  });
  return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function extractEvents(a, b, c, d, e, f) {
      e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
      if (!(f = !e)) {
        a: {
          e = cc(e);
          f = wa.onSelect;
          for (var g = 0; g < f.length; g++) if (!e.has(f[g])) {
            e = !1;
            break a;
          }
          e = !0;
        }
        f = !e;
      }
      if (f) return null;
      e = b ? Pd(b) : window;
      switch (a) {
        case "focus":
          if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
          break;
        case "blur":
          gf = ff = ef = null;
          break;
        case "mousedown":
          hf = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          return hf = !1, jf(c, d);
        case "selectionchange":
          if (cf) break;
        case "keydown":
        case "keyup":
          return jf(c, d);
      }
      return null;
    }
  },
  lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
  mf = G.extend({
    clipboardData: function clipboardData(a) {
      return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
  }),
  nf = Ne.extend({
    relatedTarget: null
  });
function of(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  },
  qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  },
  rf = Ne.extend({
    key: function key(a) {
      if (a.key) {
        var b = pf[a.key] || a.key;
        if ("Unidentified" !== b) return b;
      }
      return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function charCode(a) {
      return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function keyCode(a) {
      return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
      return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
  }),
  sf = Ve.extend({
    dataTransfer: null
  }),
  tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
  }),
  uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
  }),
  vf = Ve.extend({
    deltaX: function deltaX(a) {
      return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
      return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
  }),
  wf = {
    eventTypes: Wc,
    extractEvents: function extractEvents(a, b, c, d) {
      var e = Yc.get(a);
      if (!e) return null;
      switch (a) {
        case "keypress":
          if (0 === of(c)) return null;
        case "keydown":
        case "keyup":
          a = rf;
          break;
        case "blur":
        case "focus":
          a = nf;
          break;
        case "click":
          if (2 === c.button) return null;
        case "auxclick":
        case "dblclick":
        case "mousedown":
        case "mousemove":
        case "mouseup":
        case "mouseout":
        case "mouseover":
        case "contextmenu":
          a = Ve;
          break;
        case "drag":
        case "dragend":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "dragstart":
        case "drop":
          a = sf;
          break;
        case "touchcancel":
        case "touchend":
        case "touchmove":
        case "touchstart":
          a = tf;
          break;
        case Xb:
        case Yb:
        case Zb:
          a = lf;
          break;
        case $b:
          a = uf;
          break;
        case "scroll":
          a = Ne;
          break;
        case "wheel":
          a = vf;
          break;
        case "copy":
        case "cut":
        case "paste":
          a = mf;
          break;
        case "gotpointercapture":
        case "lostpointercapture":
        case "pointercancel":
        case "pointerdown":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "pointerup":
          a = We;
          break;
        default:
          a = G;
      }
      b = a.getPooled(e, b, c, d);
      Xd(b);
      return b;
    }
  };
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
  SimpleEventPlugin: wf,
  EnterLeaveEventPlugin: Ye,
  ChangeEventPlugin: Me,
  SelectEventPlugin: kf,
  BeforeInputEventPlugin: ve
});
var If = scheduler.unstable_runWithPriority,
  Jf = scheduler.unstable_scheduleCallback,
  Kf = scheduler.unstable_cancelCallback,
  Lf = scheduler.unstable_requestPaint,
  Mf = scheduler.unstable_now,
  Nf = scheduler.unstable_getCurrentPriorityLevel,
  Of = scheduler.unstable_ImmediatePriority,
  Pf = scheduler.unstable_UserBlockingPriority,
  Qf = scheduler.unstable_NormalPriority,
  Rf = scheduler.unstable_LowPriority,
  Sf = scheduler.unstable_IdlePriority,
  Uf = scheduler.unstable_shouldYield,
  Zf = Mf();
var Dg = Wa.ReactCurrentBatchConfig,
  Eg = new React__default.Component().refs;
var jh = Wa.ReactCurrentDispatcher,
  kh = Wa.ReactCurrentBatchConfig;
var Yh = Wa.ReactCurrentOwner;
var cj = Wa.ReactCurrentDispatcher,
  dj = Wa.ReactCurrentOwner;
function Mj(a, b) {
  try {
    return a(b);
  } finally {}
}
var Uj = null,
  Li = null;
function Yj(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
  var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (b.isDisabled || !b.supportsFiber) return !0;
  try {
    var c = b.inject(a);
    Uj = function Uj(a) {
      try {
        b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
      } catch (e) {}
    };
    Li = function Li(a) {
      try {
        b.onCommitFiberUnmount(c, a);
      } catch (e) {}
    };
  } catch (d) {}
  return !0;
}
za = function za(a, b, c) {
  switch (b) {
    case "input":
      Cb(a, c);
      b = c.name;
      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d = c[b];
          if (d !== a && d.form === a.form) {
            var e = Qd(d);
            if (!e) throw Error(u(90));
            yb(d);
            Cb(d, e);
          }
        }
      }
      break;
    case "textarea":
      Kb(a, c);
      break;
    case "select":
      b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
  }
};
Fa = Mj;
Ha = function Ha() {};
(function (a) {
  var b = a.findFiberByHostInstance;
  return Yj(objectAssign({}, a, {
    overrideHookState: null,
    overrideProps: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: Wa.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = hc(a);
      return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: function findFiberByHostInstance(a) {
      return b ? b(a) : null;
    },
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
  }));
})({
  findFiberByHostInstance: tc,
  bundleType: 0,
  version: "16.13.1",
  rendererPackageName: "react-dom"
});
var schedulerTracing_development = createCommonjsModule(function (module, exports) {
  {
    (function () {
      var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.

      var interactionIDCounter = 0;
      var threadIDCounter = 0; // Set of currently traced interactions.
      // Interactions "stack"–
      // Meaning that newly traced interactions are appended to the previously active set.
      // When an interaction goes out of scope, the previous set (if any) is restored.

      exports.__interactionsRef = null; // Listener(s) to notify when interactions begin and end.

      exports.__subscriberRef = null;
      {
        exports.__interactionsRef = {
          current: new Set()
        };
        exports.__subscriberRef = {
          current: null
        };
      }
      function unstable_clear(callback) {
        var prevInteractions = exports.__interactionsRef.current;
        exports.__interactionsRef.current = new Set();
        try {
          return callback();
        } finally {
          exports.__interactionsRef.current = prevInteractions;
        }
      }
      function unstable_getCurrent() {
        {
          return exports.__interactionsRef.current;
        }
      }
      function unstable_getThreadID() {
        return ++threadIDCounter;
      }
      function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
          __count: 1,
          id: interactionIDCounter++,
          name: name,
          timestamp: timestamp
        };
        var prevInteractions = exports.__interactionsRef.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.

        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        exports.__interactionsRef.current = interactions;
        var subscriber = exports.__subscriberRef.current;
        var returnValue;
        try {
          if (subscriber !== null) {
            subscriber.onInteractionTraced(interaction);
          }
        } finally {
          try {
            if (subscriber !== null) {
              subscriber.onWorkStarted(interactions, threadID);
            }
          } finally {
            try {
              returnValue = callback();
            } finally {
              exports.__interactionsRef.current = prevInteractions;
              try {
                if (subscriber !== null) {
                  subscriber.onWorkStopped(interactions, threadID);
                }
              } finally {
                interaction.__count--; // If no async work was scheduled for this interaction,
                // Notify subscribers that it's completed.

                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              }
            }
          }
        }
        return returnValue;
      }
      function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = exports.__interactionsRef.current;
        var subscriber = exports.__subscriberRef.current;
        if (subscriber !== null) {
          subscriber.onWorkScheduled(wrappedInteractions, threadID);
        } // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.

        wrappedInteractions.forEach(function (interaction) {
          interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
          var prevInteractions = exports.__interactionsRef.current;
          exports.__interactionsRef.current = wrappedInteractions;
          subscriber = exports.__subscriberRef.current;
          try {
            var returnValue;
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(wrappedInteractions, threadID);
              }
            } finally {
              try {
                returnValue = callback.apply(undefined, arguments);
              } finally {
                exports.__interactionsRef.current = prevInteractions;
                if (subscriber !== null) {
                  subscriber.onWorkStopped(wrappedInteractions, threadID);
                }
              }
            }
            return returnValue;
          } finally {
            if (!hasRun) {
              // We only expect a wrapped function to be executed once,
              // But in the event that it's executed more than once–
              // Only decrement the outstanding interaction counts once.
              hasRun = true; // Update pending async counts for all wrapped interactions.
              // If this was the last scheduled async work for any of them,
              // Mark them as completed.

              wrappedInteractions.forEach(function (interaction) {
                interaction.__count--;
                if (subscriber !== null && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          }
        }
        wrapped.cancel = function cancel() {
          subscriber = exports.__subscriberRef.current;
          try {
            if (subscriber !== null) {
              subscriber.onWorkCanceled(wrappedInteractions, threadID);
            }
          } finally {
            // Update pending async counts for all wrapped interactions.
            // If this was the last scheduled async work for any of them,
            // Mark them as completed.
            wrappedInteractions.forEach(function (interaction) {
              interaction.__count--;
              if (subscriber && interaction.__count === 0) {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
              }
            });
          }
        };
        return wrapped;
      }
      var subscribers = null;
      {
        subscribers = new Set();
      }
      function unstable_subscribe(subscriber) {
        {
          subscribers.add(subscriber);
          if (subscribers.size === 1) {
            exports.__subscriberRef.current = {
              onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
              onInteractionTraced: onInteractionTraced,
              onWorkCanceled: onWorkCanceled,
              onWorkScheduled: onWorkScheduled,
              onWorkStarted: onWorkStarted,
              onWorkStopped: onWorkStopped
            };
          }
        }
      }
      function unstable_unsubscribe(subscriber) {
        {
          subscribers.delete(subscriber);
          if (subscribers.size === 0) {
            exports.__subscriberRef.current = null;
          }
        }
      }
      function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionTraced(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onInteractionScheduledWorkCompleted(interaction);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkScheduled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStarted(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkStopped(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function (subscriber) {
          try {
            subscriber.onWorkCanceled(interactions, threadID);
          } catch (error) {
            if (!didCatchError) {
              didCatchError = true;
              caughtError = error;
            }
          }
        });
        if (didCatchError) {
          throw caughtError;
        }
      }
      exports.unstable_clear = unstable_clear;
      exports.unstable_getCurrent = unstable_getCurrent;
      exports.unstable_getThreadID = unstable_getThreadID;
      exports.unstable_subscribe = unstable_subscribe;
      exports.unstable_trace = unstable_trace;
      exports.unstable_unsubscribe = unstable_unsubscribe;
      exports.unstable_wrap = unstable_wrap;
    })();
  }
});
var schedulerTracing_development_1 = schedulerTracing_development.__interactionsRef;
var schedulerTracing_development_2 = schedulerTracing_development.__subscriberRef;
var schedulerTracing_development_3 = schedulerTracing_development.unstable_clear;
var schedulerTracing_development_4 = schedulerTracing_development.unstable_getCurrent;
var schedulerTracing_development_5 = schedulerTracing_development.unstable_getThreadID;
var schedulerTracing_development_6 = schedulerTracing_development.unstable_subscribe;
var schedulerTracing_development_7 = schedulerTracing_development.unstable_trace;
var schedulerTracing_development_8 = schedulerTracing_development.unstable_unsubscribe;
var schedulerTracing_development_9 = schedulerTracing_development.unstable_wrap;
var tracing = createCommonjsModule(function (module) {
  {
    module.exports = schedulerTracing_development;
  }
});
var reactDom_development = createCommonjsModule(function (module, exports) {
  {
    (function () {
      var React = React__default;
      var _assign = objectAssign;
      var Scheduler = scheduler;
      var checkPropTypes = checkPropTypes_1;
      var tracing$1 = tracing;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED; // Prevent newer renderers from RTE when used with older react package versions.
      // Current owner and dispatcher used to share the same ref,
      // but PR #14548 split them out to better support the react-debug-tools package.

      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentDispatcher')) {
        ReactSharedInternals.ReactCurrentDispatcher = {
          current: null
        };
      }
      if (!ReactSharedInternals.hasOwnProperty('ReactCurrentBatchConfig')) {
        ReactSharedInternals.ReactCurrentBatchConfig = {
          suspense: null
        };
      }

      // by calls to these methods by a Babel plugin.
      //
      // In PROD (or in packages without access to React internals),
      // they are left as they are instead.

      function warn(format) {
        {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          printWarning('warn', format, args);
        }
      }
      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;
          if (!hasExistingStack) {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame.getStackAddendum();
            if (stack !== '') {
              format += '%s';
              args = args.concat([stack]);
            }
          }
          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            var argIndex = 0;
            var message = 'Warning: ' + format.replace(/%s/g, function () {
              return args[argIndex++];
            });
            throw new Error(message);
          } catch (x) {}
        }
      }
      if (!React) {
        {
          throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
        }
      }
      var invokeGuardedCallbackImpl = function invokeGuardedCallbackImpl(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
          func.apply(context, funcArgs);
        } catch (error) {
          this.onError(error);
        }
      };
      {
        // In DEV mode, we swap out invokeGuardedCallback for a special version
        // that plays more nicely with the browser's DevTools. The idea is to preserve
        // "Pause on exceptions" behavior. Because React wraps all user-provided
        // functions in invokeGuardedCallback, and the production version of
        // invokeGuardedCallback uses a try-catch, all user exceptions are treated
        // like caught exceptions, and the DevTools won't pause unless the developer
        // takes the extra step of enabling pause on caught exceptions. This is
        // unintuitive, though, because even though React has caught the error, from
        // the developer's perspective, the error is uncaught.
        //
        // To preserve the expected "Pause on exceptions" behavior, we don't use a
        // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
        // DOM node, and call the user-provided callback from inside an event handler
        // for that fake event. If the callback throws, the error is "captured" using
        // a global event handler. But because the error happens in a different
        // event loop context, it does not interrupt the normal program flow.
        // Effectively, this gives us try-catch behavior without actually using
        // try-catch. Neat!
        // Check that the browser supports the APIs we need to implement our special
        // DEV version of invokeGuardedCallback
        if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
          var fakeNode = document.createElement('react');
          var invokeGuardedCallbackDev = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) {
              {
                throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
              }
            }
            var evt = document.createEvent('Event'); // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.

            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.

            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688

            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event'); // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.

            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
              // We immediately remove the callback from event listeners so that
              // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
              // nested call would trigger the fake event handlers of any call higher
              // in the stack.
              fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
              // window.event assignment in both IE <= 10 as they throw an error
              // "Member not found" in strict mode, and in Firefox which does not
              // support window.event.

              if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) {
                window.event = windowEvent;
              }
              func.apply(context, funcArgs);
              didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.

            var error; // Use this to track whether the error event is ever called.

            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
              error = event.error;
              didSetError = true;
              if (error === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }
              if (event.defaultPrevented) {
                // Some other error handler has prevented default.
                // Browsers silence the error report if this happens.
                // We'll remember this to later decide whether to log it or not.
                if (error != null && typeof error === 'object') {
                  try {
                    error._suppressLogging = true;
                  } catch (inner) {// Ignore.
                  }
                }
              }
            } // Create a fake event type.

            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers

            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.

            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) {
              Object.defineProperty(window, 'event', windowEventDescriptor);
            }
            if (didError) {
              if (!didSetError) {
                // The callback errored, but the error event never fired.
                error = new Error('An error was thrown inside one of your components, but React ' + "doesn't know what it was. This is likely due to browser " + 'flakiness. React does its best to preserve the "Pause on ' + 'exceptions" behavior of the DevTools, which requires some ' + "DEV-mode only tricks. It's possible that these don't work in " + 'your browser. Try triggering the error in production mode, ' + 'or switching to a modern browser. If you suspect that this is ' + 'actually an issue with React, please file an issue.');
              } else if (isCrossOriginError) {
                error = new Error("A cross-origin error was thrown. React doesn't have access to " + 'the actual error object in development. ' + 'See https://fb.me/react-crossorigin-error for more information.');
              }
              this.onError(error);
            } // Remove our event listeners

            window.removeEventListener('error', handleWindowError);
          };
          invokeGuardedCallbackImpl = invokeGuardedCallbackDev;
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null; // Used by event system to capture/rethrow the first error.

      var hasRethrowError = false;
      var rethrowError = null;
      var reporter = {
        onError: function onError(error) {
          hasError = true;
          caughtError = error;
        }
      };
      /**
       * Call a function while guarding against errors that happens within it.
       * Returns an error if it throws, otherwise null.
       *
       * In production, this is implemented using a try-catch. The reason we don't
       * use a try-catch directly is so that we can swap out a different
       * implementation in DEV mode.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      /**
       * Same as invokeGuardedCallback, but instead of returning an error, it stores
       * it in a global so it can be rethrown by `rethrowCaughtError` later.
       * TODO: See if caughtError and rethrowError can be unified.
       *
       * @param {String} name of the guard to use for logging or debugging
       * @param {Function} func The function to invoke
       * @param {*} context The context to use when calling the function
       * @param {...*} args Arguments for function
       */

      function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
          var error = clearCaughtError();
          if (!hasRethrowError) {
            hasRethrowError = true;
            rethrowError = error;
          }
        }
      }
      /**
       * During execution of guarded functions we will capture the first error which
       * we will rethrow to be handled by the top level error handler.
       */

      function rethrowCaughtError() {
        if (hasRethrowError) {
          var error = rethrowError;
          hasRethrowError = false;
          rethrowError = null;
          throw error;
        }
      }
      function hasCaughtError() {
        return hasError;
      }
      function clearCaughtError() {
        if (hasError) {
          var error = caughtError;
          hasError = false;
          caughtError = null;
          return error;
        } else {
          {
            {
              throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      var getFiberCurrentPropsFromNode = null;
      var getInstanceFromNode = null;
      var getNodeFromInstance = null;
      function setComponentTree(getFiberCurrentPropsFromNodeImpl, getInstanceFromNodeImpl, getNodeFromInstanceImpl) {
        getFiberCurrentPropsFromNode = getFiberCurrentPropsFromNodeImpl;
        getInstanceFromNode = getInstanceFromNodeImpl;
        getNodeFromInstance = getNodeFromInstanceImpl;
        {
          if (!getNodeFromInstance || !getInstanceFromNode) {
            error('EventPluginUtils.setComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.');
          }
        }
      }
      var validateEventDispatches;
      {
        validateEventDispatches = function validateEventDispatches(event) {
          var dispatchListeners = event._dispatchListeners;
          var dispatchInstances = event._dispatchInstances;
          var listenersIsArr = Array.isArray(dispatchListeners);
          var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
          var instancesIsArr = Array.isArray(dispatchInstances);
          var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
          if (instancesIsArr !== listenersIsArr || instancesLen !== listenersLen) {
            error('EventPluginUtils: Invalid `event`.');
          }
        };
      }
      /**
       * Dispatch the event to the listener.
       * @param {SyntheticEvent} event SyntheticEvent to handle
       * @param {function} listener Application-level callback
       * @param {*} inst Internal component instance
       */

      function executeDispatch(event, listener, inst) {
        var type = event.type || 'unknown-event';
        event.currentTarget = getNodeFromInstance(inst);
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
      }
      /**
       * Standard/simple iteration through an event's collected dispatches.
       */

      function executeDispatchesInOrder(event) {
        var dispatchListeners = event._dispatchListeners;
        var dispatchInstances = event._dispatchInstances;
        {
          validateEventDispatches(event);
        }
        if (Array.isArray(dispatchListeners)) {
          for (var i = 0; i < dispatchListeners.length; i++) {
            if (event.isPropagationStopped()) {
              break;
            } // Listeners and Instances are two parallel arrays that are always in sync.

            executeDispatch(event, dispatchListeners[i], dispatchInstances[i]);
          }
        } else if (dispatchListeners) {
          executeDispatch(event, dispatchListeners, dispatchInstances);
        }
        event._dispatchListeners = null;
        event._dispatchInstances = null;
      }
      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2; // Before we know whether it is function or class

      var HostRoot = 3; // Root of a host tree. Could be nested inside another node.

      var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.

      var HostComponent = 5;
      var HostText = 6;
      var Fragment = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var FundamentalComponent = 20;
      var ScopeComponent = 21;
      var Block = 22;

      /**
       * Injectable ordering of event plugins.
       */
      var eventPluginOrder = null;
      /**
       * Injectable mapping from names to event plugin modules.
       */

      var namesToPlugins = {};
      /**
       * Recomputes the plugin list using the injected plugins and plugin ordering.
       *
       * @private
       */

      function recomputePluginOrdering() {
        if (!eventPluginOrder) {
          // Wait until an `eventPluginOrder` is injected.
          return;
        }
        for (var pluginName in namesToPlugins) {
          var pluginModule = namesToPlugins[pluginName];
          var pluginIndex = eventPluginOrder.indexOf(pluginName);
          if (!(pluginIndex > -1)) {
            {
              throw Error("EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `" + pluginName + "`.");
            }
          }
          if (plugins[pluginIndex]) {
            continue;
          }
          if (!pluginModule.extractEvents) {
            {
              throw Error("EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `" + pluginName + "` does not.");
            }
          }
          plugins[pluginIndex] = pluginModule;
          var publishedEvents = pluginModule.eventTypes;
          for (var eventName in publishedEvents) {
            if (!publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName)) {
              {
                throw Error("EventPluginRegistry: Failed to publish event `" + eventName + "` for plugin `" + pluginName + "`.");
              }
            }
          }
        }
      }
      /**
       * Publishes an event so that it can be dispatched by the supplied plugin.
       *
       * @param {object} dispatchConfig Dispatch configuration for the event.
       * @param {object} PluginModule Plugin publishing the event.
       * @return {boolean} True if the event was successfully published.
       * @private
       */

      function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
        if (!!eventNameDispatchConfigs.hasOwnProperty(eventName)) {
          {
            throw Error("EventPluginRegistry: More than one plugin attempted to publish the same event name, `" + eventName + "`.");
          }
        }
        eventNameDispatchConfigs[eventName] = dispatchConfig;
        var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
        if (phasedRegistrationNames) {
          for (var phaseName in phasedRegistrationNames) {
            if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
              var phasedRegistrationName = phasedRegistrationNames[phaseName];
              publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
            }
          }
          return true;
        } else if (dispatchConfig.registrationName) {
          publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
          return true;
        }
        return false;
      }
      /**
       * Publishes a registration name that is used to identify dispatched events.
       *
       * @param {string} registrationName Registration name to add.
       * @param {object} PluginModule Plugin publishing the event.
       * @private
       */

      function publishRegistrationName(registrationName, pluginModule, eventName) {
        if (!!registrationNameModules[registrationName]) {
          {
            throw Error("EventPluginRegistry: More than one plugin attempted to publish the same registration name, `" + registrationName + "`.");
          }
        }
        registrationNameModules[registrationName] = pluginModule;
        registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
        {
          var lowerCasedName = registrationName.toLowerCase();
          possibleRegistrationNames[lowerCasedName] = registrationName;
          if (registrationName === 'onDoubleClick') {
            possibleRegistrationNames.ondblclick = registrationName;
          }
        }
      }
      /**
       * Registers plugins so that they can extract and dispatch events.
       */

      /**
       * Ordered list of injected plugins.
       */

      var plugins = [];
      /**
       * Mapping from event name to dispatch config
       */

      var eventNameDispatchConfigs = {};
      /**
       * Mapping from registration name to plugin module
       */

      var registrationNameModules = {};
      /**
       * Mapping from registration name to event name
       */

      var registrationNameDependencies = {};
      /**
       * Mapping from lowercase registration names to the properly cased version,
       * used to warn in the case of missing event handlers. Available
       * only in true.
       * @type {Object}
       */

      var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true

      /**
       * Injects an ordering of plugins (by plugin name). This allows the ordering
       * to be decoupled from injection of the actual plugins so that ordering is
       * always deterministic regardless of packaging, on-the-fly injection, etc.
       *
       * @param {array} InjectedEventPluginOrder
       * @internal
       */

      function injectEventPluginOrder(injectedEventPluginOrder) {
        if (!!eventPluginOrder) {
          {
            throw Error("EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.");
          }
        } // Clone the ordering so it cannot be dynamically mutated.

        eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
        recomputePluginOrdering();
      }
      /**
       * Injects plugins to be used by plugin event system. The plugin names must be
       * in the ordering injected by `injectEventPluginOrder`.
       *
       * Plugins can be injected as part of page initialization or on-the-fly.
       *
       * @param {object} injectedNamesToPlugins Map from names to plugin modules.
       * @internal
       */

      function injectEventPluginsByName(injectedNamesToPlugins) {
        var isOrderingDirty = false;
        for (var pluginName in injectedNamesToPlugins) {
          if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
            continue;
          }
          var pluginModule = injectedNamesToPlugins[pluginName];
          if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
            if (!!namesToPlugins[pluginName]) {
              {
                throw Error("EventPluginRegistry: Cannot inject two different event plugins using the same name, `" + pluginName + "`.");
              }
            }
            namesToPlugins[pluginName] = pluginModule;
            isOrderingDirty = true;
          }
        }
        if (isOrderingDirty) {
          recomputePluginOrdering();
        }
      }
      var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
      var PLUGIN_EVENT_SYSTEM = 1;
      var IS_REPLAYED = 1 << 5;
      var IS_FIRST_ANCESTOR = 1 << 6;
      var restoreImpl = null;
      var restoreTarget = null;
      var restoreQueue = null;
      function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) {
          // Unmounted
          return;
        }
        if (!(typeof restoreImpl === 'function')) {
          {
            throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.

        if (stateNode) {
          var _props = getFiberCurrentPropsFromNode(stateNode);
          restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
      }
      function setRestoreImplementation(impl) {
        restoreImpl = impl;
      }
      function enqueueStateRestore(target) {
        if (restoreTarget) {
          if (restoreQueue) {
            restoreQueue.push(target);
          } else {
            restoreQueue = [target];
          }
        } else {
          restoreTarget = target;
        }
      }
      function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
      }
      function restoreStateIfNeeded() {
        if (!restoreTarget) {
          return;
        }
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) {
          for (var i = 0; i < queuedTargets.length; i++) {
            restoreStateOfTarget(queuedTargets[i]);
          }
        }
      }
      var enableProfilerTimer = true; // Trace which interactions trigger each commit.

      var enableDeprecatedFlareAPI = false; // Experimental Host Component support.

      var enableFundamentalAPI = false; // Experimental Scope support.
      var warnAboutStringRefs = false;

      // the renderer. Such as when we're dispatching events or if third party
      // libraries need to call batchedUpdates. Eventually, this API will go away when
      // everything is batched by default. We'll then have a similar API to opt-out of
      // scheduled work and instead do synchronous work.
      // Defaults

      var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
        return fn(bookkeeping);
      };
      var discreteUpdatesImpl = function discreteUpdatesImpl(fn, a, b, c, d) {
        return fn(a, b, c, d);
      };
      var flushDiscreteUpdatesImpl = function flushDiscreteUpdatesImpl() {};
      var batchedEventUpdatesImpl = batchedUpdatesImpl;
      var isInsideEventHandler = false;
      var isBatchingEventUpdates = false;
      function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
          // If a controlled event was fired, we may need to restore the state of
          // the DOM node back to the controlled value. This is necessary when React
          // bails out of the update without touching the DOM.
          flushDiscreteUpdatesImpl();
          restoreStateIfNeeded();
        }
      }
      function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) {
          // If we are currently inside another batch, we need to wait until it
          // fully completes before restoring state.
          return fn(bookkeeping);
        }
        isInsideEventHandler = true;
        try {
          return batchedUpdatesImpl(fn, bookkeeping);
        } finally {
          isInsideEventHandler = false;
          finishEventHandler();
        }
      }
      function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) {
          // If we are currently inside another batch, we need to wait until it
          // fully completes before restoring state.
          return fn(a, b);
        }
        isBatchingEventUpdates = true;
        try {
          return batchedEventUpdatesImpl(fn, a, b);
        } finally {
          isBatchingEventUpdates = false;
          finishEventHandler();
        }
      } // This is for the React Flare event system
      function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
          return discreteUpdatesImpl(fn, a, b, c, d);
        } finally {
          isInsideEventHandler = prevIsInsideEventHandler;
          if (!isInsideEventHandler) {
            finishEventHandler();
          }
        }
      }
      function flushDiscreteUpdatesIfNeeded(timeStamp) {
        // event.timeStamp isn't overly reliable due to inconsistencies in
        // how different browsers have historically provided the time stamp.
        // Some browsers provide high-resolution time stamps for all events,
        // some provide low-resolution time stamps for all events. FF < 52
        // even mixes both time stamps together. Some browsers even report
        // negative time stamps or time stamps that are 0 (iOS9) in some cases.
        // Given we are only comparing two time stamps with equality (!==),
        // we are safe from the resolution differences. If the time stamp is 0
        // we bail-out of preventing the flush, which can affect semantics,
        // such as if an earlier flush removes or adds event listeners that
        // are fired in the subsequent flush. However, this is the same
        // behaviour as we had before this change, so the risks are low.
        if (!isInsideEventHandler && !enableDeprecatedFlareAPI) {
          flushDiscreteUpdatesImpl();
        }
      }
      function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
      }
      var DiscreteEvent = 0;
      var UserBlockingEvent = 1;
      var ContinuousEvent = 2;

      // A reserved attribute.
      // It is handled by React separately and shouldn't be written to the DOM.
      var RESERVED = 0; // A simple string attribute.
      // Attributes that aren't in the whitelist are presumed to have this type.

      var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
      // "enumerated" attributes with "true" and "false" as possible values.
      // When true, it should be set to a "true" string.
      // When false, it should be set to a "false" string.

      var BOOLEANISH_STRING = 2; // A real boolean attribute.
      // When true, it should be present (set either to an empty string or its name).
      // When false, it should be omitted.

      var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
      // When true, it should be present (set either to an empty string or its name).
      // When false, it should be omitted.
      // For any other value, should be present with that value.

      var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
      // When falsy, it should be removed.

      var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
      // When falsy, it should be removed.

      var POSITIVE_NUMERIC = 6;

      /* eslint-disable max-len */
      var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
      /* eslint-enable max-len */

      var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
      var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
      var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var illegalAttributeNameCache = {};
      var validatedAttributeNameCache = {};
      function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) {
          return true;
        }
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) {
          return false;
        }
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
          validatedAttributeNameCache[attributeName] = true;
          return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        {
          error('Invalid attribute name: `%s`', attributeName);
        }
        return false;
      }
      function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) {
          return propertyInfo.type === RESERVED;
        }
        if (isCustomComponentTag) {
          return false;
        }
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) {
          return true;
        }
        return false;
      }
      function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) {
          return false;
        }
        switch (typeof value) {
          case 'function': // $FlowIssue symbol is perfectly valid here

          case 'symbol':
            // eslint-disable-line
            return true;
          case 'boolean':
            {
              if (isCustomComponentTag) {
                return false;
              }
              if (propertyInfo !== null) {
                return !propertyInfo.acceptsBooleans;
              } else {
                var prefix = name.toLowerCase().slice(0, 5);
                return prefix !== 'data-' && prefix !== 'aria-';
              }
            }
          default:
            return false;
        }
      }
      function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') {
          return true;
        }
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) {
          return true;
        }
        if (isCustomComponentTag) {
          return false;
        }
        if (propertyInfo !== null) {
          switch (propertyInfo.type) {
            case BOOLEAN:
              return !value;
            case OVERLOADED_BOOLEAN:
              return value === false;
            case NUMERIC:
              return isNaN(value);
            case POSITIVE_NUMERIC:
              return isNaN(value) || value < 1;
          }
        }
        return false;
      }
      function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
      }
      function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
      } // When adding attributes to this list, be sure to also add them to
      // the `possibleStandardNames` module to ensure casing and incorrect
      // name warnings.

      var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.

      var reservedProps = ['children', 'dangerouslySetInnerHTML',
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
      reservedProps.forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // A few React string attributes have a different name.
      // This is a mapping from React prop names to the attribute names.

      [['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
        var name = _ref[0],
          attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are "enumerated" HTML attributes that accept "true" and "false".
      // In React, we let users pass `true` and `false` even though technically
      // these aren't boolean attributes (they are coerced to strings).

      ['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are "enumerated" SVG attributes that accept "true" and "false".
      // In React, we let users pass `true` and `false` even though technically
      // these aren't boolean attributes (they are coerced to strings).
      // Since these are SVG attributes, their attribute names are case-sensitive.

      ['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML boolean attributes.

      ['allowFullScreen', 'async',
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
      // Microdata
      'itemScope'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are the few React props that we set as DOM properties
      // rather than attributes. These are all booleans.

      ['checked',
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      'multiple', 'muted', 'selected' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that are "overloaded booleans": they behave like
      // booleans, but can also accept a string value.

      ['capture', 'download' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that must be positive numbers.

      ['cols', 'rows', 'size', 'span' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
        // mustUseProperty
        name,
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These are HTML attributes that must be numbers.

      ['rowSpan', 'start'].forEach(function (name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
        // mustUseProperty
        name.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      });
      var CAMELIZE = /[\-\:]([a-z])/g;
      var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
      }; // This is a list of all SVG attributes that need special casing, namespacing,
      // or boolean value assignment. Regular attributes that just accept strings
      // and have the same names are omitted, just like in the HTML whitelist.
      // Some of these attributes can be hard to find. This list was created by
      // scraping the MDN documentation.

      ['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, null,
        // attributeNamespace
        false);
      }); // String SVG attributes with the xlink namespace.

      ['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, 'http://www.w3.org/1999/xlink', false);
      }); // String SVG attributes with the xml namespace.

      ['xml:base', 'xml:lang', 'xml:space' // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
      ].forEach(function (attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false,
        // mustUseProperty
        attributeName, 'http://www.w3.org/XML/1998/namespace', false);
      }); // These attribute exists both in HTML and SVG.
      // The attribute name is case-sensitive in SVG so we can't just use
      // the React name like we do for attributes that exist only in HTML.

      ['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
        // mustUseProperty
        attributeName.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        false);
      }); // These attributes accept URLs. These must not allow javascript: URLS.
      // These will also need to accept Trusted Types object in the future.

      var xlinkHref = 'xlinkHref';
      properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
      // mustUseProperty
      'xlink:href', 'http://www.w3.org/1999/xlink', true);
      ['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
        // mustUseProperty
        attributeName.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        true);
      });
      var ReactDebugCurrentFrame = null;
      {
        ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      } // A javascript: URL can contain leading C0 control or \u0020 SPACE,
      // and any newline or tab are filtered out as if they're not part of the URL.
      // https://url.spec.whatwg.org/#url-parsing
      // Tab or newline are defined as \r\n\t:
      // https://infra.spec.whatwg.org/#ascii-tab-or-newline
      // A C0 control is a code point in the range \u0000 NULL to \u001F
      // INFORMATION SEPARATOR ONE, inclusive:
      // https://infra.spec.whatwg.org/#c0-control-or-space

      /* eslint-disable max-len */

      var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
      var didWarn = false;
      function sanitizeURL(url) {
        {
          if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error('A future version of React will block javascript: URLs as a security precaution. ' + 'Use event handlers instead if you can. If you need to generate unsafe HTML try ' + 'using dangerouslySetInnerHTML instead. React was passed %s.', JSON.stringify(url));
          }
        }
      }

      /**
       * Get the value for a property on a node. Only used in DEV for SSR validation.
       * The "expected" argument is used as a hint of what the expected value is.
       * Some properties have multiple equivalent values.
       */
      function getValueForProperty(node, name, expected, propertyInfo) {
        {
          if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
          } else {
            if (propertyInfo.sanitizeURL) {
              // If we haven't fully disabled javascript: URLs, and if
              // the hydration is successful of a javascript: URL, we
              // still want to warn on the client.
              sanitizeURL('' + expected);
            }
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
              if (node.hasAttribute(attributeName)) {
                var value = node.getAttribute(attributeName);
                if (value === '') {
                  return true;
                }
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                  return value;
                }
                if (value === '' + expected) {
                  return expected;
                }
                return value;
              }
            } else if (node.hasAttribute(attributeName)) {
              if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
                // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
              }
              if (propertyInfo.type === BOOLEAN) {
                // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
              } // Even if this property uses a namespace we use getAttribute
              // because we assume its namespaced name is the same as our config.
              // To use getAttributeNS we need the local name which we don't have
              // in our config atm.

              stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) {
              return stringValue === null ? expected : stringValue;
            } else if (stringValue === '' + expected) {
              return expected;
            } else {
              return stringValue;
            }
          }
        }
      }
      /**
       * Get the value for a attribute on a node. Only used in DEV for SSR validation.
       * The third argument is used as a hint of what the expected value is. Some
       * attributes have multiple equivalent values.
       */

      function getValueForAttribute(node, name, expected) {
        {
          if (!isAttributeNameSafe(name)) {
            return;
          }
          if (!node.hasAttribute(name)) {
            return expected === undefined ? undefined : null;
          }
          var value = node.getAttribute(name);
          if (value === '' + expected) {
            return expected;
          }
          return value;
        }
      }
      /**
       * Sets the value for a property on a node.
       *
       * @param {DOMElement} node
       * @param {string} name
       * @param {*} value
       */

      function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) {
          return;
        }
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) {
          value = null;
        } // If the prop isn't in the special list, treat it as a simple attribute.

        if (isCustomComponentTag || propertyInfo === null) {
          if (isAttributeNameSafe(name)) {
            var _attributeName = name;
            if (value === null) {
              node.removeAttribute(_attributeName);
            } else {
              node.setAttribute(_attributeName, '' + value);
            }
          }
          return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
          var propertyName = propertyInfo.propertyName;
          if (value === null) {
            var type = propertyInfo.type;
            node[propertyName] = type === BOOLEAN ? false : '';
          } else {
            // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
          }
          return;
        } // The rest are treated as attributes with special cases.

        var attributeName = propertyInfo.attributeName,
          attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) {
          node.removeAttribute(attributeName);
        } else {
          var _type = propertyInfo.type;
          var attributeValue;
          if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) {
            // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
          } else {
            // `setAttribute` with objects becomes only `[object]` in IE8/9,
            // ('' + value) makes it output the correct toString()-value.
            {
              attributeValue = '' + value;
            }
            if (propertyInfo.sanitizeURL) {
              sanitizeURL(attributeValue.toString());
            }
          }
          if (attributeNamespace) {
            node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
          } else {
            node.setAttribute(attributeName, attributeValue);
          }
        }
      }
      var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
      function describeComponentFrame(name, source, ownerName) {
        var sourceInfo = '';
        if (source) {
          var path = source.fileName;
          var fileName = path.replace(BEFORE_SLASH_RE, '');
          {
            // In DEV, include code for a common special case:
            // prefer "folder/index.js" instead of just "index.js".
            if (/^index\./.test(fileName)) {
              var match = path.match(BEFORE_SLASH_RE);
              if (match) {
                var pathBeforeSlash = match[1];
                if (pathBeforeSlash) {
                  var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
                  fileName = folderName + '/' + fileName;
                }
              }
            }
          }
          sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
        } else if (ownerName) {
          sourceInfo = ' (created by ' + ownerName + ')';
        }
        return '\n    in ' + (name || 'Unknown') + sourceInfo;
      }

      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }
        return null;
      }
      var Uninitialized = -1;
      var Pending = 0;
      var Resolved = 1;
      var Rejected = 2;
      function refineResolvedLazyComponent(lazyComponent) {
        return lazyComponent._status === Resolved ? lazyComponent._result : null;
      }
      function initializeLazyComponentType(lazyComponent) {
        if (lazyComponent._status === Uninitialized) {
          lazyComponent._status = Pending;
          var ctor = lazyComponent._ctor;
          var thenable = ctor();
          lazyComponent._result = thenable;
          thenable.then(function (moduleObject) {
            if (lazyComponent._status === Pending) {
              var defaultExport = moduleObject.default;
              {
                if (defaultExport === undefined) {
                  error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + "const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                }
              }
              lazyComponent._status = Resolved;
              lazyComponent._result = defaultExport;
            }
          }, function (error) {
            if (lazyComponent._status === Pending) {
              lazyComponent._status = Rejected;
              lazyComponent._result = error;
            }
          });
        }
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }
      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }
        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }
        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }
        if (typeof type === 'string') {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return 'Fragment';
          case REACT_PORTAL_TYPE:
            return 'Portal';
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';
          case REACT_SUSPENSE_TYPE:
            return 'Suspense';
          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }
        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              return 'Context.Consumer';
            case REACT_PROVIDER_TYPE:
              return 'Context.Provider';
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
              return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
              return getComponentName(type.render);
            case REACT_LAZY_TYPE:
              {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
          }
        }
        return null;
      }
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function describeFiber(fiber) {
        switch (fiber.tag) {
          case HostRoot:
          case HostPortal:
          case HostText:
          case Fragment:
          case ContextProvider:
          case ContextConsumer:
            return '';
          default:
            var owner = fiber._debugOwner;
            var source = fiber._debugSource;
            var name = getComponentName(fiber.type);
            var ownerName = null;
            if (owner) {
              ownerName = getComponentName(owner.type);
            }
            return describeComponentFrame(name, source, ownerName);
        }
      }
      function getStackByFiberInDevAndProd(workInProgress) {
        var info = '';
        var node = workInProgress;
        do {
          info += describeFiber(node);
          node = node.return;
        } while (node);
        return info;
      }
      var current = null;
      var isRendering = false;
      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }
          var owner = current._debugOwner;
          if (owner !== null && typeof owner !== 'undefined') {
            return getComponentName(owner.type);
          }
        }
        return null;
      }
      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return '';
          } // Safe because if current fiber exists, we are reconciling,
          // and it is guaranteed to be the work-in-progress version.

          return getStackByFiberInDevAndProd(current);
        }
      }
      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }
      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }
      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }

      // Flow does not allow string concatenation of most non-string types. To work
      // around this limitation, we use an opaque type that can only be obtained by
      // passing the value through getToStringValue first.
      function toString(value) {
        return '' + value;
      }
      function getToStringValue(value) {
        switch (typeof value) {
          case 'boolean':
          case 'number':
          case 'object':
          case 'string':
          case 'undefined':
            return value;
          default:
            // function, symbol are assigned as empty strings
            return '';
        }
      }
      var ReactDebugCurrentFrame$2 = null;
      var ReactControlledValuePropTypes = {
        checkPropTypes: null
      };
      {
        ReactDebugCurrentFrame$2 = ReactSharedInternals.ReactDebugCurrentFrame;
        var hasReadOnlyValue = {
          button: true,
          checkbox: true,
          image: true,
          hidden: true,
          radio: true,
          reset: true,
          submit: true
        };
        var propTypes = {
          value: function value(props, propName, componentName) {
            if (hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
              return null;
            }
            return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          },
          checked: function checked(props, propName, componentName) {
            if (props.onChange || props.readOnly || props.disabled || props[propName] == null || enableDeprecatedFlareAPI) {
              return null;
            }
            return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
          }
        };
        /**
         * Provide a linked `value` attribute for controlled forms. You should not use
         * this outside of the ReactDOM controlled form components.
         */

        ReactControlledValuePropTypes.checkPropTypes = function (tagName, props) {
          checkPropTypes(propTypes, props, 'prop', tagName, ReactDebugCurrentFrame$2.getStackAddendum);
        };
      }
      function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
      }
      function getTracker(node) {
        return node._valueTracker;
      }
      function detachTracker(node) {
        node._valueTracker = null;
      }
      function getValueFromNode(node) {
        var value = '';
        if (!node) {
          return value;
        }
        if (isCheckable(node)) {
          value = node.checked ? 'true' : 'false';
        } else {
          value = node.value;
        }
        return value;
      }
      function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)

        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
          return;
        }
        var _get = descriptor.get,
          _set = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function get() {
            return _get.call(this);
          },
          set: function set(value) {
            currentValue = '' + value;
            _set.call(this, value);
          }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768

        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        var tracker = {
          getValue: function getValue() {
            return currentValue;
          },
          setValue: function setValue(value) {
            currentValue = '' + value;
          },
          stopTracking: function stopTracking() {
            detachTracker(node);
            delete node[valueField];
          }
        };
        return tracker;
      }
      function track(node) {
        if (getTracker(node)) {
          return;
        } // TODO: Once it's just Fiber we can move this to node._wrapperState

        node._valueTracker = trackValueOnNode(node);
      }
      function updateValueIfChanged(node) {
        if (!node) {
          return false;
        }
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed

        if (!tracker) {
          return true;
        }
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
          tracker.setValue(nextValue);
          return true;
        }
        return false;
      }
      var didWarnValueDefaultValue = false;
      var didWarnCheckedDefaultChecked = false;
      var didWarnControlledToUncontrolled = false;
      var didWarnUncontrolledToControlled = false;
      function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
      }
      /**
       * Implements an <input> host component that allows setting these optional
       * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
       *
       * If `checked` or `value` are not supplied (or null/undefined), user actions
       * that affect the checked state or value will trigger updates to the element.
       *
       * If they are supplied (and not null/undefined), the rendered element will not
       * trigger updates to the element. Instead, the props must change in order for
       * the rendered element to be updated.
       *
       * The rendered element will be initialized as unchecked (or `defaultChecked`)
       * with an empty value (or `defaultValue`).
       *
       * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
       */

      function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
          defaultChecked: undefined,
          defaultValue: undefined,
          value: undefined,
          checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
      }
      function initWrapperState(element, props) {
        {
          ReactControlledValuePropTypes.checkPropTypes('input', props);
          if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error('%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
          }
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error('%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
          }
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
          initialChecked: props.checked != null ? props.checked : props.defaultChecked,
          initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
          controlled: isControlled(props)
        };
      }
      function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) {
          setValueForProperty(node, 'checked', checked, false);
        }
      }
      function updateWrapper(element, props) {
        var node = element;
        {
          var controlled = isControlled(props);
          if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error('A component is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', props.type);
            didWarnUncontrolledToControlled = true;
          }
          if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error('A component is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', props.type);
            didWarnControlledToUncontrolled = true;
          }
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
          if (type === 'number') {
            if (value === 0 && node.value === '' ||
            // We explicitly want to coerce to number here if possible.
            // eslint-disable-next-line
            node.value != value) {
              node.value = toString(value);
            }
          } else if (node.value !== toString(value)) {
            node.value = toString(value);
          }
        } else if (type === 'submit' || type === 'reset') {
          // Submit/reset inputs need the attribute removed completely to avoid
          // blank-text buttons.
          node.removeAttribute('value');
          return;
        }
        {
          // When syncing the value attribute, the value comes from a cascade of
          // properties:
          //  1. The value React property
          //  2. The defaultValue React property
          //  3. Otherwise there should be no change
          if (props.hasOwnProperty('value')) {
            setDefaultValue(node, props.type, value);
          } else if (props.hasOwnProperty('defaultValue')) {
            setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
          }
        }
        {
          // When syncing the checked attribute, it only changes when it needs
          // to be removed, such as transitioning from a checkbox into a text input
          if (props.checked == null && props.defaultChecked != null) {
            node.defaultChecked = !!props.defaultChecked;
          }
        }
      }
      function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.

        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
          var type = props.type;
          var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
          // default value provided by the browser. See: #12872

          if (isButton && (props.value === undefined || props.value === null)) {
            return;
          }
          var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
          // from being lost during SSR hydration.

          if (!isHydrating) {
            {
              // When syncing the value attribute, the value property should use
              // the wrapperState._initialValue property. This uses:
              //
              //   1. The value React property when present
              //   2. The defaultValue React property when present
              //   3. An empty string
              if (initialValue !== node.value) {
                node.value = initialValue;
              }
            }
          }
          {
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
          }
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.

        var name = node.name;
        if (name !== '') {
          node.name = '';
        }
        {
          // When syncing the checked attribute, both the checked property and
          // attribute are assigned at the same time using defaultChecked. This uses:
          //
          //   1. The checked React property when present
          //   2. The defaultChecked React property when present
          //   3. Otherwise, false
          node.defaultChecked = !node.defaultChecked;
          node.defaultChecked = !!node._wrapperState.initialChecked;
        }
        if (name !== '') {
          node.name = name;
        }
      }
      function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
      }
      function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
          var queryRoot = rootNode;
          while (queryRoot.parentNode) {
            queryRoot = queryRoot.parentNode;
          } // If `rootNode.form` was non-null, then we could try `form.elements`,
          // but that sometimes behaves strangely in IE8. We could also try using
          // `form.getElementsByName`, but that will only return direct children
          // and won't include inputs that use the HTML5 `form=` attribute. Since
          // the input might not even be in a form. It might not even be in the
          // document. Let's just use the local `querySelectorAll` to ensure we don't
          // miss anything.

          var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
          for (var i = 0; i < group.length; i++) {
            var otherNode = group[i];
            if (otherNode === rootNode || otherNode.form !== rootNode.form) {
              continue;
            } // This will throw if radio buttons rendered by different copies of React
            // and the same name are rendered into the same form (same as #1939).
            // That's probably okay; we don't support it just as we don't support
            // mixing React radio buttons with non-React ones.

            var otherProps = getFiberCurrentPropsFromNode$1(otherNode);
            if (!otherProps) {
              {
                throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
              }
            } // We need update the tracked value on the named cousin since the value
            // was changed but the input saw no event or value set

            updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
            // was previously checked to update will cause it to be come re-checked
            // as appropriate.

            updateWrapper(otherNode, otherProps);
          }
        }
      } // In Chrome, assigning defaultValue to certain input types triggers input validation.
      // For number inputs, the display value loses trailing decimal points. For email inputs,
      // Chrome raises "The specified value <x> is not a valid email address".
      //
      // Here we check to see if the defaultValue has actually changed, avoiding these problems
      // when the user is inputting text
      //
      // https://github.com/facebook/react/issues/7253

      function setDefaultValue(node, type, value) {
        if (
        // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
        type !== 'number' || node.ownerDocument.activeElement !== node) {
          if (value == null) {
            node.defaultValue = toString(node._wrapperState.initialValue);
          } else if (node.defaultValue !== toString(value)) {
            node.defaultValue = toString(value);
          }
        }
      }
      var didWarnSelectedSetOnOption = false;
      var didWarnInvalidChild = false;
      function flattenChildren(children) {
        var content = ''; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).

        React.Children.forEach(children, function (child) {
          if (child == null) {
            return;
          }
          content += child; // Note: we don't warn about invalid children here.
          // Instead, this is done separately below so that
          // it happens during the hydration codepath too.
        });

        return content;
      }
      /**
       * Implements an <option> host component that warns when `selected` is set.
       */

      function validateProps(element, props) {
        {
          // This mirrors the codepath above, but runs for hydration too.
          // Warn about invalid children here so that client and hydration are consistent.
          // TODO: this seems like it could cause a DEV-only throw for hydration
          // if children contains a non-element object. We should try to avoid that.
          if (typeof props.children === 'object' && props.children !== null) {
            React.Children.forEach(props.children, function (child) {
              if (child == null) {
                return;
              }
              if (typeof child === 'string' || typeof child === 'number') {
                return;
              }
              if (typeof child.type !== 'string') {
                return;
              }
              if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error('Only strings and numbers are supported as <option> children.');
              }
            });
          } // TODO: Remove support for `selected` in <option>.

          if (props.selected != null && !didWarnSelectedSetOnOption) {
            error('Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.');
            didWarnSelectedSetOnOption = true;
          }
        }
      }
      function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) {
          element.setAttribute('value', toString(getToStringValue(props.value)));
        }
      }
      function getHostProps$1(element, props) {
        var hostProps = _assign({
          children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) {
          hostProps.children = content;
        }
        return hostProps;
      }
      var didWarnValueDefaultValue$1;
      {
        didWarnValueDefaultValue$1 = false;
      }
      function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) {
          return '\n\nCheck the render method of `' + ownerName + '`.';
        }
        return '';
      }
      var valuePropNames = ['value', 'defaultValue'];
      /**
       * Validation function for `value` and `defaultValue`.
       */

      function checkSelectPropTypes(props) {
        {
          ReactControlledValuePropTypes.checkPropTypes('select', props);
          for (var i = 0; i < valuePropNames.length; i++) {
            var propName = valuePropNames[i];
            if (props[propName] == null) {
              continue;
            }
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) {
              error('The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum());
            } else if (!props.multiple && isArray) {
              error('The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum());
            }
          }
        }
      }
      function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
          var selectedValues = propValue;
          var selectedValue = {};
          for (var i = 0; i < selectedValues.length; i++) {
            // Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
          }
          for (var _i = 0; _i < options.length; _i++) {
            var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
            if (options[_i].selected !== selected) {
              options[_i].selected = selected;
            }
            if (selected && setDefaultSelected) {
              options[_i].defaultSelected = true;
            }
          }
        } else {
          // Do not set `select.value` as exact behavior isn't consistent across all
          // browsers for all cases.
          var _selectedValue = toString(getToStringValue(propValue));
          var defaultSelected = null;
          for (var _i2 = 0; _i2 < options.length; _i2++) {
            if (options[_i2].value === _selectedValue) {
              options[_i2].selected = true;
              if (setDefaultSelected) {
                options[_i2].defaultSelected = true;
              }
              return;
            }
            if (defaultSelected === null && !options[_i2].disabled) {
              defaultSelected = options[_i2];
            }
          }
          if (defaultSelected !== null) {
            defaultSelected.selected = true;
          }
        }
      }
      /**
       * Implements a <select> host component that allows optionally setting the
       * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
       * stringable. If `multiple` is true, the prop must be an array of stringables.
       *
       * If `value` is not supplied (or null/undefined), user actions that change the
       * selected option will trigger updates to the rendered options.
       *
       * If it is supplied (and not null/undefined), the rendered options will not
       * update in response to user actions. Instead, the `value` prop must change in
       * order for the rendered options to update.
       *
       * If `defaultValue` is provided, any options with the supplied values will be
       * selected.
       */

      function getHostProps$2(element, props) {
        return _assign({}, props, {
          value: undefined
        });
      }
      function initWrapperState$1(element, props) {
        var node = element;
        {
          checkSelectPropTypes(props);
        }
        node._wrapperState = {
          wasMultiple: !!props.multiple
        };
        {
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error('Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components');
            didWarnValueDefaultValue$1 = true;
          }
        }
      }
      function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (props.defaultValue != null) {
          updateOptions(node, !!props.multiple, props.defaultValue, true);
        }
      }
      function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        } else if (wasMultiple !== !!props.multiple) {
          // For simplicity, reapply `defaultValue` if `multiple` is toggled.
          if (props.defaultValue != null) {
            updateOptions(node, !!props.multiple, props.defaultValue, true);
          } else {
            // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
          }
        }
      }
      function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) {
          updateOptions(node, !!props.multiple, value, false);
        }
      }
      var didWarnValDefaultVal = false;

      /**
       * Implements a <textarea> host component that allows setting `value`, and
       * `defaultValue`. This differs from the traditional DOM API because value is
       * usually set as PCDATA children.
       *
       * If `value` is not supplied (or null/undefined), user actions that affect the
       * value will trigger updates to the element.
       *
       * If `value` is supplied (and not null/undefined), the rendered element will
       * not trigger updates to the element. Instead, the `value` prop must change in
       * order for the rendered element to be updated.
       *
       * The rendered element will be initialized with an empty value, the prop
       * `defaultValue` if specified, or the children content (deprecated).
       */
      function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) {
          {
            throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
          }
        } // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.

        var hostProps = _assign({}, props, {
          value: undefined,
          defaultValue: undefined,
          children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
      }
      function initWrapperState$2(element, props) {
        var node = element;
        {
          ReactControlledValuePropTypes.checkPropTypes('textarea', props);
          if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error('%s contains a textarea with both value and defaultValue props. ' + 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
          }
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it

        if (initialValue == null) {
          var children = props.children,
            defaultValue = props.defaultValue;
          if (children != null) {
            {
              error('Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.');
            }
            {
              if (!(defaultValue == null)) {
                {
                  throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                }
              }
              if (Array.isArray(children)) {
                if (!(children.length <= 1)) {
                  {
                    throw Error("<textarea> can only have at most one child.");
                  }
                }
                children = children[0];
              }
              defaultValue = children;
            }
          }
          if (defaultValue == null) {
            defaultValue = '';
          }
          initialValue = defaultValue;
        }
        node._wrapperState = {
          initialValue: getToStringValue(initialValue)
        };
      }
      function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed

          if (newValue !== node.value) {
            node.value = newValue;
          }
          if (props.defaultValue == null && node.defaultValue !== newValue) {
            node.defaultValue = newValue;
          }
        }
        if (defaultValue != null) {
          node.defaultValue = toString(defaultValue);
        }
      }
      function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.

        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/

        if (textContent === node._wrapperState.initialValue) {
          if (textContent !== '' && textContent !== null) {
            node.value = textContent;
          }
        }
      }
      function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
      }
      var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
      var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
      var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
      var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
      }; // Assumes there is no parent namespace.

      function getIntrinsicNamespace(type) {
        switch (type) {
          case 'svg':
            return SVG_NAMESPACE;
          case 'math':
            return MATH_NAMESPACE;
          default:
            return HTML_NAMESPACE;
        }
      }
      function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) {
          // No (or default) parent namespace: potential entry point.
          return getIntrinsicNamespace(type);
        }
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') {
          // We're leaving SVG.
          return HTML_NAMESPACE;
        } // By default, pass namespace below.

        return parentNamespace;
      }

      /* globals MSApp */

      /**
       * Create a function which has 'unsafe' privileges (required by windows8 apps)
       */
      var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
          return function (arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function () {
              return func(arg0, arg1, arg2, arg3);
            });
          };
        } else {
          return func;
        }
      };
      var reusableSVGContainer;
      /**
       * Set the innerHTML property of a node
       *
       * @param {DOMElement} node
       * @param {string} html
       * @internal
       */

      var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
        if (node.namespaceURI === Namespaces.svg) {
          if (!('innerHTML' in node)) {
            // IE does not have innerHTML for SVG nodes, so instead we inject the
            // new markup in a temp node and then move the child nodes across into
            // the target node
            reusableSVGContainer = reusableSVGContainer || document.createElement('div');
            reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
            var svgNode = reusableSVGContainer.firstChild;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            while (svgNode.firstChild) {
              node.appendChild(svgNode.firstChild);
            }
            return;
          }
        }
        node.innerHTML = html;
      });

      /**
       * HTML nodeType values that represent the type of the node
       */
      var ELEMENT_NODE = 1;
      var TEXT_NODE = 3;
      var COMMENT_NODE = 8;
      var DOCUMENT_NODE = 9;
      var DOCUMENT_FRAGMENT_NODE = 11;

      /**
       * Set the textContent property of a node. For text updates, it's faster
       * to set the `nodeValue` of the Text node directly instead of using
       * `.textContent` which will remove the existing node and create a new one.
       *
       * @param {DOMElement} node
       * @param {string} text
       * @internal
       */

      var setTextContent = function setTextContent(node, text) {
        if (text) {
          var firstChild = node.firstChild;
          if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
            firstChild.nodeValue = text;
            return;
          }
        }
        node.textContent = text;
      };

      // Do not use the below two methods directly!
      // Instead use constants exported from DOMTopLevelEventTypes in ReactDOM.
      // (It is the only module that is allowed to access these methods.)
      function unsafeCastStringToDOMTopLevelType(topLevelType) {
        return topLevelType;
      }
      function unsafeCastDOMTopLevelTypeToString(topLevelType) {
        return topLevelType;
      }

      /**
       * Generate a mapping of standard vendor prefixes using the defined style property and event name.
       *
       * @param {string} styleProp
       * @param {string} eventName
       * @returns {object}
       */

      function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
      }
      /**
       * A list of event names to a configurable list of vendor prefixes.
       */

      var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
      };
      /**
       * Event names that have already been detected and prefixed (if applicable).
       */

      var prefixedEventNames = {};
      /**
       * Element to check for prefixes on.
       */

      var style = {};
      /**
       * Bootstrap if a DOM exists.
       */

      if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.

        if (!('AnimationEvent' in window)) {
          delete vendorPrefixes.animationend.animation;
          delete vendorPrefixes.animationiteration.animation;
          delete vendorPrefixes.animationstart.animation;
        } // Same as above

        if (!('TransitionEvent' in window)) {
          delete vendorPrefixes.transitionend.transition;
        }
      }
      /**
       * Attempts to determine the correct vendor prefixed event name.
       *
       * @param {string} eventName
       * @returns {string}
       */

      function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) {
          return prefixedEventNames[eventName];
        } else if (!vendorPrefixes[eventName]) {
          return eventName;
        }
        var prefixMap = vendorPrefixes[eventName];
        for (var styleProp in prefixMap) {
          if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
            return prefixedEventNames[eventName] = prefixMap[styleProp];
          }
        }
        return eventName;
      }

      /**
       * To identify top level events in ReactDOM, we use constants defined by this
       * module. This is the only module that uses the unsafe* methods to express
       * that the constants actually correspond to the browser event names. This lets
       * us save some bundle size by avoiding a top level type -> event name map.
       * The rest of ReactDOM code should import top level types from this file.
       */

      var TOP_ABORT = unsafeCastStringToDOMTopLevelType('abort');
      var TOP_ANIMATION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationend'));
      var TOP_ANIMATION_ITERATION = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationiteration'));
      var TOP_ANIMATION_START = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('animationstart'));
      var TOP_BLUR = unsafeCastStringToDOMTopLevelType('blur');
      var TOP_CAN_PLAY = unsafeCastStringToDOMTopLevelType('canplay');
      var TOP_CAN_PLAY_THROUGH = unsafeCastStringToDOMTopLevelType('canplaythrough');
      var TOP_CANCEL = unsafeCastStringToDOMTopLevelType('cancel');
      var TOP_CHANGE = unsafeCastStringToDOMTopLevelType('change');
      var TOP_CLICK = unsafeCastStringToDOMTopLevelType('click');
      var TOP_CLOSE = unsafeCastStringToDOMTopLevelType('close');
      var TOP_COMPOSITION_END = unsafeCastStringToDOMTopLevelType('compositionend');
      var TOP_COMPOSITION_START = unsafeCastStringToDOMTopLevelType('compositionstart');
      var TOP_COMPOSITION_UPDATE = unsafeCastStringToDOMTopLevelType('compositionupdate');
      var TOP_CONTEXT_MENU = unsafeCastStringToDOMTopLevelType('contextmenu');
      var TOP_COPY = unsafeCastStringToDOMTopLevelType('copy');
      var TOP_CUT = unsafeCastStringToDOMTopLevelType('cut');
      var TOP_DOUBLE_CLICK = unsafeCastStringToDOMTopLevelType('dblclick');
      var TOP_AUX_CLICK = unsafeCastStringToDOMTopLevelType('auxclick');
      var TOP_DRAG = unsafeCastStringToDOMTopLevelType('drag');
      var TOP_DRAG_END = unsafeCastStringToDOMTopLevelType('dragend');
      var TOP_DRAG_ENTER = unsafeCastStringToDOMTopLevelType('dragenter');
      var TOP_DRAG_EXIT = unsafeCastStringToDOMTopLevelType('dragexit');
      var TOP_DRAG_LEAVE = unsafeCastStringToDOMTopLevelType('dragleave');
      var TOP_DRAG_OVER = unsafeCastStringToDOMTopLevelType('dragover');
      var TOP_DRAG_START = unsafeCastStringToDOMTopLevelType('dragstart');
      var TOP_DROP = unsafeCastStringToDOMTopLevelType('drop');
      var TOP_DURATION_CHANGE = unsafeCastStringToDOMTopLevelType('durationchange');
      var TOP_EMPTIED = unsafeCastStringToDOMTopLevelType('emptied');
      var TOP_ENCRYPTED = unsafeCastStringToDOMTopLevelType('encrypted');
      var TOP_ENDED = unsafeCastStringToDOMTopLevelType('ended');
      var TOP_ERROR = unsafeCastStringToDOMTopLevelType('error');
      var TOP_FOCUS = unsafeCastStringToDOMTopLevelType('focus');
      var TOP_GOT_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('gotpointercapture');
      var TOP_INPUT = unsafeCastStringToDOMTopLevelType('input');
      var TOP_INVALID = unsafeCastStringToDOMTopLevelType('invalid');
      var TOP_KEY_DOWN = unsafeCastStringToDOMTopLevelType('keydown');
      var TOP_KEY_PRESS = unsafeCastStringToDOMTopLevelType('keypress');
      var TOP_KEY_UP = unsafeCastStringToDOMTopLevelType('keyup');
      var TOP_LOAD = unsafeCastStringToDOMTopLevelType('load');
      var TOP_LOAD_START = unsafeCastStringToDOMTopLevelType('loadstart');
      var TOP_LOADED_DATA = unsafeCastStringToDOMTopLevelType('loadeddata');
      var TOP_LOADED_METADATA = unsafeCastStringToDOMTopLevelType('loadedmetadata');
      var TOP_LOST_POINTER_CAPTURE = unsafeCastStringToDOMTopLevelType('lostpointercapture');
      var TOP_MOUSE_DOWN = unsafeCastStringToDOMTopLevelType('mousedown');
      var TOP_MOUSE_MOVE = unsafeCastStringToDOMTopLevelType('mousemove');
      var TOP_MOUSE_OUT = unsafeCastStringToDOMTopLevelType('mouseout');
      var TOP_MOUSE_OVER = unsafeCastStringToDOMTopLevelType('mouseover');
      var TOP_MOUSE_UP = unsafeCastStringToDOMTopLevelType('mouseup');
      var TOP_PASTE = unsafeCastStringToDOMTopLevelType('paste');
      var TOP_PAUSE = unsafeCastStringToDOMTopLevelType('pause');
      var TOP_PLAY = unsafeCastStringToDOMTopLevelType('play');
      var TOP_PLAYING = unsafeCastStringToDOMTopLevelType('playing');
      var TOP_POINTER_CANCEL = unsafeCastStringToDOMTopLevelType('pointercancel');
      var TOP_POINTER_DOWN = unsafeCastStringToDOMTopLevelType('pointerdown');
      var TOP_POINTER_MOVE = unsafeCastStringToDOMTopLevelType('pointermove');
      var TOP_POINTER_OUT = unsafeCastStringToDOMTopLevelType('pointerout');
      var TOP_POINTER_OVER = unsafeCastStringToDOMTopLevelType('pointerover');
      var TOP_POINTER_UP = unsafeCastStringToDOMTopLevelType('pointerup');
      var TOP_PROGRESS = unsafeCastStringToDOMTopLevelType('progress');
      var TOP_RATE_CHANGE = unsafeCastStringToDOMTopLevelType('ratechange');
      var TOP_RESET = unsafeCastStringToDOMTopLevelType('reset');
      var TOP_SCROLL = unsafeCastStringToDOMTopLevelType('scroll');
      var TOP_SEEKED = unsafeCastStringToDOMTopLevelType('seeked');
      var TOP_SEEKING = unsafeCastStringToDOMTopLevelType('seeking');
      var TOP_SELECTION_CHANGE = unsafeCastStringToDOMTopLevelType('selectionchange');
      var TOP_STALLED = unsafeCastStringToDOMTopLevelType('stalled');
      var TOP_SUBMIT = unsafeCastStringToDOMTopLevelType('submit');
      var TOP_SUSPEND = unsafeCastStringToDOMTopLevelType('suspend');
      var TOP_TEXT_INPUT = unsafeCastStringToDOMTopLevelType('textInput');
      var TOP_TIME_UPDATE = unsafeCastStringToDOMTopLevelType('timeupdate');
      var TOP_TOGGLE = unsafeCastStringToDOMTopLevelType('toggle');
      var TOP_TOUCH_CANCEL = unsafeCastStringToDOMTopLevelType('touchcancel');
      var TOP_TOUCH_END = unsafeCastStringToDOMTopLevelType('touchend');
      var TOP_TOUCH_MOVE = unsafeCastStringToDOMTopLevelType('touchmove');
      var TOP_TOUCH_START = unsafeCastStringToDOMTopLevelType('touchstart');
      var TOP_TRANSITION_END = unsafeCastStringToDOMTopLevelType(getVendorPrefixedEventName('transitionend'));
      var TOP_VOLUME_CHANGE = unsafeCastStringToDOMTopLevelType('volumechange');
      var TOP_WAITING = unsafeCastStringToDOMTopLevelType('waiting');
      var TOP_WHEEL = unsafeCastStringToDOMTopLevelType('wheel'); // List of events that need to be individually attached to media elements.
      // Note that events in this list will *not* be listened to at the top level
      // unless they're explicitly whitelisted in `ReactBrowserEventEmitter.listenTo`.

      var mediaEventTypes = [TOP_ABORT, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_VOLUME_CHANGE, TOP_WAITING];
      function getRawEventName(topLevelType) {
        return unsafeCastDOMTopLevelTypeToString(topLevelType);
      }
      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map; // prettier-ignore

      var elementListenerMap = new PossiblyWeakMap();
      function getListenerMapForElement(element) {
        var listenerMap = elementListenerMap.get(element);
        if (listenerMap === undefined) {
          listenerMap = new Map();
          elementListenerMap.set(element, listenerMap);
        }
        return listenerMap;
      }

      /**
       * `ReactInstanceMap` maintains a mapping from a public facing stateful
       * instance (key) and the internal representation (value). This allows public
       * methods to accept the user facing instance as an argument and map them back
       * to internal methods.
       *
       * Note that this module is currently shared and assumed to be stateless.
       * If this becomes an actual Map, that will break.
       */
      function get(key) {
        return key._reactInternalFiber;
      }
      function has(key) {
        return key._reactInternalFiber !== undefined;
      }
      function set(key, value) {
        key._reactInternalFiber = value;
      }

      // Don't change these two values. They're used by React Dev Tools.
      var NoEffect = /*              */
      0;
      var PerformedWork = /*         */
      1; // You can change the rest (and add more).

      var Placement = /*             */
      2;
      var Update = /*                */
      4;
      var PlacementAndUpdate = /*    */
      6;
      var Deletion = /*              */
      8;
      var ContentReset = /*          */
      16;
      var Callback = /*              */
      32;
      var DidCapture = /*            */
      64;
      var Ref = /*                   */
      128;
      var Snapshot = /*              */
      256;
      var Passive = /*               */
      512;
      var Hydrating = /*             */
      1024;
      var HydratingAndUpdate = /*    */
      1028; // Passive & Update & Callback & Ref & Snapshot

      var LifecycleEffectMask = /*   */
      932; // Union of all host effects

      var HostEffectMask = /*        */
      2047;
      var Incomplete = /*            */
      2048;
      var ShouldCapture = /*         */
      4096;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
          // If there is no alternate, this might be a new tree that isn't inserted
          // yet. If it is, then it will have a pending insertion effect on it.
          var nextNode = node;
          do {
            node = nextNode;
            if ((node.effectTag & (Placement | Hydrating)) !== NoEffect) {
              // This is an insertion or in-progress hydration. The nearest possible
              // mounted fiber is the parent but we need to continue to figure out
              // if that one is still mounted.
              nearestMounted = node.return;
            }
            nextNode = node.return;
          } while (nextNode);
        } else {
          while (node.return) {
            node = node.return;
          }
        }
        if (node.tag === HostRoot) {
          // TODO: Check if this was a nested HostRoot when used with
          // renderContainerIntoSubtree.
          return nearestMounted;
        } // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.

        return null;
      }
      function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
          var suspenseState = fiber.memoizedState;
          if (suspenseState === null) {
            var current = fiber.alternate;
            if (current !== null) {
              suspenseState = current.memoizedState;
            }
          }
          if (suspenseState !== null) {
            return suspenseState.dehydrated;
          }
        }
        return null;
      }
      function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
      }
      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }
      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;
          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) {
              error('%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(ownerFiber.type) || 'A component');
            }
            instance._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get(component);
        if (!fiber) {
          return false;
        }
        return getNearestMountedFiber(fiber) === fiber;
      }
      function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
      }
      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
          // If there is no alternate, then we only need to check if it is mounted.
          var nearestMounted = getNearestMountedFiber(fiber);
          if (!(nearestMounted !== null)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (nearestMounted !== fiber) {
            return null;
          }
          return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.

        var a = fiber;
        var b = alternate;
        while (true) {
          var parentA = a.return;
          if (parentA === null) {
            // We're at the root.
            break;
          }
          var parentB = parentA.alternate;
          if (parentB === null) {
            // There is no alternate. This is an unusual case. Currently, it only
            // happens when a Suspense component is hidden. An extra fragment fiber
            // is inserted in between the Suspense fiber and its children. Skip
            // over this extra fragment fiber and proceed to the next parent.
            var nextParent = parentA.return;
            if (nextParent !== null) {
              a = b = nextParent;
              continue;
            } // If there's no parent, we're at the root.

            break;
          } // If both copies of the parent fiber point to the same child, we can
          // assume that the child is current. This happens when we bailout on low
          // priority: the bailed out fiber's child reuses the current child.

          if (parentA.child === parentB.child) {
            var child = parentA.child;
            while (child) {
              if (child === a) {
                // We've determined that A is the current branch.
                assertIsMounted(parentA);
                return fiber;
              }
              if (child === b) {
                // We've determined that B is the current branch.
                assertIsMounted(parentA);
                return alternate;
              }
              child = child.sibling;
            } // We should never have an alternate for any mounting node. So the only
            // way this could possibly happen is if this was unmounted, if at all.

            {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
          }
          if (a.return !== b.return) {
            // The return pointer of A and the return pointer of B point to different
            // fibers. We assume that return pointers never criss-cross, so A must
            // belong to the child set of A.return, and B must belong to the child
            // set of B.return.
            a = parentA;
            b = parentB;
          } else {
            // The return pointers point to the same fiber. We'll have to use the
            // default, slow path: scan the child sets of each parent alternate to see
            // which child belongs to which set.
            //
            // Search parent A's child set
            var didFindChild = false;
            var _child = parentA.child;
            while (_child) {
              if (_child === a) {
                didFindChild = true;
                a = parentA;
                b = parentB;
                break;
              }
              if (_child === b) {
                didFindChild = true;
                b = parentA;
                a = parentB;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild) {
              // Search parent B's child set
              _child = parentB.child;
              while (_child) {
                if (_child === a) {
                  didFindChild = true;
                  a = parentB;
                  b = parentA;
                  break;
                }
                if (_child === b) {
                  didFindChild = true;
                  b = parentB;
                  a = parentA;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                {
                  throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
              }
            }
          }
          if (!(a.alternate === b)) {
            {
              throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.

        if (!(a.tag === HostRoot)) {
          {
            throw Error("Unable to find node on an unmounted component.");
          }
        }
        if (a.stateNode.current === a) {
          // We've determined that A is the current branch.
          return fiber;
        } // Otherwise B has to be current branch.

        return alternate;
      }
      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.

        var node = currentParent;
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText) {
            return node;
          } else if (node.child) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return null;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable

        return null;
      }
      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) {
          return null;
        } // Next we'll drill down this component to find the first HostComponent/Text.

        var node = currentParent;
        while (true) {
          if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) {
            return node;
          } else if (node.child && node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === currentParent) {
            return null;
          }
          while (!node.sibling) {
            if (!node.return || node.return === currentParent) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable

        return null;
      }

      /**
       * Accumulates items that must not be null or undefined into the first one. This
       * is used to conserve memory by avoiding array allocations, and thus sacrifices
       * API cleanness. Since `current` can be null before being passed in and not
       * null after this function, make sure to assign it back to `current`:
       *
       * `a = accumulateInto(a, b);`
       *
       * This API should be sparingly used. Try `accumulate` for something cleaner.
       *
       * @return {*|array<*>} An accumulation of items.
       */

      function accumulateInto(current, next) {
        if (!(next != null)) {
          {
            throw Error("accumulateInto(...): Accumulated items must not be null or undefined.");
          }
        }
        if (current == null) {
          return next;
        } // Both are not empty. Warning: Never call x.concat(y) when you are not
        // certain that x is an Array (x could be a string with concat method).

        if (Array.isArray(current)) {
          if (Array.isArray(next)) {
            current.push.apply(current, next);
            return current;
          }
          current.push(next);
          return current;
        }
        if (Array.isArray(next)) {
          // A bit too dangerous to mutate `next`.
          return [current].concat(next);
        }
        return [current, next];
      }

      /**
       * @param {array} arr an "accumulation" of items which is either an Array or
       * a single item. Useful when paired with the `accumulate` module. This is a
       * simple utility that allows us to reason about a collection of items, but
       * handling the case when there is exactly one item (and we do not need to
       * allocate an array).
       * @param {function} cb Callback invoked with each element or a collection.
       * @param {?} [scope] Scope used as `this` in a callback.
       */
      function forEachAccumulated(arr, cb, scope) {
        if (Array.isArray(arr)) {
          arr.forEach(cb, scope);
        } else if (arr) {
          cb.call(scope, arr);
        }
      }

      /**
       * Internal queue of events that have accumulated their dispatches and are
       * waiting to have their dispatches executed.
       */

      var eventQueue = null;
      /**
       * Dispatches an event and releases it back into the pool, unless persistent.
       *
       * @param {?object} event Synthetic event to be dispatched.
       * @private
       */

      var executeDispatchesAndRelease = function executeDispatchesAndRelease(event) {
        if (event) {
          executeDispatchesInOrder(event);
          if (!event.isPersistent()) {
            event.constructor.release(event);
          }
        }
      };
      var executeDispatchesAndReleaseTopLevel = function executeDispatchesAndReleaseTopLevel(e) {
        return executeDispatchesAndRelease(e);
      };
      function runEventsInBatch(events) {
        if (events !== null) {
          eventQueue = accumulateInto(eventQueue, events);
        } // Set `eventQueue` to null before processing it so that we can tell if more
        // events get enqueued while processing.

        var processingEventQueue = eventQueue;
        eventQueue = null;
        if (!processingEventQueue) {
          return;
        }
        forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
        if (!!eventQueue) {
          {
            throw Error("processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.");
          }
        } // This would be a good time to rethrow if any of the event handlers threw.

        rethrowCaughtError();
      }

      /**
       * Gets the target node from a native browser event by accounting for
       * inconsistencies in browser DOM APIs.
       *
       * @param {object} nativeEvent Native browser event.
       * @return {DOMEventTarget} Target node.
       */

      function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963

        if (target.correspondingUseElement) {
          target = target.correspondingUseElement;
        } // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html

        return target.nodeType === TEXT_NODE ? target.parentNode : target;
      }

      /**
       * Checks if an event is supported in the current execution environment.
       *
       * NOTE: This will not work correctly for non-generic events such as `change`,
       * `reset`, `load`, `error`, and `select`.
       *
       * Borrows from Modernizr.
       *
       * @param {string} eventNameSuffix Event name, e.g. "click".
       * @return {boolean} True if the event is supported.
       * @internal
       * @license Modernizr 3.0.0pre (Custom Build) | MIT
       */

      function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) {
          return false;
        }
        var eventName = 'on' + eventNameSuffix;
        var isSupported = (eventName in document);
        if (!isSupported) {
          var element = document.createElement('div');
          element.setAttribute(eventName, 'return;');
          isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
      }

      /**
       * Summary of `DOMEventPluginSystem` event handling:
       *
       *  - Top-level delegation is used to trap most native browser events. This
       *    may only occur in the main thread and is the responsibility of
       *    ReactDOMEventListener, which is injected and can therefore support
       *    pluggable event sources. This is the only work that occurs in the main
       *    thread.
       *
       *  - We normalize and de-duplicate events to account for browser quirks. This
       *    may be done in the worker thread.
       *
       *  - Forward these native events (with the associated top-level type used to
       *    trap it) to `EventPluginRegistry`, which in turn will ask plugins if they want
       *    to extract any synthetic events.
       *
       *  - The `EventPluginRegistry` will then process each event by annotating them with
       *    "dispatches", a sequence of listeners and IDs that care about that event.
       *
       *  - The `EventPluginRegistry` then dispatches the events.
       *
       * Overview of React and the event system:
       *
       * +------------+    .
       * |    DOM     |    .
       * +------------+    .
       *       |           .
       *       v           .
       * +------------+    .
       * | ReactEvent |    .
       * |  Listener  |    .
       * +------------+    .                         +-----------+
       *       |           .               +--------+|SimpleEvent|
       *       |           .               |         |Plugin     |
       * +-----|------+    .               v         +-----------+
       * |     |      |    .    +--------------+                    +------------+
       * |     +-----------.--->|PluginRegistry|                    |    Event   |
       * |            |    .    |              |     +-----------+  | Propagators|
       * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
       * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
       * |            |    .    |              |     +-----------+  |  utilities |
       * |     +-----------.--->|              |                    +------------+
       * |     |      |    .    +--------------+
       * +-----|------+    .                ^        +-----------+
       *       |           .                |        |Enter/Leave|
       *       +           .                +-------+|Plugin     |
       * +-------------+   .                         +-----------+
       * | application |   .
       * |-------------|   .
       * |             |   .
       * |             |   .
       * +-------------+   .
       *                   .
       *    React Core     .  General Purpose Event Plugin System
       */

      var CALLBACK_BOOKKEEPING_POOL_SIZE = 10;
      var callbackBookkeepingPool = [];
      function releaseTopLevelCallbackBookKeeping(instance) {
        instance.topLevelType = null;
        instance.nativeEvent = null;
        instance.targetInst = null;
        instance.ancestors.length = 0;
        if (callbackBookkeepingPool.length < CALLBACK_BOOKKEEPING_POOL_SIZE) {
          callbackBookkeepingPool.push(instance);
        }
      } // Used to store ancestor hierarchy in top level callback

      function getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags) {
        if (callbackBookkeepingPool.length) {
          var instance = callbackBookkeepingPool.pop();
          instance.topLevelType = topLevelType;
          instance.eventSystemFlags = eventSystemFlags;
          instance.nativeEvent = nativeEvent;
          instance.targetInst = targetInst;
          return instance;
        }
        return {
          topLevelType: topLevelType,
          eventSystemFlags: eventSystemFlags,
          nativeEvent: nativeEvent,
          targetInst: targetInst,
          ancestors: []
        };
      }
      /**
       * Find the deepest React component completely containing the root of the
       * passed-in instance (for use when entire React trees are nested within each
       * other). If React trees are not nested, returns null.
       */

      function findRootContainerNode(inst) {
        if (inst.tag === HostRoot) {
          return inst.stateNode.containerInfo;
        } // TODO: It may be a good idea to cache this to prevent unnecessary DOM
        // traversal, but caching is difficult to do correctly without using a
        // mutation observer to listen for all DOM changes.

        while (inst.return) {
          inst = inst.return;
        }
        if (inst.tag !== HostRoot) {
          // This can happen if we're in a detached tree.
          return null;
        }
        return inst.stateNode.containerInfo;
      }
      /**
       * Allows registered plugins an opportunity to extract events from top-level
       * native browser events.
       *
       * @return {*} An accumulation of synthetic events.
       * @internal
       */

      function extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = null;
        for (var i = 0; i < plugins.length; i++) {
          // Not every plugin in the ordering may be loaded at runtime.
          var possiblePlugin = plugins[i];
          if (possiblePlugin) {
            var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            if (extractedEvents) {
              events = accumulateInto(events, extractedEvents);
            }
          }
        }
        return events;
      }
      function runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
        var events = extractPluginEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        runEventsInBatch(events);
      }
      function handleTopLevel(bookKeeping) {
        var targetInst = bookKeeping.targetInst; // Loop through the hierarchy, in case there's any nested components.
        // It's important that we build the array of ancestors before calling any
        // event handlers, because event handlers can modify the DOM, leading to
        // inconsistencies with ReactMount's node cache. See #1105.

        var ancestor = targetInst;
        do {
          if (!ancestor) {
            var ancestors = bookKeeping.ancestors;
            ancestors.push(ancestor);
            break;
          }
          var root = findRootContainerNode(ancestor);
          if (!root) {
            break;
          }
          var tag = ancestor.tag;
          if (tag === HostComponent || tag === HostText) {
            bookKeeping.ancestors.push(ancestor);
          }
          ancestor = getClosestInstanceFromNode(root);
        } while (ancestor);
        for (var i = 0; i < bookKeeping.ancestors.length; i++) {
          targetInst = bookKeeping.ancestors[i];
          var eventTarget = getEventTarget(bookKeeping.nativeEvent);
          var topLevelType = bookKeeping.topLevelType;
          var nativeEvent = bookKeeping.nativeEvent;
          var eventSystemFlags = bookKeeping.eventSystemFlags; // If this is the first ancestor, we mark it on the system flags

          if (i === 0) {
            eventSystemFlags |= IS_FIRST_ANCESTOR;
          }
          runExtractedPluginEventsInBatch(topLevelType, targetInst, nativeEvent, eventTarget, eventSystemFlags);
        }
      }
      function dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst) {
        var bookKeeping = getTopLevelCallbackBookKeeping(topLevelType, nativeEvent, targetInst, eventSystemFlags);
        try {
          // Event queue being processed in the same cycle allows
          // `preventDefault`.
          batchedEventUpdates(handleTopLevel, bookKeeping);
        } finally {
          releaseTopLevelCallbackBookKeeping(bookKeeping);
        }
      }
      /**
       * We listen for bubbled touch events on the document object.
       *
       * Firefox v8.01 (and possibly others) exhibited strange behavior when
       * mounting `onmousemove` events at some node that was not the document
       * element. The symptoms were that if your mouse is not moving over something
       * contained within that mount point (for example on the background) the
       * top-level listeners for `onmousemove` won't be called. However, if you
       * register the `mousemove` on the document object, then it will of course
       * catch all `mousemove`s. This along with iOS quirks, justifies restricting
       * top-level listeners to the document object only, at least for these
       * movement types of events and possibly all events.
       *
       * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
       *
       * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
       * they bubble to document.
       *
       * @param {string} registrationName Name of listener (e.g. `onClick`).
       * @param {object} mountAt Container where to mount the listener
       */

      function legacyListenToEvent(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for (var i = 0; i < dependencies.length; i++) {
          var dependency = dependencies[i];
          legacyListenToTopLevelEvent(dependency, mountAt, listenerMap);
        }
      }
      function legacyListenToTopLevelEvent(topLevelType, mountAt, listenerMap) {
        if (!listenerMap.has(topLevelType)) {
          switch (topLevelType) {
            case TOP_SCROLL:
              trapCapturedEvent(TOP_SCROLL, mountAt);
              break;
            case TOP_FOCUS:
            case TOP_BLUR:
              trapCapturedEvent(TOP_FOCUS, mountAt);
              trapCapturedEvent(TOP_BLUR, mountAt); // We set the flag for a single dependency later in this function,
              // but this ensures we mark both as attached rather than just one.

              listenerMap.set(TOP_BLUR, null);
              listenerMap.set(TOP_FOCUS, null);
              break;
            case TOP_CANCEL:
            case TOP_CLOSE:
              if (isEventSupported(getRawEventName(topLevelType))) {
                trapCapturedEvent(topLevelType, mountAt);
              }
              break;
            case TOP_INVALID:
            case TOP_SUBMIT:
            case TOP_RESET:
              // We listen to them on the target DOM elements.
              // Some of them bubble so we don't want them to fire twice.
              break;
            default:
              // By default, listen on the top level to all non-media events.
              // Media events don't bubble so adding the listener wouldn't do anything.
              var isMediaEvent = mediaEventTypes.indexOf(topLevelType) !== -1;
              if (!isMediaEvent) {
                trapBubbledEvent(topLevelType, mountAt);
              }
              break;
          }
          listenerMap.set(topLevelType, null);
        }
      }
      function isListeningToAllDependencies(registrationName, mountAt) {
        var listenerMap = getListenerMapForElement(mountAt);
        var dependencies = registrationNameDependencies[registrationName];
        for (var i = 0; i < dependencies.length; i++) {
          var dependency = dependencies[i];
          if (!listenerMap.has(dependency)) {
            return false;
          }
        }
        return true;
      }
      var attemptUserBlockingHydration;
      function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
      }
      var attemptContinuousHydration;
      function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
      }
      var attemptHydrationAtCurrentPriority;
      function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
      } // TODO: Upgrade this definition once we're on a newer version of Flow that
      var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.

      var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
      // if the last target was dehydrated.

      var queuedFocus = null;
      var queuedDrag = null;
      var queuedMouse = null; // For pointer events there can be one latest event per pointerId.

      var queuedPointers = new Map();
      var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.

      var queuedExplicitHydrationTargets = [];
      function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
      }
      var discreteReplayableEvents = [TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_TOUCH_CANCEL, TOP_TOUCH_END, TOP_TOUCH_START, TOP_AUX_CLICK, TOP_DOUBLE_CLICK, TOP_POINTER_CANCEL, TOP_POINTER_DOWN, TOP_POINTER_UP, TOP_DRAG_END, TOP_DRAG_START, TOP_DROP, TOP_COMPOSITION_END, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_INPUT, TOP_TEXT_INPUT, TOP_CLOSE, TOP_CANCEL, TOP_COPY, TOP_CUT, TOP_PASTE, TOP_CLICK, TOP_CHANGE, TOP_CONTEXT_MENU, TOP_RESET, TOP_SUBMIT];
      var continuousReplayableEvents = [TOP_FOCUS, TOP_BLUR, TOP_DRAG_ENTER, TOP_DRAG_LEAVE, TOP_MOUSE_OVER, TOP_MOUSE_OUT, TOP_POINTER_OVER, TOP_POINTER_OUT, TOP_GOT_POINTER_CAPTURE, TOP_LOST_POINTER_CAPTURE];
      function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
      }
      function trapReplayableEventForDocument(topLevelType, document, listenerMap) {
        legacyListenToTopLevelEvent(topLevelType, document, listenerMap);
      }
      function eagerlyTrapReplayableEvents(container, document) {
        var listenerMapForDoc = getListenerMapForElement(document); // Discrete

        discreteReplayableEvents.forEach(function (topLevelType) {
          trapReplayableEventForDocument(topLevelType, document, listenerMapForDoc);
        }); // Continuous

        continuousReplayableEvents.forEach(function (topLevelType) {
          trapReplayableEventForDocument(topLevelType, document, listenerMapForDoc);
        });
      }
      function createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        return {
          blockedOn: blockedOn,
          topLevelType: topLevelType,
          eventSystemFlags: eventSystemFlags | IS_REPLAYED,
          nativeEvent: nativeEvent,
          container: container
        };
      }
      function queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
      } // Resets the replaying for this type of continuous event to no event.

      function clearIfContinuousEvent(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_FOCUS:
          case TOP_BLUR:
            queuedFocus = null;
            break;
          case TOP_DRAG_ENTER:
          case TOP_DRAG_LEAVE:
            queuedDrag = null;
            break;
          case TOP_MOUSE_OVER:
          case TOP_MOUSE_OUT:
            queuedMouse = null;
            break;
          case TOP_POINTER_OVER:
          case TOP_POINTER_OUT:
            {
              var pointerId = nativeEvent.pointerId;
              queuedPointers.delete(pointerId);
              break;
            }
          case TOP_GOT_POINTER_CAPTURE:
          case TOP_LOST_POINTER_CAPTURE:
            {
              var _pointerId = nativeEvent.pointerId;
              queuedPointerCaptures.delete(_pointerId);
              break;
            }
        }
      }
      function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
          var queuedEvent = createQueuedReplayableEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
          if (blockedOn !== null) {
            var _fiber2 = getInstanceFromNode$1(blockedOn);
            if (_fiber2 !== null) {
              // Attempt to increase the priority of this target.
              attemptContinuousHydration(_fiber2);
            }
          }
          return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags and store a single event to be
        // replayed.

        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        return existingQueuedEvent;
      }
      function queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch (topLevelType) {
          case TOP_FOCUS:
            {
              var focusEvent = nativeEvent;
              queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, topLevelType, eventSystemFlags, container, focusEvent);
              return true;
            }
          case TOP_DRAG_ENTER:
            {
              var dragEvent = nativeEvent;
              queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, topLevelType, eventSystemFlags, container, dragEvent);
              return true;
            }
          case TOP_MOUSE_OVER:
            {
              var mouseEvent = nativeEvent;
              queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, topLevelType, eventSystemFlags, container, mouseEvent);
              return true;
            }
          case TOP_POINTER_OVER:
            {
              var pointerEvent = nativeEvent;
              var pointerId = pointerEvent.pointerId;
              queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, topLevelType, eventSystemFlags, container, pointerEvent));
              return true;
            }
          case TOP_GOT_POINTER_CAPTURE:
            {
              var _pointerEvent = nativeEvent;
              var _pointerId2 = _pointerEvent.pointerId;
              queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, topLevelType, eventSystemFlags, container, _pointerEvent));
              return true;
            }
        }
        return false;
      } // Check if this target is unblocked. Returns true if it's unblocked.

      function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);
          if (nearestMounted !== null) {
            var tag = nearestMounted.tag;
            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);
              if (instance !== null) {
                // We're blocked on hydrating this boundary.
                // Increase its priority.
                queuedTarget.blockedOn = instance;
                Scheduler.unstable_runWithPriority(queuedTarget.priority, function () {
                  attemptHydrationAtCurrentPriority(nearestMounted);
                });
                return;
              }
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;
              if (root.hydrate) {
                queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                // a root other than sync.

                return;
              }
            }
          }
        }
        queuedTarget.blockedOn = null;
      }
      function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) {
          return false;
        }
        var nextBlockedOn = attemptToDispatchEvent(queuedEvent.topLevelType, queuedEvent.eventSystemFlags, queuedEvent.container, queuedEvent.nativeEvent);
        if (nextBlockedOn !== null) {
          // We're still blocked. Try again later.
          var _fiber3 = getInstanceFromNode$1(nextBlockedOn);
          if (_fiber3 !== null) {
            attemptContinuousHydration(_fiber3);
          }
          queuedEvent.blockedOn = nextBlockedOn;
          return false;
        }
        return true;
      }
      function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) {
          map.delete(key);
        }
      }
      function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.

        while (queuedDiscreteEvents.length > 0) {
          var nextDiscreteEvent = queuedDiscreteEvents[0];
          if (nextDiscreteEvent.blockedOn !== null) {
            // We're still blocked.
            // Increase the priority of this boundary to unblock
            // the next discrete event.
            var _fiber4 = getInstanceFromNode$1(nextDiscreteEvent.blockedOn);
            if (_fiber4 !== null) {
              attemptUserBlockingHydration(_fiber4);
            }
            break;
          }
          var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.topLevelType, nextDiscreteEvent.eventSystemFlags, nextDiscreteEvent.container, nextDiscreteEvent.nativeEvent);
          if (nextBlockedOn !== null) {
            // We're still blocked. Try again later.
            nextDiscreteEvent.blockedOn = nextBlockedOn;
          } else {
            // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
          }
        } // Next replay any continuous events.

        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) {
          queuedFocus = null;
        }
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) {
          queuedDrag = null;
        }
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) {
          queuedMouse = null;
        }
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
      }
      function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
          queuedEvent.blockedOn = null;
          if (!hasScheduledReplayAttempt) {
            hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
            // now unblocked. This first might not actually be unblocked yet.
            // We could check it early to avoid scheduling an unnecessary callback.

            Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
          }
        }
      }
      function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
          scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
          // worth it because we expect very few discrete events to queue up and once
          // we are actually fully unblocked it will be fast to replay them.

          for (var i = 1; i < queuedDiscreteEvents.length; i++) {
            var queuedEvent = queuedDiscreteEvents[i];
            if (queuedEvent.blockedOn === unblocked) {
              queuedEvent.blockedOn = null;
            }
          }
        }
        if (queuedFocus !== null) {
          scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        }
        if (queuedDrag !== null) {
          scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        }
        if (queuedMouse !== null) {
          scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        }
        var unblock = function unblock(queuedEvent) {
          return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for (var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++) {
          var queuedTarget = queuedExplicitHydrationTargets[_i];
          if (queuedTarget.blockedOn === unblocked) {
            queuedTarget.blockedOn = null;
          }
        }
        while (queuedExplicitHydrationTargets.length > 0) {
          var nextExplicitTarget = queuedExplicitHydrationTargets[0];
          if (nextExplicitTarget.blockedOn !== null) {
            // We're still blocked.
            break;
          } else {
            attemptExplicitHydrationTarget(nextExplicitTarget);
            if (nextExplicitTarget.blockedOn === null) {
              // We're unblocked.
              queuedExplicitHydrationTargets.shift();
            }
          }
        }
      }
      function addEventBubbleListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, false);
      }
      function addEventCaptureListener(element, eventType, listener) {
        element.addEventListener(eventType, listener, true);
      }

      // do it in two places, which duplicates logic
      // and increases the bundle size, we do it all
      // here once. If we remove or refactor the
      // SimpleEventPlugin, we should also remove or
      // update the below line.

      var simpleEventPluginEventTypes = {};
      var topLevelEventsToDispatchConfig = new Map();
      var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
      // the code required to apply the same logic for event prioritization and that of the
      // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
      // duplication (for which there would be quite a bit). For the events that are not needed
      // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
      // array of top level events.
      // Lastly, we ignore prettier so we can keep the formatting sane.
      // prettier-ignore

      var discreteEventPairsForSimpleEventPlugin = [TOP_BLUR, 'blur', TOP_CANCEL, 'cancel', TOP_CLICK, 'click', TOP_CLOSE, 'close', TOP_CONTEXT_MENU, 'contextMenu', TOP_COPY, 'copy', TOP_CUT, 'cut', TOP_AUX_CLICK, 'auxClick', TOP_DOUBLE_CLICK, 'doubleClick', TOP_DRAG_END, 'dragEnd', TOP_DRAG_START, 'dragStart', TOP_DROP, 'drop', TOP_FOCUS, 'focus', TOP_INPUT, 'input', TOP_INVALID, 'invalid', TOP_KEY_DOWN, 'keyDown', TOP_KEY_PRESS, 'keyPress', TOP_KEY_UP, 'keyUp', TOP_MOUSE_DOWN, 'mouseDown', TOP_MOUSE_UP, 'mouseUp', TOP_PASTE, 'paste', TOP_PAUSE, 'pause', TOP_PLAY, 'play', TOP_POINTER_CANCEL, 'pointerCancel', TOP_POINTER_DOWN, 'pointerDown', TOP_POINTER_UP, 'pointerUp', TOP_RATE_CHANGE, 'rateChange', TOP_RESET, 'reset', TOP_SEEKED, 'seeked', TOP_SUBMIT, 'submit', TOP_TOUCH_CANCEL, 'touchCancel', TOP_TOUCH_END, 'touchEnd', TOP_TOUCH_START, 'touchStart', TOP_VOLUME_CHANGE, 'volumeChange'];
      var otherDiscreteEvents = [TOP_CHANGE, TOP_SELECTION_CHANGE, TOP_TEXT_INPUT, TOP_COMPOSITION_START, TOP_COMPOSITION_END, TOP_COMPOSITION_UPDATE]; // prettier-ignore

      var userBlockingPairsForSimpleEventPlugin = [TOP_DRAG, 'drag', TOP_DRAG_ENTER, 'dragEnter', TOP_DRAG_EXIT, 'dragExit', TOP_DRAG_LEAVE, 'dragLeave', TOP_DRAG_OVER, 'dragOver', TOP_MOUSE_MOVE, 'mouseMove', TOP_MOUSE_OUT, 'mouseOut', TOP_MOUSE_OVER, 'mouseOver', TOP_POINTER_MOVE, 'pointerMove', TOP_POINTER_OUT, 'pointerOut', TOP_POINTER_OVER, 'pointerOver', TOP_SCROLL, 'scroll', TOP_TOGGLE, 'toggle', TOP_TOUCH_MOVE, 'touchMove', TOP_WHEEL, 'wheel']; // prettier-ignore

      var continuousPairsForSimpleEventPlugin = [TOP_ABORT, 'abort', TOP_ANIMATION_END, 'animationEnd', TOP_ANIMATION_ITERATION, 'animationIteration', TOP_ANIMATION_START, 'animationStart', TOP_CAN_PLAY, 'canPlay', TOP_CAN_PLAY_THROUGH, 'canPlayThrough', TOP_DURATION_CHANGE, 'durationChange', TOP_EMPTIED, 'emptied', TOP_ENCRYPTED, 'encrypted', TOP_ENDED, 'ended', TOP_ERROR, 'error', TOP_GOT_POINTER_CAPTURE, 'gotPointerCapture', TOP_LOAD, 'load', TOP_LOADED_DATA, 'loadedData', TOP_LOADED_METADATA, 'loadedMetadata', TOP_LOAD_START, 'loadStart', TOP_LOST_POINTER_CAPTURE, 'lostPointerCapture', TOP_PLAYING, 'playing', TOP_PROGRESS, 'progress', TOP_SEEKING, 'seeking', TOP_STALLED, 'stalled', TOP_SUSPEND, 'suspend', TOP_TIME_UPDATE, 'timeUpdate', TOP_TRANSITION_END, 'transitionEnd', TOP_WAITING, 'waiting'];
      /**
       * Turns
       * ['abort', ...]
       * into
       * eventTypes = {
       *   'abort': {
       *     phasedRegistrationNames: {
       *       bubbled: 'onAbort',
       *       captured: 'onAbortCapture',
       *     },
       *     dependencies: [TOP_ABORT],
       *   },
       *   ...
       * };
       * topLevelEventsToDispatchConfig = new Map([
       *   [TOP_ABORT, { sameConfig }],
       * ]);
       */

      function processSimpleEventPluginPairsByPriority(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for (var i = 0; i < eventTypes.length; i += 2) {
          var topEvent = eventTypes[i];
          var event = eventTypes[i + 1];
          var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
          var onEvent = 'on' + capitalizedEvent;
          var config = {
            phasedRegistrationNames: {
              bubbled: onEvent,
              captured: onEvent + 'Capture'
            },
            dependencies: [topEvent],
            eventPriority: priority
          };
          eventPriorities.set(topEvent, priority);
          topLevelEventsToDispatchConfig.set(topEvent, config);
          simpleEventPluginEventTypes[event] = config;
        }
      }
      function processTopEventPairsByPriority(eventTypes, priority) {
        for (var i = 0; i < eventTypes.length; i++) {
          eventPriorities.set(eventTypes[i], priority);
        }
      } // SimpleEventPlugin

      processSimpleEventPluginPairsByPriority(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
      processSimpleEventPluginPairsByPriority(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
      processSimpleEventPluginPairsByPriority(continuousPairsForSimpleEventPlugin, ContinuousEvent); // Not used by SimpleEventPlugin

      processTopEventPairsByPriority(otherDiscreteEvents, DiscreteEvent);
      function getEventPriorityForPluginSystem(topLevelType) {
        var priority = eventPriorities.get(topLevelType); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.

        return priority === undefined ? ContinuousEvent : priority;
      }

      // Intentionally not named imports because Rollup would use dynamic dispatch for
      var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
        runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?

      var _enabled = true;
      function setEnabled(enabled) {
        _enabled = !!enabled;
      }
      function isEnabled() {
        return _enabled;
      }
      function trapBubbledEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, false);
      }
      function trapCapturedEvent(topLevelType, element) {
        trapEventForPluginEventSystem(element, topLevelType, true);
      }
      function trapEventForPluginEventSystem(container, topLevelType, capture) {
        var listener;
        switch (getEventPriorityForPluginSystem(topLevelType)) {
          case DiscreteEvent:
            listener = dispatchDiscreteEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
          case UserBlockingEvent:
            listener = dispatchUserBlockingUpdate.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
          case ContinuousEvent:
          default:
            listener = dispatchEvent.bind(null, topLevelType, PLUGIN_EVENT_SYSTEM, container);
            break;
        }
        var rawEventName = getRawEventName(topLevelType);
        if (capture) {
          addEventCaptureListener(container, rawEventName, listener);
        } else {
          addEventBubbleListener(container, rawEventName, listener);
        }
      }
      function dispatchDiscreteEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, topLevelType, eventSystemFlags, container, nativeEvent);
      }
      function dispatchUserBlockingUpdate(topLevelType, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority, dispatchEvent.bind(null, topLevelType, eventSystemFlags, container, nativeEvent));
      }
      function dispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        if (!_enabled) {
          return;
        }
        if (hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(topLevelType)) {
          // If we already have a queue of discrete events, and this is another discrete
          // event, then we can't dispatch it regardless of its target, since they
          // need to dispatch in order.
          queueDiscreteEvent(null,
          // Flags that we're not actually blocked on anything as far as we know.
          topLevelType, eventSystemFlags, container, nativeEvent);
          return;
        }
        var blockedOn = attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent);
        if (blockedOn === null) {
          // We successfully dispatched this event.
          clearIfContinuousEvent(topLevelType, nativeEvent);
          return;
        }
        if (isReplayableDiscreteEvent(topLevelType)) {
          // This this to be replayed later once the target is available.
          queueDiscreteEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent);
          return;
        }
        if (queueIfContinuousEvent(blockedOn, topLevelType, eventSystemFlags, container, nativeEvent)) {
          return;
        } // We need to clear only if we didn't queue because
        // queueing is accummulative.

        clearIfContinuousEvent(topLevelType, nativeEvent); // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.

        {
          dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, null);
        }
      } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.

      function attemptToDispatchEvent(topLevelType, eventSystemFlags, container, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
          var nearestMounted = getNearestMountedFiber(targetInst);
          if (nearestMounted === null) {
            // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
          } else {
            var tag = nearestMounted.tag;
            if (tag === SuspenseComponent) {
              var instance = getSuspenseInstanceFromFiber(nearestMounted);
              if (instance !== null) {
                // Queue the event to be replayed later. Abort dispatching since we
                // don't want this event dispatched twice through the event system.
                // TODO: If this is the first discrete event in the queue. Schedule an increased
                // priority for this boundary.
                return instance;
              } // This shouldn't happen, something went wrong but to avoid blocking
              // the whole system, dispatch the event without a target.
              // TODO: Warn.

              targetInst = null;
            } else if (tag === HostRoot) {
              var root = nearestMounted.stateNode;
              if (root.hydrate) {
                // If this happens during a replay something went wrong and it might block
                // the whole system.
                return getContainerFromFiber(nearestMounted);
              }
              targetInst = null;
            } else if (nearestMounted !== targetInst) {
              // If we get an event (ex: img onload) before committing that
              // component's mount, ignore it for now (that is, treat it as if it was an
              // event on a non-React tree). We might also consider queueing events and
              // dispatching them after the mount.
              targetInst = null;
            }
          }
        }
        {
          dispatchEventForLegacyPluginEventSystem(topLevelType, eventSystemFlags, nativeEvent, targetInst);
        } // We're not blocked on anything.

        return null;
      }

      // List derived from Gecko source code:
      // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
      var shorthandToLonghand = {
        animation: ['animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction'],
        background: ['backgroundAttachment', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundSize'],
        backgroundPosition: ['backgroundPositionX', 'backgroundPositionY'],
        border: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderBlockEnd: ['borderBlockEndColor', 'borderBlockEndStyle', 'borderBlockEndWidth'],
        borderBlockStart: ['borderBlockStartColor', 'borderBlockStartStyle', 'borderBlockStartWidth'],
        borderBottom: ['borderBottomColor', 'borderBottomStyle', 'borderBottomWidth'],
        borderColor: ['borderBottomColor', 'borderLeftColor', 'borderRightColor', 'borderTopColor'],
        borderImage: ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
        borderInlineEnd: ['borderInlineEndColor', 'borderInlineEndStyle', 'borderInlineEndWidth'],
        borderInlineStart: ['borderInlineStartColor', 'borderInlineStartStyle', 'borderInlineStartWidth'],
        borderLeft: ['borderLeftColor', 'borderLeftStyle', 'borderLeftWidth'],
        borderRadius: ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
        borderRight: ['borderRightColor', 'borderRightStyle', 'borderRightWidth'],
        borderStyle: ['borderBottomStyle', 'borderLeftStyle', 'borderRightStyle', 'borderTopStyle'],
        borderTop: ['borderTopColor', 'borderTopStyle', 'borderTopWidth'],
        borderWidth: ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth'],
        columnRule: ['columnRuleColor', 'columnRuleStyle', 'columnRuleWidth'],
        columns: ['columnCount', 'columnWidth'],
        flex: ['flexBasis', 'flexGrow', 'flexShrink'],
        flexFlow: ['flexDirection', 'flexWrap'],
        font: ['fontFamily', 'fontFeatureSettings', 'fontKerning', 'fontLanguageOverride', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition', 'fontWeight', 'lineHeight'],
        fontVariant: ['fontVariantAlternates', 'fontVariantCaps', 'fontVariantEastAsian', 'fontVariantLigatures', 'fontVariantNumeric', 'fontVariantPosition'],
        gap: ['columnGap', 'rowGap'],
        grid: ['gridAutoColumns', 'gridAutoFlow', 'gridAutoRows', 'gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        gridArea: ['gridColumnEnd', 'gridColumnStart', 'gridRowEnd', 'gridRowStart'],
        gridColumn: ['gridColumnEnd', 'gridColumnStart'],
        gridColumnGap: ['columnGap'],
        gridGap: ['columnGap', 'rowGap'],
        gridRow: ['gridRowEnd', 'gridRowStart'],
        gridRowGap: ['rowGap'],
        gridTemplate: ['gridTemplateAreas', 'gridTemplateColumns', 'gridTemplateRows'],
        listStyle: ['listStyleImage', 'listStylePosition', 'listStyleType'],
        margin: ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
        marker: ['markerEnd', 'markerMid', 'markerStart'],
        mask: ['maskClip', 'maskComposite', 'maskImage', 'maskMode', 'maskOrigin', 'maskPositionX', 'maskPositionY', 'maskRepeat', 'maskSize'],
        maskPosition: ['maskPositionX', 'maskPositionY'],
        outline: ['outlineColor', 'outlineStyle', 'outlineWidth'],
        overflow: ['overflowX', 'overflowY'],
        padding: ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
        placeContent: ['alignContent', 'justifyContent'],
        placeItems: ['alignItems', 'justifyItems'],
        placeSelf: ['alignSelf', 'justifySelf'],
        textDecoration: ['textDecorationColor', 'textDecorationLine', 'textDecorationStyle'],
        textEmphasis: ['textEmphasisColor', 'textEmphasisStyle'],
        transition: ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction'],
        wordWrap: ['overflowWrap']
      };

      /**
       * CSS properties which accept numbers but are not in units of "px".
       */
      var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
      };
      /**
       * @param {string} prefix vendor-specific prefix, eg: Webkit
       * @param {string} key style name, eg: transitionDuration
       * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
       * WebkitTransitionDuration
       */

      function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
      }
      /**
       * Support style names that may come passed in prefixed by adding permutations
       * of vendor prefixes.
       */

      var prefixes = ['Webkit', 'ms', 'Moz', 'O']; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
      // infinite loop, because it iterates over the newly added props too.

      Object.keys(isUnitlessNumber).forEach(function (prop) {
        prefixes.forEach(function (prefix) {
          isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
      });

      /**
       * Convert a value into the proper css writable value. The style name `name`
       * should be logical (no hyphens), as specified
       * in `CSSProperty.isUnitlessNumber`.
       *
       * @param {string} name CSS property name such as `topMargin`.
       * @param {*} value CSS property value such as `10px`.
       * @return {string} Normalized style value with dimensions applied.
       */

      function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) {
          return '';
        }
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) {
          return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        }

        return ('' + value).trim();
      }
      var uppercasePattern = /([A-Z])/g;
      var msPattern = /^ms-/;
      /**
       * Hyphenates a camelcased CSS property name, for example:
       *
       *   > hyphenateStyleName('backgroundColor')
       *   < "background-color"
       *   > hyphenateStyleName('MozTransition')
       *   < "-moz-transition"
       *   > hyphenateStyleName('msTransition')
       *   < "-ms-transition"
       *
       * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
       * is converted to `-ms-`.
       */

      function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
      }
      var warnValidStyle = function warnValidStyle() {};
      {
        // 'msTransform' is correct, but the other prefixes should be capitalized
        var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
        var msPattern$1 = /^-ms-/;
        var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon

        var badStyleValueWithSemicolonPattern = /;\s*$/;
        var warnedStyleNames = {};
        var warnedStyleValues = {};
        var warnedForNaNValue = false;
        var warnedForInfinityValue = false;
        var camelize = function camelize(string) {
          return string.replace(hyphenPattern, function (_, character) {
            return character.toUpperCase();
          });
        };
        var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }
          warnedStyleNames[name] = true;
          error('Unsupported style property %s. Did you mean %s?', name,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          camelize(name.replace(msPattern$1, 'ms-')));
        };
        var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
          if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
            return;
          }
          warnedStyleNames[name] = true;
          error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
        };
        var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
          if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
            return;
          }
          warnedStyleValues[value] = true;
          error("Style property values shouldn't contain a semicolon. " + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
        };
        var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
          if (warnedForNaNValue) {
            return;
          }
          warnedForNaNValue = true;
          error('`NaN` is an invalid value for the `%s` css style property.', name);
        };
        var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
          if (warnedForInfinityValue) {
            return;
          }
          warnedForInfinityValue = true;
          error('`Infinity` is an invalid value for the `%s` css style property.', name);
        };
        warnValidStyle = function warnValidStyle(name, value) {
          if (name.indexOf('-') > -1) {
            warnHyphenatedStyleName(name);
          } else if (badVendoredStyleNamePattern.test(name)) {
            warnBadVendoredStyleName(name);
          } else if (badStyleValueWithSemicolonPattern.test(value)) {
            warnStyleValueWithSemicolon(name, value);
          }
          if (typeof value === 'number') {
            if (isNaN(value)) {
              warnStyleValueIsNaN(name, value);
            } else if (!isFinite(value)) {
              warnStyleValueIsInfinity(name, value);
            }
          }
        };
      }
      var warnValidStyle$1 = warnValidStyle;

      /**
       * Operations for dealing with CSS properties.
       */

      /**
       * This creates a string that is expected to be equivalent to the style
       * attribute generated by server-side rendering. It by-passes warnings and
       * security checks so it's not safe to use this value for anything other than
       * comparison. It is only used in DEV for SSR validation.
       */

      function createDangerousStringForStyles(styles) {
        {
          var serialized = '';
          var delimiter = '';
          for (var styleName in styles) {
            if (!styles.hasOwnProperty(styleName)) {
              continue;
            }
            var styleValue = styles[styleName];
            if (styleValue != null) {
              var isCustomProperty = styleName.indexOf('--') === 0;
              serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
              serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
              delimiter = ';';
            }
          }
          return serialized || null;
        }
      }
      /**
       * Sets the value for multiple styles on a node.  If a value is specified as
       * '' (empty string), the corresponding style property will be unset.
       *
       * @param {DOMElement} node
       * @param {object} styles
       */

      function setValueForStyles(node, styles) {
        var style = node.style;
        for (var styleName in styles) {
          if (!styles.hasOwnProperty(styleName)) {
            continue;
          }
          var isCustomProperty = styleName.indexOf('--') === 0;
          {
            if (!isCustomProperty) {
              warnValidStyle$1(styleName, styles[styleName]);
            }
          }
          var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
          if (styleName === 'float') {
            styleName = 'cssFloat';
          }
          if (isCustomProperty) {
            style.setProperty(styleName, styleValue);
          } else {
            style[styleName] = styleValue;
          }
        }
      }
      function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
      }
      /**
       * Given {color: 'red', overflow: 'hidden'} returns {
       *   color: 'color',
       *   overflowX: 'overflow',
       *   overflowY: 'overflow',
       * }. This can be read as "the overflowY property was set by the overflow
       * shorthand". That is, the values are the property that each was derived from.
       */

      function expandShorthandMap(styles) {
        var expanded = {};
        for (var key in styles) {
          var longhands = shorthandToLonghand[key] || [key];
          for (var i = 0; i < longhands.length; i++) {
            expanded[longhands[i]] = key;
          }
        }
        return expanded;
      }
      /**
       * When mixing shorthand and longhand property names, we warn during updates if
       * we expect an incorrect result to occur. In particular, we warn for:
       *
       * Updating a shorthand property (longhand gets overwritten):
       *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
       *   becomes .style.font = 'baz'
       * Removing a shorthand property (longhand gets lost too):
       *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
       *   becomes .style.font = ''
       * Removing a longhand property (should revert to shorthand; doesn't):
       *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
       *   becomes .style.fontVariant = ''
       */

      function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        {
          if (!nextStyles) {
            return;
          }
          var expandedUpdates = expandShorthandMap(styleUpdates);
          var expandedStyles = expandShorthandMap(nextStyles);
          var warnedAbout = {};
          for (var key in expandedUpdates) {
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
              var warningKey = originalKey + ',' + correctOriginalKey;
              if (warnedAbout[warningKey]) {
                continue;
              }
              warnedAbout[warningKey] = true;
              error('%s a style property during rerender (%s) when a ' + 'conflicting property is set (%s) can lead to styling bugs. To ' + "avoid this, don't mix shorthand and non-shorthand properties " + 'for the same value; instead, replace the shorthand with ' + 'separate values.', isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
          }
        }
      }

      // For HTML, certain tags should omit their close tag. We keep a whitelist for
      // those special-case tags.
      var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
      };

      // `omittedCloseTags` except that `menuitem` should still have its closing tag.

      var voidElementTags = _assign({
        menuitem: true
      }, omittedCloseTags);
      var HTML = '__html';
      var ReactDebugCurrentFrame$3 = null;
      {
        ReactDebugCurrentFrame$3 = ReactSharedInternals.ReactDebugCurrentFrame;
      }
      function assertValidProps(tag, props) {
        if (!props) {
          return;
        } // Note the use of `==` which checks for null or undefined.

        if (voidElementTags[tag]) {
          if (!(props.children == null && props.dangerouslySetInnerHTML == null)) {
            {
              throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`." + ReactDebugCurrentFrame$3.getStackAddendum());
            }
          }
        }
        if (props.dangerouslySetInnerHTML != null) {
          if (!(props.children == null)) {
            {
              throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            }
          }
          if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) {
            {
              throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.");
            }
          }
        }
        {
          if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) {
            error('A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.');
          }
        }
        if (!(props.style == null || typeof props.style === 'object')) {
          {
            throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX." + ReactDebugCurrentFrame$3.getStackAddendum());
          }
        }
      }
      function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) {
          return typeof props.is === 'string';
        }
        switch (tagName) {
          // These are reserved SVG and MathML elements.
          // We don't mind this whitelist too much because we expect it to never grow.
          // The alternative is to track the namespace in a few places which is convoluted.
          // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
          case 'annotation-xml':
          case 'color-profile':
          case 'font-face':
          case 'font-face-src':
          case 'font-face-uri':
          case 'font-face-format':
          case 'font-face-name':
          case 'missing-glyph':
            return false;
          default:
            return true;
        }
      }

      // When adding attributes to the HTML or SVG whitelist, be sure to
      // also add them to this module to ensure casing and incorrect name
      // warnings.
      var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
      };
      var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
      };
      var warnedProperties = {};
      var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
      var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
      var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
      function validateProperty(tagName, name) {
        {
          if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) {
            return true;
          }
          if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (correctName == null) {
              error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
              warnedProperties[name] = true;
              return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.

            if (name !== correctName) {
              error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
              warnedProperties[name] = true;
              return true;
            }
          }
          if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.

            if (standardName == null) {
              warnedProperties[name] = true;
              return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.

            if (name !== standardName) {
              error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties[name] = true;
              return true;
            }
          }
        }
        return true;
      }
      function warnInvalidARIAProps(type, props) {
        {
          var invalidProps = [];
          for (var key in props) {
            var isValid = validateProperty(type, key);
            if (!isValid) {
              invalidProps.push(key);
            }
          }
          var unknownPropString = invalidProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');
          if (invalidProps.length === 1) {
            error('Invalid aria prop %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
          } else if (invalidProps.length > 1) {
            error('Invalid aria props %s on <%s> tag. ' + 'For details, see https://fb.me/invalid-aria-prop', unknownPropString, type);
          }
        }
      }
      function validateProperties(type, props) {
        if (isCustomComponent(type, props)) {
          return;
        }
        warnInvalidARIAProps(type, props);
      }
      var didWarnValueNull = false;
      function validateProperties$1(type, props) {
        {
          if (type !== 'input' && type !== 'textarea' && type !== 'select') {
            return;
          }
          if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty array when `multiple` is set to `true` ' + 'to clear the component or `undefined` for uncontrolled components.', type);
            } else {
              error('`value` prop on `%s` should not be null. ' + 'Consider using an empty string to clear the component or `undefined` ' + 'for uncontrolled components.', type);
            }
          }
        }
      }
      var validateProperty$1 = function validateProperty$1() {};
      {
        var warnedProperties$1 = {};
        var _hasOwnProperty = Object.prototype.hasOwnProperty;
        var EVENT_NAME_REGEX = /^on./;
        var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
        var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
        var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
        validateProperty$1 = function validateProperty$1(tagName, name, value, canUseEventSystem) {
          if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) {
            return true;
          }
          var lowerCasedName = name.toLowerCase();
          if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error('React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.');
            warnedProperties$1[name] = true;
            return true;
          } // We can't rely on the event system being injected on the server.

          if (canUseEventSystem) {
            if (registrationNameModules.hasOwnProperty(name)) {
              return true;
            }
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
              error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
              warnedProperties$1[name] = true;
              return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
              error('Unknown event handler property `%s`. It will be ignored.', name);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) {
              error('Invalid event handler property `%s`. ' + 'React events use the camelCase naming convention, for example `onClick`.', name);
            }
            warnedProperties$1[name] = true;
            return true;
          } // Let the ARIA attribute hook validate ARIA attributes

          if (rARIA$1.test(name) || rARIACamel$1.test(name)) {
            return true;
          }
          if (lowerCasedName === 'innerhtml') {
            error('Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.');
            warnedProperties$1[name] = true;
            return true;
          }
          if (lowerCasedName === 'aria') {
            error('The `aria` attribute is reserved for future use in React. ' + 'Pass individual `aria-` attributes instead.');
            warnedProperties$1[name] = true;
            return true;
          }
          if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error('Received a `%s` for a string attribute `is`. If this is expected, cast ' + 'the value to a string.', typeof value);
            warnedProperties$1[name] = true;
            return true;
          }
          if (typeof value === 'number' && isNaN(value)) {
            error('Received NaN for the `%s` attribute. If this is expected, cast ' + 'the value to a string.', name);
            warnedProperties$1[name] = true;
            return true;
          }
          var propertyInfo = getPropertyInfo(name);
          var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.

          if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
              error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
              warnedProperties$1[name] = true;
              return true;
            }
          } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error('React does not recognize the `%s` prop on a DOM element. If you ' + 'intentionally want it to appear in the DOM as a custom ' + 'attribute, spell it as lowercase `%s` instead. ' + 'If you accidentally passed it from a parent component, remove ' + 'it from the DOM element.', name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
          }
          if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.', value, name, name, value, name);
            } else {
              error('Received `%s` for a non-boolean attribute `%s`.\n\n' + 'If you want to write it to the DOM, pass a string instead: ' + '%s="%s" or %s={value.toString()}.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            }
            warnedProperties$1[name] = true;
            return true;
          } // Now that we've validated casing, do not validate
          // data types for reserved props

          if (isReserved) {
            return true;
          } // Warn when a known attribute is a bad type

          if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
          } // Warn when passing the strings 'false' or 'true' into a boolean prop

          if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error('Received the string `%s` for the boolean attribute `%s`. ' + '%s ' + 'Did you mean %s={%s}?', value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
          }
          return true;
        };
      }
      var warnUnknownProperties = function warnUnknownProperties(type, props, canUseEventSystem) {
        {
          var unknownProps = [];
          for (var key in props) {
            var isValid = validateProperty$1(type, key, props[key], canUseEventSystem);
            if (!isValid) {
              unknownProps.push(key);
            }
          }
          var unknownPropString = unknownProps.map(function (prop) {
            return '`' + prop + '`';
          }).join(', ');
          if (unknownProps.length === 1) {
            error('Invalid value for prop %s on <%s> tag. Either remove it from the element, ' + 'or pass a string or number value to keep it in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
          } else if (unknownProps.length > 1) {
            error('Invalid values for props %s on <%s> tag. Either remove them from the element, ' + 'or pass a string or number value to keep them in the DOM. ' + 'For details, see https://fb.me/react-attribute-behavior', unknownPropString, type);
          }
        }
      };
      function validateProperties$2(type, props, canUseEventSystem) {
        if (isCustomComponent(type, props)) {
          return;
        }
        warnUnknownProperties(type, props, canUseEventSystem);
      }
      var didWarnInvalidHydration = false;
      var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
      var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
      var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
      var AUTOFOCUS = 'autoFocus';
      var CHILDREN = 'children';
      var STYLE = 'style';
      var HTML$1 = '__html';
      var HTML_NAMESPACE$1 = Namespaces.html;
      var warnedUnknownTags;
      var suppressHydrationWarning;
      var validatePropertiesInDevelopment;
      var warnForTextDifference;
      var warnForPropDifference;
      var warnForExtraAttributes;
      var warnForInvalidEventListener;
      var canDiffStyleForHydrationWarning;
      var normalizeMarkupForTextOrAttribute;
      var normalizeHTML;
      {
        warnedUnknownTags = {
          // Chrome is the only major browser not shipping <time>. But as of July
          // 2017 it intends to ship it due to widespread usage. We intentionally
          // *don't* warn for <time> even if it's unrecognized by Chrome because
          // it soon will be, and many apps have been using it anyway.
          time: true,
          // There are working polyfills for <dialog>. Let people use it.
          dialog: true,
          // Electron ships a custom <webview> tag to display external web content in
          // an isolated frame and process.
          // This tag is not present in non Electron environments such as JSDom which
          // is often used for testing purposes.
          // @see https://electronjs.org/docs/api/webview-tag
          webview: true
        };
        validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
          validateProperties(type, props);
          validateProperties$1(type, props);
          validateProperties$2(type, props, /* canUseEventSystem */
          true);
        }; // IE 11 parses & normalizes the style attribute as opposed to other
        // browsers. It adds spaces and sorts the properties in some
        // non-alphabetical order. Handling that would require sorting CSS
        // properties in the client & server versions or applying
        // `expectedStyle` to a temporary DOM node to read its `style` attribute
        // normalized. Since it only affects IE, we're skipping style warnings
        // in that browser completely in favor of doing all that work.
        // See https://github.com/facebook/react/issues/11807

        canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
        // It also can turn \u0000 into \uFFFD inside attributes.
        // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
        // If we have a mismatch, it might be caused by that.
        // We will still patch up in this case but not fire the warning.

        var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
        var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
        normalizeMarkupForTextOrAttribute = function normalizeMarkupForTextOrAttribute(markup) {
          var markupString = typeof markup === 'string' ? markup : '' + markup;
          return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
        };
        warnForTextDifference = function warnForTextDifference(serverText, clientText) {
          if (didWarnInvalidHydration) {
            return;
          }
          var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
          var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
          if (normalizedServerText === normalizedClientText) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
        };
        warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
          if (didWarnInvalidHydration) {
            return;
          }
          var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
          var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
          if (normalizedServerValue === normalizedClientValue) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
        };
        warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          var names = [];
          attributeNames.forEach(function (name) {
            names.push(name);
          });
          error('Extra attributes from the server: %s', names);
        };
        warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
          if (listener === false) {
            error('Expected `%s` listener to be a function, instead got `false`.\n\n' + 'If you used to conditionally omit it with %s={condition && value}, ' + 'pass %s={condition ? value : undefined} instead.', registrationName, registrationName, registrationName);
          } else {
            error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
          }
        }; // Parse the HTML and read it back to normalize the HTML string so that it
        // can be used for comparison.

        normalizeHTML = function normalizeHTML(parent, html) {
          // We could have created a separate document here to avoid
          // re-initializing custom elements if they exist. But this breaks
          // how <noscript> is being handled. So we use the same document.
          // See the discussion in https://github.com/facebook/react/pull/11157.
          var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
          testElement.innerHTML = html;
          return testElement.innerHTML;
        };
      }
      function ensureListeningTo(rootContainerElement, registrationName) {
        var isDocumentOrFragment = rootContainerElement.nodeType === DOCUMENT_NODE || rootContainerElement.nodeType === DOCUMENT_FRAGMENT_NODE;
        var doc = isDocumentOrFragment ? rootContainerElement : rootContainerElement.ownerDocument;
        legacyListenToEvent(registrationName, doc);
      }
      function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
      }
      function noop() {}
      function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
      }
      function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for (var propKey in nextProps) {
          if (!nextProps.hasOwnProperty(propKey)) {
            continue;
          }
          var nextProp = nextProps[propKey];
          if (propKey === STYLE) {
            {
              if (nextProp) {
                // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
              }
            } // Relies on `updateStylesByID` not mutating `styleUpdates`.

            setValueForStyles(domElement, nextProp);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            if (nextHtml != null) {
              setInnerHTML(domElement, nextHtml);
            }
          } else if (propKey === CHILDREN) {
            if (typeof nextProp === 'string') {
              // Avoid setting initial textContent when the text is empty. In IE11 setting
              // textContent on a <textarea> will cause the placeholder to not
              // show within the <textarea> until it has been focused and blurred again.
              // https://github.com/facebook/react/issues/6731#issuecomment-254874553
              var canSetTextContent = tag !== 'textarea' || nextProp !== '';
              if (canSetTextContent) {
                setTextContent(domElement, nextProp);
              }
            } else if (typeof nextProp === 'number') {
              setTextContent(domElement, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
          } else if (nextProp != null) {
            setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
          }
        }
      }
      function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for (var i = 0; i < updatePayload.length; i += 2) {
          var propKey = updatePayload[i];
          var propValue = updatePayload[i + 1];
          if (propKey === STYLE) {
            setValueForStyles(domElement, propValue);
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            setInnerHTML(domElement, propValue);
          } else if (propKey === CHILDREN) {
            setTextContent(domElement, propValue);
          } else {
            setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
          }
        }
      }
      function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.

        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) {
          namespaceURI = getIntrinsicNamespace(type);
        }
        if (namespaceURI === HTML_NAMESPACE$1) {
          {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.

            if (!isCustomComponentTag && type !== type.toLowerCase()) {
              error('<%s /> is using incorrect casing. ' + 'Use PascalCase for React components, ' + 'or lowercase for HTML elements.', type);
            }
          }
          if (type === 'script') {
            // Create the script via .innerHTML so its "parser-inserted" flag is
            // set to true and it does not execute
            var div = ownerDocument.createElement('div');
            div.innerHTML = '<script><' + '/script>'; // eslint-disable-line
            // This is guaranteed to yield a script element.

            var firstChild = div.firstChild;
            domElement = div.removeChild(firstChild);
          } else if (typeof props.is === 'string') {
            // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
              is: props.is
            });
          } else {
            // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
            // See discussion in https://github.com/facebook/react/pull/6896
            // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
            domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
            // attributes on `select`s needs to be added before `option`s are inserted.
            // This prevents:
            // - a bug where the `select` does not scroll to the correct option because singular
            //  `select` elements automatically pick the first item #13222
            // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
            // See https://github.com/facebook/react/issues/13222
            // and https://github.com/facebook/react/issues/14239

            if (type === 'select') {
              var node = domElement;
              if (props.multiple) {
                node.multiple = true;
              } else if (props.size) {
                // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                // it is possible that no option is selected.
                //
                // This is only necessary when a select in "single selection mode".
                node.size = props.size;
              }
            }
          }
        } else {
          domElement = ownerDocument.createElementNS(namespaceURI, type);
        }
        {
          if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
              warnedUnknownTags[type] = true;
              error('The tag <%s> is unrecognized in this browser. ' + 'If you meant to render a React component, start its name with ' + 'an uppercase letter.', type);
            }
          }
        }
        return domElement;
      }
      function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
      }
      function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        {
          validatePropertiesInDevelopment(tag, rawProps);
        } // TODO: Make sure that we check isMounted before firing any of these events.

        var props;
        switch (tag) {
          case 'iframe':
          case 'object':
          case 'embed':
            trapBubbledEvent(TOP_LOAD, domElement);
            props = rawProps;
            break;
          case 'video':
          case 'audio':
            // Create listener for each media event
            for (var i = 0; i < mediaEventTypes.length; i++) {
              trapBubbledEvent(mediaEventTypes[i], domElement);
            }
            props = rawProps;
            break;
          case 'source':
            trapBubbledEvent(TOP_ERROR, domElement);
            props = rawProps;
            break;
          case 'img':
          case 'image':
          case 'link':
            trapBubbledEvent(TOP_ERROR, domElement);
            trapBubbledEvent(TOP_LOAD, domElement);
            props = rawProps;
            break;
          case 'form':
            trapBubbledEvent(TOP_RESET, domElement);
            trapBubbledEvent(TOP_SUBMIT, domElement);
            props = rawProps;
            break;
          case 'details':
            trapBubbledEvent(TOP_TOGGLE, domElement);
            props = rawProps;
            break;
          case 'input':
            initWrapperState(domElement, rawProps);
            props = getHostProps(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'option':
            validateProps(domElement, rawProps);
            props = getHostProps$1(domElement, rawProps);
            break;
          case 'select':
            initWrapperState$1(domElement, rawProps);
            props = getHostProps$2(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            props = getHostProps$3(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          default:
            props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch (tag) {
          case 'input':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper(domElement, rawProps, false);
            break;
          case 'textarea':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper$3(domElement);
            break;
          case 'option':
            postMountWrapper$1(domElement, rawProps);
            break;
          case 'select':
            postMountWrapper$2(domElement, rawProps);
            break;
          default:
            if (typeof props.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
      } // Calculate the diff between the two objects.

      function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        {
          validatePropertiesInDevelopment(tag, nextRawProps);
        }
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch (tag) {
          case 'input':
            lastProps = getHostProps(domElement, lastRawProps);
            nextProps = getHostProps(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'option':
            lastProps = getHostProps$1(domElement, lastRawProps);
            nextProps = getHostProps$1(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'select':
            lastProps = getHostProps$2(domElement, lastRawProps);
            nextProps = getHostProps$2(domElement, nextRawProps);
            updatePayload = [];
            break;
          case 'textarea':
            lastProps = getHostProps$3(domElement, lastRawProps);
            nextProps = getHostProps$3(domElement, nextRawProps);
            updatePayload = [];
            break;
          default:
            lastProps = lastRawProps;
            nextProps = nextRawProps;
            if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for (propKey in lastProps) {
          if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
            continue;
          }
          if (propKey === STYLE) {
            var lastStyle = lastProps[propKey];
            for (styleName in lastStyle) {
              if (lastStyle.hasOwnProperty(styleName)) {
                if (!styleUpdates) {
                  styleUpdates = {};
                }
                styleUpdates[styleName] = '';
              }
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (propKey === AUTOFOCUS) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            if (!updatePayload) {
              updatePayload = [];
            }
          } else {
            // For all other deleted properties we add it to the queue. We use
            // the whitelist in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
          }
        }
        for (propKey in nextProps) {
          var nextProp = nextProps[propKey];
          var lastProp = lastProps != null ? lastProps[propKey] : undefined;
          if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
            continue;
          }
          if (propKey === STYLE) {
            {
              if (nextProp) {
                // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
              }
            }
            if (lastProp) {
              // Unset styles on `lastProp` but not on `nextProp`.
              for (styleName in lastProp) {
                if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = '';
                }
              } // Update styles that changed since `lastProp`.

              for (styleName in nextProp) {
                if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                  if (!styleUpdates) {
                    styleUpdates = {};
                  }
                  styleUpdates[styleName] = nextProp[styleName];
                }
              }
            } else {
              // Relies on `updateStylesByID` not mutating `styleUpdates`.
              if (!styleUpdates) {
                if (!updatePayload) {
                  updatePayload = [];
                }
                updatePayload.push(propKey, styleUpdates);
              }
              styleUpdates = nextProp;
            }
          } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
            var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
            var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
            if (nextHtml != null) {
              if (lastHtml !== nextHtml) {
                (updatePayload = updatePayload || []).push(propKey, nextHtml);
              }
            }
          } else if (propKey === CHILDREN) {
            if (lastProp !== nextProp && (typeof nextProp === 'string' || typeof nextProp === 'number')) {
              (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            }
          } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              // We eagerly listen to this even though we haven't committed yet.
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
            if (!updatePayload && lastProp !== nextProp) {
              // This is a special case. If any listener updates we need to ensure
              // that the "current" props pointer gets updated so we need a commit
              // to update this element.
              updatePayload = [];
            }
          } else {
            // For any other property we always add it to the queue and then we
            // filter it out using the whitelist during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
          }
        }
        if (styleUpdates) {
          {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
          }
          (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
      } // Apply the diff.

      function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) {
          updateChecked(domElement, nextRawProps);
        }
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.

        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.

        switch (tag) {
          case 'input':
            // Update the wrapper around inputs *after* updating props. This has to
            // happen after `updateDOMProperties`. Otherwise HTML5 input validations
            // raise warnings and prevent the new value from being assigned.
            updateWrapper(domElement, nextRawProps);
            break;
          case 'textarea':
            updateWrapper$1(domElement, nextRawProps);
            break;
          case 'select':
            // <select> value update needs to occur after <option> children
            // reconciliation
            postUpdateWrapper(domElement, nextRawProps);
            break;
        }
      }
      function getPossibleStandardName(propName) {
        {
          var lowerCasedName = propName.toLowerCase();
          if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            return null;
          }
          return possibleStandardNames[lowerCasedName] || null;
        }
      }
      function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        {
          suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
          isCustomComponentTag = isCustomComponent(tag, rawProps);
          validatePropertiesInDevelopment(tag, rawProps);
        } // TODO: Make sure that we check isMounted before firing any of these events.

        switch (tag) {
          case 'iframe':
          case 'object':
          case 'embed':
            trapBubbledEvent(TOP_LOAD, domElement);
            break;
          case 'video':
          case 'audio':
            // Create listener for each media event
            for (var i = 0; i < mediaEventTypes.length; i++) {
              trapBubbledEvent(mediaEventTypes[i], domElement);
            }
            break;
          case 'source':
            trapBubbledEvent(TOP_ERROR, domElement);
            break;
          case 'img':
          case 'image':
          case 'link':
            trapBubbledEvent(TOP_ERROR, domElement);
            trapBubbledEvent(TOP_LOAD, domElement);
            break;
          case 'form':
            trapBubbledEvent(TOP_RESET, domElement);
            trapBubbledEvent(TOP_SUBMIT, domElement);
            break;
          case 'details':
            trapBubbledEvent(TOP_TOGGLE, domElement);
            break;
          case 'input':
            initWrapperState(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'option':
            validateProps(domElement, rawProps);
            break;
          case 'select':
            initWrapperState$1(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
          case 'textarea':
            initWrapperState$2(domElement, rawProps);
            trapBubbledEvent(TOP_INVALID, domElement); // For controlled components we always need to ensure we're listening
            // to onChange. Even if there is no listener.

            ensureListeningTo(rootContainerElement, 'onChange');
            break;
        }
        assertValidProps(tag, rawProps);
        {
          extraAttributeNames = new Set();
          var attributes = domElement.attributes;
          for (var _i = 0; _i < attributes.length; _i++) {
            var name = attributes[_i].name.toLowerCase();
            switch (name) {
              // Built-in SSR attribute is whitelisted
              case 'data-reactroot':
                break;
              // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.

              case 'value':
                break;
              case 'checked':
                break;
              case 'selected':
                break;
              default:
                // Intentionally use the original name.
                // See discussion in https://github.com/facebook/react/pull/10676.
                extraAttributeNames.add(attributes[_i].name);
            }
          }
        }
        var updatePayload = null;
        for (var propKey in rawProps) {
          if (!rawProps.hasOwnProperty(propKey)) {
            continue;
          }
          var nextProp = rawProps[propKey];
          if (propKey === CHILDREN) {
            // For text content children we compare against textContent. This
            // might match additional HTML that is hidden when we read it using
            // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
            // satisfies our requirement. Our requirement is not to produce perfect
            // HTML and attributes. Ideally we should preserve structure but it's
            // ok not to if the visible content is still enough to indicate what
            // even listeners these nodes might be wired up to.
            // TODO: Warn if there is more than a single textNode as a child.
            // TODO: Should we use domElement.firstChild.nodeValue to compare?
            if (typeof nextProp === 'string') {
              if (domElement.textContent !== nextProp) {
                if (!suppressHydrationWarning) {
                  warnForTextDifference(domElement.textContent, nextProp);
                }
                updatePayload = [CHILDREN, nextProp];
              }
            } else if (typeof nextProp === 'number') {
              if (domElement.textContent !== '' + nextProp) {
                if (!suppressHydrationWarning) {
                  warnForTextDifference(domElement.textContent, nextProp);
                }
                updatePayload = [CHILDREN, '' + nextProp];
              }
            }
          } else if (registrationNameModules.hasOwnProperty(propKey)) {
            if (nextProp != null) {
              if (typeof nextProp !== 'function') {
                warnForInvalidEventListener(propKey, nextProp);
              }
              ensureListeningTo(rootContainerElement, propKey);
            }
          } else if (
          // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof isCustomComponentTag === 'boolean') {
            // Validate that the properties correspond to their expected values.
            var serverValue = void 0;
            var propertyInfo = getPropertyInfo(propKey);
            if (suppressHydrationWarning) ;else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING ||
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
              var serverHTML = domElement.innerHTML;
              var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
              var expectedHTML = normalizeHTML(domElement, nextHtml != null ? nextHtml : '');
              if (expectedHTML !== serverHTML) {
                warnForPropDifference(propKey, serverHTML, expectedHTML);
              }
            } else if (propKey === STYLE) {
              // $FlowFixMe - Should be inferred as not undefined.
              extraAttributeNames.delete(propKey);
              if (canDiffStyleForHydrationWarning) {
                var expectedStyle = createDangerousStringForStyles(nextProp);
                serverValue = domElement.getAttribute('style');
                if (expectedStyle !== serverValue) {
                  warnForPropDifference(propKey, serverValue, expectedStyle);
                }
              }
            } else if (isCustomComponentTag) {
              // $FlowFixMe - Should be inferred as not undefined.
              extraAttributeNames.delete(propKey.toLowerCase());
              serverValue = getValueForAttribute(domElement, propKey, nextProp);
              if (nextProp !== serverValue) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
              var isMismatchDueToBadCasing = false;
              if (propertyInfo !== null) {
                // $FlowFixMe - Should be inferred as not undefined.
                extraAttributeNames.delete(propertyInfo.attributeName);
                serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
              } else {
                var ownNamespace = parentNamespace;
                if (ownNamespace === HTML_NAMESPACE$1) {
                  ownNamespace = getIntrinsicNamespace(tag);
                }
                if (ownNamespace === HTML_NAMESPACE$1) {
                  // $FlowFixMe - Should be inferred as not undefined.
                  extraAttributeNames.delete(propKey.toLowerCase());
                } else {
                  var standardName = getPossibleStandardName(propKey);
                  if (standardName !== null && standardName !== propKey) {
                    // If an SVG prop is supplied with bad casing, it will
                    // be successfully parsed from HTML, but will produce a mismatch
                    // (and would be incorrectly rendered on the client).
                    // However, we already warn about bad casing elsewhere.
                    // So we'll skip the misleading extra mismatch warning in this case.
                    isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.

                    extraAttributeNames.delete(standardName);
                  } // $FlowFixMe - Should be inferred as not undefined.

                  extraAttributeNames.delete(propKey);
                }
                serverValue = getValueForAttribute(domElement, propKey, nextProp);
              }
              if (nextProp !== serverValue && !isMismatchDueToBadCasing) {
                warnForPropDifference(propKey, serverValue, nextProp);
              }
            }
          }
        }
        {
          // $FlowFixMe - Should be inferred as not undefined.
          if (extraAttributeNames.size > 0 && !suppressHydrationWarning) {
            // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
          }
        }
        switch (tag) {
          case 'input':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper(domElement, rawProps, true);
            break;
          case 'textarea':
            // TODO: Make sure we check if this is still unmounted or do any clean
            // up necessary since we never stop tracking anymore.
            track(domElement);
            postMountWrapper$3(domElement);
            break;
          case 'select':
          case 'option':
            // For input and textarea we current always set the value property at
            // post mount to force it to diverge from attributes. However, for
            // option and select we don't quite do the same thing and select
            // is not resilient to the DOM state changing so we don't do that here.
            // TODO: Consider not doing this for input and textarea.
            break;
          default:
            if (typeof rawProps.onClick === 'function') {
              // TODO: This cast may not be sound for SVG, MathML or custom elements.
              trapClickOnNonInteractiveElement(domElement);
            }
            break;
        }
        return updatePayload;
      }
      function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
      }
      function warnForUnmatchedText(textNode, text) {
        {
          warnForTextDifference(textNode.nodeValue, text);
        }
      }
      function warnForDeletedHydratableElement(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
        }
      }
      function warnForDeletedHydratableText(parentNode, child) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
        }
      }
      function warnForInsertedHydratedElement(parentNode, tag, props) {
        {
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
        }
      }
      function warnForInsertedHydratedText(parentNode, text) {
        {
          if (text === '') {
            // We expect to insert empty text nodes since they're not represented in
            // the HTML.
            // TODO: Remove this special case if we can just avoid inserting empty
            // text nodes.
            return;
          }
          if (didWarnInvalidHydration) {
            return;
          }
          didWarnInvalidHydration = true;
          error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
        }
      }
      function restoreControlledState$3(domElement, tag, props) {
        switch (tag) {
          case 'input':
            restoreControlledState(domElement, props);
            return;
          case 'textarea':
            restoreControlledState$2(domElement, props);
            return;
          case 'select':
            restoreControlledState$1(domElement, props);
            return;
        }
      }
      function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') {
          return null;
        }
        try {
          return doc.activeElement || doc.body;
        } catch (e) {
          return doc.body;
        }
      }

      /**
       * Given any node return the first leaf node without children.
       *
       * @param {DOMElement|DOMTextNode} node
       * @return {DOMElement|DOMTextNode}
       */

      function getLeafNode(node) {
        while (node && node.firstChild) {
          node = node.firstChild;
        }
        return node;
      }
      /**
       * Get the next sibling within a container. This will walk up the
       * DOM if a node's siblings have been exhausted.
       *
       * @param {DOMElement|DOMTextNode} node
       * @return {?DOMElement|DOMTextNode}
       */

      function getSiblingNode(node) {
        while (node) {
          if (node.nextSibling) {
            return node.nextSibling;
          }
          node = node.parentNode;
        }
      }
      /**
       * Get object describing the nodes which contain characters at offset.
       *
       * @param {DOMElement|DOMTextNode} root
       * @param {number} offset
       * @return {?object}
       */

      function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while (node) {
          if (node.nodeType === TEXT_NODE) {
            nodeEnd = nodeStart + node.textContent.length;
            if (nodeStart <= offset && nodeEnd >= offset) {
              return {
                node: node,
                offset: offset - nodeStart
              };
            }
            nodeStart = nodeEnd;
          }
          node = getLeafNode(getSiblingNode(node));
        }
      }

      /**
       * @param {DOMElement} outerNode
       * @return {?object}
       */

      function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) {
          return null;
        }
        var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset,
          focusNode = selection.focusNode,
          focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427

        try {
          /* eslint-disable no-unused-expressions */
          anchorNode.nodeType;
          focusNode.nodeType;
          /* eslint-enable no-unused-expressions */
        } catch (e) {
          return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
      }
      /**
       * Returns {start, end} where `start` is the character/codepoint index of
       * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
       * `end` is the index of (focusNode, focusOffset).
       *
       * Returns null if you pass in garbage input but we should probably just crash.
       *
       * Exported only for testing.
       */

      function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while (true) {
          var next = null;
          while (true) {
            if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) {
              start = length + anchorOffset;
            }
            if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) {
              end = length + focusOffset;
            }
            if (node.nodeType === TEXT_NODE) {
              length += node.nodeValue.length;
            }
            if ((next = node.firstChild) === null) {
              break;
            } // Moving from `node` to its first child `next`.

            parentNode = node;
            node = next;
          }
          while (true) {
            if (node === outerNode) {
              // If `outerNode` has children, this is always the second time visiting
              // it. If it has no children, this is still the first loop, and the only
              // valid selection is anchorNode and focusNode both equal to this node
              // and both offsets 0, in which case we will have handled above.
              break outer;
            }
            if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) {
              start = length;
            }
            if (parentNode === focusNode && ++indexWithinFocus === focusOffset) {
              end = length;
            }
            if ((next = node.nextSibling) !== null) {
              break;
            }
            node = parentNode;
            parentNode = node.parentNode;
          } // Moving from `node` to its next sibling `next`.

          node = next;
        }
        if (start === -1 || end === -1) {
          // This should never happen. (Would happen if the anchor/focus nodes aren't
          // actually inside the passed-in node.)
          return null;
        }
        return {
          start: start,
          end: end
        };
      }
      /**
       * In modern non-IE browsers, we can support both forward and backward
       * selections.
       *
       * Note: IE10+ supports the Selection object, but it does not support
       * the `extend` method, which means that even in modern IE, it's not possible
       * to programmatically create a backward selection. Thus, for all IE
       * versions, we use the old IE API to create our selections.
       *
       * @param {DOMElement|DOMTextNode} node
       * @param {object} offsets
       */

      function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)

        if (!win.getSelection) {
          return;
        }
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.

        if (!selection.extend && start > end) {
          var temp = end;
          end = start;
          start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
          if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) {
            return;
          }
          var range = doc.createRange();
          range.setStart(startMarker.node, startMarker.offset);
          selection.removeAllRanges();
          if (start > end) {
            selection.addRange(range);
            selection.extend(endMarker.node, endMarker.offset);
          } else {
            range.setEnd(endMarker.node, endMarker.offset);
            selection.addRange(range);
          }
        }
      }
      function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
      }
      function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) {
          return false;
        } else if (outerNode === innerNode) {
          return true;
        } else if (isTextNode(outerNode)) {
          return false;
        } else if (isTextNode(innerNode)) {
          return containsNode(outerNode, innerNode.parentNode);
        } else if ('contains' in outerNode) {
          return outerNode.contains(innerNode);
        } else if (outerNode.compareDocumentPosition) {
          return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        } else {
          return false;
        }
      }
      function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
      }
      function isSameOriginFrame(iframe) {
        try {
          // Accessing the contentDocument of a HTMLIframeElement can cause the browser
          // to throw, e.g. if it has a cross-origin src attribute.
          // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
          // iframe.contentDocument.defaultView;
          // A safety way is to access one of the cross origin properties: Window or Location
          // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
          // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
          return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
          return false;
        }
      }
      function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while (element instanceof win.HTMLIFrameElement) {
          if (isSameOriginFrame(element)) {
            win = element.contentWindow;
          } else {
            return element;
          }
          element = getActiveElement(win.document);
        }
        return element;
      }
      /**
       * @ReactInputSelection: React input selection module. Based on Selection.js,
       * but modified to be suitable for react and has a couple of bug fixes (doesn't
       * assume buttons have range selections allowed).
       * Input selection module for React.
       */

      /**
       * @hasSelectionCapabilities: we get the element types that support selection
       * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
       * and `selectionEnd` rows.
       */

      function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
      }
      function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
          // Used by Flare
          activeElementDetached: null,
          focusedElem: focusedElem,
          selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
      }
      /**
       * @restoreSelection: If any selection information was potentially lost,
       * restore it. This is useful when performing operations that could remove dom
       * nodes and place them back in, resulting in focus being lost.
       */

      function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
          if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) {
            setSelection(priorFocusedElem, priorSelectionRange);
          } // Focusing a node can change the scroll position, which is undesirable

          var ancestors = [];
          var ancestor = priorFocusedElem;
          while (ancestor = ancestor.parentNode) {
            if (ancestor.nodeType === ELEMENT_NODE) {
              ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
              });
            }
          }
          if (typeof priorFocusedElem.focus === 'function') {
            priorFocusedElem.focus();
          }
          for (var i = 0; i < ancestors.length; i++) {
            var info = ancestors[i];
            info.element.scrollLeft = info.left;
            info.element.scrollTop = info.top;
          }
        }
      }
      /**
       * @getSelection: Gets the selection bounds of a focused textarea, input or
       * contentEditable node.
       * -@input: Look up selection bounds of this input
       * -@return {start: selectionStart, end: selectionEnd}
       */

      function getSelection(input) {
        var selection;
        if ('selectionStart' in input) {
          // Modern browser with input or textarea.
          selection = {
            start: input.selectionStart,
            end: input.selectionEnd
          };
        } else {
          // Content editable or old IE textarea.
          selection = getOffsets(input);
        }
        return selection || {
          start: 0,
          end: 0
        };
      }
      /**
       * @setSelection: Sets the selection bounds of a textarea or input and focuses
       * the input.
       * -@input     Set selection bounds of this input or textarea
       * -@offsets   Object of same form that is returned from get*
       */

      function setSelection(input, offsets) {
        var start = offsets.start,
          end = offsets.end;
        if (end === undefined) {
          end = start;
        }
        if ('selectionStart' in input) {
          input.selectionStart = start;
          input.selectionEnd = Math.min(end, input.value.length);
        } else {
          setOffsets(input, offsets);
        }
      }
      var validateDOMNesting = function validateDOMNesting() {};
      var updatedAncestorInfo = function updatedAncestorInfo() {};
      {
        // This validation code was written based on the HTML5 parsing spec:
        // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
        //
        // Note: this does not catch all invalid nesting, nor does it try to (as it's
        // not clear what practical benefit doing so provides); instead, we warn only
        // for cases where the parser will give a parse tree differing from what React
        // intended. For example, <b><div></div></b> is invalid but we don't warn
        // because it still parses correctly; we do warn for other cases like nested
        // <p> tags where the beginning of the second element implicitly closes the
        // first, causing a confusing mess.
        // https://html.spec.whatwg.org/multipage/syntax.html#special
        var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope

        var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject', 'desc', 'title']; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope

        var buttonScopeTags = inScopeTags.concat(['button']); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags

        var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
        var emptyAncestorInfo = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
        updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
          var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
          var info = {
            tag: tag
          };
          if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
          }
          if (buttonScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.pTagInButtonScope = null;
          } // See rules for 'li', 'dd', 'dt' start tags in
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody

          if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
          }
          ancestorInfo.current = info;
          if (tag === 'form') {
            ancestorInfo.formTag = info;
          }
          if (tag === 'a') {
            ancestorInfo.aTagInScope = info;
          }
          if (tag === 'button') {
            ancestorInfo.buttonTagInScope = info;
          }
          if (tag === 'nobr') {
            ancestorInfo.nobrTagInScope = info;
          }
          if (tag === 'p') {
            ancestorInfo.pTagInButtonScope = info;
          }
          if (tag === 'li') {
            ancestorInfo.listItemTagAutoclosing = info;
          }
          if (tag === 'dd' || tag === 'dt') {
            ancestorInfo.dlItemTagAutoclosing = info;
          }
          return ancestorInfo;
        };
        /**
         * Returns whether
         */

        var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
          // First, let's check if we're in an unusual parsing mode...
          switch (parentTag) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
              return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
              return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but

            case 'option':
              return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr

            case 'tr':
              return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody

            case 'tbody':
            case 'thead':
            case 'tfoot':
              return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup

            case 'colgroup':
              return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable

            case 'table':
              return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead

            case 'head':
              return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element

            case 'html':
              return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
              return tag === 'frame';
            case '#document':
              return tag === 'html';
          } // Probably in the "in body" parsing mode, so we outlaw only tag combos
          // where the parsing rules cause implicit opens or closes to be added.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody

          switch (tag) {
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
              return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
              // These tags are only valid with a few parents that have special child
              // parsing rules -- if we're down here, then none of those matched and
              // so we allow it only if we don't know what the parent is, as all other
              // cases are invalid.
              return parentTag == null;
          }
          return true;
        };
        /**
         * Returns whether
         */

        var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
          switch (tag) {
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
              return ancestorInfo.pTagInButtonScope;
            case 'form':
              return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
              return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
              return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
              return ancestorInfo.buttonTagInScope;
            case 'a':
              // Spec says something about storing a list of markers, but it sounds
              // equivalent to this check.
              return ancestorInfo.aTagInScope;
            case 'nobr':
              return ancestorInfo.nobrTagInScope;
          }
          return null;
        };
        var didWarn$1 = {};
        validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
          ancestorInfo = ancestorInfo || emptyAncestorInfo;
          var parentInfo = ancestorInfo.current;
          var parentTag = parentInfo && parentInfo.tag;
          if (childText != null) {
            if (childTag != null) {
              error('validateDOMNesting: when childText is passed, childTag should be null');
            }
            childTag = '#text';
          }
          var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
          var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
          var invalidParentOrAncestor = invalidParent || invalidAncestor;
          if (!invalidParentOrAncestor) {
            return;
          }
          var ancestorTag = invalidParentOrAncestor.tag;
          var addendum = getCurrentFiberStackInDev();
          var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + addendum;
          if (didWarn$1[warnKey]) {
            return;
          }
          didWarn$1[warnKey] = true;
          var tagDisplayName = childTag;
          var whitespaceInfo = '';
          if (childTag === '#text') {
            if (/\S/.test(childText)) {
              tagDisplayName = 'Text nodes';
            } else {
              tagDisplayName = 'Whitespace text nodes';
              whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
            }
          } else {
            tagDisplayName = '<' + childTag + '>';
          }
          if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') {
              info += ' Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by ' + 'the browser.';
            }
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
          } else {
            error('validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>.', tagDisplayName, ancestorTag);
          }
        };
      }
      var SUPPRESS_HYDRATION_WARNING$1;
      {
        SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
      }
      var SUSPENSE_START_DATA = '$';
      var SUSPENSE_END_DATA = '/$';
      var SUSPENSE_PENDING_START_DATA = '$?';
      var SUSPENSE_FALLBACK_START_DATA = '$!';
      var STYLE$1 = 'style';
      var eventsEnabled = null;
      var selectionInformation = null;
      function shouldAutoFocusHostComponent(type, props) {
        switch (type) {
          case 'button':
          case 'input':
          case 'select':
          case 'textarea':
            return !!props.autoFocus;
        }
        return false;
      }
      function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch (nodeType) {
          case DOCUMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            {
              type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
              var root = rootContainerInstance.documentElement;
              namespace = root ? root.namespaceURI : getChildNamespace(null, '');
              break;
            }
          default:
            {
              var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
              var ownNamespace = container.namespaceURI || null;
              type = container.tagName;
              namespace = getChildNamespace(ownNamespace, type);
              break;
            }
        }
        {
          var validatedTag = type.toLowerCase();
          var ancestorInfo = updatedAncestorInfo(null, validatedTag);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }
      function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        {
          var parentHostContextDev = parentHostContext;
          var namespace = getChildNamespace(parentHostContextDev.namespace, type);
          var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
          return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
          };
        }
      }
      function getPublicInstance(instance) {
        return instance;
      }
      function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        setEnabled(false);
      }
      function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
      }
      function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        {
          // TODO: take namespace into account when validating.
          var hostContextDev = hostContext;
          validateDOMNesting(type, null, hostContextDev.ancestorInfo);
          if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
          parentNamespace = hostContextDev.namespace;
        }
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
      }
      function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }
      function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
      }
      function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        {
          var hostContextDev = hostContext;
          if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
          }
        }
        return diffProperties(domElement, type, oldProps, newProps, rootContainerInstance);
      }
      function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
      }
      function shouldDeprioritizeSubtree(type, props) {
        return !!props.hidden;
      }
      function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        {
          var hostContextDev = hostContext;
          validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        }
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
      }
      // if a component just imports ReactDOM (e.g. for findDOMNode).
      // Some environments might not have setTimeout or clearTimeout.

      var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
      var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
      var noTimeout = -1; // -------------------
      function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) {
          domElement.focus();
        }
      }
      function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.

        updateProperties(domElement, updatePayload, type, oldProps, newProps);
      }
      function resetTextContent(domElement) {
        setTextContent(domElement, '');
      }
      function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
      }
      function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
      }
      function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
          parentNode = container.parentNode;
          parentNode.insertBefore(child, container);
        } else {
          parentNode = container;
          parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918

        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) {
          // TODO: This cast may not be sound for SVG, MathML or custom elements.
          trapClickOnNonInteractiveElement(parentNode);
        }
      }
      function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
      }
      function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.insertBefore(child, beforeChild);
        } else {
          container.insertBefore(child, beforeChild);
        }
      }
      function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
      }
      function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) {
          container.parentNode.removeChild(child);
        } else {
          container.removeChild(child);
        }
      }
      function hideInstance(instance) {
        // pass host context to this method?

        instance = instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') {
          style.setProperty('display', 'none', 'important');
        } else {
          style.display = 'none';
        }
      }
      function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
      }
      function unhideInstance(instance, props) {
        instance = instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
      }
      function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
      } // -------------------
      function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) {
          return null;
        } // This has now been refined to an element node.

        return instance;
      }
      function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) {
          // Empty strings are not parsed by HTML so there won't be a correct match here.
          return null;
        } // This has now been refined to a text node.

        return instance;
      }
      function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
      }
      function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
      }
      function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for (; node != null; node = node.nextSibling) {
          var nodeType = node.nodeType;
          if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) {
            break;
          }
        }
        return node;
      }
      function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
      }
      function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
      }
      function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.

        updateFiberProps(instance, props);
        var parentNamespace;
        {
          var hostContextDev = hostContext;
          parentNamespace = hostContextDev.namespace;
        }
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance);
      }
      function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
      }
      function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.

        var depth = 0;
        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;
            if (data === SUSPENSE_END_DATA) {
              if (depth === 0) {
                return getNextHydratableSibling(node);
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              depth++;
            }
          }
          node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.

        return null;
      } // Returns the SuspenseInstance if this node is a direct child of a
      // SuspenseInstance. I.e. if its previous sibling is a Comment with
      // SUSPENSE_x_START_DATA. Otherwise, null.

      function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.

        var depth = 0;
        while (node) {
          if (node.nodeType === COMMENT_NODE) {
            var data = node.data;
            if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
              if (depth === 0) {
                return node;
              } else {
                depth--;
              }
            } else if (data === SUSPENSE_END_DATA) {
              depth++;
            }
          }
          node = node.previousSibling;
        }
        return null;
      }
      function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
      }
      function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
      }
      function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        {
          warnForUnmatchedText(textInstance, text);
        }
      }
      function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForUnmatchedText(textInstance, text);
        }
      }
      function didNotHydrateContainerInstance(parentContainer, instance) {
        {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentContainer, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentContainer, instance);
          }
        }
      }
      function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          if (instance.nodeType === ELEMENT_NODE) {
            warnForDeletedHydratableElement(parentInstance, instance);
          } else if (instance.nodeType === COMMENT_NODE) ;else {
            warnForDeletedHydratableText(parentInstance, instance);
          }
        }
      }
      function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        {
          warnForInsertedHydratedElement(parentContainer, type);
        }
      }
      function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        {
          warnForInsertedHydratedText(parentContainer, text);
        }
      }
      function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForInsertedHydratedElement(parentInstance, type);
        }
      }
      function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
          warnForInsertedHydratedText(parentInstance, text);
        }
      }
      function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) ;
      }
      var randomKey = Math.random().toString(36).slice(2);
      var internalInstanceKey = '__reactInternalInstance$' + randomKey;
      var internalEventHandlersKey = '__reactEventHandlers$' + randomKey;
      var internalContainerInstanceKey = '__reactContainere$' + randomKey;
      function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
      }
      function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
      }
      function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
      }
      function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
      } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
      // If the target node is part of a hydrated or not yet rendered subtree, then
      // this may also return a SuspenseComponent or HostRoot to indicate that.
      // Conceptually the HostRoot fiber is a child of the Container node. So if you
      // pass the Container node as the targetNode, you will not actually get the
      // HostRoot back. To get to the HostRoot, you need to pass a child of it.
      // The same thing applies to Suspense boundaries.

      function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) {
          // Don't return HostRoot or SuspenseComponent here.
          return targetInst;
        } // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.

        var parentNode = targetNode.parentNode;
        while (parentNode) {
          // We'll check if this is a container root that could include
          // React nodes in the future. We need to check this first because
          // if we're a child of a dehydrated container, we need to first
          // find that inner container before moving on to finding the parent
          // instance. Note that we don't check this field on  the targetNode
          // itself because the fibers are conceptually between the container
          // node and the first child. It isn't surrounding the container node.
          // If it's not a container, we check if it's an instance.
          targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
          if (targetInst) {
            // Since this wasn't the direct target of the event, we might have
            // stepped past dehydrated DOM nodes to get here. However they could
            // also have been non-React nodes. We need to answer which one.
            // If we the instance doesn't have any children, then there can't be
            // a nested suspense boundary within it. So we can use this as a fast
            // bailout. Most of the time, when people add non-React children to
            // the tree, it is using a ref to a child-less DOM node.
            // Normally we'd only need to check one of the fibers because if it
            // has ever gone from having children to deleting them or vice versa
            // it would have deleted the dehydrated boundary nested inside already.
            // However, since the HostRoot starts out with an alternate it might
            // have one on the alternate so we need to check in case this was a
            // root.
            var alternate = targetInst.alternate;
            if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
              // Next we need to figure out if the node that skipped past is
              // nested within a dehydrated boundary and if so, which one.
              var suspenseInstance = getParentSuspenseInstance(targetNode);
              while (suspenseInstance !== null) {
                // We found a suspense instance. That means that we haven't
                // hydrated it yet. Even though we leave the comments in the
                // DOM after hydrating, and there are boundaries in the DOM
                // that could already be hydrated, we wouldn't have found them
                // through this pass since if the target is hydrated it would
                // have had an internalInstanceKey on it.
                // Let's get the fiber associated with the SuspenseComponent
                // as the deepest instance.
                var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                if (targetSuspenseInst) {
                  return targetSuspenseInst;
                } // If we don't find a Fiber on the comment, it might be because
                // we haven't gotten to hydrate it yet. There might still be a
                // parent boundary that hasn't above this one so we need to find
                // the outer most that is known.

                suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                // host component also hasn't hydrated yet. We can return it
                // below since it will bail out on the isMounted check later.
              }
            }

            return targetInst;
          }
          targetNode = parentNode;
          parentNode = targetNode.parentNode;
        }
        return null;
      }
      /**
       * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
       * instance, or null if the node was not rendered by this React.
       */

      function getInstanceFromNode$1(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
          if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) {
            return inst;
          } else {
            return null;
          }
        }
        return null;
      }
      /**
       * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
       * DOM node.
       */

      function getNodeFromInstance$1(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) {
          // In Fiber this, is just the state node right now. We assume it will be
          // a host component or host text.
          return inst.stateNode;
        } // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.

        {
          {
            throw Error("getNodeFromInstance: Invalid argument.");
          }
        }
      }
      function getFiberCurrentPropsFromNode$1(node) {
        return node[internalEventHandlersKey] || null;
      }
      function updateFiberProps(node, props) {
        node[internalEventHandlersKey] = props;
      }
      function getParent(inst) {
        do {
          inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
          // That is depending on if we want nested subtrees (layers) to bubble
          // events to their parent. We could also go through parentNode on the
          // host node but that wouldn't work for React Native and doesn't let us
          // do the portal feature.
        } while (inst && inst.tag !== HostComponent);
        if (inst) {
          return inst;
        }
        return null;
      }
      /**
       * Return the lowest common ancestor of A and B, or null if they are in
       * different trees.
       */

      function getLowestCommonAncestor(instA, instB) {
        var depthA = 0;
        for (var tempA = instA; tempA; tempA = getParent(tempA)) {
          depthA++;
        }
        var depthB = 0;
        for (var tempB = instB; tempB; tempB = getParent(tempB)) {
          depthB++;
        } // If A is deeper, crawl up.

        while (depthA - depthB > 0) {
          instA = getParent(instA);
          depthA--;
        } // If B is deeper, crawl up.

        while (depthB - depthA > 0) {
          instB = getParent(instB);
          depthB--;
        } // Walk in lockstep until we find a match.

        var depth = depthA;
        while (depth--) {
          if (instA === instB || instA === instB.alternate) {
            return instA;
          }
          instA = getParent(instA);
          instB = getParent(instB);
        }
        return null;
      }
      /**
       * Simulates the traversal of a two-phase, capture/bubble event dispatch.
       */

      function traverseTwoPhase(inst, fn, arg) {
        var path = [];
        while (inst) {
          path.push(inst);
          inst = getParent(inst);
        }
        var i;
        for (i = path.length; i-- > 0;) {
          fn(path[i], 'captured', arg);
        }
        for (i = 0; i < path.length; i++) {
          fn(path[i], 'bubbled', arg);
        }
      }
      /**
       * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
       * should would receive a `mouseEnter` or `mouseLeave` event.
       *
       * Does not invoke the callback on the nearest common ancestor because nothing
       * "entered" or "left" that element.
       */

      function traverseEnterLeave(from, to, fn, argFrom, argTo) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        var pathFrom = [];
        while (true) {
          if (!from) {
            break;
          }
          if (from === common) {
            break;
          }
          var alternate = from.alternate;
          if (alternate !== null && alternate === common) {
            break;
          }
          pathFrom.push(from);
          from = getParent(from);
        }
        var pathTo = [];
        while (true) {
          if (!to) {
            break;
          }
          if (to === common) {
            break;
          }
          var _alternate = to.alternate;
          if (_alternate !== null && _alternate === common) {
            break;
          }
          pathTo.push(to);
          to = getParent(to);
        }
        for (var i = 0; i < pathFrom.length; i++) {
          fn(pathFrom[i], 'bubbled', argFrom);
        }
        for (var _i = pathTo.length; _i-- > 0;) {
          fn(pathTo[_i], 'captured', argTo);
        }
      }
      function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
      }
      function shouldPreventMouseEvent(name, type, props) {
        switch (name) {
          case 'onClick':
          case 'onClickCapture':
          case 'onDoubleClick':
          case 'onDoubleClickCapture':
          case 'onMouseDown':
          case 'onMouseDownCapture':
          case 'onMouseMove':
          case 'onMouseMoveCapture':
          case 'onMouseUp':
          case 'onMouseUpCapture':
          case 'onMouseEnter':
            return !!(props.disabled && isInteractive(type));
          default:
            return false;
        }
      }
      /**
       * @param {object} inst The instance, which is the source of events.
       * @param {string} registrationName Name of listener (e.g. `onClick`).
       * @return {?function} The stored callback.
       */

      function getListener(inst, registrationName) {
        var listener; // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
        // live here; needs to be moved to a better place soon

        var stateNode = inst.stateNode;
        if (!stateNode) {
          // Work in progress (ex: onload events in incremental mode).
          return null;
        }
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (!props) {
          // Work in progress.
          return null;
        }
        listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) {
          return null;
        }
        if (!(!listener || typeof listener === 'function')) {
          {
            throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
          }
        }
        return listener;
      }

      /**
       * Some event types have a notion of different registration names for different
       * "phases" of propagation. This finds listeners by a given phase.
       */
      function listenerAtPhase(inst, event, propagationPhase) {
        var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
        return getListener(inst, registrationName);
      }
      /**
       * A small set of propagation patterns, each of which will accept a small amount
       * of information, and generate a set of "dispatch ready event objects" - which
       * are sets of events that have already been annotated with a set of dispatched
       * listener functions/ids. The API is designed this way to discourage these
       * propagation strategies from actually executing the dispatches, since we
       * always want to collect the entire set of dispatches before executing even a
       * single one.
       */

      /**
       * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
       * here, allows us to not have to bind or create functions for each event.
       * Mutating the event's members allows us to not have to create a wrapping
       * "dispatch" object that pairs the event with the listener.
       */

      function accumulateDirectionalDispatches(inst, phase, event) {
        {
          if (!inst) {
            error('Dispatching inst must not be null');
          }
        }
        var listener = listenerAtPhase(inst, event, phase);
        if (listener) {
          event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
          event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
        }
      }
      /**
       * Collect dispatches (must be entirely collected before dispatching - see unit
       * tests). Lazily allocate the array to conserve memory.  We must loop through
       * each event and perform the traversal for each one. We cannot perform a
       * single traversal for the entire collection of events because each event may
       * have a different target.
       */

      function accumulateTwoPhaseDispatchesSingle(event) {
        if (event && event.dispatchConfig.phasedRegistrationNames) {
          traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
        }
      }
      /**
       * Accumulates without regard to direction, does not look for phased
       * registration names. Same as `accumulateDirectDispatchesSingle` but without
       * requiring that the `dispatchMarker` be the same as the dispatched ID.
       */

      function accumulateDispatches(inst, ignoredDirection, event) {
        if (inst && event && event.dispatchConfig.registrationName) {
          var registrationName = event.dispatchConfig.registrationName;
          var listener = getListener(inst, registrationName);
          if (listener) {
            event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
            event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
          }
        }
      }
      /**
       * Accumulates dispatches on an `SyntheticEvent`, but only for the
       * `dispatchMarker`.
       * @param {SyntheticEvent} event
       */

      function accumulateDirectDispatchesSingle(event) {
        if (event && event.dispatchConfig.registrationName) {
          accumulateDispatches(event._targetInst, null, event);
        }
      }
      function accumulateTwoPhaseDispatches(events) {
        forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
      }
      function accumulateEnterLeaveDispatches(leave, enter, from, to) {
        traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
      }
      function accumulateDirectDispatches(events) {
        forEachAccumulated(events, accumulateDirectDispatchesSingle);
      }

      /**
       * These variables store information about text content of a target node,
       * allowing comparison of content before and after a given event.
       *
       * Identify the node where selection currently begins, then observe
       * both its text content and its current position in the DOM. Since the
       * browser may natively replace the target node during composition, we can
       * use its position to find its replacement.
       *
       *
       */
      var root = null;
      var startText = null;
      var fallbackText = null;
      function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
      }
      function reset() {
        root = null;
        startText = null;
        fallbackText = null;
      }
      function getData() {
        if (fallbackText) {
          return fallbackText;
        }
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for (start = 0; start < startLength; start++) {
          if (startValue[start] !== endValue[start]) {
            break;
          }
        }
        var minEnd = startLength - start;
        for (end = 1; end <= minEnd; end++) {
          if (startValue[startLength - end] !== endValue[endLength - end]) {
            break;
          }
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
      }
      function getText() {
        if ('value' in root) {
          return root.value;
        }
        return root.textContent;
      }
      var EVENT_POOL_SIZE = 10;
      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var EventInterface = {
        type: null,
        target: null,
        // currentTarget is set when dispatching; no use in copying it here
        currentTarget: function currentTarget() {
          return null;
        },
        eventPhase: null,
        bubbles: null,
        cancelable: null,
        timeStamp: function timeStamp(event) {
          return event.timeStamp || Date.now();
        },
        defaultPrevented: null,
        isTrusted: null
      };
      function functionThatReturnsTrue() {
        return true;
      }
      function functionThatReturnsFalse() {
        return false;
      }
      /**
       * Synthetic events are dispatched by event plugins, typically in response to a
       * top-level event delegation handler.
       *
       * These systems should generally use pooling to reduce the frequency of garbage
       * collection. The system should check `isPersistent` to determine whether the
       * event should be released into the pool after being dispatched. Users that
       * need a persisted event should invoke `persist`.
       *
       * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
       * normalizing browser quirks. Subclasses do not necessarily have to implement a
       * DOM interface; custom application-specific events can also subclass this.
       *
       * @param {object} dispatchConfig Configuration used to dispatch this event.
       * @param {*} targetInst Marker identifying the event target.
       * @param {object} nativeEvent Native browser event.
       * @param {DOMEventTarget} nativeEventTarget Target node.
       */

      function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
        {
          // these have a getter/setter for warnings
          delete this.nativeEvent;
          delete this.preventDefault;
          delete this.stopPropagation;
          delete this.isDefaultPrevented;
          delete this.isPropagationStopped;
        }
        this.dispatchConfig = dispatchConfig;
        this._targetInst = targetInst;
        this.nativeEvent = nativeEvent;
        var Interface = this.constructor.Interface;
        for (var propName in Interface) {
          if (!Interface.hasOwnProperty(propName)) {
            continue;
          }
          {
            delete this[propName]; // this has a getter/setter for warnings
          }

          var normalize = Interface[propName];
          if (normalize) {
            this[propName] = normalize(nativeEvent);
          } else {
            if (propName === 'target') {
              this.target = nativeEventTarget;
            } else {
              this[propName] = nativeEvent[propName];
            }
          }
        }
        var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
        if (defaultPrevented) {
          this.isDefaultPrevented = functionThatReturnsTrue;
        } else {
          this.isDefaultPrevented = functionThatReturnsFalse;
        }
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
      }
      _assign(SyntheticEvent.prototype, {
        preventDefault: function preventDefault() {
          this.defaultPrevented = true;
          var event = this.nativeEvent;
          if (!event) {
            return;
          }
          if (event.preventDefault) {
            event.preventDefault();
          } else if (typeof event.returnValue !== 'unknown') {
            event.returnValue = false;
          }
          this.isDefaultPrevented = functionThatReturnsTrue;
        },
        stopPropagation: function stopPropagation() {
          var event = this.nativeEvent;
          if (!event) {
            return;
          }
          if (event.stopPropagation) {
            event.stopPropagation();
          } else if (typeof event.cancelBubble !== 'unknown') {
            // The ChangeEventPlugin registers a "propertychange" event for
            // IE. This event does not support bubbling or cancelling, and
            // any references to cancelBubble throw "Member not found".  A
            // typeof check of "unknown" circumvents this issue (and is also
            // IE specific).
            event.cancelBubble = true;
          }
          this.isPropagationStopped = functionThatReturnsTrue;
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function persist() {
          this.isPersistent = functionThatReturnsTrue;
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: functionThatReturnsFalse,
        /**
         * `PooledClass` looks for `destructor` on each instance it releases.
         */
        destructor: function destructor() {
          var Interface = this.constructor.Interface;
          for (var propName in Interface) {
            {
              Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
            }
          }
          this.dispatchConfig = null;
          this._targetInst = null;
          this.nativeEvent = null;
          this.isDefaultPrevented = functionThatReturnsFalse;
          this.isPropagationStopped = functionThatReturnsFalse;
          this._dispatchListeners = null;
          this._dispatchInstances = null;
          {
            Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
            Object.defineProperty(this, 'isDefaultPrevented', getPooledWarningPropertyDefinition('isDefaultPrevented', functionThatReturnsFalse));
            Object.defineProperty(this, 'isPropagationStopped', getPooledWarningPropertyDefinition('isPropagationStopped', functionThatReturnsFalse));
            Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', function () {}));
            Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', function () {}));
          }
        }
      });
      SyntheticEvent.Interface = EventInterface;
      /**
       * Helper to reduce boilerplate when creating subclasses.
       */

      SyntheticEvent.extend = function (Interface) {
        var Super = this;
        var E = function E() {};
        E.prototype = Super.prototype;
        var prototype = new E();
        function Class() {
          return Super.apply(this, arguments);
        }
        _assign(prototype, Class.prototype);
        Class.prototype = prototype;
        Class.prototype.constructor = Class;
        Class.Interface = _assign({}, Super.Interface, Interface);
        Class.extend = Super.extend;
        addEventPoolingTo(Class);
        return Class;
      };
      addEventPoolingTo(SyntheticEvent);
      /**
       * Helper to nullify syntheticEvent instance properties when destructing
       *
       * @param {String} propName
       * @param {?object} getVal
       * @return {object} defineProperty object
       */

      function getPooledWarningPropertyDefinition(propName, getVal) {
        var isFunction = typeof getVal === 'function';
        return {
          configurable: true,
          set: set,
          get: get
        };
        function set(val) {
          var action = isFunction ? 'setting the method' : 'setting the property';
          warn(action, 'This is effectively a no-op');
          return val;
        }
        function get() {
          var action = isFunction ? 'accessing the method' : 'accessing the property';
          var result = isFunction ? 'This is a no-op function' : 'This is set to null';
          warn(action, result);
          return getVal;
        }
        function warn(action, result) {
          {
            error("This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result);
          }
        }
      }
      function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
        var EventConstructor = this;
        if (EventConstructor.eventPool.length) {
          var instance = EventConstructor.eventPool.pop();
          EventConstructor.call(instance, dispatchConfig, targetInst, nativeEvent, nativeInst);
          return instance;
        }
        return new EventConstructor(dispatchConfig, targetInst, nativeEvent, nativeInst);
      }
      function releasePooledEvent(event) {
        var EventConstructor = this;
        if (!(event instanceof EventConstructor)) {
          {
            throw Error("Trying to release an event instance into a pool of a different type.");
          }
        }
        event.destructor();
        if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
          EventConstructor.eventPool.push(event);
        }
      }
      function addEventPoolingTo(EventConstructor) {
        EventConstructor.eventPool = [];
        EventConstructor.getPooled = getPooledEvent;
        EventConstructor.release = releasePooledEvent;
      }

      /**
       * @interface Event
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
       */

      var SyntheticCompositionEvent = SyntheticEvent.extend({
        data: null
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
       *      /#events-inputevents
       */

      var SyntheticInputEvent = SyntheticEvent.extend({
        data: null
      });
      var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space

      var START_KEYCODE = 229;
      var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
      var documentMode = null;
      if (canUseDOM && 'documentMode' in document) {
        documentMode = document.documentMode;
      } // Webkit offers a very useful `textInput` event that can be used to
      // directly represent `beforeInput`. The IE `textinput` event is not as
      // useful, so we don't use it.

      var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
      // by the native compositionend event may be incorrect. Japanese ideographic
      // spaces, for instance (\u3000) are not recorded correctly.

      var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
      var SPACEBAR_CODE = 32;
      var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE); // Events and their corresponding property names.

      var eventTypes = {
        beforeInput: {
          phasedRegistrationNames: {
            bubbled: 'onBeforeInput',
            captured: 'onBeforeInputCapture'
          },
          dependencies: [TOP_COMPOSITION_END, TOP_KEY_PRESS, TOP_TEXT_INPUT, TOP_PASTE]
        },
        compositionEnd: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionEnd',
            captured: 'onCompositionEndCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_END, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        },
        compositionStart: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionStart',
            captured: 'onCompositionStartCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_START, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        },
        compositionUpdate: {
          phasedRegistrationNames: {
            bubbled: 'onCompositionUpdate',
            captured: 'onCompositionUpdateCapture'
          },
          dependencies: [TOP_BLUR, TOP_COMPOSITION_UPDATE, TOP_KEY_DOWN, TOP_KEY_PRESS, TOP_KEY_UP, TOP_MOUSE_DOWN]
        }
      }; // Track whether we've ever handled a keypress on the space key.

      var hasSpaceKeypress = false;
      /**
       * Return whether a native keypress event is assumed to be a command.
       * This is required because Firefox fires `keypress` events for key commands
       * (cut, copy, select-all, etc.) even though no character is inserted.
       */

      function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
        // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
      }
      /**
       * Translate native top level events into event types.
       *
       * @param {string} topLevelType
       * @return {object}
       */

      function getCompositionEventType(topLevelType) {
        switch (topLevelType) {
          case TOP_COMPOSITION_START:
            return eventTypes.compositionStart;
          case TOP_COMPOSITION_END:
            return eventTypes.compositionEnd;
          case TOP_COMPOSITION_UPDATE:
            return eventTypes.compositionUpdate;
        }
      }
      /**
       * Does our fallback best-guess model think this event signifies that
       * composition has begun?
       *
       * @param {string} topLevelType
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isFallbackCompositionStart(topLevelType, nativeEvent) {
        return topLevelType === TOP_KEY_DOWN && nativeEvent.keyCode === START_KEYCODE;
      }
      /**
       * Does our fallback mode think that this event is the end of composition?
       *
       * @param {string} topLevelType
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isFallbackCompositionEnd(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_KEY_UP:
            // Command keys insert or clear IME input.
            return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
          case TOP_KEY_DOWN:
            // Expect IME keyCode on each keydown. If we get any other
            // code we must have exited earlier.
            return nativeEvent.keyCode !== START_KEYCODE;
          case TOP_KEY_PRESS:
          case TOP_MOUSE_DOWN:
          case TOP_BLUR:
            // Events are not possible without cancelling IME.
            return true;
          default:
            return false;
        }
      }
      /**
       * Google Input Tools provides composition data via a CustomEvent,
       * with the `data` property populated in the `detail` object. If this
       * is available on the event object, use it. If not, this is a plain
       * composition event and we have nothing special to extract.
       *
       * @param {object} nativeEvent
       * @return {?string}
       */

      function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) {
          return detail.data;
        }
        return null;
      }
      /**
       * Check if a composition event was triggered by Korean IME.
       * Our fallback mode does not work well with IE's Korean IME,
       * so just use native composition events when Korean IME is used.
       * Although CompositionEvent.locale property is deprecated,
       * it is available in IE, where our fallback mode is enabled.
       *
       * @param {object} nativeEvent
       * @return {boolean}
       */

      function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
      } // Track the current IME composition status, if any.

      var isComposing = false;
      /**
       * @return {?object} A SyntheticCompositionEvent.
       */

      function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) {
          eventType = getCompositionEventType(topLevelType);
        } else if (!isComposing) {
          if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
            eventType = eventTypes.compositionStart;
          }
        } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
          eventType = eventTypes.compositionEnd;
        }
        if (!eventType) {
          return null;
        }
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
          // The current composition is stored statically and must not be
          // overwritten while composition continues.
          if (!isComposing && eventType === eventTypes.compositionStart) {
            isComposing = initialize(nativeEventTarget);
          } else if (eventType === eventTypes.compositionEnd) {
            if (isComposing) {
              fallbackData = getData();
            }
          }
        }
        var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
        if (fallbackData) {
          // Inject data generated from fallback path into the synthetic event.
          // This matches the property of native CompositionEventInterface.
          event.data = fallbackData;
        } else {
          var customData = getDataFromCustomEvent(nativeEvent);
          if (customData !== null) {
            event.data = customData;
          }
        }
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * @param {TopLevelType} topLevelType Number from `TopLevelType`.
       * @param {object} nativeEvent Native browser event.
       * @return {?string} The string corresponding to this `beforeInput` event.
       */

      function getNativeBeforeInputChars(topLevelType, nativeEvent) {
        switch (topLevelType) {
          case TOP_COMPOSITION_END:
            return getDataFromCustomEvent(nativeEvent);
          case TOP_KEY_PRESS:
            /**
             * If native `textInput` events are available, our goal is to make
             * use of them. However, there is a special case: the spacebar key.
             * In Webkit, preventing default on a spacebar `textInput` event
             * cancels character insertion, but it *also* causes the browser
             * to fall back to its default spacebar behavior of scrolling the
             * page.
             *
             * Tracking at:
             * https://code.google.com/p/chromium/issues/detail?id=355103
             *
             * To avoid this issue, use the keypress event as if no `textInput`
             * event is available.
             */
            var which = nativeEvent.which;
            if (which !== SPACEBAR_CODE) {
              return null;
            }
            hasSpaceKeypress = true;
            return SPACEBAR_CHAR;
          case TOP_TEXT_INPUT:
            // Record the characters to be added to the DOM.
            var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
            // it at the keypress level and bail immediately. Android Chrome
            // doesn't give us keycodes, so we need to ignore it.

            if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
              return null;
            }
            return chars;
          default:
            // For other native event types, do nothing.
            return null;
        }
      }
      /**
       * For browsers that do not provide the `textInput` event, extract the
       * appropriate string to use for SyntheticInputEvent.
       *
       * @param {number} topLevelType Number from `TopLevelEventTypes`.
       * @param {object} nativeEvent Native browser event.
       * @return {?string} The fallback string for this `beforeInput` event.
       */

      function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
          if (topLevelType === TOP_COMPOSITION_END || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
            var chars = getData();
            reset();
            isComposing = false;
            return chars;
          }
          return null;
        }
        switch (topLevelType) {
          case TOP_PASTE:
            // If a paste event occurs after a keypress, throw out the input
            // chars. Paste events should not lead to BeforeInput events.
            return null;
          case TOP_KEY_PRESS:
            /**
             * As of v27, Firefox may fire keypress events even when no character
             * will be inserted. A few possibilities:
             *
             * - `which` is `0`. Arrow keys, Esc key, etc.
             *
             * - `which` is the pressed key code, but no char is available.
             *   Ex: 'AltGr + d` in Polish. There is no modified character for
             *   this key combination and no character is inserted into the
             *   document, but FF fires the keypress for char code `100` anyway.
             *   No `input` event will occur.
             *
             * - `which` is the pressed key code, but a command combination is
             *   being used. Ex: `Cmd+C`. No character is inserted, and no
             *   `input` event will occur.
             */
            if (!isKeypressCommand(nativeEvent)) {
              // IE fires the `keypress` event when a user types an emoji via
              // Touch keyboard of Windows.  In such a case, the `char` property
              // holds an emoji character like `\uD83D\uDE0A`.  Because its length
              // is 2, the property `which` does not represent an emoji correctly.
              // In such a case, we directly return the `char` property instead of
              // using `which`.
              if (nativeEvent.char && nativeEvent.char.length > 1) {
                return nativeEvent.char;
              } else if (nativeEvent.which) {
                return String.fromCharCode(nativeEvent.which);
              }
            }
            return null;
          case TOP_COMPOSITION_END:
            return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
          default:
            return null;
        }
      }
      /**
       * Extract a SyntheticInputEvent for `beforeInput`, based on either native
       * `textInput` or fallback behavior.
       *
       * @return {?object} A SyntheticInputEvent.
       */

      function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) {
          chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
        } else {
          chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
        } // If no characters are being inserted, no BeforeInput event should
        // be fired.

        if (!chars) {
          return null;
        }
        var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
        event.data = chars;
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * Create an `onBeforeInput` event to match
       * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
       *
       * This event plugin is based on the native `textInput` event
       * available in Chrome, Safari, Opera, and IE. This event fires after
       * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
       *
       * `beforeInput` is spec'd but not implemented in any browsers, and
       * the `input` event does not provide any useful information about what has
       * actually been added, contrary to the spec. Thus, `textInput` is the best
       * available event to identify the characters that have actually been inserted
       * into the target node.
       *
       * This plugin is also responsible for emitting `composition` events, thus
       * allowing us to share composition fallback code for both `beforeInput` and
       * `composition` event types.
       */

      var BeforeInputEventPlugin = {
        eventTypes: eventTypes,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var composition = extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
          var beforeInput = extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget);
          if (composition === null) {
            return beforeInput;
          }
          if (beforeInput === null) {
            return composition;
          }
          return [composition, beforeInput];
        }
      };

      /**
       * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
       */
      var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
      };
      function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') {
          return !!supportedInputTypes[elem.type];
        }
        if (nodeName === 'textarea') {
          return true;
        }
        return false;
      }
      var eventTypes$1 = {
        change: {
          phasedRegistrationNames: {
            bubbled: 'onChange',
            captured: 'onChangeCapture'
          },
          dependencies: [TOP_BLUR, TOP_CHANGE, TOP_CLICK, TOP_FOCUS, TOP_INPUT, TOP_KEY_DOWN, TOP_KEY_UP, TOP_SELECTION_CHANGE]
        }
      };
      function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
        var event = SyntheticEvent.getPooled(eventTypes$1.change, inst, nativeEvent, target);
        event.type = 'change'; // Flag this event loop as needing state restore.

        enqueueStateRestore(target);
        accumulateTwoPhaseDispatches(event);
        return event;
      }
      /**
       * For IE shims
       */

      var activeElement = null;
      var activeElementInst = null;
      /**
       * SECTION: handle `change` event
       */

      function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
      }
      function manualDispatchChangeEvent(nativeEvent) {
        var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.

        batchedUpdates(runEventInBatch, event);
      }
      function runEventInBatch(event) {
        runEventsInBatch(event);
      }
      function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance$1(targetInst);
        if (updateValueIfChanged(targetNode)) {
          return targetInst;
        }
      }
      function getTargetInstForChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CHANGE) {
          return targetInst;
        }
      }
      /**
       * SECTION: handle `input` event
       */

      var isInputEventSupported = false;
      if (canUseDOM) {
        // IE9 claims to support the input event but fails to trigger it when
        // deleting text, so we ignore its input events.
        isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
      }
      /**
       * (For IE <=9) Starts tracking propertychange events on the passed-in element
       * and override the value property so that we can distinguish user events from
       * value changes in JS.
       */

      function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
      }
      /**
       * (For IE <=9) Removes the event listeners from the currently-tracked element,
       * if any exists.
       */

      function stopWatchingForValueChange() {
        if (!activeElement) {
          return;
        }
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
      }
      /**
       * (For IE <=9) Handles a propertychange event, sending a `change` event if
       * the value of the active element has changed.
       */

      function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') {
          return;
        }
        if (getInstIfValueChanged(activeElementInst)) {
          manualDispatchChangeEvent(nativeEvent);
        }
      }
      function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
        if (topLevelType === TOP_FOCUS) {
          // In IE9, propertychange fires for most input events but is buggy and
          // doesn't fire when text is deleted, but conveniently, selectionchange
          // appears to fire in all of the remaining cases so we catch those and
          // forward the event if the value has changed
          // In either case, we don't want to call the event handler if the value
          // is changed from JS so we redefine a setter for `.value` that updates
          // our activeElementValue variable, allowing us to ignore those changes
          //
          // stopWatching() should be a noop here but we call it just in case we
          // missed a blur event somehow.
          stopWatchingForValueChange();
          startWatchingForValueChange(target, targetInst);
        } else if (topLevelType === TOP_BLUR) {
          stopWatchingForValueChange();
        }
      } // For IE8 and IE9.

      function getTargetInstForInputEventPolyfill(topLevelType, targetInst) {
        if (topLevelType === TOP_SELECTION_CHANGE || topLevelType === TOP_KEY_UP || topLevelType === TOP_KEY_DOWN) {
          // On the selectionchange event, the target is just document which isn't
          // helpful for us so just check activeElement instead.
          //
          // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
          // propertychange on the first input event after setting `value` from a
          // script and fires only keydown, keypress, keyup. Catching keyup usually
          // gets it and catching keydown lets us fire an event for the first
          // keystroke if user does a key repeat (it'll be a little delayed: right
          // before the second keystroke). Other input methods (e.g., paste) seem to
          // fire selectionchange normally.
          return getInstIfValueChanged(activeElementInst);
        }
      }
      /**
       * SECTION: handle `click` event
       */

      function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
      }
      function getTargetInstForClickEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_CLICK) {
          return getInstIfValueChanged(targetInst);
        }
      }
      function getTargetInstForInputOrChangeEvent(topLevelType, targetInst) {
        if (topLevelType === TOP_INPUT || topLevelType === TOP_CHANGE) {
          return getInstIfValueChanged(targetInst);
        }
      }
      function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') {
          return;
        }
        {
          // If controlled, assign the value attribute to the current value on blur
          setDefaultValue(node, 'number', node.value);
        }
      }
      /**
       * This plugin creates an `onChange` event that normalizes change events
       * across form elements. This event fires at a time when it's possible to
       * change the element's value without seeing a flicker.
       *
       * Supported elements are:
       * - input (see `isTextInputElement`)
       * - textarea
       * - select
       */

      var ChangeEventPlugin = {
        eventTypes: eventTypes$1,
        _isInputEventSupported: isInputEventSupported,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
          var getTargetInstFunc, handleEventFunc;
          if (shouldUseChangeEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForChangeEvent;
          } else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) {
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            } else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              handleEventFunc = handleEventsForInputEventPolyfill;
            }
          } else if (shouldUseClickEvent(targetNode)) {
            getTargetInstFunc = getTargetInstForClickEvent;
          }
          if (getTargetInstFunc) {
            var inst = getTargetInstFunc(topLevelType, targetInst);
            if (inst) {
              var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
              return event;
            }
          }
          if (handleEventFunc) {
            handleEventFunc(topLevelType, targetNode, targetInst);
          } // When blurring, set the value attribute for number inputs

          if (topLevelType === TOP_BLUR) {
            handleControlledInputBlur(targetNode);
          }
        }
      };
      var SyntheticUIEvent = SyntheticEvent.extend({
        view: null,
        detail: null
      });

      /**
       * Translation from modifier key to the associated property in the event.
       * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
       */
      var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
      }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
      // getModifierState. If getModifierState is not supported, we map it to a set of
      // modifier keys exposed by the event. In this case, Lock-keys are not supported.

      function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) {
          return nativeEvent.getModifierState(keyArg);
        }
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
      }
      function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
      }
      var previousScreenX = 0;
      var previousScreenY = 0; // Use flags to signal movementX/Y has already been set

      var isMovementXSet = false;
      var isMovementYSet = false;
      /**
       * @interface MouseEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticMouseEvent = SyntheticUIEvent.extend({
        screenX: null,
        screenY: null,
        clientX: null,
        clientY: null,
        pageX: null,
        pageY: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        getModifierState: getEventModifierState,
        button: null,
        buttons: null,
        relatedTarget: function relatedTarget(event) {
          return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
        },
        movementX: function movementX(event) {
          if ('movementX' in event) {
            return event.movementX;
          }
          var screenX = previousScreenX;
          previousScreenX = event.screenX;
          if (!isMovementXSet) {
            isMovementXSet = true;
            return 0;
          }
          return event.type === 'mousemove' ? event.screenX - screenX : 0;
        },
        movementY: function movementY(event) {
          if ('movementY' in event) {
            return event.movementY;
          }
          var screenY = previousScreenY;
          previousScreenY = event.screenY;
          if (!isMovementYSet) {
            isMovementYSet = true;
            return 0;
          }
          return event.type === 'mousemove' ? event.screenY - screenY : 0;
        }
      });

      /**
       * @interface PointerEvent
       * @see http://www.w3.org/TR/pointerevents/
       */

      var SyntheticPointerEvent = SyntheticMouseEvent.extend({
        pointerId: null,
        width: null,
        height: null,
        pressure: null,
        tangentialPressure: null,
        tiltX: null,
        tiltY: null,
        twist: null,
        pointerType: null,
        isPrimary: null
      });
      var eventTypes$2 = {
        mouseEnter: {
          registrationName: 'onMouseEnter',
          dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
        },
        mouseLeave: {
          registrationName: 'onMouseLeave',
          dependencies: [TOP_MOUSE_OUT, TOP_MOUSE_OVER]
        },
        pointerEnter: {
          registrationName: 'onPointerEnter',
          dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
        },
        pointerLeave: {
          registrationName: 'onPointerLeave',
          dependencies: [TOP_POINTER_OUT, TOP_POINTER_OVER]
        }
      };
      var EnterLeaveEventPlugin = {
        eventTypes: eventTypes$2,
        /**
         * For almost every interaction we care about, there will be both a top-level
         * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
         * we do not extract duplicate events. However, moving the mouse into the
         * browser from outside will not fire a `mouseout` event. In this case, we use
         * the `mouseover` top-level event.
         */
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var isOverEvent = topLevelType === TOP_MOUSE_OVER || topLevelType === TOP_POINTER_OVER;
          var isOutEvent = topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_POINTER_OUT;
          if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0 && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
            // If this is an over event with a target, then we've already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            return null;
          }
          if (!isOutEvent && !isOverEvent) {
            // Must not be a mouse or pointer in or out - ignoring.
            return null;
          }
          var win;
          if (nativeEventTarget.window === nativeEventTarget) {
            // `nativeEventTarget` is probably a window object.
            win = nativeEventTarget;
          } else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) {
              win = doc.defaultView || doc.parentWindow;
            } else {
              win = window;
            }
          }
          var from;
          var to;
          if (isOutEvent) {
            from = targetInst;
            var related = nativeEvent.relatedTarget || nativeEvent.toElement;
            to = related ? getClosestInstanceFromNode(related) : null;
            if (to !== null) {
              var nearestMounted = getNearestMountedFiber(to);
              if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) {
                to = null;
              }
            }
          } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
          }
          if (from === to) {
            // Nothing pertains to our managed components.
            return null;
          }
          var eventInterface, leaveEventType, enterEventType, eventTypePrefix;
          if (topLevelType === TOP_MOUSE_OUT || topLevelType === TOP_MOUSE_OVER) {
            eventInterface = SyntheticMouseEvent;
            leaveEventType = eventTypes$2.mouseLeave;
            enterEventType = eventTypes$2.mouseEnter;
            eventTypePrefix = 'mouse';
          } else if (topLevelType === TOP_POINTER_OUT || topLevelType === TOP_POINTER_OVER) {
            eventInterface = SyntheticPointerEvent;
            leaveEventType = eventTypes$2.pointerLeave;
            enterEventType = eventTypes$2.pointerEnter;
            eventTypePrefix = 'pointer';
          }
          var fromNode = from == null ? win : getNodeFromInstance$1(from);
          var toNode = to == null ? win : getNodeFromInstance$1(to);
          var leave = eventInterface.getPooled(leaveEventType, from, nativeEvent, nativeEventTarget);
          leave.type = eventTypePrefix + 'leave';
          leave.target = fromNode;
          leave.relatedTarget = toNode;
          var enter = eventInterface.getPooled(enterEventType, to, nativeEvent, nativeEventTarget);
          enter.type = eventTypePrefix + 'enter';
          enter.target = toNode;
          enter.relatedTarget = fromNode;
          accumulateEnterLeaveDispatches(leave, enter, from, to); // If we are not processing the first ancestor, then we
          // should not process the same nativeEvent again, as we
          // will have already processed it in the first ancestor.

          if ((eventSystemFlags & IS_FIRST_ANCESTOR) === 0) {
            return [leave];
          }
          return [leave, enter];
        }
      };

      /**
       * inlined Object.is polyfill to avoid requiring consumers ship their own
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
       */
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
      }

      var objectIs = typeof Object.is === 'function' ? Object.is : is;
      var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
      /**
       * Performs equality by iterating through keys on an object and returning false
       * when any key has values which are not strictly equal between the arguments.
       * Returns true when the values of all keys are strictly equal.
       */

      function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) {
          return true;
        }
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
          return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
          return false;
        } // Test for A's keys different from B.

        for (var i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }
        return true;
      }
      var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
      var eventTypes$3 = {
        select: {
          phasedRegistrationNames: {
            bubbled: 'onSelect',
            captured: 'onSelectCapture'
          },
          dependencies: [TOP_BLUR, TOP_CONTEXT_MENU, TOP_DRAG_END, TOP_FOCUS, TOP_KEY_DOWN, TOP_KEY_UP, TOP_MOUSE_DOWN, TOP_MOUSE_UP, TOP_SELECTION_CHANGE]
        }
      };
      var activeElement$1 = null;
      var activeElementInst$1 = null;
      var lastSelection = null;
      var mouseDown = false;
      /**
       * Get an object which is a unique representation of the current selection.
       *
       * The return value will not be consistent across nodes or browsers, but
       * two identical selections on the same node will return identical objects.
       *
       * @param {DOMElement} node
       * @return {object}
       */

      function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) {
          return {
            start: node.selectionStart,
            end: node.selectionEnd
          };
        } else {
          var win = node.ownerDocument && node.ownerDocument.defaultView || window;
          var selection = win.getSelection();
          return {
            anchorNode: selection.anchorNode,
            anchorOffset: selection.anchorOffset,
            focusNode: selection.focusNode,
            focusOffset: selection.focusOffset
          };
        }
      }
      /**
       * Get document associated with the event target.
       *
       * @param {object} nativeEventTarget
       * @return {Document}
       */

      function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
      }
      /**
       * Poll selection to see whether it's changed.
       *
       * @param {object} nativeEvent
       * @param {object} nativeEventTarget
       * @return {?SyntheticEvent}
       */

      function constructSelectEvent(nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) {
          return null;
        } // Only fire when selection has actually changed.

        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
          lastSelection = currentSelection;
          var syntheticEvent = SyntheticEvent.getPooled(eventTypes$3.select, activeElementInst$1, nativeEvent, nativeEventTarget);
          syntheticEvent.type = 'select';
          syntheticEvent.target = activeElement$1;
          accumulateTwoPhaseDispatches(syntheticEvent);
          return syntheticEvent;
        }
        return null;
      }
      /**
       * This plugin creates an `onSelect` event that normalizes select events
       * across form elements.
       *
       * Supported elements are:
       * - input (see `isTextInputElement`)
       * - textarea
       * - contentEditable
       *
       * This differs from native browser implementations in the following ways:
       * - Fires on contentEditable fields as well as inputs.
       * - Fires for collapsed selection.
       * - Fires after user input.
       */

      var SelectEventPlugin = {
        eventTypes: eventTypes$3,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, container) {
          var containerOrDoc = container || getEventTargetDocument(nativeEventTarget); // Track whether all listeners exists for this plugin. If none exist, we do
          // not extract events. See #3639.

          if (!containerOrDoc || !isListeningToAllDependencies('onSelect', containerOrDoc)) {
            return null;
          }
          var targetNode = targetInst ? getNodeFromInstance$1(targetInst) : window;
          switch (topLevelType) {
            // Track the input node that has focus.
            case TOP_FOCUS:
              if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                activeElement$1 = targetNode;
                activeElementInst$1 = targetInst;
                lastSelection = null;
              }
              break;
            case TOP_BLUR:
              activeElement$1 = null;
              activeElementInst$1 = null;
              lastSelection = null;
              break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.

            case TOP_MOUSE_DOWN:
              mouseDown = true;
              break;
            case TOP_CONTEXT_MENU:
            case TOP_MOUSE_UP:
            case TOP_DRAG_END:
              mouseDown = false;
              return constructSelectEvent(nativeEvent, nativeEventTarget);
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.

            case TOP_SELECTION_CHANGE:
              if (skipSelectionChangeEvent) {
                break;
              }

            // falls through

            case TOP_KEY_DOWN:
            case TOP_KEY_UP:
              return constructSelectEvent(nativeEvent, nativeEventTarget);
          }
          return null;
        }
      };

      /**
       * @interface Event
       * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
       * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
       */

      var SyntheticAnimationEvent = SyntheticEvent.extend({
        animationName: null,
        elapsedTime: null,
        pseudoElement: null
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/clipboard-apis/
       */

      var SyntheticClipboardEvent = SyntheticEvent.extend({
        clipboardData: function clipboardData(event) {
          return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
      });

      /**
       * @interface FocusEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticFocusEvent = SyntheticUIEvent.extend({
        relatedTarget: null
      });

      /**
       * `charCode` represents the actual "character code" and is safe to use with
       * `String.fromCharCode`. As such, only keys that correspond to printable
       * characters produce a valid `charCode`, the only exception to this is Enter.
       * The Tab-key is considered non-printable and does not have a `charCode`,
       * presumably because it does not produce a tab-character in browsers.
       *
       * @param {object} nativeEvent Native browser event.
       * @return {number} Normalized `charCode` property.
       */
      function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
          charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.

          if (charCode === 0 && keyCode === 13) {
            charCode = 13;
          }
        } else {
          // IE8 does not implement `charCode`, but `keyCode` has the correct value.
          charCode = keyCode;
        } // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.

        if (charCode === 10) {
          charCode = 13;
        } // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.

        if (charCode >= 32 || charCode === 13) {
          return charCode;
        }
        return 0;
      }

      /**
       * Normalization of deprecated HTML5 `key` values
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
      };
      /**
       * Translation from legacy `keyCode` to HTML5 `key`
       * Only special keys supported, all others depend on keyboard layout or browser
       * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
       */

      var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
      };
      /**
       * @param {object} nativeEvent Native browser event.
       * @return {string} Normalized `key` property.
       */

      function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
          // Normalize inconsistent values reported by browsers due to
          // implementations of a working draft specification.
          // FireFox implements `key` but returns `MozPrintableKey` for all
          // printable characters (normalized to `Unidentified`), ignore it.
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if (key !== 'Unidentified') {
            return key;
          }
        } // Browser does not implement `key`, polyfill as much of it as we can.

        if (nativeEvent.type === 'keypress') {
          var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
          // thus be captured by `keypress`, no other non-printable key should.

          return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
          // While user keyboard layout determines the actual meaning of each
          // `keyCode` value, almost all function keys have a universal value.
          return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        }
        return '';
      }

      /**
       * @interface KeyboardEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticKeyboardEvent = SyntheticUIEvent.extend({
        key: getEventKey,
        location: null,
        ctrlKey: null,
        shiftKey: null,
        altKey: null,
        metaKey: null,
        repeat: null,
        locale: null,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function charCode(event) {
          // `charCode` is the result of a KeyPress event and represents the value of
          // the actual printable character.
          // KeyPress is deprecated, but its replacement is not yet final and not
          // implemented in any major browser. Only KeyPress has charCode.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          return 0;
        },
        keyCode: function keyCode(event) {
          // `keyCode` is the result of a KeyDown/Up event and represents the value of
          // physical keyboard key.
          // The actual meaning of the value depends on the users' keyboard layout
          // which cannot be detected. Assuming that it is a US keyboard layout
          // provides a surprisingly accurate mapping for US and European users.
          // Due to this, it is left to the user to implement at this time.
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        },
        which: function which(event) {
          // `which` is an alias for either `keyCode` or `charCode` depending on the
          // type of the event.
          if (event.type === 'keypress') {
            return getEventCharCode(event);
          }
          if (event.type === 'keydown' || event.type === 'keyup') {
            return event.keyCode;
          }
          return 0;
        }
      });

      /**
       * @interface DragEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticDragEvent = SyntheticMouseEvent.extend({
        dataTransfer: null
      });

      /**
       * @interface TouchEvent
       * @see http://www.w3.org/TR/touch-events/
       */

      var SyntheticTouchEvent = SyntheticUIEvent.extend({
        touches: null,
        targetTouches: null,
        changedTouches: null,
        altKey: null,
        metaKey: null,
        ctrlKey: null,
        shiftKey: null,
        getModifierState: getEventModifierState
      });

      /**
       * @interface Event
       * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
       * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
       */

      var SyntheticTransitionEvent = SyntheticEvent.extend({
        propertyName: null,
        elapsedTime: null,
        pseudoElement: null
      });

      /**
       * @interface WheelEvent
       * @see http://www.w3.org/TR/DOM-Level-3-Events/
       */

      var SyntheticWheelEvent = SyntheticMouseEvent.extend({
        deltaX: function deltaX(event) {
          return 'deltaX' in event ? event.deltaX :
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function deltaY(event) {
          return 'deltaY' in event ? event.deltaY :
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          'wheelDeltaY' in event ? -event.wheelDeltaY :
          // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
          'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: null,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: null
      });
      var knownHTMLTopLevelTypes = [TOP_ABORT, TOP_CANCEL, TOP_CAN_PLAY, TOP_CAN_PLAY_THROUGH, TOP_CLOSE, TOP_DURATION_CHANGE, TOP_EMPTIED, TOP_ENCRYPTED, TOP_ENDED, TOP_ERROR, TOP_INPUT, TOP_INVALID, TOP_LOAD, TOP_LOADED_DATA, TOP_LOADED_METADATA, TOP_LOAD_START, TOP_PAUSE, TOP_PLAY, TOP_PLAYING, TOP_PROGRESS, TOP_RATE_CHANGE, TOP_RESET, TOP_SEEKED, TOP_SEEKING, TOP_STALLED, TOP_SUBMIT, TOP_SUSPEND, TOP_TIME_UPDATE, TOP_TOGGLE, TOP_VOLUME_CHANGE, TOP_WAITING];
      var SimpleEventPlugin = {
        // simpleEventPluginEventTypes gets populated from
        // the DOMEventProperties module.
        eventTypes: simpleEventPluginEventTypes,
        extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags) {
          var dispatchConfig = topLevelEventsToDispatchConfig.get(topLevelType);
          if (!dispatchConfig) {
            return null;
          }
          var EventConstructor;
          switch (topLevelType) {
            case TOP_KEY_PRESS:
              // Firefox creates a keypress event for function keys too. This removes
              // the unwanted keypress events. Enter is however both printable and
              // non-printable. One would expect Tab to be as well (but it isn't).
              if (getEventCharCode(nativeEvent) === 0) {
                return null;
              }

            /* falls through */

            case TOP_KEY_DOWN:
            case TOP_KEY_UP:
              EventConstructor = SyntheticKeyboardEvent;
              break;
            case TOP_BLUR:
            case TOP_FOCUS:
              EventConstructor = SyntheticFocusEvent;
              break;
            case TOP_CLICK:
              // Firefox creates a click event on right mouse clicks. This removes the
              // unwanted click events.
              if (nativeEvent.button === 2) {
                return null;
              }

            /* falls through */

            case TOP_AUX_CLICK:
            case TOP_DOUBLE_CLICK:
            case TOP_MOUSE_DOWN:
            case TOP_MOUSE_MOVE:
            case TOP_MOUSE_UP: // TODO: Disabled elements should not respond to mouse events

            /* falls through */

            case TOP_MOUSE_OUT:
            case TOP_MOUSE_OVER:
            case TOP_CONTEXT_MENU:
              EventConstructor = SyntheticMouseEvent;
              break;
            case TOP_DRAG:
            case TOP_DRAG_END:
            case TOP_DRAG_ENTER:
            case TOP_DRAG_EXIT:
            case TOP_DRAG_LEAVE:
            case TOP_DRAG_OVER:
            case TOP_DRAG_START:
            case TOP_DROP:
              EventConstructor = SyntheticDragEvent;
              break;
            case TOP_TOUCH_CANCEL:
            case TOP_TOUCH_END:
            case TOP_TOUCH_MOVE:
            case TOP_TOUCH_START:
              EventConstructor = SyntheticTouchEvent;
              break;
            case TOP_ANIMATION_END:
            case TOP_ANIMATION_ITERATION:
            case TOP_ANIMATION_START:
              EventConstructor = SyntheticAnimationEvent;
              break;
            case TOP_TRANSITION_END:
              EventConstructor = SyntheticTransitionEvent;
              break;
            case TOP_SCROLL:
              EventConstructor = SyntheticUIEvent;
              break;
            case TOP_WHEEL:
              EventConstructor = SyntheticWheelEvent;
              break;
            case TOP_COPY:
            case TOP_CUT:
            case TOP_PASTE:
              EventConstructor = SyntheticClipboardEvent;
              break;
            case TOP_GOT_POINTER_CAPTURE:
            case TOP_LOST_POINTER_CAPTURE:
            case TOP_POINTER_CANCEL:
            case TOP_POINTER_DOWN:
            case TOP_POINTER_MOVE:
            case TOP_POINTER_OUT:
            case TOP_POINTER_OVER:
            case TOP_POINTER_UP:
              EventConstructor = SyntheticPointerEvent;
              break;
            default:
              {
                if (knownHTMLTopLevelTypes.indexOf(topLevelType) === -1) {
                  error('SimpleEventPlugin: Unhandled event type, `%s`. This warning ' + 'is likely caused by a bug in React. Please file an issue.', topLevelType);
                }
              } // HTML Events
              // @see http://www.w3.org/TR/html5/index.html#events-0

              EventConstructor = SyntheticEvent;
              break;
          }
          var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
          accumulateTwoPhaseDispatches(event);
          return event;
        }
      };

      /**
       * Specifies a deterministic ordering of `EventPlugin`s. A convenient way to
       * reason about plugins, without having to package every one of them. This
       * is better than having plugins be ordered in the same order that they
       * are injected because that ordering would be influenced by the packaging order.
       * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
       * preventing default on events is convenient in `SimpleEventPlugin` handlers.
       */

      var DOMEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
      /**
       * Inject modules for resolving DOM hierarchy and plugin ordering.
       */

      injectEventPluginOrder(DOMEventPluginOrder);
      setComponentTree(getFiberCurrentPropsFromNode$1, getInstanceFromNode$1, getNodeFromInstance$1);
      /**
       * Some important event plugins included by default (without having to require
       * them).
       */

      injectEventPluginsByName({
        SimpleEventPlugin: SimpleEventPlugin,
        EnterLeaveEventPlugin: EnterLeaveEventPlugin,
        ChangeEventPlugin: ChangeEventPlugin,
        SelectEventPlugin: SelectEventPlugin,
        BeforeInputEventPlugin: BeforeInputEventPlugin
      });

      // Prefix measurements so that it's possible to filter them.
      // Longer prefixes are hard to read in DevTools.
      var reactEmoji = "\u269B";
      var warningEmoji = "\u26D4";
      var supportsUserTiming = typeof performance !== 'undefined' && typeof performance.mark === 'function' && typeof performance.clearMarks === 'function' && typeof performance.measure === 'function' && typeof performance.clearMeasures === 'function'; // Keep track of current fiber so that we know the path to unwind on pause.
      // TODO: this looks the same as nextUnitOfWork in scheduler. Can we unify them?

      var currentFiber = null; // If we're in the middle of user code, which fiber and method is it?
      // Reusing `currentFiber` would be confusing for this because user code fiber
      // can change during commit phase too, but we don't need to unwind it (since
      // lifecycles in the commit phase don't resemble a tree).

      var currentPhase = null;
      var currentPhaseFiber = null; // Did lifecycle hook schedule an update? This is often a performance problem,
      // so we will keep track of it, and include it in the report.
      // Track commits caused by cascading updates.

      var isCommitting = false;
      var hasScheduledUpdateInCurrentCommit = false;
      var hasScheduledUpdateInCurrentPhase = false;
      var commitCountInCurrentWorkLoop = 0;
      var effectCountInCurrentCommit = 0;
      // to avoid stretch the commit phase with measurement overhead.

      var labelsInCurrentCommit = new Set();
      var formatMarkName = function formatMarkName(markName) {
        return reactEmoji + " " + markName;
      };
      var formatLabel = function formatLabel(label, warning) {
        var prefix = warning ? warningEmoji + " " : reactEmoji + " ";
        var suffix = warning ? " Warning: " + warning : '';
        return "" + prefix + label + suffix;
      };
      var beginMark = function beginMark(markName) {
        performance.mark(formatMarkName(markName));
      };
      var clearMark = function clearMark(markName) {
        performance.clearMarks(formatMarkName(markName));
      };
      var endMark = function endMark(label, markName, warning) {
        var formattedMarkName = formatMarkName(markName);
        var formattedLabel = formatLabel(label, warning);
        try {
          performance.measure(formattedLabel, formattedMarkName);
        } catch (err) {} // If previous mark was missing for some reason, this will throw.
        // This could only happen if React crashed in an unexpected place earlier.
        // Don't pile on with more errors.
        // Clear marks immediately to avoid growing buffer.

        performance.clearMarks(formattedMarkName);
        performance.clearMeasures(formattedLabel);
      };
      var getFiberMarkName = function getFiberMarkName(label, debugID) {
        return label + " (#" + debugID + ")";
      };
      var getFiberLabel = function getFiberLabel(componentName, isMounted, phase) {
        if (phase === null) {
          // These are composite component total time measurements.
          return componentName + " [" + (isMounted ? 'update' : 'mount') + "]";
        } else {
          // Composite component methods.
          return componentName + "." + phase;
        }
      };
      var beginFiberMark = function beginFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        if (isCommitting && labelsInCurrentCommit.has(label)) {
          // During the commit phase, we don't show duplicate labels because
          // there is a fixed overhead for every measurement, and we don't
          // want to stretch the commit phase beyond necessary.
          return false;
        }
        labelsInCurrentCommit.add(label);
        var markName = getFiberMarkName(label, debugID);
        beginMark(markName);
        return true;
      };
      var clearFiberMark = function clearFiberMark(fiber, phase) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        clearMark(markName);
      };
      var endFiberMark = function endFiberMark(fiber, phase, warning) {
        var componentName = getComponentName(fiber.type) || 'Unknown';
        var debugID = fiber._debugID;
        var isMounted = fiber.alternate !== null;
        var label = getFiberLabel(componentName, isMounted, phase);
        var markName = getFiberMarkName(label, debugID);
        endMark(label, markName, warning);
      };
      var shouldIgnoreFiber = function shouldIgnoreFiber(fiber) {
        // Host components should be skipped in the timeline.
        // We could check typeof fiber.type, but does this work with RN?
        switch (fiber.tag) {
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case Fragment:
          case ContextProvider:
          case ContextConsumer:
          case Mode:
            return true;
          default:
            return false;
        }
      };
      var clearPendingPhaseMeasurement = function clearPendingPhaseMeasurement() {
        if (currentPhase !== null && currentPhaseFiber !== null) {
          clearFiberMark(currentPhaseFiber, currentPhase);
        }
        currentPhaseFiber = null;
        currentPhase = null;
        hasScheduledUpdateInCurrentPhase = false;
      };
      var pauseTimers = function pauseTimers() {
        // Stops all currently active measurements so that they can be resumed
        // if we continue in a later deferred loop from the same unit of work.
        var fiber = currentFiber;
        while (fiber) {
          if (fiber._debugIsCurrentlyTiming) {
            endFiberMark(fiber, null, null);
          }
          fiber = fiber.return;
        }
      };
      var resumeTimersRecursively = function resumeTimersRecursively(fiber) {
        if (fiber.return !== null) {
          resumeTimersRecursively(fiber.return);
        }
        if (fiber._debugIsCurrentlyTiming) {
          beginFiberMark(fiber, null);
        }
      };
      var resumeTimers = function resumeTimers() {
        // Resumes all measurements that were active during the last deferred loop.
        if (currentFiber !== null) {
          resumeTimersRecursively(currentFiber);
        }
      };
      function recordEffect() {
        {
          effectCountInCurrentCommit++;
        }
      }
      function recordScheduleUpdate() {
        {
          if (isCommitting) {
            hasScheduledUpdateInCurrentCommit = true;
          }
          if (currentPhase !== null && currentPhase !== 'componentWillMount' && currentPhase !== 'componentWillReceiveProps') {
            hasScheduledUpdateInCurrentPhase = true;
          }
        }
      }
      function startWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, this is the fiber to unwind from.

          currentFiber = fiber;
          if (!beginFiberMark(fiber, null)) {
            return;
          }
          fiber._debugIsCurrentlyTiming = true;
        }
      }
      function cancelWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // Remember we shouldn't complete measurement for this fiber.
          // Otherwise flamechart will be deep even for small updates.

          fiber._debugIsCurrentlyTiming = false;
          clearFiberMark(fiber, null);
        }
      }
      function stopWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          endFiberMark(fiber, null, null);
        }
      }
      function stopFailedWorkTimer(fiber) {
        {
          if (!supportsUserTiming || shouldIgnoreFiber(fiber)) {
            return;
          } // If we pause, its parent is the fiber to unwind from.

          currentFiber = fiber.return;
          if (!fiber._debugIsCurrentlyTiming) {
            return;
          }
          fiber._debugIsCurrentlyTiming = false;
          var warning = fiber.tag === SuspenseComponent ? 'Rendering was suspended' : 'An error was thrown inside this error boundary';
          endFiberMark(fiber, null, warning);
        }
      }
      function startPhaseTimer(fiber, phase) {
        {
          if (!supportsUserTiming) {
            return;
          }
          clearPendingPhaseMeasurement();
          if (!beginFiberMark(fiber, phase)) {
            return;
          }
          currentPhaseFiber = fiber;
          currentPhase = phase;
        }
      }
      function stopPhaseTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          if (currentPhase !== null && currentPhaseFiber !== null) {
            var warning = hasScheduledUpdateInCurrentPhase ? 'Scheduled a cascading update' : null;
            endFiberMark(currentPhaseFiber, currentPhase, warning);
          }
          currentPhase = null;
          currentPhaseFiber = null;
        }
      }
      function startWorkLoopTimer(nextUnitOfWork) {
        {
          currentFiber = nextUnitOfWork;
          if (!supportsUserTiming) {
            return;
          }
          commitCountInCurrentWorkLoop = 0; // This is top level call.
          // Any other measurements are performed within.

          beginMark('(React Tree Reconciliation)'); // Resume any measurements that were in progress during the last loop.

          resumeTimers();
        }
      }
      function stopWorkLoopTimer(interruptedBy, didCompleteRoot) {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (interruptedBy !== null) {
            if (interruptedBy.tag === HostRoot) {
              warning = 'A top-level update interrupted the previous render';
            } else {
              var componentName = getComponentName(interruptedBy.type) || 'Unknown';
              warning = "An update to " + componentName + " interrupted the previous render";
            }
          } else if (commitCountInCurrentWorkLoop > 1) {
            warning = 'There were cascading updates';
          }
          commitCountInCurrentWorkLoop = 0;
          var label = didCompleteRoot ? '(React Tree Reconciliation: Completed Root)' : '(React Tree Reconciliation: Yielded)'; // Pause any measurements until the next loop.

          pauseTimers();
          endMark(label, '(React Tree Reconciliation)', warning);
        }
      }
      function startCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          isCommitting = true;
          hasScheduledUpdateInCurrentCommit = false;
          labelsInCurrentCommit.clear();
          beginMark('(Committing Changes)');
        }
      }
      function stopCommitTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var warning = null;
          if (hasScheduledUpdateInCurrentCommit) {
            warning = 'Lifecycle hook scheduled a cascading update';
          } else if (commitCountInCurrentWorkLoop > 0) {
            warning = 'Caused by a cascading update in earlier commit';
          }
          hasScheduledUpdateInCurrentCommit = false;
          commitCountInCurrentWorkLoop++;
          isCommitting = false;
          labelsInCurrentCommit.clear();
          endMark('(Committing Changes)', '(Committing Changes)', warning);
        }
      }
      function startCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Snapshot Effects)');
        }
      }
      function stopCommitSnapshotEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Snapshot Effects: " + count + " Total)", '(Committing Snapshot Effects)', null);
        }
      }
      function startCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Committing Host Effects)');
        }
      }
      function stopCommitHostEffectsTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Committing Host Effects: " + count + " Total)", '(Committing Host Effects)', null);
        }
      }
      function startCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          effectCountInCurrentCommit = 0;
          beginMark('(Calling Lifecycle Methods)');
        }
      }
      function stopCommitLifeCyclesTimer() {
        {
          if (!supportsUserTiming) {
            return;
          }
          var count = effectCountInCurrentCommit;
          effectCountInCurrentCommit = 0;
          endMark("(Calling Lifecycle Methods: " + count + " Total)", '(Calling Lifecycle Methods)', null);
        }
      }
      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index = -1;
      function createCursor(defaultValue) {
        return {
          current: defaultValue
        };
      }
      function pop(cursor, fiber) {
        if (index < 0) {
          {
            error('Unexpected pop.');
          }
          return;
        }
        {
          if (fiber !== fiberStack[index]) {
            error('Unexpected Fiber popped.');
          }
        }
        cursor.current = valueStack[index];
        valueStack[index] = null;
        {
          fiberStack[index] = null;
        }
        index--;
      }
      function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        {
          fiberStack[index] = fiber;
        }
        cursor.current = value;
      }
      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      } // A cursor to the current merged context object on the stack.

      var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.

      var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
      // We use this to get access to the parent context after we have already
      // pushed the next context provider, and now need to merge their contexts.

      var previousContext = emptyContextObject;
      function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component)) {
            // If the fiber is a context provider itself, when we read its context
            // we may have already pushed its own child context on the stack. A context
            // provider should not "see" its own child context. Therefore we read the
            // previous (parent) context instead for a context provider.
            return previousContext;
          }
          return contextStackCursor.current;
        }
      }
      function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        {
          var instance = workInProgress.stateNode;
          instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }
      function getMaskedContext(workInProgress, unmaskedContext) {
        {
          var type = workInProgress.type;
          var contextTypes = type.contextTypes;
          if (!contextTypes) {
            return emptyContextObject;
          } // Avoid recreating masked context unless unmasked context has changed.
          // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
          // This may trigger infinite loops if componentWillReceiveProps calls setState.

          var instance = workInProgress.stateNode;
          if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance.__reactInternalMemoizedMaskedChildContext;
          }
          var context = {};
          for (var key in contextTypes) {
            context[key] = unmaskedContext[key];
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(contextTypes, context, 'context', name, getCurrentFiberStackInDev);
          } // Cache unmasked context so we can avoid recreating masked context unless necessary.
          // Context is created before the class component is instantiated so check for instance.

          if (instance) {
            cacheContext(workInProgress, unmaskedContext, context);
          }
          return context;
        }
      }
      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }
      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== undefined;
        }
      }
      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function pushTopLevelContextObject(fiber, context, didChange) {
        {
          if (!(contextStackCursor.current === emptyContextObject)) {
            {
              throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          push(contextStackCursor, context, fiber);
          push(didPerformWorkStackCursor, didChange, fiber);
        }
      }
      function processChildContext(fiber, type, parentContext) {
        {
          var instance = fiber.stateNode;
          var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
          // It has only been added in Fiber to match the (unintentional) behavior in Stack.

          if (typeof instance.getChildContext !== 'function') {
            {
              var componentName = getComponentName(type) || 'Unknown';
              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error('%s.childContextTypes is specified but there is no getChildContext() method ' + 'on the instance. You can either define getChildContext() on %s or remove ' + 'childContextTypes from it.', componentName, componentName);
              }
            }
            return parentContext;
          }
          var childContext;
          startPhaseTimer(fiber, 'getChildContext');
          childContext = instance.getChildContext();
          stopPhaseTimer();
          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              {
                throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
              }
            }
          }
          {
            var name = getComponentName(type) || 'Unknown';
            checkPropTypes(childContextTypes, childContext, 'child context', name,
            // In practice, there is one case in which we won't get a stack. It's when
            // somebody calls unstable_renderSubtreeIntoContainer() and we process
            // context from the parent component instance. The stack will be missing
            // because it's outside of the reconciliation, and so the pointer has not
            // been set. This is rare and doesn't matter. We'll also remove that API.
            getCurrentFiberStackInDev);
          }
          return _assign({}, parentContext, {}, childContext);
        }
      }
      function pushContextProvider(workInProgress) {
        {
          var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
          // If the instance does not exist yet, we will push null at first,
          // and replace it on the stack later when invalidating the context.

          var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
          // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.

          previousContext = contextStackCursor.current;
          push(contextStackCursor, memoizedMergedChildContext, workInProgress);
          push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
          return true;
        }
      }
      function invalidateContextProvider(workInProgress, type, didChange) {
        {
          var instance = workInProgress.stateNode;
          if (!instance) {
            {
              throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.

            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.

            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
          }
        }
      }
      function findCurrentUnmaskedContext(fiber) {
        {
          // Currently this is only used with renderSubtreeIntoContainer; not sure if it
          // makes sense elsewhere
          if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
            {
              throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var node = fiber;
          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;
              case ClassComponent:
                {
                  var Component = node.type;
                  if (isContextProvider(Component)) {
                    return node.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
            }
            node = node.return;
          } while (node !== null);
          {
            {
              throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
      }
      var LegacyRoot = 0;
      var BlockingRoot = 1;
      var ConcurrentRoot = 2;
      var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority,
        Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback,
        Scheduler_cancelCallback = Scheduler.unstable_cancelCallback,
        Scheduler_shouldYield = Scheduler.unstable_shouldYield,
        Scheduler_requestPaint = Scheduler.unstable_requestPaint,
        Scheduler_now = Scheduler.unstable_now,
        Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel,
        Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority,
        Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority,
        Scheduler_NormalPriority = Scheduler.unstable_NormalPriority,
        Scheduler_LowPriority = Scheduler.unstable_LowPriority,
        Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
      {
        // Provide explicit error message when production+profiling bundle of e.g.
        // react-dom is used with production (non-profiling) bundle of
        // scheduler/tracing
        if (!(tracing$1.__interactionsRef != null && tracing$1.__interactionsRef.current != null)) {
          {
            throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at http://fb.me/react-profiling");
          }
        }
      }
      var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
      // ascending numbers so we can compare them like numbers. They start at 90 to
      // avoid clashing with Scheduler's priorities.

      var ImmediatePriority = 99;
      var UserBlockingPriority$1 = 98;
      var NormalPriority = 97;
      var LowPriority = 96;
      var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.

      var NoPriority = 90;
      var shouldYield = Scheduler_shouldYield;
      var requestPaint =
      // Fall back gracefully if we're running an older version of Scheduler.
      Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function () {};
      var syncQueue = null;
      var immediateQueueCallbackNode = null;
      var isFlushingSyncQueue = false;
      var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
      // This will be the case for modern browsers that support `performance.now`. In
      // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
      // timestamp. In that case, subtract the module initialization time to simulate
      // the behavior of performance.now and keep our times small enough to fit
      // within 32 bits.
      // TODO: Consider lifting this into Scheduler.

      var now = initialTimeMs < 10000 ? Scheduler_now : function () {
        return Scheduler_now() - initialTimeMs;
      };
      function getCurrentPriorityLevel() {
        switch (Scheduler_getCurrentPriorityLevel()) {
          case Scheduler_ImmediatePriority:
            return ImmediatePriority;
          case Scheduler_UserBlockingPriority:
            return UserBlockingPriority$1;
          case Scheduler_NormalPriority:
            return NormalPriority;
          case Scheduler_LowPriority:
            return LowPriority;
          case Scheduler_IdlePriority:
            return IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch (reactPriorityLevel) {
          case ImmediatePriority:
            return Scheduler_ImmediatePriority;
          case UserBlockingPriority$1:
            return Scheduler_UserBlockingPriority;
          case NormalPriority:
            return Scheduler_NormalPriority;
          case LowPriority:
            return Scheduler_LowPriority;
          case IdlePriority:
            return Scheduler_IdlePriority;
          default:
            {
              {
                throw Error("Unknown priority level.");
              }
            }
        }
      }
      function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
      }
      function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
      }
      function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
          syncQueue = [callback]; // Flush the queue in the next tick, at the earliest.

          immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else {
          // Push onto existing queue. Don't need to schedule a callback because
          // we already scheduled one when we created the queue.
          syncQueue.push(callback);
        }
        return fakeCallbackNode;
      }
      function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) {
          Scheduler_cancelCallback(callbackNode);
        }
      }
      function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
          var node = immediateQueueCallbackNode;
          immediateQueueCallbackNode = null;
          Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
      }
      function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          // Prevent re-entrancy.
          isFlushingSyncQueue = true;
          var i = 0;
          try {
            var _isSync = true;
            var queue = syncQueue;
            runWithPriority$1(ImmediatePriority, function () {
              for (; i < queue.length; i++) {
                var callback = queue[i];
                do {
                  callback = callback(_isSync);
                } while (callback !== null);
              }
            });
            syncQueue = null;
          } catch (error) {
            // If something throws, leave the remaining callbacks on the queue.
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i + 1);
            } // Resume flushing in the next tick

            Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
            throw error;
          } finally {
            isFlushingSyncQueue = false;
          }
        }
      }
      var NoMode = 0;
      var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
      // tag instead

      var BlockingMode = 2;
      var ConcurrentMode = 4;
      var ProfileMode = 8;

      // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
      // Math.pow(2, 30) - 1
      // 0b111111111111111111111111111111
      var MAX_SIGNED_31_BIT_INT = 1073741823;
      var NoWork = 0; // TODO: Think of a better name for Never. The key difference with Idle is that
      // Never work can be committed in an inconsistent state without tearing the UI.
      // The main example is offscreen content, like a hidden subtree. So one possible
      // name is Offscreen. However, it also includes dehydrated Suspense boundaries,
      // which are inconsistent in the sense that they haven't finished yet, but
      // aren't visibly inconsistent because the server rendered HTML matches what the
      // hydrated tree would look like.

      var Never = 1; // Idle is slightly higher priority than Never. It must completely finish in
      // order to be consistent.

      var Idle = 2; // Continuous Hydration is slightly higher than Idle and is used to increase
      // priority of hover targets.

      var ContinuousHydration = 3;
      var Sync = MAX_SIGNED_31_BIT_INT;
      var Batched = Sync - 1;
      var UNIT_SIZE = 10;
      var MAGIC_NUMBER_OFFSET = Batched - 1; // 1 unit of expiration time represents 10ms.

      function msToExpirationTime(ms) {
        // Always subtract from the offset so that we don't clash with the magic number for NoWork.
        return MAGIC_NUMBER_OFFSET - (ms / UNIT_SIZE | 0);
      }
      function expirationTimeToMs(expirationTime) {
        return (MAGIC_NUMBER_OFFSET - expirationTime) * UNIT_SIZE;
      }
      function ceiling(num, precision) {
        return ((num / precision | 0) + 1) * precision;
      }
      function computeExpirationBucket(currentTime, expirationInMs, bucketSizeMs) {
        return MAGIC_NUMBER_OFFSET - ceiling(MAGIC_NUMBER_OFFSET - currentTime + expirationInMs / UNIT_SIZE, bucketSizeMs / UNIT_SIZE);
      } // TODO: This corresponds to Scheduler's NormalPriority, not LowPriority. Update
      // the names to reflect.

      var LOW_PRIORITY_EXPIRATION = 5000;
      var LOW_PRIORITY_BATCH_SIZE = 250;
      function computeAsyncExpiration(currentTime) {
        return computeExpirationBucket(currentTime, LOW_PRIORITY_EXPIRATION, LOW_PRIORITY_BATCH_SIZE);
      }
      function computeSuspenseExpiration(currentTime, timeoutMs) {
        // TODO: Should we warn if timeoutMs is lower than the normal pri expiration time?
        return computeExpirationBucket(currentTime, timeoutMs, LOW_PRIORITY_BATCH_SIZE);
      } // We intentionally set a higher expiration time for interactive updates in
      // dev than in production.
      //
      // If the main thread is being blocked so long that you hit the expiration,
      // it's a problem that could be solved with better scheduling.
      //
      // People will be more likely to notice this and fix it with the long
      // expiration time in development.
      //
      // In production we opt for better UX at the risk of masking scheduling
      // problems, by expiring fast.

      var HIGH_PRIORITY_EXPIRATION = 500;
      var HIGH_PRIORITY_BATCH_SIZE = 100;
      function computeInteractiveExpiration(currentTime) {
        return computeExpirationBucket(currentTime, HIGH_PRIORITY_EXPIRATION, HIGH_PRIORITY_BATCH_SIZE);
      }
      function inferPriorityFromExpirationTime(currentTime, expirationTime) {
        if (expirationTime === Sync) {
          return ImmediatePriority;
        }
        if (expirationTime === Never || expirationTime === Idle) {
          return IdlePriority;
        }
        var msUntil = expirationTimeToMs(expirationTime) - expirationTimeToMs(currentTime);
        if (msUntil <= 0) {
          return ImmediatePriority;
        }
        if (msUntil <= HIGH_PRIORITY_EXPIRATION + HIGH_PRIORITY_BATCH_SIZE) {
          return UserBlockingPriority$1;
        }
        if (msUntil <= LOW_PRIORITY_EXPIRATION + LOW_PRIORITY_BATCH_SIZE) {
          return NormalPriority;
        } // TODO: Handle LowPriority
        // Assume anything lower has idle priority

        return IdlePriority;
      }
      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
      };
      {
        var findStrictRoot = function findStrictRoot(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;
          while (node !== null) {
            if (node.mode & StrictMode) {
              maybeStrictRoot = node;
            }
            node = node.return;
          }
          return maybeStrictRoot;
        };
        var setToSortedString = function setToSortedString(set) {
          var array = [];
          set.forEach(function (value) {
            array.push(value);
          });
          return array.sort().join(', ');
        };
        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.

        var didWarnAboutUnsafeLifecycles = new Set();
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function (fiber, instance) {
          // Dedup strategy: Warn once per component.
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }
          if (typeof instance.componentWillMount === 'function' &&
          // Don't warn about react-lifecycles-compat polyfilled components.
          instance.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }
          if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }
          if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }
          if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function () {
          // We do an initial pass to gather component names
          var componentWillMountUniqueNames = new Set();
          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function (fiber) {
              componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }
          var UNSAFE_componentWillMountUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function (fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }
          var componentWillReceivePropsUniqueNames = new Set();
          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function (fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }
          var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function (fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }
          var componentWillUpdateUniqueNames = new Set();
          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function (fiber) {
              componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }
          var UNSAFE_componentWillUpdateUniqueNames = new Set();
          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function (fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          } // Finally, we flush all the warnings
          // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'

          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error('Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '\nPlease update the following components: %s', sortedNames);
          }
          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error('Using UNSAFE_componentWillReceiveProps in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, " + 'refactor your code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '\nPlease update the following components: %s', _sortedNames);
          }
          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error('Using UNSAFE_componentWillUpdate in strict mode is not recommended ' + 'and may indicate bugs in your code. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '\nPlease update the following components: %s', _sortedNames2);
          }
          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn('componentWillMount has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move code with side effects to componentDidMount, and set initial state in the constructor.\n' + '* Rename componentWillMount to UNSAFE_componentWillMount to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames3);
          }
          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn('componentWillReceiveProps has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + "* If you're updating state whenever props change, refactor your " + 'code to use memoization techniques or move it to ' + 'static getDerivedStateFromProps. Learn more at: https://fb.me/react-derived-state\n' + '* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames4);
          }
          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn('componentWillUpdate has been renamed, and is not recommended for use. ' + 'See https://fb.me/react-unsafe-component-lifecycles for details.\n\n' + '* Move data fetching code or side effects to componentDidUpdate.\n' + '* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress ' + 'this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work. ' + 'To rename all deprecated lifecycles to their new names, you can run ' + '`npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n' + '\nPlease update the following components: %s', _sortedNames5);
          }
        };
        var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.

        var didWarnAboutLegacyContext = new Set();
        ReactStrictModeWarnings.recordLegacyContextWarning = function (fiber, instance) {
          var strictRoot = findStrictRoot(fiber);
          if (strictRoot === null) {
            error('Expected to find a StrictMode component in a strict mode tree. ' + 'This error is likely caused by a bug in React. Please file an issue.');
            return;
          } // Dedup strategy: Warn once per component.

          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }
          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushLegacyContextWarning = function () {
          pendingLegacyContextWarning.forEach(function (fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function (fiber) {
              uniqueNames.add(getComponentName(fiber.type) || 'Component');
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            var firstComponentStack = getStackByFiberInDevAndProd(firstFiber);
            error('Legacy context API has been detected within a strict-mode tree.' + '\n\nThe old API will be supported in all 16.x releases, but applications ' + 'using it should migrate to the new version.' + '\n\nPlease update the following components: %s' + '\n\nLearn more about this warning here: https://fb.me/react-legacy-context' + '%s', sortedNames, firstComponentStack);
          });
        };
        ReactStrictModeWarnings.discardPendingWarnings = function () {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = new Map();
        };
      }
      var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.

      var failedBoundaries = null;
      var setRefreshHandler = function setRefreshHandler(handler) {
        {
          resolveFamily = handler;
        }
      };
      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
      }
      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return type;
          }
          var family = resolveFamily(type);
          if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
              // ForwardRef is special because its resolved .type is an object,
              // but it's possible that we only have its inner render function in the map.
              // If that inner render function is different, we'll build a new forwardRef type.
              var currentRender = resolveFunctionForHotReloading(type.render);
              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };
                if (type.displayName !== undefined) {
                  syntheticType.displayName = type.displayName;
                }
                return syntheticType;
              }
            }
            return type;
          } // Use the latest known implementation.

          return family.current;
        }
      }
      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return false;
          }
          var prevType = fiber.elementType;
          var nextType = element.type; // If we got here, we know types aren't === equal.

          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
          switch (fiber.tag) {
            case ClassComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                }
                break;
              }
            case FunctionComponent:
              {
                if (typeof nextType === 'function') {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  // We don't know the inner type yet.
                  // We're going to assume that the lazy inner type is stable,
                  // and so it is sufficient to avoid reconciling it away.
                  // We're not going to unwrap or actually use the new lazy type.
                  needsCompareFamilies = true;
                }
                break;
              }
            case ForwardRef:
              {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            case MemoComponent:
            case SimpleMemoComponent:
              {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  // TODO: if it was but can no longer be simple,
                  // we shouldn't set this.
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
            default:
              return false;
          } // Check if both types have a family and it's the same one.

          if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }
          return false;
        }
      }
      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          if (typeof WeakSet !== 'function') {
            return;
          }
          if (failedBoundaries === null) {
            failedBoundaries = new WeakSet();
          }
          failedBoundaries.add(fiber);
        }
      }
      var scheduleRefresh = function scheduleRefresh(root, update) {
        {
          if (resolveFamily === null) {
            // Hot reloading is disabled.
            return;
          }
          var staleFamilies = update.staleFamilies,
            updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync(function () {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
          });
        }
      };
      var scheduleRoot = function scheduleRoot(root, element) {
        {
          if (root.context !== emptyContextObject) {
            // Super edge case: root has a legacy _renderSubtree context
            // but we don't know the parentComponent so we can't pass it.
            // Just ignore. We'll delete this with _renderSubtree code path later.
            return;
          }
          flushPassiveEffects();
          syncUpdates(function () {
            updateContainer(element, root, null, null);
          });
        }
      };
      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate,
            child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          if (resolveFamily === null) {
            throw new Error('Expected resolveFamily to be set during hot reload.');
          }
          var needsRender = false;
          var needsRemount = false;
          if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }
          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }
          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }
          if (needsRemount || needsRender) {
            scheduleWork(fiber, Sync);
          }
          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }
          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }
      var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        {
          var hostInstances = new Set();
          var types = new Set(families.map(function (family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
          return hostInstances;
        }
      };
      function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        {
          var child = fiber.child,
            sibling = fiber.sibling,
            tag = fiber.tag,
            type = fiber.type;
          var candidateType = null;
          switch (tag) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          var didMatch = false;
          if (candidateType !== null) {
            if (types.has(candidateType)) {
              didMatch = true;
            }
          }
          if (didMatch) {
            // We have a match. This only drills down to the closest host components.
            // There's no need to search deeper because for the purpose of giving
            // visual feedback, "flashing" outermost parent rectangles is sufficient.
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            // If there's no match, maybe there will be one further down in the child tree.
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
            }
          }
          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
          }
        }
      }
      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
          if (foundHostInstances) {
            return;
          } // If we didn't find any host children, fallback to closest host parent.

          var node = fiber;
          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;
              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;
              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }
            if (node.return === null) {
              throw new Error('Expected to reach root first.');
            }
            node = node.return;
          }
        }
      }
      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;
          while (true) {
            if (node.tag === HostComponent) {
              // We got a match.
              foundHostInstances = true;
              hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === fiber) {
              return foundHostInstances;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === fiber) {
                return foundHostInstances;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        return false;
      }
      function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
          // Resolve default props. Taken from ReactElement
          var props = _assign({}, baseProps);
          var defaultProps = Component.defaultProps;
          for (var propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
          return props;
        }
        return baseProps;
      }
      function readLazyComponentType(lazyComponent) {
        initializeLazyComponentType(lazyComponent);
        if (lazyComponent._status !== Resolved) {
          throw lazyComponent._result;
        }
        return lazyComponent._result;
      }
      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        // Use this to detect multiple renderers using the same context
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastContextWithAllBitsObserved = null;
      var isDisallowedContextReadInDEV = false;
      function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }
      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        {
          push(valueCursor, context._currentValue, providerFiber);
          context._currentValue = nextValue;
          {
            if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) {
              error('Detected multiple renderers concurrently rendering the ' + 'same context provider. This is currently unsupported.');
            }
            context._currentRenderer = rendererSigil;
          }
        }
      }
      function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        {
          context._currentValue = currentValue;
        }
      }
      function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) {
          // No change
          return 0;
        } else {
          var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          {
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
              error('calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }
          }
          return changedBits | 0;
        }
      }
      function scheduleWorkOnParentPath(parent, renderExpirationTime) {
        // Update the child expiration time of all the ancestors, including
        // the alternates.
        var node = parent;
        while (node !== null) {
          var alternate = node.alternate;
          if (node.childExpirationTime < renderExpirationTime) {
            node.childExpirationTime = renderExpirationTime;
            if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
              alternate.childExpirationTime = renderExpirationTime;
            }
          } else if (alternate !== null && alternate.childExpirationTime < renderExpirationTime) {
            alternate.childExpirationTime = renderExpirationTime;
          } else {
            // Neither alternate was updated, which means the rest of the
            // ancestor path already has sufficient priority.
            break;
          }
          node = node.return;
        }
      }
      function propagateContextChange(workInProgress, context, changedBits, renderExpirationTime) {
        var fiber = workInProgress.child;
        if (fiber !== null) {
          // Set the return pointer of the child to the work-in-progress fiber.
          fiber.return = workInProgress;
        }
        while (fiber !== null) {
          var nextFiber = void 0; // Visit this fiber.

          var list = fiber.dependencies;
          if (list !== null) {
            nextFiber = fiber.child;
            var dependency = list.firstContext;
            while (dependency !== null) {
              // Check if the context matches.
              if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                // Match! Schedule an update on this fiber.
                if (fiber.tag === ClassComponent) {
                  // Schedule a force update on the work-in-progress.
                  var update = createUpdate(renderExpirationTime, null);
                  update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                  // update to the current fiber, too, which means it will persist even if
                  // this render is thrown away. Since it's a race condition, not sure it's
                  // worth fixing.

                  enqueueUpdate(fiber, update);
                }
                if (fiber.expirationTime < renderExpirationTime) {
                  fiber.expirationTime = renderExpirationTime;
                }
                var alternate = fiber.alternate;
                if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
                  alternate.expirationTime = renderExpirationTime;
                }
                scheduleWorkOnParentPath(fiber.return, renderExpirationTime); // Mark the expiration time on the list, too.

                if (list.expirationTime < renderExpirationTime) {
                  list.expirationTime = renderExpirationTime;
                } // Since we already found a match, we can stop traversing the
                // dependency list.

                break;
              }
              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
          } else {
            // Traverse down.
            nextFiber = fiber.child;
          }
          if (nextFiber !== null) {
            // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
          } else {
            // No child. Traverse to next sibling.
            nextFiber = fiber;
            while (nextFiber !== null) {
              if (nextFiber === workInProgress) {
                // We're back to the root of this subtree. Exit.
                nextFiber = null;
                break;
              }
              var sibling = nextFiber.sibling;
              if (sibling !== null) {
                // Set the return pointer of the sibling to the work-in-progress fiber.
                sibling.return = nextFiber.return;
                nextFiber = sibling;
                break;
              } // No more siblings. Traverse up.

              nextFiber = nextFiber.return;
            }
          }
          fiber = nextFiber;
        }
      }
      function prepareToReadContext(workInProgress, renderExpirationTime) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
          var firstContext = dependencies.firstContext;
          if (firstContext !== null) {
            if (dependencies.expirationTime >= renderExpirationTime) {
              // Context list has a pending update. Mark that this fiber performed work.
              markWorkInProgressReceivedUpdate();
            } // Reset the work-in-progress list

            dependencies.firstContext = null;
          }
        }
      }
      function _readContext(context, observedBits) {
        {
          // This warning would fire if you read context inside a Hook like useMemo.
          // Unlike the class check below, it's not enforced in production for perf.
          if (isDisallowedContextReadInDEV) {
            error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
          }
        }
        if (lastContextWithAllBitsObserved === context) ;else if (observedBits === false || observedBits === 0) ;else {
          var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.

          if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
            // Observe all updates.
            lastContextWithAllBitsObserved = context;
            resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
          } else {
            resolvedObservedBits = observedBits;
          }
          var contextItem = {
            context: context,
            observedBits: resolvedObservedBits,
            next: null
          };
          if (lastContextDependency === null) {
            if (!(currentlyRenderingFiber !== null)) {
              {
                throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
              }
            } // This is the first dependency for this component. Create a new list.

            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              expirationTime: NoWork,
              firstContext: contextItem,
              responders: null
            };
          } else {
            // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return context._currentValue;
      }
      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
      // It should only be read right after calling `processUpdateQueue`, via
      // `checkHasForceUpdateAfterProcessing`.

      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }
      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          baseQueue: null,
          shared: {
            pending: null
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }
      function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
          var clone = {
            baseState: currentQueue.baseState,
            baseQueue: currentQueue.baseQueue,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress.updateQueue = clone;
        }
      }
      function createUpdate(expirationTime, suspenseConfig) {
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        update.next = update;
        {
          update.priority = getCurrentPriorityLevel();
        }
        return update;
      }
      function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) {
          // Only occurs if the fiber has been unmounted.
          return;
        }
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        sharedQueue.pending = update;
        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error('An update (setState, replaceState, or forceUpdate) was scheduled ' + 'from inside an update function. Update functions should be pure, ' + 'with zero side-effects. Consider using componentDidUpdate or a ' + 'callback.');
            didWarnUpdateInsideUpdate = true;
          }
        }
      }
      function enqueueCapturedUpdate(workInProgress, update) {
        var current = workInProgress.alternate;
        if (current !== null) {
          // Ensure the work-in-progress queue is a clone
          cloneUpdateQueue(current, workInProgress);
        } // Captured updates go only on the work-in-progress queue.

        var queue = workInProgress.updateQueue; // Append the update to the end of the list.

        var last = queue.baseQueue;
        if (last === null) {
          queue.baseQueue = update.next = update;
          update.next = update;
        } else {
          update.next = last.next;
          last.next = update;
        }
      }
      function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch (update.tag) {
          case ReplaceState:
            {
              var payload = update.payload;
              if (typeof payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress.mode & StrictMode) {
                    payload.call(instance, prevState, nextProps);
                  }
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              } // State object

              return payload;
            }
          case CaptureUpdate:
            {
              workInProgress.effectTag = workInProgress.effectTag & ~ShouldCapture | DidCapture;
            }
          // Intentional fallthrough

          case UpdateState:
            {
              var _payload = update.payload;
              var partialState;
              if (typeof _payload === 'function') {
                // Updater function
                {
                  enterDisallowedContextReadInDEV();
                  if (workInProgress.mode & StrictMode) {
                    _payload.call(instance, prevState, nextProps);
                  }
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
              } else {
                // Partial state object
                partialState = _payload;
              }
              if (partialState === null || partialState === undefined) {
                // Null and undefined are treated as no-ops.
                return prevState;
              } // Merge the partial state and the previous state.

              return _assign({}, prevState, partialState);
            }
          case ForceUpdate:
            {
              hasForceUpdate = true;
              return prevState;
            }
        }
        return prevState;
      }
      function processUpdateQueue(workInProgress, props, instance, renderExpirationTime) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        } // The last rebase update that is NOT part of the base state.

        var baseQueue = queue.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          baseQueue = pendingQueue;
          queue.shared.pending = null; // TODO: Pass `current` as argument

          var current = workInProgress.alternate;
          if (current !== null) {
            var currentQueue = current.updateQueue;
            if (currentQueue !== null) {
              currentQueue.baseQueue = pendingQueue;
            }
          }
        } // These values may change as we process the queue.

        if (baseQueue !== null) {
          var first = baseQueue.next; // Iterate through the list of updates to compute the result.

          var newState = queue.baseState;
          var newExpirationTime = NoWork;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          if (first !== null) {
            var update = first;
            do {
              var updateExpirationTime = update.expirationTime;
              if (updateExpirationTime < renderExpirationTime) {
                // Priority is insufficient. Skip this update. If this is the first
                // skipped update, the previous update/state is the new base
                // update/state.
                var clone = {
                  expirationTime: update.expirationTime,
                  suspenseConfig: update.suspenseConfig,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone;
                } // Update the remaining priority in the queue.

                if (updateExpirationTime > newExpirationTime) {
                  newExpirationTime = updateExpirationTime;
                }
              } else {
                // This update does have sufficient priority.
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    expirationTime: Sync,
                    // This update is going to be committed so we never want uncommit it.
                    suspenseConfig: update.suspenseConfig,
                    tag: update.tag,
                    payload: update.payload,
                    callback: update.callback,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                } // Mark the event time of this update as relevant to this render pass.
                // TODO: This should ideally use the true event time of this update rather than
                // its priority which is a derived and not reverseable value.
                // TODO: We should skip this update if it was already committed but currently
                // we have no way of detecting the difference between a committed and suspended
                // update here.

                markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

                newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                var callback = update.callback;
                if (callback !== null) {
                  workInProgress.effectTag |= Callback;
                  var effects = queue.effects;
                  if (effects === null) {
                    queue.effects = [update];
                  } else {
                    effects.push(update);
                  }
                }
              }
              update = update.next;
              if (update === null || update === first) {
                pendingQueue = queue.shared.pending;
                if (pendingQueue === null) {
                  break;
                } else {
                  // An update was scheduled from inside a reducer. Add the new
                  // pending updates to the end of the list and keep processing.
                  update = baseQueue.next = pendingQueue.next;
                  pendingQueue.next = first;
                  queue.baseQueue = baseQueue = pendingQueue;
                  queue.shared.pending = null;
                }
              }
            } while (true);
          }
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }
          queue.baseState = newBaseState;
          queue.baseQueue = newBaseQueueLast; // Set the remaining expiration time to be whatever is remaining in the queue.
          // This should be fine because the only two other things that contribute to
          // expiration time are props and context. We're already in the middle of the
          // begin phase by the time we start processing the queue, so we've already
          // dealt with the props. Context in components that specify
          // shouldComponentUpdate is tricky; but we'll have to account for
          // that regardless.

          markUnprocessedUpdateTime(newExpirationTime);
          workInProgress.expirationTime = newExpirationTime;
          workInProgress.memoizedState = newState;
        }
        {
          currentlyProcessingQueue = null;
        }
      }
      function callCallback(callback, context) {
        if (!(typeof callback === 'function')) {
          {
            throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
          }
        }
        callback.call(context);
      }
      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }
      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }
      function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) {
          for (var i = 0; i < effects.length; i++) {
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance);
            }
          }
        }
      }
      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      function requestCurrentSuspenseConfig() {
        return ReactCurrentBatchConfig.suspense;
      }
      var fakeInternalInstance = {};
      var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
      // We'll use it to determine whether we need to initialize legacy refs.

      var emptyRefsObject = new React.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = new Set();
        didWarnAboutUninitializedState = new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
        didWarnAboutDirectlyAssigningPropsToState = new Set();
        didWarnAboutUndefinedDerivedState = new Set();
        didWarnAboutContextTypeAndContextTypes = new Set();
        didWarnAboutInvalidateContextType = new Set();
        var didWarnOnInvalidCallback = new Set();
        warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
          if (callback === null || typeof callback === 'function') {
            return;
          }
          var key = callerName + "_" + callback;
          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        };
        warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
          if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error('%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. ' + 'You have returned undefined.', componentName);
            }
          }
        }; // This is so gross but it's at least non-critical and can be removed if
        // it causes problems. This is meant to give a nicer error message for
        // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
        // ...)) which otherwise throws a "_processChildContext is not a function"
        // exception.

        Object.defineProperty(fakeInternalInstance, '_processChildContext', {
          enumerable: false,
          value: function value() {
            {
              {
                throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
              }
            }
          }
        });
        Object.freeze(fakeInternalInstance);
      }
      function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        {
          if (workInProgress.mode & StrictMode) {
            // Invoke the function an extra time to help detect side-effects.
            getDerivedStateFromProps(nextProps, prevState);
          }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          warnOnUndefinedDerivedState(ctor, partialState);
        } // Merge the partial state and the previous state.

        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.

        if (workInProgress.expirationTime === NoWork) {
          // Queue is always non-null for classes
          var updateQueue = workInProgress.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }
      var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'setState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ReplaceState;
          update.payload = payload;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'replaceState');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
          var fiber = get(inst);
          var currentTime = requestCurrentTimeForUpdate();
          var suspenseConfig = requestCurrentSuspenseConfig();
          var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
          var update = createUpdate(expirationTime, suspenseConfig);
          update.tag = ForceUpdate;
          if (callback !== undefined && callback !== null) {
            {
              warnOnInvalidCallback(callback, 'forceUpdate');
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          scheduleWork(fiber, expirationTime);
        }
      };
      function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
          {
            if (workInProgress.mode & StrictMode) {
              // Invoke the function an extra time to help detect side-effects.
              instance.shouldComponentUpdate(newProps, newState, nextContext);
            }
          }
          startPhaseTimer(workInProgress, 'shouldComponentUpdate');
          var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
          stopPhaseTimer();
          {
            if (shouldUpdate === undefined) {
              error('%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', getComponentName(ctor) || 'Component');
            }
          }
          return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }
        return true;
      }
      function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        {
          var name = getComponentName(ctor) || 'Component';
          var renderPresent = instance.render;
          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') {
              error('%s(...): No `render` method found on the returned component ' + 'instance: did you accidentally return an object from the constructor?', name);
            } else {
              error('%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', name);
            }
          }
          if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
            error('getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', name);
          }
          if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', name);
          }
          if (instance.propTypes) {
            error('propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', name);
          }
          if (instance.contextType) {
            error('contextType was defined as an instance property on %s. Use a static ' + 'property to define contextType instead.', name);
          }
          {
            if (instance.contextTypes) {
              error('contextTypes was defined as an instance property on %s. Use a static ' + 'property to define contextTypes instead.', name);
            }
            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error('%s declares both contextTypes and contextType static properties. ' + 'The legacy contextTypes property will be ignored.', name);
            }
          }
          if (typeof instance.componentShouldUpdate === 'function') {
            error('%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', name);
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') {
            error('%s has a method called shouldComponentUpdate(). ' + 'shouldComponentUpdate should not be used when extending React.PureComponent. ' + 'Please extend React.Component if shouldComponentUpdate is used.', getComponentName(ctor) || 'A pure component');
          }
          if (typeof instance.componentDidUnmount === 'function') {
            error('%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', name);
          }
          if (typeof instance.componentDidReceiveProps === 'function') {
            error('%s has a method called ' + 'componentDidReceiveProps(). But there is no such lifecycle method. ' + 'If you meant to update the state in response to changing props, ' + 'use componentWillReceiveProps(). If you meant to fetch data or ' + 'run side-effects or mutations after React has updated the UI, use componentDidUpdate().', name);
          }
          if (typeof instance.componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', name);
          }
          if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') {
            error('%s has a method called ' + 'UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?', name);
          }
          var hasMutatedProps = instance.props !== newProps;
          if (instance.props !== undefined && hasMutatedProps) {
            error('%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", name, name);
          }
          if (instance.defaultProps) {
            error('Setting defaultProps as an instance property on %s is not supported and will be ignored.' + ' Instead, define defaultProps as a static property on %s.', name, name);
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error('%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). ' + 'This component defines getSnapshotBeforeUpdate() only.', getComponentName(ctor));
          }
          if (typeof instance.getDerivedStateFromProps === 'function') {
            error('%s: getDerivedStateFromProps() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof instance.getDerivedStateFromError === 'function') {
            error('%s: getDerivedStateFromError() is defined as an instance method ' + 'and will be ignored. Instead, declare it as a static method.', name);
          }
          if (typeof ctor.getSnapshotBeforeUpdate === 'function') {
            error('%s: getSnapshotBeforeUpdate() is defined as a static method ' + 'and will be ignored. Instead, declare it as an instance method.', name);
          }
          var _state = instance.state;
          if (_state && (typeof _state !== 'object' || isArray(_state))) {
            error('%s.state: must be set to an object or null', name);
          }
          if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') {
            error('%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', name);
          }
        }
      }
      function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates

        set(instance, workInProgress);
        {
          instance._reactInternalInstance = fakeInternalInstance;
        }
      }
      function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ('contextType' in ctor) {
            var isValid =
            // Allow null for conditional declaration
            contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>

            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = '';
              if (contextType === undefined) {
                addendum = ' However, it is set to undefined. ' + 'This can be caused by a typo or by mixing up named and default imports. ' + 'This can also happen due to a circular dependency, so ' + 'try moving the createContext() call to a separate file.';
              } else if (typeof contextType !== 'object') {
                addendum = ' However, it is set to a ' + typeof contextType + '.';
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = ' Did you accidentally pass the Context.Provider instead?';
              } else if (contextType._context !== undefined) {
                // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
              } else {
                addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
              }
              error('%s defines an invalid contextType. ' + 'contextType should point to the Context object returned by React.createContext().%s', getComponentName(ctor) || 'Component', addendum);
            }
          }
        }
        if (typeof contextType === 'object' && contextType !== null) {
          context = _readContext(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
          context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.

        {
          if (workInProgress.mode & StrictMode) {
            new ctor(props, context); // eslint-disable-line no-new
          }
        }

        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        {
          if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error('`%s` uses `getDerivedStateFromProps` but its initial state is ' + '%s. This is not recommended. Instead, define the initial state by ' + 'assigning an object to `this.state` in the constructor of `%s`. ' + 'This ensures that `getDerivedStateFromProps` arguments have a consistent shape.', componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
          } // If new component APIs are defined, "unsafe" lifecycles won't be called.
          // Warn about these lifecycles if they are present.
          // Don't warn about react-lifecycles-compat polyfilled methods though.

          if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = 'componentWillMount';
            } else if (typeof instance.UNSAFE_componentWillMount === 'function') {
              foundWillMountName = 'UNSAFE_componentWillMount';
            }
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = 'componentWillReceiveProps';
            } else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
              foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            }
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = 'componentWillUpdate';
            } else if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            }
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentName(ctor) || 'Component';
              var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + '%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\n' + 'The above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-unsafe-component-lifecycles', _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
              }
            }
          }
        } // Cache unmasked context so we can avoid recreating masked context unless necessary.
        // ReactFiberContext usually updates this cache but can't for newly-created instances.

        if (isLegacyContextConsumer) {
          cacheContext(workInProgress, unmaskedContext, context);
        }
        return instance;
      }
      function callComponentWillMount(workInProgress, instance) {
        startPhaseTimer(workInProgress, 'componentWillMount');
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') {
          instance.componentWillMount();
        }
        if (typeof instance.UNSAFE_componentWillMount === 'function') {
          instance.UNSAFE_componentWillMount();
        }
        stopPhaseTimer();
        if (oldState !== instance.state) {
          {
            error('%s.componentWillMount(): Assigning directly to this.state is ' + "deprecated (except inside a component's " + 'constructor). Use setState instead.', getComponentName(workInProgress.type) || 'Component');
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      }
      function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        startPhaseTimer(workInProgress, 'componentWillReceiveProps');
        if (typeof instance.componentWillReceiveProps === 'function') {
          instance.componentWillReceiveProps(newProps, nextContext);
        }
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') {
          instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }
        stopPhaseTimer();
        if (instance.state !== oldState) {
          {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error('%s.componentWillReceiveProps(): Assigning directly to ' + "this.state is deprecated (except inside a component's " + 'constructor). Use setState instead.', componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
      } // Invokes the mount life-cycles on a previously never rendered instance.

      function mountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        {
          checkClassInstance(workInProgress, ctor, newProps);
        }
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) {
          instance.context = _readContext(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        {
          if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error('%s: It is not recommended to assign props directly to state ' + "because updates to props won't be reflected in state. " + 'In most cases, it is better to use props directly.', componentName);
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
          }
          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
          }
        }
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
          callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
          // process them now.

          processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
          instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
          workInProgress.effectTag |= Update;
        }
      }
      function resumeMountClassInstance(workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillMount');
            if (typeof instance.componentWillMount === 'function') {
              instance.componentWillMount();
            }
            if (typeof instance.UNSAFE_componentWillMount === 'function') {
              instance.UNSAFE_componentWillMount();
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidMount === 'function') {
            workInProgress.effectTag |= Update;
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      } // Invokes the update life-cycles and returns false if it shouldn't rerender.

      function updateClassInstance(current, workInProgress, ctor, newProps, renderExpirationTime) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var oldProps = workInProgress.memoizedProps;
        instance.props = workInProgress.type === workInProgress.elementType ? oldProps : resolveDefaultProps(workInProgress.type, oldProps);
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) {
          nextContext = _readContext(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
          nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.

        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderExpirationTime);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
          applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          // In order to support react-lifecycles-compat polyfilled components,
          // Unsafe lifecycles should not be invoked for components using the new APIs.
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
            startPhaseTimer(workInProgress, 'componentWillUpdate');
            if (typeof instance.componentWillUpdate === 'function') {
              instance.componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.UNSAFE_componentWillUpdate === 'function') {
              instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            stopPhaseTimer();
          }
          if (typeof instance.componentDidUpdate === 'function') {
            workInProgress.effectTag |= Update;
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            workInProgress.effectTag |= Snapshot;
          }
        } else {
          // If an update was already in progress, we should schedule an Update
          // effect even though we're bailing out, so that cWU/cDU are called.
          if (typeof instance.componentDidUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Update;
            }
          }
          if (typeof instance.getSnapshotBeforeUpdate === 'function') {
            if (oldProps !== current.memoizedProps || oldState !== current.memoizedState) {
              workInProgress.effectTag |= Snapshot;
            }
          } // If shouldComponentUpdate returned false, we should still update the
          // memoized props/state to indicate that this work can be reused.

          workInProgress.memoizedProps = newProps;
          workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.

        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
      }
      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;
      var warnForMissingKey = function warnForMissingKey(child) {};
      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        /**
         * Warn if there's no key explicitly set on dynamic arrays of children or
         * object keys are not valid. This allows us to keep track of children between
         * updates.
         */

        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};
        warnForMissingKey = function warnForMissingKey(child) {
          if (child === null || typeof child !== 'object') {
            return;
          }
          if (!child._store || child._store.validated || child.key != null) {
            return;
          }
          if (!(typeof child._store === 'object')) {
            {
              throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          child._store.validated = true;
          var currentComponentErrorInfo = 'Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.' + getCurrentFiberStackInDev();
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          error('Each child in a list should have a unique ' + '"key" prop. See https://fb.me/react-warning-keys for ' + 'more information.');
        };
      }
      var isArray$1 = Array.isArray;
      function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
          {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) &&
            // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentName(returnFiber.type) || 'Component';
              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error('A string ref, "%s", has been found within a strict mode tree. ' + 'String refs are a source of potential bugs and should be avoided. ' + 'We recommend using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref%s', mixedRef, getStackByFiberInDevAndProd(returnFiber));
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
          if (element._owner) {
            var owner = element._owner;
            var inst;
            if (owner) {
              var ownerFiber = owner;
              if (!(ownerFiber.tag === ClassComponent)) {
                {
                  throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref");
                }
              }
              inst = ownerFiber.stateNode;
            }
            if (!inst) {
              {
                throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref

            if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) {
              return current.ref;
            }
            var ref = function ref(value) {
              var refs = inst.refs;
              if (refs === emptyRefsObject) {
                // This is a lazy pooled frozen object, so we need to initialize.
                refs = inst.refs = {};
              }
              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };
            ref._stringRef = stringRef;
            return ref;
          } else {
            if (!(typeof mixedRef === 'string')) {
              {
                throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
              }
            }
            if (!element._owner) {
              {
                throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://fb.me/react-refs-must-have-owner for more information.");
              }
            }
          }
        }
        return mixedRef;
      }
      function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') {
          var addendum = '';
          {
            addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + getCurrentFiberStackInDev();
          }
          {
            {
              throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + ")." + addendum);
            }
          }
        }
      }
      function warnOnFunctionType() {
        {
          var currentComponentErrorInfo = 'Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.' + getCurrentFiberStackInDev();
          if (ownerHasFunctionTypeWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasFunctionTypeWarning[currentComponentErrorInfo] = true;
          error('Functions are not valid as a React child. This may happen if ' + 'you return a Component instead of <Component /> from render. ' + 'Or maybe you meant to call this function rather than return it.');
        }
      } // This wrapper function exists because I expect to clone the code in each path
      // to be able to optimize each path individually by branching early. This needs
      // a compiler or we can do it manually. Helpers that don't need this branching
      // live outside of this function.

      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return;
          } // Deletions are added in reversed order so we add it to the front.
          // At this point, the return fiber's effect list is empty except for
          // deletions, so we can just append the deletion to the list. The remaining
          // effects aren't added until the complete phase. Once we implement
          // resuming, this may not be true.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
          }
          childToDelete.nextEffect = null;
          childToDelete.effectTag = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            // Noop.
            return null;
          } // TODO: For the shouldClone case, this could be micro-optimized a bit by
          // assuming that after the first child we've already added everything.

          var childToDelete = currentFirstChild;
          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }
          return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
          // Add the remaining children to a temporary map so that we can find them by
          // keys quickly. Implicit (null) keys get added to this set with their index
          // instead.
          var existingChildren = new Map();
          var existingChild = currentFirstChild;
          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }
            existingChild = existingChild.sibling;
          }
          return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
          // We currently set sibling to null and index to 0 here because it is easy
          // to forget to do before returning it. E.g. for the single child case.
          var clone = createWorkInProgress(fiber, pendingProps);
          clone.index = 0;
          clone.sibling = null;
          return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;
          if (!shouldTrackSideEffects) {
            // Noop.
            return lastPlacedIndex;
          }
          var current = newFiber.alternate;
          if (current !== null) {
            var oldIndex = current.index;
            if (oldIndex < lastPlacedIndex) {
              // This is a move.
              newFiber.effectTag = Placement;
              return lastPlacedIndex;
            } else {
              // This item can stay in place.
              return oldIndex;
            }
          } else {
            // This is an insertion.
            newFiber.effectTag = Placement;
            return lastPlacedIndex;
          }
        }
        function placeSingleChild(newFiber) {
          // This is simpler for the single child case. We only need to do a
          // placement for inserting new children.
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.effectTag = Placement;
          }
          return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, expirationTime) {
          if (current === null || current.tag !== HostText) {
            // Insert
            var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, textContent);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateElement(returnFiber, current, element, expirationTime) {
          if (current !== null) {
            if (current.elementType === element.type ||
            // Keep this check inline so it only runs on the false path:
            isCompatibleFamilyForHotReloading(current, element)) {
              // Move based on index
              var existing = useFiber(current, element.props);
              existing.ref = coerceRef(returnFiber, current, element);
              existing.return = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          } // Insert

          var created = createFiberFromElement(element, returnFiber.mode, expirationTime);
          created.ref = coerceRef(returnFiber, current, element);
          created.return = returnFiber;
          return created;
        }
        function updatePortal(returnFiber, current, portal, expirationTime) {
          if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
            // Insert
            var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, portal.children || []);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateFragment(returnFiber, current, fragment, expirationTime, key) {
          if (current === null || current.tag !== Fragment) {
            // Insert
            var created = createFiberFromFragment(fragment, returnFiber.mode, expirationTime, key);
            created.return = returnFiber;
            return created;
          } else {
            // Update
            var existing = useFiber(current, fragment);
            existing.return = returnFiber;
            return existing;
          }
        }
        function createChild(returnFiber, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            var created = createFiberFromText('' + newChild, returnFiber.mode, expirationTime);
            created.return = returnFiber;
            return created;
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, expirationTime);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
              case REACT_PORTAL_TYPE:
                {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, expirationTime);
                  _created2.return = returnFiber;
                  return _created2;
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, expirationTime, null);
              _created3.return = returnFiber;
              return _created3;
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, expirationTime) {
          // Update the fiber if the keys match, otherwise return null.
          var key = oldFiber !== null ? oldFiber.key : null;
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys. If the previous node is implicitly keyed
            // we can continue to replace it without aborting even if it is not a text
            // node.
            if (key !== null) {
              return null;
            }
            return updateTextNode(returnFiber, oldFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment(returnFiber, oldFiber, newChild.props.children, expirationTime, key);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
              case REACT_PORTAL_TYPE:
                {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, expirationTime);
                  } else {
                    return null;
                  }
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }
              return updateFragment(returnFiber, oldFiber, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, expirationTime) {
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            // Text nodes don't have keys, so we neither have to check the old nor
            // new node for the key. If both are text nodes, they match.
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, '' + newChild, expirationTime);
          }
          if (typeof newChild === 'object' && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment(returnFiber, _matchedFiber, newChild.props.children, expirationTime, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, expirationTime);
                }
              case REACT_PORTAL_TYPE:
                {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, expirationTime);
                }
            }
            if (isArray$1(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;
              return updateFragment(returnFiber, _matchedFiber3, newChild, expirationTime, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          return null;
        }
        /**
         * Warns if there is a duplicate or missing key
         */

        function warnOnInvalidKey(child, knownKeys) {
          {
            if (typeof child !== 'object' || child === null) {
              return knownKeys;
            }
            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child);
                var key = child.key;
                if (typeof key !== 'string') {
                  break;
                }
                if (knownKeys === null) {
                  knownKeys = new Set();
                  knownKeys.add(key);
                  break;
                }
                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }
                error('Encountered two children with the same key, `%s`. ' + 'Keys should be unique so that components maintain their identity ' + 'across updates. Non-unique keys may cause children to be ' + 'duplicated and/or omitted — the behavior is unsupported and ' + 'could change in a future version.', key);
                break;
            }
          }
          return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, expirationTime) {
          // This algorithm can't optimize by searching from both ends since we
          // don't have backpointers on fibers. I'm trying to see how far we can get
          // with that model. If it ends up not being worth the tradeoffs, we can
          // add it later.
          // Even with a two ended optimization, we'd want to optimize for the case
          // where there are few changes and brute force the comparison instead of
          // going for the Map. It'd like to explore hitting that path first in
          // forward-only mode and only go for the Map once we notice that we need
          // lots of look ahead. This doesn't handle reversal as well as two ended
          // search but that's unusual. Besides, for the two ended optimization to
          // work on Iterables, we'd need to copy the whole set.
          // In this first iteration, we'll just live with hitting the bad case
          // (adding everything to a Map) in for every insert/move.
          // If you change this code, also update reconcileChildrenIterator() which
          // uses the same algorithm.
          {
            // First, validate keys.
            var knownKeys = null;
            for (var i = 0; i < newChildren.length; i++) {
              var child = newChildren[i];
              knownKeys = warnOnInvalidKey(child, knownKeys);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (newIdx === newChildren.length) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], expirationTime);
              if (_newFiber === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }
              previousNewFiber = _newFiber;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], expirationTime);
            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }
              previousNewFiber = _newFiber2;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, expirationTime) {
          // This is the same implementation as reconcileChildrenArray(),
          // but using the iterator instead.
          var iteratorFn = getIteratorFn(newChildrenIterable);
          if (!(typeof iteratorFn === 'function')) {
            {
              throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          {
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' &&
            // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
              if (!didWarnAboutGenerators) {
                error('Using Generators as children is unsupported and will likely yield ' + 'unexpected results because enumerating a generator mutates it. ' + 'You may convert it to an array with `Array.from()` or the ' + '`[...spread]` operator before rendering. Keep in mind ' + 'you might need to polyfill these features for older browsers.');
              }
              didWarnAboutGenerators = true;
            } // Warn about using Maps as children

            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error('Using Maps as children is unsupported and will likely yield ' + 'unexpected results. Convert it to a sequence/iterable of keyed ' + 'ReactElements instead.');
              }
              didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.

            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
              var knownKeys = null;
              var _step = _newChildren.next();
              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);
          if (!(newChildren != null)) {
            {
              throw Error("An iterable object provided no iterator.");
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();
          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, expirationTime);
            if (newFiber === null) {
              // TODO: This breaks on empty slots like null children. That's
              // unfortunate because it triggers the slow path all the time. We need
              // a better way to communicate whether this was a miss or null,
              // boolean, undefined, etc.
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                // We matched the slot, but we didn't reuse the existing fiber, so we
                // need to delete the existing child.
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              // TODO: Move out of the loop. This only happens for the first run.
              resultingFirstChild = newFiber;
            } else {
              // TODO: Defer siblings if we're not at the right index for this slot.
              // I.e. if we had null values before, then we want to defer this
              // for each null value. However, we also don't want to call updateSlot
              // with the previous one.
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (step.done) {
            // We've reached the end of the new children. We can delete the rest.
            deleteRemainingChildren(returnFiber, oldFiber);
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            // If we don't have any more existing children we can choose a fast path
            // since the rest will all be insertions.
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, expirationTime);
              if (_newFiber3 === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }
              previousNewFiber = _newFiber3;
            }
            return resultingFirstChild;
          } // Add all children to a key map for quick lookups.

          var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.

          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, expirationTime);
            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  // The new fiber is a work in progress, but if there exists a
                  // current, that means that we reused the fiber. We need to delete
                  // it from the child list so that we don't add it to the deletion
                  // list.
                  existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }
              previousNewFiber = _newFiber4;
            }
          }
          if (shouldTrackSideEffects) {
            // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function (child) {
              return deleteChild(returnFiber, child);
            });
          }
          return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, expirationTime) {
          // There's no need to check for keys on text nodes since we don't have a
          // way to define them.
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            // We already have an existing node so let's just update it and delete
            // the rest.
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber(currentFirstChild, textContent);
            existing.return = returnFiber;
            return existing;
          } // The existing first child is not a text node so we need to create one
          // and delete the existing ones.

          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, expirationTime) {
          var key = element.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              switch (child.tag) {
                case Fragment:
                  {
                    if (element.type === REACT_FRAGMENT_TYPE) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                case Block:

                // We intentionally fallthrough here if enableBlocksAPI is not on.
                // eslint-disable-next-lined no-fallthrough

                default:
                  {
                    if (child.elementType === element.type ||
                    // Keep this check inline so it only runs on the false path:
                    isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
              } // Didn't match.

              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, expirationTime, element.key);
            created.return = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, expirationTime);
            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4.return = returnFiber;
            return _created4;
          }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, expirationTime) {
          var key = portal.key;
          var child = currentFirstChild;
          while (child !== null) {
            // TODO: If key === null and child.key === null, then this only applies to
            // the first item in the list.
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber(child, portal.children || []);
                existing.return = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          var created = createFiberFromPortal(portal, returnFiber.mode, expirationTime);
          created.return = returnFiber;
          return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.

        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, expirationTime) {
          // This function is not recursive.
          // If the top level item is an array, we treat it as a set of children,
          // not as a fragment. Nested arrays on the other hand will be treated as
          // fragment nodes. Recursion happens at the normal flow.
          // Handle top level unkeyed fragments as if they were arrays.
          // This leads to an ambiguity between <>{[...]}</> and <>...</>.
          // We treat the ambiguous cases above the same.
          var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          } // Handle object types

          var isObject = typeof newChild === 'object' && newChild !== null;
          if (isObject) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, expirationTime));
              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, expirationTime));
            }
          }
          if (typeof newChild === 'string' || typeof newChild === 'number') {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, expirationTime));
          }
          if (isArray$1(newChild)) {
            return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (getIteratorFn(newChild)) {
            return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, expirationTime);
          }
          if (isObject) {
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === 'function') {
              warnOnFunctionType();
            }
          }
          if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) {
            // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch (returnFiber.tag) {
              case ClassComponent:
                {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      // We allow auto-mocks to proceed as if they're returning null.
                      break;
                    }
                  }
                }
              // Intentionally fall through to the next case, which handles both
              // functions and classes
              // eslint-disable-next-lined no-fallthrough

              case FunctionComponent:
                {
                  var Component = returnFiber.type;
                  {
                    {
                      throw Error((Component.displayName || Component.name || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
            }
          } // Remaining cases are all treated as empty.

          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
      }
      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);
      function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) {
          {
            throw Error("Resuming work not yet implemented.");
          }
        }
        if (workInProgress.child === null) {
          return;
        }
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild.return = workInProgress;
        }
        newChild.sibling = null;
      } // Reset a workInProgress child set to prepare it for a second pass.

      function resetChildFibers(workInProgress, renderExpirationTime) {
        var child = workInProgress.child;
        while (child !== null) {
          resetWorkInProgress(child, renderExpirationTime);
          child = child.sibling;
        }
      }
      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);
      function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) {
          {
            throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        return c;
      }
      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }
      function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.

        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.

        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
      }
      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }
      function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
      }
      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.

        if (context === nextContext) {
          return;
        } // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.

        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
      }
      function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }
      var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
      // inherited deeply down the subtree. The upper bits only affect
      // this immediate suspense boundary and gets reset each new
      // boundary or suspense list.

      var SubtreeSuspenseContextMask = 1; // Subtree Flags:
      // InvisibleParentSuspenseContext indicates that one of our parent Suspense
      // boundaries is not currently showing visible main content.
      // Either because it is already showing a fallback or is not mounted at all.
      // We can use this to determine if it is desirable to trigger a fallback at
      // the parent. If not, then we might need to trigger undesirable boundaries
      // and/or suspend the commit to avoid hiding the parent content.

      var InvisibleParentSuspenseContext = 1; // Shallow Flags:
      // ForceSuspenseFallback can be used by SuspenseList to force newly added
      // items into their fallback state during one of the render passes.

      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);
      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }
      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }
      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }
      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }
      function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
      }
      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }
      function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            // A dehydrated boundary always captures.
            return true;
          }
          return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.

        if (props.fallback === undefined) {
          return false;
        } // Regular boundaries always capture.

        if (props.unstable_avoidThisFallback !== true) {
          return true;
        } // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.

        if (hasInvisibleParent) {
          return false;
        } // If the parent is not able to handle it, we must handle it.

        return true;
      }
      function findFirstSuspended(row) {
        var node = row;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              var dehydrated = state.dehydrated;
              if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent &&
          // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          node.memoizedProps.revealOrder !== undefined) {
            var didSuspend = (node.effectTag & DidCapture) !== NoEffect;
            if (didSuspend) {
              return node;
            }
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === row) {
            return null;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === row) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return null;
      }
      function createDeprecatedResponderListener(responder, props) {
        var eventResponderListener = {
          responder: responder,
          props: props
        };
        {
          Object.freeze(eventResponderListener);
        }
        return eventResponderListener;
      }
      var HasEffect = /* */
      1; // Represents the phase in which the effect (not the clean-up) fires.

      var Layout = /*    */
      2;
      var Passive$1 = /*   */
      4;
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      {
        didWarnAboutMismatchedHooksForComponent = new Set();
      }

      // These are set right before calling the component.
      var renderExpirationTime = NoWork; // The work-in-progress fiber. I've named it differently to distinguish it from
      // the work-in-progress hook.

      var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
      // current hook list is the list that belongs to the current fiber. The
      // work-in-progress hook list is a new list that will be added to the
      // work-in-progress fiber.

      var currentHook = null;
      var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
      // does not get reset if we do another render pass; only when we're completely
      // finished evaluating this component. This is an optimization so we know
      // whether we need to clear render phase updates after a throw.

      var didScheduleRenderPhaseUpdate = false;
      var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook

      var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
      // The list stores the order of hooks used during the initial render (mount).
      // Subsequent renders (updates) reference this list.

      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
      // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
      // When true, such Hooks will always be "remounted". Only used during hot reload.

      var ignorePreviousDependencies = false;
      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }
      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }
      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== undefined && deps !== null && !Array.isArray(deps)) {
            // Verify deps, but only on mount to avoid extra checks.
            // It's unlikely their type would change as usually you define them inline.
            error('%s received a final argument that is not an array (instead, received `%s`). When ' + 'specified, the final argument must be an array.', currentHookNameInDev, typeof deps);
          }
        }
      }
      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentName(currentlyRenderingFiber$1.type);
          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
              var table = '';
              var secondColumnStart = 30;
              for (var i = 0; i <= hookTypesUpdateIndexDev; i++) {
                var oldHookName = hookTypesDev[i];
                var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                // lol @ IE not supporting String#repeat

                while (row.length < secondColumnStart) {
                  row += ' ';
                }
                row += newHookName + '\n';
                table += row;
              }
              error('React has detected a change in the order of Hooks called by %s. ' + 'This will lead to bugs and errors if not fixed. ' + 'For more information, read the Rules of Hooks: https://fb.me/rules-of-hooks\n\n' + '   Previous render            Next render\n' + '   ------------------------------------------------------\n' + '%s' + '   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n', componentName, table);
            }
          }
        }
      }
      function throwInvalidHookError() {
        {
          {
            throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.");
          }
        }
      }
      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            // Only true when this component is being hot reloaded.
            return false;
          }
        }
        if (prevDeps === null) {
          {
            error('%s received a final argument during this render, but not during ' + 'the previous render. Even though the final argument is optional, ' + 'its type cannot change between renders.', currentHookNameInDev);
          }
          return false;
        }
        {
          // Don't bother comparing lengths in prod because these arrays should be
          // passed inline.
          if (nextDeps.length !== prevDeps.length) {
            error('The final argument passed to %s changed size between renders. The ' + 'order and size of this array must remain constant.\n\n' + 'Previous: %s\n' + 'Incoming: %s', currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
          }
        }
        for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
          if (objectIs(nextDeps[i], prevDeps[i])) {
            continue;
          }
          return false;
        }
        return true;
      }
      function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderExpirationTime) {
        renderExpirationTime = nextRenderExpirationTime;
        currentlyRenderingFiber$1 = workInProgress;
        {
          hookTypesDev = current !== null ? current._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1; // Used for hot reloading:

          ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        }
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.expirationTime = NoWork; // The following should have already been reset
        // currentHook = null;
        // workInProgressHook = null;
        // didScheduleRenderPhaseUpdate = false;
        // TODO Warn if no hooks are used at all during mount, then some are used during update.
        // Currently we will identify the update render as a mount because memoizedState === null.
        // This is tricky because it's valid for certain types of components (e.g. React.lazy)
        // Using memoizedState to differentiate between mount/update only works if at least one stateful hook is used.
        // Non-stateful hooks (e.g. context) don't get added to memoizedState,
        // so memoizedState would be null during updates and mounts.

        {
          if (current !== null && current.memoizedState !== null) {
            ReactCurrentDispatcher.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            // This dispatcher handles an edge case where a component is updating,
            // but no stateful hooks have been used.
            // We want to match the production code behavior (which will use HooksDispatcherOnMount),
            // but with the extra DEV validation to ensure hooks ordering hasn't changed.
            // This dispatcher does that.
            ReactCurrentDispatcher.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component(props, secondArg); // Check if there was a render phase update

        if (workInProgress.expirationTime === renderExpirationTime) {
          // Keep rendering in a loop for as long as render phase updates continue to
          // be scheduled. Use a counter to prevent infinite loops.
          var numberOfReRenders = 0;
          do {
            workInProgress.expirationTime = NoWork;
            if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
              {
                throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
              }
            }
            numberOfReRenders += 1;
            {
              // Even when hot reloading, allow dependencies to stabilize
              // after first render to prevent infinite render phase updates.
              ignorePreviousDependencies = false;
            } // Start over from the beginning of the list

            currentHook = null;
            workInProgressHook = null;
            workInProgress.updateQueue = null;
            {
              // Also validate hook order for cascading updates.
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher.current = HooksDispatcherOnRerenderInDEV;
            children = Component(props, secondArg);
          } while (workInProgress.expirationTime === renderExpirationTime);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.

        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        {
          workInProgress._debugHookTypes = hookTypesDev;
        } // This check uses currentHook so that it works the same in DEV and prod bundles.
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.

        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
        }
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) {
          {
            throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
          }
        }
        return children;
      }
      function bailoutHooks(current, workInProgress, expirationTime) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.effectTag &= ~(Passive | Update);
        if (current.expirationTime <= expirationTime) {
          current.expirationTime = NoWork;
        }
      }
      function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
          // There were render phase updates. These are only valid for this render
          // phase, which we are now aborting. Remove the updates from the queues so
          // they do not persist to the next render. Do not remove updates from hooks
          // that weren't processed.
          //
          // Only reset the updates from the queue if it has a clone. If it does
          // not have a clone, that means it wasn't processed, and the updates were
          // scheduled before we entered the render phase.
          var hook = currentlyRenderingFiber$1.memoizedState;
          while (hook !== null) {
            var queue = hook.queue;
            if (queue !== null) {
              queue.pending = null;
            }
            hook = hook.next;
          }
        }
        renderExpirationTime = NoWork;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        if (workInProgressHook === null) {
          // This is the first hook in the list
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          // Append to the end of the list
          workInProgressHook = workInProgressHook.next = hook;
        }
        return workInProgressHook;
      }
      function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
          var current = currentlyRenderingFiber$1.alternate;
          if (current !== null) {
            nextCurrentHook = current.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }
        var nextWorkInProgressHook;
        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }
        if (nextWorkInProgressHook !== null) {
          // There's already a work-in-progress. Reuse it.
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          // Clone from the current hook.
          if (!(nextCurrentHook !== null)) {
            {
              throw Error("Rendered more hooks than during the previous render.");
            }
          }
          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };
          if (workInProgressHook === null) {
            // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }
        return workInProgressHook;
      }
      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null
        };
      }
      function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
      }
      function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) {
          initialState = init(initialArg);
        } else {
          initialState = initialArg;
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.

        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.

        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
          // We have new updates that haven't been processed yet.
          // We'll add them to the base queue.
          if (baseQueue !== null) {
            // Merge the pending queue and the base queue.
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          current.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }
        if (baseQueue !== null) {
          // We have a queue to process.
          var first = baseQueue.next;
          var newState = current.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;
          do {
            var updateExpirationTime = update.expirationTime;
            if (updateExpirationTime < renderExpirationTime) {
              // Priority is insufficient. Skip this update. If this is the first
              // skipped update, the previous update/state is the new base
              // update/state.
              var clone = {
                expirationTime: update.expirationTime,
                suspenseConfig: update.suspenseConfig,
                action: update.action,
                eagerReducer: update.eagerReducer,
                eagerState: update.eagerState,
                next: null
              };
              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone;
              } // Update the remaining priority in the queue.

              if (updateExpirationTime > currentlyRenderingFiber$1.expirationTime) {
                currentlyRenderingFiber$1.expirationTime = updateExpirationTime;
                markUnprocessedUpdateTime(updateExpirationTime);
              }
            } else {
              // This update does have sufficient priority.
              if (newBaseQueueLast !== null) {
                var _clone = {
                  expirationTime: Sync,
                  // This update is going to be committed so we never want uncommit it.
                  suspenseConfig: update.suspenseConfig,
                  action: update.action,
                  eagerReducer: update.eagerReducer,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              } // Mark the event time of this update as relevant to this render pass.
              // TODO: This should ideally use the true event time of this update rather than
              // its priority which is a derived and not reverseable value.
              // TODO: We should skip this update if it was already committed but currently
              // we have no way of detecting the difference between a committed and suspended
              // update here.

              markRenderEventTimeAndConfig(updateExpirationTime, update.suspenseConfig); // Process this update.

              if (update.eagerReducer === reducer) {
                // If this update was processed eagerly, and its reducer matches the
                // current reducer, we can use the eagerly computed state.
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }
            update = update.next;
          } while (update !== null && update !== first);
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          } // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }
      function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) {
          {
            throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
          }
        }
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.

        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
          // The queue doesn't persist past this render pass.
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;
          do {
            // Process this render phase update. We don't have to check the
            // priority because it will always be the same as the current
            // render's.
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
          // different from the current state.

          if (!objectIs(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
          // the base state unless the queue is empty.
          // TODO: Not sure if this is the desired semantics, but it's what we
          // do for gDSFP. I can't remember why.

          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }
          queue.lastRenderedState = newState;
        }
        return [newState, dispatch];
      }
      function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') {
          // $FlowFixMe: Flow doesn't like mixed types
          initialState = initialState();
        }
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateState(initialState) {
        return updateReducer(basicStateReducer);
      }
      function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
      }
      function pushEffect(tag, create, destroy, deps) {
        var effect = {
          tag: tag,
          create: create,
          destroy: destroy,
          deps: deps,
          // Circular
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;
          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }
        return effect;
      }
      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
          current: initialValue
        };
        {
          Object.seal(ref);
        }
        hook.memoizedState = ref;
        return ref;
      }
      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }
      function mountEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, undefined, nextDeps);
      }
      function updateEffectImpl(fiberEffectTag, hookEffectTag, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy = prevEffect.destroy;
          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              pushEffect(hookEffectTag, create, destroy, nextDeps);
              return;
            }
          }
        }
        currentlyRenderingFiber$1.effectTag |= fiberEffectTag;
        hook.memoizedState = pushEffect(HasEffect | hookEffectTag, create, destroy, nextDeps);
      }
      function mountEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function updateEffect(create, deps) {
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
          }
        }
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
      }
      function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
      }
      function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
      }
      function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
          var refCallback = ref;
          var _inst = create();
          refCallback(_inst);
          return function () {
            refCallback(null);
          };
        } else if (ref !== null && ref !== undefined) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty('current')) {
              error('Expected useImperativeHandle() first argument to either be a ' + 'ref callback or React.createRef() object. Instead received: %s.', 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            }
          }
          var _inst2 = create();
          refObject.current = _inst2;
          return function () {
            refObject.current = null;
          };
        }
      }
      function mountImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function updateImperativeHandle(ref, create, deps) {
        {
          if (typeof create !== 'function') {
            error('Expected useImperativeHandle() second argument to be a function ' + 'that creates a handle. Instead received: %s.', create !== null ? typeof create : 'null');
          }
        } // TODO: If deps are provided, should we skip comparing the ref itself?

        var effectDeps = deps !== null && deps !== undefined ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
      }
      function mountDebugValue(value, formatterFn) {// This hook is normally a no-op.
        // The react-debug-hooks package injects its own implementation
        // so that e.g. DevTools can display custom hook values.
      }
      var updateDebugValue = mountDebugValue;
      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          // Assume these are defined. If they're not, areHookInputsEqual will warn.
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function mountDeferredValue(value, config) {
        var _mountState = mountState(value),
          prevValue = _mountState[0],
          setValue = _mountState[1];
        mountEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function updateDeferredValue(value, config) {
        var _updateState = updateState(),
          prevValue = _updateState[0],
          setValue = _updateState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function rerenderDeferredValue(value, config) {
        var _rerenderState = rerenderState(),
          prevValue = _rerenderState[0],
          setValue = _rerenderState[1];
        updateEffect(function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setValue(value);
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        }, [value, config]);
        return prevValue;
      }
      function startTransition(setPending, config, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function () {
          setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority ? NormalPriority : priorityLevel, function () {
          var previousConfig = ReactCurrentBatchConfig$1.suspense;
          ReactCurrentBatchConfig$1.suspense = config === undefined ? null : config;
          try {
            setPending(false);
            callback();
          } finally {
            ReactCurrentBatchConfig$1.suspense = previousConfig;
          }
        });
      }
      function mountTransition(config) {
        var _mountState2 = mountState(false),
          isPending = _mountState2[0],
          setPending = _mountState2[1];
        var start = mountCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function updateTransition(config) {
        var _updateState2 = updateState(),
          isPending = _updateState2[0],
          setPending = _updateState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function rerenderTransition(config) {
        var _rerenderState2 = rerenderState(),
          isPending = _rerenderState2[0],
          setPending = _rerenderState2[1];
        var start = updateCallback(startTransition.bind(null, setPending, config), [setPending, config]);
        return [start, isPending];
      }
      function dispatchAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === 'function') {
            error("State updates from the useState() and useReducer() Hooks don't support the " + 'second callback argument. To execute a side effect after ' + 'rendering, declare it in the component body with useEffect().');
          }
        }
        var currentTime = requestCurrentTimeForUpdate();
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, fiber, suspenseConfig);
        var update = {
          expirationTime: expirationTime,
          suspenseConfig: suspenseConfig,
          action: action,
          eagerReducer: null,
          eagerState: null,
          next: null
        };
        {
          update.priority = getCurrentPriorityLevel();
        } // Append the update to the end of the list.

        var pending = queue.pending;
        if (pending === null) {
          // This is the first update. Create a circular list.
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
          // This is a render phase update. Stash it in a lazily-created map of
          // queue -> linked list of updates. After this render pass, we'll restart
          // and apply the stashed updates on top of the work-in-progress hook.
          didScheduleRenderPhaseUpdate = true;
          update.expirationTime = renderExpirationTime;
          currentlyRenderingFiber$1.expirationTime = renderExpirationTime;
        } else {
          if (fiber.expirationTime === NoWork && (alternate === null || alternate.expirationTime === NoWork)) {
            // The queue is currently empty, which means we can eagerly compute the
            // next state before entering the render phase. If the new state is the
            // same as the current state, we may be able to bail out entirely.
            var lastRenderedReducer = queue.lastRenderedReducer;
            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher.current;
                ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }
              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                // it, on the update object. If the reducer hasn't changed by the
                // time we enter the render phase, then the eager state can be used
                // without calling the reducer again.

                update.eagerReducer = lastRenderedReducer;
                update.eagerState = eagerState;
                if (objectIs(eagerState, currentState)) {
                  // Fast path. We can bail out without scheduling React to re-render.
                  // It's still possible that we'll need to rebase this update later,
                  // if the component re-renders for a different reason and by that
                  // time the reducer has changed.
                  return;
                }
              } catch (error) {// Suppress the error. It will throw again in the render phase.
              } finally {
                {
                  ReactCurrentDispatcher.current = prevDispatcher;
                }
              }
            }
          }
          {
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
              warnIfNotScopedWithMatchingAct(fiber);
              warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
          }
          scheduleWork(fiber, expirationTime);
        }
      }
      var ContextOnlyDispatcher = {
        readContext: _readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useResponder: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function warnInvalidContextAccess() {
          error('Context can only be read while React is rendering. ' + 'In classes, you can read it in the render method or getDerivedStateFromProps. ' + 'In function components, you can read it directly in the function body, but not ' + 'inside Hooks like useReducer() or useMemo().');
        };
        var warnInvalidHookAccess = function warnInvalidHookAccess() {
          error('Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. ' + 'You can only call Hooks at the top level of your React function. ' + 'For more information, see ' + 'https://fb.me/rules-of-hooks');
        };
        HooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition(config);
          }
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition(config);
          }
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function readContext(context, observedBits) {
            warnInvalidContextAccess();
            return _readContext(context, observedBits);
          },
          useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function useContext(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return _readContext(context, observedBits);
          },
          useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
          },
          useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
          },
          useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
          },
          useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create, deps);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderState(initialState);
            } finally {
              ReactCurrentDispatcher.current = prevDispatcher;
            }
          },
          useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useResponder: function useResponder(responder, props) {
            currentHookNameInDev = 'useResponder';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return createDeprecatedResponderListener(responder, props);
          },
          useDeferredValue: function useDeferredValue(value, config) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, config);
          },
          useTransition: function useTransition(config) {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition(config);
          }
        };
      }
      var now$1 = Scheduler.unstable_now;
      var commitTime = 0;
      var profilerStartTime = -1;
      function getCommitTime() {
        return commitTime;
      }
      function recordCommitTime() {
        commitTime = now$1();
      }
      function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$1();
        }
      }
      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }
      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$1() - profilerStartTime;
          fiber.actualDuration += elapsedTime;
          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }
          profilerStartTime = -1;
        }
      }

      // This may have been an insertion or a hydration.

      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;
      function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
      }
      function deleteHydratableInstance(returnFiber, instance) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
              break;
            case HostComponent:
              didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
              break;
          }
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.effectTag = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.

        if (returnFiber.lastEffect !== null) {
          returnFiber.lastEffect.nextEffect = childToDelete;
          returnFiber.lastEffect = childToDelete;
        } else {
          returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
        }
      }
      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.effectTag = fiber.effectTag & ~Hydrating | Placement;
        {
          switch (returnFiber.tag) {
            case HostRoot:
              {
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch (fiber.tag) {
                  case HostComponent:
                    var type = fiber.type;
                    var props = fiber.pendingProps;
                    didNotFindHydratableContainerInstance(parentContainer, type);
                    break;
                  case HostText:
                    var text = fiber.pendingProps;
                    didNotFindHydratableContainerTextInstance(parentContainer, text);
                    break;
                }
                break;
              }
            case HostComponent:
              {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch (fiber.tag) {
                  case HostComponent:
                    var _type = fiber.type;
                    var _props = fiber.pendingProps;
                    didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                    break;
                  case HostText:
                    var _text = fiber.pendingProps;
                    didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                    break;
                  case SuspenseComponent:
                    didNotFindHydratableSuspenseInstance(parentType, parentProps);
                    break;
                }
                break;
              }
            default:
              return;
          }
        }
      }
      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent:
            {
              var type = fiber.type;
              var props = fiber.pendingProps;
              var instance = canHydrateInstance(nextInstance, type);
              if (instance !== null) {
                fiber.stateNode = instance;
                return true;
              }
              return false;
            }
          case HostText:
            {
              var text = fiber.pendingProps;
              var textInstance = canHydrateTextInstance(nextInstance, text);
              if (textInstance !== null) {
                fiber.stateNode = textInstance;
                return true;
              }
              return false;
            }
          case SuspenseComponent:
            {
              return false;
            }
          default:
            return false;
        }
      }
      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
          // Nothing to hydrate. Make it an insertion.
          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
          // If we can't hydrate this instance let's try the next one.
          // We use this as a heuristic. It's based on intuition and not data so it
          // might be flawed or unnecessary.
          nextInstance = getNextHydratableSibling(firstAttemptedInstance);
          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          } // We matched the next one, we'll now assume that the first one was
          // superfluous and we'll delete it. Since we can't eagerly delete it
          // we'll have to schedule a deletion. To do that, this node needs a dummy
          // fiber associated with it.

          deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
      }
      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.

        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.

        if (updatePayload !== null) {
          return true;
        }
        return false;
      }
      function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        {
          if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) {
              switch (returnFiber.tag) {
                case HostRoot:
                  {
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                  }
                case HostComponent:
                  {
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
                  }
              }
            }
          }
        }
        return shouldUpdate;
      }
      function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) {
          {
            throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
      }
      function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
          parent = parent.return;
        }
        hydrationParentFiber = parent;
      }
      function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) {
          // We're deeper than the current hydration context, inside an inserted
          // tree.
          return false;
        }
        if (!isHydrating) {
          // If we're not currently hydrating but we're in a hydration context, then
          // we were an insertion and now need to pop up reenter hydration of our
          // siblings.
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.

        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
          var nextInstance = nextHydratableInstance;
          while (nextInstance) {
            deleteHydratableInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
          }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) {
          nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        } else {
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        }
        return true;
      }
      function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }
      function reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime) {
        if (current === null) {
          // If this is a fresh new component that hasn't been rendered yet, we
          // won't update its child set by applying minimal side-effects. Instead,
          // we will add them all to the child before it gets rendered. That means
          // we can optimize this reconciliation pass by not tracking side-effects.
          workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          // If the current child is the same as the work in progress, it means that
          // we haven't yet started any work on these children. Therefore, we use
          // the clone algorithm to create a copy of all the current children.
          // If we had any progressed work already, that is invalid at this point so
          // let's throw it out.
          workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderExpirationTime);
        }
      }
      function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderExpirationTime); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.

        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
      }
      function updateForwardRef(current, workInProgress, Component, nextProps, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens after the first render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent

        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
          if (workInProgress.mode & StrictMode) {
            // Only double-render components with Hooks
            if (workInProgress.memoizedState !== null) {
              nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderExpirationTime);
            }
          }
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        if (current === null) {
          var type = Component.type;
          if (isSimpleFunctionComponent(type) && Component.compare === null &&
          // SimpleMemoComponent codepath doesn't resolve outer props either.
          Component.defaultProps === undefined) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            } // If this is a plain function component without default props,
            // and with only the default shallow comparison, we upgrade it
            // to a SimpleMemoComponent to allow fast path updates.

            workInProgress.tag = SimpleMemoComponent;
            workInProgress.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress, type);
            }
            return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateExpirationTime, renderExpirationTime);
          }
          {
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) {
              // Inner memo component props aren't currently validated in createElement.
              // We could move it there, but we'd still need this for lazy code path.
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(type), getCurrentFiberStackInDev);
            }
          }
          var child = createFiberFromTypeAndProps(Component.type, null, nextProps, null, workInProgress.mode, renderExpirationTime);
          child.ref = workInProgress.ref;
          child.return = workInProgress;
          workInProgress.child = child;
          return child;
        }
        {
          var _type = Component.type;
          var _innerPropTypes = _type.propTypes;
          if (_innerPropTypes) {
            // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(_innerPropTypes, nextProps,
            // Resolved props
            'prop', getComponentName(_type), getCurrentFiberStackInDev);
          }
        }
        var currentChild = current.child; // This is always exactly one child

        if (updateExpirationTime < renderExpirationTime) {
          // This will be the props with resolved defaultProps,
          // unlike current.memoizedProps which will be the unresolved ones.
          var prevProps = currentChild.memoizedProps; // Default to shallow comparison

          var compare = Component.compare;
          compare = compare !== null ? compare : shallowEqual;
          if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) {
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
      }
      function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateExpirationTime, renderExpirationTime) {
        // TODO: current can be non-null here even if the component
        // hasn't yet mounted. This happens when the inner render suspends.
        // We'll need to figure out if this is fine or can cause issues.
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              // We warn when you define propTypes on lazy()
              // so let's just skip over it to find memo() outer wrapper.
              // Inner props for memo are validated later.
              outerMemoType = refineResolvedLazyComponent(outerMemoType);
            }
            var outerPropTypes = outerMemoType && outerMemoType.propTypes;
            if (outerPropTypes) {
              checkPropTypes(outerPropTypes, nextProps,
              // Resolved (SimpleMemoComponent has no defaultProps)
              'prop', getComponentName(outerMemoType), getCurrentFiberStackInDev);
            } // Inner propTypes will be validated in the function component path.
          }
        }

        if (current !== null) {
          var prevProps = current.memoizedProps;
          if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref &&
          // Prevent bailout if the implementation changed due to hot reload.
          workInProgress.type === current.type) {
            didReceiveUpdate = false;
            if (updateExpirationTime < renderExpirationTime) {
              // The pending update priority was cleared at the beginning of
              // beginWork. We're about to bail out, but there might be additional
              // updates at a lower priority. Usually, the priority level of the
              // remaining updates is accumlated during the evaluation of the
              // component (i.e. when processing the update queue). But since since
              // we're bailing out early *without* evaluating the component, we need
              // to account for it here, too. Reset to the value of the current fiber.
              // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
              // because a MemoComponent fiber does not have hooks or an update queue;
              // rather, it wraps around an inner component, which may or may not
              // contains hooks.
              // TODO: Move the reset at in beginWork out of the common path so that
              // this is no longer necessary.
              workInProgress.expirationTime = current.expirationTime;
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime);
      }
      function updateFragment(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateMode(current, workInProgress, renderExpirationTime) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateProfiler(current, workInProgress, renderExpirationTime) {
        {
          workInProgress.effectTag |= Update;
        }
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
          // Schedule a Ref effect
          workInProgress.effectTag |= Ref;
        }
      }
      function updateFunctionComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        }
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        var nextChildren;
        prepareToReadContext(workInProgress, renderExpirationTime);
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
          if (workInProgress.mode & StrictMode) {
            // Only double-render components with Hooks
            if (workInProgress.memoizedState !== null) {
              nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderExpirationTime);
            }
          }
          setIsRendering(false);
        }
        if (current !== null && !didReceiveUpdate) {
          bailoutHooks(current, workInProgress, renderExpirationTime);
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateClassComponent(current, workInProgress, Component, nextProps, renderExpirationTime) {
        {
          if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) {
              checkPropTypes(innerPropTypes, nextProps,
              // Resolved props
              'prop', getComponentName(Component), getCurrentFiberStackInDev);
            }
          }
        } // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
          if (current !== null) {
            // A class component without an instance only mounts if it suspended
            // inside a non-concurrent tree, in an inconsistent state. We want to
            // treat it like a new mount, even though an empty version of it already
            // committed. Disconnect the alternate pointers.
            current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

            workInProgress.effectTag |= Placement;
          } // In the initial pass we might need to construct the instance.

          constructClassInstance(workInProgress, Component, nextProps);
          mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
          shouldUpdate = true;
        } else if (current === null) {
          // In a resume, we'll already have an instance we can reuse.
          shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        } else {
          shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderExpirationTime);
        }
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime);
        {
          var inst = workInProgress.stateNode;
          if (inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error('It looks like %s is reassigning its own `this.props` while rendering. ' + 'This is not supported and can lead to confusing bugs.', getComponentName(workInProgress.type) || 'a component');
            }
            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }
      function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderExpirationTime) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (!shouldUpdate && !didCaptureError) {
          // Context providers should defer to sCU for rendering
          if (hasContext) {
            invalidateContextProvider(workInProgress, Component, false);
          }
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var instance = workInProgress.stateNode; // Rerender

        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
          // If we captured an error, but getDerivedStateFromError is not defined,
          // unmount all the children. componentDidCatch will schedule an update to
          // re-render a fallback. This is temporary until we migrate everyone to
          // the new API.
          // TODO: Warn in a future release.
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
              instance.render();
            }
            setIsRendering(false);
          }
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (current !== null && didCaptureError) {
          // If we're recovering from an error, reconcile without reusing any of
          // the existing children. Conceptually, the normal children and the children
          // that are shown on error are two different sets, so we shouldn't reuse
          // normal children even if their identities match.
          forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        } // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.

        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.

        if (hasContext) {
          invalidateContextProvider(workInProgress, Component, true);
        }
        return workInProgress.child;
      }
      function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) {
          pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        } else if (root.context) {
          // Should always be set
          pushTopLevelContextObject(workInProgress, root.context, false);
        }
        pushHostContainer(workInProgress, root.containerInfo);
      }
      function updateHostRoot(current, workInProgress, renderExpirationTime) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) {
          {
            throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderExpirationTime);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".

        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
          // If the state is the same as before, that's a bailout because we had
          // no work that expires at this time.
          resetHydrationState();
          return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
          // If we don't have any current children this might be the first pass.
          // We always try to hydrate. If this isn't a hydration pass there won't
          // be any children to hydrate which is effectively the same thing as
          // not hydrating.
          var child = mountChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
          workInProgress.child = child;
          var node = child;
          while (node) {
            // Mark each child as hydrating. This is a fast path to know whether this
            // tree is part of a hydrating tree. This is used to determine if a child
            // node has fully mounted yet, and for scheduling event replaying.
            // Conceptually this is similar to Placement in that a new subtree is
            // inserted into the React tree here. It just happens to not need DOM
            // mutations because it already exists.
            node.effectTag = node.effectTag & ~Placement | Hydrating;
            node = node.sibling;
          }
        } else {
          // Otherwise reset hydration state in case we aborted and resumed another
          // root.
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
          resetHydrationState();
        }
        return workInProgress.child;
      }
      function updateHostComponent(current, workInProgress, renderExpirationTime) {
        pushHostContext(workInProgress);
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        }
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) {
          // We special case a direct text child of a host node. This is a common
          // case. We won't handle it as a reified child. We will instead handle
          // this in the host environment that also has access to this prop. That
          // avoids allocating another HostText fiber and traversing it.
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          // If we're switching from a direct text child to a normal child, or to
          // empty, we need to schedule the text content to be reset.
          workInProgress.effectTag |= ContentReset;
        }
        markRef(current, workInProgress); // Check the host config to see if the children are offscreen/hidden.

        if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(type, nextProps)) {
          {
            markSpawnedWork(Never);
          } // Schedule this fiber to re-render at offscreen priority. Then bailout.

          workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
          return null;
        }
        reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function updateHostText(current, workInProgress) {
        if (current === null) {
          tryToClaimNextHydratableInstance(workInProgress);
        } // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.

        return null;
      }
      function mountLazyComponent(_current, workInProgress, elementType, updateExpirationTime, renderExpirationTime) {
        if (_current !== null) {
          // A lazy component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps; // We can't start a User Timing measurement with correct label yet.
        // Cancel and resume right after we know the tag.

        cancelWorkTimer(workInProgress);
        var Component = readLazyComponentType(elementType); // Store the unwrapped component in the type.

        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        startWorkTimer(workInProgress);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch (resolvedTag) {
          case FunctionComponent:
            {
              {
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
              }
              child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ClassComponent:
            {
              {
                workInProgress.type = Component = resolveClassForHotReloading(Component);
              }
              child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case ForwardRef:
            {
              {
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
              }
              child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderExpirationTime);
              return child;
            }
          case MemoComponent:
            {
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = Component.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, resolvedProps,
                    // Resolved for outer only
                    'prop', getComponentName(Component), getCurrentFiberStackInDev);
                  }
                }
              }
              child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps),
              // The inner type can have defaults too
              updateExpirationTime, renderExpirationTime);
              return child;
            }
        }
        var hint = '';
        {
          if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) {
            hint = ' Did you wrap a component in React.lazy() more than once?';
          }
        } // This message intentionally doesn't mention ForwardRef or MemoComponent
        // because the fact that it's a separate type of work is an
        // implementation detail.

        {
          {
            throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
          }
        }
      }
      function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderExpirationTime) {
        if (_current !== null) {
          // An incomplete component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        } // Promote the fiber to a class and try rendering again.

        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.

        var hasContext;
        if (isContextProvider(Component)) {
          hasContext = true;
          pushContextProvider(workInProgress);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderExpirationTime);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
      }
      function mountIndeterminateComponent(_current, workInProgress, Component, renderExpirationTime) {
        if (_current !== null) {
          // An indeterminate component only mounts if it suspended inside a non-
          // concurrent tree, in an inconsistent state. We want to treat it like
          // a new mount, even though an empty version of it already committed.
          // Disconnect the alternate pointers.
          _current.alternate = null;
          workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect

          workInProgress.effectTag |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
          context = getMaskedContext(workInProgress, unmaskedContext);
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var value;
        {
          if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
              error("The <%s /> component appears to have a render method, but doesn't extend React.Component. " + 'This is likely to cause errors. Change %s to extend React.Component instead.', componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
          if (workInProgress.mode & StrictMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
          }
          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress;
          value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
          {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error('The <%s /> component appears to be a function component that returns a class instance. ' + 'Change %s to a class that extends React.Component instead. ' + "If you can't use a class try assigning the prototype on the function as a workaround. " + "`%s.prototype = React.Component.prototype`. Don't use an arrow function since it " + 'cannot be called with `new` by React.', _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          } // Proceed under the assumption that this is a class instance

          workInProgress.tag = ClassComponent; // Throw out any hooks that were used.

          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
          // During mounting we don't know the child context yet as the instance doesn't exist.
          // We will invalidate the child context in finishClassComponent() right after rendering.

          var hasContext = false;
          if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
          } else {
            hasContext = false;
          }
          workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
          initializeUpdateQueue(workInProgress);
          var getDerivedStateFromProps = Component.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
          }
          adoptClassInstance(workInProgress, value);
          mountClassInstance(workInProgress, Component, props, renderExpirationTime);
          return finishClassComponent(null, workInProgress, Component, true, hasContext, renderExpirationTime);
        } else {
          // Proceed under the assumption that this is a function component
          workInProgress.tag = FunctionComponent;
          {
            if (workInProgress.mode & StrictMode) {
              // Only double-render components with Hooks
              if (workInProgress.memoizedState !== null) {
                value = renderWithHooks(null, workInProgress, Component, props, context, renderExpirationTime);
              }
            }
          }
          reconcileChildren(null, workInProgress, value, renderExpirationTime);
          {
            validateFunctionComponentInDev(workInProgress, Component);
          }
          return workInProgress.child;
        }
      }
      function validateFunctionComponentInDev(workInProgress, Component) {
        {
          if (Component) {
            if (Component.childContextTypes) {
              error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
            }
          }
          if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) {
              info += '\n\nCheck the render method of `' + ownerName + '`.';
            }
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) {
              warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            }
            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error('Function components cannot be given refs. ' + 'Attempts to access this ref will fail. ' + 'Did you mean to use React.forwardRef()?%s', info);
            }
          }
          if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2]) {
              error('%s: Function components do not support getDerivedStateFromProps.', _componentName2);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName2] = true;
            }
          }
          if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName3]) {
              error('%s: Function components do not support contextType.', _componentName3);
              didWarnAboutContextTypeOnFunctionComponent[_componentName3] = true;
            }
          }
        }
      }
      var SUSPENDED_MARKER = {
        dehydrated: null,
        retryTime: NoWork
      };
      function shouldRemainOnFallback(suspenseContext, current, workInProgress) {
        // If the context is telling us that we should show a fallback, and we're not
        // already showing content, then we should show the fallback instead.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback) && (current === null || current.memoizedState !== null);
      }
      function updateSuspenseComponent(current, workInProgress, renderExpirationTime) {
        var mode = workInProgress.mode;
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.

        {
          if (shouldSuspend(workInProgress)) {
            workInProgress.effectTag |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var nextDidTimeout = false;
        var didSuspend = (workInProgress.effectTag & DidCapture) !== NoEffect;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
          // Something in this boundary's subtree already suspended. Switch to
          // rendering the fallback children.
          nextDidTimeout = true;
          workInProgress.effectTag &= ~DidCapture;
        } else {
          // Attempting the main content
          if (current === null || current.memoizedState !== null) {
            // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // This next part is a bit confusing. If the children timeout, we switch to
        // showing the fallback children in place of the "primary" children.
        // However, we don't want to delete the primary children because then their
        // state will be lost (both the React state and the host state, e.g.
        // uncontrolled form inputs). Instead we keep them mounted and hide them.
        // Both the fallback children AND the primary children are rendered at the
        // same time. Once the primary children are un-suspended, we can delete
        // the fallback children — don't need to preserve their state.
        //
        // The two sets of children are siblings in the host environment, but
        // semantically, for purposes of reconciliation, they are two separate sets.
        // So we store them using two fragment fibers.
        //
        // However, we want to avoid allocating extra fibers for every placeholder.
        // They're only necessary when the children time out, because that's the
        // only time when both sets are mounted.
        //
        // So, the extra fragment fibers are only used if the children time out.
        // Otherwise, we render the primary children directly. This requires some
        // custom reconciliation logic to preserve the state of the primary
        // children. It's essentially a very basic form of re-parenting.

        if (current === null) {
          // If we're currently hydrating, try to hydrate this boundary.
          // But only if this has a fallback.
          if (nextProps.fallback !== undefined) {
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
          } // This is the initial mount. This branch is pretty simple because there's
          // no previous state that needs to be preserved.

          if (nextDidTimeout) {
            // Mount separate fragments for primary and fallback children.
            var nextFallbackChildren = nextProps.fallback;
            var primaryChildFragment = createFiberFromFragment(null, mode, NoWork, null);
            primaryChildFragment.return = workInProgress;
            if ((workInProgress.mode & BlockingMode) === NoMode) {
              // Outside of blocking mode, we commit the effects from the
              // partially completed, timed-out tree, too.
              var progressedState = workInProgress.memoizedState;
              var progressedPrimaryChild = progressedState !== null ? workInProgress.child.child : workInProgress.child;
              primaryChildFragment.child = progressedPrimaryChild;
              var progressedChild = progressedPrimaryChild;
              while (progressedChild !== null) {
                progressedChild.return = primaryChildFragment;
                progressedChild = progressedChild.sibling;
              }
            }
            var fallbackChildFragment = createFiberFromFragment(nextFallbackChildren, mode, renderExpirationTime, null);
            fallbackChildFragment.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildFragment; // Skip the primary children, and continue working on the
            // fallback children.

            workInProgress.memoizedState = SUSPENDED_MARKER;
            workInProgress.child = primaryChildFragment;
            return fallbackChildFragment;
          } else {
            // Mount the primary children without an intermediate fragment fiber.
            var nextPrimaryChildren = nextProps.children;
            workInProgress.memoizedState = null;
            return workInProgress.child = mountChildFibers(workInProgress, null, nextPrimaryChildren, renderExpirationTime);
          }
        } else {
          // This is an update. This branch is more complicated because we need to
          // ensure the state of the primary children is preserved.
          var prevState = current.memoizedState;
          if (prevState !== null) {
            // wrapped in a fragment fiber.

            var currentPrimaryChildFragment = current.child;
            var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
            if (nextDidTimeout) {
              // Still timed out. Reuse the current primary children by cloning
              // its fragment. We're going to skip over these entirely.
              var _nextFallbackChildren2 = nextProps.fallback;
              var _primaryChildFragment2 = createWorkInProgress(currentPrimaryChildFragment, currentPrimaryChildFragment.pendingProps);
              _primaryChildFragment2.return = workInProgress;
              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState = workInProgress.memoizedState;
                var _progressedPrimaryChild = _progressedState !== null ? workInProgress.child.child : workInProgress.child;
                if (_progressedPrimaryChild !== currentPrimaryChildFragment.child) {
                  _primaryChildFragment2.child = _progressedPrimaryChild;
                  var _progressedChild2 = _progressedPrimaryChild;
                  while (_progressedChild2 !== null) {
                    _progressedChild2.return = _primaryChildFragment2;
                    _progressedChild2 = _progressedChild2.sibling;
                  }
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration = 0;
                var _hiddenChild = _primaryChildFragment2.child;
                while (_hiddenChild !== null) {
                  _treeBaseDuration += _hiddenChild.treeBaseDuration;
                  _hiddenChild = _hiddenChild.sibling;
                }
                _primaryChildFragment2.treeBaseDuration = _treeBaseDuration;
              } // Clone the fallback child fragment, too. These we'll continue
              // working on.

              var _fallbackChildFragment2 = createWorkInProgress(currentFallbackChildFragment, _nextFallbackChildren2);
              _fallbackChildFragment2.return = workInProgress;
              _primaryChildFragment2.sibling = _fallbackChildFragment2;
              _primaryChildFragment2.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment2;
              return _fallbackChildFragment2;
            } else {
              // No longer suspended. Switch back to showing the primary children,
              // and remove the intermediate fragment fiber.
              var _nextPrimaryChildren = nextProps.children;
              var currentPrimaryChild = currentPrimaryChildFragment.child;
              var primaryChild = reconcileChildFibers(workInProgress, currentPrimaryChild, _nextPrimaryChildren, renderExpirationTime); // If this render doesn't suspend, we need to delete the fallback
              // children. Wait until the complete phase, after we've confirmed the
              // fallback is no longer needed.
              // TODO: Would it be better to store the fallback fragment on
              // the stateNode?
              // Continue rendering the children, like we normally do.

              workInProgress.memoizedState = null;
              return workInProgress.child = primaryChild;
            }
          } else {
            // The current tree has not already timed out. That means the primary
            // children are not wrapped in a fragment fiber.
            var _currentPrimaryChild = current.child;
            if (nextDidTimeout) {
              // Timed out. Wrap the children in a fragment fiber to keep them
              // separate from the fallback children.
              var _nextFallbackChildren3 = nextProps.fallback;
              var _primaryChildFragment3 = createFiberFromFragment(
              // It shouldn't matter what the pending props are because we aren't
              // going to render this fragment.
              null, mode, NoWork, null);
              _primaryChildFragment3.return = workInProgress;
              _primaryChildFragment3.child = _currentPrimaryChild;
              if (_currentPrimaryChild !== null) {
                _currentPrimaryChild.return = _primaryChildFragment3;
              } // Even though we're creating a new fiber, there are no new children,
              // because we're reusing an already mounted tree. So we don't need to
              // schedule a placement.
              // primaryChildFragment.effectTag |= Placement;

              if ((workInProgress.mode & BlockingMode) === NoMode) {
                // Outside of blocking mode, we commit the effects from the
                // partially completed, timed-out tree, too.
                var _progressedState2 = workInProgress.memoizedState;
                var _progressedPrimaryChild2 = _progressedState2 !== null ? workInProgress.child.child : workInProgress.child;
                _primaryChildFragment3.child = _progressedPrimaryChild2;
                var _progressedChild3 = _progressedPrimaryChild2;
                while (_progressedChild3 !== null) {
                  _progressedChild3.return = _primaryChildFragment3;
                  _progressedChild3 = _progressedChild3.sibling;
                }
              } // Because primaryChildFragment is a new fiber that we're inserting as the
              // parent of a new tree, we need to set its treeBaseDuration.

              if (workInProgress.mode & ProfileMode) {
                // treeBaseDuration is the sum of all the child tree base durations.
                var _treeBaseDuration2 = 0;
                var _hiddenChild2 = _primaryChildFragment3.child;
                while (_hiddenChild2 !== null) {
                  _treeBaseDuration2 += _hiddenChild2.treeBaseDuration;
                  _hiddenChild2 = _hiddenChild2.sibling;
                }
                _primaryChildFragment3.treeBaseDuration = _treeBaseDuration2;
              } // Create a fragment from the fallback children, too.

              var _fallbackChildFragment3 = createFiberFromFragment(_nextFallbackChildren3, mode, renderExpirationTime, null);
              _fallbackChildFragment3.return = workInProgress;
              _primaryChildFragment3.sibling = _fallbackChildFragment3;
              _fallbackChildFragment3.effectTag |= Placement;
              _primaryChildFragment3.childExpirationTime = NoWork; // Skip the primary children, and continue working on the
              // fallback children.

              workInProgress.memoizedState = SUSPENDED_MARKER;
              workInProgress.child = _primaryChildFragment3;
              return _fallbackChildFragment3;
            } else {
              // Still haven't timed out. Continue rendering the children, like we
              // normally do.
              workInProgress.memoizedState = null;
              var _nextPrimaryChildren2 = nextProps.children;
              return workInProgress.child = reconcileChildFibers(workInProgress, _currentPrimaryChild, _nextPrimaryChildren2, renderExpirationTime);
            }
          }
        }
      }
      function scheduleWorkOnFiber(fiber, renderExpirationTime) {
        if (fiber.expirationTime < renderExpirationTime) {
          fiber.expirationTime = renderExpirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < renderExpirationTime) {
          alternate.expirationTime = renderExpirationTime;
        }
        scheduleWorkOnParentPath(fiber.return, renderExpirationTime);
      }
      function propagateSuspenseContextChange(workInProgress, firstChild, renderExpirationTime) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              scheduleWorkOnFiber(node, renderExpirationTime);
            }
          } else if (node.tag === SuspenseListComponent) {
            // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderExpirationTime);
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === workInProgress) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === workInProgress) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while (row !== null) {
          var currentRow = row.alternate; // New rows can't be content rows.

          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }
          row = row.sibling;
        }
        return lastContentRow;
      }
      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') {
              switch (revealOrder.toLowerCase()) {
                case 'together':
                case 'forwards':
                case 'backwards':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                case 'forward':
                case 'backward':
                  {
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. ' + 'React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                default:
                  error('"%s" is not a supported revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error('%s is not a supported value for revealOrder on <SuspenseList />. ' + 'Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }
      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
              didWarnAboutTailOptions[tailMode] = true;
              error('"%s" is not a supported value for tail on <SuspenseList />. ' + 'Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
              didWarnAboutTailOptions[tailMode] = true;
              error('<SuspenseList tail="%s" /> is only valid if revealOrder is ' + '"forwards" or "backwards". ' + 'Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }
      function validateSuspenseListNestedChild(childSlot, index) {
        {
          var isArray = Array.isArray(childSlot);
          var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
          if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error('A nested %s was passed to row #%s in <SuspenseList />. Wrap it in ' + 'an additional SuspenseList to configure its revealOrder: ' + '<SuspenseList revealOrder=...> ... ' + '<SuspenseList revealOrder=...>{%s}</SuspenseList> ... ' + '</SuspenseList>', type, index, type);
            return false;
          }
        }
        return true;
      }
      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                if (!validateSuspenseListNestedChild(children[i], i)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);
              if (typeof iteratorFn === 'function') {
                var childrenIterator = iteratorFn.call(children);
                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;
                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }
                    _i++;
                  }
                }
              } else {
                error('A single row was passed to a <SuspenseList revealOrder="%s" />. ' + 'This is not useful since it needs multiple rows. ' + 'Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }
      function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) {
          workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailExpiration: 0,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
          };
        } else {
          // We can reuse the existing object from previous renders.
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailExpiration = 0;
          renderState.tailMode = tailMode;
          renderState.lastEffect = lastEffectBeforeRendering;
        }
      } // This can end up rendering this component multiple passes.
      // The first pass splits the children fibers into two sets. A head and tail.
      // We first render the head. If anything is in fallback state, we do another
      // pass through beginWork to rerender all children (including the tail) with
      // the force suspend context. If the first render didn't have anything in
      // in fallback state. Then we render each row in the tail one-by-one.
      // That happens in the completeWork phase without going back to beginWork.

      function updateSuspenseListComponent(current, workInProgress, renderExpirationTime) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress.effectTag |= DidCapture;
        } else {
          var didSuspendBefore = current !== null && (current.effectTag & DidCapture) !== NoEffect;
          if (didSuspendBefore) {
            // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderExpirationTime);
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) {
          // Outside of blocking mode, SuspenseList doesn't work so we just
          // use make it a noop by treating it as the default revealOrder.
          workInProgress.memoizedState = null;
        } else {
          switch (revealOrder) {
            case 'forwards':
              {
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                  // The whole list is part of the tail.
                  // TODO: We could fast path by just rendering the tail now.
                  tail = workInProgress.child;
                  workInProgress.child = null;
                } else {
                  // Disconnect the tail rows after the content row.
                  // We're going to render them separately later.
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
              }
            case 'backwards':
              {
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while (row !== null) {
                  var currentRow = row.alternate; // New rows can't be content rows.

                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    // This is the beginning of the main content.
                    workInProgress.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.

                initSuspenseListRenderState(workInProgress, true,
                // isBackwards
                _tail, null,
                // last
                tailMode, workInProgress.lastEffect);
                break;
              }
            case 'together':
              {
                initSuspenseListRenderState(workInProgress, false,
                // isBackwards
                null,
                // tail
                null,
                // last
                undefined, workInProgress.lastEffect);
                break;
              }
            default:
              {
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
              }
          }
        }
        return workInProgress.child;
      }
      function updatePortalComponent(current, workInProgress, renderExpirationTime) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) {
          // Portals are special because we don't append the children during mount
          // but at commit. Therefore we need to track insertions which the normal
          // flow doesn't do during mount. This doesn't happen at the root because
          // the root always starts with a "current" with a null child.
          // TODO: Consider unifying this with how the root works.
          workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderExpirationTime);
        } else {
          reconcileChildren(current, workInProgress, nextChildren, renderExpirationTime);
        }
        return workInProgress.child;
      }
      function updateContextProvider(current, workInProgress, renderExpirationTime) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        {
          var providerPropTypes = workInProgress.type.propTypes;
          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider', getCurrentFiberStackInDev);
          }
        }
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
          var oldValue = oldProps.value;
          var changedBits = calculateChangedBits(context, newValue, oldValue);
          if (changedBits === 0) {
            // No change. Bailout early if children are the same.
            if (oldProps.children === newProps.children && !hasContextChanged()) {
              return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
            }
          } else {
            // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderExpirationTime);
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      var hasWarnedAboutUsingContextAsConsumer = false;
      function updateContextConsumer(current, workInProgress, renderExpirationTime) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        // DEV mode, we create a separate object for Context.Consumer that acts
        // like a proxy to Context. This proxy object adds unnecessary code in PROD
        // so we use the old behaviour (Context.Consumer references Context) to
        // reduce size and overhead. The separate object references context via
        // a property called "_context", which also gives us the ability to check
        // in DEV mode if this property exists or not and warn if it does not.

        {
          if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error('Rendering <Context> directly is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
              }
            }
          } else {
            context = context._context;
          }
        }
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        {
          if (typeof render !== 'function') {
            error('A context consumer was rendered with multiple children, or a child ' + "that isn't a function. A context consumer expects a single child " + 'that is a function. If you did pass a function, make sure there ' + 'is no trailing or leading whitespace around it.');
          }
        }
        prepareToReadContext(workInProgress, renderExpirationTime);
        var newValue = _readContext(context, newProps.unstable_observedBits);
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress;
          setIsRendering(true);
          newChildren = render(newValue);
          setIsRendering(false);
        } // React DevTools reads this flag.

        workInProgress.effectTag |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderExpirationTime);
        return workInProgress.child;
      }
      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }
      function bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime) {
        cancelWorkTimer(workInProgress);
        if (current !== null) {
          // Reuse previous dependencies
          workInProgress.dependencies = current.dependencies;
        }
        {
          // Don't update "base" render times for bailouts.
          stopProfilerTimerIfRunning();
        }
        var updateExpirationTime = workInProgress.expirationTime;
        if (updateExpirationTime !== NoWork) {
          markUnprocessedUpdateTime(updateExpirationTime);
        } // Check if the children have any pending work.

        var childExpirationTime = workInProgress.childExpirationTime;
        if (childExpirationTime < renderExpirationTime) {
          // The children don't have any work either. We can skip them.
          // TODO: Once we add back resuming, we should check if the children are
          // a work-in-progress set. If so, we need to transfer their effects.
          return null;
        } else {
          // This fiber doesn't have work, but its subtree does. Clone the child
          // fibers and continue.
          cloneChildFibers(current, workInProgress);
          return workInProgress.child;
        }
      }
      function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress.return;
          if (returnFiber === null) {
            throw new Error('Cannot swap the root fiber.');
          } // Disconnect from the old current.
          // It will get deleted.

          current.alternate = null;
          oldWorkInProgress.alternate = null; // Connect to the new tree.

          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress.return = oldWorkInProgress.return;
          newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.

          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) {
              throw new Error('Expected parent to have a child.');
            }
            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;
              if (prevSibling === null) {
                throw new Error('Expected to find the previous sibling.');
              }
            }
            prevSibling.sibling = newWorkInProgress;
          } // Delete the old fiber and place the new one.
          // Since the old fiber is disconnected, we have to schedule it manually.

          var last = returnFiber.lastEffect;
          if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
          } else {
            returnFiber.firstEffect = returnFiber.lastEffect = current;
          }
          current.nextEffect = null;
          current.effectTag = Deletion;
          newWorkInProgress.effectTag |= Placement; // Restart work from the new fiber.

          return newWorkInProgress;
        }
      }
      function beginWork(current, workInProgress, renderExpirationTime) {
        var updateExpirationTime = workInProgress.expirationTime;
        {
          if (workInProgress._debugNeedsRemount && current !== null) {
            // This will restart the begin phase with a new fiber.
            return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.expirationTime));
          }
        }
        if (current !== null) {
          var oldProps = current.memoizedProps;
          var newProps = workInProgress.pendingProps;
          if (oldProps !== newProps || hasContextChanged() ||
          // Force a re-render if the implementation changed due to hot reload:
          workInProgress.type !== current.type) {
            // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
          } else if (updateExpirationTime < renderExpirationTime) {
            didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
            // the begin phase. There's still some bookkeeping we that needs to be done
            // in this optimized path, mostly pushing stuff onto the stack.

            switch (workInProgress.tag) {
              case HostRoot:
                pushHostRootContext(workInProgress);
                resetHydrationState();
                break;
              case HostComponent:
                pushHostContext(workInProgress);
                if (workInProgress.mode & ConcurrentMode && renderExpirationTime !== Never && shouldDeprioritizeSubtree(workInProgress.type, newProps)) {
                  {
                    markSpawnedWork(Never);
                  } // Schedule this fiber to re-render at offscreen priority. Then bailout.

                  workInProgress.expirationTime = workInProgress.childExpirationTime = Never;
                  return null;
                }
                break;
              case ClassComponent:
                {
                  var Component = workInProgress.type;
                  if (isContextProvider(Component)) {
                    pushContextProvider(workInProgress);
                  }
                  break;
                }
              case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
              case ContextProvider:
                {
                  var newValue = workInProgress.memoizedProps.value;
                  pushProvider(workInProgress, newValue);
                  break;
                }
              case Profiler:
                {
                  // Profiler should only call onRender when one of its descendants actually rendered.
                  var hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (hasChildWork) {
                    workInProgress.effectTag |= Update;
                  }
                }
                break;
              case SuspenseComponent:
                {
                  var state = workInProgress.memoizedState;
                  if (state !== null) {
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.

                    var primaryChildFragment = workInProgress.child;
                    var primaryChildExpirationTime = primaryChildFragment.childExpirationTime;
                    if (primaryChildExpirationTime !== NoWork && primaryChildExpirationTime >= renderExpirationTime) {
                      // The primary children have pending work. Use the normal path
                      // to attempt to render the primary children again.
                      return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
                    } else {
                      pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                      // priority. Bailout.

                      var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
                      if (child !== null) {
                        // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
              case SuspenseListComponent:
                {
                  var didSuspendBefore = (current.effectTag & DidCapture) !== NoEffect;
                  var _hasChildWork = workInProgress.childExpirationTime >= renderExpirationTime;
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      // If something was in fallback state last time, and we have all the
                      // same children then we're still in progressive loading state.
                      // Something might get unblocked by state updates or retries in the
                      // tree which will affect the tail. So we need to use the normal
                      // path to compute the correct tail.
                      return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
                    } // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.

                    workInProgress.effectTag |= DidCapture;
                  } // If nothing suspended before and we're rendering the same children,
                  // then the tail doesn't matter. Anything new that suspends will work
                  // in the "together" mode, so we can continue from the state we had.

                  var renderState = workInProgress.memoizedState;
                  if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                  }
                  pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    return null;
                  }
                }
            }
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderExpirationTime);
          } else {
            // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
          }
        } else {
          didReceiveUpdate = false;
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.

        workInProgress.expirationTime = NoWork;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
            {
              return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderExpirationTime);
            }
          case LazyComponent:
            {
              var elementType = workInProgress.elementType;
              return mountLazyComponent(current, workInProgress, elementType, updateExpirationTime, renderExpirationTime);
            }
          case FunctionComponent:
            {
              var _Component = workInProgress.type;
              var unresolvedProps = workInProgress.pendingProps;
              var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderExpirationTime);
            }
          case ClassComponent:
            {
              var _Component2 = workInProgress.type;
              var _unresolvedProps = workInProgress.pendingProps;
              var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderExpirationTime);
            }
          case HostRoot:
            return updateHostRoot(current, workInProgress, renderExpirationTime);
          case HostComponent:
            return updateHostComponent(current, workInProgress, renderExpirationTime);
          case HostText:
            return updateHostText(current, workInProgress);
          case SuspenseComponent:
            return updateSuspenseComponent(current, workInProgress, renderExpirationTime);
          case HostPortal:
            return updatePortalComponent(current, workInProgress, renderExpirationTime);
          case ForwardRef:
            {
              var type = workInProgress.type;
              var _unresolvedProps2 = workInProgress.pendingProps;
              var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
              return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderExpirationTime);
            }
          case Fragment:
            return updateFragment(current, workInProgress, renderExpirationTime);
          case Mode:
            return updateMode(current, workInProgress, renderExpirationTime);
          case Profiler:
            return updateProfiler(current, workInProgress, renderExpirationTime);
          case ContextProvider:
            return updateContextProvider(current, workInProgress, renderExpirationTime);
          case ContextConsumer:
            return updateContextConsumer(current, workInProgress, renderExpirationTime);
          case MemoComponent:
            {
              var _type2 = workInProgress.type;
              var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.

              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress.type !== workInProgress.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(outerPropTypes, _resolvedProps3,
                    // Resolved for outer only
                    'prop', getComponentName(_type2), getCurrentFiberStackInDev);
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateExpirationTime, renderExpirationTime);
            }
          case SimpleMemoComponent:
            {
              return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateExpirationTime, renderExpirationTime);
            }
          case IncompleteClassComponent:
            {
              var _Component3 = workInProgress.type;
              var _unresolvedProps4 = workInProgress.pendingProps;
              var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderExpirationTime);
            }
          case SuspenseListComponent:
            {
              return updateSuspenseListComponent(current, workInProgress, renderExpirationTime);
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.effectTag |= Update;
      }
      function markRef$1(workInProgress) {
        workInProgress.effectTag |= Ref;
      }
      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent$1;
      var updateHostText$1;
      {
        // Mutation mode
        appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
          // We only have the top Fiber that was created but we need recurse down its
          // children to find all the terminal nodes.
          var node = workInProgress.child;
          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal) ;else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === workInProgress) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        updateHostContainer = function updateHostContainer(workInProgress) {// Noop
        };
        updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
          // If we have an alternate, that means this is an update and we need to
          // schedule a side-effect to do the updates.
          var oldProps = current.memoizedProps;
          if (oldProps === newProps) {
            // In mutation mode, this is sufficient for a bailout because
            // we won't touch this node even if children changed.
            return;
          } // If we get updated because one of our children updated, we don't
          // have newProps so we'll have to reuse them.
          // TODO: Split the update API as separate for the props vs. children.
          // Even better would be if children weren't special cased at all tho.

          var instance = workInProgress.stateNode;
          var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
          // component is hitting the resume path. Figure out why. Possibly
          // related to `hidden`.

          var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.

          workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
          // is a new ref we mark this as an update. All the work is done in commitWork.

          if (updatePayload) {
            markUpdate(workInProgress);
          }
        };
        updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
          // If the text differs, mark it as an update. All the work in done in commitWork.
          if (oldText !== newText) {
            markUpdate(workInProgress);
          }
        };
      }
      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        switch (renderState.tailMode) {
          case 'hidden':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (lastTailNode === null) {
                // All remaining items in the tail are insertions.
                renderState.tail = null;
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
              }
              break;
            }
          case 'collapsed':
            {
              // Any insertions at the end of the tail list after this point
              // should be invisible. If there are already mounted boundaries
              // anything before them are not considered for collapsing.
              // Therefore we need to go through the whole tail to find if
              // there are any.
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              } // Next we're simply going to delete all insertions after the
              // last rendered item.

              if (_lastTailNode === null) {
                // All remaining items in the tail are insertions.
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  // We suspended during the head. We want to show at least one
                  // row at the tail. So we'll keep on and cut off the rest.
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
              }
              break;
            }
        }
      }
      function completeWork(current, workInProgress, renderExpirationTime) {
        var newProps = workInProgress.pendingProps;
        switch (workInProgress.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            return null;
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var fiberRoot = workInProgress.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current === null || current.child === null) {
                // If we hydrated, pop so that we can delete any remaining children
                // that weren't hydrated.
                var wasHydrated = popHydrationState(workInProgress);
                if (wasHydrated) {
                  // If we hydrated, then we'll need to schedule an update for
                  // the commit side-effects on the root.
                  markUpdate(workInProgress);
                }
              }
              updateHostContainer(workInProgress);
              return null;
            }
          case HostComponent:
            {
              popHostContext(workInProgress);
              var rootContainerInstance = getRootHostContainer();
              var type = workInProgress.type;
              if (current !== null && workInProgress.stateNode != null) {
                updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                if (current.ref !== workInProgress.ref) {
                  markRef$1(workInProgress);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.

                  return null;
                }
                var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                // "stack" as the parent. Then append children as we go in beginWork
                // or completeWork depending on whether we want to add them top->down or
                // bottom->up. Top->down is faster in IE11.

                var _wasHydrated = popHydrationState(workInProgress);
                if (_wasHydrated) {
                  // TODO: Move this and createInstance step into the beginPhase
                  // to consolidate.
                  if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) {
                    // If changes to the hydrated node need to be applied at the
                    // commit-phase we mark this as such.
                    markUpdate(workInProgress);
                  }
                } else {
                  var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                  appendAllChildren(instance, workInProgress, false, false); // This needs to be set before we mount Flare event listeners

                  workInProgress.stateNode = instance;
                  // (eg DOM renderer supports auto-focus for certain elements).
                  // Make sure such renderers get scheduled for later work.

                  if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) {
                    markUpdate(workInProgress);
                  }
                }
                if (workInProgress.ref !== null) {
                  // If there is a ref on a host node we need to schedule a callback
                  markRef$1(workInProgress);
                }
              }
              return null;
            }
          case HostText:
            {
              var newText = newProps;
              if (current && workInProgress.stateNode != null) {
                var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                // to schedule a side-effect to do the updates.

                updateHostText$1(current, workInProgress, oldText, newText);
              } else {
                if (typeof newText !== 'string') {
                  if (!(workInProgress.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  } // This can happen when we abort work.
                }

                var _rootContainerInstance = getRootHostContainer();
                var _currentHostContext = getHostContext();
                var _wasHydrated2 = popHydrationState(workInProgress);
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance(workInProgress)) {
                    markUpdate(workInProgress);
                  }
                } else {
                  workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
              }
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var nextState = workInProgress.memoizedState;
              if ((workInProgress.effectTag & DidCapture) !== NoEffect) {
                // Something suspended. Re-render with the fallback children.
                workInProgress.expirationTime = renderExpirationTime; // Do not reset the effect list.

                return workInProgress;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current === null) {
                if (workInProgress.memoizedProps.fallback !== undefined) {
                  popHydrationState(workInProgress);
                }
              } else {
                var prevState = current.memoizedState;
                prevDidTimeout = prevState !== null;
                if (!nextDidTimeout && prevState !== null) {
                  // We just switched from the fallback to the normal children.
                  // Delete the fallback.
                  // TODO: Would it be better to store the fallback fragment on
                  // the stateNode during the begin phase?
                  var currentFallbackChild = current.child.sibling;
                  if (currentFallbackChild !== null) {
                    // Deletions go at the beginning of the return fiber's effect list
                    var first = workInProgress.firstEffect;
                    if (first !== null) {
                      workInProgress.firstEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = first;
                    } else {
                      workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChild;
                      currentFallbackChild.nextEffect = null;
                    }
                    currentFallbackChild.effectTag = Deletion;
                  }
                }
              }
              if (nextDidTimeout && !prevDidTimeout) {
                // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                if ((workInProgress.mode & BlockingMode) !== NoMode) {
                  // TODO: Move this back to throwException because this is too late
                  // if this is a large tree which is common for initial loads. We
                  // don't know if we should restart a render or not until we get
                  // this marker, and this is too late.
                  // If this render already had a ping or lower pri updates,
                  // and this is the first time we know we're going to suspend we
                  // should be able to immediately restart from within throwException.
                  var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    // If this was in an invisible tree or a new render, then showing
                    // this boundary is ok.
                    renderDidSuspend();
                  } else {
                    // Otherwise, we're going to have to hide content so we should
                    // suspend for longer if possible.
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) {
                  // If this boundary just timed out, schedule an effect to attach a
                  // retry listener to the promise. This flag is also used to hide the
                  // primary children. In mutation mode, we also need the flag to
                  // *unhide* children that were previously hidden, so check if this
                  // is currently timed out, too.
                  workInProgress.effectTag |= Update;
                }
              }
              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            updateHostContainer(workInProgress);
            return null;
          case ContextProvider:
            // Pop provider fiber
            popProvider(workInProgress);
            return null;
          case IncompleteClassComponent:
            {
              // Same as class component case. I put it down here so that the tags are
              // sequential to ensure this switch is compiled to a jump table.
              var _Component = workInProgress.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress);
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress);
              var renderState = workInProgress.memoizedState;
              if (renderState === null) {
                // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
              }
              var didSuspendAlready = (workInProgress.effectTag & DidCapture) !== NoEffect;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                // We just rendered the head.
                if (!didSuspendAlready) {
                  // This is the first pass. We need to figure out if anything is still
                  // suspended in the rendered set.
                  // If new content unsuspended, but there's still some content that
                  // didn't. Then we need to do a second pass that forces everything
                  // to keep showing their fallbacks.
                  // We might be suspended if something in this render pass suspended, or
                  // something in the previous committed pass suspended. Otherwise,
                  // there's no chance so we can skip the expensive call to
                  // findFirstSuspended.
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.effectTag & DidCapture) === NoEffect);
                  if (!cannotBeSuspended) {
                    var row = workInProgress.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress.effectTag |= DidCapture;
                        cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                        // part of the second pass. In that case nothing will subscribe to
                        // its thennables. Instead, we'll transfer its thennables to the
                        // SuspenseList so that it can retry if they resolve.
                        // There might be multiple of these in the list but since we're
                        // going to wait for all of them anyway, it doesn't really matter
                        // which ones gets to ping. In theory we could get clever and keep
                        // track of how many dependencies remain but it gets tricky because
                        // in the meantime, we can add/remove/change items and dependencies.
                        // We might bail out of the loop before finding any but that
                        // doesn't matter since that means that the other boundaries that
                        // we did find already has their listeners attached.

                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress.updateQueue = newThennables;
                          workInProgress.effectTag |= Update;
                        } // Rerender the whole list, but this time, we'll force fallbacks
                        // to stay in place.
                        // Reset the effect list before doing the second pass since that's now invalid.

                        if (renderState.lastEffect === null) {
                          workInProgress.firstEffect = null;
                        }
                        workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.

                        resetChildFibers(workInProgress, renderExpirationTime); // Set up the Suspense Context to force suspense and immediately
                        // rerender the children.

                        pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress.child;
                      }
                      row = row.sibling;
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                } // Next we're going to render the tail.
              } else {
                // Append the rendered row to the child list.
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                    // get lost if this row ends up dropped during a second pass.

                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress.updateQueue = _newThennables;
                      workInProgress.effectTag |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true); // This might have been modified.

                    if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate) {
                      // We need to delete the row we just rendered.
                      // Reset the effect list to what it was before we rendered this
                      // child. The nested children have already appended themselves.
                      var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.

                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      } // We're done.

                      return null;
                    }
                  } else if (
                  // The time it took to render last row is greater than time until
                  // the expiration.
                  now() * 2 - renderState.renderingStartTime > renderState.tailExpiration && renderExpirationTime > Never) {
                    // We have now passed our CPU deadline and we'll just give up further
                    // attempts to render the main content and only render fallbacks.
                    // The assumption is that this is usually faster.
                    workInProgress.effectTag |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                    // to get it started back up to attempt the next item. If we can show
                    // them, then they really have the same priority as this render.
                    // So we'll pick it back up the very next render pass once we've had
                    // an opportunity to yield for paint.

                    var nextPriority = renderExpirationTime - 1;
                    workInProgress.expirationTime = workInProgress.childExpirationTime = nextPriority;
                    {
                      markSpawnedWork(nextPriority);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  // The effect list of the backwards tail will have been added
                  // to the end. This breaks the guarantee that life-cycles fire in
                  // sibling order but that isn't a strong guarantee promised by React.
                  // Especially since these might also just pop in during future commits.
                  // Append to the beginning of the list.
                  renderedTail.sibling = workInProgress.child;
                  workInProgress.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                // We still have tail rows to render.
                if (renderState.tailExpiration === 0) {
                  // Heuristic for how long we're willing to spend rendering rows
                  // until we just give up and show what we have so far.
                  var TAIL_EXPIRATION_TIMEOUT_MS = 500;
                  renderState.tailExpiration = now() + TAIL_EXPIRATION_TIMEOUT_MS; // TODO: This is meant to mimic the train model or JND but this
                  // is a per component value. It should really be since the start
                  // of the total render or last commit. Consider using something like
                  // globalMostRecentFallbackTime. That doesn't account for being
                  // suspended for part of the time or when it's a new render.
                  // It should probably use a global start time value instead.
                } // Pop a row.

                var next = renderState.tail;
                renderState.rendering = next;
                renderState.tail = next.sibling;
                renderState.lastEffect = workInProgress.lastEffect;
                renderState.renderingStartTime = now();
                next.sibling = null; // Restore the context.
                // TODO: We can probably just avoid popping it instead and only
                // setting it the first time we go from not suspended to suspended.

                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.

                return next;
              }
              return null;
            }
        }
        {
          {
            throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function unwindWork(workInProgress, renderExpirationTime) {
        switch (workInProgress.tag) {
          case ClassComponent:
            {
              var Component = workInProgress.type;
              if (isContextProvider(Component)) {
                popContext(workInProgress);
              }
              var effectTag = workInProgress.effectTag;
              if (effectTag & ShouldCapture) {
                workInProgress.effectTag = effectTag & ~ShouldCapture | DidCapture;
                return workInProgress;
              }
              return null;
            }
          case HostRoot:
            {
              popHostContainer(workInProgress);
              popTopLevelContextObject(workInProgress);
              var _effectTag = workInProgress.effectTag;
              if (!((_effectTag & DidCapture) === NoEffect)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress.effectTag = _effectTag & ~ShouldCapture | DidCapture;
              return workInProgress;
            }
          case HostComponent:
            {
              // TODO: popHydrationState
              popHostContext(workInProgress);
              return null;
            }
          case SuspenseComponent:
            {
              popSuspenseContext(workInProgress);
              var _effectTag2 = workInProgress.effectTag;
              if (_effectTag2 & ShouldCapture) {
                workInProgress.effectTag = _effectTag2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.

                return workInProgress;
              }
              return null;
            }
          case SuspenseListComponent:
            {
              popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
              // caught by a nested boundary. If not, it should bubble through.

              return null;
            }
          case HostPortal:
            popHostContainer(workInProgress);
            return null;
          case ContextProvider:
            popProvider(workInProgress);
            return null;
          default:
            return null;
        }
      }
      function unwindInterruptedWork(interruptedWork) {
        switch (interruptedWork.tag) {
          case ClassComponent:
            {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== undefined) {
                popContext(interruptedWork);
              }
              break;
            }
          case HostRoot:
            {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              break;
            }
          case HostComponent:
            {
              popHostContext(interruptedWork);
              break;
            }
          case HostPortal:
            popHostContainer(interruptedWork);
            break;
          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;
          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;
          case ContextProvider:
            popProvider(interruptedWork);
            break;
        }
      }
      function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
          value: value,
          source: source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }
      function logCapturedError(capturedError) {
        var error = capturedError.error;
        {
          var componentName = capturedError.componentName,
            componentStack = capturedError.componentStack,
            errorBoundaryName = capturedError.errorBoundaryName,
            errorBoundaryFound = capturedError.errorBoundaryFound,
            willRetry = capturedError.willRetry; // Browsers support silencing uncaught errors by calling
          // `preventDefault()` in window `error` handler.
          // We record this information as an expando on the error.

          if (error != null && error._suppressLogging) {
            if (errorBoundaryFound && willRetry) {
              // The error is recoverable and was silenced.
              // Ignore it and don't print the stack addendum.
              // This is handy for testing error boundaries without noise.
              return;
            } // The error is fatal. Since the silencing might have
            // been accidental, we'll surface it anyway.
            // However, the browser would have silenced the original error
            // so we'll print it first, and then print the stack addendum.

            console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
          }

          var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
          var errorBoundaryMessage; // errorBoundaryFound check is sufficient; errorBoundaryName check is to satisfy Flow.

          if (errorBoundaryFound && errorBoundaryName) {
            if (willRetry) {
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            } else {
              errorBoundaryMessage = "This error was initially handled by the error boundary " + errorBoundaryName + ".\n" + "Recreating the tree from scratch failed so React will unmount the tree.";
            }
          } else {
            errorBoundaryMessage = 'Consider adding an error boundary to your tree to customize error handling behavior.\n' + 'Visit https://fb.me/react-error-boundaries to learn more about error boundaries.';
          }
          var combinedMessage = "" + componentNameMessage + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
          // We don't include the original error message and JS stack because the browser
          // has already printed it. Even if the application swallows the error, it is still
          // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.

          console['error'](combinedMessage); // Don't transform to our wrapper
        }
      }

      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
      }
      var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
      function logError(boundary, errorInfo) {
        var source = errorInfo.source;
        var stack = errorInfo.stack;
        if (stack === null && source !== null) {
          stack = getStackByFiberInDevAndProd(source);
        }
        var capturedError = {
          componentName: source !== null ? getComponentName(source.type) : null,
          componentStack: stack !== null ? stack : '',
          error: errorInfo.value,
          errorBoundary: null,
          errorBoundaryName: null,
          errorBoundaryFound: false,
          willRetry: false
        };
        if (boundary !== null && boundary.tag === ClassComponent) {
          capturedError.errorBoundary = boundary.stateNode;
          capturedError.errorBoundaryName = getComponentName(boundary.type);
          capturedError.errorBoundaryFound = true;
          capturedError.willRetry = true;
        }
        try {
          logCapturedError(capturedError);
        } catch (e) {
          // This method must not throw, or React internal state will get messed up.
          // If console.error is overridden, or logCapturedError() shows a dialog that throws,
          // we want to report this error outside of the normal stack as a last resort.
          // https://github.com/facebook/react/issues/13188
          setTimeout(function () {
            throw e;
          });
        }
      }
      var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        startPhaseTimer(current, 'componentWillUnmount');
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
        stopPhaseTimer();
      }; // Capture errors so they don't interrupt unmounting.

      function safelyCallComponentWillUnmount(current, instance) {
        {
          invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
          if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
          }
        }
      }
      function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
          if (typeof ref === 'function') {
            {
              invokeGuardedCallback(null, ref, null, null);
              if (hasCaughtError()) {
                var refError = clearCaughtError();
                captureCommitPhaseError(current, refError);
              }
            }
          } else {
            ref.current = null;
          }
        }
      }
      function safelyCallDestroy(current, destroy) {
        {
          invokeGuardedCallback(null, destroy, null);
          if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
          }
        }
      }
      function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              return;
            }
          case ClassComponent:
            {
              if (finishedWork.effectTag & Snapshot) {
                if (current !== null) {
                  var prevProps = current.memoizedProps;
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'getSnapshotBeforeUpdate');
                  var instance = finishedWork.stateNode; // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'getSnapshotBeforeUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error('%s.getSnapshotBeforeUpdate(): A snapshot value (or null) ' + 'must be returned. You have returned undefined.', getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                  stopPhaseTimer();
                }
              }
              return;
            }
          case HostRoot:
          case HostComponent:
          case HostText:
          case HostPortal:
          case IncompleteClassComponent:
            // Nothing to do for these component types
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Unmount
              var destroy = effect.destroy;
              effect.destroy = undefined;
              if (destroy !== undefined) {
                destroy();
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & tag) === tag) {
              // Mount
              var create = effect.create;
              effect.destroy = create();
              {
                var destroy = effect.destroy;
                if (destroy !== undefined && typeof destroy !== 'function') {
                  var addendum = void 0;
                  if (destroy === null) {
                    addendum = ' You returned null. If your effect does not require clean ' + 'up, return undefined (or nothing).';
                  } else if (typeof destroy.then === 'function') {
                    addendum = '\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + 'useEffect(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://fb.me/react-hooks-data-fetching';
                  } else {
                    addendum = ' You returned: ' + destroy;
                  }
                  error('An effect function must not return anything besides a function, ' + 'which is used for clean-up.%s%s', addendum, getStackByFiberInDevAndProd(finishedWork));
                }
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitPassiveHookEffects(finishedWork) {
        if ((finishedWork.effectTag & Passive) !== NoEffect) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
              {
                // TODO (#17945) We should call all passive destroy functions (for all fibers)
                // before calling any create functions. The current approach only serializes
                // these for a single fiber.
                commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork);
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
              }
          }
        }
      }
      function commitLifeCycles(finishedRoot, current, finishedWork, committedExpirationTime) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent:
          case Block:
            {
              // At this point layout effects have already been destroyed (during mutation phase).
              // This is done to prevent sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListMount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              var instance = finishedWork.stateNode;
              if (finishedWork.effectTag & Update) {
                if (current === null) {
                  startPhaseTimer(finishedWork, 'componentDidMount'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidMount. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidMount();
                  stopPhaseTimer();
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                  var prevState = current.memoizedState;
                  startPhaseTimer(finishedWork, 'componentDidUpdate'); // We could update instance props and state here,
                  // but instead we rely on them being set during last render.
                  // TODO: revisit this when we implement resuming.

                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error('Expected %s props to match memoized props before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error('Expected %s state to match memoized state before ' + 'componentDidUpdate. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                      }
                    }
                  }
                  instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  stopPhaseTimer();
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error('Expected %s props to match memoized props before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error('Expected %s state to match memoized state before ' + 'processing the update queue. ' + 'This might either be because of a bug in React, or because ' + 'a component reassigns its own `this.props`. ' + 'Please file an issue.', getComponentName(finishedWork.type) || 'instance');
                    }
                  }
                } // We could update instance props and state here,
                // but instead we rely on them being set during last render.
                // TODO: revisit this when we implement resuming.

                commitUpdateQueue(finishedWork, updateQueue, instance);
              }
              return;
            }
          case HostRoot:
            {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
          case HostComponent:
            {
              var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
              // (eg DOM renderer may schedule auto-focus for inputs and form controls).
              // These effects should only be committed when components are first mounted,
              // aka when there is no current/alternate.

              if (current === null && finishedWork.effectTag & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type, props);
              }
              return;
            }
          case HostText:
            {
              // We have no life-cycles associated with text.
              return;
            }
          case HostPortal:
            {
              // We have no life-cycles associated with portals.
              return;
            }
          case Profiler:
            {
              {
                var onRender = finishedWork.memoizedProps.onRender;
                if (typeof onRender === 'function') {
                  {
                    onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, getCommitTime(), finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
          case SuspenseComponent:
            {
              commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
              return;
            }
          case SuspenseListComponent:
          case IncompleteClassComponent:
          case FundamentalComponent:
          case ScopeComponent:
            return;
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function hideOrUnhideAllChildren(finishedWork, isHidden) {
        {
          // We only have the top Fiber that was inserted but we need to recurse down its
          // children to find all the terminal nodes.
          var node = finishedWork;
          while (true) {
            if (node.tag === HostComponent) {
              var instance = node.stateNode;
              if (isHidden) {
                hideInstance(instance);
              } else {
                unhideInstance(node.stateNode, node.memoizedProps);
              }
            } else if (node.tag === HostText) {
              var _instance3 = node.stateNode;
              if (isHidden) {
                hideTextInstance(_instance3);
              } else {
                unhideTextInstance(_instance3, node.memoizedProps);
              }
            } else if (node.tag === SuspenseComponent && node.memoizedState !== null && node.memoizedState.dehydrated === null) {
              // Found a nested Suspense component that timed out. Skip over the
              // primary child fragment, which should remain hidden.
              var fallbackChildFragment = node.child.sibling;
              fallbackChildFragment.return = node;
              node = fallbackChildFragment;
              continue;
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === finishedWork) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
      }
      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
          var instance = finishedWork.stateNode;
          var instanceToUse;
          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance);
              break;
            default:
              instanceToUse = instance;
          } // Moved outside to ensure DCE works with this flag

          if (typeof ref === 'function') {
            ref(instanceToUse);
          } else {
            {
              if (!ref.hasOwnProperty('current')) {
                error('Unexpected ref object provided for %s. ' + 'Use either a ref-setter function or React.createRef().%s', getComponentName(finishedWork.type), getStackByFiberInDevAndProd(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }
      function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
          if (typeof currentRef === 'function') {
            currentRef(null);
          } else {
            currentRef.current = null;
          }
        }
      } // User-originating errors (lifecycles and refs) should not interrupt
      // deletion, so don't let them throw. Host-originating errors should
      // interrupt deletion, so it's okay

      function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch (current.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              var updateQueue = current.updateQueue;
              if (updateQueue !== null) {
                var lastEffect = updateQueue.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  {
                    // When the owner fiber is deleted, the destroy function of a passive
                    // effect hook is called during the synchronous commit phase. This is
                    // a concession to implementation complexity. Calling it in the
                    // passive effect phase (like they usually are, when dependencies
                    // change during an update) would require either traversing the
                    // children of the deleted fiber again, or including unmount effects
                    // as part of the fiber effect list.
                    //
                    // Because this is during the sync commit phase, we need to change
                    // the priority.
                    //
                    // TODO: Reconsider this implementation trade off.
                    var priorityLevel = renderPriorityLevel > NormalPriority ? NormalPriority : renderPriorityLevel;
                    runWithPriority$1(priorityLevel, function () {
                      var effect = firstEffect;
                      do {
                        var _destroy = effect.destroy;
                        if (_destroy !== undefined) {
                          safelyCallDestroy(current, _destroy);
                        }
                        effect = effect.next;
                      } while (effect !== firstEffect);
                    });
                  }
                }
              }
              return;
            }
          case ClassComponent:
            {
              safelyDetachRef(current);
              var instance = current.stateNode;
              if (typeof instance.componentWillUnmount === 'function') {
                safelyCallComponentWillUnmount(current, instance);
              }
              return;
            }
          case HostComponent:
            {
              safelyDetachRef(current);
              return;
            }
          case HostPortal:
            {
              // TODO: this is recursive.
              // We are also not using this parent because
              // the portal will get pushed immediately.
              {
                unmountHostComponents(finishedRoot, current, renderPriorityLevel);
              }
              return;
            }
          case FundamentalComponent:
            {
              return;
            }
          case DehydratedFragment:
            {
              return;
            }
          case ScopeComponent:
            {
              return;
            }
        }
      }
      function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while (true) {
          commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because they may contain more composite or host nodes.
          // Skip portals because commitUnmount() currently visits them recursively.

          if (node.child !== null &&
          // If we use mutation we drill down into portals using commitUnmount above.
          // If we don't use mutation we drill down into portals here instead.
          node.tag !== HostPortal) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === root) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === root) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function detachFiber(current) {
        var alternate = current.alternate; // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.

        current.return = null;
        current.child = null;
        current.memoizedState = null;
        current.updateQueue = null;
        current.dependencies = null;
        current.alternate = null;
        current.firstEffect = null;
        current.lastEffect = null;
        current.pendingProps = null;
        current.memoizedProps = null;
        current.stateNode = null;
        if (alternate !== null) {
          detachFiber(alternate);
        }
      }
      function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }
          parent = parent.return;
        }
        {
          {
            throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }
      function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while (true) {
          // If we didn't find anything, let's try the next sibling.
          while (node.sibling === null) {
            if (node.return === null || isHostParent(node.return)) {
              // If we pop out of the root or hit the parent the fiber we are the
              // last sibling.
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
          while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
            // If it is not host node and, we might have a host node inside it.
            // Try to search down until we find one.
            if (node.effectTag & Placement) {
              // If we don't have a child, try the siblings instead.
              continue siblings;
            } // If we don't have a child, try the siblings instead.
            // We also skip portals because they are not part of this host tree.

            if (node.child === null || node.tag === HostPortal) {
              continue siblings;
            } else {
              node.child.return = node;
              node = node.child;
            }
          } // Check if this host node is stable or about to be placed.

          if (!(node.effectTag & Placement)) {
            // Found it!
            return node.stateNode;
          }
        }
      }
      function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.

        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch (parentFiber.tag) {
          case HostComponent:
            parent = parentStateNode;
            isContainer = false;
            break;
          case HostRoot:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case HostPortal:
            parent = parentStateNode.containerInfo;
            isContainer = true;
            break;
          case FundamentalComponent:

          // eslint-disable-next-line-no-fallthrough

          default:
            {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
        }
        if (parentFiber.effectTag & ContentReset) {
          // Reset the text content of the parent before doing any insertions
          resetTextContent(parent); // Clear ContentReset from the effect tag

          parentFiber.effectTag &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.

        if (isContainer) {
          insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        } else {
          insertOrAppendPlacementNode(finishedWork, before, parent);
        }
      }
      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
          var stateNode = isHost ? node.stateNode : node.stateNode.instance;
          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag === HostPortal) ;else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.

        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.

        var currentParent;
        var currentParentIsContainer;
        while (true) {
          if (!currentParentIsValid) {
            var parent = node.return;
            findParent: while (true) {
              if (!(parent !== null)) {
                {
                  throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var parentStateNode = parent.stateNode;
              switch (parent.tag) {
                case HostComponent:
                  currentParent = parentStateNode;
                  currentParentIsContainer = false;
                  break findParent;
                case HostRoot:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
                case HostPortal:
                  currentParent = parentStateNode.containerInfo;
                  currentParentIsContainer = true;
                  break findParent;
              }
              parent = parent.return;
            }
            currentParentIsValid = true;
          }
          if (node.tag === HostComponent || node.tag === HostText) {
            commitNestedUnmounts(finishedRoot, node, renderPriorityLevel); // After all the children have unmounted, it is now safe to remove the
            // node from the tree.

            if (currentParentIsContainer) {
              removeChildFromContainer(currentParent, node.stateNode);
            } else {
              removeChild(currentParent, node.stateNode);
            } // Don't visit children because we already visited them.
          } else if (node.tag === HostPortal) {
            if (node.child !== null) {
              // When we go into a portal, it becomes the parent to remove from.
              // We will reassign it back when we pop the portal on the way up.
              currentParent = node.stateNode.containerInfo;
              currentParentIsContainer = true; // Visit children because portals might contain host components.

              node.child.return = node;
              node = node.child;
              continue;
            }
          } else {
            commitUnmount(finishedRoot, node, renderPriorityLevel); // Visit children because we may find more host components below.

            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          }
          if (node === current) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === current) {
              return;
            }
            node = node.return;
            if (node.tag === HostPortal) {
              // When we go out of the portal, we need to restore the parent.
              // Since we don't keep a stack of them, we will search for it.
              currentParentIsValid = false;
            }
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        {
          // Recursively delete all host nodes from the parent.
          // Detach refs and call componentWillUnmount() on the whole subtree.
          unmountHostComponents(finishedRoot, current, renderPriorityLevel);
        }
        detachFiber(current);
      }
      function commitWork(current, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent:
          case Block:
            {
              // Layout effects are destroyed during the mutation phase so that all
              // destroy functions for all fibers are called before any create functions.
              // This prevents sibling component effects from interfering with each other,
              // e.g. a destroy function in one component should never override a ref set
              // by a create function in another component during the same commit.
              commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              return;
            }
          case ClassComponent:
            {
              return;
            }
          case HostComponent:
            {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                // Commit the work prepared earlier.
                var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.

                var oldProps = current !== null ? current.memoizedProps : newProps;
                var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.

                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
              }
              return;
            }
          case HostText:
            {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
              // as the newProps. The updatePayload will contain the real change in
              // this case.

              var oldText = current !== null ? current.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
          case HostRoot:
            {
              {
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                  // We've just hydrated. No need to hydrate again.
                  _root.hydrate = false;
                  commitHydratedContainer(_root.containerInfo);
                }
              }
              return;
            }
          case Profiler:
            {
              return;
            }
          case SuspenseComponent:
            {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case SuspenseListComponent:
            {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
          case IncompleteClassComponent:
            {
              return;
            }
        }
        {
          {
            throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        var newDidTimeout;
        var primaryChildParent = finishedWork;
        if (newState === null) {
          newDidTimeout = false;
        } else {
          newDidTimeout = true;
          primaryChildParent = finishedWork.child;
          markCommitTimeOfFallback();
        }
        if (primaryChildParent !== null) {
          hideOrUnhideAllChildren(primaryChildParent, newDidTimeout);
        }
      }
      function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
          var current = finishedWork.alternate;
          if (current !== null) {
            var prevState = current.memoizedState;
            if (prevState !== null) {
              var suspenseInstance = prevState.dehydrated;
              if (suspenseInstance !== null) {
                commitHydratedSuspenseInstance(suspenseInstance);
              }
            }
          }
        }
      }
      function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of thenables.
        // For each thenable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var thenables = finishedWork.updateQueue;
        if (thenables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;
          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }
          thenables.forEach(function (thenable) {
            // Memoize using the boundary fiber to prevent redundant listeners.
            var retry = resolveRetryThenable.bind(null, finishedWork, thenable);
            if (!retryCache.has(thenable)) {
              {
                if (thenable.__reactDoNotTraceInteractions !== true) {
                  retry = tracing$1.unstable_wrap(retry);
                }
              }
              retryCache.add(thenable);
              thenable.then(retry, retry);
            }
          });
        }
      }
      function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
      }
      var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
      function createRootErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null); // Unmount the root by rendering null.

        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: null
        };
        var error = errorInfo.value;
        update.callback = function () {
          onUncaughtError(error);
          logError(fiber, errorInfo);
        };
        return update;
      }
      function createClassErrorUpdate(fiber, errorInfo, expirationTime) {
        var update = createUpdate(expirationTime, null);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
          var error$1 = errorInfo.value;
          update.payload = function () {
            logError(fiber, errorInfo);
            return getDerivedStateFromError(error$1);
          };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            if (typeof getDerivedStateFromError !== 'function') {
              // To preserve the preexisting retry behavior of error boundaries,
              // we keep track of which ones already failed during this batch.
              // This gets reset before we yield back to the browser.
              // TODO: Warn in strict mode if getDerivedStateFromError is
              // not defined.
              markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined

              logError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
              componentStack: stack !== null ? stack : ''
            });
            {
              if (typeof getDerivedStateFromError !== 'function') {
                // If componentDidCatch is the only error boundary method defined,
                // then it needs to call setState to recover from errors.
                // If no state update is scheduled then the boundary will swallow the error.
                if (fiber.expirationTime !== Sync) {
                  error('%s: Error boundaries should implement getDerivedStateFromError(). ' + 'In that method, return a state update to display an error message or fallback UI.', getComponentName(fiber.type) || 'Unknown');
                }
              }
            }
          };
        } else {
          update.callback = function () {
            markFailedErrorBoundaryForHotReloading(fiber);
          };
        }
        return update;
      }
      function attachPingListener(root, renderExpirationTime, thenable) {
        // Attach a listener to the promise to "ping" the root and retry. But
        // only if one does not already exist for the current render expiration
        // time (which acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
          pingCache = root.pingCache = new PossiblyWeakMap$1();
          threadIDs = new Set();
          pingCache.set(thenable, threadIDs);
        } else {
          threadIDs = pingCache.get(thenable);
          if (threadIDs === undefined) {
            threadIDs = new Set();
            pingCache.set(thenable, threadIDs);
          }
        }
        if (!threadIDs.has(renderExpirationTime)) {
          // Memoize using the thread ID to prevent redundant listeners.
          threadIDs.add(renderExpirationTime);
          var ping = pingSuspendedRoot.bind(null, root, thenable, renderExpirationTime);
          thenable.then(ping, ping);
        }
      }
      function throwException(root, returnFiber, sourceFiber, value, renderExpirationTime) {
        // The source fiber did not complete.
        sourceFiber.effectTag |= Incomplete; // Its effect list is no longer valid.

        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
          // This is a thenable.
          var thenable = value;
          if ((sourceFiber.mode & BlockingMode) === NoMode) {
            // Reset the memoizedState to what it was before we attempted
            // to render it.
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
              sourceFiber.updateQueue = currentSource.updateQueue;
              sourceFiber.memoizedState = currentSource.memoizedState;
              sourceFiber.expirationTime = currentSource.expirationTime;
            } else {
              sourceFiber.updateQueue = null;
              sourceFiber.memoizedState = null;
            }
          }
          var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.

          var _workInProgress = returnFiber;
          do {
            if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
              // Found the nearest boundary.
              // Stash the promise on the boundary fiber. If the boundary times out, we'll
              // attach another listener to flip the boundary back to its normal state.
              var thenables = _workInProgress.updateQueue;
              if (thenables === null) {
                var updateQueue = new Set();
                updateQueue.add(thenable);
                _workInProgress.updateQueue = updateQueue;
              } else {
                thenables.add(thenable);
              } // If the boundary is outside of blocking mode, we should *not*
              // suspend the commit. Pretend as if the suspended component rendered
              // null and keep rendering. In the commit phase, we'll schedule a
              // subsequent synchronous update to re-render the Suspense.
              //
              // Note: It doesn't matter whether the component that suspended was
              // inside a blocking mode tree. If the Suspense is outside of it, we
              // should *not* suspend the commit.

              if ((_workInProgress.mode & BlockingMode) === NoMode) {
                _workInProgress.effectTag |= DidCapture; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.

                sourceFiber.effectTag &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                  var currentSourceFiber = sourceFiber.alternate;
                  if (currentSourceFiber === null) {
                    // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                  } else {
                    // When we try rendering again, we should not reuse the current fiber,
                    // since it's known to be in an inconsistent state. Use a force update to
                    // prevent a bail out.
                    var update = createUpdate(Sync, null);
                    update.tag = ForceUpdate;
                    enqueueUpdate(sourceFiber, update);
                  }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.

                sourceFiber.expirationTime = Sync; // Exit without suspending.

                return;
              } // Confirmed that the boundary is in a concurrent mode tree. Continue
              // with the normal suspend path.
              //
              // After this we'll use a set of heuristics to determine whether this
              // render pass will run to completion or restart or "suspend" the commit.
              // The actual logic for this is spread out in different places.
              //
              // This first principle is that if we're going to suspend when we complete
              // a root, then we should also restart if we get an update or ping that
              // might unsuspend it, and vice versa. The only reason to suspend is
              // because you think you might want to restart before committing. However,
              // it doesn't make sense to restart only while in the period we're suspended.
              //
              // Restarting too aggressively is also not good because it starves out any
              // intermediate loading state. So we use heuristics to determine when.
              // Suspense Heuristics
              //
              // If nothing threw a Promise or all the same fallbacks are already showing,
              // then don't suspend/restart.
              //
              // If this is an initial render of a new tree of Suspense boundaries and
              // those trigger a fallback, then don't suspend/restart. We want to ensure
              // that we can show the initial loading state as quickly as possible.
              //
              // If we hit a "Delayed" case, such as when we'd switch from content back into
              // a fallback, then we should always suspend/restart. SuspenseConfig applies to
              // this case. If none is defined, JND is used instead.
              //
              // If we're already showing a fallback and it gets "retried", allowing us to show
              // another level, but there's still an inner boundary that would show a fallback,
              // then we suspend/restart for 500ms since the last time we showed a fallback
              // anywhere in the tree. This effectively throttles progressive loading into a
              // consistent train of commits. This also gives us an opportunity to restart to
              // get to the completed state slightly earlier.
              //
              // If there's ambiguity due to batching it's resolved in preference of:
              // 1) "delayed", 2) "initial render", 3) "retry".
              //
              // We want to ensure that a "busy" state doesn't get force committed. We want to
              // ensure that new initial loading states can commit as soon as possible.

              attachPingListener(root, renderExpirationTime, thenable);
              _workInProgress.effectTag |= ShouldCapture;
              _workInProgress.expirationTime = renderExpirationTime;
              return;
            } // This boundary already captured during this render. Continue to the next
            // boundary.

            _workInProgress = _workInProgress.return;
          } while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
          // TODO: Use invariant so the message is stripped in prod?

          value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.' + getStackByFiberInDevAndProd(sourceFiber));
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.

        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
          switch (workInProgress.tag) {
            case HostRoot:
              {
                var _errorInfo = value;
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime;
                var _update = createRootErrorUpdate(workInProgress, _errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update);
                return;
              }
            case ClassComponent:
              // Capture and retry
              var errorInfo = value;
              var ctor = workInProgress.type;
              var instance = workInProgress.stateNode;
              if ((workInProgress.effectTag & DidCapture) === NoEffect && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                workInProgress.effectTag |= ShouldCapture;
                workInProgress.expirationTime = renderExpirationTime; // Schedule the error boundary to re-render using updated state

                var _update2 = createClassErrorUpdate(workInProgress, errorInfo, renderExpirationTime);
                enqueueCapturedUpdate(workInProgress, _update2);
                return;
              }
              break;
          }
          workInProgress = workInProgress.return;
        } while (workInProgress !== null);
      }
      var ceil = Math.ceil;
      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher,
        ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner,
        IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
      var NoContext = /*                    */
      0;
      var BatchedContext = /*               */
      1;
      var EventContext = /*                 */
      2;
      var DiscreteEventContext = /*         */
      4;
      var LegacyUnbatchedContext = /*       */
      8;
      var RenderContext = /*                */
      16;
      var CommitContext = /*                */
      32;
      var RootIncomplete = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      // Describes where we are in the React execution stack
      var executionContext = NoContext; // The root we're working on

      var workInProgressRoot = null; // The fiber we're working on

      var workInProgress = null; // The expiration time we're rendering

      var renderExpirationTime$1 = NoWork; // Whether to root completed, errored, suspended, etc.

      var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown

      var workInProgressRootFatalError = null; // Most recent event time among processed updates during this render.
      // This is conceptually a time stamp but expressed in terms of an ExpirationTime
      // because we deal mostly with expiration times in the hot path, so this avoids
      // the conversion happening in the hot path.

      var workInProgressRootLatestProcessedExpirationTime = Sync;
      var workInProgressRootLatestSuspenseTimeout = Sync;
      var workInProgressRootCanSuspendUsingConfig = null; // The work left over by components that were visited during this render. Only
      // includes unprocessed updates, not work in bailed out children.

      var workInProgressRootNextUnprocessedUpdateTime = NoWork; // If we're pinged while rendering we don't always restart immediately.
      // This flag determines if it might be worthwhile to restart if an opportunity
      // happens latere.

      var workInProgressRootHasPendingPing = false; // The most recent time we committed a fallback. This lets us ensure a train
      // model where we don't commit new loading states in too quick succession.

      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var nextEffect = null;
      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsRenderPriority = NoPriority;
      var pendingPassiveEffectsExpirationTime = NoWork;
      var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates

      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var interruptedBy = null; // Marks the need to reschedule pending interactions at these expiration times
      // during the commit phase. This enables them to be traced across components
      // that spawn new work during render. E.g. hidden boundaries, suspended SSR
      // hydration or SuspenseList.

      var spawnedWorkDuringRender = null; // Expiration times are computed by adding to the current time (the start
      // time). However, if two updates are scheduled within the same event, we
      // should treat their start times as simultaneous, even if the actual clock
      // time has advanced between the first and second call.
      // In other words, because expiration times determine how updates are batched,
      // we want all updates of like priority that occur within the same event to
      // receive the same expiration time. Otherwise we get tearing.

      var currentEventTime = NoWork;
      function requestCurrentTimeForUpdate() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          // We're inside React, so it's fine to read the actual time.
          return msToExpirationTime(now());
        } // We're not inside React, so we may be in the middle of a browser event.

        if (currentEventTime !== NoWork) {
          // Use the same start time for all updates until we enter React again.
          return currentEventTime;
        } // This is the first update since React yielded. Compute a new start time.

        currentEventTime = msToExpirationTime(now());
        return currentEventTime;
      }
      function getCurrentTime() {
        return msToExpirationTime(now());
      }
      function computeExpirationForFiber(currentTime, fiber, suspenseConfig) {
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) {
          return Sync;
        }
        var priorityLevel = getCurrentPriorityLevel();
        if ((mode & ConcurrentMode) === NoMode) {
          return priorityLevel === ImmediatePriority ? Sync : Batched;
        }
        if ((executionContext & RenderContext) !== NoContext) {
          // Use whatever time we're already rendering
          // TODO: Should there be a way to opt out, like with `runWithPriority`?
          return renderExpirationTime$1;
        }
        var expirationTime;
        if (suspenseConfig !== null) {
          // Compute an expiration time based on the Suspense timeout.
          expirationTime = computeSuspenseExpiration(currentTime, suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
        } else {
          // Compute an expiration time based on the Scheduler priority.
          switch (priorityLevel) {
            case ImmediatePriority:
              expirationTime = Sync;
              break;
            case UserBlockingPriority$1:
              // TODO: Rename this to computeUserBlockingExpiration
              expirationTime = computeInteractiveExpiration(currentTime);
              break;
            case NormalPriority:
            case LowPriority:
              // TODO: Handle LowPriority
              // TODO: Rename this to... something better.
              expirationTime = computeAsyncExpiration(currentTime);
              break;
            case IdlePriority:
              expirationTime = Idle;
              break;
            default:
              {
                {
                  throw Error("Expected a valid priority level");
                }
              }
          }
        } // If we're in the middle of rendering a tree, do not update at the same
        // expiration time that is already rendering.
        // TODO: We shouldn't have to do this if the update is on a different root.
        // Refactor computeExpirationForFiber + scheduleUpdate so we have access to
        // the root when we check for this condition.

        if (workInProgressRoot !== null && expirationTime === renderExpirationTime$1) {
          // This is a trick to move this update into a separate batch
          expirationTime -= 1;
        }
        return expirationTime;
      }
      function scheduleUpdateOnFiber(fiber, expirationTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateTimeFromFiberToRoot(fiber, expirationTime);
        if (root === null) {
          warnAboutUpdateOnUnmountedFiberInDEV(fiber);
          return;
        }
        checkForInterruption(fiber, expirationTime);
        recordScheduleUpdate(); // TODO: computeExpirationForFiber also reads the priority. Pass the
        // priority as an argument to that function and this one.

        var priorityLevel = getCurrentPriorityLevel();
        if (expirationTime === Sync) {
          if (
          // Check if we're inside unbatchedUpdates
          (executionContext & LegacyUnbatchedContext) !== NoContext &&
          // Check if we're not already rendering
          (executionContext & (RenderContext | CommitContext)) === NoContext) {
            // Register pending interactions on the root to avoid losing traced interaction data.
            schedulePendingInteractions(root, expirationTime); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
            // root inside of batchedUpdates should be synchronous, but layout updates
            // should be deferred until the end of the batch.

            performSyncWorkOnRoot(root);
          } else {
            ensureRootIsScheduled(root);
            schedulePendingInteractions(root, expirationTime);
            if (executionContext === NoContext) {
              // Flush the synchronous work now, unless we're already working or inside
              // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
              // scheduleCallbackForFiber to preserve the ability to schedule a callback
              // without immediately flushing it. We only do this for user-initiated
              // updates, to preserve historical behavior of legacy mode.
              flushSyncCallbackQueue();
            }
          }
        } else {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, expirationTime);
        }
        if ((executionContext & DiscreteEventContext) !== NoContext && (
        // Only updates at user-blocking priority or greater are considered
        // discrete, even inside a discrete event.
        priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority)) {
          // This is the result of a discrete event. Track the lowest priority
          // discrete update per root so we can flush them early, if needed.
          if (rootsWithPendingDiscreteUpdates === null) {
            rootsWithPendingDiscreteUpdates = new Map([[root, expirationTime]]);
          } else {
            var lastDiscreteTime = rootsWithPendingDiscreteUpdates.get(root);
            if (lastDiscreteTime === undefined || lastDiscreteTime > expirationTime) {
              rootsWithPendingDiscreteUpdates.set(root, expirationTime);
            }
          }
        }
      }
      var scheduleWork = scheduleUpdateOnFiber; // This is split into a separate function so we can mark a fiber with pending
      // work without treating it as a typical update that originates from an event;
      // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
      // on a fiber.

      function markUpdateTimeFromFiberToRoot(fiber, expirationTime) {
        // Update the source fiber's expiration time
        if (fiber.expirationTime < expirationTime) {
          fiber.expirationTime = expirationTime;
        }
        var alternate = fiber.alternate;
        if (alternate !== null && alternate.expirationTime < expirationTime) {
          alternate.expirationTime = expirationTime;
        } // Walk the parent path to the root and update the child expiration time.

        var node = fiber.return;
        var root = null;
        if (node === null && fiber.tag === HostRoot) {
          root = fiber.stateNode;
        } else {
          while (node !== null) {
            alternate = node.alternate;
            if (node.childExpirationTime < expirationTime) {
              node.childExpirationTime = expirationTime;
              if (alternate !== null && alternate.childExpirationTime < expirationTime) {
                alternate.childExpirationTime = expirationTime;
              }
            } else if (alternate !== null && alternate.childExpirationTime < expirationTime) {
              alternate.childExpirationTime = expirationTime;
            }
            if (node.return === null && node.tag === HostRoot) {
              root = node.stateNode;
              break;
            }
            node = node.return;
          }
        }
        if (root !== null) {
          if (workInProgressRoot === root) {
            // Received an update to a tree that's in the middle of rendering. Mark
            // that's unprocessed work on this root.
            markUnprocessedUpdateTime(expirationTime);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              // The root already suspended with a delay, which means this render
              // definitely won't finish. Since we have a new update, let's mark it as
              // suspended now, right before marking the incoming update. This has the
              // effect of interrupting the current render and switching to the update.
              // TODO: This happens to work when receiving an update during the render
              // phase, because of the trick inside computeExpirationForFiber to
              // subtract 1 from `renderExpirationTime` to move it into a
              // separate bucket. But we should probably model it with an exception,
              // using the same mechanism we use to force hydration of a subtree.
              // TODO: This does not account for low pri updates that were already
              // scheduled before the root started rendering. Need to track the next
              // pending expiration time (perhaps by backtracking the return path) and
              // then trigger a restart in the `renderDidSuspendDelayIfPossible` path.
              markRootSuspendedAtTime(root, renderExpirationTime$1);
            }
          } // Mark that the root has a pending update.

          markRootUpdatedAtTime(root, expirationTime);
        }
        return root;
      }
      function getNextRootExpirationTimeToWorkOn(root) {
        // Determines the next expiration time that the root should render, taking
        // into account levels that may be suspended, or levels that may have
        // received a ping.
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          return lastExpiredTime;
        } // "Pending" refers to any update that hasn't committed yet, including if it
        // suspended. The "suspended" range is therefore a subset.

        var firstPendingTime = root.firstPendingTime;
        if (!isRootSuspendedAtTime(root, firstPendingTime)) {
          // The highest priority pending time is not suspended. Let's work on that.
          return firstPendingTime;
        } // If the first pending time is suspended, check if there's a lower priority
        // pending level that we know about. Or check if we received a ping. Work
        // on whichever is higher priority.

        var lastPingedTime = root.lastPingedTime;
        var nextKnownPendingLevel = root.nextKnownPendingLevel;
        var nextLevel = lastPingedTime > nextKnownPendingLevel ? lastPingedTime : nextKnownPendingLevel;
        if (nextLevel <= Idle && firstPendingTime !== nextLevel) {
          // Don't work on Idle/Never priority unless everything else is committed.
          return NoWork;
        }
        return nextLevel;
      } // Use this function to schedule a task for a root. There's only one task per
      // root; if a task was already scheduled, we'll check to make sure the
      // expiration time of the existing task is the same as the expiration time of
      // the next level that the root has work on. This function is called on every
      // update, and right before exiting a task.

      function ensureRootIsScheduled(root) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime !== NoWork) {
          // Special case: Expired work should flush synchronously.
          root.callbackExpirationTime = Sync;
          root.callbackPriority = ImmediatePriority;
          root.callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
          return;
        }
        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        var existingCallbackNode = root.callbackNode;
        if (expirationTime === NoWork) {
          // There's nothing to work on.
          if (existingCallbackNode !== null) {
            root.callbackNode = null;
            root.callbackExpirationTime = NoWork;
            root.callbackPriority = NoPriority;
          }
          return;
        } // TODO: If this is an update, we already read the current time. Pass the
        // time as an argument.

        var currentTime = requestCurrentTimeForUpdate();
        var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime); // If there's an existing render task, confirm it has the correct priority and
        // expiration time. Otherwise, we'll cancel it and schedule a new one.

        if (existingCallbackNode !== null) {
          var existingCallbackPriority = root.callbackPriority;
          var existingCallbackExpirationTime = root.callbackExpirationTime;
          if (
          // Callback must have the exact same expiration time.
          existingCallbackExpirationTime === expirationTime &&
          // Callback must have greater or equal priority.
          existingCallbackPriority >= priorityLevel) {
            // Existing callback is sufficient.
            return;
          } // Need to schedule a new task.
          // TODO: Instead of scheduling a new task, we should be able to change the
          // priority of the existing one.

          cancelCallback(existingCallbackNode);
        }
        root.callbackExpirationTime = expirationTime;
        root.callbackPriority = priorityLevel;
        var callbackNode;
        if (expirationTime === Sync) {
          // Sync React callbacks are scheduled on a special internal queue
          callbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        } else {
          callbackNode = scheduleCallback(priorityLevel, performConcurrentWorkOnRoot.bind(null, root),
          // Compute a task timeout based on the expiration time. This also affects
          // ordering because tasks are processed in timeout order.
          {
            timeout: expirationTimeToMs(expirationTime) - now()
          });
        }
        root.callbackNode = callbackNode;
      } // This is the entry point for every concurrent task, i.e. anything that
      // goes through Scheduler.

      function performConcurrentWorkOnRoot(root, didTimeout) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoWork;
        if (didTimeout) {
          // The render task took too long to complete. Mark the current time as
          // expired to synchronously render all expired work in a single batch.
          var currentTime = requestCurrentTimeForUpdate();
          markRootExpiredAtTime(root, currentTime); // This will schedule a synchronous callback.

          ensureRootIsScheduled(root);
          return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.

        var expirationTime = getNextRootExpirationTimeToWorkOn(root);
        if (expirationTime !== NoWork) {
          var originalCallbackNode = root.callbackNode;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
          // and prepare a fresh one. Otherwise we'll continue where we left off.

          if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
            prepareFreshStack(root, expirationTime);
            startWorkOnPendingInteractions(root, expirationTime);
          } // If we have a work-in-progress fiber, it means there's still work to do
          // in this root.

          if (workInProgress !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= RenderContext;
            var prevDispatcher = pushDispatcher();
            var prevInteractions = pushInteractions(root);
            startWorkLoopTimer(workInProgress);
            do {
              try {
                workLoopConcurrent();
                break;
              } catch (thrownValue) {
                handleError(root, thrownValue);
              }
            } while (true);
            resetContextDependencies();
            executionContext = prevExecutionContext;
            popDispatcher(prevDispatcher);
            {
              popInteractions(prevInteractions);
            }
            if (workInProgressRootExitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              stopInterruptedWorkLoopTimer();
              prepareFreshStack(root, expirationTime);
              markRootSuspendedAtTime(root, expirationTime);
              ensureRootIsScheduled(root);
              throw fatalError;
            }
            if (workInProgress !== null) {
              // There's still work left over. Exit without committing.
              stopInterruptedWorkLoopTimer();
            } else {
              // We now have a consistent tree. The next step is either to commit it,
              // or, if something suspended, wait to commit it after a timeout.
              stopFinishedWorkLoopTimer();
              var finishedWork = root.finishedWork = root.current.alternate;
              root.finishedExpirationTime = expirationTime;
              finishConcurrentRender(root, finishedWork, workInProgressRootExitStatus, expirationTime);
            }
            ensureRootIsScheduled(root);
            if (root.callbackNode === originalCallbackNode) {
              // The task node scheduled for this root is the same one that's
              // currently executed. Need to return a continuation.
              return performConcurrentWorkOnRoot.bind(null, root);
            }
          }
        }
        return null;
      }
      function finishConcurrentRender(root, finishedWork, exitStatus, expirationTime) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        switch (exitStatus) {
          case RootIncomplete:
          case RootFatalErrored:
            {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
          // Flow knows about invariant, so it complains if I add a break
          // statement, but eslint doesn't know about invariant, so it complains
          // if I do. eslint-disable-next-line no-fallthrough

          case RootErrored:
            {
              // If this was an async render, the error may have happened due to
              // a mutation in a concurrent event. Try rendering one more time,
              // synchronously, to see if the error goes away. If there are
              // lower priority updates, let's include those, too, in case they
              // fix the inconsistency. Render at Idle to include all updates.
              // If it was Idle or Never or some not-yet-invented time, render
              // at that time.
              markRootExpiredAtTime(root, expirationTime > Idle ? Idle : expirationTime); // We assume that this second render pass will be synchronous
              // and therefore not hit this path again.

              break;
            }
          case RootSuspended:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              } // We have an acceptable loading state. We need to figure out if we
              // should immediately commit it or wait a bit.
              // If we have processed new updates during this render, we may now
              // have a new loading state ready. We want to ensure that we commit
              // that as soon as possible.

              var hasNotProcessedNewUpdates = workInProgressRootLatestProcessedExpirationTime === Sync;
              if (hasNotProcessedNewUpdates &&
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // If we have not processed any new updates during this pass, then
                // this is either a retry of an existing fallback state or a
                // hidden tree. Hidden trees shouldn't be batched with other work
                // and after that's fixed it can only be a retry. We're going to
                // throttle committing retries so that we don't show too many
                // loading states too quickly.
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.

                if (msUntilTimeout > 10) {
                  if (workInProgressRootHasPendingPing) {
                    var lastPingedTime = root.lastPingedTime;
                    if (lastPingedTime === NoWork || lastPingedTime >= expirationTime) {
                      // This render was pinged but we didn't get to restart
                      // earlier so try restarting now instead.
                      root.lastPingedTime = expirationTime;
                      prepareFreshStack(root, expirationTime);
                      break;
                    }
                  }
                  var nextTime = getNextRootExpirationTimeToWorkOn(root);
                  if (nextTime !== NoWork && nextTime !== expirationTime) {
                    // There's additional work on this root.
                    break;
                  }
                  if (lastSuspendedTime !== NoWork && lastSuspendedTime !== expirationTime) {
                    // We should prefer to render the fallback of at the last
                    // suspended level. Ping the last suspended level to try
                    // rendering it again.
                    root.lastPingedTime = lastSuspendedTime;
                    break;
                  } // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.

                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootSuspendedWithDelay:
            {
              markRootSuspendedAtTime(root, expirationTime);
              var _lastSuspendedTime = root.lastSuspendedTime;
              if (expirationTime === _lastSuspendedTime) {
                root.nextKnownPendingLevel = getRemainingExpirationTime(finishedWork);
              }
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current) {
                // We're suspended in a state that should be avoided. We'll try to
                // avoid committing it for as long as the timeouts let us.
                if (workInProgressRootHasPendingPing) {
                  var _lastPingedTime = root.lastPingedTime;
                  if (_lastPingedTime === NoWork || _lastPingedTime >= expirationTime) {
                    // This render was pinged but we didn't get to restart earlier
                    // so try restarting now instead.
                    root.lastPingedTime = expirationTime;
                    prepareFreshStack(root, expirationTime);
                    break;
                  }
                }
                var _nextTime = getNextRootExpirationTimeToWorkOn(root);
                if (_nextTime !== NoWork && _nextTime !== expirationTime) {
                  // There's additional work on this root.
                  break;
                }
                if (_lastSuspendedTime !== NoWork && _lastSuspendedTime !== expirationTime) {
                  // We should prefer to render the fallback of at the last
                  // suspended level. Ping the last suspended level to try
                  // rendering it again.
                  root.lastPingedTime = _lastSuspendedTime;
                  break;
                }
                var _msUntilTimeout;
                if (workInProgressRootLatestSuspenseTimeout !== Sync) {
                  // We have processed a suspense config whose expiration time we
                  // can use as the timeout.
                  _msUntilTimeout = expirationTimeToMs(workInProgressRootLatestSuspenseTimeout) - now();
                } else if (workInProgressRootLatestProcessedExpirationTime === Sync) {
                  // This should never normally happen because only new updates
                  // cause delayed states, so we should have processed something.
                  // However, this could also happen in an offscreen tree.
                  _msUntilTimeout = 0;
                } else {
                  // If we don't have a suspense config, we're going to use a
                  // heuristic to determine how long we can suspend.
                  var eventTimeMs = inferTimeFromExpirationTime(workInProgressRootLatestProcessedExpirationTime);
                  var currentTimeMs = now();
                  var timeUntilExpirationMs = expirationTimeToMs(expirationTime) - currentTimeMs;
                  var timeElapsed = currentTimeMs - eventTimeMs;
                  if (timeElapsed < 0) {
                    // We get this wrong some time since we estimate the time.
                    timeElapsed = 0;
                  }
                  _msUntilTimeout = jnd(timeElapsed) - timeElapsed; // Clamp the timeout to the expiration time. TODO: Once the
                  // event time is exact instead of inferred from expiration time
                  // we don't need this.

                  if (timeUntilExpirationMs < _msUntilTimeout) {
                    _msUntilTimeout = timeUntilExpirationMs;
                  }
                } // Don't bother with a very short suspense time.

                if (_msUntilTimeout > 10) {
                  // The render is suspended, it hasn't timed out, and there's no
                  // lower priority work to do. Instead of committing the fallback
                  // immediately, wait for more data to arrive.
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                  break;
                }
              } // The work expired. Commit immediately.

              commitRoot(root);
              break;
            }
          case RootCompleted:
            {
              // The work completed. Ready to commit.
              if (
              // do not delay if we're inside an act() scope
              !IsThisRendererActing.current && workInProgressRootLatestProcessedExpirationTime !== Sync && workInProgressRootCanSuspendUsingConfig !== null) {
                // If we have exceeded the minimum loading delay, which probably
                // means we have shown a spinner already, we might have to suspend
                // a bit longer to ensure that the spinner is shown for
                // enough time.
                var _msUntilTimeout2 = computeMsUntilSuspenseLoadingDelay(workInProgressRootLatestProcessedExpirationTime, expirationTime, workInProgressRootCanSuspendUsingConfig);
                if (_msUntilTimeout2 > 10) {
                  markRootSuspendedAtTime(root, expirationTime);
                  root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout2);
                  break;
                }
              }
              commitRoot(root);
              break;
            }
          default:
            {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
        }
      } // This is the entry point for synchronous tasks that don't go
      // through Scheduler

      function performSyncWorkOnRoot(root) {
        // Check if there's expired work on this root. Otherwise, render at Sync.
        var lastExpiredTime = root.lastExpiredTime;
        var expirationTime = lastExpiredTime !== NoWork ? lastExpiredTime : Sync;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        flushPassiveEffects(); // If the root or expiration time have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.

        if (root !== workInProgressRoot || expirationTime !== renderExpirationTime$1) {
          prepareFreshStack(root, expirationTime);
          startWorkOnPendingInteractions(root, expirationTime);
        } // If we have a work-in-progress fiber, it means there's still work to do
        // in this root.

        if (workInProgress !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          var prevInteractions = pushInteractions(root);
          startWorkLoopTimer(workInProgress);
          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);
          {
            popInteractions(prevInteractions);
          }
          if (workInProgressRootExitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            stopInterruptedWorkLoopTimer();
            prepareFreshStack(root, expirationTime);
            markRootSuspendedAtTime(root, expirationTime);
            ensureRootIsScheduled(root);
            throw fatalError;
          }
          if (workInProgress !== null) {
            // This is a sync render, so we should have finished the whole tree.
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          } else {
            // We now have a consistent tree. Because this is a sync render, we
            // will commit it even if something suspended.
            stopFinishedWorkLoopTimer();
            root.finishedWork = root.current.alternate;
            root.finishedExpirationTime = expirationTime;
            finishSyncRender(root);
          } // Before exiting, make sure there's a callback scheduled for the next
          // pending level.

          ensureRootIsScheduled(root);
        }
        return null;
      }
      function finishSyncRender(root) {
        // Set this to null to indicate there's no in-progress render.
        workInProgressRoot = null;
        commitRoot(root);
      }
      function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
          {
            if ((executionContext & RenderContext) !== NoContext) {
              error('unstable_flushDiscreteUpdates: Cannot flush updates when React is ' + 'already rendering.');
            }
          } // We're already rendering, so we can't synchronously flush pending work.
          // This is probably a nested event dispatch triggered by a lifecycle/effect,
          // like `el.focus()`. Exit.

          return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.

        flushPassiveEffects();
      }
      function syncUpdates(fn, a, b, c) {
        return runWithPriority$1(ImmediatePriority, fn.bind(null, a, b, c));
      }
      function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
          // For each root with pending discrete updates, schedule a callback to
          // immediately flush them.
          var roots = rootsWithPendingDiscreteUpdates;
          rootsWithPendingDiscreteUpdates = null;
          roots.forEach(function (expirationTime, root) {
            markRootExpiredAtTime(root, expirationTime);
            ensureRootIsScheduled(root);
          }); // Now flush the immediate queue.

          flushSyncCallbackQueue();
        }
      }
      function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
          // Should this
          return runWithPriority$1(UserBlockingPriority$1, fn.bind(null, a, b, c, d));
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
          return fn(a);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            // Flush the immediate callbacks that were scheduled during this batch
            flushSyncCallbackQueue();
          }
        }
      }
      function flushSync(fn, a) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          {
            {
              throw Error("flushSync was called from inside a lifecycle method. It cannot be called when React is already rendering.");
            }
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return runWithPriority$1(ImmediatePriority, fn.bind(null, a));
        } finally {
          executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
          // Note that this will happen even if batchedUpdates is higher up
          // the stack.

          flushSyncCallbackQueue();
        }
      }
      function prepareFreshStack(root, expirationTime) {
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
          // The root previous suspended and scheduled a timeout to commit a fallback
          // state. Now that we have additional work, cancel the timeout.
          root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above

          cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
          var interruptedWork = workInProgress.return;
          while (interruptedWork !== null) {
            unwindInterruptedWork(interruptedWork);
            interruptedWork = interruptedWork.return;
          }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        renderExpirationTime$1 = expirationTime;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootLatestProcessedExpirationTime = Sync;
        workInProgressRootLatestSuspenseTimeout = Sync;
        workInProgressRootCanSuspendUsingConfig = null;
        workInProgressRootNextUnprocessedUpdateTime = NoWork;
        workInProgressRootHasPendingPing = false;
        {
          spawnedWorkDuringRender = null;
        }
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
      }
      function handleError(root, thrownValue) {
        do {
          try {
            // Reset module-level state that was set during the render phase.
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            if (workInProgress === null || workInProgress.return === null) {
              // Expected to be working on a non-root fiber. This is a fatal error
              // because there's no ancestor that can handle it; the root is
              // supposed to capture all errors that weren't caught by an error
              // boundary.
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
              // sibling, or the parent if there are no siblings. But since the root
              // has no siblings nor a parent, we set it to null. Usually this is
              // handled by `completeUnitOfWork` or `unwindWork`, but since we're
              // interntionally not calling those, we need set it here.
              // TODO: Consider calling `unwindWork` to pop the contexts.

              workInProgress = null;
              return null;
            }
            if (enableProfilerTimer && workInProgress.mode & ProfileMode) {
              // Record the time spent rendering before an error was thrown. This
              // avoids inaccurate Profiler durations in the case of a
              // suspended render.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, true);
            }
            throwException(root, workInProgress.return, workInProgress, thrownValue, renderExpirationTime$1);
            workInProgress = completeUnitOfWork(workInProgress);
          } catch (yetAnotherThrownValue) {
            // Something in the return path also threw.
            thrownValue = yetAnotherThrownValue;
            continue;
          } // Return to the normal work loop.

          return;
        } while (true);
      }
      function pushDispatcher(root) {
        var prevDispatcher = ReactCurrentDispatcher$1.current;
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) {
          // The React isomorphic package does not include a default dispatcher.
          // Instead the first renderer will lazily attach one, in order to give
          // nicer error messages.
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }
      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$1.current = prevDispatcher;
      }
      function pushInteractions(root) {
        {
          var prevInteractions = tracing$1.__interactionsRef.current;
          tracing$1.__interactionsRef.current = root.memoizedInteractions;
          return prevInteractions;
        }
      }
      function popInteractions(prevInteractions) {
        {
          tracing$1.__interactionsRef.current = prevInteractions;
        }
      }
      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
      }
      function markRenderEventTimeAndConfig(expirationTime, suspenseConfig) {
        if (expirationTime < workInProgressRootLatestProcessedExpirationTime && expirationTime > Idle) {
          workInProgressRootLatestProcessedExpirationTime = expirationTime;
        }
        if (suspenseConfig !== null) {
          if (expirationTime < workInProgressRootLatestSuspenseTimeout && expirationTime > Idle) {
            workInProgressRootLatestSuspenseTimeout = expirationTime; // Most of the time we only have one config and getting wrong is not bad.

            workInProgressRootCanSuspendUsingConfig = suspenseConfig;
          }
        }
      }
      function markUnprocessedUpdateTime(expirationTime) {
        if (expirationTime > workInProgressRootNextUnprocessedUpdateTime) {
          workInProgressRootNextUnprocessedUpdateTime = expirationTime;
        }
      }
      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }
      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        } // Check if there's a lower priority update somewhere else in the tree.

        if (workInProgressRootNextUnprocessedUpdateTime !== NoWork && workInProgressRoot !== null) {
          // Mark the current render as suspended, and then mark that there's a
          // pending update.
          // TODO: This should immediately interrupt the current render, instead
          // of waiting until the next time we yield.
          markRootSuspendedAtTime(workInProgressRoot, renderExpirationTime$1);
          markRootUpdatedAtTime(workInProgressRoot, workInProgressRootNextUnprocessedUpdateTime);
        }
      }
      function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) {
          workInProgressRootExitStatus = RootErrored;
        }
      } // Called during render to determine if anything has suspended.
      // Returns false if we're not sure.

      function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
      }
      function inferTimeFromExpirationTime(expirationTime) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - LOW_PRIORITY_EXPIRATION;
      }
      function inferTimeFromExpirationTimeWithSuspenseConfig(expirationTime, suspenseConfig) {
        // We don't know exactly when the update was scheduled, but we can infer an
        // approximate start time from the expiration time by subtracting the timeout
        // that was added to the event time.
        var earliestExpirationTimeMs = expirationTimeToMs(expirationTime);
        return earliestExpirationTimeMs - (suspenseConfig.timeoutMs | 0 || LOW_PRIORITY_EXPIRATION);
      } // The work loop is an extremely hot path. Tell Closure not to inline it.

      /** @noinline */

      function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while (workInProgress !== null) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      /** @noinline */

      function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while (workInProgress !== null && !shouldYield()) {
          workInProgress = performUnitOfWork(workInProgress);
        }
      }
      function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        startWorkTimer(unitOfWork);
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next = beginWork$1(current, unitOfWork, renderExpirationTime$1);
        }
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) {
          // If this doesn't spawn new work, complete the current work.
          next = completeUnitOfWork(unitOfWork);
        }
        ReactCurrentOwner$2.current = null;
        return next;
      }
      function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        workInProgress = unitOfWork;
        do {
          // The current, flushed, state of this fiber is the alternate. Ideally
          // nothing should rely on this, but relying on it here means that we don't
          // need an additional field on the work in progress.
          var current = workInProgress.alternate;
          var returnFiber = workInProgress.return; // Check if the work completed or if something threw.

          if ((workInProgress.effectTag & Incomplete) === NoEffect) {
            setCurrentFiber(workInProgress);
            var next = void 0;
            if ((workInProgress.mode & ProfileMode) === NoMode) {
              next = completeWork(current, workInProgress, renderExpirationTime$1);
            } else {
              startProfilerTimer(workInProgress);
              next = completeWork(current, workInProgress, renderExpirationTime$1); // Update render duration assuming we didn't error.

              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false);
            }
            stopWorkTimer(workInProgress);
            resetCurrentFiber();
            resetChildExpirationTime(workInProgress);
            if (next !== null) {
              // Completing this fiber spawned new work. Work on that next.
              return next;
            }
            if (returnFiber !== null &&
            // Do not append effects to parents if a sibling failed to complete
            (returnFiber.effectTag & Incomplete) === NoEffect) {
              // Append all the effects of the subtree and this fiber onto the effect
              // list of the parent. The completion order of the children affects the
              // side-effect order.
              if (returnFiber.firstEffect === null) {
                returnFiber.firstEffect = workInProgress.firstEffect;
              }
              if (workInProgress.lastEffect !== null) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress.firstEffect;
                }
                returnFiber.lastEffect = workInProgress.lastEffect;
              } // If this fiber had side-effects, we append it AFTER the children's
              // side-effects. We can perform certain side-effects earlier if needed,
              // by doing multiple passes over the effect list. We don't want to
              // schedule our own side-effect on our own list because if end up
              // reusing children we'll schedule this effect onto itself since we're
              // at the end.

              var effectTag = workInProgress.effectTag; // Skip both NoWork and PerformedWork tags when creating the effect
              // list. PerformedWork effect is read by React DevTools but shouldn't be
              // committed.

              if (effectTag > PerformedWork) {
                if (returnFiber.lastEffect !== null) {
                  returnFiber.lastEffect.nextEffect = workInProgress;
                } else {
                  returnFiber.firstEffect = workInProgress;
                }
                returnFiber.lastEffect = workInProgress;
              }
            }
          } else {
            // This fiber did not complete because something threw. Pop values off
            // the stack without entering the complete phase. If this is a boundary,
            // capture values if possible.
            var _next = unwindWork(workInProgress); // Because this fiber did not complete, don't reset its expiration time.

            if ((workInProgress.mode & ProfileMode) !== NoMode) {
              // Record the render duration for the fiber that errored.
              stopProfilerTimerIfRunningAndRecordDelta(workInProgress, false); // Include the time spent working on failed children before continuing.

              var actualDuration = workInProgress.actualDuration;
              var child = workInProgress.child;
              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }
              workInProgress.actualDuration = actualDuration;
            }
            if (_next !== null) {
              // If completing this work spawned new work, do that next. We'll come
              // back here again.
              // Since we're restarting, remove anything that is not a host effect
              // from the effect tag.
              // TODO: The name stopFailedWorkTimer is misleading because Suspense
              // also captures and restarts.
              stopFailedWorkTimer(workInProgress);
              _next.effectTag &= HostEffectMask;
              return _next;
            }
            stopWorkTimer(workInProgress);
            if (returnFiber !== null) {
              // Mark the parent fiber as incomplete and clear its effect list.
              returnFiber.firstEffect = returnFiber.lastEffect = null;
              returnFiber.effectTag |= Incomplete;
            }
          }
          var siblingFiber = workInProgress.sibling;
          if (siblingFiber !== null) {
            // If there is more work to do in this returnFiber, do that next.
            return siblingFiber;
          } // Otherwise, return to the parent

          workInProgress = returnFiber;
        } while (workInProgress !== null); // We've reached the root.

        if (workInProgressRootExitStatus === RootIncomplete) {
          workInProgressRootExitStatus = RootCompleted;
        }
        return null;
      }
      function getRemainingExpirationTime(fiber) {
        var updateExpirationTime = fiber.expirationTime;
        var childExpirationTime = fiber.childExpirationTime;
        return updateExpirationTime > childExpirationTime ? updateExpirationTime : childExpirationTime;
      }
      function resetChildExpirationTime(completedWork) {
        if (renderExpirationTime$1 !== Never && completedWork.childExpirationTime === Never) {
          // The children of this component are hidden. Don't bubble their
          // expiration times.
          return;
        }
        var newChildExpirationTime = NoWork; // Bubble up the earliest expiration time.

        if ((completedWork.mode & ProfileMode) !== NoMode) {
          // In profiling mode, resetChildExpirationTime is also used to reset
          // profiler durations.
          var actualDuration = completedWork.actualDuration;
          var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
          // only be updated if work is done on the fiber (i.e. it doesn't bailout).
          // When work is done, it should bubble to the parent's actualDuration. If
          // the fiber has not been cloned though, (meaning no work was done), then
          // this value will reflect the amount of time spent working on a previous
          // render. In that case it should not bubble. We determine whether it was
          // cloned by comparing the child pointer.

          var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
          var child = completedWork.child;
          while (child !== null) {
            var childUpdateExpirationTime = child.expirationTime;
            var childChildExpirationTime = child.childExpirationTime;
            if (childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childUpdateExpirationTime;
            }
            if (childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = childChildExpirationTime;
            }
            if (shouldBubbleActualDurations) {
              actualDuration += child.actualDuration;
            }
            treeBaseDuration += child.treeBaseDuration;
            child = child.sibling;
          }
          completedWork.actualDuration = actualDuration;
          completedWork.treeBaseDuration = treeBaseDuration;
        } else {
          var _child = completedWork.child;
          while (_child !== null) {
            var _childUpdateExpirationTime = _child.expirationTime;
            var _childChildExpirationTime = _child.childExpirationTime;
            if (_childUpdateExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childUpdateExpirationTime;
            }
            if (_childChildExpirationTime > newChildExpirationTime) {
              newChildExpirationTime = _childChildExpirationTime;
            }
            _child = _child.sibling;
          }
        }
        completedWork.childExpirationTime = newChildExpirationTime;
      }
      function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
      }
      function commitRootImpl(root, renderPriorityLevel) {
        do {
          // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
          // means `flushPassiveEffects` will sometimes result in additional
          // passive effects. So we need to keep flushing in a loop until there are
          // no more pending effects.
          // TODO: Might be better if `flushPassiveEffects` did not automatically
          // flush synchronous work at the end, to avoid factoring hazards like this.
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Should not already be working.");
          }
        }
        var finishedWork = root.finishedWork;
        var expirationTime = root.finishedExpirationTime;
        if (finishedWork === null) {
          return null;
        }
        root.finishedWork = null;
        root.finishedExpirationTime = NoWork;
        if (!(finishedWork !== root.current)) {
          {
            throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
          }
        } // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.

        root.callbackNode = null;
        root.callbackExpirationTime = NoWork;
        root.callbackPriority = NoPriority;
        root.nextKnownPendingLevel = NoWork;
        startCommitTimer(); // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.

        var remainingExpirationTimeBeforeCommit = getRemainingExpirationTime(finishedWork);
        markRootFinishedAtTime(root, expirationTime, remainingExpirationTimeBeforeCommit);
        if (root === workInProgressRoot) {
          // We can reset these now that they are finished.
          workInProgressRoot = null;
          workInProgress = null;
          renderExpirationTime$1 = NoWork;
        } // This indicates that the last root we worked on is not the same one that
        // we're committing now. This most commonly happens when a suspended root
        // times out.
        // Get the list of effects.

        var firstEffect;
        if (finishedWork.effectTag > PerformedWork) {
          // A fiber's effect list consists only of its children, not itself. So if
          // the root has an effect, we need to add it to the end of the list. The
          // resulting list is the set that would belong to the root's parent, if it
          // had one; that is, all the effects in the tree including the root.
          if (finishedWork.lastEffect !== null) {
            finishedWork.lastEffect.nextEffect = finishedWork;
            firstEffect = finishedWork.firstEffect;
          } else {
            firstEffect = finishedWork;
          }
        } else {
          // There is no effect on the root.
          firstEffect = finishedWork.firstEffect;
        }
        if (firstEffect !== null) {
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles

          ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
          // of the effect list for each phase: all mutation effects come before all
          // layout effects, and so on.
          // The first phase a "before mutation" phase. We use this phase to read the
          // state of the host tree right before we mutate it. This is where
          // getSnapshotBeforeUpdate is called.

          startCommitSnapshotEffectsTimer();
          prepareForCommit(root.containerInfo);
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitBeforeMutationEffects, null);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var error = clearCaughtError();
                captureCommitPhaseError(nextEffect, error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitSnapshotEffectsTimer();
          {
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
          } // The next phase is the mutation phase, where we mutate the host tree.

          startCommitHostEffectsTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitHostEffectsTimer();
          resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
          // the mutation phase, so that the previous tree is still current during
          // componentWillUnmount, but before the layout phase, so that the finished
          // work is current during componentDidMount/Update.

          root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
          // the host tree after it's been mutated. The idiomatic use case for this is
          // layout, but class component lifecycles also fire here for legacy reasons.

          startCommitLifeCyclesTimer();
          nextEffect = firstEffect;
          do {
            {
              invokeGuardedCallback(null, commitLayoutEffects, null, root, expirationTime);
              if (hasCaughtError()) {
                if (!(nextEffect !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error2 = clearCaughtError();
                captureCommitPhaseError(nextEffect, _error2);
                nextEffect = nextEffect.nextEffect;
              }
            }
          } while (nextEffect !== null);
          stopCommitLifeCyclesTimer();
          nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
          // opportunity to paint.

          requestPaint();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
        } else {
          // No effects.
          root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
          // no effects.
          // TODO: Maybe there's a better way to report this.

          startCommitSnapshotEffectsTimer();
          stopCommitSnapshotEffectsTimer();
          {
            recordCommitTime();
          }
          startCommitHostEffectsTimer();
          stopCommitHostEffectsTimer();
          startCommitLifeCyclesTimer();
          stopCommitLifeCyclesTimer();
        }
        stopCommitTimer();
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
          // This commit has passive effects. Stash a reference to them. But don't
          // schedule a callback until after flushing layout work.
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root;
          pendingPassiveEffectsExpirationTime = expirationTime;
          pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
          // We are done with the effect chain at this point so let's clear the
          // nextEffect pointers to assist with GC. If we have passive effects, we'll
          // clear this in flushPassiveEffects.
          nextEffect = firstEffect;
          while (nextEffect !== null) {
            var nextNextEffect = nextEffect.nextEffect;
            nextEffect.nextEffect = null;
            nextEffect = nextNextEffect;
          }
        } // Check if there's remaining work on this root

        var remainingExpirationTime = root.firstPendingTime;
        if (remainingExpirationTime !== NoWork) {
          {
            if (spawnedWorkDuringRender !== null) {
              var expirationTimes = spawnedWorkDuringRender;
              spawnedWorkDuringRender = null;
              for (var i = 0; i < expirationTimes.length; i++) {
                scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
              }
            }
            schedulePendingInteractions(root, remainingExpirationTime);
          }
        } else {
          // If there's no remaining work, we can clear the set of already failed
          // error boundaries.
          legacyErrorBoundariesThatAlreadyFailed = null;
        }
        {
          if (!rootDidHavePassiveEffects) {
            // If there are no passive effects, then we can complete the pending interactions.
            // Otherwise, we'll wait until after the passive effects are flushed.
            // Wait to do this until after remaining work has been scheduled,
            // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
            finishPendingInteractions(root, expirationTime);
          }
        }
        if (remainingExpirationTime === Sync) {
          // Count the number of times the root synchronously re-renders without
          // finishing. If there are too many, it indicates an infinite update loop.
          if (root === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root;
          }
        } else {
          nestedUpdateCount = 0;
        }
        onCommitRoot(finishedWork.stateNode, expirationTime); // Always call this before exiting `commitRoot`, to ensure that any
        // additional work on this root is scheduled.

        ensureRootIsScheduled(root);
        if (hasUncaughtError) {
          hasUncaughtError = false;
          var _error3 = firstUncaughtError;
          firstUncaughtError = null;
          throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
          // This is a legacy edge case. We just committed the initial mount of
          // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
          // synchronously, but layout updates should be deferred until the end
          // of the batch.
          return null;
        } // If layout work was scheduled, flush it now.

        flushSyncCallbackQueue();
        return null;
      }
      function commitBeforeMutationEffects() {
        while (nextEffect !== null) {
          var effectTag = nextEffect.effectTag;
          if ((effectTag & Snapshot) !== NoEffect) {
            setCurrentFiber(nextEffect);
            recordEffect();
            var current = nextEffect.alternate;
            commitBeforeMutationLifeCycles(current, nextEffect);
            resetCurrentFiber();
          }
          if ((effectTag & Passive) !== NoEffect) {
            // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            if (!rootDoesHavePassiveEffects) {
              rootDoesHavePassiveEffects = true;
              scheduleCallback(NormalPriority, function () {
                flushPassiveEffects();
                return null;
              });
            }
          }
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & ContentReset) {
            commitResetTextContent(nextEffect);
          }
          if (effectTag & Ref) {
            var current = nextEffect.alternate;
            if (current !== null) {
              commitDetachRef(current);
            }
          } // The following switch statement is only concerned about placement,
          // updates, and deletions. To avoid needing to add a case for every possible
          // bitmap value, we remove the secondary effects from the effect tag and
          // switch on that value.

          var primaryEffectTag = effectTag & (Placement | Update | Deletion | Hydrating);
          switch (primaryEffectTag) {
            case Placement:
              {
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.
                // TODO: findDOMNode doesn't rely on this any more but isMounted does
                // and isMounted is deprecated anyway so we should be able to kill this.

                nextEffect.effectTag &= ~Placement;
                break;
              }
            case PlacementAndUpdate:
              {
                // Placement
                commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                // inserted, before any life-cycles like componentDidMount gets called.

                nextEffect.effectTag &= ~Placement; // Update

                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
            case Hydrating:
              {
                nextEffect.effectTag &= ~Hydrating;
                break;
              }
            case HydratingAndUpdate:
              {
                nextEffect.effectTag &= ~Hydrating; // Update

                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
            case Update:
              {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
            case Deletion:
              {
                commitDeletion(root, nextEffect, renderPriorityLevel);
                break;
              }
          } // TODO: Only record a mutation effect if primaryEffectTag is non-zero.

          recordEffect();
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function commitLayoutEffects(root, committedExpirationTime) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while (nextEffect !== null) {
          setCurrentFiber(nextEffect);
          var effectTag = nextEffect.effectTag;
          if (effectTag & (Update | Callback)) {
            recordEffect();
            var current = nextEffect.alternate;
            commitLifeCycles(root, current, nextEffect);
          }
          if (effectTag & Ref) {
            recordEffect();
            commitAttachRef(nextEffect);
          }
          resetCurrentFiber();
          nextEffect = nextEffect.nextEffect;
        }
      }
      function flushPassiveEffects() {
        if (pendingPassiveEffectsRenderPriority !== NoPriority) {
          var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority ? NormalPriority : pendingPassiveEffectsRenderPriority;
          pendingPassiveEffectsRenderPriority = NoPriority;
          return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
      }
      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }
        var root = rootWithPendingPassiveEffects;
        var expirationTime = pendingPassiveEffectsExpirationTime;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsExpirationTime = NoWork;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
          {
            throw Error("Cannot flush passive effects while already rendering.");
          }
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root);
        {
          // Note: This currently assumes there are no passive effects on the root fiber
          // because the root is not part of its own effect list.
          // This could change in the future.
          var _effect2 = root.current.firstEffect;
          while (_effect2 !== null) {
            {
              setCurrentFiber(_effect2);
              invokeGuardedCallback(null, commitPassiveHookEffects, null, _effect2);
              if (hasCaughtError()) {
                if (!(_effect2 !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error5 = clearCaughtError();
                captureCommitPhaseError(_effect2, _error5);
              }
              resetCurrentFiber();
            }
            var nextNextEffect = _effect2.nextEffect; // Remove nextEffect pointer to assist GC

            _effect2.nextEffect = null;
            _effect2 = nextNextEffect;
          }
        }
        {
          popInteractions(prevInteractions);
          finishPendingInteractions(root, expirationTime);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.

        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
      }
      function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
      }
      function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = new Set([instance]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance);
        }
      }
      function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error;
        }
      }
      var onUncaughtError = prepareToThrowUncaughtError;
      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, Sync);
        enqueueUpdate(rootFiber, update);
        var root = markUpdateTimeFromFiberToRoot(rootFiber, Sync);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, Sync);
        }
      }
      function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
          // Error was thrown at the root. There is no parent, so the root
          // itself should capture it.
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
          return;
        }
        var fiber = sourceFiber.return;
        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance = fiber.stateNode;
            if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
              var errorInfo = createCapturedValue(error, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo,
              // TODO: This is always sync
              Sync);
              enqueueUpdate(fiber, update);
              var root = markUpdateTimeFromFiberToRoot(fiber, Sync);
              if (root !== null) {
                ensureRootIsScheduled(root);
                schedulePendingInteractions(root, Sync);
              }
              return;
            }
          }
          fiber = fiber.return;
        }
      }
      function pingSuspendedRoot(root, thenable, suspendedTime) {
        var pingCache = root.pingCache;
        if (pingCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          pingCache.delete(thenable);
        }
        if (workInProgressRoot === root && renderExpirationTime$1 === suspendedTime) {
          // Received a ping at the same priority level at which we're currently
          // rendering. We might want to restart this render. This should mirror
          // the logic of whether or not a root suspends once it completes.
          // TODO: If we're rendering sync either due to Sync, Batched or expired,
          // we should probably never restart.
          // If we're suspended with delay, we'll always suspend so we can always
          // restart. If we're suspended without any updates, it might be a retry.
          // If it's early in the retry we can restart. We can't know for sure
          // whether we'll eventually process an update during this render pass,
          // but it's somewhat unlikely that we get to a ping before that, since
          // getting to the root most update is usually very fast.
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && workInProgressRootLatestProcessedExpirationTime === Sync && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            // Restart from the root. Don't need to schedule a ping because
            // we're already working on this tree.
            prepareFreshStack(root, renderExpirationTime$1);
          } else {
            // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootHasPendingPing = true;
          }
          return;
        }
        if (!isRootSuspendedAtTime(root, suspendedTime)) {
          // The root is no longer suspended at this time.
          return;
        }
        var lastPingedTime = root.lastPingedTime;
        if (lastPingedTime !== NoWork && lastPingedTime < suspendedTime) {
          // There's already a lower priority ping scheduled.
          return;
        } // Mark the time at which this ping was scheduled.

        root.lastPingedTime = suspendedTime;
        ensureRootIsScheduled(root);
        schedulePendingInteractions(root, suspendedTime);
      }
      function retryTimedOutBoundary(boundaryFiber, retryTime) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryTime === NoWork) {
          var suspenseConfig = null; // Retries don't carry over the already committed update.

          var currentTime = requestCurrentTimeForUpdate();
          retryTime = computeExpirationForFiber(currentTime, boundaryFiber, suspenseConfig);
        } // TODO: Special case idle priority?

        var root = markUpdateTimeFromFiberToRoot(boundaryFiber, retryTime);
        if (root !== null) {
          ensureRootIsScheduled(root);
          schedulePendingInteractions(root, retryTime);
        }
      }
      function resolveRetryThenable(boundaryFiber, thenable) {
        var retryTime = NoWork; // Default

        var retryCache;
        {
          retryCache = boundaryFiber.stateNode;
        }
        if (retryCache !== null) {
          // The thenable resolved, so we no longer need to memoize, because it will
          // never be thrown again.
          retryCache.delete(thenable);
        }
        retryTimedOutBoundary(boundaryFiber, retryTime);
      } // Computes the next Just Noticeable Difference (JND) boundary.
      // The theory is that a person can't tell the difference between small differences in time.
      // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
      // difference in the experience. However, waiting for longer might mean that we can avoid
      // showing an intermediate loading state. The longer we have already waited, the harder it
      // is to tell small differences in time. Therefore, the longer we've already waited,
      // the longer we can wait additionally. At some point we have to give up though.
      // We pick a train model where the next boundary commits at a consistent schedule.
      // These particular numbers are vague estimates. We expect to adjust them based on research.

      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
      }
      function computeMsUntilSuspenseLoadingDelay(mostRecentEventTime, committedExpirationTime, suspenseConfig) {
        var busyMinDurationMs = suspenseConfig.busyMinDurationMs | 0;
        if (busyMinDurationMs <= 0) {
          return 0;
        }
        var busyDelayMs = suspenseConfig.busyDelayMs | 0; // Compute the time until this render pass would expire.

        var currentTimeMs = now();
        var eventTimeMs = inferTimeFromExpirationTimeWithSuspenseConfig(mostRecentEventTime, suspenseConfig);
        var timeElapsed = currentTimeMs - eventTimeMs;
        if (timeElapsed <= busyDelayMs) {
          // If we haven't yet waited longer than the initial delay, we don't
          // have to wait any additional time.
          return 0;
        }
        var msUntilTimeout = busyDelayMs + busyMinDurationMs - timeElapsed; // This is the value that is passed to `setTimeout`.

        return msUntilTimeout;
      }
      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          {
            {
              throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
            }
          }
        }
        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error('Maximum update depth exceeded. This can happen when a component ' + "calls setState inside useEffect, but useEffect either doesn't " + 'have a dependency array, or one of the dependencies changes on ' + 'every render.');
          }
        }
      }
      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }
      function stopFinishedWorkLoopTimer() {
        var didCompleteRoot = true;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function stopInterruptedWorkLoopTimer() {
        // TODO: Track which fiber caused the interruption.
        var didCompleteRoot = false;
        stopWorkLoopTimer(interruptedBy, didCompleteRoot);
        interruptedBy = null;
      }
      function checkForInterruption(fiberThatReceivedUpdate, updateExpirationTime) {
        if (workInProgressRoot !== null && updateExpirationTime > renderExpirationTime$1) {
          interruptedBy = fiberThatReceivedUpdate;
        }
      }
      var didWarnStateUpdateForUnmountedComponent = null;
      function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        {
          var tag = fiber.tag;
          if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) {
            // Only warn for user-defined components, not internal ones like Suspense.
            return;
          }
          // the problematic code almost always lies inside that component.

          var componentName = getComponentName(fiber.type) || 'ReactComponent';
          if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
              return;
            }
            didWarnStateUpdateForUnmountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForUnmountedComponent = new Set([componentName]);
          }
          error("Can't perform a React state update on an unmounted component. This " + 'is a no-op, but it indicates a memory leak in your application. To ' + 'fix, cancel all subscriptions and asynchronous tasks in %s.%s', tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function', getStackByFiberInDevAndProd(fiber));
        }
      }
      var beginWork$1;
      {
        var dummyFiber = null;
        beginWork$1 = function beginWork$1(current, unitOfWork, expirationTime) {
          // If a component throws an error, we replay it again in a synchronously
          // dispatched event, so that the debugger will treat it as an uncaught
          // error See ReactErrorUtils for more information.
          // Before entering the begin phase, copy the work-in-progress onto a dummy
          // fiber. If beginWork throws, we'll use this to reset the state.
          var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
          try {
            return beginWork(current, unitOfWork, expirationTime);
          } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') {
              // Don't replay promises. Treat everything else like an error.
              throw originalError;
            } // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.

            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame

            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.

            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) {
              // Reset the profiler timer.
              startProfilerTimer(unitOfWork);
            } // Run beginWork again.

            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, expirationTime);
            if (hasCaughtError()) {
              var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
              // Rethrow this error instead of the original one.

              throw replayError;
            } else {
              // This branch is reachable if the render phase is impure.
              throw originalError;
            }
          }
        };
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = new Set();
      }
      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && (executionContext & RenderContext) !== NoContext) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent:
                {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.

                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error('Cannot update a component (`%s`) while rendering a ' + 'different component (`%s`). To locate the bad setState() call inside `%s`, ' + 'follow the stack trace as described in https://fb.me/setstate-in-render', setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
              case ClassComponent:
                {
                  if (!didWarnAboutUpdateInRender) {
                    error('Cannot update during an existing state transition (such as ' + 'within `render`). Render methods should be a pure ' + 'function of props and state.');
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
            }
          }
        }
      } // a 'shared' variable that changes when act() opens/closes in tests.

      var IsThisRendererActing = {
        current: false
      };
      function warnIfNotScopedWithMatchingAct(fiber) {
        {
          if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            error("It looks like you're using the wrong act() around your test interactions.\n" + 'Be sure to use the matching version of act() corresponding to your renderer:\n\n' + '// for react-dom:\n' + "import {act} from 'react-dom/test-utils';\n" + '// ...\n' + 'act(() => ...);\n\n' + '// for react-test-renderer:\n' + "import TestRenderer from 'react-test-renderer';\n" + 'const {act} = TestRenderer;\n' + '// ...\n' + 'act(() => ...);' + '%s', getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        {
          if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s ran an effect, but was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        {
          if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            error('An update to %s inside a test was not wrapped in act(...).\n\n' + 'When testing, code that causes React state updates should be ' + 'wrapped into act(...):\n\n' + 'act(() => {\n' + '  /* fire events that update state */\n' + '});\n' + '/* assert on the output */\n\n' + "This ensures that you're testing the behavior the user would see " + 'in the browser.' + ' Learn more at https://fb.me/react-wrap-tests-with-act' + '%s', getComponentName(fiber.type), getStackByFiberInDevAndProd(fiber));
          }
        }
      }
      var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.

      var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
      // scheduler is the actual recommendation. The alternative could be a testing build,
      // a new lib, or whatever; we dunno just yet. This message is for early adopters
      // to get their tests right.

      function warnIfUnmockedScheduler(fiber) {
        {
          if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
              didWarnAboutUnmockedScheduler = true;
              error('In Concurrent or Sync modes, the "scheduler" module needs to be mocked ' + 'to guarantee consistent behaviour across tests and browsers. ' + 'For example, with jest: \n' + "jest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\n" + 'For more info, visit https://fb.me/react-mock-scheduler');
            }
          }
        }
      }
      function computeThreadID(root, expirationTime) {
        // Interaction threads are unique per root and expiration time.
        return expirationTime * 1000 + root.interactionThreadID;
      }
      function markSpawnedWork(expirationTime) {
        if (spawnedWorkDuringRender === null) {
          spawnedWorkDuringRender = [expirationTime];
        } else {
          spawnedWorkDuringRender.push(expirationTime);
        }
      }
      function scheduleInteractions(root, expirationTime, interactions) {
        if (interactions.size > 0) {
          var pendingInteractionMap = root.pendingInteractionMap;
          var pendingInteractions = pendingInteractionMap.get(expirationTime);
          if (pendingInteractions != null) {
            interactions.forEach(function (interaction) {
              if (!pendingInteractions.has(interaction)) {
                // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
              }
              pendingInteractions.add(interaction);
            });
          } else {
            pendingInteractionMap.set(expirationTime, new Set(interactions)); // Update the pending async work count for the current interactions.

            interactions.forEach(function (interaction) {
              interaction.__count++;
            });
          }
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            subscriber.onWorkScheduled(interactions, threadID);
          }
        }
      }
      function schedulePendingInteractions(root, expirationTime) {
        scheduleInteractions(root, expirationTime, tracing$1.__interactionsRef.current);
      }
      function startWorkOnPendingInteractions(root, expirationTime) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.

        var interactions = new Set();
        root.pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
          if (scheduledExpirationTime >= expirationTime) {
            scheduledInteractions.forEach(function (interaction) {
              return interactions.add(interaction);
            });
          }
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.

        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
          var subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null) {
            var threadID = computeThreadID(root, expirationTime);
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
              // If the subscriber throws, rethrow it in a separate task
              scheduleCallback(ImmediatePriority, function () {
                throw error;
              });
            }
          }
        }
      }
      function finishPendingInteractions(root, committedExpirationTime) {
        var earliestRemainingTimeAfterCommit = root.firstPendingTime;
        var subscriber;
        try {
          subscriber = tracing$1.__subscriberRef.current;
          if (subscriber !== null && root.memoizedInteractions.size > 0) {
            var threadID = computeThreadID(root, committedExpirationTime);
            subscriber.onWorkStopped(root.memoizedInteractions, threadID);
          }
        } catch (error) {
          // If the subscriber throws, rethrow it in a separate task
          scheduleCallback(ImmediatePriority, function () {
            throw error;
          });
        } finally {
          // Clear completed interactions from the pending Map.
          // Unless the render was suspended or cascading work was scheduled,
          // In which case– leave pending interactions until the subsequent render.
          var pendingInteractionMap = root.pendingInteractionMap;
          pendingInteractionMap.forEach(function (scheduledInteractions, scheduledExpirationTime) {
            // Only decrement the pending interaction count if we're done.
            // If there's still work at the current priority,
            // That indicates that we are waiting for suspense data.
            if (scheduledExpirationTime > earliestRemainingTimeAfterCommit) {
              pendingInteractionMap.delete(scheduledExpirationTime);
              scheduledInteractions.forEach(function (interaction) {
                interaction.__count--;
                if (subscriber !== null && interaction.__count === 0) {
                  try {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority, function () {
                      throw error;
                    });
                  }
                }
              });
            }
          });
        }
      }
      var onScheduleFiberRoot = null;
      var onCommitFiberRoot = null;
      var onCommitFiberUnmount = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
          // No DevTools
          return false;
        }
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) {
          // This isn't a real property on the hook, but it can be set to opt out
          // of DevTools integration and associated warnings and logs.
          // https://github.com/facebook/react/issues/3877
          return true;
        }
        if (!hook.supportsFiber) {
          {
            error('The installed version of React DevTools is too old and will not work ' + 'with the current version of React. Please update React DevTools. ' + 'https://fb.me/react-devtools');
          } // DevTools exists, even though it doesn't support Fiber.

          return true;
        }
        try {
          var rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.

          if (true) {
            // Only used by Fast Refresh
            if (typeof hook.onScheduleFiberRoot === 'function') {
              onScheduleFiberRoot = function onScheduleFiberRoot(root, children) {
                try {
                  hook.onScheduleFiberRoot(rendererID, root, children);
                } catch (err) {
                  if (true && !hasLoggedError) {
                    hasLoggedError = true;
                    error('React instrumentation encountered an error: %s', err);
                  }
                }
              };
            }
          }
          onCommitFiberRoot = function onCommitFiberRoot(root, expirationTime) {
            try {
              var didError = (root.current.effectTag & DidCapture) === DidCapture;
              if (enableProfilerTimer) {
                var currentTime = getCurrentTime();
                var priorityLevel = inferPriorityFromExpirationTime(currentTime, expirationTime);
                hook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
              } else {
                hook.onCommitFiberRoot(rendererID, root, undefined, didError);
              }
            } catch (err) {
              if (true) {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
          onCommitFiberUnmount = function onCommitFiberUnmount(fiber) {
            try {
              hook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              if (true) {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error('React instrumentation encountered an error: %s', err);
                }
              }
            }
          };
        } catch (err) {
          // Catch all errors because it is unsafe to throw during initialization.
          {
            error('React instrumentation encountered an error: %s.', err);
          }
        } // DevTools exists

        return true;
      }
      function onScheduleRoot(root, children) {
        if (typeof onScheduleFiberRoot === 'function') {
          onScheduleFiberRoot(root, children);
        }
      }
      function onCommitRoot(root, expirationTime) {
        if (typeof onCommitFiberRoot === 'function') {
          onCommitFiberRoot(root, expirationTime);
        }
      }
      function onCommitUnmount(fiber) {
        if (typeof onCommitFiberUnmount === 'function') {
          onCommitFiberUnmount(fiber);
        }
      }
      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;
        try {
          var nonExtensibleObject = Object.preventExtensions({});
          var testMap = new Map([[nonExtensibleObject, null]]);
          var testSet = new Set([nonExtensibleObject]); // This is necessary for Rollup to not consider these unused.
          // https://github.com/rollup/rollup/issues/1771
          // TODO: we can remove these if Rollup fixes the bug.

          testMap.set(0, 0);
          testSet.add(0);
        } catch (e) {
          // TODO: Consider warning about bad polyfills
          hasBadMapPolyfill = true;
        }
      }
      var debugCounter = 1;
      function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber

        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects

        this.effectTag = NoEffect;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.expirationTime = NoWork;
        this.childExpirationTime = NoWork;
        this.alternate = null;
        {
          // Note: The following is done to avoid a v8 performance cliff.
          //
          // Initializing the fields below to smis and later updating them with
          // double values will cause Fibers to end up having separate shapes.
          // This behavior/bug has something to do with Object.preventExtension().
          // Fortunately this only impacts DEV builds.
          // Unfortunately it makes React unusably slow for some applications.
          // To work around this, initialize the fields below with doubles.
          //
          // Learn more about this here:
          // https://github.com/facebook/react/issues/14365
          // https://bugs.chromium.org/p/v8/issues/detail?id=8538
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
          // This won't trigger the performance cliff mentioned above,
          // and it simplifies other profiler code (including DevTools).

          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        } // This is normally DEV-only except www when it adds listeners.
        // TODO: remove the User Timing integration in favor of Root Events.

        {
          this._debugID = debugCounter++;
          this._debugIsCurrentlyTiming = false;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;
          if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') {
            Object.preventExtensions(this);
          }
        }
      } // This is a constructor function, rather than a POJO constructor, still
      // please ensure we do the following:
      // 1) Nobody should add any instance methods on this. Instance methods can be
      //    more difficult to predict when they get optimized and they are almost
      //    never inlined properly in static compilers.
      // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
      //    always know when it is a fiber.
      // 3) We might want to experiment with using numeric keys since they are easier
      //    to optimize in a non-JIT environment.
      // 4) We can easily go from a constructor to a createFiber object literal if that
      //    is faster.
      // 5) It should be easy to port this to a C struct and keep a C implementation
      //    compatible.

      var createFiber = function createFiber(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
      };
      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct(type) && type.defaultProps === undefined;
      }
      function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') {
          return shouldConstruct(Component) ? ClassComponent : FunctionComponent;
        } else if (Component !== undefined && Component !== null) {
          var $$typeof = Component.$$typeof;
          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }
          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }
        return IndeterminateComponent;
      } // This is used to create an alternate fiber to do work on.

      function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
          // We use a double buffering pooling technique because we know that we'll
          // only ever need at most two versions of a tree. We pool the "other" unused
          // node that we're free to reuse. This is lazily created to avoid allocating
          // extra objects for things that are never updated. It also allow us to
          // reclaim the extra memory if needed.
          workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
          workInProgress.elementType = current.elementType;
          workInProgress.type = current.type;
          workInProgress.stateNode = current.stateNode;
          {
            // DEV-only fields
            {
              workInProgress._debugID = current._debugID;
            }
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
          }
          workInProgress.alternate = current;
          current.alternate = workInProgress;
        } else {
          workInProgress.pendingProps = pendingProps; // We already have an alternate.
          // Reset the effect tag.

          workInProgress.effectTag = NoEffect; // The effect list is no longer valid.

          workInProgress.nextEffect = null;
          workInProgress.firstEffect = null;
          workInProgress.lastEffect = null;
          {
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
          }
        }
        workInProgress.childExpirationTime = current.childExpirationTime;
        workInProgress.expirationTime = current.expirationTime;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.

        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
          expirationTime: currentDependencies.expirationTime,
          firstContext: currentDependencies.firstContext,
          responders: currentDependencies.responders
        }; // These will be overridden during the parent's reconciliation

        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        {
          workInProgress.selfBaseDuration = current.selfBaseDuration;
          workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        {
          workInProgress._debugNeedsRemount = current._debugNeedsRemount;
          switch (workInProgress.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress.type = resolveFunctionForHotReloading(current.type);
              break;
            case ClassComponent:
              workInProgress.type = resolveClassForHotReloading(current.type);
              break;
            case ForwardRef:
              workInProgress.type = resolveForwardRefForHotReloading(current.type);
              break;
          }
        }
        return workInProgress;
      } // Used to reuse a Fiber for a second pass.

      function resetWorkInProgress(workInProgress, renderExpirationTime) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.effectTag &= Placement; // The effect list is no longer valid.

        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
          // Reset to createFiber's initial values.
          workInProgress.childExpirationTime = NoWork;
          workInProgress.expirationTime = renderExpirationTime;
          workInProgress.child = null;
          workInProgress.memoizedProps = null;
          workInProgress.memoizedState = null;
          workInProgress.updateQueue = null;
          workInProgress.dependencies = null;
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
          }
        } else {
          // Reset to the cloned values that createWorkInProgress would've.
          workInProgress.childExpirationTime = current.childExpirationTime;
          workInProgress.expirationTime = current.expirationTime;
          workInProgress.child = current.child;
          workInProgress.memoizedProps = current.memoizedProps;
          workInProgress.memoizedState = current.memoizedState;
          workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
          // it cannot be shared with the current fiber.

          var currentDependencies = current.dependencies;
          workInProgress.dependencies = currentDependencies === null ? null : {
            expirationTime: currentDependencies.expirationTime,
            firstContext: currentDependencies.firstContext,
            responders: currentDependencies.responders
          };
          {
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
          }
        }
        return workInProgress;
      }
      function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) {
          mode = ConcurrentMode | BlockingMode | StrictMode;
        } else if (tag === BlockingRoot) {
          mode = BlockingMode | StrictMode;
        } else {
          mode = NoMode;
        }
        if (isDevToolsPresent) {
          // Always collect profile timings when DevTools are present.
          // This enables DevTools to start capturing timing at any point–
          // Without some nodes in the tree having empty base times.
          mode |= ProfileMode;
        }
        return createFiber(HostRoot, null, null, mode);
      }
      function createFiberFromTypeAndProps(type,
      // React$ElementType
      key, pendingProps, owner, mode, expirationTime) {
        var fiber;
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.

        var resolvedType = type;
        if (typeof type === 'function') {
          if (shouldConstruct(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === 'string') {
          fiberTag = HostComponent;
        } else {
          getTag: switch (type) {
            case REACT_FRAGMENT_TYPE:
              return createFiberFromFragment(pendingProps.children, mode, expirationTime, key);
            case REACT_CONCURRENT_MODE_TYPE:
              fiberTag = Mode;
              mode |= ConcurrentMode | BlockingMode | StrictMode;
              break;
            case REACT_STRICT_MODE_TYPE:
              fiberTag = Mode;
              mode |= StrictMode;
              break;
            case REACT_PROFILER_TYPE:
              return createFiberFromProfiler(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_TYPE:
              return createFiberFromSuspense(pendingProps, mode, expirationTime, key);
            case REACT_SUSPENSE_LIST_TYPE:
              return createFiberFromSuspenseList(pendingProps, mode, expirationTime, key);
            default:
              {
                if (typeof type === 'object' && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;
                    case REACT_CONTEXT_TYPE:
                      // This is a consumer
                      fiberTag = ContextConsumer;
                      break getTag;
                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;
                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;
                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                    case REACT_BLOCK_TYPE:
                      fiberTag = Block;
                      break getTag;
                  }
                }
                var info = '';
                {
                  if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
                    info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and " + 'named imports.';
                  }
                  var ownerName = owner ? getComponentName(owner.type) : null;
                  if (ownerName) {
                    info += '\n\nCheck the render method of `' + ownerName + '`.';
                  }
                }
                {
                  {
                    throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
                  }
                }
              }
          }
        }
        fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromElement(element, mode, expirationTime) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, expirationTime);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }
      function createFiberFromFragment(elements, mode, expirationTime, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromProfiler(pendingProps, mode, expirationTime, key) {
        {
          if (typeof pendingProps.id !== 'string' || typeof pendingProps.onRender !== 'function') {
            error('Profiler must specify an "id" string and "onRender" function as props');
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.

        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspense(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.

        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromSuspenseList(pendingProps, mode, expirationTime, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        {
          // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
          // This needs to be fixed in getComponentName so that it relies on the tag
          // instead.
          fiber.type = REACT_SUSPENSE_LIST_TYPE;
        }
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromText(content, mode, expirationTime) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.expirationTime = expirationTime;
        return fiber;
      }
      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.

        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
      }
      function createFiberFromPortal(portal, mode, expirationTime) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.expirationTime = expirationTime;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: portal.implementation
        };
        return fiber;
      } // Used for stashing WIP properties to replay failed work in DEV.

      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          // This Fiber's initial properties will always be overwritten.
          // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
          target = createFiber(IndeterminateComponent, null, null, NoMode);
        } // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.

        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.effectTag = source.effectTag;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.expirationTime = source.expirationTime;
        target.childExpirationTime = source.childExpirationTime;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        {
          target._debugID = source._debugID;
        }
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugIsCurrentlyTiming = source._debugIsCurrentlyTiming;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
      }
      function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.current = null;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.pingCache = null;
        this.finishedExpirationTime = NoWork;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoPriority;
        this.firstPendingTime = NoWork;
        this.firstSuspendedTime = NoWork;
        this.lastSuspendedTime = NoWork;
        this.nextKnownPendingLevel = NoWork;
        this.lastPingedTime = NoWork;
        this.lastExpiredTime = NoWork;
        {
          this.interactionThreadID = tracing$1.unstable_getThreadID();
          this.memoizedInteractions = new Set();
          this.pendingInteractionMap = new Map();
        }
      }
      function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.

        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
      }
      function isRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        return firstSuspendedTime !== NoWork && firstSuspendedTime >= expirationTime && lastSuspendedTime <= expirationTime;
      }
      function markRootSuspendedAtTime(root, expirationTime) {
        var firstSuspendedTime = root.firstSuspendedTime;
        var lastSuspendedTime = root.lastSuspendedTime;
        if (firstSuspendedTime < expirationTime) {
          root.firstSuspendedTime = expirationTime;
        }
        if (lastSuspendedTime > expirationTime || firstSuspendedTime === NoWork) {
          root.lastSuspendedTime = expirationTime;
        }
        if (expirationTime <= root.lastPingedTime) {
          root.lastPingedTime = NoWork;
        }
        if (expirationTime <= root.lastExpiredTime) {
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootUpdatedAtTime(root, expirationTime) {
        // Update the range of pending times
        var firstPendingTime = root.firstPendingTime;
        if (expirationTime > firstPendingTime) {
          root.firstPendingTime = expirationTime;
        } // Update the range of suspended times. Treat everything lower priority or
        // equal to this update as unsuspended.

        var firstSuspendedTime = root.firstSuspendedTime;
        if (firstSuspendedTime !== NoWork) {
          if (expirationTime >= firstSuspendedTime) {
            // The entire suspended range is now unsuspended.
            root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
          } else if (expirationTime >= root.lastSuspendedTime) {
            root.lastSuspendedTime = expirationTime + 1;
          } // This is a pending level. Check if it's higher priority than the next
          // known pending level.

          if (expirationTime > root.nextKnownPendingLevel) {
            root.nextKnownPendingLevel = expirationTime;
          }
        }
      }
      function markRootFinishedAtTime(root, finishedExpirationTime, remainingExpirationTime) {
        // Update the range of pending times
        root.firstPendingTime = remainingExpirationTime; // Update the range of suspended times. Treat everything higher priority or
        // equal to this update as unsuspended.

        if (finishedExpirationTime <= root.lastSuspendedTime) {
          // The entire suspended range is now unsuspended.
          root.firstSuspendedTime = root.lastSuspendedTime = root.nextKnownPendingLevel = NoWork;
        } else if (finishedExpirationTime <= root.firstSuspendedTime) {
          // Part of the suspended range is now unsuspended. Narrow the range to
          // include everything between the unsuspended time (non-inclusive) and the
          // last suspended time.
          root.firstSuspendedTime = finishedExpirationTime - 1;
        }
        if (finishedExpirationTime <= root.lastPingedTime) {
          // Clear the pinged time
          root.lastPingedTime = NoWork;
        }
        if (finishedExpirationTime <= root.lastExpiredTime) {
          // Clear the expired time
          root.lastExpiredTime = NoWork;
        }
      }
      function markRootExpiredAtTime(root, expirationTime) {
        var lastExpiredTime = root.lastExpiredTime;
        if (lastExpiredTime === NoWork || lastExpiredTime > expirationTime) {
          root.lastExpiredTime = expirationTime;
        }
      }
      var didWarnAboutNestedUpdates;
      var didWarnAboutFindNodeInStrictMode;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }
      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
          var Component = fiber.type;
          if (isContextProvider(Component)) {
            return processChildContext(fiber, Component, parentContext);
          }
        }
        return parentContext;
      }
      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get(component);
          if (fiber === undefined) {
            if (typeof component.render === 'function') {
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            } else {
              {
                {
                  throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
                }
              }
            }
          }
          var hostFiber = findCurrentHostFiber(fiber);
          if (hostFiber === null) {
            return null;
          }
          if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;
              if (fiber.mode & StrictMode) {
                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which is inside StrictMode. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-find-node%s', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              } else {
                error('%s is deprecated in StrictMode. ' + '%s was passed an instance of %s which renders StrictMode children. ' + 'Instead, add a ref directly to the element you want to reference. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-find-node%s', methodName, methodName, componentName, getStackByFiberInDevAndProd(hostFiber));
              }
            }
          }
          return hostFiber.stateNode;
        }
      }
      function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
      }
      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var currentTime = requestCurrentTimeForUpdate();
        {
          // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
          if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
          }
        }
        var suspenseConfig = requestCurrentSuspenseConfig();
        var expirationTime = computeExpirationForFiber(currentTime, current$1, suspenseConfig);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) {
          container.context = context;
        } else {
          container.pendingContext = context;
        }
        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error('Render methods should be a pure function of props and state; ' + 'triggering nested component updates from render is not allowed. ' + 'If necessary, trigger nested updates in componentDidUpdate.\n\n' + 'Check the render method of %s.', getComponentName(current.type) || 'Unknown');
          }
        }
        var update = createUpdate(expirationTime, suspenseConfig); // Caution: React DevTools currently depends on this property
        // being called "element".

        update.payload = {
          element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
          {
            if (typeof callback !== 'function') {
              error('render(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callback);
            }
          }
          update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleWork(current$1, expirationTime);
        return expirationTime;
      }
      function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) {
          return null;
        }
        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);
          default:
            return containerFiber.child.stateNode;
        }
      }
      function markRetryTimeImpl(fiber, retryTime) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
          if (suspenseState.retryTime < retryTime) {
            suspenseState.retryTime = retryTime;
          }
        }
      } // Increases the priority of thennables when they resolve within this boundary.

      function markRetryTimeIfNotHydrated(fiber, retryTime) {
        markRetryTimeImpl(fiber, retryTime);
        var alternate = fiber.alternate;
        if (alternate) {
          markRetryTimeImpl(alternate, retryTime);
        }
      }
      function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority and they should not suspend on I/O,
          // since you have to wrap anything that might suspend in
          // Suspense.
          return;
        }
        var expTime = computeInteractiveExpiration(requestCurrentTimeForUpdate());
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
      }
      function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority and they should not suspend on I/O,
          // since you have to wrap anything that might suspend in
          // Suspense.
          return;
        }
        scheduleWork(fiber, ContinuousHydration);
        markRetryTimeIfNotHydrated(fiber, ContinuousHydration);
      }
      function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          // We ignore HostRoots here because we can't increase
          // their priority other than synchronously flush it.
          return;
        }
        var currentTime = requestCurrentTimeForUpdate();
        var expTime = computeExpirationForFiber(currentTime, fiber, null);
        scheduleWork(fiber, expTime);
        markRetryTimeIfNotHydrated(fiber, expTime);
      }
      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) {
          return null;
        }
        if (hostFiber.tag === FundamentalComponent) {
          return hostFiber.stateNode.instance;
        }
        return hostFiber.stateNode;
      }
      var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
      };
      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }
      var overrideHookState = null;
      var overrideProps = null;
      var scheduleUpdate = null;
      var setSuspenseHandler = null;
      {
        var copyWithSetImpl = function copyWithSetImpl(obj, path, idx, value) {
          if (idx >= path.length) {
            return value;
          }
          var key = path[idx];
          var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here

          updated[key] = copyWithSetImpl(obj[key], path, idx + 1, value);
          return updated;
        };
        var copyWithSet = function copyWithSet(obj, path, value) {
          return copyWithSetImpl(obj, path, 0, value);
        }; // Support DevTools editable values for useState and useReducer.

        overrideHookState = function overrideHookState(fiber, id, path, value) {
          // For now, the "id" of stateful hooks is just the stateful hook index.
          // This may change in the future with e.g. nested hooks.
          var currentHook = fiber.memoizedState;
          while (currentHook !== null && id > 0) {
            currentHook = currentHook.next;
            id--;
          }
          if (currentHook !== null) {
            var newState = copyWithSet(currentHook.memoizedState, path, value);
            currentHook.memoizedState = newState;
            currentHook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.

            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleWork(fiber, Sync);
          }
        }; // Support DevTools props for function components, forwardRef, memo, host components, etc.

        overrideProps = function overrideProps(fiber, path, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleWork(fiber, Sync);
        };
        scheduleUpdate = function scheduleUpdate(fiber) {
          scheduleWork(fiber, Sync);
        };
        setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }
      function injectIntoDevTools(devToolsConfig) {
        var _findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals(_assign({}, devToolsConfig, {
          overrideHookState: overrideHookState,
          overrideProps: overrideProps,
          setSuspenseHandler: setSuspenseHandler,
          scheduleUpdate: scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher,
          findHostInstanceByFiber: function findHostInstanceByFiber(fiber) {
            var hostFiber = findCurrentHostFiber(fiber);
            if (hostFiber === null) {
              return null;
            }
            return hostFiber.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(instance) {
            if (!_findFiberByHostInstance) {
              // Might not be implemented by the renderer.
              return null;
            }
            return _findFiberByHostInstance(instance);
          },
          // React Refresh
          findHostInstancesForRefresh: findHostInstancesForRefresh,
          scheduleRefresh: scheduleRefresh,
          scheduleRoot: scheduleRoot,
          setRefreshHandler: setRefreshHandler,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: function getCurrentFiber() {
            return current;
          }
        }));
      }
      var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
      function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
      }
      function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
      }
      ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function (children) {
        var root = this._internalRoot;
        {
          if (typeof arguments[1] === 'function') {
            error('render(...): does not support the second callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
          var container = root.containerInfo;
          if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of the ' + 'root container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + "root.unmount() to empty a root's container.");
              }
            }
          }
        }
        updateContainer(children, root, null, null);
      };
      ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function () {
        {
          if (typeof arguments[0] === 'function') {
            error('unmount(...): does not support a callback argument. ' + 'To execute a side effect after rendering, declare it in a component body with useEffect().');
          }
        }
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function () {
          unmarkContainerAsRoot(container);
        });
      };
      function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        if (hydrate && tag !== LegacyRoot) {
          var doc = container.nodeType === DOCUMENT_NODE ? container : container.ownerDocument;
          eagerlyTrapReplayableEvents(container, doc);
        }
        return root;
      }
      function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
      }
      function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
      }
      var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
      var topLevelUpdateWarnings;
      var warnedAboutHydrateAPI = false;
      {
        topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
          if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
              if (hostInstance.parentNode !== container) {
                error('render(...): It looks like the React-rendered content of this ' + 'container was removed without using React. This is not ' + 'supported and will cause errors. Instead, call ' + 'ReactDOM.unmountComponentAtNode to empty a container.');
              }
            }
          }
          var isRootRenderedBySomeReact = !!container._reactRootContainer;
          var rootEl = getReactRootElementInContainer(container);
          var hasNonRootReactChild = !!(rootEl && getInstanceFromNode$1(rootEl));
          if (hasNonRootReactChild && !isRootRenderedBySomeReact) {
            error('render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.');
          }
          if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') {
            error('render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.');
          }
        };
      }
      function getReactRootElementInContainer(container) {
        if (!container) {
          return null;
        }
        if (container.nodeType === DOCUMENT_NODE) {
          return container.documentElement;
        } else {
          return container.firstChild;
        }
      }
      function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
      }
      function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.

        if (!shouldHydrate) {
          var warned = false;
          var rootSibling;
          while (rootSibling = container.lastChild) {
            {
              if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                warned = true;
                error('render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.');
              }
            }
            container.removeChild(rootSibling);
          }
        }
        {
          if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn('render(): Calling ReactDOM.render() to hydrate server-rendered markup ' + 'will stop working in React v17. Replace the ReactDOM.render() call ' + 'with ReactDOM.hydrate() if you want React to attach to the server HTML.');
          }
        }
        return createLegacyRoot(container, shouldHydrate ? {
          hydrate: true
        } : undefined);
      }
      function warnOnInvalidCallback$1(callback, callerName) {
        {
          if (callback !== null && typeof callback !== 'function') {
            error('%s(...): Expected the last optional `callback` argument to be a ' + 'function. Instead received: %s.', callerName, callback);
          }
        }
      }
      function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        {
          topLevelUpdateWarnings(container);
          warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        } // TODO: Without `any` type, Flow says "Property cannot be accessed on any
        // member of intersection type." Whyyyyyy.

        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
          // Initial mount
          root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
          fiberRoot = root._internalRoot;
          if (typeof callback === 'function') {
            var originalCallback = callback;
            callback = function callback() {
              var instance = getPublicRootInstance(fiberRoot);
              originalCallback.call(instance);
            };
          } // Initial mount should not be batched.

          unbatchedUpdates(function () {
            updateContainer(children, fiberRoot, parentComponent, callback);
          });
        } else {
          fiberRoot = root._internalRoot;
          if (typeof callback === 'function') {
            var _originalCallback = callback;
            callback = function callback() {
              var instance = getPublicRootInstance(fiberRoot);
              _originalCallback.call(instance);
            };
          } // Update

          updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
      }
      function findDOMNode(componentOrElement) {
        {
          var owner = ReactCurrentOwner$3.current;
          if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) {
              error('%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', getComponentName(owner.type) || 'A component');
            }
            owner.stateNode._warnedAboutRefsInRender = true;
          }
        }
        if (componentOrElement == null) {
          return null;
        }
        if (componentOrElement.nodeType === ELEMENT_NODE) {
          return componentOrElement;
        }
        {
          return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
        }
      }
      function hydrate(element, container, callback) {
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.hydrate() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call createRoot(container, {hydrate: true}).render(element)?');
          }
        } // TODO: throw or warn if we couldn't hydrate?

        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
      }
      function render(element, container, callback) {
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.render() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. ' + 'Did you mean to call root.render(element)?');
          }
        }
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
      }
      function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        }
        if (!(parentComponent != null && has(parentComponent))) {
          {
            throw Error("parentComponent must be a valid React Component");
          }
        }
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
      }
      function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) {
          {
            throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
          }
        }
        {
          var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
          if (isModernRoot) {
            error('You are calling ReactDOM.unmountComponentAtNode() on a container that was previously ' + 'passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?');
          }
        }
        if (container._reactRootContainer) {
          {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode$1(rootEl);
            if (renderedByDifferentReact) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.');
            }
          } // Unmount should not be batched.

          unbatchedUpdates(function () {
            legacyRenderSubtreeIntoContainer(null, null, container, false, function () {
              // $FlowFixMe This should probably use `delete container._reactRootContainer`
              container._reactRootContainer = null;
              unmarkContainerAsRoot(container);
            });
          }); // If you call unmountComponentAtNode twice in quick succession, you'll
          // get `true` twice. That's probably fine?

          return true;
        } else {
          {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode$1(_rootEl)); // Check if the container itself is a React root node.

            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) {
              error("unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.');
            }
          }
          return false;
        }
      }
      function createPortal(children, containerInfo,
      // TODO: figure out the API for cross-renderer implementation.
      implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
          // This tag allow us to uniquely identify this as a React Portal
          $$typeof: REACT_PORTAL_TYPE,
          key: key == null ? null : '' + key,
          children: children,
          containerInfo: containerInfo,
          implementation: implementation
        };
      }
      var ReactVersion = '16.13.1';
      setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
      setAttemptContinuousHydration(attemptContinuousHydration$1);
      setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
      var didWarnAboutUnstableCreatePortal = false;
      {
        if (typeof Map !== 'function' ||
        // $FlowIssue Flow incorrectly thinks Map has no prototype
        Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' ||
        // $FlowIssue Flow incorrectly thinks Set has no prototype
        Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') {
          error('React depends on Map and Set built-in types. Make sure that you load a ' + 'polyfill in older browsers. https://fb.me/react-polyfills');
        }
      }
      setRestoreImplementation(restoreControlledState$3);
      setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
      function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) {
          {
            throw Error("Target container is not a DOM element.");
          }
        } // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.

        return createPortal(children, container, null, key);
      }
      function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
      }
      function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        {
          if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactDOM.createPortal() instead. It has the exact same API, ' + 'but without the "unstable_" prefix.');
          }
        }
        return createPortal$1(children, container, key);
      }
      var Internals = {
        // Keep in sync with ReactDOMUnstableNativeDependencies.js
        // ReactTestUtils.js, and ReactTestUtilsAct.js. This is an array for better minification.
        Events: [getInstanceFromNode$1, getNodeFromInstance$1, getFiberCurrentPropsFromNode$1, injectEventPluginsByName, eventNameDispatchConfigs, accumulateTwoPhaseDispatches, accumulateDirectDispatches, enqueueStateRestore, restoreStateIfNeeded, dispatchEvent, runEventsInBatch, flushPassiveEffects, IsThisRendererActing]
      };
      var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
      });
      {
        if (!foundDevTools && canUseDOM && window.top === window.self) {
          // If we're in Chrome or Firefox, provide a download link if not installed.
          if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.

            if (/^(https?|file):$/.test(protocol)) {
              // eslint-disable-next-line react-internal/no-production-logging
              console.info('%cDownload the React DevTools ' + 'for a better development experience: ' + 'https://fb.me/react-devtools' + (protocol === 'file:' ? '\nYou might need to use a local HTTP server (instead of file://): ' + 'https://fb.me/react-devtools-faq' : ''), 'font-weight:bold');
            }
          }
        }
      }
      exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
      exports.createPortal = createPortal$1;
      exports.findDOMNode = findDOMNode;
      exports.flushSync = flushSync;
      exports.hydrate = hydrate;
      exports.render = render;
      exports.unmountComponentAtNode = unmountComponentAtNode;
      exports.unstable_batchedUpdates = batchedUpdates$1;
      exports.unstable_createPortal = unstable_createPortal;
      exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
      exports.version = ReactVersion;
    })();
  }
});
var reactDom_development_1 = reactDom_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var reactDom_development_2 = reactDom_development.createPortal;
var reactDom_development_3 = reactDom_development.findDOMNode;
var reactDom_development_4 = reactDom_development.flushSync;
var reactDom_development_5 = reactDom_development.hydrate;
var reactDom_development_6 = reactDom_development.render;
var reactDom_development_7 = reactDom_development.unmountComponentAtNode;
var reactDom_development_8 = reactDom_development.unstable_batchedUpdates;
var reactDom_development_9 = reactDom_development.unstable_createPortal;
var reactDom_development_10 = reactDom_development.unstable_renderSubtreeIntoContainer;
var reactDom_development_11 = reactDom_development.version;
var reactDom = createCommonjsModule(function (module) {
  {
    module.exports = reactDom_development;
  }
});
var build = createCommonjsModule(function (module) {
  module.exports = function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: 'Module'
      }), Object.defineProperty(e, '__esModule', {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && 'object' == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, 'default', {
        enumerable: !0,
        value: e
      }), 2 & t && 'string' != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, 'a', t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = '', r(r.s = 8);
  }([function (e, t) {
    e.exports = React__default;
  }, function (e, t, r) {
    e.exports = r(10)();
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    }), t.default = function () {
      return 'undefined' != typeof window && 'IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype;
    };
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      o = u(r(0)),
      i = r(1),
      s = u(r(4)),
      a = u(r(12)),
      l = u(r(2));
    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var c = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        }(this, t);
        var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
          n = e.afterLoad,
          o = e.beforeLoad,
          i = e.scrollPosition,
          s = e.visibleByDefault;
        return r.state = {
          visible: s
        }, s && (o(), n()), r.onVisible = r.onVisible.bind(r), r.isScrollTracked = Boolean(i && Number.isFinite(i.x) && i.x >= 0 && Number.isFinite(i.y) && i.y >= 0), r;
      }
      return function (e, t) {
        if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), n(t, [{
        key: 'componentDidUpdate',
        value: function value(e, t) {
          t.visible !== this.state.visible && this.props.afterLoad();
        }
      }, {
        key: 'onVisible',
        value: function value() {
          this.props.beforeLoad(), this.setState({
            visible: !0
          });
        }
      }, {
        key: 'render',
        value: function value() {
          if (this.state.visible) return this.props.children;
          var e = this.props,
            t = e.className,
            r = e.delayMethod,
            n = e.delayTime,
            i = e.height,
            u = e.placeholder,
            c = e.scrollPosition,
            f = e.style,
            p = e.threshold,
            d = e.useIntersectionObserver,
            y = e.width;
          return this.isScrollTracked || d && (0, l.default)() ? o.default.createElement(s.default, {
            className: t,
            height: i,
            onVisible: this.onVisible,
            placeholder: u,
            scrollPosition: c,
            style: f,
            threshold: p,
            useIntersectionObserver: d,
            width: y
          }) : o.default.createElement(a.default, {
            className: t,
            delayMethod: r,
            delayTime: n,
            height: i,
            onVisible: this.onVisible,
            placeholder: u,
            style: f,
            threshold: p,
            width: y
          });
        }
      }]), t;
    }(o.default.Component);
    c.propTypes = {
      afterLoad: i.PropTypes.func,
      beforeLoad: i.PropTypes.func,
      useIntersectionObserver: i.PropTypes.bool,
      visibleByDefault: i.PropTypes.bool
    }, c.defaultProps = {
      afterLoad: function afterLoad() {
        return {};
      },
      beforeLoad: function beforeLoad() {
        return {};
      },
      useIntersectionObserver: !0,
      visibleByDefault: !1
    }, t.default = c;
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      o = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      i = u(r(0)),
      s = u(r(5)),
      a = r(1),
      l = u(r(2));
    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var c = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        }(this, t);
        var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
          n = !e.scrollPosition && e.useIntersectionObserver && (0, l.default)();
        if (r.LAZY_LOAD_OBSERVER = {
          supportsObserver: n
        }, n) {
          var o = e.threshold;
          r.LAZY_LOAD_OBSERVER.observer = new IntersectionObserver(r.checkIntersections, {
            rootMargin: o + 'px'
          });
        }
        return r;
      }
      return function (e, t) {
        if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, [{
        key: 'checkIntersections',
        value: function value(e) {
          e.forEach(function (e) {
            e.isIntersecting && e.target.onVisible();
          });
        }
      }, {
        key: 'componentDidMount',
        value: function value() {
          this.placeholder && this.LAZY_LOAD_OBSERVER && this.LAZY_LOAD_OBSERVER.observer && (this.placeholder.onVisible = this.props.onVisible, this.LAZY_LOAD_OBSERVER.observer.observe(this.placeholder)), this.LAZY_LOAD_OBSERVER && !this.LAZY_LOAD_OBSERVER.supportsObserver && this.updateVisibility();
        }
      }, {
        key: 'componentWillUnmount',
        value: function value() {
          this.LAZY_LOAD_OBSERVER && this.LAZY_LOAD_OBSERVER.observer && this.LAZY_LOAD_OBSERVER.observer.unobserve(this.placeholder);
        }
      }, {
        key: 'componentDidUpdate',
        value: function value() {
          this.LAZY_LOAD_OBSERVER && !this.LAZY_LOAD_OBSERVER.supportsObserver && this.updateVisibility();
        }
      }, {
        key: 'getPlaceholderBoundingBox',
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition,
            t = this.placeholder.getBoundingClientRect(),
            r = s.default.findDOMNode(this.placeholder).style,
            n = {
              left: parseInt(r.getPropertyValue('margin-left'), 10) || 0,
              top: parseInt(r.getPropertyValue('margin-top'), 10) || 0
            };
          return {
            bottom: e.y + t.bottom + n.top,
            left: e.x + t.left + n.left,
            right: e.x + t.right + n.left,
            top: e.y + t.top + n.top
          };
        }
      }, {
        key: 'isPlaceholderInViewport',
        value: function value() {
          if ('undefined' == typeof window || !this.placeholder) return !1;
          var e = this.props,
            t = e.scrollPosition,
            r = e.threshold,
            n = this.getPlaceholderBoundingBox(t),
            o = t.y + window.innerHeight,
            i = t.x,
            s = t.x + window.innerWidth,
            a = t.y;
          return Boolean(a - r <= n.bottom && o + r >= n.top && i - r <= n.right && s + r >= n.left);
        }
      }, {
        key: 'updateVisibility',
        value: function value() {
          this.isPlaceholderInViewport() && this.props.onVisible();
        }
      }, {
        key: 'render',
        value: function value() {
          var e = this,
            t = this.props,
            r = t.className,
            o = t.height,
            s = t.placeholder,
            a = t.style,
            l = t.width;
          if (s && 'function' != typeof s.type) return i.default.cloneElement(s, {
            ref: function ref(t) {
              return e.placeholder = t;
            }
          });
          var u = n({
            display: 'inline-block'
          }, a);
          return void 0 !== l && (u.width = l), void 0 !== o && (u.height = o), i.default.createElement('span', {
            className: r,
            ref: function ref(t) {
              return e.placeholder = t;
            },
            style: u
          }, s);
        }
      }]), t;
    }(i.default.Component);
    c.propTypes = {
      onVisible: a.PropTypes.func.isRequired,
      className: a.PropTypes.string,
      height: a.PropTypes.oneOfType([a.PropTypes.number, a.PropTypes.string]),
      placeholder: a.PropTypes.element,
      threshold: a.PropTypes.number,
      useIntersectionObserver: a.PropTypes.bool,
      scrollPosition: a.PropTypes.shape({
        x: a.PropTypes.number.isRequired,
        y: a.PropTypes.number.isRequired
      }),
      width: a.PropTypes.oneOfType([a.PropTypes.number, a.PropTypes.string])
    }, c.defaultProps = {
      className: '',
      placeholder: null,
      threshold: 100,
      useIntersectionObserver: !0
    }, t.default = c;
  }, function (e, t) {
    e.exports = reactDom;
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      o = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      i = p(r(0)),
      s = p(r(5)),
      a = r(1),
      l = p(r(13)),
      u = p(r(14)),
      c = p(r(2)),
      f = p(r(15));
    function p(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function d(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
    }
    var y = function y() {
        return 'undefined' == typeof window ? 0 : window.scrollX || window.pageXOffset;
      },
      h = function h() {
        return 'undefined' == typeof window ? 0 : window.scrollY || window.pageYOffset;
      };
    t.default = function (e) {
      var t = function (t) {
        function r(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
          }(this, r);
          var t = d(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
          if (t.useIntersectionObserver = e.useIntersectionObserver && (0, c.default)(), t.useIntersectionObserver) return d(t);
          var n = t.onChangeScroll.bind(t);
          return 'debounce' === e.delayMethod ? t.delayedScroll = (0, l.default)(n, e.delayTime) : 'throttle' === e.delayMethod && (t.delayedScroll = (0, u.default)(n, e.delayTime)), t.state = {
            scrollPosition: {
              x: y(),
              y: h()
            }
          }, t.baseComponentRef = i.default.createRef(), t;
        }
        return function (e, t) {
          if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(r, t), o(r, [{
          key: 'componentDidMount',
          value: function value() {
            this.addListeners();
          }
        }, {
          key: 'componentWillUnmount',
          value: function value() {
            this.removeListeners();
          }
        }, {
          key: 'componentDidUpdate',
          value: function value() {
            'undefined' == typeof window || this.useIntersectionObserver || (0, f.default)(s.default.findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
          }
        }, {
          key: 'addListeners',
          value: function value() {
            'undefined' == typeof window || this.useIntersectionObserver || (this.scrollElement = (0, f.default)(s.default.findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener('scroll', this.delayedScroll, {
              passive: !0
            }), window.addEventListener('resize', this.delayedScroll, {
              passive: !0
            }), this.scrollElement !== window && window.addEventListener('scroll', this.delayedScroll, {
              passive: !0
            }));
          }
        }, {
          key: 'removeListeners',
          value: function value() {
            'undefined' == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener('scroll', this.delayedScroll), window.removeEventListener('resize', this.delayedScroll), this.scrollElement !== window && window.removeEventListener('scroll', this.delayedScroll));
          }
        }, {
          key: 'onChangeScroll',
          value: function value() {
            this.useIntersectionObserver || this.setState({
              scrollPosition: {
                x: y(),
                y: h()
              }
            });
          }
        }, {
          key: 'render',
          value: function value() {
            var t = this.props,
              r = (t.delayMethod, t.delayTime, function (e, t) {
                var r = {};
                for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r;
              }(t, ['delayMethod', 'delayTime'])),
              o = this.useIntersectionObserver ? null : this.state.scrollPosition;
            return i.default.createElement(e, n({
              ref: this.baseComponentRef,
              scrollPosition: o
            }, r));
          }
        }]), r;
      }(i.default.Component);
      return t.propTypes = {
        delayMethod: a.PropTypes.oneOf(['debounce', 'throttle']),
        delayTime: a.PropTypes.number,
        useIntersectionObserver: a.PropTypes.bool
      }, t.defaultProps = {
        delayMethod: 'throttle',
        delayTime: 300,
        useIntersectionObserver: !0
      }, t;
    };
  }, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || new Function('return this')();
    } catch (e) {
      'object' == typeof window && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    }), t.trackWindowScroll = t.LazyLoadComponent = t.LazyLoadImage = void 0;
    var n = s(r(9)),
      o = s(r(3)),
      i = s(r(6));
    function s(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    t.LazyLoadImage = n.default, t.LazyLoadComponent = o.default, t.trackWindowScroll = i.default;
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      o = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      i = l(r(0)),
      s = r(1),
      a = l(r(3));
    function l(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var u = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        }(this, t);
        var r = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return r.state = {
          loaded: !1
        }, r;
      }
      return function (e, t) {
        if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, [{
        key: 'onImageLoad',
        value: function value() {
          var e = this;
          return this.state.loaded ? null : function () {
            e.props.afterLoad(), e.setState({
              loaded: !0
            });
          };
        }
      }, {
        key: 'getImg',
        value: function value() {
          var e = this.props,
            t = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, function (e, t) {
              var r = {};
              for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
              return r;
            }(e, ['afterLoad', 'beforeLoad', 'delayMethod', 'delayTime', 'effect', 'placeholder', 'placeholderSrc', 'scrollPosition', 'threshold', 'useIntersectionObserver', 'visibleByDefault', 'wrapperClassName']));
          return i.default.createElement('img', n({
            onLoad: this.onImageLoad()
          }, t));
        }
      }, {
        key: 'getLazyLoadImage',
        value: function value() {
          var e = this.props,
            t = e.beforeLoad,
            r = e.className,
            n = e.delayMethod,
            o = e.delayTime,
            s = e.height,
            l = e.placeholder,
            u = e.scrollPosition,
            c = e.style,
            f = e.threshold,
            p = e.useIntersectionObserver,
            d = e.visibleByDefault,
            y = e.width;
          return i.default.createElement(a.default, {
            beforeLoad: t,
            className: r,
            delayMethod: n,
            delayTime: o,
            height: s,
            placeholder: l,
            scrollPosition: u,
            style: c,
            threshold: f,
            useIntersectionObserver: p,
            visibleByDefault: d,
            width: y
          }, this.getImg());
        }
      }, {
        key: 'getWrappedLazyLoadImage',
        value: function value(e) {
          var t = this.props,
            r = t.effect,
            n = t.height,
            o = t.placeholderSrc,
            s = t.width,
            a = t.wrapperClassName,
            l = this.state.loaded,
            u = l ? ' lazy-load-image-loaded' : '';
          return i.default.createElement('span', {
            className: a + ' lazy-load-image-background ' + r + u,
            style: {
              backgroundImage: l || !o ? '' : 'url(' + o + ')',
              backgroundSize: l || !o ? '' : '100% 100%',
              color: 'transparent',
              display: 'inline-block',
              height: n,
              width: s
            }
          }, e);
        }
      }, {
        key: 'render',
        value: function value() {
          var e = this.props,
            t = e.effect,
            r = e.placeholderSrc,
            n = e.visibleByDefault,
            o = this.getLazyLoadImage();
          return !t && !r || n ? o : this.getWrappedLazyLoadImage(o);
        }
      }]), t;
    }(i.default.Component);
    u.propTypes = {
      afterLoad: s.PropTypes.func,
      beforeLoad: s.PropTypes.func,
      delayMethod: s.PropTypes.string,
      delayTime: s.PropTypes.number,
      effect: s.PropTypes.string,
      placeholderSrc: s.PropTypes.string,
      threshold: s.PropTypes.number,
      useIntersectionObserver: s.PropTypes.bool,
      visibleByDefault: s.PropTypes.bool,
      wrapperClassName: s.PropTypes.string
    }, u.defaultProps = {
      afterLoad: function afterLoad() {
        return {};
      },
      beforeLoad: function beforeLoad() {
        return {};
      },
      delayMethod: 'throttle',
      delayTime: 300,
      effect: '',
      placeholderSrc: null,
      threshold: 100,
      useIntersectionObserver: !0,
      visibleByDefault: !1,
      wrapperClassName: ''
    }, t.default = u;
  }, function (e, t, r) {
    var n = r(11);
    function o() {}
    function i() {}
    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, r, o, i, s) {
        if (s !== n) {
          var a = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types');
          throw a.name = 'Invariant Violation', a;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    e.exports = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, 'value' in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }(),
      o = a(r(0)),
      i = a(r(4)),
      s = a(r(6));
    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var l = function (e) {
      function t(e) {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
        }(this, t), function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || 'object' != typeof t && 'function' != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      }
      return function (e, t) {
        if ('function' != typeof t && null !== t) throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), n(t, [{
        key: 'render',
        value: function value() {
          return o.default.createElement(i.default, this.props);
        }
      }]), t;
    }(o.default.Component);
    t.default = (0, s.default)(l);
  }, function (e, t, r) {
    (function (t) {
      var r = 'Expected a function',
        n = NaN,
        o = '[object Symbol]',
        i = /^\s+|\s+$/g,
        s = /^[-+]0x[0-9a-f]+$/i,
        a = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        u = parseInt,
        c = 'object' == typeof t && t && t.Object === Object && t,
        f = 'object' == typeof self && self && self.Object === Object && self,
        p = c || f || Function('return this')(),
        d = Object.prototype.toString,
        y = Math.max,
        h = Math.min,
        b = function b() {
          return p.Date.now();
        };
      function v(e) {
        var t = typeof e;
        return !!e && ('object' == t || 'function' == t);
      }
      function m(e) {
        if ('number' == typeof e) return e;
        if (function (e) {
          return 'symbol' == typeof e || function (e) {
            return !!e && 'object' == typeof e;
          }(e) && d.call(e) == o;
        }(e)) return n;
        if (v(e)) {
          var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
          e = v(t) ? t + '' : t;
        }
        if ('string' != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, '');
        var r = a.test(e);
        return r || l.test(e) ? u(e.slice(2), r ? 2 : 8) : s.test(e) ? n : +e;
      }
      e.exports = function (e, t, n) {
        var o,
          i,
          s,
          a,
          l,
          u,
          c = 0,
          f = !1,
          p = !1,
          d = !0;
        if ('function' != typeof e) throw new TypeError(r);
        function O(t) {
          var r = o,
            n = i;
          return o = i = void 0, c = t, a = e.apply(n, r);
        }
        function w(e) {
          var r = e - u;
          return void 0 === u || r >= t || r < 0 || p && e - c >= s;
        }
        function g() {
          var e = b();
          if (w(e)) return _(e);
          l = setTimeout(g, function (e) {
            var r = t - (e - u);
            return p ? h(r, s - (e - c)) : r;
          }(e));
        }
        function _(e) {
          return l = void 0, d && o ? O(e) : (o = i = void 0, a);
        }
        function P() {
          var e = b(),
            r = w(e);
          if (o = arguments, i = this, u = e, r) {
            if (void 0 === l) return function (e) {
              return c = e, l = setTimeout(g, t), f ? O(e) : a;
            }(u);
            if (p) return l = setTimeout(g, t), O(u);
          }
          return void 0 === l && (l = setTimeout(g, t)), a;
        }
        return t = m(t) || 0, v(n) && (f = !!n.leading, s = (p = 'maxWait' in n) ? y(m(n.maxWait) || 0, t) : s, d = 'trailing' in n ? !!n.trailing : d), P.cancel = function () {
          void 0 !== l && clearTimeout(l), c = 0, o = u = i = l = void 0;
        }, P.flush = function () {
          return void 0 === l ? a : _(b());
        }, P;
      };
    }).call(this, r(7));
  }, function (e, t, r) {
    (function (t) {
      var r = 'Expected a function',
        n = NaN,
        o = '[object Symbol]',
        i = /^\s+|\s+$/g,
        s = /^[-+]0x[0-9a-f]+$/i,
        a = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        u = parseInt,
        c = 'object' == typeof t && t && t.Object === Object && t,
        f = 'object' == typeof self && self && self.Object === Object && self,
        p = c || f || Function('return this')(),
        d = Object.prototype.toString,
        y = Math.max,
        h = Math.min,
        b = function b() {
          return p.Date.now();
        };
      function v(e, t, n) {
        var o,
          i,
          s,
          a,
          l,
          u,
          c = 0,
          f = !1,
          p = !1,
          d = !0;
        if ('function' != typeof e) throw new TypeError(r);
        function v(t) {
          var r = o,
            n = i;
          return o = i = void 0, c = t, a = e.apply(n, r);
        }
        function w(e) {
          var r = e - u;
          return void 0 === u || r >= t || r < 0 || p && e - c >= s;
        }
        function g() {
          var e = b();
          if (w(e)) return _(e);
          l = setTimeout(g, function (e) {
            var r = t - (e - u);
            return p ? h(r, s - (e - c)) : r;
          }(e));
        }
        function _(e) {
          return l = void 0, d && o ? v(e) : (o = i = void 0, a);
        }
        function P() {
          var e = b(),
            r = w(e);
          if (o = arguments, i = this, u = e, r) {
            if (void 0 === l) return function (e) {
              return c = e, l = setTimeout(g, t), f ? v(e) : a;
            }(u);
            if (p) return l = setTimeout(g, t), v(u);
          }
          return void 0 === l && (l = setTimeout(g, t)), a;
        }
        return t = O(t) || 0, m(n) && (f = !!n.leading, s = (p = 'maxWait' in n) ? y(O(n.maxWait) || 0, t) : s, d = 'trailing' in n ? !!n.trailing : d), P.cancel = function () {
          void 0 !== l && clearTimeout(l), c = 0, o = u = i = l = void 0;
        }, P.flush = function () {
          return void 0 === l ? a : _(b());
        }, P;
      }
      function m(e) {
        var t = typeof e;
        return !!e && ('object' == t || 'function' == t);
      }
      function O(e) {
        if ('number' == typeof e) return e;
        if (function (e) {
          return 'symbol' == typeof e || function (e) {
            return !!e && 'object' == typeof e;
          }(e) && d.call(e) == o;
        }(e)) return n;
        if (m(e)) {
          var t = 'function' == typeof e.valueOf ? e.valueOf() : e;
          e = m(t) ? t + '' : t;
        }
        if ('string' != typeof e) return 0 === e ? e : +e;
        e = e.replace(i, '');
        var r = a.test(e);
        return r || l.test(e) ? u(e.slice(2), r ? 2 : 8) : s.test(e) ? n : +e;
      }
      e.exports = function (e, t, n) {
        var o = !0,
          i = !0;
        if ('function' != typeof e) throw new TypeError(r);
        return m(n) && (o = 'leading' in n ? !!n.leading : o, i = 'trailing' in n ? !!n.trailing : i), v(e, t, {
          leading: o,
          maxWait: t,
          trailing: i
        });
      };
    }).call(this, r(7));
  }, function (e, t, r) {
    Object.defineProperty(t, '__esModule', {
      value: !0
    });
    var n = function n(e, t) {
        return 'undefined' == typeof getComputedStyle ? e.style[t] : getComputedStyle(e, null).getPropertyValue(t);
      },
      o = function o(e) {
        return n(e, 'overflow') + n(e, 'overflow-y') + n(e, 'overflow-x');
      };
    t.default = function (e) {
      if (!(e instanceof HTMLElement)) return window;
      for (var t = e; t && t !== document.body && t !== document.documentElement && t.parentNode;) {
        if (/(scroll|auto)/.test(o(t))) return t;
        t = t.parentNode;
      }
      return window;
    };
  }]);
});
unwrapExports(build);
var build_1 = build.LazyLoadComponent;
var contentCardVisualProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * image to be lazy loaded, and overlay
  */
  children: propTypes.node,
  /**
   * classnames applied to specific elements of
   * the component
   */
  classes: propTypes.shape({
    root: propTypes.string,
    loadingShimmer: propTypes.string
  })
});
var ContentCardVisual = function ContentCardVisual(props) {
  var classesArray = [props.additionalClassName, props.classes.root];
  var classes = classesArray.join(' ');
  var threshold = typeof window !== 'undefined' ? window.innerHeight : 500;
  return jsx("div", {
    className: classes,
    css: /*#__PURE__*/css([{
      position: 'relative'
    }, loadingGradient(), props.__css], ";label:ContentCardVisual;")
  }, jsx(build_1, {
    placeholder: jsx(LoadingShimmer, {
      additionalClassName: [].concat(classesArray, [props.classes.loadingShimmer]).join(' ')
    }),
    threshold: threshold
  }, !props.children && jsx(LoadingShimmer, null), props.children));
};
ContentCardVisual.propTypes = contentCardVisualProps;
ContentCardVisual.defaultProps = {
  classes: {}
};
ContentCardVisual.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentCardVisual",
  "props": {
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "root": {
            "name": "string",
            "required": false
          },
          "loadingShimmer": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "classnames applied to specific elements of\nthe component"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "image to be lazy loaded, and overlay"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = "/* autoprefixer grid: autoplace */\n.gridCss_grid__2F0AA.gridCss_grid__2F0AA {\n  display: -ms-grid;\n  display: grid;\n  width: 100%;\n  height: 100%; }\n\n.gridCss_vertical__1bqsS {\n                          grid-template-areas: \"img\" \"textual\" \"footer\";\n  -ms-grid-rows: 1fr 1fr auto;\n  grid-template-rows: 1fr 1fr auto;\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  border-top-right-radius: inherit;\n  border-top-left-radius: inherit; }\n\n.gridCss_horizontal__37fQL {\n                          grid-template-areas: \"img textual\" \"img textual\" \"img footer\";\n  -ms-grid-rows: 1fr 2rem auto;\n  grid-template-rows: 1fr 2rem auto;\n  -ms-grid-columns: 160px 1fr;\n  grid-template-columns: 160px 1fr;\n  border-top-left-radius: inherit;\n  border-bottom-left-radius: inherit; }\n\n.gridCss_img__3G9fv {\n  -ms-grid-row: 1;\n  -ms-grid-column: 1;\n  grid-area: img; }\n\n.gridCss_horizontal__37fQL > .gridCss_img__3G9fv {\n  -ms-grid-row: 1;\n  -ms-grid-row-span: 3;\n  -ms-grid-column: 1; }\n\n.gridCss_textual__2zlCD {\n  -ms-grid-row: 2;\n  -ms-grid-column: 1;\n  grid-area: textual; }\n\n.gridCss_horizontal__37fQL > .gridCss_textual__2zlCD {\n  -ms-grid-row: 1;\n  -ms-grid-row-span: 2;\n  -ms-grid-column: 2; }\n\n.gridCss_footer__2L55O {\n  -ms-grid-row: 3;\n  -ms-grid-column: 1;\n  grid-area: footer; }\n\n.gridCss_horizontal__37fQL > .gridCss_footer__2L55O {\n  -ms-grid-row: 3;\n  -ms-grid-column: 2; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdyaWRDc3Muc2NzcyIsIjxubyBzb3VyY2U+Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLGlDQUFpQztBQUNqQztFQUNFLGlCQUFhO0VBQWIsYUFBYTtFQUNiLFdBQVc7RUFDWCxZQUFZLEVBQUU7O0FBRWhCOzBCQUNFLDZDQUE2QztFQUM3QywyQkFBZ0M7RUFBaEMsZ0NBQWdDO0VBQ2hDLHFCQUEwQjtFQUExQiwwQkFBMEI7RUFDMUIsZ0NBQWdDO0VBQ2hDLCtCQUErQixFQUFFOztBQUVuQzswQkFDRSw2REFBNkQ7RUFDN0QsNEJBQWlDO0VBQWpDLGlDQUFpQztFQUNqQywyQkFBZ0M7RUFBaEMsZ0NBQWdDO0VBQ2hDLCtCQUErQjtFQUMvQixrQ0FBa0MsRUFBRTs7QUFFdEM7RUNwQkEsZ0JBQUE7RUFBQSxtQkFBQTtFRHFCRSxjQUFjLEVBQUU7O0FBRGxCO0VDcEJBLGdCQUFBO0VBQUEscUJBQUE7RUFBQSxtQkFBQSxDRHFCa0I7O0FBRWxCO0VDdkJBLGdCQUFBO0VBQUEsbUJBQUE7RUR3QkUsa0JBQWtCLEVBQUU7O0FBRHRCO0VDdkJBLGdCQUFBO0VBQUEscUJBQUE7RUFBQSxtQkFBQSxDRHdCc0I7O0FBRXRCO0VDMUJBLGdCQUFBO0VBQUEsbUJBQUE7RUQyQkUsaUJBQWlCLEVBQUU7O0FBRHJCO0VDMUJBLGdCQUFBO0VBQUEsbUJBQUEsQ0QyQnFCIiwiZmlsZSI6ImdyaWRDc3Muc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGF1dG9wcmVmaXhlciBncmlkOiBhdXRvcGxhY2UgKi9cbi5ncmlkLmdyaWQge1xuICBkaXNwbGF5OiBncmlkO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAxMDAlOyB9XG5cbi52ZXJ0aWNhbCB7XG4gIGdyaWQtdGVtcGxhdGUtYXJlYXM6IFwiaW1nXCIgXCJ0ZXh0dWFsXCIgXCJmb290ZXJcIjtcbiAgZ3JpZC10ZW1wbGF0ZS1yb3dzOiAxZnIgMWZyIGF1dG87XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogMWZyO1xuICBib3JkZXItdG9wLXJpZ2h0LXJhZGl1czogaW5oZXJpdDtcbiAgYm9yZGVyLXRvcC1sZWZ0LXJhZGl1czogaW5oZXJpdDsgfVxuXG4uaG9yaXpvbnRhbCB7XG4gIGdyaWQtdGVtcGxhdGUtYXJlYXM6IFwiaW1nIHRleHR1YWxcIiBcImltZyB0ZXh0dWFsXCIgXCJpbWcgZm9vdGVyXCI7XG4gIGdyaWQtdGVtcGxhdGUtcm93czogMWZyIDJyZW0gYXV0bztcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAxNjBweCAxZnI7XG4gIGJvcmRlci10b3AtbGVmdC1yYWRpdXM6IGluaGVyaXQ7XG4gIGJvcmRlci1ib3R0b20tbGVmdC1yYWRpdXM6IGluaGVyaXQ7IH1cblxuLmltZyB7XG4gIGdyaWQtYXJlYTogaW1nOyB9XG5cbi50ZXh0dWFsIHtcbiAgZ3JpZC1hcmVhOiB0ZXh0dWFsOyB9XG5cbi5mb290ZXIge1xuICBncmlkLWFyZWE6IGZvb3RlcjsgfVxuIixudWxsXX0= */";
var cssStyles = {
  "grid": "gridCss_grid__2F0AA",
  "vertical": "gridCss_vertical__1bqsS",
  "horizontal": "gridCss_horizontal__37fQL",
  "img": "gridCss_img__3G9fv",
  "textual": "gridCss_textual__2zlCD",
  "footer": "gridCss_footer__2L55O"
};
styleInject(css_248z);
var contentCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * what type of content is displayed on the card.
   * see ContentCardTextual for more information
   */
  contentType: propTypes.string,
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3(_objectSpread3({}, imgProps), {}, {
    ariaProps: propTypes.object
  })),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
   * This is an array of metaData string to be rendered.
   * The string should be a numeric value and then a word
   * for more details see the CardMetaData component
   */
  metaData: propTypes.arrayOf(propTypes.string),
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * Override the ContentType row
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
   )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var ContentCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  ContentCard.displayName = 'ContentCard';
  var _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    _props$anchorAriaProp = props.anchorAriaProps,
    anchorAriaProps = _props$anchorAriaProp === void 0 ? {} : _props$anchorAriaProp;
  var gridClasses = [cssStyles.grid, !props.isVertical ? cssStyles.horizontal : cssStyles.vertical].join(' ');
  var defaultAriaLabel = "".concat(props.contentType, " - ").concat(props.title);
  if (!anchorAriaProps['aria-label']) {
    anchorAriaProps['aria-label'] = defaultAriaLabel;
  } // filter out all the undefined classnames before joining them.

  var cardClasses = [classes.root, props.additionalClassName].filter(function (className) {
    return className;
  }).join(' ');
  /**
   * If there is an imageOverlay passed down, lets
   * render that in our div to handle positioning.
   * If they want to override it give them all the tools
   * they need to recreate it, including the imageOverlay
   * passed in
   */

  var overlay = null;
  if (props.__renderImageOverlay) {
    overlay = props.__renderImageOverlay({
      css: imageOverlayContainer(props.isVertical),
      className: get(props, 'classes.visual.overlay'),
      children: props.imageOverlay
    });
  } else if (props.imageOverlay) {
    overlay = jsx("div", {
      className: get(props, 'classes.visual.overlay'),
      css: imageOverlayContainer(props.isVertical)
    }, props.imageOverlay);
  }
  var textual = props.__renderTextual ? props.__renderTextual({
    className: cssStyles.textual
  }) : jsx(ContentCardTextual, {
    additionalClassName: cssStyles.textual,
    classes: classes.textual,
    contentType: props.contentType,
    isVertical: props.isVertical,
    metaData: props.metaData,
    title: props.title,
    titleLineNum: props.titleLineNum,
    __renderMetaData: props.__renderMetaData,
    __renderContentType: props.__renderContentType
  });
  return jsx(Card, {
    additionalClassName: cardClasses,
    anchorAriaProps: anchorAriaProps,
    ariaProps: props.ariaProps,
    dataProps: props.dataProps,
    href: props.href,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    ref: ref,
    __css: [cardHoverTitle, focusStyleTitle, cardDimensions(props.isVertical), props.__css],
    __renderCustomLink: props.__renderCustomLink,
    __renderCustomWrapper: props.__renderCustomWrapper ? props.__renderCustomWrapper : function (cardProps, kids) {
      return jsx("article", cardProps, kids);
    }
  }, jsx("div", {
    className: gridClasses
  }, props.__renderImage ? props.__renderImage({
    className: cssStyles.Img
  }, jsx(LoadingShimmer, null)) : jsx(ContentCardVisual, {
    additionalClassName: cssStyles.img,
    classes: {
      root: get(props, 'classes.visual.root'),
      loadingShimmer: get(props, 'classes.visual.loadingShimmer')
    }
  }, props.img && props.img.src && jsx(BackgroundImg, _extends({
    additionalClassName: get(props, 'classes.visual.img')
  }, props.img, {
    ariaProps: _objectSpread3({
      'aria-label': props.img.alt ? props.img.alt : "image for ".concat(defaultAriaLabel)
    }, get(props.img, 'ariaProps', {}))
  })), overlay && overlay), textual, jsx("div", {
    className: [cssStyles.footer, classes.footer].join(' '),
    css: footerMargins(props.isVertical)
  }, props.footer)));
});
ContentCard.defaultProps = {
  isVertical: true
};
ContentCard.propTypes = contentCardProps;
ContentCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ContentCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "contentType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "what type of content is displayed on the card.\nsee ContentCardTextual for more information"
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {
          "ariaProps": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "metaData": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "This is an array of metaData string to be rendered.\nThe string should be a numeric value and then a word\nfor more details see the CardMetaData component"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Override the ContentType row"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n   )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var moment = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    var hookCallback;
    function hooks() {
      return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
      hookCallback = callback;
    }
    function isArray(input) {
      return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (hasOwnProp(obj, k)) {
            return false;
          }
        }
        return true;
      }
    }
    function isUndefined(input) {
      return input === void 0;
    }
    function isNumber(input) {
      return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
      return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
      var res = [],
        i;
      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }
    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }
      if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
      }
      if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
      }
      return a;
    }
    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidEra: null,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        era: null,
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }
    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }
    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function some(fun) {
        var t = Object(this),
          len = t.length >>> 0,
          i;
        for (i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }
        return false;
      };
    }
    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m),
          parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
          }),
          isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
        if (m._strict) {
          isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }
    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }
      return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [],
      updateInProgress = false;
    function copyConfig(to, from) {
      var i, prop, val;
      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }
      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }
      return to;
    }

    // Moment prototype object
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      // Prevent infinite loop in case updateOffset creates new moment
      // objects.
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }
    function isMoment(obj) {
      return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
      if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
        console.warn('Deprecation warning: ' + msg);
      }
    }
    function deprecate(msg, fn) {
      var firstTime = true;
      return extend(function () {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [],
            arg,
            i,
            key;
          for (i = 0; i < arguments.length; i++) {
            arg = '';
            if (typeof arguments[i] === 'object') {
              arg += '\n[' + i + '] ';
              for (key in arguments[0]) {
                if (hasOwnProp(arguments[0], key)) {
                  arg += key + ': ' + arguments[0][key] + ', ';
                }
              }
              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
      return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
      var prop, i;
      for (i in config) {
        if (hasOwnProp(config, i)) {
          prop = config[i];
          if (isFunction(prop)) {
            this[i] = prop;
          } else {
            this['_' + i] = prop;
          }
        }
      }
      this._config = config;
      // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.
      this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }
    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }
    var keys;
    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function keys(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }
    var defaultCalendar = {
      sameDay: '[Today at] LT',
      nextDay: '[Tomorrow at] LT',
      nextWeek: 'dddd [at] LT',
      lastDay: '[Yesterday at] LT',
      lastWeek: '[Last] dddd [at] LT',
      sameElse: 'L'
    };
    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar['sameElse'];
      return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
      var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
      localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
      formatFunctions = {},
      formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === 'string') {
        func = function func() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function () {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }
    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
      }
      return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;
      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }
      return function (mom) {
        var output = '',
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
      };
    }

    // format date using native date object
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }
      format = expandFormat(format, m.localeData());
      formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
      return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
      var i = 5;
      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }
      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }
      return format;
    }
    var defaultLongDateFormat = {
      LTS: 'h:mm:ss A',
      LT: 'h:mm A',
      L: 'MM/DD/YYYY',
      LL: 'MMMM D, YYYY',
      LLL: 'MMMM D, YYYY h:mm A',
      LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];
      if (format || !formatUpper) {
        return format;
      }
      this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
        if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
          return tok.slice(1);
        }
        return tok;
      }).join('');
      return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
      return this._invalidDate;
    }
    var defaultOrdinal = '%d',
      defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
      return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
      future: 'in %s',
      past: '%s ago',
      s: 'a few seconds',
      ss: '%d seconds',
      m: 'a minute',
      mm: '%d minutes',
      h: 'an hour',
      hh: '%d hours',
      d: 'a day',
      dd: '%d days',
      w: 'a week',
      ww: '%d weeks',
      M: 'a month',
      MM: '%d months',
      y: 'a year',
      yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
      return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
      return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;
      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }
      return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
      var units = [],
        u;
      for (u in unitsObj) {
        if (hasOwnProp(unitsObj, u)) {
          units.push({
            unit: u,
            priority: priorities[u]
          });
        }
      }
      units.sort(function (a, b) {
        return a.priority - b.priority;
      });
      return units;
    }
    function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }
    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;
      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }
      return value;
    }
    function makeGetSet(unit, keepTime) {
      return function (value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }
    function get(mom, unit) {
      return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
          value = toInt(value);
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        } else {
          mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
      }
    }

    // MOMENTS

    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }
    function stringSet(units, value) {
      if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units),
          i;
        for (i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }
    var match1 = /\d/,
      //       0 - 9
      match2 = /\d\d/,
      //      00 - 99
      match3 = /\d{3}/,
      //     000 - 999
      match4 = /\d{4}/,
      //    0000 - 9999
      match6 = /[+-]?\d{6}/,
      // -999999 - 999999
      match1to2 = /\d\d?/,
      //       0 - 99
      match3to4 = /\d\d\d\d?/,
      //     999 - 9999
      match5to6 = /\d\d\d\d\d\d?/,
      //   99999 - 999999
      match1to3 = /\d{1,3}/,
      //       0 - 999
      match1to4 = /\d{1,4}/,
      //       0 - 9999
      match1to6 = /[+-]?\d{1,6}/,
      // -999999 - 999999
      matchUnsigned = /\d+/,
      //       0 - inf
      matchSigned = /[+-]?\d+/,
      //    -inf - inf
      matchOffset = /Z|[+-]\d\d:?\d\d/gi,
      // +00:00 -00:00 +0000 -0000 or Z
      matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
      // +00 -00 +00:00 -00:00 +0000 -0000 or Z
      matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
      // 123456789 123456789.123
      // any word (or two) characters or numbers including two/three word month in arabic.
      // includes scottish gaelic two word and hyphenated months
      matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
      regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return isStrict && strictRegex ? strictRegex : regex;
      };
    }
    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }
      return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
      return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
      }));
    }
    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    var tokens = {};
    function addParseToken(token, callback) {
      var i,
        func = callback;
      if (typeof token === 'string') {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function func(input, array) {
          array[callback] = toInt(input);
        };
      }
      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
      }
    }
    function addWeekParseToken(token, callback) {
      addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }
    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }
    var YEAR = 0,
      MONTH = 1,
      DATE = 2,
      HOUR = 3,
      MINUTE = 4,
      SECOND = 5,
      MILLISECOND = 6,
      WEEK = 7,
      WEEKDAY = 8;
    function mod(n, x) {
      return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function indexOf(o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }
    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
      return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function (format) {
      return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function (format) {
      return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });
    addParseToken(['M', 'MM'], function (input, array) {
      array[MONTH] = toInt(input) - 1;
    });
    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      // if we didn't find a month name, mark the date as invalid.
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
      defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
      MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
      defaultMonthsShortRegex = matchWord,
      defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months) ? this._months : this._months['standalone'];
      }
      return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
      }
      return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'MMM') {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;
      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }
      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }

      // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
          this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
          regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
          this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
          return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function setMonth(mom, value) {
      var dayOfMonth;
      if (!mom.isValid()) {
        // No op
        return mom;
      }
      if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          // TODO: Another silent failure?
          if (!isNumber(value)) {
            return mom;
          }
        }
      }
      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
      return mom;
    }
    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, 'Month');
      }
    }
    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
      }
    }
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
      }
    }
    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
      }
      // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }
      this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
      var y = this.year();
      return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, ['YY', 2], 0, function () {
      return this.year() % 100;
    });
    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
      array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
      array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
      return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date;
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        date = new Date(y + 400, m, d, h, M, s, ms);
        if (isFinite(date.getFullYear())) {
          date.setFullYear(y);
        }
      } else {
        date = new Date(y, m, d, h, M, s, ms);
      }
      return date;
    }
    function createUTCDate(y) {
      var date, args;
      // the Date.UTC function remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        args = Array.prototype.slice.call(arguments);
        // preserve leap years using a full 400 year cycle, then reset
        args[0] = y + 400;
        date = new Date(Date.UTC.apply(null, args));
        if (isFinite(date.getUTCFullYear())) {
          date.setUTCFullYear(y);
        }
      } else {
        date = new Date(Date.UTC.apply(null, arguments));
      }
      return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
      var
        // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
      return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;
      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }
      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }
    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;
      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }
      return {
        week: resWeek,
        year: resYear
      };
    }
    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
      week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }
    function localeFirstDayOfYear() {
      return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function (format) {
      return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function (format) {
      return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function (format) {
      return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      // if we didn't get a weekday name, mark the date as invalid
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });
    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
      week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== 'string') {
        return input;
      }
      if (!isNaN(input)) {
        return parseInt(input, 10);
      }
      input = locale.weekdaysParse(input);
      if (typeof input === 'number') {
        return input;
      }
      return null;
    }
    function parseIsoWeekday(input, locale) {
      if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
      return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
      defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
      defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
      defaultWeekdaysRegex = matchWord,
      defaultWeekdaysShortRegex = matchWord,
      defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
      var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
      return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
      return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
      return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];
        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
      }
      if (strict) {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === 'dddd') {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;
      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }
      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
          this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
          this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
          regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
          this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
      } else {
        return day;
      }
    }
    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.

      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
      }
    }
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
      }
    }
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
      }
    }
    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }
      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = regexEscape(this.weekdaysMin(mom, ''));
        shortp = regexEscape(this.weekdaysShort(mom, ''));
        longp = regexEscape(this.weekdays(mom, ''));
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;
      this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
      this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
      this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
      return this.hours() % 12 || 12;
    }
    function kFormat() {
      return this.hours() || 24;
    }
    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);
    addFormatToken('hmm', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function () {
      return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function () {
      return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
      });
    }
    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
      var pos1 = input.length - 4,
        pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
      // Setting the hour should keep the time, because the user explicitly
      // specified which hour they want. So trying to maintain the same hour (in
      // a new timezone) makes sense. Adding/subtracting hours does not follow
      // this rule.
      getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? 'pm' : 'PM';
      } else {
        return isLower ? 'am' : 'AM';
      }
    }
    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,
      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,
      week: defaultLocaleWeek,
      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,
      meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {},
      localeFamilies = {},
      globalLocale;
    function commonPrefix(arr1, arr2) {
      var i,
        minl = Math.min(arr1.length, arr2.length);
      for (i = 0; i < minl; i += 1) {
        if (arr1[i] !== arr2[i]) {
          return i;
        }
      }
      return minl;
    }
    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;
      while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join('-'));
          if (locale) {
            return locale;
          }
          if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
            //the next array item is better than a shallower substring of this one
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }
    function loadLocale(name) {
      var oldLocale = null,
        aliasedRequire;
      // TODO: Find a better way to register and load all the locales in Node
      if (locales[name] === undefined && 'object' !== 'undefined' && module && module.exports) {
        try {
          oldLocale = globalLocale._abbr;
          aliasedRequire = commonjsRequire;
          aliasedRequire('./locale/' + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {
          // mark as not found to avoid repeating expensive file require call causing high CPU
          // when trying to find en-US, en_US, en-us for every format call
          locales[name] = null; // null means not found
        }
      }

      return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }
        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== 'undefined' && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
          }
        }
      }
      return globalLocale._abbr;
    }
    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));
        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function (x) {
            defineLocale(x.name, x.config);
          });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);
        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }
    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        if (locales[name] != null && locales[name].parentLocale != null) {
          // Update existing child locale in-place to avoid memory-leaks
          locales[name].set(mergeConfigs(locales[name]._config, config));
        } else {
          // MERGE
          tmpLocale = loadLocale(name);
          if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
          }
          config = mergeConfigs(parentConfig, config);
          if (tmpLocale == null) {
            // updateLocale is called for creating a new locale
            // Set abbr so it will have a name (getters return
            // undefined otherwise).
            config.abbr = name;
          }
          locale = new Locale(config);
          locale.parentLocale = locales[name];
          locales[name] = locale;
        }

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
            if (name === getSetGlobalLocale()) {
              getSetGlobalLocale(name);
            }
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }

    // returns locale data
    function getLocale(key) {
      var locale;
      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }
      if (!key) {
        return globalLocale;
      }
      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }
      return chooseLocale(key);
    }
    function listLocales() {
      return keys(locales);
    }
    function checkOverflow(m) {
      var overflow,
        a = m._a;
      if (a && getParsingFlags(m).overflow === -2) {
        overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }
        getParsingFlags(m).overflow = overflow;
      }
      return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
      tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
      isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
      // iso time formats and regexes
      isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
      aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
      // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
      rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
      obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
      };

    // date from iso format
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;
      if (match) {
        getParsingFlags(config).iso = true;
        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || ' ') + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = 'Z';
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
      var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }
      return result;
    }
    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }
    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10),
          m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i)),
        parsedArray;
      if (match) {
        parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }
        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);
        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);
      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }
      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }
      if (config._strict) {
        config._isValid = false;
      } else {
        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
      }
    }
    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged and will be removed in an upcoming major release. Please refer to ' + 'http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
      config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }
    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;
      if (config._d) {
        return;
      }
      currentDate = currentDateArray(config);

      //compute day of the year from weeks and weekdays
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }

      //if the day of the year is set, figure out what it is
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }
        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }

      // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }

      // Zero out whatever was not defaulted, including time
      for (; i < 7; i++) {
        config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
      }

      // Check for 24:00:00.000
      if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }
      config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
      expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

      // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }
      if (config._nextDay) {
        config._a[HOUR] = 24;
      }

      // check for mismatching day of week
      if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }
    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;
        curWeek = weekOfYear(createLocal(), dow, doy);
        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);
        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from beginning of week
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to beginning of week
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;

      // This array is used to make a Date, either with `new Date` or `Date.UTC`
      var string = '' + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0,
        era;
      tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
          totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }

      // add remaining unparsed input length to the string
      getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }

      // clear _12h flag if hour is <= 12
      if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
      }
      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      // handle meridiem
      config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

      // handle era
      era = getParsingFlags(config).era;
      if (era !== null) {
        config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
      }
      configFromArray(config);
      checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;
      if (meridiem == null) {
        // nothing to do
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
      var tempConfig,
        bestMoment,
        scoreToBeat,
        i,
        currentScore,
        validFormatFound,
        bestFormatIsValid = false;
      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }
      for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        validFormatFound = false;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);
        if (isValid(tempConfig)) {
          validFormatFound = true;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
        getParsingFlags(tempConfig).score = currentScore;
        if (!bestFormatIsValid) {
          if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
            if (validFormatFound) {
              bestFormatIsValid = true;
            }
          }
        } else {
          if (currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
          }
        }
      }
      extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
      if (config._d) {
        return;
      }
      var i = normalizeObjectUnits(config._i),
        dayOrDate = i.day === undefined ? i.date : i.day;
      config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
      });
      configFromArray(config);
    }
    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
      }
      return res;
    }
    function prepareConfig(config) {
      var input = config._i,
        format = config._f;
      config._locale = config._locale || getLocale(config._l);
      if (input === null || format === undefined && input === '') {
        return createInvalid({
          nullInput: true
        });
      }
      if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
      }
      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }
      if (!isValid(config)) {
        config._d = null;
      }
      return config;
    }
    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === 'string') {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};
      if (format === true || format === false) {
        strict = format;
        format = undefined;
      }
      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }
      if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
        input = undefined;
      }
      // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;
      return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }),
      prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }

    // TODO: Use [].sort instead?
    function min() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isBefore', args);
    }
    function max() {
      var args = [].slice.call(arguments, 0);
      return pickBy('isAfter', args);
    }
    var now = function now() {
      return Date.now ? Date.now() : +new Date();
    };
    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
    function isDurationValid(m) {
      var key,
        unitHasDecimal = false,
        i;
      for (key in m) {
        if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
          return false;
        }
      }
      for (i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }

          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }
      return true;
    }
    function isValid$1() {
      return this._isValid;
    }
    function createInvalid$1() {
      return createDuration(NaN);
    }
    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;
      this._isValid = isDurationValid(normalizedInput);

      // representation for dateAddRemove
      this._milliseconds = +milliseconds + seconds * 1e3 +
      // 1000
      minutes * 6e4 +
      // 1000 * 60
      hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately
      this._days = +days + weeks * 7;
      // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.
      this._months = +months + quarters * 3 + years * 12;
      this._data = {};
      this._locale = getLocale();
      this._bubble();
    }
    function isDuration(obj) {
      return obj instanceof Duration;
    }
    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
      addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset(),
          sign = '+';
        if (offset < 0) {
          offset = -offset;
          sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
      });
    }
    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
      var matches = (string || '').match(matcher),
        chunk,
        parts,
        minutes;
      if (matches === null) {
        return null;
      }
      chunk = matches[matches.length - 1] || [];
      parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
      minutes = +(parts[1] * 60) + toInt(parts[2]);
      return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }
    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === 'string') {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, 'm');
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, 'm'), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }
    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== 'string') {
          input = -input;
        }
        this.utcOffset(input, keepLocalTime);
        return this;
      } else {
        return -this.utcOffset();
      }
    }
    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;
        if (keepLocalTime) {
          this.subtract(getDateOffset(this), 'm');
        }
      }
      return this;
    }
    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }
    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;
      return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
      return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }
      var c = {},
        other;
      copyConfig(c, this);
      c = prepareConfig(c);
      if (c._a) {
        other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }
      return this._isDSTShifted;
    }
    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
      // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
      // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
      // and further modified to allow for strings containing both week and day
      isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
      var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;
      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input) || !isNaN(+input)) {
        duration = {};
        if (key) {
          duration[key] = +input;
        } else {
          duration.milliseconds = +input;
        }
      } else if (match = aspNetRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
      } else if (match = isoRegex.exec(input)) {
        sign = match[1] === '-' ? -1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }
      ret = new Duration(duration);
      if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
      }
      if (isDuration(input) && hasOwnProp(input, '_isValid')) {
        ret._isValid = input._isValid;
      }
      return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(',', '.'));
      // apply sign while we're at it
      return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
      var res = {};
      res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
      if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
      }
      res.milliseconds = +other - +base.clone().add(res.months, 'M');
      return res;
    }
    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return {
          milliseconds: 0,
          months: 0
        };
      }
      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }
      return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
      return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
          tmp = val;
          val = period;
          period = tmp;
        }
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);
      if (!mom.isValid()) {
        // No op
        return;
      }
      updateOffset = updateOffset == null ? true : updateOffset;
      if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
      }
      if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }
    var add = createAdder(1, 'add'),
      subtract = createAdder(-1, 'subtract');
    function isString(input) {
      return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
      return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
      var arrayTest = isArray(input),
        dataTypeTest = false;
      if (arrayTest) {
        dataTypeTest = input.filter(function (item) {
          return !isNumber(item) && isString(input);
        }).length === 0;
      }
      return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
      var objectTest = isObject(input) && !isObjectEmpty(input),
        propertyTest = false,
        properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
        i,
        property;
      for (i = 0; i < properties.length; i += 1) {
        property = properties[i];
        propertyTest = propertyTest || hasOwnProp(input, property);
      }
      return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, 'days', true);
      return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
      // Support for single parameter, formats only overload to the calendar function
      if (arguments.length === 1) {
        if (isMomentInput(arguments[0])) {
          time = arguments[0];
          formats = undefined;
        } else if (isCalendarSpec(arguments[0])) {
          formats = arguments[0];
          time = undefined;
        }
      }
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse',
        output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
      return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
      return new Moment(this);
    }
    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
      } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
      }
    }
    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
      } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
      }
    }
    function isBetween(from, to, units, inclusivity) {
      var localFrom = isMoment(from) ? from : createLocal(from),
        localTo = isMoment(to) ? to : createLocal(to);
      if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
        return false;
      }
      inclusivity = inclusivity || '()';
      return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units) || 'millisecond';
      if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
      }
    }
    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
      var that, zoneDelta, output;
      if (!this.isValid()) {
        return NaN;
      }
      that = cloneWithOffset(input, this);
      if (!that.isValid()) {
        return NaN;
      }
      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
      units = normalizeUnits(units);
      switch (units) {
        case 'year':
          output = monthDiff(this, that) / 12;
          break;
        case 'month':
          output = monthDiff(this, that);
          break;
        case 'quarter':
          output = monthDiff(this, that) / 3;
          break;
        case 'second':
          output = (this - that) / 1e3;
          break;
        // 1000
        case 'minute':
          output = (this - that) / 6e4;
          break;
        // 1000 * 60
        case 'hour':
          output = (this - that) / 36e5;
          break;
        // 1000 * 60 * 60
        case 'day':
          output = (this - that - zoneDelta) / 864e5;
          break;
        // 1000 * 60 * 60 * 24, negate dst
        case 'week':
          output = (this - that - zoneDelta) / 6048e5;
          break;
        // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
          output = this - that;
      }
      return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
      if (a.date() < b.date()) {
        // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
      }
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2,
        adjust;
      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
      }

      //check for negative zero, return zero if negative zero
      return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
      return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true,
        m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
      }
      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
      }
      return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
      if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
      }
      var func = 'moment',
        zone = '',
        prefix,
        year,
        datetime,
        suffix;
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
      }
      prefix = '[' + func + '("]';
      year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
      datetime = '-MM-DD[T]HH:mm:ss.SSS';
      suffix = zone + '[")]';
      return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          to: this,
          from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
      if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
        return createDuration({
          from: this,
          to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }
    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
      var newLocaleData;
      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
      if (key === undefined) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    });
    function localeData() {
      return this._locale;
    }
    var MS_PER_SECOND = 1000,
      MS_PER_MINUTE = 60 * MS_PER_SECOND,
      MS_PER_HOUR = 60 * MS_PER_MINUTE,
      MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
      return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return new Date(y, m, d).valueOf();
      }
    }
    function utcStartOfDate(y, m, d) {
      // Date.UTC remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0) {
        // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
      } else {
        return Date.UTC(y, m, d);
      }
    }
    function startOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year(), 0, 1);
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
          break;
        case 'month':
          time = startOfDate(this.year(), this.month(), 1);
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date());
          break;
        case 'hour':
          time = this._d.valueOf();
          time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
          break;
        case 'minute':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_MINUTE);
          break;
        case 'second':
          time = this._d.valueOf();
          time -= mod$1(time, MS_PER_SECOND);
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function endOf(units) {
      var time, startOfDate;
      units = normalizeUnits(units);
      if (units === undefined || units === 'millisecond' || !this.isValid()) {
        return this;
      }
      startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
      switch (units) {
        case 'year':
          time = startOfDate(this.year() + 1, 0, 1) - 1;
          break;
        case 'quarter':
          time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
          break;
        case 'month':
          time = startOfDate(this.year(), this.month() + 1, 1) - 1;
          break;
        case 'week':
          time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
          break;
        case 'isoWeek':
          time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
          break;
        case 'day':
        case 'date':
          time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
          break;
        case 'hour':
          time = this._d.valueOf();
          time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
          break;
        case 'minute':
          time = this._d.valueOf();
          time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
          break;
        case 'second':
          time = this._d.valueOf();
          time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
          break;
      }
      this._d.setTime(time);
      hooks.updateOffset(this, true);
      return this;
    }
    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
      return new Date(this.valueOf());
    }
    function toArray() {
      var m = this;
      return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }
    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }
    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
      return isValid(this);
    }
    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
      return getParsingFlags(this).overflow;
    }
    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
      var era = config._locale.erasParse(input, token, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
      var match;
      if (config._locale._eraYearOrdinalRegex) {
        match = input.match(config._locale._eraYearOrdinalRegex);
      }
      if (config._locale.eraYearOrdinalParse) {
        array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
      } else {
        array[YEAR] = parseInt(input, 10);
      }
    });
    function localeEras(m, format) {
      var i,
        l,
        date,
        eras = this._eras || getLocale('en')._eras;
      for (i = 0, l = eras.length; i < l; ++i) {
        switch (typeof eras[i].since) {
          case 'string':
            // truncate time
            date = hooks(eras[i].since).startOf('day');
            eras[i].since = date.valueOf();
            break;
        }
        switch (typeof eras[i].until) {
          case 'undefined':
            eras[i].until = +Infinity;
            break;
          case 'string':
            // truncate time
            date = hooks(eras[i].until).startOf('day').valueOf();
            eras[i].until = date.valueOf();
            break;
        }
      }
      return eras;
    }
    function localeErasParse(eraName, format, strict) {
      var i,
        l,
        eras = this.eras(),
        name,
        abbr,
        narrow;
      eraName = eraName.toUpperCase();
      for (i = 0, l = eras.length; i < l; ++i) {
        name = eras[i].name.toUpperCase();
        abbr = eras[i].abbr.toUpperCase();
        narrow = eras[i].narrow.toUpperCase();
        if (strict) {
          switch (format) {
            case 'N':
            case 'NN':
            case 'NNN':
              if (abbr === eraName) {
                return eras[i];
              }
              break;
            case 'NNNN':
              if (name === eraName) {
                return eras[i];
              }
              break;
            case 'NNNNN':
              if (narrow === eraName) {
                return eras[i];
              }
              break;
          }
        } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
          return eras[i];
        }
      }
    }
    function localeErasConvertYear(era, year) {
      var dir = era.since <= era.until ? +1 : -1;
      if (year === undefined) {
        return hooks(era.since).year();
      } else {
        return hooks(era.since).year() + (year - era.offset) * dir;
      }
    }
    function getEraName() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].name;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].name;
        }
      }
      return '';
    }
    function getEraNarrow() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].narrow;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].narrow;
        }
      }
      return '';
    }
    function getEraAbbr() {
      var i,
        l,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        // truncate time
        val = this.startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until) {
          return eras[i].abbr;
        }
        if (eras[i].until <= val && val <= eras[i].since) {
          return eras[i].abbr;
        }
      }
      return '';
    }
    function getEraYear() {
      var i,
        l,
        dir,
        val,
        eras = this.localeData().eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        dir = eras[i].since <= eras[i].until ? +1 : -1;

        // truncate time
        val = this.startOf('day').valueOf();
        if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
          return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
      }
      return this.year();
    }
    function erasNameRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNameRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
      if (!hasOwnProp(this, '_erasAbbrRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
      if (!hasOwnProp(this, '_erasNarrowRegex')) {
        computeErasParse.call(this);
      }
      return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
      return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
      return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
      return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
      return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
      var abbrPieces = [],
        namePieces = [],
        narrowPieces = [],
        mixedPieces = [],
        i,
        l,
        eras = this.eras();
      for (i = 0, l = eras.length; i < l; ++i) {
        namePieces.push(regexEscape(eras[i].name));
        abbrPieces.push(regexEscape(eras[i].abbr));
        narrowPieces.push(regexEscape(eras[i].narrow));
        mixedPieces.push(regexEscape(eras[i].name));
        mixedPieces.push(regexEscape(eras[i].abbr));
        mixedPieces.push(regexEscape(eras[i].narrow));
      }
      this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
      this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
      this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
      this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
      return this.weekYear() % 100;
    });
    addFormatToken(0, ['GG', 2], 0, function () {
      return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
      week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
      return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
      return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
      config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
      return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, ['SS', 2], 0, function () {
      return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
      return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
      addRegexToken(token, matchUnsigned);
    }
    function parseMs(input, array) {
      array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for (token = 'S'; token.length <= 9; token += 'S') {
      addParseToken(token, parseMs);
    }
    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
      return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
      proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
        return 'Moment<' + this.format() + '>';
      };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
      return createLocal(input * 1000);
    }
    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
      return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
      var locale = getLocale(),
        utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
      if (index != null) {
        return get$1(format, index, field, 'month');
      }
      var i,
        out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
      }
      return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }
        format = format || '';
      }
      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0,
        i,
        out = [];
      if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
      }
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
      }
      return out;
    }
    function listMonths(format, index) {
      return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
      eras: [{
        since: '0001-01-01',
        until: +Infinity,
        offset: 1,
        name: 'Anno Domini',
        narrow: 'AD',
        abbr: 'AD'
      }, {
        since: '0000-12-31',
        until: -Infinity,
        offset: 1,
        name: 'Before Christ',
        narrow: 'BC',
        abbr: 'BC'
      }],
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function ordinal(number) {
        var b = number % 10,
          output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        return number + output;
      }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
      var data = this._data;
      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);
      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);
      return this;
    }
    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);
      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;
      return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }
    function bubble() {
      var milliseconds = this._milliseconds,
        days = this._days,
        months = this._months,
        data = this._data,
        seconds,
        minutes,
        hours,
        years,
        monthsFromDays;

      // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166
      if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }

      // The following code bubbles up values, see the tests for
      // examples of what that means.
      data.milliseconds = milliseconds % 1000;
      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;
      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;
      hours = absFloor(minutes / 60);
      data.hours = hours % 24;
      days += absFloor(hours / 24);

      // convert days to months
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;
      data.days = days;
      data.months = months;
      data.years = years;
      return this;
    }
    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return days * 4800 / 146097;
    }
    function monthsToDays(months) {
      // the reverse of daysToMonths
      return months * 146097 / 4800;
    }
    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days,
        months,
        milliseconds = this._milliseconds;
      units = normalizeUnits(units);
      if (units === 'month' || units === 'quarter' || units === 'year') {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        switch (units) {
          case 'month':
            return months;
          case 'quarter':
            return months / 3;
          case 'year':
            return months / 12;
        }
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case 'week':
            return days / 7 + milliseconds / 6048e5;
          case 'day':
            return days + milliseconds / 864e5;
          case 'hour':
            return days * 24 + milliseconds / 36e5;
          case 'minute':
            return days * 1440 + milliseconds / 6e4;
          case 'second':
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here
          case 'millisecond':
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error('Unknown unit ' + units);
        }
      }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
      return function () {
        return this.as(alias);
      };
    }
    var asMilliseconds = makeAs('ms'),
      asSeconds = makeAs('s'),
      asMinutes = makeAs('m'),
      asHours = makeAs('h'),
      asDays = makeAs('d'),
      asWeeks = makeAs('w'),
      asMonths = makeAs('M'),
      asQuarters = makeAs('Q'),
      asYears = makeAs('y');
    function clone$1() {
      return createDuration(this);
    }
    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
      return function () {
        return this.isValid() ? this._data[name] : NaN;
      };
    }
    var milliseconds = makeGetter('milliseconds'),
      seconds = makeGetter('seconds'),
      minutes = makeGetter('minutes'),
      hours = makeGetter('hours'),
      days = makeGetter('days'),
      months = makeGetter('months'),
      years = makeGetter('years');
    function weeks() {
      return absFloor(this.days() / 7);
    }
    var round = Math.round,
      thresholds = {
        ss: 44,
        // a few seconds to seconds
        s: 45,
        // seconds to minute
        m: 45,
        // minutes to hour
        h: 22,
        // hours to day
        d: 26,
        // days to month/week
        w: null,
        // weeks to month
        M: 11 // months to year
      };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
      return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
      var duration = createDuration(posNegDuration).abs(),
        seconds = round(duration.as('s')),
        minutes = round(duration.as('m')),
        hours = round(duration.as('h')),
        days = round(duration.as('d')),
        months = round(duration.as('M')),
        weeks = round(duration.as('w')),
        years = round(duration.as('y')),
        a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
      if (thresholds.w != null) {
        a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
      }
      a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === 'function') {
        round = roundingFunction;
        return true;
      }
      return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === 's') {
        thresholds.ss = limit - 1;
      }
      return true;
    }
    function humanize(argWithSuffix, argThresholds) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var withSuffix = false,
        th = thresholds,
        locale,
        output;
      if (typeof argWithSuffix === 'object') {
        argThresholds = argWithSuffix;
        argWithSuffix = false;
      }
      if (typeof argWithSuffix === 'boolean') {
        withSuffix = argWithSuffix;
      }
      if (typeof argThresholds === 'object') {
        th = Object.assign({}, thresholds, argThresholds);
        if (argThresholds.s != null && argThresholds.ss == null) {
          th.ss = argThresholds.s - 1;
        }
      }
      locale = this.localeData();
      output = relativeTime$1(this, !withSuffix, th, locale);
      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }
      return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }
      var seconds = abs$1(this._milliseconds) / 1000,
        days = abs$1(this._days),
        months = abs$1(this._months),
        minutes,
        hours,
        years,
        s,
        total = this.asSeconds(),
        totalSign,
        ymSign,
        daysSign,
        hmsSign;
      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
      }

      // 3600 seconds -> 60 minutes -> 1 hour
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;

      // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
      s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
      totalSign = total < 0 ? '-' : '';
      ymSign = sign(this._months) !== sign(total) ? '-' : '';
      daysSign = sign(this._days) !== sign(total) ? '-' : '';
      hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
      return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
      config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
      config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.26.0';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
      // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
      // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
      // <input type="datetime-local" step="0.001" />
      DATE: 'YYYY-MM-DD',
      // <input type="date" />
      TIME: 'HH:mm',
      // <input type="time" />
      TIME_SECONDS: 'HH:mm:ss',
      // <input type="time" step="1" />
      TIME_MS: 'HH:mm:ss.SSS',
      // <input type="time" step="0.001" />
      WEEK: 'GGGG-[W]WW',
      // <input type="week" />
      MONTH: 'YYYY-MM' // <input type="month" />
    };

    return hooks;
  });
});
var dateFormatted = function dateFormatted(date) {
  return moment(date).format('MM/DD/YYYY');
};
var secondsInHour = 3600;
var secondsInTenMin = 600;
var getFormattedDuration = function getFormattedDuration(duration) {
  var formatObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    lg: 'H:mm:ss',
    md: 'mm:ss',
    sm: 'm:ss'
  };
  return duration >= secondsInHour ? moment.utc(duration * 1000).format(formatObj.lg) : duration >= secondsInTenMin ? moment.utc(duration * 1000).format(formatObj.md) : moment.utc(duration * 1000).format(formatObj.sm);
};
var ariaFormatObj = {
  lg: 'H [hours] mm [minutes] ss [seconds]',
  md: 'mm [minutes] ss [seconds]',
  sm: 'm [minutes] ss [seconds]'
};
var durationFormatted = function durationFormatted(duration) {
  return {
    visual: getFormattedDuration(duration),
    aria: getFormattedDuration(duration, ariaFormatObj)
  };
};
var getAssetCountLanguage = function getAssetCountLanguage() {
  var assetCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return assetCount <= 99 ? "".concat(assetCount, " Assets") : 'More Than 99+ Assets';
};
var articleCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date published of the video
   */
  datePublished: propTypes.string,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
   * String representing the lexile range. should be formatted as
   * lower - upper
   */
  lexileRange: propTypes.string,
  /**
   * This is an array of metaData string to be rendered.
   * The string should be a numeric value and then a word
   * for more details see the CardMetaData component
   */
  metaData: propTypes.arrayOf(propTypes.string),
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * The source of the Article
  */
  source: propTypes.string,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * Override the ContentType row
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
   * Pass __renderCustomWrapper a function to render the Card as something other than a div.
   *
   * **Example**:
   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
       <article {...cardProps}>
         {linkTagWithChildren}
       </article>
   )}`
   */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var ArticleCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  ArticleCard.displayName = 'ArticleCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var datePublished = props.datePublished,
    lexileRange = props.lexileRange,
    source = props.source,
    passThroughProps = _objectWithoutProperties3(props, _excluded4);
  var metaData = [source];
  if (datePublished) {
    metaData.push(dateFormatted(datePublished));
  }
  return jsx(ContentCard, _extends({}, passThroughProps, {
    ref: ref,
    imageOverlay: props.lexileRange && jsx("div", {
      css: /*#__PURE__*/css([defaultImageOverlayContainer, {
        flexDirection: 'column-reverse'
      }], ";label:ArticleCard;")
    }, jsx("div", {
      css: imageOverlayTextStyle(props.isVertical)
    }, lexileRange)),
    contentType: "Article",
    metaData: metaData
  }));
});
ArticleCard.propTypes = articleCardProps;
ArticleCard.defaultProps = {
  isVertical: true
};
ArticleCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArticleCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date published of the video"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "lexileRange": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String representing the lexile range. should be formatted as\nlower - upper"
    },
    "metaData": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "This is an array of metaData string to be rendered.\nThe string should be a numeric value and then a word\nfor more details see the CardMetaData component"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "source": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The source of the Article"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Override the ContentType row"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n   `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n       <article {...cardProps}>\n         {linkTagWithChildren}\n       </article>\n   )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var audioIcon = {
  height: '2em',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  fill: ui.white['100']
};
function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 4C11.175 4 4 11.175 4 20s7.175 16 16 16 16-7.175 16-16S28.825 4 20 4zm-8 18.086v-3.654c0-.757.605-1.37 1.35-1.37h1.8l3.072-3.01a.556.556 0 01.62-.152c.218.085.36.298.36.535v11.648a.57.57 0 01-.36.534.556.556 0 01-.62-.152l-3.071-3.009h-1.8A1.36 1.36 0 0112 22.086zm9.769.73c.66-.682 1.03-1.6 1.03-2.557 0-.956-.37-1.875-1.03-2.558a.447.447 0 00-.483-.102.46.46 0 00-.285.408v4.504a.46.46 0 00.285.408.447.447 0 00.483-.102zm.495 4.05a7.249 7.249 0 003.63-3.917 7.395 7.395 0 000-5.378 7.254 7.254 0 00-3.63-3.918.897.897 0 00-1.121.48.92.92 0 00.372 1.174 5.45 5.45 0 012.709 2.94 5.56 5.56 0 010 4.026 5.448 5.448 0 01-2.71 2.94.923.923 0 00-.371 1.175.894.894 0 001.12.478z"
});
function SvgSoundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 40 40"
  }, props), _ref);
}
var hiddenStyle = {
  border: '0',
  clipPath: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px'
};
var visuallyHiddenStyles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': hiddenStyle
});
var AudioCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * aria attributes passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date published of the audio
   */
  datePublished: propTypes.string,
  /**
   * Audio duration of the Card.
   */
  duration: propTypes.number,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3(_objectSpread3({}, imgProps), {}, {
    ariaProps: propTypes.object
  })),
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
   * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseEnter={() => console.log('mouseEntered')}`
   */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * source of the audio
   */
  source: propTypes.string
});
var AudioCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  AudioCard.displayName = 'AudioCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var datePublished = props.datePublished,
    duration = props.duration,
    source = props.source,
    passThroughProps = _objectWithoutProperties3(props, _excluded5);
  var metaData = datePublished ? [source, dateFormatted(datePublished)] : [source];
  var durationObj = durationFormatted(duration);
  return jsx(ContentCard, _extends({}, passThroughProps, {
    contentType: "Audio",
    metaData: metaData,
    ref: ref,
    imageOverlay: jsx("div", {
      css: /*#__PURE__*/css(_objectSpread3(_objectSpread3({}, defaultImageOverlayContainer), {}, {
        flexDirection: 'column-reverse'
      }), ";label:AudioCard;")
    }, jsx(SvgSoundIcon, {
      "aria-hidden": "true",
      css: audioIcon
    }), duration && jsx("div", {
      css: imageOverlayTextStyle(passThroughProps.isVertical)
    }, jsx("span", {
      css: hiddenStyle
    }, durationObj.aria), jsx("span", {
      "aria-hidden": "true"
    }, durationObj.visual)))
  }));
});
AudioCard.defaultProps = {
  isVertical: ContentCard.defaultProps.isVertical
};
AudioCard.propTypes = AudioCardProps;
AudioCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AudioCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "ContentCard.defaultProps.isVertical",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "aria attributes passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date published of the audio"
    },
    "duration": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Audio duration of the Card."
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {
          "ariaProps": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "source": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "source of the audio"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  module.exports = _typeof;
});
var interopRequireWildcard = createCommonjsModule(function (module) {
  function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
      return cache;
    };
    return cache;
  }
  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || _typeof_1(obj) !== "object" && typeof obj !== "function") {
      return {
        "default": obj
      };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj["default"] = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  module.exports = _interopRequireWildcard;
});
unwrapExports(interopRequireWildcard);
var interopRequireDefault = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault;
});
unwrapExports(interopRequireDefault);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defineProperty = _defineProperty;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var objectWithoutProperties = _objectWithoutProperties;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var classCallCheck = _classCallCheck;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var createClass = _createClass;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var assertThisInitialized = _assertThisInitialized;
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  module.exports = _setPrototypeOf;
});
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
var inherits = _inherits;
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }
  return assertThisInitialized(self);
}
var possibleConstructorReturn = _possibleConstructorReturn;
var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  module.exports = _getPrototypeOf;
});
var reactIs_development$1 = createCommonjsModule(function (module, exports) {
  {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' ||
        // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode

      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs_development_1$1 = reactIs_development$1.AsyncMode;
var reactIs_development_2$1 = reactIs_development$1.ConcurrentMode;
var reactIs_development_3$1 = reactIs_development$1.ContextConsumer;
var reactIs_development_4$1 = reactIs_development$1.ContextProvider;
var reactIs_development_5$1 = reactIs_development$1.Element;
var reactIs_development_6$1 = reactIs_development$1.ForwardRef;
var reactIs_development_7$1 = reactIs_development$1.Fragment;
var reactIs_development_8$1 = reactIs_development$1.Lazy;
var reactIs_development_9$1 = reactIs_development$1.Memo;
var reactIs_development_10$1 = reactIs_development$1.Portal;
var reactIs_development_11$1 = reactIs_development$1.Profiler;
var reactIs_development_12$1 = reactIs_development$1.StrictMode;
var reactIs_development_13$1 = reactIs_development$1.Suspense;
var reactIs_development_14$1 = reactIs_development$1.isAsyncMode;
var reactIs_development_15$1 = reactIs_development$1.isConcurrentMode;
var reactIs_development_16$1 = reactIs_development$1.isContextConsumer;
var reactIs_development_17$1 = reactIs_development$1.isContextProvider;
var reactIs_development_18$1 = reactIs_development$1.isElement;
var reactIs_development_19$1 = reactIs_development$1.isForwardRef;
var reactIs_development_20$1 = reactIs_development$1.isFragment;
var reactIs_development_21$1 = reactIs_development$1.isLazy;
var reactIs_development_22$1 = reactIs_development$1.isMemo;
var reactIs_development_23$1 = reactIs_development$1.isPortal;
var reactIs_development_24$1 = reactIs_development$1.isProfiler;
var reactIs_development_25$1 = reactIs_development$1.isStrictMode;
var reactIs_development_26$1 = reactIs_development$1.isSuspense;
var reactIs_development_27$1 = reactIs_development$1.isValidElementType;
var reactIs_development_28$1 = reactIs_development$1.typeOf;
var reactIs$1 = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_development$1;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$6 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;
function toObject$1(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative$1() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118

    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056

    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056

    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
  var from;
  var to = toObject$1(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$6.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols$1) {
      symbols = getOwnPropertySymbols$1(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable$1.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;
var printWarning$2 = function printWarning$2() {};
{
  var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning$2 = function printWarning$2(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */

function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$2('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */

checkPropTypes$1.resetWarningCache = function () {
  {
    loggedTypeFailures$1 = {};
  }
};
var checkPropTypes_1$1 = checkPropTypes$1;
var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$3 = function printWarning$3() {};
{
  printWarning$3 = function printWarning$3(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull$1() {
  return null;
}
var factoryWithTypeCheckers$1 = function factoryWithTypeCheckers$1(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */

  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.

  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$3('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      {
        if (arguments.length > 1) {
          printWarning$3('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$3('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      printWarning$3('Invalid argument supplied to oneOfType, expected an instance of array.');
      return emptyFunctionThatReturnsNull$1;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$3('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull$1;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
          return null;
        }
      }
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.

      var allKeys = objectAssign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol

    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'

    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.

    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.

  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.

  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"

  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  } // Returns class name of the object, if any.

  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes$1 = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    var ReactIs = reactIs$1; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
  }
});
var classnames$1 = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */

  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);
          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;
  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      result = Symbol('observable');
      Symbol.observable = result;
    }
  } else {
    result = '@@observable';
  }
  return result;
}

/* global window */
var root$1;
if (typeof self !== 'undefined') {
  root$1 = self;
} else if (typeof window !== 'undefined') {
  root$1 = window;
} else if (typeof global !== 'undefined') {
  root$1 = global;
} else if (typeof module !== 'undefined') {
  root$1 = module;
} else {
  root$1 = Function('return this')();
}
var result = symbolObservablePonyfill(root$1);

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */

var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */

function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }
  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }
  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */

  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }
    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */

  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }
    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }
    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }
    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */

  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }
    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */

  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[result] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.

  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[result] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */

function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */

  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && "action \"" + String(actionType) + "\"" || 'an action';
  return "Given " + actionDescription + ", reducer \"" + key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }
  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }
  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;
  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });
    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }
    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle " + ActionTypes.INIT + " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];
    {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }
    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;
  {
    unexpectedKeyCache = {};
  }
  var shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }
    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */

function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? 'null' : typeof actionCreators) + ". " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }
  var boundActionCreators = {};
  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }
  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }
  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };
      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}
if (typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}
var redux = /*#__PURE__*/Object.freeze({
  __proto__: null,
  __DO_NOT_USE__ActionTypes: ActionTypes,
  applyMiddleware: applyMiddleware,
  bindActionCreators: bindActionCreators,
  combineReducers: combineReducers,
  compose: compose,
  createStore: createStore
});
var video = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.handleLoadStart = handleLoadStart;
  exports.handleCanPlay = handleCanPlay;
  exports.handleWaiting = handleWaiting;
  exports.handleCanPlayThrough = handleCanPlayThrough;
  exports.handlePlaying = handlePlaying;
  exports.handlePlay = handlePlay;
  exports.handlePause = handlePause;
  exports.handleEnd = handleEnd;
  exports.handleSeeking = handleSeeking;
  exports.handleSeeked = handleSeeked;
  exports.handleDurationChange = handleDurationChange;
  exports.handleTimeUpdate = handleTimeUpdate;
  exports.handleVolumeChange = handleVolumeChange;
  exports.handleProgressChange = handleProgressChange;
  exports.handleRateChange = handleRateChange;
  exports.handleSuspend = handleSuspend;
  exports.handleAbort = handleAbort;
  exports.handleEmptied = handleEmptied;
  exports.handleStalled = handleStalled;
  exports.handleLoadedMetaData = handleLoadedMetaData;
  exports.handleLoadedData = handleLoadedData;
  exports.handleResize = handleResize;
  exports.handleError = handleError;
  exports.handleSeekingTime = handleSeekingTime;
  exports.handleEndSeeking = handleEndSeeking;
  exports.activateTextTrack = activateTextTrack;
  exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
  var LOAD_START = 'video-react/LOAD_START';
  exports.LOAD_START = LOAD_START;
  var CAN_PLAY = 'video-react/CAN_PLAY';
  exports.CAN_PLAY = CAN_PLAY;
  var WAITING = 'video-react/WAITING';
  exports.WAITING = WAITING;
  var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
  exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
  var PLAYING = 'video-react/PLAYING';
  exports.PLAYING = PLAYING;
  var PLAY = 'video-react/PLAY';
  exports.PLAY = PLAY;
  var PAUSE = 'video-react/PAUSE';
  exports.PAUSE = PAUSE;
  var END = 'video-react/END';
  exports.END = END;
  var SEEKING = 'video-react/SEEKING';
  exports.SEEKING = SEEKING;
  var SEEKED = 'video-react/SEEKED';
  exports.SEEKED = SEEKED;
  var SEEKING_TIME = 'video-react/SEEKING_TIME';
  exports.SEEKING_TIME = SEEKING_TIME;
  var END_SEEKING = 'video-react/END_SEEKING';
  exports.END_SEEKING = END_SEEKING;
  var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
  exports.DURATION_CHANGE = DURATION_CHANGE;
  var TIME_UPDATE = 'video-react/TIME_UPDATE';
  exports.TIME_UPDATE = TIME_UPDATE;
  var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
  exports.VOLUME_CHANGE = VOLUME_CHANGE;
  var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
  exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
  var RATE_CHANGE = 'video-react/RATE_CHANGE';
  exports.RATE_CHANGE = RATE_CHANGE;
  var SUSPEND = 'video-react/SUSPEND';
  exports.SUSPEND = SUSPEND;
  var ABORT = 'video-react/ABORT';
  exports.ABORT = ABORT;
  var EMPTIED = 'video-react/EMPTIED';
  exports.EMPTIED = EMPTIED;
  var STALLED = 'video-react/STALLED';
  exports.STALLED = STALLED;
  var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
  exports.LOADED_META_DATA = LOADED_META_DATA;
  var LOADED_DATA = 'video-react/LOADED_DATA';
  exports.LOADED_DATA = LOADED_DATA;
  var RESIZE = 'video-react/RESIZE';
  exports.RESIZE = RESIZE;
  var ERROR = 'video-react/ERROR';
  exports.ERROR = ERROR;
  var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
  exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;
  function handleLoadStart(videoProps) {
    return {
      type: LOAD_START,
      videoProps: videoProps
    };
  }
  function handleCanPlay(videoProps) {
    return {
      type: CAN_PLAY,
      videoProps: videoProps
    };
  }
  function handleWaiting(videoProps) {
    return {
      type: WAITING,
      videoProps: videoProps
    };
  }
  function handleCanPlayThrough(videoProps) {
    return {
      type: CAN_PLAY_THROUGH,
      videoProps: videoProps
    };
  }
  function handlePlaying(videoProps) {
    return {
      type: PLAYING,
      videoProps: videoProps
    };
  }
  function handlePlay(videoProps) {
    return {
      type: PLAY,
      videoProps: videoProps
    };
  }
  function handlePause(videoProps) {
    return {
      type: PAUSE,
      videoProps: videoProps
    };
  }
  function handleEnd(videoProps) {
    return {
      type: END,
      videoProps: videoProps
    };
  }
  function handleSeeking(videoProps) {
    return {
      type: SEEKING,
      videoProps: videoProps
    };
  }
  function handleSeeked(videoProps) {
    return {
      type: SEEKED,
      videoProps: videoProps
    };
  }
  function handleDurationChange(videoProps) {
    return {
      type: DURATION_CHANGE,
      videoProps: videoProps
    };
  }
  function handleTimeUpdate(videoProps) {
    return {
      type: TIME_UPDATE,
      videoProps: videoProps
    };
  }
  function handleVolumeChange(videoProps) {
    return {
      type: VOLUME_CHANGE,
      videoProps: videoProps
    };
  }
  function handleProgressChange(videoProps) {
    return {
      type: PROGRESS_CHANGE,
      videoProps: videoProps
    };
  }
  function handleRateChange(videoProps) {
    return {
      type: RATE_CHANGE,
      videoProps: videoProps
    };
  }
  function handleSuspend(videoProps) {
    return {
      type: SUSPEND,
      videoProps: videoProps
    };
  }
  function handleAbort(videoProps) {
    return {
      type: ABORT,
      videoProps: videoProps
    };
  }
  function handleEmptied(videoProps) {
    return {
      type: EMPTIED,
      videoProps: videoProps
    };
  }
  function handleStalled(videoProps) {
    return {
      type: STALLED,
      videoProps: videoProps
    };
  }
  function handleLoadedMetaData(videoProps) {
    return {
      type: LOADED_META_DATA,
      videoProps: videoProps
    };
  }
  function handleLoadedData(videoProps) {
    return {
      type: LOADED_DATA,
      videoProps: videoProps
    };
  }
  function handleResize(videoProps) {
    return {
      type: RESIZE,
      videoProps: videoProps
    };
  }
  function handleError(videoProps) {
    return {
      type: ERROR,
      videoProps: videoProps
    };
  }
  function handleSeekingTime(time) {
    return {
      type: SEEKING_TIME,
      time: time
    };
  }
  function handleEndSeeking(time) {
    return {
      type: END_SEEKING,
      time: time
    };
  }
  function activateTextTrack(textTrack) {
    return {
      type: ACTIVATE_TEXT_TRACK,
      textTrack: textTrack
    };
  }
});
unwrapExports(video);
var video_1 = video.handleLoadStart;
var video_2 = video.handleCanPlay;
var video_3 = video.handleWaiting;
var video_4 = video.handleCanPlayThrough;
var video_5 = video.handlePlaying;
var video_6 = video.handlePlay;
var video_7 = video.handlePause;
var video_8 = video.handleEnd;
var video_9 = video.handleSeeking;
var video_10 = video.handleSeeked;
var video_11 = video.handleDurationChange;
var video_12 = video.handleTimeUpdate;
var video_13 = video.handleVolumeChange;
var video_14 = video.handleProgressChange;
var video_15 = video.handleRateChange;
var video_16 = video.handleSuspend;
var video_17 = video.handleAbort;
var video_18 = video.handleEmptied;
var video_19 = video.handleStalled;
var video_20 = video.handleLoadedMetaData;
var video_21 = video.handleLoadedData;
var video_22 = video.handleResize;
var video_23 = video.handleError;
var video_24 = video.handleSeekingTime;
var video_25 = video.handleEndSeeking;
var video_26 = video.activateTextTrack;
var video_27 = video.ACTIVATE_TEXT_TRACK;
var video_28 = video.ERROR;
var video_29 = video.RESIZE;
var video_30 = video.LOADED_DATA;
var video_31 = video.LOADED_META_DATA;
var video_32 = video.STALLED;
var video_33 = video.EMPTIED;
var video_34 = video.ABORT;
var video_35 = video.SUSPEND;
var video_36 = video.RATE_CHANGE;
var video_37 = video.PROGRESS_CHANGE;
var video_38 = video.VOLUME_CHANGE;
var video_39 = video.TIME_UPDATE;
var video_40 = video.DURATION_CHANGE;
var video_41 = video.END_SEEKING;
var video_42 = video.SEEKING_TIME;
var video_43 = video.SEEKED;
var video_44 = video.SEEKING;
var video_45 = video.END;
var video_46 = video.PAUSE;
var video_47 = video.PLAY;
var video_48 = video.PLAYING;
var video_49 = video.CAN_PLAY_THROUGH;
var video_50 = video.WAITING;
var video_51 = video.CAN_PLAY;
var video_52 = video.LOAD_START;
var fullscreen = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var Fullscreen = /*#__PURE__*/function () {
    function Fullscreen() {
      (0, _classCallCheck2.default)(this, Fullscreen);
    }
    (0, _createClass2.default)(Fullscreen, [{
      key: "request",
      value: function request(elm) {
        if (elm.requestFullscreen) {
          elm.requestFullscreen();
        } else if (elm.webkitRequestFullscreen) {
          elm.webkitRequestFullscreen();
        } else if (elm.mozRequestFullScreen) {
          elm.mozRequestFullScreen();
        } else if (elm.msRequestFullscreen) {
          elm.msRequestFullscreen();
        }
      }
    }, {
      key: "exit",
      value: function exit() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }, {
      key: "addEventListener",
      value: function addEventListener(handler) {
        document.addEventListener('fullscreenchange', handler);
        document.addEventListener('webkitfullscreenchange', handler);
        document.addEventListener('mozfullscreenchange', handler);
        document.addEventListener('MSFullscreenChange', handler);
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(handler) {
        document.removeEventListener('fullscreenchange', handler);
        document.removeEventListener('webkitfullscreenchange', handler);
        document.removeEventListener('mozfullscreenchange', handler);
        document.removeEventListener('MSFullscreenChange', handler);
      }
    }, {
      key: "isFullscreen",
      get: function get() {
        return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
      }
    }, {
      key: "enabled",
      get: function get() {
        return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
      }
    }]);
    return Fullscreen;
  }();
  var _default = new Fullscreen();
  exports.default = _default;
});
unwrapExports(fullscreen);
var player = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.handleFullscreenChange = handleFullscreenChange;
  exports.handleOptionsOverlayChange = handleOptionsOverlayChange;
  exports.setAudioDescriptions = setAudioDescriptions;
  exports.updateActiveAudioDescription = updateActiveAudioDescription;
  exports.activate = activate;
  exports.userActivate = userActivate;
  exports.play = play;
  exports.pause = pause;
  exports.togglePlay = togglePlay;
  exports.seek = seek;
  exports.forward = forward;
  exports.replay = replay;
  exports.changeRate = changeRate;
  exports.changeVolume = changeVolume;
  exports.mute = mute;
  exports.toggleFullscreen = toggleFullscreen;
  exports.ACTIVE_AUDIO_DESCRIPTION = exports.AUDIO_DESCRIPTIONS = exports.OPTIONS_OVERLAY_CHANGE = exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;
  var _fullscreen = interopRequireDefault(fullscreen);
  var OPERATE = 'video-react/OPERATE';
  exports.OPERATE = OPERATE;
  var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
  exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
  var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
  exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
  var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
  exports.USER_ACTIVATE = USER_ACTIVATE;
  var OPTIONS_OVERLAY_CHANGE = 'video-react/OPTIONS_OVERLAY_CHANGE';
  exports.OPTIONS_OVERLAY_CHANGE = OPTIONS_OVERLAY_CHANGE;
  var AUDIO_DESCRIPTIONS = 'video-react/AUDIO_DESCRIPTIONS';
  exports.AUDIO_DESCRIPTIONS = AUDIO_DESCRIPTIONS;
  var ACTIVE_AUDIO_DESCRIPTION = 'video-react/ACTIVE_AUDIO_DESCRIPTION';
  exports.ACTIVE_AUDIO_DESCRIPTION = ACTIVE_AUDIO_DESCRIPTION;
  function handleFullscreenChange(isFullscreen) {
    return {
      type: FULLSCREEN_CHANGE,
      isFullscreen: isFullscreen
    };
  }
  function handleOptionsOverlayChange() {
    return {
      type: OPTIONS_OVERLAY_CHANGE
    };
  }
  function setAudioDescriptions(audioDescriptions) {
    return {
      type: AUDIO_DESCRIPTIONS,
      audioDescriptions: audioDescriptions
    };
  }
  function updateActiveAudioDescription(activeAudioDescription) {
    return {
      type: ACTIVE_AUDIO_DESCRIPTION,
      activeAudioDescription: activeAudioDescription
    };
  }
  function activate(activity) {
    return {
      type: PLAYER_ACTIVATE,
      activity: activity
    };
  }
  function userActivate(activity) {
    return {
      type: USER_ACTIVATE,
      activity: activity
    };
  }
  function play() {
    var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      action: 'play',
      source: ''
    };
    this.video.play();
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function pause() {
    var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      action: 'pause',
      source: ''
    };
    this.video.pause();
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function togglePlay() {
    var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      action: 'toggle-play',
      source: ''
    };
    this.video.togglePlay();
    return {
      type: OPERATE,
      operation: operation
    };
  } // seek video by time

  function seek(time) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: 'seek',
      source: ''
    };
    this.video.seek(time);
    return {
      type: OPERATE,
      operation: operation
    };
  } // jump forward x seconds

  function forward(seconds) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: "forward-".concat(seconds),
      source: ''
    };
    this.video.forward(seconds);
    return {
      type: OPERATE,
      operation: operation
    };
  } // jump back x seconds

  function replay(seconds) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: "replay-".concat(seconds),
      source: ''
    };
    this.video.replay(seconds);
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function changeRate(rate) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: 'change-rate',
      source: ''
    };
    this.video.playbackRate = rate;
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function changeVolume(volume) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: 'change-volume',
      source: ''
    };
    var v = volume;
    if (volume < 0) {
      v = 0;
    }
    if (volume > 1) {
      v = 1;
    }
    this.video.volume = v;
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function mute(muted) {
    var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      action: muted ? 'muted' : 'unmuted',
      source: ''
    };
    this.video.muted = muted;
    return {
      type: OPERATE,
      operation: operation
    };
  }
  function toggleFullscreen(player) {
    if (_fullscreen.default.enabled) {
      if (_fullscreen.default.isFullscreen) {
        _fullscreen.default.exit();
      } else {
        _fullscreen.default.request(this.rootElement);
      }
      return {
        type: OPERATE,
        operation: {
          action: 'toggle-fullscreen',
          source: ''
        }
      };
    }
    return {
      type: FULLSCREEN_CHANGE,
      isFullscreen: !player.isFullscreen
    };
  }
});
unwrapExports(player);
var player_1 = player.handleFullscreenChange;
var player_2 = player.handleOptionsOverlayChange;
var player_3 = player.setAudioDescriptions;
var player_4 = player.updateActiveAudioDescription;
var player_5 = player.activate;
var player_6 = player.userActivate;
var player_7 = player.play;
var player_8 = player.pause;
var player_9 = player.togglePlay;
var player_10 = player.seek;
var player_11 = player.forward;
var player_12 = player.replay;
var player_13 = player.changeRate;
var player_14 = player.changeVolume;
var player_15 = player.mute;
var player_16 = player.toggleFullscreen;
var player_17 = player.ACTIVE_AUDIO_DESCRIPTION;
var player_18 = player.AUDIO_DESCRIPTIONS;
var player_19 = player.OPTIONS_OVERLAY_CHANGE;
var player_20 = player.USER_ACTIVATE;
var player_21 = player.PLAYER_ACTIVATE;
var player_22 = player.FULLSCREEN_CHANGE;
var player_23 = player.OPERATE;
var player_1$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = player$1;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var initialState = {
    currentSrc: null,
    duration: 0,
    currentTime: 0,
    seekingTime: 0,
    buffered: null,
    waiting: false,
    seeking: false,
    paused: true,
    autoPaused: false,
    ended: false,
    playbackRate: 1,
    muted: false,
    volume: 1,
    readyState: 0,
    networkState: 0,
    videoWidth: 0,
    videoHeight: 0,
    hasStarted: false,
    userActivity: true,
    isActive: false,
    isFullscreen: false,
    activeTextTrack: null,
    isOptionsOverlayOpen: false,
    audioDescriptions: [],
    activeAudioDescription: 0
  };
  function player$1() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action.type) {
      case player.USER_ACTIVATE:
        return _objectSpread(_objectSpread({}, state), {}, {
          userActivity: action.activity
        });
      case player.PLAYER_ACTIVATE:
        return _objectSpread(_objectSpread({}, state), {}, {
          isActive: action.activity
        });
      case player.FULLSCREEN_CHANGE:
        return _objectSpread(_objectSpread({}, state), {}, {
          isFullscreen: !!action.isFullscreen
        });
      case player.OPTIONS_OVERLAY_CHANGE:
        return _objectSpread(_objectSpread({}, state), {}, {
          isOptionsOverlayOpen: !state.isOptionsOverlayOpen
        });
      case video.SEEKING_TIME:
        return _objectSpread(_objectSpread({}, state), {}, {
          seekingTime: action.time
        });
      case video.END_SEEKING:
        return _objectSpread(_objectSpread({}, state), {}, {
          seekingTime: 0
        });
      case video.LOAD_START:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          hasStarted: false,
          ended: false
        });
      case video.CAN_PLAY:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          waiting: false
        });
      case video.WAITING:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          waiting: true
        });
      case video.CAN_PLAY_THROUGH:
      case video.PLAYING:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          waiting: false
        });
      case video.PLAY:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          ended: false,
          paused: false,
          autoPaused: false,
          waiting: false,
          hasStarted: true
        });
      case video.PAUSE:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          paused: true
        });
      case video.END:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          ended: true
        });
      case video.SEEKING:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          seeking: true
        });
      case video.SEEKED:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          seeking: false
        });
      case video.ERROR:
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.videoProps), {}, {
          error: 'UNKNOWN ERROR',
          ended: true
        });
      case video.DURATION_CHANGE:
      case video.TIME_UPDATE:
      case video.VOLUME_CHANGE:
      case video.PROGRESS_CHANGE:
      case video.RATE_CHANGE:
      case video.SUSPEND:
      case video.ABORT:
      case video.EMPTIED:
      case video.STALLED:
      case video.LOADED_META_DATA:
      case video.LOADED_DATA:
      case video.RESIZE:
        return _objectSpread(_objectSpread({}, state), action.videoProps);
      case video.ACTIVATE_TEXT_TRACK:
        return _objectSpread(_objectSpread({}, state), {}, {
          activeTextTrack: action.textTrack
        });
      case player.AUDIO_DESCRIPTIONS:
        return _objectSpread(_objectSpread({}, state), {}, {
          audioDescriptions: action.audioDescriptions
        });
      case player.ACTIVE_AUDIO_DESCRIPTION:
        return _objectSpread(_objectSpread({}, state), {}, {
          activeAudioDescription: action.activeAudioDescription
        });
      default:
        return state;
    }
  }
});
unwrapExports(player_1$1);
var operation_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = operation;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var initialState = {
    count: 0,
    operation: {
      action: '',
      source: ''
    }
  };
  function operation() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action.type) {
      case player.OPERATE:
        return _objectSpread(_objectSpread({}, state), {}, {
          count: state.count + 1,
          operation: _objectSpread(_objectSpread({}, state.operation), action.operation)
        });
      default:
        return state;
    }
  }
});
unwrapExports(operation_1);
var reducers = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = _default;
  exports.operationReducer = exports.playerReducer = void 0;
  var _player = interopRequireDefault(player_1$1);
  var _operation = interopRequireDefault(operation_1);
  function _default() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return {
      player: (0, _player.default)(state.player, action),
      operation: (0, _operation.default)(state.operation, action)
    };
  }
  var playerReducer = _player.default;
  exports.playerReducer = playerReducer;
  var operationReducer = _operation.default;
  exports.operationReducer = operationReducer;
});
unwrapExports(reducers);
var reducers_1 = reducers.operationReducer;
var reducers_2 = reducers.playerReducer;
var Manager_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _reducers = interopRequireDefault(reducers);
  var playerActions = interopRequireWildcard(player);
  var videoActions = interopRequireWildcard(video);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var Manager = /*#__PURE__*/function () {
    function Manager(store) {
      (0, _classCallCheck2.default)(this, Manager);
      this.store = store || (0, redux.createStore)(_reducers.default);
      this.video = null;
      this.rootElement = null;
    }
    (0, _createClass2.default)(Manager, [{
      key: "getActions",
      value: function getActions() {
        var manager = this;
        var dispatch = this.store.dispatch;
        var actions = _objectSpread(_objectSpread({}, playerActions), videoActions);
        function bindActionCreator(actionCreator) {
          return function bindAction() {
            // eslint-disable-next-line prefer-rest-params
            var action = actionCreator.apply(manager, arguments);
            if (typeof action !== 'undefined') {
              dispatch(action);
            }
          };
        }
        return Object.keys(actions).filter(function (key) {
          return typeof actions[key] === 'function';
        }).reduce(function (boundActions, key) {
          boundActions[key] = bindActionCreator(actions[key]);
          return boundActions;
        }, {});
      }
    }, {
      key: "getState",
      value: function getState() {
        return this.store.getState();
      } // subscribe state change
    }, {
      key: "subscribeToStateChange",
      value: function subscribeToStateChange(listener, getState) {
        if (!getState) {
          getState = this.getState.bind(this);
        }
        var prevState = getState();
        var handleChange = function handleChange() {
          var state = getState();
          if (state === prevState) {
            return;
          }
          var prevStateCopy = prevState;
          prevState = state;
          listener(state, prevStateCopy);
        };
        return this.store.subscribe(handleChange);
      } // subscribe to operation state change
    }, {
      key: "subscribeToOperationStateChange",
      value: function subscribeToOperationStateChange(listener) {
        var _this = this;
        return this.subscribeToStateChange(listener, function () {
          return _this.getState().operation;
        });
      } // subscribe to player state change
    }, {
      key: "subscribeToPlayerStateChange",
      value: function subscribeToPlayerStateChange(listener) {
        var _this2 = this;
        return this.subscribeToStateChange(listener, function () {
          return _this2.getState().player;
        });
      }
    }]);
    return Manager;
  }();
  exports.default = Manager;
});
unwrapExports(Manager_1);
var LoadingSpinner_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = LoadingSpinner;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  function LoadingSpinner(_ref) {
    var player = _ref.player,
      className = _ref.className;
    if (player.error) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-loading-spinner', className)
    });
  }
  LoadingSpinner.propTypes = propTypes;
  LoadingSpinner.displayName = 'LoadingSpinner';
});
unwrapExports(LoadingSpinner_1);
var PosterImage_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    poster: _propTypes.default.string,
    player: _propTypes.default.object,
    actions: _propTypes.default.object,
    className: _propTypes.default.string
  };
  function PosterImage(_ref) {
    var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;
    if (!poster || player.hasStarted) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-poster', className),
      style: {
        backgroundImage: "url(\"".concat(poster, "\")")
      },
      onClick: function onClick() {
        if (player.paused) {
          actions.play();
        }
      }
    });
  }
  PosterImage.propTypes = propTypes;
  PosterImage.displayName = 'PosterImage';
  var _default = PosterImage;
  exports.default = _default;
});
unwrapExports(PosterImage_1);
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var arrayLikeToArray = _arrayLikeToArray;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
var arrayWithoutHoles = _arrayWithoutHoles;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
var iterableToArray = _iterableToArray;
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
var unsupportedIterableToArray = _unsupportedIterableToArray;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var nonIterableSpread = _nonIterableSpread;
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
var toConsumableArray = _toConsumableArray;
var utils = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.formatTime = formatTime;
  exports.isVideoChild = isVideoChild;
  exports.mergeAndSortChildren = mergeAndSortChildren;
  exports.deprecatedWarning = deprecatedWarning;
  exports.throttle = throttle;
  exports.mediaProperties = void 0;
  var _toConsumableArray2 = interopRequireDefault(toConsumableArray);
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _react = interopRequireDefault(React__default);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  } // NaN is the only value in javascript which is not equal to itself.
  // eslint-disable-next-line no-self-compare

  var isNaN = Number.isNaN || function (value) {
    return value !== value;
  };
  /**
   * @file format-time.js
   *
   * Format seconds as a time string, H:MM:SS or M:SS
   * Supplying a guide (in seconds) will force a number of leading zeros
   * to cover the length of the guide
   *
   * @param  {Number} seconds Number of seconds to be turned into a string
   * @param  {Number} guide   Number (in seconds) to model the string after
   * @return {String}         Time formatted as H:MM:SS or M:SS
   * @private
   * @function formatTime
   */

  function formatTime() {
    var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
    var s = Math.floor(seconds % 60);
    var m = Math.floor(seconds / 60 % 60);
    var h = Math.floor(seconds / 3600);
    var gm = Math.floor(guide / 60 % 60);
    var gh = Math.floor(guide / 3600); // handle invalid times

    if (isNaN(seconds) || seconds === Infinity) {
      // '-' is false for all relational operators (e.g. <, >=) so this setting
      // will add the minimum number of fields specified by the guide
      h = '-';
      m = '-';
      s = '-';
    } // Check if we need to show hours

    h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
    // Always show at least one digit of minutes.

    m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

    s = s < 10 ? "0".concat(s) : s;
    return h + m + s;
  } // Check if the element belongs to a video element
  // only accept <source />, <track />,
  // <MyComponent isVideoChild />
  // elements

  function isVideoChild(c) {
    if (c.props && c.props.isVideoChild) {
      return true;
    }
    return c.type === 'source' || c.type === 'track';
  }
  var find = function find(elements, func) {
    return elements.filter(func)[0];
  }; // check if two components are the same type

  var isTypeEqual = function isTypeEqual(component1, component2) {
    var type1 = component1.type;
    var type2 = component2.type;
    if (typeof type1 === 'string' || typeof type2 === 'string') {
      return type1 === type2;
    }
    if (typeof type1 === 'function' && typeof type2 === 'function') {
      return type1.displayName === type2.displayName;
    }
    return false;
  }; // merge default children
  // sort them by `order` property
  // filter them by `disabled` property

  function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
    var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var children = _react.default.Children.toArray(_children);
    var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2.default)(_parentProps, ["order"]); // ignore order from parent

    return children.filter(function (e) {
      return !e.props.disabled;
    }) // filter the disabled components
    .concat(defaultChildren.filter(function (c) {
      return !find(children, function (component) {
        return isTypeEqual(component, c);
      });
    })).map(function (element) {
      var defaultComponent = find(defaultChildren, function (c) {
        return isTypeEqual(c, element);
      });
      var defaultProps = defaultComponent ? defaultComponent.props : {};
      var props = _objectSpread(_objectSpread(_objectSpread({}, parentProps), defaultProps), element.props);
      var e = /*#__PURE__*/_react.default.cloneElement(element, props, element.props.children);
      return e;
    }).sort(function (a, b) {
      return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
    });
  }
  /**
   * Temporary utility for generating the warnings
   */

  function deprecatedWarning(oldMethodCall, newMethodCall) {
    // eslint-disable-next-line no-console
    console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
  }
  function throttle(callback, limit) {
    var _arguments = arguments;
    var wait = false;
    return function () {
      if (!wait) {
        // eslint-disable-next-line prefer-rest-params
        callback.apply(void 0, (0, _toConsumableArray2.default)(_arguments));
        wait = true;
        setTimeout(function () {
          wait = false;
        }, limit);
      }
    };
  }
  var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
  exports.mediaProperties = mediaProperties;
});
unwrapExports(utils);
var utils_1 = utils.formatTime;
var utils_2 = utils.isVideoChild;
var utils_3 = utils.mergeAndSortChildren;
var utils_4 = utils.deprecatedWarning;
var utils_5 = utils.throttle;
var utils_6 = utils.mediaProperties;
var Media_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    children: _propTypes.default.any,
    startTime: _propTypes.default.number,
    loop: _propTypes.default.bool,
    muted: _propTypes.default.bool,
    autoPlay: _propTypes.default.bool,
    playsInline: _propTypes.default.bool,
    src: _propTypes.default.string,
    type: _propTypes.default.string,
    poster: _propTypes.default.string,
    className: _propTypes.default.string,
    preload: _propTypes.default.oneOf(['auto', 'metadata', 'none']),
    crossOrigin: _propTypes.default.string,
    onLoadStart: _propTypes.default.func,
    onWaiting: _propTypes.default.func,
    onCanPlay: _propTypes.default.func,
    onCanPlayThrough: _propTypes.default.func,
    onPlaying: _propTypes.default.func,
    onEnded: _propTypes.default.func,
    onSeeking: _propTypes.default.func,
    onSeeked: _propTypes.default.func,
    onPlay: _propTypes.default.func,
    onPause: _propTypes.default.func,
    onProgress: _propTypes.default.func,
    onDurationChange: _propTypes.default.func,
    onError: _propTypes.default.func,
    onSuspend: _propTypes.default.func,
    onAbort: _propTypes.default.func,
    onEmptied: _propTypes.default.func,
    onStalled: _propTypes.default.func,
    onLoadedMetadata: _propTypes.default.func,
    onLoadedData: _propTypes.default.func,
    onTimeUpdate: _propTypes.default.func,
    onRateChange: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    onResize: _propTypes.default.func
  };
  var Media = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Media, _Component);
    var _super = _createSuper(Media);
    function Media(props) {
      var _this;
      (0, _classCallCheck2.default)(this, Media);
      _this = _super.call(this, props);
      _this.video = null; // the html5 video

      _this.play = _this.play.bind((0, _assertThisInitialized2.default)(_this));
      _this.pause = _this.pause.bind((0, _assertThisInitialized2.default)(_this));
      _this.seek = _this.seek.bind((0, _assertThisInitialized2.default)(_this));
      _this.forward = _this.forward.bind((0, _assertThisInitialized2.default)(_this));
      _this.replay = _this.replay.bind((0, _assertThisInitialized2.default)(_this));
      _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2.default)(_this));
      _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2.default)(_this));
      _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2.default)(_this));
      _this.renderMedia = _this.renderMedia.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleError = _this.handleError.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleProgress = (0, utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2.default)(_this)), 250);
      _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(Media, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.forceUpdate(); // make sure the children can get the video property

        if (this.video && this.video.textTracks) {
          this.video.textTracks.onaddtrack = this.handleTextTrackChange;
          this.video.textTracks.onremovetrack = this.handleTextTrackChange;
        }
      } // get all video properties
    }, {
      key: "getProperties",
      value: function getProperties() {
        var _this2 = this;
        if (!this.video) {
          return null;
        }
        return utils.mediaProperties.reduce(function (properties, key) {
          properties[key] = _this2.video[key];
          return properties;
        }, {});
      } // get playback rate
    }, {
      key: "handleTextTrackChange",
      value: function handleTextTrackChange() {
        var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;
        if (this.video && this.video.textTracks) {
          var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
            return textTrack.mode === 'showing';
          });
          if (activeTextTrack !== player.activeTextTrack) {
            actions.activateTextTrack(activeTextTrack);
          }
        }
      } // play the video
    }, {
      key: "play",
      value: function play() {
        var promise = this.video.play();
        if (promise !== undefined) {
          promise.catch(function () {}).then(function () {});
        }
      } // pause the video
    }, {
      key: "pause",
      value: function pause() {
        var promise = this.video.pause();
        if (promise !== undefined) {
          promise.catch(function () {}).then(function () {});
        }
      } // Change the video source and re-load the video:
    }, {
      key: "load",
      value: function load() {
        this.video.load();
      } // Add a new text track to the video
    }, {
      key: "addTextTrack",
      value: function addTextTrack() {
        var _this$video;
        (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
      } // Check if your browser can play different types of video:
    }, {
      key: "canPlayType",
      value: function canPlayType() {
        var _this$video2;
        (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
      } // toggle play
    }, {
      key: "togglePlay",
      value: function togglePlay() {
        if (this.video.paused) {
          this.play();
        } else {
          this.pause();
        }
      } // seek video by time
    }, {
      key: "seek",
      value: function seek(time) {
        try {
          this.video.currentTime = time;
        } catch (e) {// console.log(e, 'Video is not ready.')
        }
      } // jump forward x seconds
    }, {
      key: "forward",
      value: function forward(seconds) {
        this.seek(this.video.currentTime + seconds);
      } // jump back x seconds
    }, {
      key: "replay",
      value: function replay(seconds) {
        this.forward(-seconds);
      } // enter or exist full screen
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
        actions.toggleFullscreen(player);
      } // Fired when the user agent
      // begins looking for media data
    }, {
      key: "handleLoadStart",
      value: function handleLoadStart() {
        var _this$props3 = this.props,
          actions = _this$props3.actions,
          onLoadStart = _this$props3.onLoadStart;
        actions.handleLoadStart(this.getProperties());
        if (onLoadStart) {
          onLoadStart.apply(void 0, arguments);
        }
      } // A handler for events that
      // signal that waiting has ended
    }, {
      key: "handleCanPlay",
      value: function handleCanPlay() {
        var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlay = _this$props4.onCanPlay;
        actions.handleCanPlay(this.getProperties());
        if (onCanPlay) {
          onCanPlay.apply(void 0, arguments);
        }
      } // A handler for events that
      // signal that waiting has ended
    }, {
      key: "handleCanPlayThrough",
      value: function handleCanPlayThrough() {
        var _this$props5 = this.props,
          actions = _this$props5.actions,
          onCanPlayThrough = _this$props5.onCanPlayThrough;
        actions.handleCanPlayThrough(this.getProperties());
        if (onCanPlayThrough) {
          onCanPlayThrough.apply(void 0, arguments);
        }
      } // A handler for events that
      // signal that waiting has ended
    }, {
      key: "handlePlaying",
      value: function handlePlaying() {
        var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlaying = _this$props6.onPlaying;
        actions.handlePlaying(this.getProperties());
        if (onPlaying) {
          onPlaying.apply(void 0, arguments);
        }
      } // Fired whenever the media has been started
    }, {
      key: "handlePlay",
      value: function handlePlay() {
        var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPlay = _this$props7.onPlay;
        actions.handlePlay(this.getProperties());
        if (onPlay) {
          onPlay.apply(void 0, arguments);
        }
      } // Fired whenever the media has been paused
    }, {
      key: "handlePause",
      value: function handlePause() {
        var _this$props8 = this.props,
          actions = _this$props8.actions,
          onPause = _this$props8.onPause;
        actions.handlePause(this.getProperties());
        if (onPause) {
          onPause.apply(void 0, arguments);
        }
      } // Fired when the duration of
      // the media resource is first known or changed
    }, {
      key: "handleDurationChange",
      value: function handleDurationChange() {
        var _this$props9 = this.props,
          actions = _this$props9.actions,
          onDurationChange = _this$props9.onDurationChange;
        actions.handleDurationChange(this.getProperties());
        if (onDurationChange) {
          onDurationChange.apply(void 0, arguments);
        }
      } // Fired while the user agent
      // is downloading media data
    }, {
      key: "handleProgress",
      value: function handleProgress() {
        var _this$props10 = this.props,
          actions = _this$props10.actions,
          onProgress = _this$props10.onProgress;
        if (this.video) {
          actions.handleProgressChange(this.getProperties());
        }
        if (onProgress) {
          onProgress.apply(void 0, arguments);
        }
      } // Fired when the end of the media resource
      // is reached (currentTime == duration)
    }, {
      key: "handleEnded",
      value: function handleEnded() {
        var _this$props11 = this.props,
          loop = _this$props11.loop,
          player = _this$props11.player,
          actions = _this$props11.actions,
          onEnded = _this$props11.onEnded;
        if (loop) {
          this.seek(0);
          this.play();
        } else if (!player.paused) {
          this.pause();
        }
        actions.handleEnd(this.getProperties());
        if (onEnded) {
          onEnded.apply(void 0, arguments);
        }
      } // Fired whenever the media begins waiting
    }, {
      key: "handleWaiting",
      value: function handleWaiting() {
        var _this$props12 = this.props,
          actions = _this$props12.actions,
          onWaiting = _this$props12.onWaiting;
        actions.handleWaiting(this.getProperties());
        if (onWaiting) {
          onWaiting.apply(void 0, arguments);
        }
      } // Fired whenever the player
      // is jumping to a new time
    }, {
      key: "handleSeeking",
      value: function handleSeeking() {
        var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeking = _this$props13.onSeeking;
        actions.handleSeeking(this.getProperties());
        if (onSeeking) {
          onSeeking.apply(void 0, arguments);
        }
      } // Fired when the player has
      // finished jumping to a new time
    }, {
      key: "handleSeeked",
      value: function handleSeeked() {
        var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSeeked = _this$props14.onSeeked;
        actions.handleSeeked(this.getProperties());
        if (onSeeked) {
          onSeeked.apply(void 0, arguments);
        }
      } // Handle Fullscreen Change
    }, {
      key: "handleFullscreenChange",
      value: function handleFullscreenChange() {} // Fires when the browser is
      // intentionally not getting media data
    }, {
      key: "handleSuspend",
      value: function handleSuspend() {
        var _this$props15 = this.props,
          actions = _this$props15.actions,
          onSuspend = _this$props15.onSuspend;
        actions.handleSuspend(this.getProperties());
        if (onSuspend) {
          onSuspend.apply(void 0, arguments);
        }
      } // Fires when the loading of an audio/video is aborted
    }, {
      key: "handleAbort",
      value: function handleAbort() {
        var _this$props16 = this.props,
          actions = _this$props16.actions,
          onAbort = _this$props16.onAbort;
        actions.handleAbort(this.getProperties());
        if (onAbort) {
          onAbort.apply(void 0, arguments);
        }
      } // Fires when the current playlist is empty
    }, {
      key: "handleEmptied",
      value: function handleEmptied() {
        var _this$props17 = this.props,
          actions = _this$props17.actions,
          onEmptied = _this$props17.onEmptied;
        actions.handleEmptied(this.getProperties());
        if (onEmptied) {
          onEmptied.apply(void 0, arguments);
        }
      } // Fires when the browser is trying to
      // get media data, but data is not available
    }, {
      key: "handleStalled",
      value: function handleStalled() {
        var _this$props18 = this.props,
          actions = _this$props18.actions,
          onStalled = _this$props18.onStalled;
        actions.handleStalled(this.getProperties());
        if (onStalled) {
          onStalled.apply(void 0, arguments);
        }
      } // Fires when the browser has loaded
      // meta data for the audio/video
    }, {
      key: "handleLoadedMetaData",
      value: function handleLoadedMetaData() {
        var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedMetadata = _this$props19.onLoadedMetadata,
          startTime = _this$props19.startTime;
        if (startTime && startTime > 0) {
          this.video.currentTime = startTime;
        }
        actions.handleLoadedMetaData(this.getProperties());
        if (onLoadedMetadata) {
          onLoadedMetadata.apply(void 0, arguments);
        }
      } // Fires when the browser has loaded
      // the current frame of the audio/video
    }, {
      key: "handleLoadedData",
      value: function handleLoadedData() {
        var _this$props20 = this.props,
          actions = _this$props20.actions,
          onLoadedData = _this$props20.onLoadedData;
        actions.handleLoadedData(this.getProperties());
        if (onLoadedData) {
          onLoadedData.apply(void 0, arguments);
        }
      } // Fires when the current
      // playback position has changed
    }, {
      key: "handleTimeUpdate",
      value: function handleTimeUpdate() {
        var _this$props21 = this.props,
          actions = _this$props21.actions,
          onTimeUpdate = _this$props21.onTimeUpdate;
        actions.handleTimeUpdate(this.getProperties());
        if (onTimeUpdate) {
          onTimeUpdate.apply(void 0, arguments);
        }
      }
      /**
       * Fires when the playing speed of the audio/video is changed
       */
    }, {
      key: "handleRateChange",
      value: function handleRateChange() {
        var _this$props22 = this.props,
          actions = _this$props22.actions,
          onRateChange = _this$props22.onRateChange;
        actions.handleRateChange(this.getProperties());
        if (onRateChange) {
          onRateChange.apply(void 0, arguments);
        }
      } // Fires when the volume has been changed
    }, {
      key: "handleVolumeChange",
      value: function handleVolumeChange() {
        var _this$props23 = this.props,
          actions = _this$props23.actions,
          onVolumeChange = _this$props23.onVolumeChange;
        actions.handleVolumeChange(this.getProperties());
        if (onVolumeChange) {
          onVolumeChange.apply(void 0, arguments);
        }
      } // Fires when an error occurred
      // during the loading of an audio/video
    }, {
      key: "handleError",
      value: function handleError() {
        var _this$props24 = this.props,
          actions = _this$props24.actions,
          onError = _this$props24.onError;
        actions.handleError(this.getProperties());
        if (onError) {
          onError.apply(void 0, arguments);
        }
      }
    }, {
      key: "handleResize",
      value: function handleResize() {
        var _this$props25 = this.props,
          actions = _this$props25.actions,
          onResize = _this$props25.onResize;
        actions.handleResize(this.getProperties());
        if (onResize) {
          onResize.apply(void 0, arguments);
        }
      }
    }, {
      key: "handleKeypress",
      value: function handleKeypress() {}
    }, {
      key: "renderChildren",
      value: function renderChildren() {
        var _this3 = this;
        var props = _objectSpread(_objectSpread({}, this.props), {}, {
          video: this.video
        }); // to make sure the children can get video property

        if (!this.video) {
          return null;
        } // only keep <source />, <track />, <MyComponent isVideoChild /> elements

        return _react.default.Children.toArray(this.props.children).filter(utils.isVideoChild).map(function (c) {
          var cprops;
          if (typeof c.type === 'string') {
            // add onError to <source />
            if (c.type === 'source') {
              cprops = _objectSpread({}, c.props);
              var preOnError = cprops.onError;
              cprops.onError = function () {
                if (preOnError) {
                  preOnError.apply(void 0, arguments);
                }
                _this3.handleError.apply(_this3, arguments);
              };
            }
          } else {
            cprops = props;
          }
          return /*#__PURE__*/_react.default.cloneElement(c, cprops);
        });
      }
    }, {
      key: "renderMedia",
      value: function renderMedia() {
        var _this4 = this;
        var _this$props26 = this.props,
          loop = _this$props26.loop,
          poster = _this$props26.poster,
          preload = _this$props26.preload,
          src = _this$props26.src,
          type = _this$props26.type,
          autoPlay = _this$props26.autoPlay,
          playsInline = _this$props26.playsInline,
          muted = _this$props26.muted,
          crossOrigin = _this$props26.crossOrigin,
          videoId = _this$props26.videoId;
        if (type === Player_1.MediaType.video) {
          return /*#__PURE__*/_react.default.createElement("video", {
            className: (0, _classnames.default)('video-react-video', this.props.className),
            id: videoId,
            crossOrigin: crossOrigin,
            ref: function ref(c) {
              _this4.video = c;
            },
            muted: muted,
            preload: preload,
            loop: loop,
            playsInline: playsInline,
            autoPlay: autoPlay,
            poster: poster,
            src: src,
            onLoadStart: this.handleLoadStart,
            onWaiting: this.handleWaiting,
            onCanPlay: this.handleCanPlay,
            onCanPlayThrough: this.handleCanPlayThrough,
            onPlaying: this.handlePlaying,
            onEnded: this.handleEnded,
            onSeeking: this.handleSeeking,
            onSeeked: this.handleSeeked,
            onPlay: this.handlePlay,
            onPause: this.handlePause,
            onProgress: this.handleProgress,
            onDurationChange: this.handleDurationChange,
            onError: this.handleError,
            onSuspend: this.handleSuspend,
            onAbort: this.handleAbort,
            onEmptied: this.handleEmptied,
            onStalled: this.handleStalled,
            onLoadedMetadata: this.handleLoadedMetaData,
            onLoadedData: this.handleLoadedData,
            onTimeUpdate: this.handleTimeUpdate,
            onRateChange: this.handleRateChange,
            onVolumeChange: this.handleVolumeChange,
            tabIndex: "-1"
          }, this.renderChildren());
        }
        return /*#__PURE__*/_react.default.createElement("audio", {
          className: (0, _classnames.default)('video-react-video', this.props.className),
          id: videoId,
          crossOrigin: crossOrigin,
          ref: function ref(c) {
            _this4.video = c;
          },
          muted: muted,
          preload: preload,
          loop: loop,
          playsInline: playsInline,
          autoPlay: autoPlay,
          src: src,
          onLoadStart: this.handleLoadStart,
          onWaiting: this.handleWaiting,
          onCanPlay: this.handleCanPlay,
          onCanPlayThrough: this.handleCanPlayThrough,
          onPlaying: this.handlePlaying,
          onEnded: this.handleEnded,
          onSeeking: this.handleSeeking,
          onSeeked: this.handleSeeked,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onProgress: this.handleProgress,
          onDurationChange: this.handleDurationChange,
          onError: this.handleError,
          onSuspend: this.handleSuspend,
          onAbort: this.handleAbort,
          onEmptied: this.handleEmptied,
          onStalled: this.handleStalled,
          onLoadedMetadata: this.handleLoadedMetaData,
          onLoadedData: this.handleLoadedData,
          onTimeUpdate: this.handleTimeUpdate,
          onRateChange: this.handleRateChange,
          onVolumeChange: this.handleVolumeChange,
          tabIndex: "-1"
        }, this.renderChildren());
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "video-react-video-container"
        }, this.renderMedia());
      }
    }, {
      key: "playbackRate",
      get: function get() {
        return this.video.playbackRate;
      } // set playback rate
      // speed of video
      ,

      set: function set(rate) {
        this.video.playbackRate = rate;
      }
    }, {
      key: "muted",
      get: function get() {
        return this.video.muted;
      },
      set: function set(val) {
        this.video.muted = val;
      }
    }, {
      key: "volume",
      get: function get() {
        return this.video.volume;
      },
      set: function set(val) {
        if (val > 1) {
          val = 1;
        }
        if (val < 0) {
          val = 0;
        }
        this.video.volume = val;
      } // video width
    }, {
      key: "videoWidth",
      get: function get() {
        return this.video.videoWidth;
      } // video height
    }, {
      key: "videoHeight",
      get: function get() {
        return this.video.videoHeight;
      }
    }]);
    return Media;
  }(_react.Component);
  exports.default = Media;
  Media.propTypes = propTypes;
  Media.displayName = 'Media';
});
unwrapExports(Media_1);
var Bezel_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    manager: _propTypes.default.object,
    className: _propTypes.default.string
  };
  var Bezel = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Bezel, _Component);
    var _super = _createSuper(Bezel);
    function Bezel(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, Bezel);
      _this = _super.call(this, props, context);
      _this.timer = null;
      props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2.default)(_this)));
      _this.state = {
        hidden: true,
        operation: {}
      };
      return _this;
    }
    (0, _createClass2.default)(Bezel, [{
      key: "handleStateChange",
      value: function handleStateChange(state, prevState) {
        var _this2 = this;
        if (state.count !== prevState.count && state.operation.source === 'shortcut') {
          if (this.timer) {
            // previous animation is not finished
            clearTimeout(this.timer); // cancel it

            this.timer = null;
          } // show it
          // update operation

          this.setState({
            hidden: false,
            count: state.count,
            operation: state.operation
          }); // hide it after 0.5s

          this.timer = setTimeout(function () {
            _this2.setState({
              hidden: true
            });
            _this2.timer = null;
          }, 500);
        }
      }
    }, {
      key: "render",
      value: function render() {
        // only displays for shortcut so far
        if (this.state.operation.source !== 'shortcut') {
          return null;
        }
        var style = this.state.hidden ? {
          display: 'none'
        } : null;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)({
            'video-react-bezel': true,
            'video-react-bezel-animation': this.state.count % 2 === 0,
            'video-react-bezel-animation-alt': this.state.count % 2 === 1
          }, this.props.className),
          style: style,
          role: "status",
          "aria-label": this.state.operation.action
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
        }));
      }
    }]);
    return Bezel;
  }(_react.Component);
  exports.default = Bezel;
  Bezel.propTypes = propTypes;
  Bezel.displayName = 'Bezel';
});
unwrapExports(Bezel_1);
var dom = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.findElPosition = findElPosition;
  exports.getPointerPosition = getPointerPosition;
  exports.blurNode = blurNode;
  exports.focusNode = focusNode;
  exports.hasClass = hasClass;
  /**
   * Offset Left
   * getBoundingClientRect technique from
   * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
   *
   * @function findElPosition
   * @param {ReactNodeRef} el React Node ref from which to get offset
   * @return {Object}
   */

  function findElPosition(el) {
    var box;
    if (el.getBoundingClientRect && el.parentNode) {
      box = el.getBoundingClientRect();
    }
    if (!box) {
      return {
        left: 0,
        top: 0
      };
    }
    var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var left = box.left + scrollLeft - clientLeft;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

    return {
      left: Math.round(left),
      top: Math.round(top)
    };
  }
  /**
   * Get pointer position in a React Node ref
   * Returns an object with x and y coordinates.
   * The base on the coordinates are the bottom left of the element.
   *
   * @function getPointerPosition
   * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
   * @param {Event} event Event object
   * @return {Object} This object will have x and y coordinates corresponding to the mouse position
   */

  function getPointerPosition(el, event) {
    var position = {};
    var box = findElPosition(el);
    var boxW = el.offsetWidth;
    var boxH = el.offsetHeight;
    var boxY = box.top;
    var boxX = box.left;
    var evtPageY = event.pageY;
    var evtPageX = event.pageX;
    if (event.changedTouches) {
      evtPageX = event.changedTouches[0].pageX;
      evtPageY = event.changedTouches[0].pageY;
    }
    position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
    position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
    return position;
  } // blur an element

  function blurNode(reactNode) {
    if (reactNode && reactNode.blur) {
      reactNode.blur();
    }
  } // focus an element

  function focusNode(reactNode) {
    if (reactNode && reactNode.focus) {
      reactNode.focus();
    }
  } // check if an element has a class name

  function hasClass(elm, cls) {
    var classes = elm.className.split(' ');
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].toLowerCase() === cls.toLowerCase()) {
        return true;
      }
    }
    return false;
  }
});
unwrapExports(dom);
var dom_1 = dom.findElPosition;
var dom_2 = dom.getPointerPosition;
var dom_3 = dom.blurNode;
var dom_4 = dom.focusNode;
var dom_5 = dom.hasClass;
var Shortcut_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _toConsumableArray2 = interopRequireDefault(toConsumableArray);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    clickable: _propTypes.default.bool,
    dblclickable: _propTypes.default.bool,
    manager: _propTypes.default.object,
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    shortcuts: _propTypes.default.array
  };
  var defaultProps = {
    clickable: true,
    dblclickable: true
  };
  var Shortcut = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Shortcut, _Component);
    var _super = _createSuper(Shortcut);
    function Shortcut(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, Shortcut);
      _this = _super.call(this, props, context);
      _this.defaultShortcuts = [{
        keyCode: 32,
        // spacebar
        handle: _this.togglePlay
      }, {
        keyCode: 75,
        // k
        handle: _this.togglePlay
      }, {
        keyCode: 70,
        // f
        handle: _this.toggleFullscreen
      }, {
        keyCode: 37,
        // Left arrow
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          }
          actions.replay(5, {
            action: 'replay-5',
            source: 'shortcut'
          }); // Go back 5 seconds
        }
      }, {
        keyCode: 74,
        // j
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          }
          actions.replay(10, {
            action: 'replay-10',
            source: 'shortcut'
          }); // Go back 10 seconds
        }
      }, {
        keyCode: 39,
        // Right arrow
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          }
          actions.forward(5, {
            action: 'forward-5',
            source: 'shortcut'
          }); // Go forward 5 seconds
        }
      }, {
        keyCode: 76,
        // l
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          }
          actions.forward(10, {
            action: 'forward-10',
            source: 'shortcut'
          }); // Go forward 10 seconds
        }
      }, {
        keyCode: 36,
        // Home
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          }
          actions.seek(0); // Go to beginning of video
        }
      }, {
        keyCode: 35,
        // End
        handle: function handle(player, actions) {
          if (!player.hasStarted) {
            return;
          } // Go to end of video

          actions.seek(player.duration);
        }
      }, {
        keyCode: 38,
        // Up arrow
        handle: function handle(player, actions) {
          // Increase volume 5%
          var v = player.volume + 0.05;
          if (v > 1) {
            v = 1;
          }
          actions.changeVolume(v, {
            action: 'volume-up',
            source: 'shortcut'
          });
        }
      }, {
        keyCode: 40,
        // Down arrow
        handle: function handle(player, actions) {
          // Decrease volume 5%
          var v = player.volume - 0.05;
          if (v < 0) {
            v = 0;
          }
          var action = v > 0 ? 'volume-down' : 'volume-off';
          actions.changeVolume(v, {
            action: action,
            source: 'shortcut'
          });
        }
      }, {
        keyCode: 190,
        // Shift + >
        shift: true,
        handle: function handle(player, actions) {
          // Increase speed
          var playbackRate = player.playbackRate;
          if (playbackRate >= 1.5) {
            playbackRate = 2;
          } else if (playbackRate >= 1.25) {
            playbackRate = 1.5;
          } else if (playbackRate >= 1.0) {
            playbackRate = 1.25;
          } else if (playbackRate >= 0.5) {
            playbackRate = 1.0;
          } else if (playbackRate >= 0.25) {
            playbackRate = 0.5;
          } else if (playbackRate >= 0) {
            playbackRate = 0.25;
          }
          actions.changeRate(playbackRate, {
            action: 'fast-forward',
            source: 'shortcut'
          });
        }
      }, {
        keyCode: 188,
        // Shift + <
        shift: true,
        handle: function handle(player, actions) {
          // Decrease speed
          var playbackRate = player.playbackRate;
          if (playbackRate <= 0.5) {
            playbackRate = 0.25;
          } else if (playbackRate <= 1.0) {
            playbackRate = 0.5;
          } else if (playbackRate <= 1.25) {
            playbackRate = 1.0;
          } else if (playbackRate <= 1.5) {
            playbackRate = 1.25;
          } else if (playbackRate <= 2) {
            playbackRate = 1.5;
          }
          actions.changeRate(playbackRate, {
            action: 'fast-rewind',
            source: 'shortcut'
          });
        }
      }];
      _this.shortcuts = (0, _toConsumableArray2.default)(_this.defaultShortcuts);
      _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(Shortcut, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.mergeShortcuts();
        document.addEventListener('keydown', this.handleKeyPress);
        document.addEventListener('click', this.handleClick);
        document.addEventListener('dblclick', this.handleDoubleClick);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.shortcuts !== this.props.shortcuts) {
          this.mergeShortcuts();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPress);
        document.removeEventListener('click', this.handleClick);
        document.removeEventListener('dblclick', this.handleDoubleClick);
      } // merge the shortcuts from props
    }, {
      key: "mergeShortcuts",
      value: function mergeShortcuts() {
        var getShortcutKey = function getShortcutKey(_ref) {
          var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
          return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
        };
        var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
          return Object.assign(shortcuts, (0, _defineProperty2.default)({}, getShortcutKey(shortcut), shortcut));
        }, {});
        var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
          var keyCode = shortcut.keyCode,
            handle = shortcut.handle;
          if (keyCode && typeof handle === 'function') {
            return Object.assign(shortcuts, (0, _defineProperty2.default)({}, getShortcutKey(shortcut), shortcut));
          }
          return shortcuts;
        }, defaultShortcuts);
        var gradeShortcut = function gradeShortcut(s) {
          var score = 0;
          var ps = ['ctrl', 'shift', 'alt'];
          ps.forEach(function (key) {
            if (s[key]) {
              score++;
            }
          });
          return score;
        };
        this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
          return mergedShortcuts[key];
        }).sort(function (a, b) {
          return gradeShortcut(b) - gradeShortcut(a);
        });
      }
    }, {
      key: "togglePlay",
      value: function togglePlay(player, actions) {
        if (player.paused) {
          actions.play({
            action: 'play',
            source: 'shortcut'
          });
        } else {
          actions.pause({
            action: 'pause',
            source: 'shortcut'
          });
        }
      }
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen(player, actions) {
        actions.toggleFullscreen(player);
      }
    }, {
      key: "handleKeyPress",
      value: function handleKeyPress(e) {
        var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
        if (!player.isActive) {
          return;
        }
        if (document.activeElement && ((0, dom.hasClass)(document.activeElement, 'video-react-control') || (0, dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
        || (0, dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
          return;
        }
        var keyCode = e.keyCode || e.which;
        var ctrl = e.ctrlKey || e.metaKey;
        var shift = e.shiftKey;
        var alt = e.altKey;
        var shortcut = this.shortcuts.filter(function (s) {
          if (!s.keyCode || s.keyCode - keyCode !== 0) {
            return false;
          }
          if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
            return false;
          }
          return true;
        })[0];
        if (shortcut) {
          shortcut.handle(player, actions);
          e.preventDefault();
        }
      } // only if player is active and player is ready
    }, {
      key: "canBeClicked",
      value: function canBeClicked(player, e) {
        if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
          return false;
        }
        return true;
      }
    }, {
      key: "handleClick",
      value: function handleClick(e) {
        var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;
        if (!this.canBeClicked(player, e) || !clickable) {
          return;
        }
        this.togglePlay(player, actions); // e.preventDefault();
      }
    }, {
      key: "handleDoubleClick",
      value: function handleDoubleClick(e) {
        var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;
        if (!this.canBeClicked(player, e) || !dblclickable) {
          return;
        }
        this.toggleFullscreen(player, actions); // e.preventDefault();
      } // this component dose not render anything
      // it's just for the key down event
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);
    return Shortcut;
  }(React__default.Component);
  exports.default = Shortcut;
  Shortcut.propTypes = propTypes;
  Shortcut.defaultProps = defaultProps;
  Shortcut.displayName = 'Shortcut';
});
unwrapExports(Shortcut_1);
var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  module.exports = _extends;
});
var Slider_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var Dom = interopRequireWildcard(dom);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    className: _propTypes.default.string,
    onMouseDown: _propTypes.default.func,
    onMouseMove: _propTypes.default.func,
    stepForward: _propTypes.default.func,
    stepBack: _propTypes.default.func,
    sliderActive: _propTypes.default.func,
    sliderInactive: _propTypes.default.func,
    onMouseUp: _propTypes.default.func,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    onClick: _propTypes.default.func,
    getPercent: _propTypes.default.func,
    vertical: _propTypes.default.bool,
    children: _propTypes.default.node,
    label: _propTypes.default.string,
    valuenow: _propTypes.default.string,
    valuetext: _propTypes.default.string,
    childrenToMerge: _propTypes.default.node
  };
  var Slider = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Slider, _Component);
    var _super = _createSuper(Slider);
    function Slider(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, Slider);
      _this = _super.call(this, props, context);
      _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2.default)(_this));
      _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2.default)(_this));
      _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2.default)(_this));
      _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        active: false
      };
      return _this;
    }
    (0, _createClass2.default)(Slider, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('mousemove', this.handleMouseMove, true);
        document.removeEventListener('mouseup', this.handleMouseUp, true);
        document.removeEventListener('touchmove', this.handleMouseMove, true);
        document.removeEventListener('touchend', this.handleMouseUp, true);
        document.removeEventListener('keydown', this.handleKeyPress, true);
      }
    }, {
      key: "getProgress",
      value: function getProgress() {
        var getPercent = this.props.getPercent;
        if (!getPercent) {
          return 0;
        }
        var progress = getPercent(); // Protect against no duration and other division issues

        if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
          progress = 0;
        }
        return progress;
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(event) {
        var onMouseDown = this.props.onMouseDown; // event.preventDefault();
        // event.stopPropagation();

        document.addEventListener('mousemove', this.handleMouseMove, true);
        document.addEventListener('mouseup', this.handleMouseUp, true);
        document.addEventListener('touchmove', this.handleMouseMove, true);
        document.addEventListener('touchend', this.handleMouseUp, true);
        this.setState({
          active: true
        });
        if (this.props.sliderActive) {
          this.props.sliderActive(event);
        }
        this.handleMouseMove(event);
        if (onMouseDown) {
          onMouseDown(event);
        }
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        var onMouseMove = this.props.onMouseMove;
        if (onMouseMove) {
          onMouseMove(event);
        }
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(event) {
        // On iOS safari, a subsequent mouseup event will be fired after touchend.
        // Its weird event positions make the player seek a wrong time.
        // calling preventDefault (at touchend phase) will prevent the mouseup event
        event.preventDefault();
        var onMouseUp = this.props.onMouseUp;
        document.removeEventListener('mousemove', this.handleMouseMove, true);
        document.removeEventListener('mouseup', this.handleMouseUp, true);
        document.removeEventListener('touchmove', this.handleMouseMove, true);
        document.removeEventListener('touchend', this.handleMouseUp, true);
        this.setState({
          active: false
        });
        if (this.props.sliderInactive) {
          this.props.sliderInactive(event);
        }
        if (onMouseUp) {
          onMouseUp(event);
        }
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(e) {
        document.addEventListener('keydown', this.handleKeyPress, true);
        if (this.props.onFocus) {
          this.props.onFocus(e);
        }
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        document.removeEventListener('keydown', this.handleKeyPress, true);
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }
      }
    }, {
      key: "handleClick",
      value: function handleClick(event) {
        event.preventDefault(); // event.stopPropagation();

        if (this.props.onClick) {
          this.props.onClick(event);
        }
      }
    }, {
      key: "handleKeyPress",
      value: function handleKeyPress(event) {
        if (event.which === 37 || event.which === 40) {
          // Left and Down Arrows
          event.preventDefault();
          event.stopPropagation();
          this.stepBack();
        } else if (event.which === 38 || event.which === 39) {
          // Up and Right Arrows
          event.preventDefault();
          event.stopPropagation();
          this.stepForward();
        }
      }
    }, {
      key: "stepForward",
      value: function stepForward() {
        if (this.props.stepForward) {
          this.props.stepForward();
        }
      }
    }, {
      key: "stepBack",
      value: function stepBack() {
        if (this.props.stepBack) {
          this.props.stepBack();
        }
      }
    }, {
      key: "calculateDistance",
      value: function calculateDistance(event) {
        var node = this.slider;
        var position = Dom.getPointerPosition(node, event);
        if (this.props.vertical) {
          return position.y;
        }
        return position.x;
      }
    }, {
      key: "renderChildren",
      value: function renderChildren() {
        var children = this.props.children;
        var childrenToRender;
        if (this.props.childrenToMerge) {
          var _this$props = this.props,
            className = _this$props.className,
            childrenToMerge = _this$props.childrenToMerge,
            parentProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "childrenToMerge"]);
          childrenToRender = (0, utils.mergeAndSortChildren)(children, childrenToMerge, parentProps);
        } else {
          childrenToRender = children;
        }
        var progress = this.getProgress();
        var percentage = "".concat((progress * 100).toFixed(2), "%");
        return _react.default.Children.map(childrenToRender, function (child) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            progress: progress,
            percentage: percentage
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          label = _this$props2.label,
          valuenow = _this$props2.valuenow,
          valuetext = _this$props2.valuetext;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(this.props.className, {
            'video-react-slider-vertical': vertical,
            'video-react-slider-horizontal': !vertical,
            'video-react-sliding': this.state.active
          }, 'video-react-slider'),
          ref: function ref(c) {
            _this2.slider = c;
          },
          tabIndex: "0",
          role: "slider",
          onMouseDown: this.handleMouseDown,
          onTouchStart: this.handleMouseDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          "aria-label": label || '',
          "aria-valuenow": valuenow || '',
          "aria-valuetext": valuetext || '',
          "aria-valuemin": 0,
          "aria-valuemax": 100
        }, this.renderChildren());
      }
    }]);
    return Slider;
  }(_react.Component);
  exports.default = Slider;
  Slider.propTypes = propTypes;
  Slider.displayName = 'Slider';
});
unwrapExports(Slider_1);
var PlayProgressBar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PlayProgressBar;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    currentTime: _propTypes.default.number,
    duration: _propTypes.default.number,
    percentage: _propTypes.default.string,
    className: _propTypes.default.string
  }; // Shows play progress

  function PlayProgressBar(_ref) {
    var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-current-time": (0, utils.formatTime)(currentTime, duration),
      className: (0, _classnames.default)('video-react-play-progress video-react-slider-bar', className),
      style: {
        width: percentage
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Progress: ".concat(percentage)));
  }
  PlayProgressBar.propTypes = propTypes;
  PlayProgressBar.displayName = 'PlayProgressBar';
});
unwrapExports(PlayProgressBar_1);
var LoadProgressBar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = LoadProgressBar;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    duration: _propTypes.default.number,
    buffered: _propTypes.default.object,
    className: _propTypes.default.string
  }; // Shows load progress

  function LoadProgressBar(_ref) {
    var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;
    if (!buffered || !buffered.length) {
      return null;
    }
    var bufferedEnd = buffered.end(buffered.length - 1);
    var style = {};
    if (bufferedEnd > duration) {
      bufferedEnd = duration;
    } // get the percent width of a time compared to the total end

    function percentify(time, end) {
      var percent = time / end || 0; // no NaN

      return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
    } // the width of the progress bar

    style.width = percentify(bufferedEnd, duration);
    var parts = []; // add child elements to represent the individual buffered time ranges

    for (var i = 0; i < buffered.length; i++) {
      var start = buffered.start(i);
      var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

      var part = /*#__PURE__*/_react.default.createElement("div", {
        style: {
          left: percentify(start, bufferedEnd),
          width: percentify(end - start, bufferedEnd)
        },
        key: "part-".concat(i)
      });
      parts.push(part);
    }
    if (parts.length === 0) {
      parts = null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      style: style,
      className: (0, _classnames.default)('video-react-load-progress', className)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Loaded: 0%"), parts);
  }
  LoadProgressBar.propTypes = propTypes;
  LoadProgressBar.displayName = 'LoadProgressBar';
});
unwrapExports(LoadProgressBar_1);
var MouseTimeDisplay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function MouseTimeDisplay(_ref) {
    var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;
    if (!mouseTime.time) {
      return null;
    }
    var time = text || (0, utils.formatTime)(mouseTime.time, duration);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-mouse-display', className),
      style: {
        left: "".concat(mouseTime.position, "px")
      },
      "data-current-time": time
    });
  }
  MouseTimeDisplay.propTypes = {
    duration: _propTypes.default.number,
    mouseTime: _propTypes.default.object,
    className: _propTypes.default.string
  };
  MouseTimeDisplay.displayName = 'MouseTimeDisplay';
  var _default = MouseTimeDisplay;
  exports.default = _default;
});
unwrapExports(MouseTimeDisplay_1);
var SeekBar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _Slider = interopRequireDefault(Slider_1);
  var _PlayProgressBar = interopRequireDefault(PlayProgressBar_1);
  var _LoadProgressBar = interopRequireDefault(LoadProgressBar_1);
  var _MouseTimeDisplay = interopRequireDefault(MouseTimeDisplay_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    children: _propTypes.default.node,
    player: _propTypes.default.object,
    mouseTime: _propTypes.default.object,
    actions: _propTypes.default.object,
    className: _propTypes.default.string
  };
  var SeekBar = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(SeekBar, _Component);
    var _super = _createSuper(SeekBar);
    function SeekBar(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, SeekBar);
      _this = _super.call(this, props, context);
      _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2.default)(_this));
      _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(SeekBar, [{
      key: "componentDidMount",
      value: function componentDidMount() {}
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {}
      /**
       * Get percentage of video played
       *
       * @return {Number} Percentage played
       * @method getPercent
       */
    }, {
      key: "getPercent",
      value: function getPercent() {
        var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
        var time = seekingTime || currentTime;
        var percent = time / duration;
        return percent >= 1 ? 1 : percent;
      }
    }, {
      key: "getNewTime",
      value: function getNewTime(event) {
        var duration = this.props.player.duration;
        var distance = this.slider.calculateDistance(event);
        var newTime = distance * duration; // Don't let video end while scrubbing.

        return newTime === duration ? newTime - 0.1 : newTime;
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown() {}
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(event) {
        var actions = this.props.actions;
        var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

        actions.seek(newTime);
        actions.handleEndSeeking(newTime);
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        var actions = this.props.actions;
        var newTime = this.getNewTime(event);
        actions.handleSeekingTime(newTime);
      }
    }, {
      key: "stepForward",
      value: function stepForward() {
        var actions = this.props.actions;
        actions.forward(5);
      }
    }, {
      key: "stepBack",
      value: function stepBack() {
        var actions = this.props.actions;
        actions.replay(5);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          children = _this$props.children,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime,
          type = _this$props.type;
        var time = seekingTime || currentTime;
        var renderGrandchildren = children && children.props && children.props.children;
        var childrenToMerge = renderGrandchildren ? children.props.children : [];
        var label = "".concat(type, " progress bar");
        return /*#__PURE__*/_react.default.createElement(_Slider.default, {
          ref: function ref(input) {
            _this2.slider = input;
          },
          label: label,
          className: (0, _classnames.default)('video-react-progress-holder', this.props.className),
          valuenow: (this.getPercent() * 100).toFixed(2),
          valuetext: (0, utils.formatTime)(time, duration),
          onMouseDown: this.handleMouseDown,
          onMouseMove: this.handleMouseMove,
          onMouseUp: this.handleMouseUp,
          getPercent: this.getPercent,
          stepForward: this.stepForward,
          stepBack: this.stepBack,
          childrenToMerge: childrenToMerge
        }, /*#__PURE__*/_react.default.createElement(_LoadProgressBar.default, {
          buffered: buffered,
          currentTime: time,
          duration: duration
        }), /*#__PURE__*/_react.default.createElement(_MouseTimeDisplay.default, {
          duration: duration,
          mouseTime: mouseTime
        }), /*#__PURE__*/_react.default.createElement(_PlayProgressBar.default, {
          currentTime: time,
          duration: duration
        }));
      }
    }]);
    return SeekBar;
  }(_react.Component);
  exports.default = SeekBar;
  SeekBar.propTypes = propTypes;
  SeekBar.displayName = 'SeekBar';
});
unwrapExports(SeekBar_1);
var ProgressControl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _extends2 = interopRequireDefault(_extends_1);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var Dom = interopRequireWildcard(dom);
  var _SeekBar = interopRequireDefault(SeekBar_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    children: _propTypes.default.node,
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  var ProgressControl = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ProgressControl, _Component);
    var _super = _createSuper(ProgressControl);
    function ProgressControl(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, ProgressControl);
      _this = _super.call(this, props, context);
      _this.state = {
        mouseTime: {
          time: null,
          position: 0
        }
      };
      _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(ProgressControl, [{
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        if (!event.pageX) {
          return;
        }
        var duration = this.props.player.duration;
        var node = this.seekBar;
        var newTime = Dom.getPointerPosition(node, event).x * duration;
        var position = event.pageX - Dom.findElPosition(node).left;
        this.setState({
          mouseTime: {
            time: newTime,
            position: position
          }
        });
      }
    }, {
      key: "getDefaultChildren",
      value: function getDefaultChildren() {
        var _this2 = this;
        return [/*#__PURE__*/_react.default.createElement(_SeekBar.default, (0, _extends2.default)({
          mouseTime: this.state.mouseTime,
          ref: function ref(c) {
            _this2.seekBar = c;
          }
        }, this.props))];
      }
    }, {
      key: "getChildren",
      value: function getChildren() {
        var children = _react.default.Children.toArray(this.props.children);
        var defaultChildren = this.getDefaultChildren();
        var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2.default)(_this$props, ["className"]); // remove className

        return (0, utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
      }
    }, {
      key: "render",
      value: function render() {
        var className = this.props.className;
        var children = this.getChildren();
        return /*#__PURE__*/_react.default.createElement("div", {
          onMouseMove: this.handleMouseMoveThrottle,
          className: (0, _classnames.default)('video-react-progress-control video-react-control', className)
        }, children);
      }
    }]);
    return ProgressControl;
  }(_react.Component);
  exports.default = ProgressControl;
  ProgressControl.propTypes = propTypes;
  ProgressControl.displayName = 'ProgressControl';
});
unwrapExports(ProgressControl_1);
var PlayToggle_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  var PlayToggle = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(PlayToggle, _Component);
    var _super = _createSuper(PlayToggle);
    function PlayToggle(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, PlayToggle);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(PlayToggle, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;
        if (player.paused) {
          actions.play();
        } else {
          actions.pause();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
        var controlText = player.paused ? "Play" : "Pause";
        return /*#__PURE__*/_react.default.createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: (0, _classnames.default)(className, {
            'video-react-play-control': true,
            'video-react-control': true,
            'video-react-button': true,
            'video-react-paused': player.paused,
            'video-react-playing': !player.paused
          }),
          type: "button",
          tabIndex: "0",
          onClick: this.handleClick
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "video-react-control-text"
        }, controlText));
      }
    }]);
    return PlayToggle;
  }(_react.Component);
  exports.default = PlayToggle;
  PlayToggle.propTypes = propTypes;
  PlayToggle.displayName = 'PlayToggle';
});
unwrapExports(PlayToggle_1);
var ForwardReplayControl = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    className: _propTypes.default.string,
    seconds: _propTypes.default.oneOf([5, 10, 15, 30])
  };
  var defaultProps = {
    seconds: 15
  };
  var _default = function _default(mode) {
    var ForwardReplayControl = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(ForwardReplayControl, _Component);
      var _super = _createSuper(ForwardReplayControl);
      function ForwardReplayControl(props, context) {
        var _this;
        (0, _classCallCheck2.default)(this, ForwardReplayControl);
        _this = _super.call(this, props, context);
        _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
        return _this;
      }
      (0, _createClass2.default)(ForwardReplayControl, [{
        key: "handleClick",
        value: function handleClick() {
          var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

          if (mode === 'forward') {
            actions.forward(seconds);
          } else {
            actions.replay(seconds);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
          var modeName = mode === 'replay' ? 'rewind' : mode;
          var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
          classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));
          if (className) {
            classNames.push(className);
          }
          return /*#__PURE__*/_react.default.createElement("button", {
            ref: function ref(c) {
              _this2.button = c;
            },
            className: classNames.join(' '),
            type: "button",
            onClick: this.handleClick
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "video-react-control-text"
          }, "".concat(modeName, " ").concat(seconds, " seconds")));
        }
      }]);
      return ForwardReplayControl;
    }(_react.Component);
    ForwardReplayControl.propTypes = propTypes;
    ForwardReplayControl.defaultProps = defaultProps;
    return ForwardReplayControl;
  };
  exports.default = _default;
});
unwrapExports(ForwardReplayControl);
var ForwardControl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _ForwardReplayControl = interopRequireDefault(ForwardReplayControl); // Pass mode into parent function

  var ForwardControl = (0, _ForwardReplayControl.default)('forward');
  ForwardControl.displayName = 'ForwardControl';
  var _default = ForwardControl;
  exports.default = _default;
});
unwrapExports(ForwardControl_1);
var ReplayControl_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _ForwardReplayControl = interopRequireDefault(ForwardReplayControl); // Pass mode into parent function

  var ReplayControl = (0, _ForwardReplayControl.default)('replay');
  ReplayControl.displayName = 'ReplayControl';
  var _default = ReplayControl;
  exports.default = _default;
});
unwrapExports(ReplayControl_1);
var FullscreenToggle_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  var FullscreenToggle = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(FullscreenToggle, _Component);
    var _super = _createSuper(FullscreenToggle);
    function FullscreenToggle(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, FullscreenToggle);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(FullscreenToggle, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
        actions.toggleFullscreen(player);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
        var controlText = !player.isFullscreen ? 'Full Screen' : 'Exit Full Screen';
        return /*#__PURE__*/_react.default.createElement("button", {
          className: (0, _classnames.default)(className, {
            'video-react-icon-fullscreen-exit': player.isFullscreen,
            'video-react-icon-fullscreen': !player.isFullscreen
          }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
          ref: function ref(c) {
            _this2.button = c;
          },
          type: "button",
          tabIndex: "0",
          onClick: this.handleClick
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "video-react-control-text"
        }, controlText));
      }
    }]);
    return FullscreenToggle;
  }(_react.Component);
  exports.default = FullscreenToggle;
  FullscreenToggle.propTypes = propTypes;
  FullscreenToggle.displayName = 'FullscreenToggle';
});
unwrapExports(FullscreenToggle_1);
var RemainingTimeDisplay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  function RemainingTimeDisplay(_ref) {
    var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
    var remainingTime = duration - currentTime;
    var formattedTime = (0, utils.formatTime)(remainingTime);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-remaining-time video-react-time-control video-react-control', className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-react-remaining-time-display",
      "aria-live": "off"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Remaining Time "), "-".concat(formattedTime)));
  }
  RemainingTimeDisplay.propTypes = propTypes;
  RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
  var _default = RemainingTimeDisplay;
  exports.default = _default;
});
unwrapExports(RemainingTimeDisplay_1);
var CurrentTimeDisplay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  function CurrentTimeDisplay(_ref) {
    var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
    var formattedTime = (0, utils.formatTime)(currentTime, duration);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-current-time video-react-time-control video-react-control', className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-react-current-time-display",
      "aria-live": "off"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Current Time "), formattedTime));
  }
  CurrentTimeDisplay.propTypes = propTypes;
  CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
  var _default = CurrentTimeDisplay;
  exports.default = _default;
});
unwrapExports(CurrentTimeDisplay_1);
var DurationDisplay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    player: _propTypes.default.object,
    className: _propTypes.default.string
  };
  function DurationDisplay(_ref) {
    var duration = _ref.player.duration,
      className = _ref.className;
    var formattedTime = (0, utils.formatTime)(duration);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(className, 'video-react-duration video-react-time-control video-react-control')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "video-react-duration-display",
      "aria-live": "off"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Duration Time "), formattedTime));
  }
  DurationDisplay.propTypes = propTypes;
  DurationDisplay.displayName = 'DurationDisplay';
  var _default = DurationDisplay;
  exports.default = _default;
});
unwrapExports(DurationDisplay_1);
var TimeDivider_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = TimeDivider;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    separator: _propTypes.default.string,
    className: _propTypes.default.string
  };
  function TimeDivider(_ref) {
    var separator = _ref.separator,
      className = _ref.className;
    var separatorText = separator || '/';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('video-react-time-control video-react-time-divider', className),
      dir: "ltr"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, separatorText)));
  }
  TimeDivider.propTypes = propTypes;
  TimeDivider.displayName = 'TimeDivider';
});
unwrapExports(TimeDivider_1);
var ClickableComponent_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    tagName: _propTypes.default.string,
    onClick: _propTypes.default.func.isRequired,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    className: _propTypes.default.string
  };
  var defaultProps = {
    tagName: 'div'
  };
  var ClickableComponent = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ClickableComponent, _Component);
    var _super = _createSuper(ClickableComponent);
    function ClickableComponent(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, ClickableComponent);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(ClickableComponent, [{
      key: "handleKeypress",
      value: function handleKeypress(event) {
        // Support Space (32) or Enter (13) key operation to fire a click event
        if (event.which === 32 || event.which === 13) {
          event.preventDefault();
          this.handleClick(event);
        }
      }
    }, {
      key: "handleClick",
      value: function handleClick(event) {
        var onClick = this.props.onClick;
        onClick(event);
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(e) {
        document.addEventListener('keydown', this.handleKeypress);
        if (this.props.onFocus) {
          this.props.onFocus(e);
        }
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        document.removeEventListener('keydown', this.handleKeypress);
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var Tag = this.props.tagName;
        var props = _objectSpread({}, this.props);
        delete props.tagName;
        delete props.className;
        return /*#__PURE__*/_react.default.createElement(Tag, (0, _extends2.default)({
          className: (0, _classnames.default)(this.props.className),
          role: "button",
          tabIndex: "0",
          onClick: this.handleClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, props));
      }
    }]);
    return ClickableComponent;
  }(_react.Component);
  exports.default = ClickableComponent;
  ClickableComponent.propTypes = propTypes;
  ClickableComponent.defaultProps = defaultProps;
  ClickableComponent.displayName = 'ClickableComponent';
});
unwrapExports(ClickableComponent_1);
var Popup_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    player: _propTypes.default.object,
    children: _propTypes.default.any
  };
  var Popup = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Popup, _Component);
    var _super = _createSuper(Popup);
    function Popup(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, Popup);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(Popup, [{
      key: "handleClick",
      value: function handleClick(event) {
        event.preventDefault(); // event.stopPropagation();
      }
    }, {
      key: "render",
      value: function render() {
        var children = this.props.children;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "video-react-menu",
          onClick: this.handleClick
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-react-menu-content"
        }, children));
      }
    }]);
    return Popup;
  }(_react.Component);
  exports.default = Popup;
  Popup.propTypes = propTypes;
  Popup.displayName = 'Popup';
});
unwrapExports(Popup_1);
var PopupButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = PopupButton;
  var _extends2 = interopRequireDefault(_extends_1);
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _ClickableComponent = interopRequireDefault(ClickableComponent_1);
  var _Popup = interopRequireDefault(Popup_1);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  var propTypes = {
    inline: _propTypes.default.bool,
    onClick: _propTypes.default.func.isRequired,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    className: _propTypes.default.string
  };
  var defaultProps = {
    inline: true
  };
  function PopupButton(props) {
    var inline = props.inline,
      className = props.className;
    var ps = _objectSpread({}, props);
    delete ps.children;
    delete ps.inline;
    delete ps.className;
    return /*#__PURE__*/_react.default.createElement(_ClickableComponent.default, (0, _extends2.default)({
      className: (0, _classnames.default)(className, {
        'video-react-menu-button-inline': !!inline,
        'video-react-menu-button-popup': !inline
      }, 'video-react-control video-react-button video-react-menu-button')
    }, ps), /*#__PURE__*/_react.default.createElement(_Popup.default, props));
  }
  PopupButton.propTypes = propTypes;
  PopupButton.defaultProps = defaultProps;
  PopupButton.displayName = 'PopupButton';
});
unwrapExports(PopupButton_1);
var VolumeLevel_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    percentage: _propTypes.default.string,
    vertical: _propTypes.default.bool,
    className: _propTypes.default.string
  };
  var defaultProps = {
    percentage: '100%',
    vertical: false
  };
  function VolumeLevel(_ref) {
    var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
    var style = {};
    if (vertical) {
      style.height = percentage;
    } else {
      style.width = percentage;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(className, 'video-react-volume-level'),
      style: style
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }));
  }
  VolumeLevel.propTypes = propTypes;
  VolumeLevel.defaultProps = defaultProps;
  VolumeLevel.displayName = 'VolumeLevel';
  var _default = VolumeLevel;
  exports.default = _default;
});
unwrapExports(VolumeLevel_1);
var VolumeBar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _Slider = interopRequireDefault(Slider_1);
  var _VolumeLevel = interopRequireDefault(VolumeLevel_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    className: _propTypes.default.string,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func
  };
  var VolumeBar = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(VolumeBar, _Component);
    var _super = _createSuper(VolumeBar);
    function VolumeBar(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, VolumeBar);
      _this = _super.call(this, props, context);
      _this.state = {
        percentage: '0%'
      };
      _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this));
      _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2.default)(_this));
      _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2.default)(_this));
      _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(VolumeBar, [{
      key: "componentDidMount",
      value: function componentDidMount() {}
    }, {
      key: "getPercent",
      value: function getPercent() {
        var player = this.props.player;
        if (player.muted) {
          return 0;
        }
        return player.volume;
      }
    }, {
      key: "checkMuted",
      value: function checkMuted() {
        var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
        if (player.muted) {
          actions.mute(false);
        }
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        var actions = this.props.actions;
        this.checkMuted();
        var distance = this.slider.calculateDistance(event);
        actions.changeVolume(distance);
      }
    }, {
      key: "stepForward",
      value: function stepForward() {
        var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
        this.checkMuted();
        actions.changeVolume(player.volume + 0.1);
      }
    }, {
      key: "stepBack",
      value: function stepBack() {
        var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
        this.checkMuted();
        actions.changeVolume(player.volume - 0.1);
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(e) {
        if (this.props.onFocus) {
          this.props.onFocus(e);
        }
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        if (this.props.onBlur) {
          this.props.onBlur(e);
        }
      }
    }, {
      key: "handlePercentageChange",
      value: function handlePercentageChange(percentage) {
        if (percentage !== this.state.percentage) {
          this.setState({
            percentage: percentage
          });
        }
      }
    }, {
      key: "handleClick",
      value: function handleClick(event) {
        event.stopPropagation();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props4 = this.props,
          className = _this$props4.className,
          parentProps = (0, _objectWithoutProperties2.default)(_this$props4, ["className"]); // remove className

        var player = this.props.player;
        var volume = (player.volume * 100).toFixed(2);
        return /*#__PURE__*/_react.default.createElement(_Slider.default, (0, _extends2.default)({
          ref: function ref(c) {
            _this2.slider = c;
          },
          label: "volume level",
          valuenow: volume,
          valuetext: "".concat(volume, "%"),
          onMouseMove: this.handleMouseMove,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          sliderActive: this.handleFocus,
          sliderInactive: this.handleBlur,
          getPercent: this.getPercent,
          onPercentageChange: this.handlePercentageChange,
          stepForward: this.stepForward,
          stepBack: this.stepBack
        }, this.props, {
          className: (0, _classnames.default)(className, 'video-react-volume-bar video-react-slider-bar')
        }), /*#__PURE__*/_react.default.createElement(_VolumeLevel.default, parentProps));
      }
    }]);
    return VolumeBar;
  }(_react.Component);
  VolumeBar.propTypes = propTypes;
  VolumeBar.displayName = 'VolumeBar';
  var _default = VolumeBar;
  exports.default = _default;
});
unwrapExports(VolumeBar_1);
var VolumeMenuButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _extends2 = interopRequireDefault(_extends_1);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _PopupButton = interopRequireDefault(PopupButton_1);
  var _VolumeBar = interopRequireDefault(VolumeBar_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    player: _propTypes.default.object,
    actions: _propTypes.default.object,
    vertical: _propTypes.default.bool,
    className: _propTypes.default.string,
    alwaysShowVolume: _propTypes.default.bool,
    children: _propTypes.default.node
  };
  var defaultProps = {
    vertical: false
  };
  var VolumeMenuButton = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(VolumeMenuButton, _Component);
    var _super = _createSuper(VolumeMenuButton);
    function VolumeMenuButton(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, VolumeMenuButton);
      _this = _super.call(this, props, context);
      _this.state = {
        active: false
      };
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(VolumeMenuButton, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
        actions.mute(!player.muted);
      }
    }, {
      key: "handleFocus",
      value: function handleFocus() {
        this.setState({
          active: true
        });
      }
    }, {
      key: "handleBlur",
      value: function handleBlur() {
        this.setState({
          active: false
        });
      }
    }, {
      key: "getDefaultChildren",
      value: function getDefaultChildren() {
        return [/*#__PURE__*/_react.default.createElement(_VolumeBar.default, (0, _extends2.default)({
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, this.props))];
      }
    }, {
      key: "getChildren",
      value: function getChildren() {
        var children = _react.default.Children.toArray(this.props.children);
        var defaultChildren = this.getDefaultChildren();
        var _this$props2 = this.props,
          className = _this$props2.className,
          parentProps = (0, _objectWithoutProperties2.default)(_this$props2, ["className"]); // remove className

        return (0, utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          vertical = _this$props3.vertical,
          player = _this$props3.player,
          className = _this$props3.className;
        var inline = !vertical;
        var level = this.volumeLevel;
        var children = this.getChildren();
        return /*#__PURE__*/_react.default.createElement(_PopupButton.default, {
          className: (0, _classnames.default)(className, {
            'video-react-volume-menu-button-vertical': vertical,
            'video-react-volume-menu-button-horizontal': !vertical,
            'video-react-vol-muted': player.muted,
            'video-react-vol-0': level === 0 && !player.muted,
            'video-react-vol-1': level === 1,
            'video-react-vol-2': level === 2,
            'video-react-vol-3': level === 3,
            'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
            'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
          }, 'video-react-volume-menu-button'),
          onClick: this.handleClick,
          inline: inline
        }, children);
      }
    }, {
      key: "volumeLevel",
      get: function get() {
        var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
        var level = 3;
        if (volume === 0 || muted) {
          level = 0;
        } else if (volume < 0.33) {
          level = 1;
        } else if (volume < 0.67) {
          level = 2;
        }
        return level;
      }
    }]);
    return VolumeMenuButton;
  }(_react.Component);
  VolumeMenuButton.propTypes = propTypes;
  VolumeMenuButton.defaultProps = defaultProps;
  VolumeMenuButton.displayName = 'VolumeMenuButton';
  var _default = VolumeMenuButton;
  exports.default = _default;
});
unwrapExports(VolumeMenuButton_1);
var Menu_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    children: _propTypes.default.any
  };
  var Menu = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Menu, _Component);
    var _super = _createSuper(Menu);
    function Menu(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, Menu);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(Menu, [{
      key: "handleClick",
      value: function handleClick(event) {
        event.preventDefault(); // event.stopPropagation();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "video-react-menu video-react-lock-showing",
          role: "presentation",
          onClick: this.handleClick
        }, this.props.children);
      }
    }]);
    return Menu;
  }(_react.Component);
  exports.default = Menu;
  Menu.propTypes = propTypes;
  Menu.displayName = 'Menu';
});
unwrapExports(Menu_1);
var MenuItem_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    label: _propTypes.default.string,
    index: _propTypes.default.number,
    activateIndex: _propTypes.default.number,
    onSelectItem: _propTypes.default.func
  };
  var MenuItem = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(MenuItem, _Component);
    var _super = _createSuper(MenuItem);
    function MenuItem(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, MenuItem);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(MenuItem, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
        onSelectItem(index);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          label = _this$props2.label,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-menu-item'),
          role: "menuitem",
          onClick: this.handleClick,
          tabIndex: "0"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)({
            'video-react-menu-item-radio': true,
            'video-react-menu-item-radio-selected': index === activateIndex
          })
        }), /*#__PURE__*/_react.default.createElement("p", null, label));
      }
    }]);
    return MenuItem;
  }(_react.Component);
  exports.default = MenuItem;
  MenuItem.propTypes = propTypes;
  MenuItem.displayName = 'MenuItem';
});
unwrapExports(MenuItem_1);
var MenuButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _Menu = interopRequireDefault(Menu_1);
  var _MenuItem = interopRequireDefault(MenuItem_1);
  var _ClickableComponent = interopRequireDefault(ClickableComponent_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    inline: _propTypes.default.bool,
    items: _propTypes.default.array,
    className: _propTypes.default.string,
    onSelectItem: _propTypes.default.func,
    children: _propTypes.default.any,
    selectedIndex: _propTypes.default.number
  };
  var MenuButton = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(MenuButton, _Component);
    var _super = _createSuper(MenuButton);
    function MenuButton(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, MenuButton);
      _this = _super.call(this, props, context);
      _this.state = {
        active: false,
        activateIndex: props.selectedIndex || 0
      };
      _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2.default)(_this));
      _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(MenuButton, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.selectedIndex !== this.props.selectedIndex) {
          this.activateMenuItem(this.props.selectedIndex);
        }
      }
    }, {
      key: "commitSelection",
      value: function commitSelection(index) {
        this.setState({
          activateIndex: index
        });
        this.handleIndexChange(index);
      }
    }, {
      key: "activateMenuItem",
      value: function activateMenuItem(index) {
        this.setState({
          activateIndex: index
        });
        this.handleIndexChange(index);
      }
    }, {
      key: "handleIndexChange",
      value: function handleIndexChange(index) {
        var onSelectItem = this.props.onSelectItem;
        onSelectItem(index);
      }
    }, {
      key: "handleClick",
      value: function handleClick() {
        this.setState(function (prevState) {
          return {
            active: !prevState.active
          };
        });
      }
    }, {
      key: "handleFocus",
      value: function handleFocus() {
        document.addEventListener('keydown', this.handleKeyPress);
      }
    }, {
      key: "handleBlur",
      value: function handleBlur() {
        this.setState({
          active: false
        });
        document.removeEventListener('keydown', this.handleKeyPress);
      }
    }, {
      key: "handleUpArrow",
      value: function handleUpArrow(e) {
        var items = this.props.items;
        if (this.state.active) {
          e.preventDefault();
          var newIndex = this.state.activateIndex - 1;
          if (newIndex < 0) {
            newIndex = items.length ? items.length - 1 : 0;
          }
          this.activateMenuItem(newIndex);
        }
      }
    }, {
      key: "handleDownArrow",
      value: function handleDownArrow(e) {
        var items = this.props.items;
        if (this.state.active) {
          e.preventDefault();
          var newIndex = this.state.activateIndex + 1;
          if (newIndex >= items.length) {
            newIndex = 0;
          }
          this.activateMenuItem(newIndex);
        }
      }
    }, {
      key: "handleTab",
      value: function handleTab(e) {
        if (this.state.active) {
          e.preventDefault();
          this.commitSelection(this.state.activateIndex);
        }
      }
    }, {
      key: "handleReturn",
      value: function handleReturn(e) {
        e.preventDefault();
        if (this.state.active) {
          this.commitSelection(this.state.activateIndex);
        } else {
          this.setState({
            active: true
          });
        }
      }
    }, {
      key: "handleEscape",
      value: function handleEscape() {
        this.setState({
          active: false,
          activateIndex: 0
        });
      }
    }, {
      key: "handleKeyPress",
      value: function handleKeyPress(event) {
        // Escape (27) key
        if (event.which === 27) {
          this.handleEscape(event);
        } else if (event.which === 9) {
          // Tab (9) key
          this.handleTab(event);
        } else if (event.which === 13) {
          // Enter (13) key
          this.handleReturn(event);
        } else if (event.which === 38) {
          // Up (38) key
          this.handleUpArrow(event);
        } else if (event.which === 40) {
          // Down (40) key press
          this.handleDownArrow(event);
        }
      }
    }, {
      key: "handleSelectItem",
      value: function handleSelectItem(i) {
        this.commitSelection(i);
      }
    }, {
      key: "renderMenu",
      value: function renderMenu() {
        var _this2 = this;
        if (!this.state.active) {
          return null;
        }
        var items = this.props.items;
        return /*#__PURE__*/_react.default.createElement(_Menu.default, null, items.map(function (item, i) {
          return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
            item: item,
            index: i,
            onSelectItem: _this2.handleSelectItem,
            activateIndex: _this2.state.activateIndex,
            key: "item-".concat(i++)
          });
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
        return /*#__PURE__*/_react.default.createElement(_ClickableComponent.default, {
          className: (0, _classnames.default)(className, {
            'video-react-menu-button-inline': !!inline,
            'video-react-menu-button-popup': !inline,
            'video-react-menu-button-active': this.state.active
          }, 'video-react-control video-react-button video-react-menu-button'),
          role: "button",
          tabIndex: "0",
          ref: function ref(c) {
            _this3.menuButton = c;
          },
          onClick: this.handleClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }, this.props.children, this.renderMenu());
      }
    }]);
    return MenuButton;
  }(_react.Component);
  exports.default = MenuButton;
  MenuButton.propTypes = propTypes;
  MenuButton.displayName = 'MenuButton';
});
unwrapExports(MenuButton_1);
var PlaybackRateMenuButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _MenuButton = interopRequireDefault(MenuButton_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    player: _propTypes.default.object,
    actions: _propTypes.default.object,
    rates: _propTypes.default.array,
    className: _propTypes.default.string
  };
  var defaultProps = {
    rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
  };
  var PlaybackRateMenuButton = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(PlaybackRateMenuButton, _Component);
    var _super = _createSuper(PlaybackRateMenuButton);
    function PlaybackRateMenuButton(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, PlaybackRateMenuButton);
      _this = _super.call(this, props, context);
      _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(PlaybackRateMenuButton, [{
      key: "handleSelectItem",
      value: function handleSelectItem(index) {
        var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;
        if (index >= 0 && index < rates.length) {
          actions.changeRate(rates[index]);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
        var items = rates.map(function (rate) {
          return {
            label: "".concat(rate, "x"),
            value: rate
          };
        });
        var selectedIndex = rates.indexOf(player.playbackRate) || 0;
        return /*#__PURE__*/_react.default.createElement(_MenuButton.default, {
          className: (0, _classnames.default)('video-react-playback-rate', this.props.className),
          onSelectItem: this.handleSelectItem,
          items: items,
          selectedIndex: selectedIndex
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "video-react-control-text"
        }, "Playback Rate"), /*#__PURE__*/_react.default.createElement("div", {
          className: "video-react-playback-rate-value"
        }, "".concat(player.playbackRate.toFixed(2), "x")));
      }
    }]);
    return PlaybackRateMenuButton;
  }(_react.Component);
  PlaybackRateMenuButton.propTypes = propTypes;
  PlaybackRateMenuButton.defaultProps = defaultProps;
  PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
  var _default = PlaybackRateMenuButton;
  exports.default = _default;
});
unwrapExports(PlaybackRateMenuButton_1);
var ControlBar_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _ProgressControl = interopRequireDefault(ProgressControl_1);
  var _PlayToggle = interopRequireDefault(PlayToggle_1);
  var _ForwardControl = interopRequireDefault(ForwardControl_1);
  var _ReplayControl = interopRequireDefault(ReplayControl_1);
  var _FullscreenToggle = interopRequireDefault(FullscreenToggle_1);
  var _RemainingTimeDisplay = interopRequireDefault(RemainingTimeDisplay_1);
  var _CurrentTimeDisplay = interopRequireDefault(CurrentTimeDisplay_1);
  var _DurationDisplay = interopRequireDefault(DurationDisplay_1);
  var _TimeDivider = interopRequireDefault(TimeDivider_1);
  var _VolumeMenuButton = interopRequireDefault(VolumeMenuButton_1);
  var _PlaybackRateMenuButton = interopRequireDefault(PlaybackRateMenuButton_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    children: _propTypes.default.any,
    autoHide: _propTypes.default.bool,
    autoHideTime: _propTypes.default.number,
    // used in Player
    disableDefaultControls: _propTypes.default.bool,
    disableCompletely: _propTypes.default.bool,
    className: _propTypes.default.string
  };
  var defaultProps = {
    autoHide: true,
    disableCompletely: false
  };
  var ControlBar = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(ControlBar, _Component);
    var _super = _createSuper(ControlBar);
    function ControlBar(props) {
      var _this;
      (0, _classCallCheck2.default)(this, ControlBar);
      _this = _super.call(this, props);
      _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2.default)(_this));
      _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(ControlBar, [{
      key: "getDefaultChildren",
      value: function getDefaultChildren() {
        return [/*#__PURE__*/_react.default.createElement(_PlayToggle.default, {
          key: "play-toggle",
          order: 1
        }), /*#__PURE__*/_react.default.createElement(_VolumeMenuButton.default, {
          key: "volume-menu-button",
          order: 4
        }), /*#__PURE__*/_react.default.createElement(_CurrentTimeDisplay.default, {
          key: "current-time-display",
          order: 5.1
        }), /*#__PURE__*/_react.default.createElement(_TimeDivider.default, {
          key: "time-divider",
          order: 5.2
        }), /*#__PURE__*/_react.default.createElement(_DurationDisplay.default, {
          key: "duration-display",
          order: 5.3
        }), /*#__PURE__*/_react.default.createElement(_ProgressControl.default, {
          key: "progress-control",
          order: 6
        }), /*#__PURE__*/_react.default.createElement(_FullscreenToggle.default, {
          key: "fullscreen-toggle",
          order: 8
        })];
      }
    }, {
      key: "getFullChildren",
      value: function getFullChildren() {
        return [/*#__PURE__*/_react.default.createElement(_PlayToggle.default, {
          key: "play-toggle",
          order: 1
        }), /*#__PURE__*/_react.default.createElement(_ReplayControl.default, {
          key: "replay-control",
          order: 2
        }), /*#__PURE__*/_react.default.createElement(_ForwardControl.default, {
          key: "forward-control",
          order: 3
        }), /*#__PURE__*/_react.default.createElement(_VolumeMenuButton.default, {
          key: "volume-menu-button",
          order: 4
        }), /*#__PURE__*/_react.default.createElement(_CurrentTimeDisplay.default, {
          key: "current-time-display",
          order: 5
        }), /*#__PURE__*/_react.default.createElement(_TimeDivider.default, {
          key: "time-divider",
          order: 6
        }), /*#__PURE__*/_react.default.createElement(_DurationDisplay.default, {
          key: "duration-display",
          order: 7
        }), /*#__PURE__*/_react.default.createElement(_ProgressControl.default, {
          key: "progress-control",
          order: 8
        }), /*#__PURE__*/_react.default.createElement(_RemainingTimeDisplay.default, {
          key: "remaining-time-display",
          order: 9
        }), /*#__PURE__*/_react.default.createElement(_PlaybackRateMenuButton.default, {
          rates: [1, 1.25, 1.5, 2],
          key: "playback-rate",
          order: 10
        }), /*#__PURE__*/_react.default.createElement(_FullscreenToggle.default, {
          key: "fullscreen-toggle",
          order: 11
        })];
      }
    }, {
      key: "getChildren",
      value: function getChildren() {
        var children = _react.default.Children.toArray(this.props.children);
        var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
        var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2.default)(_this$props, ["className"]); // remove className

        return (0, utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
        var children = this.getChildren();
        return disableCompletely ? null : /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-control-bar', {
            'video-react-control-bar-auto-hide': autoHide
          }, className)
        }, children);
      }
    }]);
    return ControlBar;
  }(_react.Component);
  exports.default = ControlBar;
  ControlBar.propTypes = propTypes;
  ControlBar.defaultProps = defaultProps;
  ControlBar.displayName = 'ControlBar';
});
unwrapExports(ControlBar_1);
var browser = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
  var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
  // const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

  /*
   * Device is an iPhone
   *
   * @type {Boolean}
   * @constant
   * @private
   */

  var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
  // to identify iPhones, we need to exclude iPads.
  // http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

  exports.IS_IPAD = IS_IPAD;
  var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
  exports.IS_IPHONE = IS_IPHONE;
  var IS_IPOD = /iPod/i.test(USER_AGENT);
  exports.IS_IPOD = IS_IPOD;
  var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
  exports.IS_IOS = IS_IOS;
});
unwrapExports(browser);
var browser_1 = browser.IS_IOS;
var browser_2 = browser.IS_IPOD;
var browser_3 = browser.IS_IPHONE;
var browser_4 = browser.IS_IPAD;
var OptionsOverlay_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _Menu = interopRequireDefault(Menu_1);
  var _MenuItem = interopRequireDefault(MenuItem_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    player: _propTypes.default.object,
    actions: _propTypes.default.object,
    className: _propTypes.default.string,
    offMenuText: _propTypes.default.string,
    showOffMenu: _propTypes.default.bool,
    kinds: _propTypes.default.array
  };
  var defaultProps = {
    offMenuText: 'Off',
    showOffMenu: true,
    kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.
  };

  var OptionsOverlay = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(OptionsOverlay, _Component);
    var _super = _createSuper(OptionsOverlay);
    function OptionsOverlay(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, OptionsOverlay);
      _this = _super.call(this, props, context);
      _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSelectAudioDescription = _this.handleSelectAudioDescription.bind((0, _assertThisInitialized2.default)(_this));
      _this.updateState = _this.updateState.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2.default)(_this));
      _this.state = _this.getTextTrackItems();
      return _this;
    }
    (0, _createClass2.default)(OptionsOverlay, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        this.updateState();
      }
    }, {
      key: "getTextTrackItems",
      value: function getTextTrackItems() {
        var _this$props = this.props,
          kinds = _this$props.kinds,
          player = _this$props.player,
          offMenuText = _this$props.offMenuText,
          showOffMenu = _this$props.showOffMenu;
        var textTracks = player.textTracks,
          activeTextTrack = player.activeTextTrack;
        var textTrackItems = {
          items: [],
          selectedIndex: 0
        };
        var tracks = Array.from(textTracks || []);
        if (tracks.length === 0) {
          return textTrackItems;
        }
        if (showOffMenu) {
          textTrackItems.items.push({
            label: offMenuText || 'Off',
            value: null
          });
        }
        tracks.forEach(function (textTrack) {
          // ignore invalid text track kind
          if (kinds.length && !kinds.includes(textTrack.kind)) {
            return;
          }
          textTrackItems.items.push({
            label: textTrack.label,
            value: textTrack.language
          });
        });
        textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
          return activeTextTrack && activeTextTrack.language === item.value;
        });
        if (textTrackItems.selectedIndex === -1) {
          textTrackItems.selectedIndex = 0;
        }
        return textTrackItems;
      }
    }, {
      key: "updateState",
      value: function updateState() {
        var textTrackItems = this.getTextTrackItems();
        if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
          this.setState(textTrackItems);
        }
      }
    }, {
      key: "textTrackItemsAreEqual",
      value: function textTrackItemsAreEqual(items1, items2) {
        if (items1.length !== items2.length) {
          return false;
        }
        for (var i = 0; i < items1.length; i++) {
          if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
            return false;
          }
        }
        return true;
      }
    }, {
      key: "handleSelectItem",
      value: function handleSelectItem(index) {
        var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          showOffMenu = _this$props2.showOffMenu;
        var textTracks = player.textTracks;
        if (index === 0 && showOffMenu) actions.activateTextTrack(null); // update video-react's state to reflect off button being selected
        // For the 'subtitles-off' button, the first condition will never match
        // so all subtitles will be turned off

        Array.from(textTracks).forEach(function (textTrack, i) {
          // if it shows the `Off` menu, the first item is `Off`
          if (index === (showOffMenu ? i + 1 : i)) {
            textTrack.mode = 'showing';
            actions.activateTextTrack(textTrack);
          } else {
            textTrack.mode = 'hidden';
          }
        });
      }
    }, {
      key: "handleSelectAudioDescription",
      value: function handleSelectAudioDescription(index) {
        var actions = this.props.actions;
        actions.updateActiveAudioDescription(index);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$state = this.state,
          items = _this$state.items,
          selectedIndex = _this$state.selectedIndex;
        var _this$props3 = this.props,
          className = _this$props3.className,
          player = _this$props3.player,
          actions = _this$props3.actions;
        if (!player.isOptionsOverlayOpen) return null;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(className)
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: (0, _classnames.default)('video-react-options-close'),
          onClick: function onClick() {
            return actions.handleOptionsOverlayChange();
          },
          "aria-label": "Close Options Menu"
        }, "\xD7"), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-options-overlay')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-options-menu-section')
        }, /*#__PURE__*/_react.default.createElement("h3", {
          className: (0, _classnames.default)('video-react-menu-section-header')
        }, "Closed Captions"), items && /*#__PURE__*/_react.default.createElement(_Menu.default, null, items.map(function (item, i) {
          return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
            label: item.label,
            index: i,
            onSelectItem: _this2.handleSelectItem,
            activateIndex: selectedIndex,
            key: item.label
          });
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-react-options-menu-section')
        }, /*#__PURE__*/_react.default.createElement("h3", {
          className: (0, _classnames.default)('video-react-menu-section-header')
        }, "Audio Description"), player.audioDescriptions && /*#__PURE__*/_react.default.createElement(_Menu.default, null, player.audioDescriptions.map(function (description, i) {
          return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
            label: description.label,
            index: i,
            onSelectItem: _this2.handleSelectAudioDescription,
            activateIndex: player.activeAudioDescription,
            key: description.label
          });
        })))));
      }
    }]);
    return OptionsOverlay;
  }(_react.Component);
  OptionsOverlay.propTypes = propTypes;
  OptionsOverlay.defaultProps = defaultProps;
  OptionsOverlay.displayName = 'OptionsOverlay';
  var _default = OptionsOverlay;
  exports.default = _default;
});
unwrapExports(OptionsOverlay_1);
var AudioDescription_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _toConsumableArray2 = interopRequireDefault(toConsumableArray);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    player: _propTypes.default.object,
    actions: _propTypes.default.object,
    className: _propTypes.default.string,
    audioDescriptions: _propTypes.default.any
  };
  var AudioDescription = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(AudioDescription, _Component);
    var _super = _createSuper(AudioDescription);
    function AudioDescription(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, AudioDescription);
      _this = _super.call(this, props, context);
      _this.audioRef = /*#__PURE__*/_react.default.createRef();
      return _this;
    }
    (0, _createClass2.default)(AudioDescription, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        // keep audio description in sync with video player
        if (!this.audioRef || !this.audioRef.current) return; // stop audio description if video is done

        if (this.props.player.currentTime > this.audioRef.current.duration) {
          this.audioRef.current.currentTime = 0;
          this.audioRef.current.pause();
        } // keep audio in sync with video

        if (Math.abs(this.audioRef.current.currentTime - this.props.player.currentTime) > 0.5) this.audioRef.current.currentTime = this.props.player.currentTime; // update settings if necessary

        if (this.audioRef.current.volume !== this.props.player.volume) this.audioRef.current.volume = this.props.player.volume;
        if (this.props.player.paused && !this.audioRef.current.paused) this.audioRef.current.pause();
        if (!this.props.player.paused && this.audioRef.current.paused) this.audioRef.current.play();
        if (this.props.player.muted) this.audioRef.current.muted = true;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          player = _this$props.player,
          className = _this$props.className,
          actions = _this$props.actions,
          audioDescriptions = _this$props.audioDescriptions;
        if (!player.audioDescriptions.length && audioDescriptions) {
          var descriptions = [{
            label: 'Off'
          }].concat((0, _toConsumableArray2.default)(audioDescriptions));
          actions.setAudioDescriptions(descriptions);
        }
        if (!player.audioDescriptions || !player.activeAudioDescription) return null;
        var activeAudioDescription = player.audioDescriptions[player.activeAudioDescription];
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(className)
        }, /*#__PURE__*/_react.default.createElement("audio", {
          controls: true,
          src: activeAudioDescription.src,
          ref: this.audioRef
        }, "Your browser does not support the ", /*#__PURE__*/_react.default.createElement("code", null, "audio"), " element for audio descriptions."));
      }
    }]);
    return AudioDescription;
  }(_react.Component);
  AudioDescription.propTypes = propTypes;
  AudioDescription.displayName = 'AudioDescription';
  var _default = AudioDescription;
  exports.default = _default;
});
unwrapExports(AudioDescription_1);
var Player_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Player = exports.MediaType = void 0;
  var _defineProperty2 = interopRequireDefault(defineProperty);
  var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var _Manager = interopRequireDefault(Manager_1);
  var _LoadingSpinner = interopRequireDefault(LoadingSpinner_1);
  var _PosterImage = interopRequireDefault(PosterImage_1);
  var _Media = interopRequireDefault(Media_1);
  var _Bezel = interopRequireDefault(Bezel_1);
  var _Shortcut = interopRequireDefault(Shortcut_1);
  var _ControlBar = interopRequireDefault(ControlBar_1);
  var browser$1 = interopRequireWildcard(browser);
  var _fullscreen = interopRequireDefault(fullscreen);
  var _OptionsOverlay = interopRequireDefault(OptionsOverlay_1);
  var _AudioDescription = interopRequireDefault(AudioDescription_1);
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          (0, _defineProperty2.default)(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var MediaType = {
    audio: 'AUDIO',
    video: 'VIDEO'
  };
  exports.MediaType = MediaType;
  var propTypes = {
    children: _propTypes.default.any,
    width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    fluid: _propTypes.default.bool,
    muted: _propTypes.default.bool,
    playsInline: _propTypes.default.bool,
    aspectRatio: _propTypes.default.string,
    className: _propTypes.default.string,
    videoId: _propTypes.default.string,
    startTime: _propTypes.default.number,
    loop: _propTypes.default.bool,
    autoPlay: _propTypes.default.bool,
    src: _propTypes.default.string,
    type: _propTypes.default.oneOf(Object.values(MediaType)),
    poster: _propTypes.default.string,
    preload: _propTypes.default.oneOf(['auto', 'metadata', 'none']),
    onLoadStart: _propTypes.default.func,
    onWaiting: _propTypes.default.func,
    onCanPlay: _propTypes.default.func,
    onCanPlayThrough: _propTypes.default.func,
    onPlaying: _propTypes.default.func,
    onEnded: _propTypes.default.func,
    onSeeking: _propTypes.default.func,
    onSeeked: _propTypes.default.func,
    onPlay: _propTypes.default.func,
    onPause: _propTypes.default.func,
    onProgress: _propTypes.default.func,
    onDurationChange: _propTypes.default.func,
    onError: _propTypes.default.func,
    onSuspend: _propTypes.default.func,
    onAbort: _propTypes.default.func,
    onEmptied: _propTypes.default.func,
    onStalled: _propTypes.default.func,
    onLoadedMetadata: _propTypes.default.func,
    onLoadedData: _propTypes.default.func,
    onTimeUpdate: _propTypes.default.func,
    onRateChange: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    store: _propTypes.default.object
  };
  var defaultProps = {
    fluid: true,
    muted: false,
    playsInline: false,
    preload: 'auto',
    aspectRatio: 'auto'
  };
  var Player = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(Player, _Component);
    var _super = _createSuper(Player);
    function Player(props) {
      var _this;
      (0, _classCallCheck2.default)(this, Player);
      _this = _super.call(this, props);
      _this.controlsHideTimer = null;
      _this.video = null; // the Video component

      _this.manager = new _Manager.default(props.store);
      _this.actions = _this.manager.getActions();
      _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2.default)(_this)));
      _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2.default)(_this));
      _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleMouseMove = (0, utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2.default)(_this)), 250);
      _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
      _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(Player, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        _fullscreen.default.addEventListener(this.handleFullScreenChange);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        // Remove event listener
        window.removeEventListener('resize', this.handleResize);
        _fullscreen.default.removeEventListener(this.handleFullScreenChange);
        if (this.controlsHideTimer) {
          window.clearTimeout(this.controlsHideTimer);
        }
      }
    }, {
      key: "getDefaultChildren",
      value: function getDefaultChildren(originalChildren) {
        var _this2 = this;
        return [/*#__PURE__*/_react.default.createElement(_Media.default, {
          ref: function ref(c) {
            _this2.video = c;
            _this2.manager.video = _this2.video;
          },
          key: "video",
          order: 0.0
        }, originalChildren), /*#__PURE__*/_react.default.createElement(_PosterImage.default, {
          key: "poster-image",
          order: 1.0
        }), /*#__PURE__*/_react.default.createElement(_LoadingSpinner.default, {
          key: "loading-spinner",
          order: 2.0
        }), /*#__PURE__*/_react.default.createElement(_Bezel.default, {
          key: "bezel",
          order: 3.0
        }), /*#__PURE__*/_react.default.createElement(_ControlBar.default, {
          key: "control-bar",
          order: 5.0
        }), /*#__PURE__*/_react.default.createElement(_AudioDescription.default, {
          key: "audio-description",
          order: 6.0
        }), /*#__PURE__*/_react.default.createElement(_OptionsOverlay.default, {
          key: "options-overlay",
          order: 7.0
        }), /*#__PURE__*/_react.default.createElement(_Shortcut.default, {
          key: "shortcut",
          order: 99.0
        })];
      }
    }, {
      key: "getChildren",
      value: function getChildren(props) {
        var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2.default)(props, ["className", "children"]);
        var children = _react.default.Children.toArray(this.props.children).filter(function (e) {
          return !(0, utils.isVideoChild)(e);
        });
        var defaultChildren = this.getDefaultChildren(originalChildren);
        return (0, utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
      }
    }, {
      key: "setWidthOrHeight",
      value: function setWidthOrHeight(style, name, value) {
        var styleVal;
        if (typeof value === 'string') {
          if (value === 'auto') {
            styleVal = 'auto';
          } else if (value.match(/\d+%/)) {
            styleVal = value;
          }
        } else if (typeof value === 'number') {
          styleVal = "".concat(value, "px");
        }
        Object.assign(style, (0, _defineProperty2.default)({}, name, styleVal));
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;
        var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;
        var style = {};
        var width;
        var height;
        var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

        if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
          // Use any aspectRatio that's been specifically set
          aspectRatio = propsAspectRatio;
        } else if (player.videoWidth) {
          // Otherwise try to get the aspect ratio from the video metadata
          aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
        } else {
          // Or use a default. The video element's is 2:1, but 16:9 is more common.
          aspectRatio = '16:9';
        } // Get the ratio as a decimal we can use to calculate dimensions

        var ratioParts = aspectRatio.split(':');
        var ratioMultiplier = ratioParts[1] / ratioParts[0];
        if (propsWidth !== undefined) {
          // Use any width that's been specifically set
          width = propsWidth;
        } else if (propsHeight !== undefined) {
          // Or calulate the width from the aspect ratio if a height has been set
          width = propsHeight / ratioMultiplier;
        } else {
          // Or use the video's metadata, or use the video el's default of 300
          width = player.videoWidth || 400;
        }
        if (propsHeight !== undefined) {
          // Use any height that's been specifically set
          height = propsHeight;
        } else {
          // Otherwise calculate the height from the ratio and the width
          height = width * ratioMultiplier;
        }
        if (fluid) {
          style.paddingTop = "".concat(ratioMultiplier * 100, "%");
        } else {
          // If Width contains "auto", set "auto" in style
          this.setWidthOrHeight(style, 'width', width);
          this.setWidthOrHeight(style, 'height', height);
        }
        return style;
      } // get redux state
      // { player, operation }
    }, {
      key: "getState",
      value: function getState() {
        return this.manager.getState();
      } // get playback rate
    }, {
      key: "play",
      // play the video
      value: function play() {
        this.video.play();
      } // pause the video
    }, {
      key: "pause",
      value: function pause() {
        this.video.pause();
      } // Change the video source and re-load the video:
    }, {
      key: "load",
      value: function load() {
        this.video.load();
      } // Add a new text track to the video
    }, {
      key: "addTextTrack",
      value: function addTextTrack() {
        var _this$video;
        (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
      } // Check if your browser can play different types of video:
    }, {
      key: "canPlayType",
      value: function canPlayType() {
        var _this$video2;
        (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
      } // seek video by time
    }, {
      key: "seek",
      value: function seek(time) {
        this.video.seek(time);
      } // jump forward x seconds
    }, {
      key: "forward",
      value: function forward(seconds) {
        this.video.forward(seconds);
      } // jump back x seconds
    }, {
      key: "replay",
      value: function replay(seconds) {
        this.video.replay(seconds);
      } // enter or exist full screen
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        this.video.toggleFullscreen();
      } // subscribe to player state change
    }, {
      key: "subscribeToStateChange",
      value: function subscribeToStateChange(listener) {
        return this.manager.subscribeToPlayerStateChange(listener);
      } // player resize
    }, {
      key: "handleResize",
      value: function handleResize() {}
    }, {
      key: "handleFullScreenChange",
      value: function handleFullScreenChange(event) {
        if (event.target === this.manager.rootElement) {
          this.actions.handleFullscreenChange(_fullscreen.default.isFullscreen);
        }
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown() {
        this.startControlsTimer();
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove() {
        this.startControlsTimer();
      }
    }, {
      key: "handleKeyDown",
      value: function handleKeyDown() {
        this.startControlsTimer();
      }
    }, {
      key: "startControlsTimer",
      value: function startControlsTimer() {
        var _this3 = this;
        var controlBarActiveTime = 3000;
        _react.default.Children.forEach(this.props.children, function (element) {
          if (! /*#__PURE__*/_react.default.isValidElement(element) || element.type !== _ControlBar.default) {
            return;
          }
          var autoHideTime = element.props.autoHideTime;
          if (typeof autoHideTime === 'number') {
            controlBarActiveTime = autoHideTime;
          }
        });
        this.actions.userActivate(true);
        clearTimeout(this.controlsHideTimer);
        this.controlsHideTimer = setTimeout(function () {
          _this3.actions.userActivate(false);
        }, controlBarActiveTime);
      }
    }, {
      key: "handleStateChange",
      value: function handleStateChange(state, prevState) {
        if (state.isFullscreen !== prevState.isFullscreen) {
          this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

          (0, dom.focusNode)(this.manager.rootElement);
        }
        this.forceUpdate(); // re-render
      }
    }, {
      key: "handleFocus",
      value: function handleFocus() {
        this.actions.activate(true);
      }
    }, {
      key: "handleBlur",
      value: function handleBlur() {
        this.actions.activate(false);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;
        var fluid = this.props.fluid;
        var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;
        var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
        var props = _objectSpread(_objectSpread({}, this.props), {}, {
          player: player,
          actions: this.actions,
          manager: this.manager,
          store: this.manager.store,
          video: this.video ? this.video.video : null
        });
        var children = this.getChildren(props);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)({
            'video-react-controls-enabled': true,
            'video-react-has-started': hasStarted,
            'video-react-paused': paused,
            'video-react-playing': !paused,
            'video-react-waiting': waiting,
            'video-react-seeking': seeking,
            'video-react-fluid': fluid,
            'video-react-fullscreen': isFullscreen,
            'video-react-user-inactive': !userActivity,
            'video-react-user-active': userActivity,
            'video-react-workinghover': !browser$1.IS_IOS
          }, 'video-react', this.props.className),
          style: this.getStyle(),
          ref: function ref(c) {
            _this4.manager.rootElement = c;
          },
          role: "region",
          onTouchStart: this.handleMouseDown,
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleMouseMove,
          onMouseMove: this.handleMouseMove,
          onKeyDown: this.handleKeyDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          tabIndex: "-1"
        }, children);
      }
    }, {
      key: "playbackRate",
      get: function get() {
        return this.video.playbackRate;
      } // set playback rate
      // speed of video
      ,

      set: function set(rate) {
        this.video.playbackRate = rate;
      }
    }, {
      key: "muted",
      get: function get() {
        return this.video.muted;
      },
      set: function set(val) {
        this.video.muted = val;
      }
    }, {
      key: "volume",
      get: function get() {
        return this.video.volume;
      },
      set: function set(val) {
        this.video.volume = val;
      } // video width
    }, {
      key: "videoWidth",
      get: function get() {
        return this.video.videoWidth;
      } // video height
    }, {
      key: "videoHeight",
      get: function get() {
        return this.video.videoHeight;
      }
    }]);
    return Player;
  }(_react.Component);
  exports.Player = Player;
  Player.contextTypes = {
    store: _propTypes.default.object
  };
  Player.propTypes = propTypes;
  Player.defaultProps = defaultProps;
  Player.displayName = 'Player';
  Player.mediaType = MediaType;
});
unwrapExports(Player_1);
var Player_2 = Player_1.Player;
var Player_3 = Player_1.MediaType;
var BigPlayButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _assertThisInitialized2 = interopRequireDefault(assertThisInitialized);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireWildcard(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var propTypes = {
    actions: _propTypes.default.object,
    player: _propTypes.default.object,
    position: _propTypes.default.string,
    className: _propTypes.default.string
  };
  var defaultProps = {
    position: 'left'
  };
  var BigPlayButton = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(BigPlayButton, _Component);
    var _super = _createSuper(BigPlayButton);
    function BigPlayButton(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, BigPlayButton);
      _this = _super.call(this, props, context);
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }
    (0, _createClass2.default)(BigPlayButton, [{
      key: "componentDidMount",
      value: function componentDidMount() {}
    }, {
      key: "handleClick",
      value: function handleClick() {
        var actions = this.props.actions;
        actions.play();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
        return /*#__PURE__*/_react.default.createElement("button", {
          className: (0, _classnames.default)('video-react-button', 'video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
            'big-play-button-hide': player.hasStarted || !player.currentSrc
          }),
          type: "button",
          "aria-live": "polite",
          tabIndex: "0",
          onClick: this.handleClick
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "video-react-control-text"
        }, "Play Video"));
      }
    }]);
    return BigPlayButton;
  }(_react.Component);
  exports.default = BigPlayButton;
  BigPlayButton.propTypes = propTypes;
  BigPlayButton.defaultProps = defaultProps;
  BigPlayButton.displayName = 'BigPlayButton';
});
unwrapExports(BigPlayButton_1);
var PlaybackRate_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _classCallCheck2 = interopRequireDefault(classCallCheck);
  var _createClass2 = interopRequireDefault(createClass);
  var _inherits2 = interopRequireDefault(inherits);
  var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn);
  var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);
  var _react = interopRequireWildcard(React__default);
  var _PlaybackRateMenuButton = interopRequireDefault(PlaybackRateMenuButton_1);
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = (0, _getPrototypeOf2.default)(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return (0, _possibleConstructorReturn2.default)(this, result);
    };
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  var PlaybackRate = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(PlaybackRate, _Component);
    var _super = _createSuper(PlaybackRate);
    function PlaybackRate(props, context) {
      var _this;
      (0, _classCallCheck2.default)(this, PlaybackRate);
      _this = _super.call(this, props, context);
      (0, utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
      return _this;
    }
    (0, _createClass2.default)(PlaybackRate, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_PlaybackRateMenuButton.default, this.props);
      }
    }]);
    return PlaybackRate;
  }(_react.Component);
  exports.default = PlaybackRate;
  PlaybackRate.displayName = 'PlaybackRate';
});
unwrapExports(PlaybackRate_1);
var OptionsButton_1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _propTypes = interopRequireDefault(propTypes$1);
  var _react = interopRequireDefault(React__default);
  var _classnames = interopRequireDefault(classnames$1);
  var propTypes = {
    actions: _propTypes.default.object
  };
  var OptionsButton = function OptionsButton(props) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "data-testid": "test-options-icon",
      className: (0, _classnames.default)('video-react-options-button', props.className),
      onClick: function onClick() {
        return props.actions.handleOptionsOverlayChange();
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "video-react-control-text"
    }, "Audio and CC"));
  };
  OptionsButton.propTypes = propTypes;
  OptionsButton.displayName = 'OptionsButton';
  var _default = OptionsButton;
  exports.default = _default;
});
unwrapExports(OptionsButton_1);
var lib$1 = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Player", {
    enumerable: true,
    get: function get() {
      return Player_1.Player;
    }
  });
  Object.defineProperty(exports, "Media", {
    enumerable: true,
    get: function get() {
      return _Media.default;
    }
  });
  Object.defineProperty(exports, "BigPlayButton", {
    enumerable: true,
    get: function get() {
      return _BigPlayButton.default;
    }
  });
  Object.defineProperty(exports, "LoadingSpinner", {
    enumerable: true,
    get: function get() {
      return _LoadingSpinner.default;
    }
  });
  Object.defineProperty(exports, "PosterImage", {
    enumerable: true,
    get: function get() {
      return _PosterImage.default;
    }
  });
  Object.defineProperty(exports, "Slider", {
    enumerable: true,
    get: function get() {
      return _Slider.default;
    }
  });
  Object.defineProperty(exports, "Bezel", {
    enumerable: true,
    get: function get() {
      return _Bezel.default;
    }
  });
  Object.defineProperty(exports, "Shortcut", {
    enumerable: true,
    get: function get() {
      return _Shortcut.default;
    }
  });
  Object.defineProperty(exports, "ControlBar", {
    enumerable: true,
    get: function get() {
      return _ControlBar.default;
    }
  });
  Object.defineProperty(exports, "PlayToggle", {
    enumerable: true,
    get: function get() {
      return _PlayToggle.default;
    }
  });
  Object.defineProperty(exports, "ForwardControl", {
    enumerable: true,
    get: function get() {
      return _ForwardControl.default;
    }
  });
  Object.defineProperty(exports, "ReplayControl", {
    enumerable: true,
    get: function get() {
      return _ReplayControl.default;
    }
  });
  Object.defineProperty(exports, "FullscreenToggle", {
    enumerable: true,
    get: function get() {
      return _FullscreenToggle.default;
    }
  });
  Object.defineProperty(exports, "ProgressControl", {
    enumerable: true,
    get: function get() {
      return _ProgressControl.default;
    }
  });
  Object.defineProperty(exports, "SeekBar", {
    enumerable: true,
    get: function get() {
      return _SeekBar.default;
    }
  });
  Object.defineProperty(exports, "PlayProgressBar", {
    enumerable: true,
    get: function get() {
      return _PlayProgressBar.default;
    }
  });
  Object.defineProperty(exports, "LoadProgressBar", {
    enumerable: true,
    get: function get() {
      return _LoadProgressBar.default;
    }
  });
  Object.defineProperty(exports, "MouseTimeDisplay", {
    enumerable: true,
    get: function get() {
      return _MouseTimeDisplay.default;
    }
  });
  Object.defineProperty(exports, "VolumeMenuButton", {
    enumerable: true,
    get: function get() {
      return _VolumeMenuButton.default;
    }
  });
  Object.defineProperty(exports, "PlaybackRateMenuButton", {
    enumerable: true,
    get: function get() {
      return _PlaybackRateMenuButton.default;
    }
  });
  Object.defineProperty(exports, "PlaybackRate", {
    enumerable: true,
    get: function get() {
      return _PlaybackRate.default;
    }
  });
  Object.defineProperty(exports, "OptionsButton", {
    enumerable: true,
    get: function get() {
      return _OptionsButton.default;
    }
  });
  Object.defineProperty(exports, "OptionsOverlay", {
    enumerable: true,
    get: function get() {
      return _OptionsOverlay.default;
    }
  });
  Object.defineProperty(exports, "AudioDescription", {
    enumerable: true,
    get: function get() {
      return _AudioDescription.default;
    }
  });
  Object.defineProperty(exports, "RemainingTimeDisplay", {
    enumerable: true,
    get: function get() {
      return _RemainingTimeDisplay.default;
    }
  });
  Object.defineProperty(exports, "CurrentTimeDisplay", {
    enumerable: true,
    get: function get() {
      return _CurrentTimeDisplay.default;
    }
  });
  Object.defineProperty(exports, "DurationDisplay", {
    enumerable: true,
    get: function get() {
      return _DurationDisplay.default;
    }
  });
  Object.defineProperty(exports, "TimeDivider", {
    enumerable: true,
    get: function get() {
      return _TimeDivider.default;
    }
  });
  Object.defineProperty(exports, "VolumeBar", {
    enumerable: true,
    get: function get() {
      return _VolumeBar.default;
    }
  });
  Object.defineProperty(exports, "MenuButton", {
    enumerable: true,
    get: function get() {
      return _MenuButton.default;
    }
  });
  Object.defineProperty(exports, "playerReducer", {
    enumerable: true,
    get: function get() {
      return reducers.playerReducer;
    }
  });
  Object.defineProperty(exports, "operationReducer", {
    enumerable: true,
    get: function get() {
      return reducers.operationReducer;
    }
  });
  exports.videoActions = exports.playerActions = void 0;
  var _Media = interopRequireDefault(Media_1);
  var _BigPlayButton = interopRequireDefault(BigPlayButton_1);
  var _LoadingSpinner = interopRequireDefault(LoadingSpinner_1);
  var _PosterImage = interopRequireDefault(PosterImage_1);
  var _Slider = interopRequireDefault(Slider_1);
  var _Bezel = interopRequireDefault(Bezel_1);
  var _Shortcut = interopRequireDefault(Shortcut_1);
  var _ControlBar = interopRequireDefault(ControlBar_1);
  var _PlayToggle = interopRequireDefault(PlayToggle_1);
  var _ForwardControl = interopRequireDefault(ForwardControl_1);
  var _ReplayControl = interopRequireDefault(ReplayControl_1);
  var _FullscreenToggle = interopRequireDefault(FullscreenToggle_1);
  var _ProgressControl = interopRequireDefault(ProgressControl_1);
  var _SeekBar = interopRequireDefault(SeekBar_1);
  var _PlayProgressBar = interopRequireDefault(PlayProgressBar_1);
  var _LoadProgressBar = interopRequireDefault(LoadProgressBar_1);
  var _MouseTimeDisplay = interopRequireDefault(MouseTimeDisplay_1);
  var _VolumeMenuButton = interopRequireDefault(VolumeMenuButton_1);
  var _PlaybackRateMenuButton = interopRequireDefault(PlaybackRateMenuButton_1);
  var _PlaybackRate = interopRequireDefault(PlaybackRate_1);
  var _OptionsButton = interopRequireDefault(OptionsButton_1);
  var _OptionsOverlay = interopRequireDefault(OptionsOverlay_1);
  var _AudioDescription = interopRequireDefault(AudioDescription_1);
  var _RemainingTimeDisplay = interopRequireDefault(RemainingTimeDisplay_1);
  var _CurrentTimeDisplay = interopRequireDefault(CurrentTimeDisplay_1);
  var _DurationDisplay = interopRequireDefault(DurationDisplay_1);
  var _TimeDivider = interopRequireDefault(TimeDivider_1);
  var _VolumeBar = interopRequireDefault(VolumeBar_1);
  var _MenuButton = interopRequireDefault(MenuButton_1);
  var playerActions = interopRequireWildcard(player);
  exports.playerActions = playerActions;
  var videoActions = interopRequireWildcard(video);
  exports.videoActions = videoActions;
});
unwrapExports(lib$1);
var lib_1 = lib$1.Player;
var lib_2 = lib$1.ControlBar;
var lib_3 = lib$1.OptionsButton;
var lib_4 = lib$1.ReplayControl;
var lib_5 = lib$1.BigPlayButton;
var lib_6 = lib$1.PlayToggle;
var lib_7 = lib$1.VolumeMenuButton;
var lib_8 = lib$1.SeekBar;
var lib_9 = lib$1.ProgressControl;
var lib_10 = lib$1.CurrentTimeDisplay;
var lib_11 = lib$1.TimeDivider;
var lib_12 = lib$1.DurationDisplay;
var lib_13 = lib$1.FullscreenToggle;
var lib_14 = lib$1.VolumeBar;
var lib_15 = lib$1.OptionsOverlay;
var lib_16 = lib$1.AudioDescription;
var lib_17 = lib$1.videoActions;
var lib_18 = lib$1.playerActions;
var css_248z$1 = "@charset \"UTF-8\";\n.video-react .video-react-control:before, .video-react .video-react-big-play-button:before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.video-react .video-react-control:before, .video-react .video-react-big-play-button:before {\n  text-align: center;\n}\n\n@font-face {\n  font-family: \"video-react\";\n  src: url(data:application/vnd.ms-fontobject;base64,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?#iefix) format(\"eot\");\n}\n@font-face {\n  font-family: \"video-react\";\n  src: url(data:application/font-woff;base64,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) format(\"woff\"), url(data:application/x-font-ttf;base64,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) format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n.video-react-icon, .video-react .video-react-options-button, .video-react .video-react-bezel .video-react-bezel-icon, .video-react .video-react-mute-control,\n.video-react .video-react-volume-menu-button, .video-react .video-react-play-control, .video-react .video-react-play-progress, .video-react .video-react-big-play-button {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"video-react\" !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-feature-settings: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.video-react-icon-play-arrow:before, .video-react .video-react-bezel .video-react-bezel-icon-play:before, .video-react .video-react-play-control:before, .video-react .video-react-big-play-button:before {\n  content: \"\";\n}\n\n.video-react-icon-play-circle-filled:before {\n  content: \"\";\n}\n\n.video-react-icon-play-circle-outline:before {\n  content: \"\";\n}\n\n.video-react-icon-pause:before, .video-react .video-react-bezel .video-react-bezel-icon-pause:before, .video-react .video-react-play-control.video-react-playing:before {\n  content: \"\";\n}\n\n.video-react-icon-pause-circle-filled:before {\n  content: \"\";\n}\n\n.video-react-icon-pause-circle-outline:before {\n  content: \"\";\n}\n\n.video-react-icon-stop:before {\n  content: \"\";\n}\n\n.video-react-icon-fast-rewind:before, .video-react .video-react-bezel .video-react-bezel-icon-fast-rewind:before {\n  content: \"\";\n}\n\n.video-react-icon-fast-forward:before, .video-react .video-react-bezel .video-react-bezel-icon-fast-forward:before {\n  content: \"\";\n}\n\n.video-react-icon-skip-previous:before {\n  content: \"\";\n}\n\n.video-react-icon-skip-next:before {\n  content: \"\";\n}\n\n.video-react-icon-replay-5:before, .video-react .video-react-bezel .video-react-bezel-icon-replay-5:before {\n  content: \"\";\n}\n\n.video-react-icon-replay-10:before, .video-react .video-react-bezel .video-react-bezel-icon-replay-10:before {\n  content: \"\";\n}\n\n.video-react-icon-replay-30:before, .video-react .video-react-bezel .video-react-bezel-icon-replay-30:before {\n  content: \"\";\n}\n\n.video-react-icon-forward-5:before, .video-react .video-react-bezel .video-react-bezel-icon-forward-5:before {\n  content: \"\";\n}\n\n.video-react-icon-forward-10:before, .video-react .video-react-bezel .video-react-bezel-icon-forward-10:before {\n  content: \"\";\n}\n\n.video-react-icon-forward-30:before, .video-react .video-react-bezel .video-react-bezel-icon-forward-30:before {\n  content: \"\";\n}\n\n.video-react-icon-volume-off:before, .video-react .video-react-bezel .video-react-bezel-icon-volume-off:before, .video-react .video-react-mute-control.video-react-vol-muted:before,\n.video-react .video-react-volume-menu-button.video-react-vol-muted:before {\n  content: \"\";\n}\n\n.video-react-icon-volume-mute:before, .video-react .video-react-mute-control.video-react-vol-0:before,\n.video-react .video-react-volume-menu-button.video-react-vol-0:before {\n  content: \"\";\n}\n\n.video-react-icon-volume-down:before, .video-react .video-react-bezel .video-react-bezel-icon-volume-down:before, .video-react .video-react-mute-control.video-react-vol-2:before,\n.video-react .video-react-volume-menu-button.video-react-vol-2:before, .video-react .video-react-mute-control.video-react-vol-1:before,\n.video-react .video-react-volume-menu-button.video-react-vol-1:before {\n  content: \"\";\n}\n\n.video-react-icon-volume-up:before, .video-react .video-react-bezel .video-react-bezel-icon-volume-up:before, .video-react .video-react-mute-control:before,\n.video-react .video-react-volume-menu-button:before {\n  content: \"\";\n}\n\n.video-react-icon-fullscreen:before {\n  content: \"\";\n}\n\n.video-react-icon-fullscreen-exit:before {\n  content: \"\";\n}\n\n.video-react-icon-closed-caption:before {\n  content: \"\";\n}\n\n.video-react-icon-hd:before {\n  content: \"\";\n}\n\n.video-react-icon-settings:before {\n  content: \"\";\n}\n\n.video-react-icon-share:before {\n  content: \"\";\n}\n\n.video-react-icon-info:before {\n  content: \"\";\n}\n\n.video-react-icon-info-outline:before {\n  content: \"\";\n}\n\n.video-react-icon-close:before {\n  content: \"\";\n}\n\n.video-react-icon-circle:before, .video-react .video-react-play-progress:before {\n  content: \"\";\n}\n\n.video-react-icon-circle-outline:before {\n  content: \"\";\n}\n\n.video-react-icon-circle-inner-circle:before {\n  content: \"\";\n}\n\n.video-react {\n  display: block;\n  vertical-align: top;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: #000;\n  position: relative;\n  font-size: 10px;\n  line-height: 1;\n  font-family: serif, Times, \"Times New Roman\";\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.video-react:-moz-full-screen {\n  position: absolute;\n}\n.video-react:-webkit-full-screen {\n  width: 100% !important;\n  height: 100% !important;\n}\n.video-react *,\n.video-react *:before,\n.video-react *:after {\n  box-sizing: inherit;\n}\n.video-react ul {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  list-style-position: outside;\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.video-react.video-react-fluid, .video-react.video-react-16-9, .video-react.video-react-4-3 {\n  width: 100%;\n  max-width: 100%;\n  height: 0;\n}\n.video-react.video-react-16-9 {\n  padding-top: 56.25%;\n}\n.video-react.video-react-4-3 {\n  padding-top: 75%;\n}\n.video-react.video-react-fill {\n  width: 100%;\n  height: 100%;\n}\n.video-react .video-react-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.video-react.video-react-fullscreen {\n  width: 100% !important;\n  height: 100% !important;\n  padding-top: 0 !important;\n}\n.video-react.video-react-fullscreen.video-react-user-inactive {\n  cursor: none;\n}\n\nbody.video-react-full-window {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  overflow-y: auto;\n}\nbody.video-react-full-window .video-react-fullscreen {\n  position: fixed;\n  overflow: hidden;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.video-react .video-react-button {\n  background: none;\n  border: none;\n  color: inherit;\n  display: inline-block;\n  cursor: pointer;\n  overflow: visible;\n  font-size: inherit;\n  line-height: inherit;\n  text-transform: none;\n  text-decoration: none;\n  transition: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.video-react .video-react-loading-spinner {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -25px 0 0 -25px;\n  opacity: 0.85;\n  text-align: left;\n  border: 6px solid rgba(43, 51, 63, 0.7);\n  box-sizing: border-box;\n  background-clip: padding-box;\n  width: 50px;\n  height: 50px;\n  border-radius: 25px;\n}\n.video-react .video-react-loading-spinner:before, .video-react .video-react-loading-spinner:after {\n  content: \"\";\n  position: absolute;\n  margin: -6px;\n  box-sizing: inherit;\n  width: inherit;\n  height: inherit;\n  border-radius: inherit;\n  opacity: 1;\n  border: inherit;\n  border-color: transparent;\n  border-top-color: white;\n  animation: video-react-spinner-spin 1.1s cubic-bezier(0.6, 0.2, 0, 0.8) infinite, video-react-spinner-fade 1.1s linear infinite;\n}\n\n.video-react-seeking .video-react-loading-spinner,\n.video-react-waiting .video-react-loading-spinner {\n  display: block;\n}\n\n.video-react-seeking .video-react-loading-spinner:before,\n.video-react-waiting .video-react-loading-spinner:before {\n  border-top-color: white;\n}\n\n.video-react-seeking .video-react-loading-spinner:after,\n.video-react-waiting .video-react-loading-spinner:after {\n  border-top-color: white;\n  animation-delay: 0.44s;\n}\n\n@keyframes video-react-spinner-spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes video-react-spinner-fade {\n  0% {\n    border-top-color: #73859f;\n  }\n  20% {\n    border-top-color: #73859f;\n  }\n  35% {\n    border-top-color: white;\n  }\n  60% {\n    border-top-color: #73859f;\n  }\n  100% {\n    border-top-color: #73859f;\n  }\n}\n.video-react .video-react-big-play-button {\n  font-size: 3em;\n  line-height: 1.5em;\n  height: 1.5em;\n  width: 3em;\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  padding: 0;\n  cursor: pointer;\n  opacity: 1;\n  border: 0.06666em solid #fff;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  border-radius: 0.3em;\n  transition: all 0.4s;\n}\n.video-react .video-react-big-play-button.video-react-big-play-button-center {\n  top: 50%;\n  left: 50%;\n  margin-top: -0.75em;\n  margin-left: -1.5em;\n}\n.video-react .video-react-big-play-button.big-play-button-hide {\n  display: none;\n}\n.video-react:hover .video-react-big-play-button,\n.video-react .video-react-big-play-button:focus {\n  outline: 0;\n  border-color: #fff;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n  transition: all 0s;\n}\n\n.video-react-menu-button {\n  cursor: pointer;\n}\n.video-react-menu-button.video-react-disabled {\n  cursor: default;\n}\n\n.video-react-menu .video-react-menu-content {\n  display: block;\n  padding: 0;\n  margin: 0;\n  overflow: auto;\n  font-family: serif, Times, \"Times New Roman\";\n}\n.video-react-menu li {\n  list-style: none;\n  margin: 0;\n  line-height: 1.4em;\n  font-size: 1.2em;\n}\n.video-react-menu li:focus, .video-react-menu li:hover {\n  outline: 0;\n}\n.video-react-menu li.video-react-selected, .video-react-menu li.video-react-selected:focus, .video-react-menu li.video-react-selected:hover {\n  background-color: #fff;\n  color: #2B333F;\n}\n.video-react-menu li.vjs-menu-title {\n  text-align: center;\n  text-transform: uppercase;\n  font-size: 1em;\n  line-height: 2em;\n  padding: 0;\n  margin: 0 0 0.3em 0;\n  font-weight: bold;\n  cursor: default;\n}\n\n.video-react-scrubbing .vjs-menu-button:hover .video-react-menu {\n  display: none;\n}\n\n.video-react .video-react-menu-button-popup .video-react-menu {\n  display: none;\n  position: absolute;\n  bottom: 100%;\n  width: 10em;\n  left: -3em;\n  height: 0em;\n  border-top-color: rgba(43, 51, 63, 0.7);\n}\n.video-react .video-react-menu-button-popup .video-react-menu .video-react-menu-content {\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n  bottom: 1.5em;\n}\n\n.video-react-menu-button-popup .video-react-menu.video-react-lock-showing {\n  display: block;\n}\n\n.video-react-options-close {\n  position: absolute;\n  top: 0.4em;\n  right: 0.5em;\n  color: white;\n  background: none;\n  border: none;\n  font-size: 2.5em;\n  z-index: 2;\n}\n.video-react-options-close:hover {\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.video-react-options-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 325px;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.video-react-options-overlay .video-react-options-menu-section {\n  width: 80%;\n  align-self: center;\n  color: #ffffff;\n}\n.video-react-options-overlay .video-react-options-menu-section .video-react-menu-section-header {\n  font-weight: normal;\n  margin: 0.25em 0;\n}\n.video-react-options-overlay .video-react-options-menu-section .video-react-menu-item {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.video-react-options-overlay .video-react-options-menu-section .video-react-menu-item .video-react-menu-item-radio {\n  width: 1em;\n  height: 1em;\n  border-radius: 0.5em;\n  border: 1px solid white;\n  display: block;\n  margin-right: 0.5em;\n}\n.video-react-options-overlay .video-react-options-menu-section .video-react-menu-item .video-react-menu-item-radio.video-react-menu-item-radio-selected, .video-react-options-overlay .video-react-options-menu-section .video-react-menu-item .video-react-menu-item-radio:hover {\n  background-color: blue;\n}\n.video-react-options-overlay .video-react-options-menu-section .video-react-menu-item p {\n  font-size: 1.3em;\n  margin: 0.25em 0;\n  font-weight: bold;\n}\n\n.video-react .video-react-menu-button-inline {\n  transition: all 0.4s;\n  overflow: hidden;\n}\n.video-react .video-react-menu-button-inline:before {\n  width: 2.222222222em;\n}\n.video-react .video-react-menu-button-inline:hover, .video-react .video-react-menu-button-inline:focus, .video-react .video-react-menu-button-inline.video-react-slider-active {\n  width: 12em;\n}\n.video-react .video-react-menu-button-inline:hover .video-react-menu, .video-react .video-react-menu-button-inline:focus .video-react-menu, .video-react .video-react-menu-button-inline.video-react-slider-active .video-react-menu {\n  display: block;\n  opacity: 1;\n}\n.video-react .video-react-menu-button-inline.video-react-slider-active {\n  transition: none;\n}\n.video-react .video-react-menu-button-inline .video-react-menu {\n  opacity: 0;\n  height: 100%;\n  width: auto;\n  position: absolute;\n  left: 4em;\n  top: 0;\n  padding: 0;\n  margin: 0;\n  transition: all 0.4s;\n}\n.video-react .video-react-menu-button-inline .video-react-menu-content {\n  width: auto;\n  height: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n\n.video-react-no-flex .video-react-menu-button-inline .video-react-menu {\n  display: block;\n  opacity: 1;\n  position: relative;\n  width: auto;\n}\n.video-react-no-flex .video-react-menu-button-inline:hover, .video-react-no-flex .video-react-menu-button-inline:focus, .video-react-no-flex .video-react-menu-button-inline.video-react-slider-active {\n  width: auto;\n}\n\n.video-react .video-react-poster {\n  display: inline-block;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  background-size: contain;\n  background-color: #000000;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n}\n.video-react .video-react-poster img {\n  display: block;\n  vertical-align: middle;\n  margin: 0 auto;\n  max-height: 100%;\n  padding: 0;\n  width: 100%;\n}\n\n.video-react .video-react-slider {\n  outline: 0;\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 0.45em 0 0.45em;\n  background-color: #73859f;\n  background-color: rgba(115, 133, 159, 0.5);\n}\n.video-react .video-react-slider:focus {\n  box-shadow: 0 0 1em #fff;\n}\n\n.video-react .video-react-control {\n  outline: none;\n  position: relative;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  width: 4em;\n  flex: none;\n}\n.video-react .video-react-control:before {\n  font-size: 1.8em;\n  line-height: 1.67;\n}\n.video-react .video-react-control:focus:before, .video-react .video-react-control:hover:before, .video-react .video-react-control:focus {\n  text-shadow: 0em 0em 1em #fff, 0em 0em 0.5em #fff;\n}\n\n.video-react .video-react-control-text {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.video-react-no-flex .video-react-control {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.video-react .video-react-control-bar {\n  display: none;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 3em;\n  background-color: #2B333F;\n  background-color: rgba(43, 51, 63, 0.7);\n}\n\n.video-react-has-started .video-react-control-bar {\n  display: flex;\n  visibility: visible;\n  opacity: 1;\n  transition: visibility 0.1s, opacity 0.1s;\n}\n\n.video-react-has-started.video-react-user-inactive.video-react-playing .video-react-control-bar.video-react-control-bar-auto-hide {\n  visibility: visible;\n  opacity: 0;\n  transition: visibility 1s, opacity 1s;\n}\n\n.video-react-controls-disabled .video-react-control-bar,\n.video-react-using-native-controls .video-react-control-bar,\n.video-react-error .video-react-control-bar {\n  display: none !important;\n}\n\n.video-react-audio.video-react-has-started.video-react-user-inactive.video-react-playing .video-react-control-bar {\n  opacity: 1;\n  visibility: visible;\n}\n\n.video-react-has-started.video-react-no-flex .video-react-control-bar {\n  display: table;\n}\n\n.video-react .video-react-progress-control {\n  flex: auto;\n  display: flex;\n  align-items: center;\n  min-width: 4em;\n}\n\n.video-react-live .video-react-progress-control {\n  display: none;\n}\n\n.video-react .video-react-progress-holder {\n  flex: auto;\n  transition: all 0.2s;\n  height: 0.3em;\n}\n\n.video-react .video-react-progress-control:hover .video-react-progress-holder {\n  font-size: 1.6666666667em;\n}\n\n/* If we let the font size grow as much as everything else, the current time tooltip ends up\n ginormous. If you'd like to enable the current time tooltip all the time, this should be disabled\n to avoid a weird hitch when you roll off the hover. */\n.video-react .video-react-progress-control:hover .video-react-time-tooltip,\n.video-react .video-react-progress-control:hover .video-react-mouse-display:after,\n.video-react .video-react-progress-control:hover .video-react-play-progress:after {\n  visibility: visible;\n  font-size: 0.6em;\n}\n\n.video-react .video-react-progress-holder .video-react-play-progress,\n.video-react .video-react-progress-holder .video-react-load-progress,\n.video-react .video-react-progress-holder .video-react-tooltip-progress-bar,\n.video-react .video-react-progress-holder .video-react-load-progress div {\n  position: absolute;\n  display: block;\n  height: 0.3em;\n  margin: 0;\n  padding: 0;\n  width: 0;\n  left: 0;\n  top: 0;\n}\n\n.video-react .video-react-play-progress {\n  background-color: #fff;\n}\n.video-react .video-react-play-progress:before {\n  position: absolute;\n  top: -0.3333333333em;\n  right: -0.5em;\n  font-size: 0.9em;\n}\n\n.video-react .video-react-time-tooltip,\n.video-react .video-react-mouse-display:after,\n.video-react .video-react-play-progress:after {\n  visibility: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: -3.4em;\n  right: -1.9em;\n  font-size: 0.9em;\n  color: #000;\n  content: attr(data-current-time);\n  padding: 6px 8px 8px 8px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 0.3em;\n}\n\n.video-react .video-react-time-tooltip,\n.video-react .video-react-play-progress:before,\n.video-react .video-react-play-progress:after {\n  z-index: 1;\n}\n\n.video-react .video-react-progress-control .video-react-keep-tooltips-inside:after {\n  display: none;\n}\n\n.video-react .video-react-load-progress {\n  background: #bfc7d3;\n  background: rgba(115, 133, 159, 0.5);\n}\n\n.video-react .video-react-load-progress div {\n  background: white;\n  background: rgba(115, 133, 159, 0.75);\n}\n\n.video-react.video-react-no-flex .video-react-progress-control {\n  width: auto;\n}\n\n.video-react .video-react-time-tooltip {\n  display: inline-block;\n  height: 2.4em;\n  position: relative;\n  float: right;\n  right: -1.9em;\n}\n\n.video-react .video-react-tooltip-progress-bar {\n  visibility: hidden;\n}\n\n.video-react .video-react-progress-control .video-react-mouse-display {\n  display: none;\n  position: absolute;\n  width: 1px;\n  height: 100%;\n  background-color: #000;\n  z-index: 1;\n}\n\n.video-react-no-flex .video-react-progress-control .video-react-mouse-display {\n  z-index: 0;\n}\n\n.video-react .video-react-progress-control:hover .video-react-mouse-display {\n  display: block;\n}\n\n.video-react.video-react-user-inactive .video-react-progress-control .video-react-mouse-display,\n.video-react.video-react-user-inactive .video-react-progress-control .video-react-mouse-display:after {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 1s, opacity 1s;\n}\n\n.video-react.video-react-user-inactive.video-react-no-flex .video-react-progress-control .video-react-mouse-display,\n.video-react.video-react-user-inactive.video-react-no-flex .video-react-progress-control .video-react-mouse-display:after {\n  display: none;\n}\n\n.video-react .video-react-mouse-display .video-react-time-tooltip,\n.video-react .video-react-progress-control .video-react-mouse-display:after {\n  color: #fff;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.video-react .video-react-play-control {\n  cursor: pointer;\n  flex: none;\n}\n.video-react .video-react-fullscreen-control {\n  cursor: pointer;\n  flex: none;\n}\n\n.video-react.video-react-fullscreen {\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 9999;\n}\n\n.video-react .video-react-time-control {\n  flex: none;\n  font-size: 1em;\n  line-height: 3em;\n  min-width: 2em;\n  width: auto;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.video-react .video-react-time-divider {\n  line-height: 3em;\n  min-width: 0;\n  min-width: initial;\n  padding: 0;\n}\n\n.video-react .video-react-mute-control,\n.video-react .video-react-volume-menu-button {\n  cursor: pointer;\n  flex: none;\n}\n.video-react .video-react-volume-control {\n  width: 5em;\n  flex: none;\n  display: flex;\n  align-items: center;\n}\n.video-react .video-react-volume-bar {\n  margin: 1.35em 0.45em;\n}\n.video-react .video-react-volume-bar.video-react-slider-horizontal {\n  width: 5em;\n  height: 0.3em;\n}\n.video-react .video-react-volume-bar.video-react-slider-horizontal .video-react-volume-level {\n  width: 100%;\n}\n.video-react .video-react-volume-bar.video-react-slider-vertical {\n  width: 0.3em;\n  height: 5em;\n  margin: 1.35em auto;\n}\n.video-react .video-react-volume-bar.video-react-slider-vertical .video-react-volume-level {\n  height: 100%;\n  width: 100%;\n}\n.video-react .video-react-volume-level {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  border-radius: inherit;\n  background-color: #fff;\n}\n.video-react .video-react-slider-vertical .video-react-volume-level {\n  width: 0.3em;\n}\n.video-react .video-react-slider-horizontal .video-react-volume-level {\n  height: 0.3em;\n}\n.video-react .video-react-menu-button-popup.video-react-volume-menu-button .video-react-menu {\n  display: block;\n  width: 0;\n  height: 0;\n  border-top-color: transparent;\n}\n.video-react .video-react-menu-button-popup.video-react-volume-menu-button-vertical .video-react-menu {\n  left: 0;\n  height: auto;\n  width: inherit;\n  background-color: inherit;\n  border-radius: 4px 4px 0 0;\n}\n.video-react .video-react-menu-button-popup.video-react-volume-menu-button-horizontal .video-react-menu {\n  left: -2em;\n}\n.video-react .video-react-menu-button-popup.video-react-volume-menu-button .video-react-menu-content {\n  height: 0;\n  width: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n.video-react .video-react-volume-menu-button-vertical:hover .video-react-menu-content,\n.video-react .video-react-volume-menu-button-vertical:focus .video-react-menu-content,\n.video-react .video-react-volume-menu-button-vertical.video-react-slider-active .video-react-menu-content,\n.video-react .video-react-volume-menu-button-vertical .video-react-lock-showing .video-react-menu-content {\n  height: auto;\n  width: inherit;\n  background-color: transparent;\n}\n.video-react .video-react-volume-menu-button-horizontal:hover .video-react-menu-content,\n.video-react .video-react-volume-menu-button-horizontal:focus .video-react-menu-content,\n.video-react .video-react-volume-menu-button-horizontal .video-react-slider-active .video-react-menu-content,\n.video-react .video-react-volume-menu-button-horizontal .video-react-lock-showing .video-react-menu-content {\n  height: 2.9em;\n  width: 8em;\n}\n.video-react .video-react-volume-menu-button.video-react-menu-button-inline .video-react-menu-content {\n  background-color: transparent !important;\n}\n\n.video-react .video-react-playback-rate .video-react-playback-rate-value {\n  line-height: 3em;\n  text-align: center;\n}\n.video-react .video-react-playback-rate .video-react-menu {\n  width: 4em;\n  left: 0em;\n}\n\n.video-react .video-react-bezel {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 52px;\n  height: 52px;\n  z-index: 17;\n  margin-left: -26px;\n  margin-top: -26px;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 26px;\n}\n.video-react .video-react-bezel.video-react-bezel-animation {\n  animation: video-react-bezel-fadeout 0.5s linear 1 normal forwards;\n  pointer-events: none;\n}\n.video-react .video-react-bezel.video-react-bezel-animation-alt {\n  animation: video-react-bezel-fadeout-alt 0.5s linear 1 normal forwards;\n  pointer-events: none;\n}\n.video-react .video-react-bezel .video-react-bezel-icon {\n  width: 36px;\n  height: 36px;\n  margin: 8px;\n  font-size: 26px;\n  line-height: 36px;\n  text-align: center;\n}\n@keyframes video-react-bezel-fadeout {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n@keyframes video-react-bezel-fadeout-alt {\n  0% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    transform: scale(2);\n  }\n}\n.video-react .video-react-options-button {\n  cursor: pointer;\n  flex: none;\n}\n.video-react video::-webkit-media-text-track-container {\n  transform: translateY(-30px);\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
styleInject(css_248z$1);
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var objectWithoutPropertiesLoose$1 = _objectWithoutPropertiesLoose$1;
var _extends_1$1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  module.exports = _extends;
});
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var assertThisInitialized$1 = _assertThisInitialized$1;
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defineProperty$1 = _defineProperty$2;
var toStr = Object.prototype.toString;
var isArguments = function isArguments(value) {
  var str = toStr.call(value);
  var isArgs = str === '[object Arguments]';
  if (!isArgs) {
    isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
  }
  return isArgs;
};
var keysShim;
if (!Object.keys) {
  // modified from https://github.com/es-shims/es5-shim
  var has$4 = Object.prototype.hasOwnProperty;
  var toStr$1 = Object.prototype.toString;
  var isArgs = isArguments; // eslint-disable-line global-require
  var isEnumerable = Object.prototype.propertyIsEnumerable;
  var hasDontEnumBug = !isEnumerable.call({
    toString: null
  }, 'toString');
  var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
  var dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];
  var equalsConstructorPrototype = function equalsConstructorPrototype(o) {
    var ctor = o.constructor;
    return ctor && ctor.prototype === o;
  };
  var excludedKeys = {
    $applicationCache: true,
    $console: true,
    $external: true,
    $frame: true,
    $frameElement: true,
    $frames: true,
    $innerHeight: true,
    $innerWidth: true,
    $onmozfullscreenchange: true,
    $onmozfullscreenerror: true,
    $outerHeight: true,
    $outerWidth: true,
    $pageXOffset: true,
    $pageYOffset: true,
    $parent: true,
    $scrollLeft: true,
    $scrollTop: true,
    $scrollX: true,
    $scrollY: true,
    $self: true,
    $webkitIndexedDB: true,
    $webkitStorageInfo: true,
    $window: true
  };
  var hasAutomationEqualityBug = function () {
    /* global window */
    if (typeof window === 'undefined') {
      return false;
    }
    for (var k in window) {
      try {
        if (!excludedKeys['$' + k] && has$4.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
          try {
            equalsConstructorPrototype(window[k]);
          } catch (e) {
            return true;
          }
        }
      } catch (e) {
        return true;
      }
    }
    return false;
  }();
  var equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
    /* global window */
    if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
      return equalsConstructorPrototype(o);
    }
    try {
      return equalsConstructorPrototype(o);
    } catch (e) {
      return false;
    }
  };
  keysShim = function keys(object) {
    var isObject = object !== null && typeof object === 'object';
    var isFunction = toStr$1.call(object) === '[object Function]';
    var isArguments = isArgs(object);
    var isString = isObject && toStr$1.call(object) === '[object String]';
    var theKeys = [];
    if (!isObject && !isFunction && !isArguments) {
      throw new TypeError('Object.keys called on a non-object');
    }
    var skipProto = hasProtoEnumBug && isFunction;
    if (isString && object.length > 0 && !has$4.call(object, 0)) {
      for (var i = 0; i < object.length; ++i) {
        theKeys.push(String(i));
      }
    }
    if (isArguments && object.length > 0) {
      for (var j = 0; j < object.length; ++j) {
        theKeys.push(String(j));
      }
    } else {
      for (var name in object) {
        if (!(skipProto && name === 'prototype') && has$4.call(object, name)) {
          theKeys.push(String(name));
        }
      }
    }
    if (hasDontEnumBug) {
      var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
      for (var k = 0; k < dontEnums.length; ++k) {
        if (!(skipConstructor && dontEnums[k] === 'constructor') && has$4.call(object, dontEnums[k])) {
          theKeys.push(dontEnums[k]);
        }
      }
    }
    return theKeys;
  };
}
var implementation = keysShim;
var slice = Array.prototype.slice;
var origKeys = Object.keys;
var keysShim$1 = origKeys ? function keys(o) {
  return origKeys(o);
} : implementation;
var originalKeys = Object.keys;
keysShim$1.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function () {
      // Safari 5.0 bug
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys(object) {
        // eslint-disable-line func-name-matching
        if (isArguments(object)) {
          return originalKeys(slice.call(object));
        }
        return originalKeys(object);
      };
    }
  } else {
    Object.keys = keysShim$1;
  }
  return Object.keys || keysShim$1;
};
var objectKeys = keysShim$1;
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var toStr$2 = Object.prototype.toString;
var isStandardArguments = function isArguments(value) {
  if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
    return false;
  }
  return toStr$2.call(value) === '[object Arguments]';
};
var isLegacyArguments = function isArguments(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr$2.call(value) !== '[object Array]' && toStr$2.call(value.callee) === '[object Function]';
};
var supportsStandardArguments = function () {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var toStr$3 = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction$1 = function isFunction$1(fn) {
  return typeof fn === 'function' && toStr$3.call(fn) === '[object Function]';
};
var arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
  var obj = {};
  try {
    origDefineProperty(obj, 'x', {
      enumerable: false,
      value: obj
    });
    // eslint-disable-next-line no-unused-vars, no-restricted-syntax
    for (var _ in obj) {
      // jscs:ignore disallowUnusedVariables
      return false;
    }
    return obj.x === obj;
  } catch (e) {
    /* this is IE 8. */
    return false;
  }
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
var defineProperty$2 = function defineProperty$2(object, name, value, predicate) {
  if (name in object && (!isFunction$1(predicate) || !predicate())) {
    return;
  }
  if (supportsDescriptors) {
    origDefineProperty(object, name, {
      configurable: true,
      enumerable: false,
      value: value,
      writable: true
    });
  } else {
    object[name] = value;
  }
};
var defineProperties = function defineProperties(object, map) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = objectKeys(map);
  if (hasSymbols) {
    props = concat.call(props, Object.getOwnPropertySymbols(map));
  }
  for (var i = 0; i < props.length; i += 1) {
    defineProperty$2(object, props[i], map[props[i]], predicates[props[i]]);
  }
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
var defineProperties_1 = defineProperties;

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice$1 = Array.prototype.slice;
var toStr$4 = Object.prototype.toString;
var funcType = '[object Function]';
var implementation$1 = function bind(that) {
  var target = this;
  if (typeof target !== 'function' || toStr$4.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice$1.call(arguments, 1);
  var bound;
  var binder = function binder() {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice$1.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice$1.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs.push('$' + i);
  }
  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
  if (target.prototype) {
    var Empty = function Empty() {};
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};
var functionBind = Function.prototype.bind || implementation$1;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }
  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }
  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);
  if (typeof sym === 'string') {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  }

  // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }

  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax
  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = commonjsGlobal.Symbol;
var hasSymbols$1 = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }
  if (typeof Symbol !== 'function') {
    return false;
  }
  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }
  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }
  return shams();
};

/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined$1;
var $TypeError = TypeError;
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, '');
  } catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function throwTypeError() {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$2 = hasSymbols$1();
var getProto = Object.getPrototypeOf || function (x) {
  return x.__proto__;
}; // eslint-disable-line no-proto
var generatorFunction = undefined$1;
var asyncFunction = undefined$1;
var asyncGenFunction = undefined$1;
var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);
var INTRINSICS = {
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
  '%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer.prototype,
  '%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
  '%ArrayPrototype%': Array.prototype,
  '%ArrayProto_entries%': Array.prototype.entries,
  '%ArrayProto_forEach%': Array.prototype.forEach,
  '%ArrayProto_keys%': Array.prototype.keys,
  '%ArrayProto_values%': Array.prototype.values,
  '%AsyncFromSyncIteratorPrototype%': undefined$1,
  '%AsyncFunction%': asyncFunction,
  '%AsyncFunctionPrototype%': undefined$1,
  '%AsyncGenerator%': undefined$1,
  '%AsyncGeneratorFunction%': asyncGenFunction,
  '%AsyncGeneratorPrototype%': undefined$1,
  '%AsyncIteratorPrototype%': undefined$1,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
  '%Boolean%': Boolean,
  '%BooleanPrototype%': Boolean.prototype,
  '%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
  '%DataViewPrototype%': typeof DataView === 'undefined' ? undefined$1 : DataView.prototype,
  '%Date%': Date,
  '%DatePrototype%': Date.prototype,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': Error,
  '%ErrorPrototype%': Error.prototype,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': EvalError,
  '%EvalErrorPrototype%': EvalError.prototype,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
  '%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array.prototype,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
  '%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array.prototype,
  '%Function%': Function,
  '%FunctionPrototype%': Function.prototype,
  '%Generator%': undefined$1,
  '%GeneratorFunction%': generatorFunction,
  '%GeneratorPrototype%': undefined$1,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
  '%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array.prototype,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
  '%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined$1 : Int8Array.prototype,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
  '%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array.prototype,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
  '%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined$1,
  '%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
  '%MapPrototype%': typeof Map === 'undefined' ? undefined$1 : Map.prototype,
  '%Math%': Math,
  '%Number%': Number,
  '%NumberPrototype%': Number.prototype,
  '%Object%': Object,
  '%ObjectPrototype%': Object.prototype,
  '%ObjProto_toString%': Object.prototype.toString,
  '%ObjProto_valueOf%': Object.prototype.valueOf,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
  '%PromisePrototype%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype,
  '%PromiseProto_then%': typeof Promise === 'undefined' ? undefined$1 : Promise.prototype.then,
  '%Promise_all%': typeof Promise === 'undefined' ? undefined$1 : Promise.all,
  '%Promise_reject%': typeof Promise === 'undefined' ? undefined$1 : Promise.reject,
  '%Promise_resolve%': typeof Promise === 'undefined' ? undefined$1 : Promise.resolve,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
  '%RangeError%': RangeError,
  '%RangeErrorPrototype%': RangeError.prototype,
  '%ReferenceError%': ReferenceError,
  '%ReferenceErrorPrototype%': ReferenceError.prototype,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
  '%RegExp%': RegExp,
  '%RegExpPrototype%': RegExp.prototype,
  '%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
  '%SetPrototype%': typeof Set === 'undefined' ? undefined$1 : Set.prototype,
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
  '%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer.prototype,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
  '%StringPrototype%': String.prototype,
  '%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
  '%SymbolPrototype%': hasSymbols$2 ? Symbol.prototype : undefined$1,
  '%SyntaxError%': SyntaxError,
  '%SyntaxErrorPrototype%': SyntaxError.prototype,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined$1,
  '%TypeError%': $TypeError,
  '%TypeErrorPrototype%': $TypeError.prototype,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
  '%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array.prototype,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
  '%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray.prototype,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
  '%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array.prototype,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
  '%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array.prototype,
  '%URIError%': URIError,
  '%URIErrorPrototype%': URIError.prototype,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
  '%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap.prototype,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet,
  '%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet.prototype
};
var $replace = functionBind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath$1 = function stringToPath(string) {
  var result = [];
  $replace(string, rePropName$1, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar$1, '$1') : number || match;
  });
  return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  if (!(name in INTRINSICS)) {
    throw new SyntaxError('intrinsic ' + name + ' does not exist!');
  }

  // istanbul ignore if // hopefully this is impossible to test :-)
  if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
    throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
  }
  return INTRINSICS[name];
};
var GetIntrinsic = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new TypeError('intrinsic name must be a non-empty string');
  }
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new TypeError('"allowMissing" argument must be a boolean');
  }
  var parts = stringToPath$1(name);
  var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
  for (var i = 1; i < parts.length; i += 1) {
    if (value != null) {
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, parts[i]);
        if (!allowMissing && !(parts[i] in value)) {
          throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
        }
        value = desc ? desc.get || desc.value : value[parts[i]];
      } else {
        value = value[parts[i]];
      }
    }
  }
  return value;
};
var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;
var callBind = function callBind() {
  return functionBind.apply($call, arguments);
};
var apply = function applyBind() {
  return functionBind.apply($apply, arguments);
};
callBind.apply = apply;
var numberIsNaN = function numberIsNaN(value) {
  return value !== value;
};
var implementation$2 = function is(a, b) {
  if (a === 0 && b === 0) {
    return 1 / a === 1 / b;
  }
  if (a === b) {
    return true;
  }
  if (numberIsNaN(a) && numberIsNaN(b)) {
    return true;
  }
  return false;
};
var polyfill = function getPolyfill() {
  return typeof Object.is === 'function' ? Object.is : implementation$2;
};
var shim = function shimObjectIs() {
  var polyfill$1 = polyfill();
  defineProperties_1(Object, {
    is: polyfill$1
  }, {
    is: function testObjectIs() {
      return Object.is !== polyfill$1;
    }
  });
  return polyfill$1;
};
var polyfill$1 = callBind(polyfill(), Object);
defineProperties_1(polyfill$1, {
  getPolyfill: polyfill,
  implementation: implementation$2,
  shim: shim
});
var objectIs = polyfill$1;
var hasSymbols$3 = hasSymbols$1();
var hasToStringTag$1 = hasSymbols$3 && typeof Symbol.toStringTag === 'symbol';
var regexExec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag$1) {
  regexExec = Function.call.bind(RegExp.prototype.exec);
  isRegexMarker = {};
  var throwRegexMarker = function throwRegexMarker() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === 'symbol') {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var toStr$5 = Object.prototype.toString;
var regexClass = '[object RegExp]';
var isRegex = hasToStringTag$1
// eslint-disable-next-line consistent-return
? function isRegex(value) {
  if (!value || typeof value !== 'object') {
    return false;
  }
  try {
    regexExec(value, badStringifier);
  } catch (e) {
    return e === isRegexMarker;
  }
} : function isRegex(value) {
  // In older browsers, typeof regex incorrectly returns 'function'
  if (!value || typeof value !== 'object' && typeof value !== 'function') {
    return false;
  }
  return toStr$5.call(value) === regexClass;
};
var $Object = Object;
var $TypeError$1 = TypeError;
var implementation$3 = function flags() {
  if (this != null && this !== $Object(this)) {
    throw new $TypeError$1('RegExp.prototype.flags getter called on non-object');
  }
  var result = '';
  if (this.global) {
    result += 'g';
  }
  if (this.ignoreCase) {
    result += 'i';
  }
  if (this.multiline) {
    result += 'm';
  }
  if (this.dotAll) {
    result += 's';
  }
  if (this.unicode) {
    result += 'u';
  }
  if (this.sticky) {
    result += 'y';
  }
  return result;
};
var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD$1 = Object.getOwnPropertyDescriptor;
var $TypeError$2 = TypeError;
var polyfill$2 = function getPolyfill() {
  if (!supportsDescriptors$1) {
    throw new $TypeError$2('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }
  if (/a/mig.flags === 'gim') {
    var descriptor = $gOPD$1(RegExp.prototype, 'flags');
    if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') {
      return descriptor.get;
    }
  }
  return implementation$3;
};
var supportsDescriptors$2 = defineProperties_1.supportsDescriptors;
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty$3 = Object.defineProperty;
var TypeErr = TypeError;
var getProto$1 = Object.getPrototypeOf;
var regex = /a/;
var shim$1 = function shimFlags() {
  if (!supportsDescriptors$2 || !getProto$1) {
    throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
  }
  var polyfill = polyfill$2();
  var proto = getProto$1(regex);
  var descriptor = gOPD(proto, 'flags');
  if (!descriptor || descriptor.get !== polyfill) {
    defineProperty$3(proto, 'flags', {
      configurable: true,
      enumerable: false,
      get: polyfill
    });
  }
  return polyfill;
};
var flagsBound = callBind(implementation$3);
defineProperties_1(flagsBound, {
  getPolyfill: polyfill$2,
  implementation: implementation$3,
  shim: shim$1
});
var regexp_prototype_flags = flagsBound;
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e) {
    return false;
  }
};
var toStr$6 = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var isDateObject = function isDateObject(value) {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  return hasToStringTag$2 ? tryDateObject(value) : toStr$6.call(value) === dateClass;
};
var getTime = Date.prototype.getTime;
function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? objectIs(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') {
    return opts.strict ? objectIs(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}
function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}
function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) {
    return false;
  }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
    return false;
  }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) {
    return false;
  }
  if (isArguments$1(a) !== isArguments$1(b)) {
    return false;
  }
  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && regexp_prototype_flags(a) === regexp_prototype_flags(b);
  }
  if (isDateObject(a) && isDateObject(b)) {
    return getTime.call(a) === getTime.call(b);
  }
  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    // && would work too, because both are true or both false here
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) {
    // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) {
    return false;
  }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) {
      return false;
    }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) {
      return false;
    }
  }
  return true;
}
var deepEqual_1 = deepEqual;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$3 = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser$3 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser$3 && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
    overflow = _getStyleComputedProp.overflow,
    overflowX = _getStyleComputedProp.overflowX,
    overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser$3 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$3 && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}
var classCallCheck$1 = function classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty$4 = function defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$2({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}
  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }
  return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };
  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = {
    top: 0,
    left: 0
  };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
        height = _getWindowSizes.height,
        width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  if (placement.indexOf('auto') === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$2({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
      height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split('-')[1];
  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$2(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
      enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }
  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, {
    passive: true
  });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, {
    passive: true
  });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, {
    position: options.positionFixed ? 'fixed' : 'absolute'
  });
  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var round = Math.round,
    floor = Math.floor;
  var noRound = function noRound(v) {
    return v;
  };
  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser$3 && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
    y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
    top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$2({}, attributes, data.attributes);
  data.styles = _extends$2({}, styles, data.styles);
  data.arrowStyles = _extends$2({}, data.offsets.arrow, data.arrowStyles);
  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }
  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }
  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$4(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$4(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }
    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$2({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }
  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
    _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var basePlacement = placement.split('-')[0];
  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }
  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
    left = popperStyles.left,
    transform = popperStyles[transformProp];
  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$4({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$4({}, mainSide, value);
    }
  };
  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$2({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
      reference = _data$offsets.reference,
      popper = _data$offsets.popper;
    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    var shiftOffsets = {
      start: defineProperty$4({}, side, reference[side]),
      end: defineProperty$4({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$2({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
    popper = _data$offsets.popper,
    reference = _data$offsets.reference;
  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck$1(this, Popper);
    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$1(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$2({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$2({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$2({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$2({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs

  createClass$1(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);

  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
var key = '__global_unique_id__';
var gud = function gud() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var warning$1 = function warning$1() {};
{
  var printWarning$4 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
  warning$1 = function warning$1(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning$4.apply(null, [format].concat(args));
    }
  };
}
var warning_1 = warning$1;
var implementation$4 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  var _react2 = _interopRequireDefault(React__default);
  var _propTypes2 = _interopRequireDefault(propTypes);
  var _gud2 = _interopRequireDefault(gud);
  var _warning2 = _interopRequireDefault(warning_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MAX_SIGNED_31_BIT_INT = 1073741823;

  // Inlined Object.is polyfill.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  function objectIs(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function (h) {
          return h !== handler;
        });
      },
      get: function get() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function (handler) {
          return handler(value, changedBits);
        });
      }
    };
  }
  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }
  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
    var Provider = function (_Component) {
      _inherits(Provider, _Component);
      function Provider() {
        var _temp, _this, _ret;
        _classCallCheck(this, Provider);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
      }
      Provider.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[contextProp] = this.emitter, _ref;
      };
      Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;
          if (objectIs(oldValue, newValue)) {
            changedBits = 0; // No change
          } else {
            changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            {
              (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
            }
            changedBits |= 0;
            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };
      Provider.prototype.render = function render() {
        return this.props.children;
      };
      return Provider;
    }(React__default.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function (_Component2) {
      _inherits(Consumer, _Component2);
      function Consumer() {
        var _temp2, _this2, _ret2;
        _classCallCheck(this, Consumer);
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function (newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;
          if ((observedBits & changedBits) !== 0) {
            _this2.setState({
              value: _this2.getValue()
            });
          }
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
      }
      Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };
      Consumer.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }
        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
        : observedBits;
      };
      Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };
      Consumer.prototype.getValue = function getValue() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };
      Consumer.prototype.render = function render() {
        return onlyChild(this.props.children)(this.state.value);
      };
      return Consumer;
    }(React__default.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
      Provider: Provider,
      Consumer: Consumer
    };
  }
  exports.default = createReactContext;
  module.exports = exports['default'];
});
unwrapExports(implementation$4);
var lib$2 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  var _react2 = _interopRequireDefault(React__default);
  var _implementation2 = _interopRequireDefault(implementation$4);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  exports.default = _react2.default.createContext || _implementation2.default;
  module.exports = exports['default'];
});
var createContext = unwrapExports(lib$2);
var ManagerReferenceNodeContext = createContext();
var ManagerReferenceNodeSetterContext = createContext();
var Manager = /*#__PURE__*/
function (_React$Component) {
  inheritsLoose(Manager, _React$Component);
  function Manager() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    defineProperty$1(assertThisInitialized$1(_this), "referenceNode", void 0);
    defineProperty$1(assertThisInitialized$1(_this), "setReferenceNode", function (newReferenceNode) {
      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
        _this.referenceNode = newReferenceNode;
        _this.forceUpdate();
      }
    });
    return _this;
  }
  var _proto = Manager.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.referenceNode = null;
  };
  _proto.render = function render() {
    return React.createElement(ManagerReferenceNodeContext.Provider, {
      value: this.referenceNode
    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: this.setReferenceNode
    }, this.props.children));
  };
  return Manager;
}(React.Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn.apply(void 0, args);
  }
};
/**
 * Does a shallow equality check of two objects by comparing the reference
 * equality of each value.
 */

var shallowEqual = function shallowEqual(objA, objB) {
  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);
  if (bKeys.length !== aKeys.length) {
    return false;
  }
  for (var i = 0; i < bKeys.length; i++) {
    var key = aKeys[i];
    if (objA[key] !== objB[key]) {
      return false;
    }
  }
  return true;
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
    ref.current = node;
  }
};
var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper = /*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerPopper, _React$Component);
  function InnerPopper() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    defineProperty$1(assertThisInitialized$1(_this), "state", {
      data: undefined,
      placement: undefined
    });
    defineProperty$1(assertThisInitialized$1(_this), "popperInstance", void 0);
    defineProperty$1(assertThisInitialized$1(_this), "popperNode", null);
    defineProperty$1(assertThisInitialized$1(_this), "arrowNode", null);
    defineProperty$1(assertThisInitialized$1(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      setRef(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;
      _this.updatePopperInstance();
    });
    defineProperty$1(assertThisInitialized$1(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });
    defineProperty$1(assertThisInitialized$1(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;
        _this.setState({
          data: data,
          placement: placement
        });
        return data;
      }
    });
    defineProperty$1(assertThisInitialized$1(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends_1$1({}, _this.props.modifiers, {
          arrow: _extends_1$1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });
    defineProperty$1(assertThisInitialized$1(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends_1$1({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });
    defineProperty$1(assertThisInitialized$1(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });
    defineProperty$1(assertThisInitialized$1(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });
    defineProperty$1(assertThisInitialized$1(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });
    defineProperty$1(assertThisInitialized$1(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;
      _this.popperInstance.destroy();
      _this.popperInstance = null;
    });
    defineProperty$1(assertThisInitialized$1(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();
      var _assertThisInitialize = assertThisInitialized$1(_this),
        popperNode = _assertThisInitialize.popperNode;
      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });
    defineProperty$1(assertThisInitialized$1(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });
    return _this;
  }
  var _proto = InnerPopper.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !deepEqual_1(this.props.modifiers, prevProps.modifiers, {
      strict: true
    })) {
      // develop only check that modifiers isn't being updated needlessly
      {
        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && shallowEqual(this.props.modifiers, prevProps.modifiers)) {
          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
        }
      }
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.

    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
    this.destroyPopperInstance();
  };
  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };
  return InnerPopper;
}(React.Component);
defineProperty$1(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});
function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
    props = objectWithoutPropertiesLoose$1(_ref, ["referenceElement"]);
  return React.createElement(ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
    return React.createElement(InnerPopper, _extends_1$1({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}
var InnerReference = /*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerReference, _React$Component);
  function InnerReference() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    defineProperty$1(assertThisInitialized$1(_this), "refHandler", function (node) {
      setRef(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });
    return _this;
  }
  var _proto = InnerReference.prototype;
  _proto.componentWillUnmount = function componentWillUnmount() {
    setRef(this.props.innerRef, null);
  };
  _proto.render = function render() {
    warning_1(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };
  return InnerReference;
}(React.Component);
function Reference(props) {
  return React.createElement(ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
    return React.createElement(InnerReference, _extends_1$1({
      setReferenceNode: setReferenceNode
    }, props));
  });
}
var chainFunction = function chain() {
  var len = arguments.length;
  var args = [];
  for (var i = 0; i < len; i++) args[i] = arguments[i];
  args = args.filter(function (fn) {
    return fn != null;
  });
  if (args.length === 0) return undefined;
  if (args.length === 1) return args[0];
  return args.reduce(function (current, next) {
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  });
};

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var warning$2 = function warning$2() {};
{
  warning$2 = function warning$2(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }
    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}
var warning_1$1 = warning$2;
var ChildMapping = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.getChildMapping = getChildMapping;
  exports.mergeChildMappings = mergeChildMappings;

  /**
   * Given `this.props.children`, return an object mapping key to child.
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */
  function getChildMapping(children) {
    if (!children) {
      return children;
    }
    var result = {};
    React__default.Children.map(children, function (child) {
      return child;
    }).forEach(function (child) {
      result[child.key] = child;
    });
    return result;
  }

  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */
  function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
      if (next.hasOwnProperty(key)) {
        return next[key];
      }
      return prev[key];
    }

    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = {};
    var pendingKeys = [];
    for (var prevKey in prev) {
      if (next.hasOwnProperty(prevKey)) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }
    var i = void 0;
    var childMapping = {};
    for (var nextKey in next) {
      if (nextKeysPending.hasOwnProperty(nextKey)) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }
      childMapping[nextKey] = getValueForKey(nextKey);
    }

    // Finally, add the keys which didn't appear before any key in `next`
    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }
    return childMapping;
  }
});
unwrapExports(ChildMapping);
var ChildMapping_1 = ChildMapping.getChildMapping;
var ChildMapping_2 = ChildMapping.mergeChildMappings;
var TransitionGroup_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _chainFunction2 = _interopRequireDefault(chainFunction);
  var _react2 = _interopRequireDefault(React__default);
  var _propTypes2 = _interopRequireDefault(propTypes);
  var _warning2 = _interopRequireDefault(warning_1$1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var propTypes$1 = {
    component: _propTypes2.default.any,
    childFactory: _propTypes2.default.func,
    children: _propTypes2.default.node
  };
  var defaultProps = {
    component: 'span',
    childFactory: function childFactory(child) {
      return child;
    }
  };
  var TransitionGroup = function (_React$Component) {
    _inherits(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
      _classCallCheck(this, TransitionGroup);
      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
      _this.performAppear = function (key, component) {
        _this.currentlyTransitioningKeys[key] = true;
        if (component.componentWillAppear) {
          component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
        } else {
          _this._handleDoneAppearing(key, component);
        }
      };
      _this._handleDoneAppearing = function (key, component) {
        if (component.componentDidAppear) {
          component.componentDidAppear();
        }
        delete _this.currentlyTransitioningKeys[key];
        var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
          // This was removed before it had fully appeared. Remove it.
          _this.performLeave(key, component);
        }
      };
      _this.performEnter = function (key, component) {
        _this.currentlyTransitioningKeys[key] = true;
        if (component.componentWillEnter) {
          component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
        } else {
          _this._handleDoneEntering(key, component);
        }
      };
      _this._handleDoneEntering = function (key, component) {
        if (component.componentDidEnter) {
          component.componentDidEnter();
        }
        delete _this.currentlyTransitioningKeys[key];
        var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
          // This was removed before it had fully entered. Remove it.
          _this.performLeave(key, component);
        }
      };
      _this.performLeave = function (key, component) {
        _this.currentlyTransitioningKeys[key] = true;
        if (component.componentWillLeave) {
          component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
        } else {
          // Note that this is somewhat dangerous b/c it calls setState()
          // again, effectively mutating the component before all the work
          // is done.
          _this._handleDoneLeaving(key, component);
        }
      };
      _this._handleDoneLeaving = function (key, component) {
        if (component.componentDidLeave) {
          component.componentDidLeave();
        }
        delete _this.currentlyTransitioningKeys[key];
        var currentChildMapping = (0, ChildMapping.getChildMapping)(_this.props.children);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
          // This entered again before it fully left. Add it again.
          _this.keysToEnter.push(key);
        } else {
          _this.setState(function (state) {
            var newChildren = _extends({}, state.children);
            delete newChildren[key];
            return {
              children: newChildren
            };
          });
        }
      };
      _this.childRefs = Object.create(null);
      _this.state = {
        children: (0, ChildMapping.getChildMapping)(props.children)
      };
      return _this;
    }
    TransitionGroup.prototype.componentWillMount = function componentWillMount() {
      this.currentlyTransitioningKeys = {};
      this.keysToEnter = [];
      this.keysToLeave = [];
    };
    TransitionGroup.prototype.componentDidMount = function componentDidMount() {
      var initialChildMapping = this.state.children;
      for (var key in initialChildMapping) {
        if (initialChildMapping[key]) {
          this.performAppear(key, this.childRefs[key]);
        }
      }
    };
    TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var nextChildMapping = (0, ChildMapping.getChildMapping)(nextProps.children);
      var prevChildMapping = this.state.children;
      this.setState({
        children: (0, ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
      });
      for (var key in nextChildMapping) {
        var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
        if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
          this.keysToEnter.push(key);
        }
      }
      for (var _key in prevChildMapping) {
        var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
        if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
          this.keysToLeave.push(_key);
        }
      }

      // If we want to someday check for reordering, we could do it here.
    };

    TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
      var _this2 = this;
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(function (key) {
        return _this2.performEnter(key, _this2.childRefs[key]);
      });
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(function (key) {
        return _this2.performLeave(key, _this2.childRefs[key]);
      });
    };
    TransitionGroup.prototype.render = function render() {
      var _this3 = this;

      // TODO: we could get rid of the need for the wrapper node
      // by cloning a single child
      var childrenToRender = [];
      var _loop = function _loop(key) {
        var child = _this3.state.children[key];
        if (child) {
          var isCallbackRef = typeof child.ref !== 'string';
          var factoryChild = _this3.props.childFactory(child);
          var ref = function ref(r) {
            _this3.childRefs[key] = r;
          };
          (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute');

          // Always chaining the refs leads to problems when the childFactory
          // wraps the child. The child ref callback gets called twice with the
          // wrapper and the child. So we only need to chain the ref if the
          // factoryChild is not different from child.
          if (factoryChild === child && isCallbackRef) {
            ref = (0, _chainFunction2.default)(child.ref, ref);
          }

          // You may need to apply reactive updates to a child as it is leaving.
          // The normal React way to do it won't work since the child will have
          // already been removed. In case you need this behavior you can provide
          // a childFactory function to wrap every child, even the ones that are
          // leaving.
          childrenToRender.push(_react2.default.cloneElement(factoryChild, {
            key: key,
            ref: ref
          }));
        }
      };
      for (var key in this.state.children) {
        _loop(key);
      }

      // Do not forward TransitionGroup props to primitive DOM nodes
      var props = _extends({}, this.props);
      delete props.transitionLeave;
      delete props.transitionName;
      delete props.transitionAppear;
      delete props.transitionEnter;
      delete props.childFactory;
      delete props.transitionLeaveTimeout;
      delete props.transitionEnterTimeout;
      delete props.transitionAppearTimeout;
      delete props.component;
      return _react2.default.createElement(this.props.component, props, childrenToRender);
    };
    return TransitionGroup;
  }(_react2.default.Component);
  TransitionGroup.displayName = 'TransitionGroup';
  TransitionGroup.propTypes = propTypes$1;
  TransitionGroup.defaultProps = defaultProps;
  exports.default = TransitionGroup;
  module.exports = exports['default'];
});
unwrapExports(TransitionGroup_1);
var interopRequireDefault$1 = createCommonjsModule(function (module) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  module.exports = _interopRequireDefault;
});
unwrapExports(interopRequireDefault$1);
var hasClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = hasClass;
  function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }
  module.exports = exports["default"];
});
unwrapExports(hasClass_1);
var addClass_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = addClass;
  var _hasClass = interopRequireDefault$1(hasClass_1);
  function addClass(element, className) {
    if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
  }
  module.exports = exports["default"];
});
unwrapExports(addClass_1);
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
var removeClass = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};
var inDOM = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;
  var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(inDOM);
var requestAnimationFrame$1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = void 0;
  var _inDOM = interopRequireDefault$1(inDOM);
  var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
  var cancel = 'clearTimeout';
  var raf = fallback;
  var compatRaf;
  var getKey = function getKey(vendor, k) {
    return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
  };
  if (_inDOM.default) {
    vendors.some(function (vendor) {
      var rafKey = getKey(vendor, 'request');
      if (rafKey in window) {
        cancel = getKey(vendor, 'cancel');
        return raf = function raf(cb) {
          return window[rafKey](cb);
        };
      }
    });
  }
  /* https://github.com/component/raf */

  var prev = new Date().getTime();
  function fallback(fn) {
    var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
    prev = curr;
    return req;
  }
  compatRaf = function compatRaf(cb) {
    return raf(cb);
  };
  compatRaf.cancel = function (id) {
    window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
  };
  var _default = compatRaf;
  exports.default = _default;
  module.exports = exports["default"];
});
unwrapExports(requestAnimationFrame$1);
var properties = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
  var _inDOM = interopRequireDefault$1(inDOM);
  var transform = 'transform';
  exports.transform = transform;
  var prefix, transitionEnd, animationEnd;
  exports.animationEnd = animationEnd;
  exports.transitionEnd = transitionEnd;
  var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
  exports.transitionDelay = transitionDelay;
  exports.transitionTiming = transitionTiming;
  exports.transitionDuration = transitionDuration;
  exports.transitionProperty = transitionProperty;
  var animationName, animationDuration, animationTiming, animationDelay;
  exports.animationDelay = animationDelay;
  exports.animationTiming = animationTiming;
  exports.animationDuration = animationDuration;
  exports.animationName = animationName;
  if (_inDOM.default) {
    var _getTransitionPropert = getTransitionProperties();
    prefix = _getTransitionPropert.prefix;
    exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
    exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
    exports.transform = transform = prefix + "-" + transform;
    exports.transitionProperty = transitionProperty = prefix + "-transition-property";
    exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
    exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
    exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
    exports.animationName = animationName = prefix + "-animation-name";
    exports.animationDuration = animationDuration = prefix + "-animation-duration";
    exports.animationTiming = animationTiming = prefix + "-animation-delay";
    exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
  }
  var _default = {
    transform: transform,
    end: transitionEnd,
    property: transitionProperty,
    timing: transitionTiming,
    delay: transitionDelay,
    duration: transitionDuration
  };
  exports.default = _default;
  function getTransitionProperties() {
    var style = document.createElement('div').style;
    var vendorMap = {
      O: function O(e) {
        return "o" + e.toLowerCase();
      },
      Moz: function Moz(e) {
        return e.toLowerCase();
      },
      Webkit: function Webkit(e) {
        return "webkit" + e;
      },
      ms: function ms(e) {
        return "MS" + e;
      }
    };
    var vendors = Object.keys(vendorMap);
    var transitionEnd, animationEnd;
    var prefix = '';
    for (var i = 0; i < vendors.length; i++) {
      var vendor = vendors[i];
      if (vendor + "TransitionProperty" in style) {
        prefix = "-" + vendor.toLowerCase();
        transitionEnd = vendorMap[vendor]('TransitionEnd');
        animationEnd = vendorMap[vendor]('AnimationEnd');
        break;
      }
    }
    if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
    if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
    style = null;
    return {
      animationEnd: animationEnd,
      transitionEnd: transitionEnd,
      prefix: prefix
    };
  }
});
unwrapExports(properties);
var properties_1 = properties.animationEnd;
var properties_2 = properties.animationDelay;
var properties_3 = properties.animationTiming;
var properties_4 = properties.animationDuration;
var properties_5 = properties.animationName;
var properties_6 = properties.transitionEnd;
var properties_7 = properties.transitionDuration;
var properties_8 = properties.transitionDelay;
var properties_9 = properties.transitionTiming;
var properties_10 = properties.transitionProperty;
var properties_11 = properties.transform;
var PropTypes = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  exports.nameShape = undefined;
  exports.transitionTimeout = transitionTimeout;
  var _react2 = _interopRequireDefault(React__default);
  var _propTypes2 = _interopRequireDefault(propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function transitionTimeout(transitionType) {
    var timeoutPropName = 'transition' + transitionType + 'Timeout';
    var enabledPropName = 'transition' + transitionType;
    return function (props) {
      // If the transition is enabled
      if (props[enabledPropName]) {
        // If no timeout duration is provided
        if (props[timeoutPropName] == null) {
          return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

          // If the duration isn't a number
        } else if (typeof props[timeoutPropName] !== 'number') {
          return new Error(timeoutPropName + ' must be a number (in milliseconds)');
        }
      }
      return null;
    };
  }
  var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    leave: _propTypes2.default.string,
    active: _propTypes2.default.string
  }), _propTypes2.default.shape({
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    leave: _propTypes2.default.string,
    leaveActive: _propTypes2.default.string,
    appear: _propTypes2.default.string,
    appearActive: _propTypes2.default.string
  })]);
});
unwrapExports(PropTypes);
var PropTypes_1 = PropTypes.nameShape;
var PropTypes_2 = PropTypes.transitionTimeout;
var CSSTransitionGroupChild_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _addClass2 = _interopRequireDefault(addClass_1);
  var _removeClass2 = _interopRequireDefault(removeClass);
  var _requestAnimationFrame2 = _interopRequireDefault(requestAnimationFrame$1);
  var _react2 = _interopRequireDefault(React__default);
  var _propTypes2 = _interopRequireDefault(propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var events = [];
  if (properties.transitionEnd) events.push(properties.transitionEnd);
  if (properties.animationEnd) events.push(properties.animationEnd);
  function addEndListener(node, listener) {
    if (events.length) {
      events.forEach(function (e) {
        return node.addEventListener(e, listener, false);
      });
    } else {
      setTimeout(listener, 0);
    }
    return function () {
      if (!events.length) return;
      events.forEach(function (e) {
        return node.removeEventListener(e, listener, false);
      });
    };
  }
  var propTypes$1 = {
    children: _propTypes2.default.node,
    name: PropTypes.nameShape.isRequired,
    // Once we require timeouts to be specified, we can remove the
    // boolean flags (appear etc.) and just accept a number
    // or a bool for the timeout flags (appearTimeout etc.)
    appear: _propTypes2.default.bool,
    enter: _propTypes2.default.bool,
    leave: _propTypes2.default.bool,
    appearTimeout: _propTypes2.default.number,
    enterTimeout: _propTypes2.default.number,
    leaveTimeout: _propTypes2.default.number
  };
  var CSSTransitionGroupChild = function (_React$Component) {
    _inherits(CSSTransitionGroupChild, _React$Component);
    function CSSTransitionGroupChild() {
      var _temp, _this, _ret;
      _classCallCheck(this, CSSTransitionGroupChild);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
        if (_this.props.appear) {
          _this.transition('appear', done, _this.props.appearTimeout);
        } else {
          done();
        }
      }, _this.componentWillEnter = function (done) {
        if (_this.props.enter) {
          _this.transition('enter', done, _this.props.enterTimeout);
        } else {
          done();
        }
      }, _this.componentWillLeave = function (done) {
        if (_this.props.leave) {
          _this.transition('leave', done, _this.props.leaveTimeout);
        } else {
          done();
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
      this.classNameAndNodeQueue = [];
      this.transitionTimeouts = [];
    };
    CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.transitionTimeouts.forEach(function (timeout) {
        clearTimeout(timeout);
      });
      this.classNameAndNodeQueue.length = 0;
    };
    CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
      var node = (0, reactDom.findDOMNode)(this);
      if (!node) {
        if (finishCallback) {
          finishCallback();
        }
        return;
      }
      var className = this.props.name[animationType] || this.props.name + '-' + animationType;
      var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
      var timer = null;
      var removeListeners = void 0;
      (0, _addClass2.default)(node, className);

      // Need to do this to actually trigger a transition.
      this.queueClassAndNode(activeClassName, node);

      // Clean-up the animation after the specified delay
      var finish = function finish(e) {
        if (e && e.target !== node) {
          return;
        }
        clearTimeout(timer);
        if (removeListeners) removeListeners();
        (0, _removeClass2.default)(node, className);
        (0, _removeClass2.default)(node, activeClassName);
        if (removeListeners) removeListeners();

        // Usually this optional callback is used for informing an owner of
        // a leave animation and telling it to remove the child.
        if (finishCallback) {
          finishCallback();
        }
      };
      if (timeout) {
        timer = setTimeout(finish, timeout);
        this.transitionTimeouts.push(timer);
      } else if (properties.transitionEnd) {
        removeListeners = addEndListener(node, finish);
      }
    };
    CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
      var _this2 = this;
      this.classNameAndNodeQueue.push({
        className: className,
        node: node
      });
      if (!this.rafHandle) {
        this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
          return _this2.flushClassNameAndNodeQueue();
        });
      }
    };
    CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
      if (!this.unmounted) {
        this.classNameAndNodeQueue.forEach(function (obj) {
          // This is for to force a repaint,
          // which is necessary in order to transition styles when adding a class name.
          /* eslint-disable no-unused-expressions */
          obj.node.scrollTop;
          /* eslint-enable no-unused-expressions */
          (0, _addClass2.default)(obj.node, obj.className);
        });
      }
      this.classNameAndNodeQueue.length = 0;
      this.rafHandle = null;
    };
    CSSTransitionGroupChild.prototype.render = function render() {
      var props = _extends({}, this.props);
      delete props.name;
      delete props.appear;
      delete props.enter;
      delete props.leave;
      delete props.appearTimeout;
      delete props.enterTimeout;
      delete props.leaveTimeout;
      delete props.children;
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
    };
    return CSSTransitionGroupChild;
  }(_react2.default.Component);
  CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';
  CSSTransitionGroupChild.propTypes = propTypes$1;
  exports.default = CSSTransitionGroupChild;
  module.exports = exports['default'];
});
unwrapExports(CSSTransitionGroupChild_1);
var CSSTransitionGroup_1 = createCommonjsModule(function (module, exports) {
  exports.__esModule = true;
  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _react2 = _interopRequireDefault(React__default);
  var _propTypes2 = _interopRequireDefault(propTypes);
  var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1);
  var _CSSTransitionGroupChild2 = _interopRequireDefault(CSSTransitionGroupChild_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var propTypes$1 = {
    transitionName: PropTypes.nameShape.isRequired,
    transitionAppear: _propTypes2.default.bool,
    transitionEnter: _propTypes2.default.bool,
    transitionLeave: _propTypes2.default.bool,
    transitionAppearTimeout: (0, PropTypes.transitionTimeout)('Appear'),
    transitionEnterTimeout: (0, PropTypes.transitionTimeout)('Enter'),
    transitionLeaveTimeout: (0, PropTypes.transitionTimeout)('Leave')
  };
  var defaultProps = {
    transitionAppear: false,
    transitionEnter: true,
    transitionLeave: true
  };
  var CSSTransitionGroup = function (_React$Component) {
    _inherits(CSSTransitionGroup, _React$Component);
    function CSSTransitionGroup() {
      var _temp, _this, _ret;
      _classCallCheck(this, CSSTransitionGroup);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
        return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
          name: _this.props.transitionName,
          appear: _this.props.transitionAppear,
          enter: _this.props.transitionEnter,
          leave: _this.props.transitionLeave,
          appearTimeout: _this.props.transitionAppearTimeout,
          enterTimeout: _this.props.transitionEnterTimeout,
          leaveTimeout: _this.props.transitionLeaveTimeout
        }, child);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // We need to provide this childFactory so that
    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
    // leave while it is leaving.

    CSSTransitionGroup.prototype.render = function render() {
      return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, {
        childFactory: this._wrapChild
      }));
    };
    return CSSTransitionGroup;
  }(_react2.default.Component);
  CSSTransitionGroup.displayName = 'CSSTransitionGroup';
  CSSTransitionGroup.propTypes = propTypes$1;
  CSSTransitionGroup.defaultProps = defaultProps;
  exports.default = CSSTransitionGroup;
  module.exports = exports['default'];
});
unwrapExports(CSSTransitionGroup_1);
var reactTransitionGroup = createCommonjsModule(function (module) {
  var _CSSTransitionGroup2 = _interopRequireDefault(CSSTransitionGroup_1);
  var _TransitionGroup2 = _interopRequireDefault(TransitionGroup_1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  module.exports = {
    TransitionGroup: _TransitionGroup2.default,
    CSSTransitionGroup: _CSSTransitionGroup2.default
  };
});
unwrapExports(reactTransitionGroup);
var reactTransitionGroup_1 = reactTransitionGroup.TransitionGroup;
var reactTransitionGroup_2 = reactTransitionGroup.CSSTransitionGroup;
var css_248z$2 = ".transitionCss_appear__2rkUf {\n  opacity: 0.01; }\n\n.transitionCss_appearActive__10N-A {\n  opacity: 1;\n  transition: opacity 200ms linear; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRyYW5zaXRpb25Dc3Muc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWEsRUFBRTs7QUFFakI7RUFDRSxVQUFVO0VBQ1YsZ0NBQWdDLEVBQUUiLCJmaWxlIjoidHJhbnNpdGlvbkNzcy5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmFwcGVhciB7XG4gIG9wYWNpdHk6IDAuMDE7IH1cblxuLmFwcGVhckFjdGl2ZSB7XG4gIG9wYWNpdHk6IDE7XG4gIHRyYW5zaXRpb246IG9wYWNpdHkgMjAwbXMgbGluZWFyOyB9XG4iXX0= */";
var cssStyles$1 = {
  "appear": "transitionCss_appear__2rkUf",
  "appearActive": "transitionCss_appearActive__10N-A"
};
styleInject(css_248z$2);
var TipAlign = {
  above: 'above',
  below: 'below',
  right: 'right',
  left: 'left',
  center: 'center'
};
var TipPosition = {
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left'
};
var centerText = 'line-height: 22px;';
var arrowAlign = 'calc(95% - 27px)';
var arrowTopBottom = "\n  width: 18px;\n  height: 0px;\n";
var arrowRightLeft = "\n  width: 6px;\n  height: 6px;\n";
var arrowBorderWidth = 'border-width: 9px;';
var length = 24;
var minHeight = "min-height: ".concat(length, "px;");
var halfLength = "calc(50% - ".concat(length / 2, "px)");
var bubbleBorderRadius = 'border-radius: 10px;';
var tipText = {
  display: 'inline',
  centerText: centerText
};
var getBubbleColor = function getBubbleColor(isDark) {
  return isDark ? {
    backgroundColor: ui.greyDark[700],
    color: ui.white[500],
    border: 'none'
  } : {
    backgroundColor: ui.white[500],
    color: ui.greyDark[500],
    border: "solid 1px ".concat(ui.greyLight[300])
  };
};
var bubbleStyle = function bubbleStyle(isDark) {
  var bubbleColor = getBubbleColor(isDark);
  return /*#__PURE__*/css("background-color:", bubbleColor.backgroundColor, ";color:", bubbleColor.color, ";border:", bubbleColor.border, ";max-width:380px;", minHeight, " padding:8px;box-shadow:0 16px 16px 0 rgba(0,0,0,0.24);z-index:1;", family.circular, " ", size.S, " pointer-events:none;display:table;");
};
var tipBubbleDark = "\n  background-color: ".concat(ui.greyDark[700], ";\n  color: ").concat(ui.white[500], ";\n  :before {\n    background-color: ").concat(ui.greyDark[700], ";\n  }\n");
var tipBubbleLight = "\n  background-color: ".concat(ui.white[500], "};\n  color: ").concat(ui.greyDark[500], ";\n  border: solid 1px ").concat(ui.greyLight[300], ";\n  :before {\n    background-color: ").concat(ui.white[500], "};\n  }\n");
var tipPositionLeft = "\n  &[data-placement*='bottom'], &[data-placement*='top'] {\n    &::before {\n      left: 10%;\n    }\n  }\n";
var tipPositionRight = "\n  &[data-placement*='bottom'], &[data-placement*='top'] {\n    &::before {\n      left: ".concat(arrowAlign, ";\n    }\n  }\n");
var tipPositionAbove = "\n  &[data-placement*='right'], &[data-placement*='left'] {\n    &::before {\n      top: 15%;\n    }\n  }\n";
var tipPositionBelow = "\n  &[data-placement*='right'], &[data-placement*='left'] {\n    &::before {\n      top: ".concat(arrowAlign, ";\n    }\n  }\n");
var arrowStyle = function arrowStyle(isDark) {
  var tipColor = getBubbleColor(isDark);
  return /*#__PURE__*/css("&[data-placement*='bottom']{", arrowTopBottom, " &:before{", arrowBorderWidth, " border-color:", tipColor.backgroundColor, " transparent transparent  ", tipColor.backgroundColor, ";top:-8px;box-shadow:-5px -3px 5px -6px ", ui.greyDark[500], ",-3px -5px 5px -6px ", ui.greyDark[500], ";}}&[data-placement*='top']{", arrowTopBottom, " &:before{", arrowBorderWidth, " bottom:-8px;border-color:transparent ", tipColor.backgroundColor, " ", tipColor.backgroundColor, " transparent;box-shadow:5px 3px 5px -6px ", ui.greyDark[500], ",3px 5px 5px -6px ", ui.greyDark[500], ";}}&[data-placement*='right']{&:before{top:", halfLength, ";left:-6px;", arrowBorderWidth, " border-color:transparent transparent ", tipColor.backgroundColor, " ", tipColor.backgroundColor, ";box-shadow:-5px 6px 8px -5px ", ui.greyDark[500], ";}}&[data-placement*='left']{&:before{top:", halfLength, ";left:calc(100% - 16px);", arrowBorderWidth, " border-color:", tipColor.backgroundColor, " ", tipColor.backgroundColor, " transparent transparent;box-shadow:5px -6px 8px -5px ", ui.greyDark[500], ";}}&:before{content:'';margin:auto;display:block;", arrowRightLeft, " border-style:solid;border-radius:2px;transform:rotate(45deg);left:", halfLength, ";position:absolute;}");
};
var cornerStyle = function cornerStyle(hasRoundedCorners) {
  if (hasRoundedCorners) {
    return /*#__PURE__*/css("{", bubbleBorderRadius, "}");
  }
};
var left = /*#__PURE__*/css(tipPositionLeft, ";label:left;");
var right = /*#__PURE__*/css(tipPositionRight, ";label:right;");
var above = /*#__PURE__*/css(tipPositionAbove, ";label:above;");
var below = /*#__PURE__*/css(tipPositionBelow, ";label:below;");
var textStyle = tipText;
var tooltipPopperProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  children: propTypes.node,
  /*
  * Sets the position of the entire tooltip top, bottom, left, or right
  * of its children. Popper will override this if the tooltip is out of
  * the screen view.
  */
  position: propTypes.oneOf(Object.keys(TipPosition)),
  /*
   * Determines if tooltip has light or dark background.
   */
  isDark: propTypes.bool,
  /*
   * Defines tooltip message
   */
  message: propTypes.string,
  /*
   * Determines if tooltip has rounder or sharp corners
   */
  hasRoundedCorners: propTypes.bool,
  /*
   * Defines alignment of the tip of the tooltip
   * relative to the edge of the bubble where the tip sits.
   */
  tooltipAlign: propTypes.oneOf(Object.keys(TipAlign)),
  /*
   * Optional horizontal offset amount.
   * This moves the whole tooltip.
   */
  tooltipHorizontalOffset: propTypes.number,
  /*
   * Optional vertical offset amount
   * This moves the whole tooltip.
   */
  tooltipVerticalOffset: propTypes.number,
  /*
   * A function to override default message styles
   */
  __renderTooltipContent: propTypes.func,
  /*
   * An object to customize aria props
   */
  aria: propTypes.object
});
var tooltipAlignStyles = {
  above: above,
  below: below,
  right: right,
  left: left
};
var TooltipPopper = function TooltipPopper(props) {
  var children = props.children,
    position = props.position,
    additionalClassName = props.additionalClassName,
    message = props.message,
    isDark = props.isDark,
    hasRoundedCorners = props.hasRoundedCorners,
    tooltipHorizontalOffset = props.tooltipHorizontalOffset,
    tooltipVerticalOffset = props.tooltipVerticalOffset,
    __renderTooltipContent = props.__renderTooltipContent,
    tooltipAlign = props.tooltipAlign,
    closeTooltip = props.closeTooltip,
    aria = props.aria;
  var addEventListeners = function addEventListeners() {
    window.addEventListener('keydown', escFunction, false);
  };
  var removeEventListeners = function removeEventListeners() {
    window.removeEventListener('keydown', escFunction);
  };
  var escFunction = function escFunction(e) {
    if (e.keyCode === 27) {
      e.preventDefault();
      closeTooltip();
    }
  };
  React.useEffect(function () {
    addEventListeners();
    return removeEventListeners;
  }, []);
  var firstOffset;
  var secondOffset;
  if (position === TipPosition.top || position === TipPosition.bottom) {
    firstOffset = tooltipHorizontalOffset || 0;
    secondOffset = tooltipVerticalOffset || 0;
  } else {
    firstOffset = tooltipVerticalOffset || 0;
    secondOffset = tooltipHorizontalOffset || 0;
  }
  /**
   * This functions is called on the ariaProps object. If no ariaProps object is passed to the component,
   * an object is created and sets the aria-label to the tooltips's children props if it is a string. In the
   * case that the tooltips's child is not a string (ex: if it's an icon), a console warning is thrown.
   **/

  var checkAriaProps = function checkAriaProps(obj) {
    var ariaObj = {};
    var childrenValue = typeof children === 'string' ? children : null;
    if (obj && !obj['aria-label'] || !obj) {
      typeof childrenValue !== 'string' && console.warn('A button requires either a plain string child (ex: not a DOM element rendering a string) or an explicit aria-label provided via the ariaProp.');
      ariaObj = _objectSpread3({
        'aria-label': childrenValue
      }, obj);
      return ariaObj;
    }
    return obj;
  };
  var checkedAriaProps = checkAriaProps(aria);
  var idString = "".concat(checkedAriaProps['aria-label'], "_dialog").replace(' ', '_');
  return jsx(Popper$1, {
    placement: TipPosition[position],
    modifiers: {
      offset: {
        offset: "".concat(firstOffset, "px ").concat(secondOffset, "px")
      },
      flip: {
        enabled: false
      },
      preventOverflow: {
        enabled: false
      }
    }
  }, function (_ref15) {
    var ref = _ref15.ref,
      style = _ref15.style,
      placement = _ref15.placement,
      arrowProps = _ref15.arrowProps;
    return jsx(reactTransitionGroup_2, {
      transitionAppear: true,
      transitionAppearTimeout: 250,
      transitionEnter: false,
      transitionLeave: false,
      transitionName: {
        appear: cssStyles$1.appear,
        appearActive: cssStyles$1.appearActive
      }
    }, jsx("div", _extends({
      "aria-modal": "true",
      "aria-hidden": "false",
      role: "dialog"
    }, checkedAriaProps, {
      id: idString,
      ref: ref,
      style: style,
      "data-placement": placement,
      css: /*#__PURE__*/css([bubbleStyle(isDark), cornerStyle(hasRoundedCorners), additionalClassName], ";label:TooltipPopper;")
    }), __renderTooltipContent ? __renderTooltipContent(textStyle) : jsx("p", {
      css: textStyle
    }, message), jsx("div", {
      css: /*#__PURE__*/css([arrowStyle(isDark), tooltipAlignStyles[tooltipAlign]], ";label:TooltipPopper;"),
      ref: arrowProps.ref,
      "data-placement": placement
    })));
  });
};
TooltipPopper.propTypes = tooltipPopperProps;
TooltipPopper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TooltipPopper",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.keys(TipPosition)"
      },
      "required": false,
      "description": ""
    },
    "isDark": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "hasRoundedCorners": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tooltipAlign": {
      "type": {
        "name": "enum",
        "computed": true,
        "value": "Object.keys(TipAlign)"
      },
      "required": false,
      "description": ""
    },
    "tooltipHorizontalOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tooltipVerticalOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "__renderTooltipContent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "aria": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var tipAlignKeys = Object.keys(TipAlign);
var tipPositionKeys = Object.keys(TipPosition);
var tooltipProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  children: propTypes.node.isRequired,
  /*
  * Sets the position of the entire tooltip top, bottom, left, or right
  * of its children. Popper will override this if the tooltip is out of
  * the screen view.
  */
  position: propTypes.oneOf([].concat(tipPositionKeys)),
  /*
   * Dismiss either on click or mouseout
   */
  dismissOnMouseout: propTypes.bool,
  /*
   * Sets if the tooltip is open on default
   */
  isOpenByDefault: propTypes.bool,
  /*
   * Determines if tooltip has light or dark background.
   */
  isDark: propTypes.bool,
  /*
   * Defines tooltip message
   */
  message: propTypes.string,
  /*
   * Determines if tooltip has rounder or sharp corners
   */
  hasRoundedCorners: propTypes.bool,
  /*
   * Defines alignment of the tip of the tooltip
   * relative to the edge of the bubble where the tip sits.
   */
  tooltipAlign: propTypes.oneOf([].concat(tipAlignKeys)),
  /*
   * Optional horizontal offset amount.
   * This moves the whole tooltip.
   */
  tooltipHorizontalOffset: propTypes.number,
  /*
   * Optional vertical offset amount
   * This moves the whole tooltip.
   */
  tooltipVerticalOffset: propTypes.number,
  /*
   * A function to override default message styles
   */
  __renderTooltipContent: propTypes.func,
  /*
   * An object to customize aria props
   */
  aria: propTypes.object
});
var defaultProps$1 = {
  isOpenByDefault: false,
  position: TipPosition.top,
  isDark: true,
  dismissOnMouseout: true
};
var Tooltip = function Tooltip(props) {
  var children = props.children;
  var dismissOnMouseout = props.dismissOnMouseout,
    isOpenByDefault = props.isOpenByDefault,
    popperProps = _objectWithoutProperties3(props, _excluded6);
  var _React$useState7 = React.useState(isOpenByDefault),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isVisible = _React$useState8[0],
    setIsVisible = _React$useState8[1];
  var openTooltip = function openTooltip() {
    setIsVisible(true);
  };
  var closeTooltip = function closeTooltip() {
    setIsVisible(false);
  };
  return jsx(Manager, null, jsx(Reference, null, function (_ref16) {
    var ref = _ref16.ref;
    return jsx("span", {
      ref: ref,
      onMouseEnter: openTooltip,
      onFocus: openTooltip,
      onMouseLeave: function onMouseLeave() {
        if (dismissOnMouseout) {
          closeTooltip();
        }
      },
      onBlur: closeTooltip
    }, children);
  }), isVisible && jsx(TooltipPopper, _extends({}, popperProps, {
    closeTooltip: closeTooltip
  })));
};
Tooltip.propTypes = tooltipProps;
Tooltip.defaultProps = defaultProps$1;
Tooltip.align = TipAlign;
Tooltip.position = TipPosition;
Tooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tooltip",
  "props": {
    "isOpenByDefault": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "position": {
      "defaultValue": {
        "value": "TipPosition.top",
        "computed": true
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "...tipPositionKeys",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "isDark": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissOnMouseout": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "message": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "hasRoundedCorners": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tooltipAlign": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "...tipAlignKeys",
          "computed": true
        }]
      },
      "required": false,
      "description": ""
    },
    "tooltipHorizontalOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tooltipVerticalOffset": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "__renderTooltipContent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "aria": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var audioOff = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Audio%20Off%20%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-13-Copy%22%20transform%3D%22translate%286.000000%2C%206.000000%29%22%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Close-X--Light-Grey-Dark-Theme-Copy-8%22%20transform%3D%22translate%2815.454545%2C%204.545455%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0.2574647%2C10.6528198%20C0.423400405%2C10.8128292%200.655444895%2C10.9090909%200.888153128%2C10.9090909%20C1.12019762%2C10.9090909%201.33604678%2C10.8290862%201.51884156%2C10.6528198%20L5.66723418%2C6.65258406%20L9.81562681%2C10.6528198%20C9.98156251%2C10.8128292%2010.213607%2C10.9090909%2010.4463152%2C10.9090909%20C10.6783597%2C10.9090909%2010.8942089%2C10.8290862%2011.0770037%2C10.6528198%20C11.4257341%2C10.316544%2011.4257341%2C9.77276794%2011.0770037%2C9.45274908%20L6.92861104%2C5.45251333%20L11.0770037%2C1.45227759%20C11.4257341%2C1.11600177%2011.4257341%2C0.572225723%2011.0770037%2C0.252206863%20C10.7282732%2C-0.0840689545%2010.1812164%2C-0.0840689545%209.83248588%2C0.252206863%20L5.68409325%2C4.25244261%20L1.53570062%2C0.252206863%20C1.18697015%2C-0.0840689545%200.639913313%2C-0.0840689545%200.291182835%2C0.252206863%20C-0.0575476426%2C0.588482681%20-0.0575476426%2C1.13225873%200.291182835%2C1.45227759%20L4.43957546%2C5.45251333%20L0.291182835%2C9.45274908%20C-0.0912491843%2C9.7890249%20-0.0912491843%2C10.316544%200.257477975%2C10.6528198%20L0.2574647%2C10.6528198%20Z%22%20id%3D%22Close-thin%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.15532993%2C14.3600365%20L5.53259308%2C14.3600365%20L10.7520995%2C19.6740105%20C11.4793113%2C20.372627%2012.7272727%2C19.8734533%2012.7272727%2C18.8863758%20L12.7272727%2C1.11361075%20C12.7272727%2C0.126536193%2011.4804824%2C-0.372611595%2010.7520995%2C0.325976081%20L5.59024396%2C5.485625%20L1.15532963%2C5.485625%20C0.519608579%2C5.485625%200%2C5.98480163%200%2C6.59552499%20L0%2C13.2525596%20C0%2C13.8722828%200.519608579%2C14.3601808%201.15532963%2C14.3601808%20L1.15532993%2C14.3600365%20Z%22%20id%3D%22Fill-1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var audioOn = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Audio%20On%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2-Copy-5%22%20transform%3D%22translate%287.000000%2C%206.000000%29%22%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.02332473%2C13.7244481%20L4.90045239%2C13.7244481%20L9.52359069%2C18.6239162%20C10.167713%2C19.2680386%2011.2730854%2C18.8078019%2011.2730854%2C17.8977194%20L11.2730854%2C1.51128324%20C11.2730854%2C0.601203457%2010.1687503%2C0.140990691%209.52359069%2C0.785086436%20L4.95151622%2C5.54226729%20L1.02332447%2C5.54226729%20C0.460239362%2C5.54226729%207.40148683e-14%2C6.00250665%207.40148683e-14%2C6.56559176%20L7.40148683e-14%2C12.7033577%20C7.40148683e-14%2C13.2747407%200.460239362%2C13.7245811%201.02332447%2C13.7245811%20L1.02332473%2C13.7244481%20Z%22%20id%3D%22Fill-1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M20.6762237%2C0.299980053%20C20.2762503%2C-0.0999933511%2019.6290162%2C-0.0999933511%2019.2300801%2C0.299980053%20C18.8301066%2C0.699953457%2018.8301066%2C1.3471875%2019.2300801%2C1.74612367%20C21.3515162%2C3.86755984%2022.5202396%2C6.6934641%2022.5202396%2C9.70303856%20C22.5202396%2C12.712613%2021.3514896%2C15.537613%2019.2300801%2C17.6599535%20C18.8301066%2C18.0599269%2018.8301066%2C18.7071609%2019.2300801%2C19.1060971%20C19.6300535%2C19.5060705%2020.2772875%2C19.5060705%2020.6762237%2C19.1060971%20C23.1841226%2C16.5992354%2024.5658513%2C13.2592886%2024.5658513%2C9.70317154%20C24.5658513%2C6.14705452%2023.1841226%2C2.80795878%2020.6762237%2C0.300246011%20L20.6762237%2C0.299980053%20Z%22%20id%3D%22Fill-2%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M17.7828726%2C3.19306516%20C17.3828992%2C2.79309176%2016.7356652%2C2.79309176%2016.336729%2C3.19306516%20C15.9367556%2C3.59303856%2015.9367556%2C4.24027261%2016.336729%2C4.63920878%20C19.1282184%2C7.43176197%2019.1282184%2C11.9748471%2016.336729%2C14.7663364%20C15.9367556%2C15.1663098%2015.9367556%2C15.8135439%2016.336729%2C16.2124801%20C16.7367024%2C16.6124535%2017.3839364%2C16.6124535%2017.7828726%2C16.2124801%20C21.3722343%2C12.6241822%2021.3722343%2C6.78136303%2017.7828726%2C3.19306516%20Z%22%20id%3D%22Fill-3%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13.4421811%2C13.3204588%20C13.8421545%2C13.7204322%2014.4893886%2C13.7204322%2014.8883247%2C13.3204588%20C15.8544949%2C12.3542886%2016.3864098%2C11.0702194%2016.3864098%2C9.70290559%20C16.3864098%2C8.33676197%2015.8544949%2C7.05269282%2014.8883247%2C6.08641622%20C14.4883513%2C5.68644282%2013.8400801%2C5.68644282%2013.4421811%2C6.08641622%20C13.0422077%2C6.48638963%2013.0422077%2C7.13362367%2013.4421811%2C7.53255984%20C14.0218886%2C8.11226729%2014.3408247%2C8.88208112%2014.3408247%2C9.70176197%20C14.3408247%2C10.5214428%2014.0218886%2C11.2933577%2013.4421811%2C11.8720279%20C13.0432449%2C12.2730386%2013.0432449%2C12.9202726%2013.4421811%2C13.320246%20L13.4421811%2C13.3204588%20Z%22%20id%3D%22Fill-4%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var back15 = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Back%20%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Triangle%22%20fill%3D%22%23FFFFFF%22%20transform%3D%22translate%284.000000%2C%206.500000%29%20rotate%28-90.000000%29%20translate%28-4.000000%2C%20-6.500000%29%20%22%20points%3D%224%204%208%209%200%209%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8.44686729%2C17.2416363%20C8.44686729%2C22.078747%2012.3681203%2C26%2017.205231%2C26%20L22.6246413%2C26%20C28.0094177%2C26%2032.3746413%2C21.6347763%2032.3746413%2C16.25%20C32.3746413%2C10.8652237%2028.0094177%2C6.5%2022.6246413%2C6.5%20L6.44686729%2C6.5%20L6.44686729%2C6.5%22%20id%3D%22Path-2%22%20stroke%3D%22%23FFFFFF%22%20stroke-width%3D%221.5%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3Ctext%20id%3D%2215%22%20font-family%3D%22Circular-Book%2C%20Circular%22%20font-size%3D%2216%22%20font-weight%3D%22300%22%20line-spacing%3D%2212%22%20fill%3D%22%23FFFFFF%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Ctspan%20x%3D%2211.056%22%20y%3D%2221.6721191%22%3E15%20%3C%2Ftspan%3E%20%20%20%20%20%20%20%20%3C%2Ftext%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var collapse = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Collapse%20%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle-Copy-9%22%20stroke%3D%22%23FFFFFF%22%20x%3D%223%22%20y%3D%223%22%20width%3D%2232%22%20height%3D%2226%22%20rx%3D%223%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.3235909%2C17.8%20L11.2465755%2C22.8632776%20L11.2465755%2C19.5311284%20C11.2490285%2C19.3632947%2011.1840039%2C19.2003597%2011.0662228%2C19.0815313%20C10.9484417%2C18.9614767%2010.7864943%2C18.8940968%2010.6184033%2C18.8940968%20C10.4515468%2C18.8965461%2010.2932647%2C18.9651492%2010.1767399%2C19.0839807%20C10.0614118%2C19.2040353%209.99761522%2C19.3645178%2010%2C19.5311316%20L10%2C24.3727051%20C10%2C24.7194054%2010.2810248%2C25%2010.6282341%2C25%20L15.4770469%2C25%20C15.6451316%2C25.0023825%2015.8070853%2C24.937455%2015.9260913%2C24.8186266%20C16.0463254%2C24.7010213%2016.1138061%2C24.5405388%2016.1138061%2C24.3726988%20C16.1138061%2C24.2048588%2016.0463286%2C24.0443763%2015.9260913%2C23.9255479%20C15.8070821%2C23.8079426%2015.6451347%2C23.7430151%2015.4770469%2C23.7454644%20L12.1399154%2C23.7454644%20L17.2%2C18.6870172%20L16.3235909%2C17.8%20Z%22%20id%3D%22Fill-1-Copy%22%20fill%3D%22%23FFFFFF%22%20transform%3D%22translate%2813.600000%2C%2021.400000%29%20scale%28-1%2C%20-1%29%20translate%28-13.600000%2C%20-21.400000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M27.1235909%2C7%20L22.0465755%2C12.0632776%20L22.0465755%2C8.73112842%20C22.0490285%2C8.56329473%2021.9840039%2C8.4003597%2021.8662228%2C8.28153134%20C21.7484417%2C8.16147675%2021.5864943%2C8.09409677%2021.4184033%2C8.09409677%20C21.2515468%2C8.0965461%2021.0932647%2C8.16514917%2020.9767399%2C8.28398066%20C20.8614118%2C8.40403525%2020.7976152%2C8.56451783%2020.8%2C8.73113156%20L20.8%2C13.5727051%20C20.8%2C13.9194054%2021.0810248%2C14.2%2021.4282341%2C14.2%20L26.2770469%2C14.2%20C26.4451316%2C14.2023825%2026.6070853%2C14.137455%2026.7260913%2C14.0186266%20C26.8463254%2C13.9010213%2026.9138061%2C13.7405388%2026.9138061%2C13.5726988%20C26.9138061%2C13.4048588%2026.8463286%2C13.2443763%2026.7260913%2C13.1255479%20C26.6070821%2C13.0079426%2026.4451347%2C12.9430151%2026.2770469%2C12.9454644%20L22.9399154%2C12.9454644%20L28%2C7.88701715%20L27.1235909%2C7%20Z%22%20id%3D%22Fill-1-Copy-2%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var expand = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Expand%20%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle-Copy-9%22%20stroke%3D%22%23FFFFFF%22%20x%3D%223%22%20y%3D%223%22%20width%3D%2232%22%20height%3D%2226%22%20rx%3D%223%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.3235909%2C17.8%20L11.2465755%2C22.8632776%20L11.2465755%2C19.5311284%20C11.2490285%2C19.3632947%2011.1840039%2C19.2003597%2011.0662228%2C19.0815313%20C10.9484417%2C18.9614767%2010.7864943%2C18.8940968%2010.6184033%2C18.8940968%20C10.4515468%2C18.8965461%2010.2932647%2C18.9651492%2010.1767399%2C19.0839807%20C10.0614118%2C19.2040353%209.99761522%2C19.3645178%2010%2C19.5311316%20L10%2C24.3727051%20C10%2C24.7194054%2010.2810248%2C25%2010.6282341%2C25%20L15.4770469%2C25%20C15.6451316%2C25.0023825%2015.8070853%2C24.937455%2015.9260913%2C24.8186266%20C16.0463254%2C24.7010213%2016.1138061%2C24.5405388%2016.1138061%2C24.3726988%20C16.1138061%2C24.2048588%2016.0463286%2C24.0443763%2015.9260913%2C23.9255479%20C15.8070821%2C23.8079426%2015.6451347%2C23.7430151%2015.4770469%2C23.7454644%20L12.1399154%2C23.7454644%20L17.2%2C18.6870172%20L16.3235909%2C17.8%20Z%22%20id%3D%22Fill-1-Copy%22%20fill%3D%22%23FFFFFF%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M27.1235909%2C7%20L22.0465755%2C12.0632776%20L22.0465755%2C8.73112842%20C22.0490285%2C8.56329473%2021.9840039%2C8.4003597%2021.8662228%2C8.28153134%20C21.7484417%2C8.16147675%2021.5864943%2C8.09409677%2021.4184033%2C8.09409677%20C21.2515468%2C8.0965461%2021.0932647%2C8.16514917%2020.9767399%2C8.28398066%20C20.8614118%2C8.40403525%2020.7976152%2C8.56451783%2020.8%2C8.73113156%20L20.8%2C13.5727051%20C20.8%2C13.9194054%2021.0810248%2C14.2%2021.4282341%2C14.2%20L26.2770469%2C14.2%20C26.4451316%2C14.2023825%2026.6070853%2C14.137455%2026.7260913%2C14.0186266%20C26.8463254%2C13.9010213%2026.9138061%2C13.7405388%2026.9138061%2C13.5726988%20C26.9138061%2C13.4048588%2026.8463286%2C13.2443763%2026.7260913%2C13.1255479%20C26.6070821%2C13.0079426%2026.4451347%2C12.9430151%2026.2770469%2C12.9454644%20L22.9399154%2C12.9454644%20L28%2C7.88701715%20L27.1235909%2C7%20Z%22%20id%3D%22Fill-1-Copy-2%22%20fill%3D%22%23FFFFFF%22%20transform%3D%22translate%2824.400000%2C%2010.600000%29%20scale%28-1%2C%20-1%29%20translate%28-24.400000%2C%20-10.600000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var options = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2238px%22%20height%3D%2232px%22%20viewBox%3D%220%200%2038%2032%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EVideo%20Icon%20Options%20%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M8%2C12%20C9.1045695%2C12%2010%2C12.8954305%2010%2C14%20C10%2C15.1045695%209.1045695%2C16%208%2C16%20C6.8954305%2C16%206%2C15.1045695%206%2C14%20C6%2C12.8954305%206.8954305%2C12%208%2C12%20Z%20M8%2C6%20C9.1045695%2C6%2010%2C6.8954305%2010%2C8%20C10%2C9.1045695%209.1045695%2C10%208%2C10%20C6.8954305%2C10%206%2C9.1045695%206%2C8%20C6%2C6.8954305%206.8954305%2C6%208%2C6%20Z%20M8%2C0%20C9.1045695%2C0%2010%2C0.8954305%2010%2C2%20C10%2C3.1045695%209.1045695%2C4%208%2C4%20C6.8954305%2C4%206%2C3.1045695%206%2C2%20C6%2C0.8954305%206.8954305%2C0%208%2C0%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22button%2Ficon%2Fbasic%2Fwhite%2Fdefault%22%20transform%3D%22translate%283.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22icon%2Fellipsis-vertical%22%20transform%3D%22translate%288.000000%2C%208.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23000000%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20mask%3D%22url%28%23mask-2%29%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2216%22%20height%3D%2216%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
var xs$1 = BreakpointNames.xs,
  lg$1 = BreakpointNames.lg; // QUESTION: Should media queries be the breaking point or the width of the video player?

var iconMargins = '0.3rem 0';
var progressBarMargins = '0 0.5rem';
var timeDisplayMarginTop = '0.8rem';
var darkGradientFadeTo = function darkGradientFadeTo(orientation) {
  return /*#__PURE__*/css("background-color:transparent;min-height:5rem;background-image:linear-gradient(to ", orientation, ",rgba(0,0,0,0.5) 50%,transparent 100%);");
};
var displayFlex = {
  name: "12jcid2-displayFlex",
  styles: "display:flex;;label:displayFlex;"
};
var tooltipBorderRadius = {
  name: "1fa7xa4-tooltipBorderRadius",
  styles: "border-radius:4px;;label:tooltipBorderRadius;"
};
var volumeBar = {
  name: "qbv848-volumeBar",
  styles: "&&&&{width:0.5rem;border-radius:40px;background-color:transparent;border:1px solid white;box-shadow:none;height:7rem;};label:volumeBar;"
};
var bigPlayButton = /*#__PURE__*/css("&&&{background:none;border:none;font-size:4rem;opacity:0.7;z-index:1;&:focus{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;background:none;}", mediaQuery.downTo(lg$1), "{font-size:10rem;}};label:bigPlayButton;");
var toolBar = /*#__PURE__*/css("&&&{", darkGradientFadeTo('top'), " padding-top:1.75rem;flex-wrap:wrap;", displayFlex, " justify-content:space-between;};label:toolBar;");
var toolBarInvisible = {
  name: "11snlvt-toolBarInvisible",
  styles: "opacity:0;transition:opacity 1.0s;;label:toolBarInvisible;"
};
var videoButtonIconStyle = {
  name: "go5bh-videoButtonIconStyle",
  styles: "&&&{max-height:2rem;&:hover,&:focus{background-color:rgba(0,0,0,0.8);text-shadow:none;border-radius:4px;outline:none;}};label:videoButtonIconStyle;"
};
var volumeHoverIconStyle = {
  name: "ub4oji-volumeHoverIconStyle",
  styles: "&&&{&:hover,&:focus{border-radius:0 0 4px 4px;}};label:volumeHoverIconStyle;"
};
var hideOldIcon = {
  name: "130z9xg-hideOldIcon",
  styles: "&&&{&:before{display:none;}};label:hideOldIcon;"
};
var smallPlayButton = /*#__PURE__*/css("&&&{margin:", iconMargins, ";margin-left:1rem;margin-right:0.5rem;max-width:2.5rem;&:before{text-shadow:none;font-size:2rem;line-height:2rem;}", videoButtonIconStyle, "};label:smallPlayButton;");
var timeDisplay = /*#__PURE__*/css("&&&{", family.circular, " margin-top:", timeDisplayMarginTop, ";padding:0;};label:timeDisplay;");
var timeDivider = {
  name: "dcb12m-timeDivider",
  styles: "&&&{padding:0 0.25rem;};label:timeDivider;"
};
var timeDuration = {
  name: "1uhqrew-timeDuration",
  styles: "&&&{margin-right:1rem;};label:timeDuration;"
};
var progressBar = /*#__PURE__*/css("&&&{flex:0 1 100%;height:0.3em;margin:", progressBarMargins, ";};label:progressBar;");
/**
 * The max-widith is 2.38rem for the fullScreenIcon because the icon isn't
 * totally centered on the div. This exact amount makes the background on hover
 * appear even on both sides of the icon.
 */

var fullscreenExpandIcon = /*#__PURE__*/css("&&&{background-image:url(", expand, ");background-repeat:no-repeat;max-width:2.38rem;margin:", iconMargins, ";margin-right:0.5rem;", hideOldIcon, " ", videoButtonIconStyle, "};label:fullscreenExpandIcon;");
var volumeOnIcon = /*#__PURE__*/css("&&&{background-image:url(", audioOn, ");background-repeat:no-repeat;margin:", iconMargins, ";", hideOldIcon, " ", videoButtonIconStyle, " ", volumeHoverIconStyle, "};label:volumeOnIcon;");
var volumeOffIcon = /*#__PURE__*/css("&&&{background-image:url(", audioOff, ");background-repeat:no-repeat;margin:", iconMargins, ";", hideOldIcon, " ", videoButtonIconStyle, " ", volumeHoverIconStyle, "};label:volumeOffIcon;");
var replayIcon = /*#__PURE__*/css("&&&{background-image:url(", back15, ");background-repeat:no-repeat;margin:", iconMargins, ";", hideOldIcon, " ", videoButtonIconStyle, " ", mediaQuery.upTo(xs$1), "{display:none;}};label:replayIcon;");
var optionsIcon = /*#__PURE__*/css("&&&{background-image:url(", options, ");background-repeat:no-repeat;background-color:transparent;border:none;min-width:2.5rem;height:2rem;margin:0.5rem 0.5rem 0 0;", videoButtonIconStyle, "};label:optionsIcon;");
var overlay = /*#__PURE__*/css(family.circular, " font-size:.8rem;;label:overlay;");
var audioDescription = {
  name: "1yiebri-audioDescription",
  styles: "display:none;;label:audioDescription;"
};
var fullscreenCollapseIcon = /*#__PURE__*/css("&&&{background-image:url(", collapse, ");background-repeat:no-repeat;max-width:2.38rem;margin:", iconMargins, ";", hideOldIcon, " ", videoButtonIconStyle, "};label:fullscreenCollapseIcon;");
var fullscreenOverlay = /*#__PURE__*/css("z-index:1;position:absolute;top:0;left:0;width:100%;padding:3.5rem 1.5rem;margin:0;font-weight:normal;", darkGradientFadeTo('bottom'), ";label:fullscreenOverlay;"); // The opacity transition below mimics the auto-hide transition for the
// video-react control bar.

var fullscreenOverlayInvisible = {
  name: "15bbz3m-fullscreenOverlayInvisible",
  styles: "opacity:0;transition:opacity 1.0s;;label:fullscreenOverlayInvisible;"
};
var useMergedRefs = function useMergedRefs(internalRef, externalRef) {
  return React.useCallback(function (valueToAssign) {
    if (externalRef) {
      if (typeof externalRef === 'function') {
        externalRef(valueToAssign);
      } else {
        externalRef.current = valueToAssign;
      }
    }
    internalRef.current = valueToAssign;
  }, [internalRef, externalRef]);
};
var audioProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Path for the audio source URL
   */
  src: propTypes.string
});
var AudioPlayer = /*#__PURE__*/React__default.forwardRef(function (props, externalRef) {
  var _React$useState9 = React.useState({}),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    playerState = _React$useState10[0],
    setPlayerState = _React$useState10[1];
  var muted = playerState.muted,
    paused = playerState.paused;
  var internalRef = React.useRef();
  var mergedRef = useMergedRefs(internalRef, externalRef);
  var actions = internalRef.current ? internalRef.current.actions : null;
  React.useEffect(function () {
    return internalRef.current.subscribeToStateChange(setPlayerState);
  }, []);
  return jsx(ClassNames, null, function (_ref17) {
    var css = _ref17.css,
      cx = _ref17.cx;
    return jsx(lib_1, {
      playsInline: true,
      fluid: false,
      height: 100,
      width: "100%",
      src: props.src,
      ref: mergedRef,
      crossOrigin: "anonymous",
      style: {
        zIndex: '0'
      },
      type: lib_1.mediaType.audio
    }, jsx(lib_2, {
      className: css(toolBar),
      disableDefaultControls: true,
      autoHide: false
    }, jsx(lib_9, {
      className: css(progressBar)
    }), jsx("div", {
      className: css(displayFlex)
    }, jsx(Tooltip, {
      message: paused ? 'Play Audio' : 'Pause Audio',
      tooltipAlign: "left",
      tooltipHorizontalOffset: 25,
      additionalClassName: tooltipBorderRadius
    }, jsx(lib_6, {
      player: playerState,
      actions: actions,
      className: css(smallPlayButton)
    })), jsx(lib_10, {
      player: playerState,
      className: css(timeDisplay)
    }), jsx(lib_11, {
      player: playerState,
      className: css(timeDisplay, timeDivider)
    }), jsx(lib_12, {
      player: playerState,
      className: css(timeDisplay, timeDuration)
    }), jsx(Tooltip, {
      message: "Rewind 15 Seconds",
      hasRoundedCorners: true
    }, jsx(lib_4, {
      seconds: 15,
      actions: actions,
      className: css(replayIcon)
    })), muted ? jsx(Tooltip, {
      message: "Unmute",
      additionalClassName: tooltipBorderRadius
    }, jsx(lib_7, {
      player: playerState,
      actions: actions,
      vertical: true,
      className: css(volumeOffIcon)
    }, jsx(lib_14, {
      className: css(volumeBar)
    }))) : jsx(lib_7, {
      vertical: true,
      player: playerState,
      actions: actions,
      className: css(volumeOnIcon)
    }, jsx(lib_14, {
      className: css(volumeBar)
    })))));
  });
});
AudioPlayer.propTypes = audioProps;
AudioPlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "props": {
    "src": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Path for the audio source URL"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var biographyCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3(_objectSpread3({}, imgProps), {}, {
    ariaProps: propTypes.object
  })),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
   * Pass a string representing birth/death dates.
   *
   * **Example**
   * `lifeSpan={'02/21/1933 - 02/21/2020'}`
   */
  lifeSpan: propTypes.string,
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
  * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseLeave={() => console.log('mouseLeft')}`
  */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles.
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var BiographyCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  BiographyCard.displayName = 'BiographyCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var lifeSpan = props.lifeSpan,
    passThroughProps = _objectWithoutProperties3(props, _excluded7);
  var metaData = [lifeSpan];
  return jsx(ContentCard, _extends({}, passThroughProps, {
    contentType: "Biography",
    metaData: metaData,
    ref: ref
  }));
});
BiographyCard.propTypes = biographyCardProps;
BiographyCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BiographyCard",
  "props": {
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {
          "ariaProps": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "isVertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "lifeSpan": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass a string representing birth/death dates.\n\n**Example**\n`lifeSpan={'02/21/1933 - 02/21/2020'}`"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles."
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var ButtonStatusColor = {
  primary: 'primary',
  secondary: 'secondary',
  danger: 'danger'
};
var style$2 = {
  fontFamily: 'Circular,Helvetica,Arial,sans-serif',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: '0.875rem',
  transition: 'all 0.12s',
  boxSizing: 'border-box',
  border: '0.2em solid transparent',
  cursor: 'pointer',
  '&[disabled]': {
    cursor: 'not-allowed'
  }
};
/**
 * Flavors
 *
 * @param {string} status
 * @return {Object}
 */

var getIntentColor = function getIntentColor(status$1) {
  var textColor = ui.white['100'];
  if (status$1 === ButtonStatusColor.secondary) {
    return {
      textColor: textColor,
      primaryColor: ui.greyDark['500'],
      actionColor: ui.greyDark['700']
    };
  } else {
    return {
      primaryColor: status[status$1]['500'],
      actionColor: status[status$1]['700'],
      textColor: textColor
    };
  }
};
var solidCss = function solidCss(intent) {
  var color = getIntentColor(intent);
  return {
    color: color.textColor,
    backgroundColor: color.primaryColor,
    '&:hover, &:focus, &.selected': {
      backgroundColor: color.actionColor
    },
    '&[disabled]': {
      color: color.textColor,
      backgroundColor: ui.greyLight['500']
    }
  };
};
var hollowCss = function hollowCss(intent) {
  var color = getIntentColor(intent);
  return {
    backgroundColor: 'transparent',
    color: color.primaryColor,
    borderColor: color.primaryColor,
    '&:hover, &:focus, &.selected': {
      color: color.textColor,
      backgroundColor: color.primaryColor
    },
    '&[disabled]': {
      color: ui.greyLight['500'],
      borderColor: ui.greyLight['500'],
      backgroundColor: ui.white['500']
    }
  };
};
var flatCss = function flatCss(intent) {
  var color = getIntentColor(intent);
  return {
    color: color.primaryColor,
    backgroundColor: color.textColor,
    '&:hover, &:focus, &.selected': {
      color: color.textColor,
      backgroundColor: color.primaryColor
    },
    '&[disabled]': {
      color: ui.greyLight['500'],
      backgroundColor: ui.white['500']
    }
  };
};
var incognitoCss = {
  background: 'transparent',
  color: 'inherit',
  border: 'none',
  padding: 0,
  font: 'inherit'
};
var linkCss = {
  background: 'transparent',
  color: brand.newselaBlue['500'],
  border: 'none',
  textDecoration: 'underline',
  '&[disabled]': {
    color: ui.greyLight['500'],
    cursor: 'not-allowed'
  }
};
/**
 * Shapes
 */

var padding = '0.5rem 1rem';
var rectangularCss = {
  padding: padding
};
var roundedCss = {
  borderRadius: '300px',
  padding: padding
};
var ButtonFlavor = {
  solid: 'SOLID',
  hollow: 'HOLLOW',
  incognito: 'INCOGNITO',
  link: 'LINK',
  flat: 'FLAT'
};
var ButtonStatusColor$1 = {
  primary: 'primary',
  secondary: 'secondary',
  danger: 'danger'
};
var ButtonShape = {
  rectangular: 'RECTANGULAR',
  rounded: 'ROUNDED'
};
var propTypes$2 = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Maps directly to aria attributes
   */
  ariaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  children: propTypes.node.isRequired,
  /**
   * Maps directly to data attributes
   */
  dataProps: propTypes.objectOf(propTypes.string),
  /**
   * Flavor of button. options are available in the ButtonFlavors enum above
   */
  flavor: propTypes.oneOf(Object.values(ButtonFlavor)).isRequired,
  /**
   * StatusColor dictates the color of the button
   * can be.
   */
  statusColor: propTypes.oneOf(Object.values(ButtonStatusColor$1)).isRequired,
  /**
   * Shape of the button. rectangle has built
   * in padding and depening on the flavor a
   * border or background color. rounded is the
   * same only rounded.
   */
  shape: propTypes.oneOf(Object.values(ButtonShape)).isRequired,
  /**
   * Is the button disabled
   */
  disabled: propTypes.bool.isRequired,
  /**
   * Is the button in a state indicating that is is selected
   * and its influence is actively being applied
   */
  selected: propTypes.bool.isRequired,
  /**
   * OnClick event to be fired when the button is clicked
   */
  onClick: propTypes.func.isRequired,
  /**
   * Accessability prop that maps directly to html attribute
   * role
   */
  role: propTypes.string
});
var getFlavorCss = function getFlavorCss(flavor, statusColor) {
  switch (flavor) {
    case ButtonFlavor.solid:
      return solidCss(statusColor);
    case ButtonFlavor.hollow:
      return hollowCss(statusColor);
    case ButtonFlavor.flat:
      return flatCss(statusColor);
    case ButtonFlavor.link:
      return linkCss;
    case ButtonFlavor.incognito:
      return incognitoCss;
  }
};
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  Button.displayName = 'Button';
  var children = props.children,
    onClick = props.onClick,
    flavor = props.flavor,
    disabled = props.disabled,
    selected = props.selected,
    shape = props.shape,
    __css = props.__css,
    additionalClassName = props.additionalClassName,
    statusColor = props.statusColor,
    dataProps = props.dataProps,
    ariaProps = props.ariaProps,
    role = props.role;
  var removeShapeStyles = flavor === ButtonFlavor.incognito || flavor === ButtonFlavor.link;
  var selectedClass = selected ? ' selected' : '';
  /**
   * This functions is called on the ariaProps object. If no ariaProps object is passed to the component,
   * an object is created and sets the aria-label to the button's children props if it is a string. In the
   * case that the button's child is not a string (ex: if it's an icon), a console warning is thrown.
   **/

  var checkAriaProps = function checkAriaProps(obj) {
    var ariaObj = {};
    var childrenValue = typeof children === 'string' ? children : null;
    if (obj && !obj['aria-label'] || !obj) {
      typeof childrenValue !== 'string' && console.warn('A button requires either a plain string child (ex: not a DOM element rendering a string) or an explicit aria-label provided via the ariaProp.');
      ariaObj = _objectSpread3({
        'aria-label': childrenValue
      }, obj);
      return ariaObj;
    }
    return obj;
  };
  var checkedAriaProps = checkAriaProps(ariaProps);
  return jsx("button", _extends({
    className: additionalClassName + selectedClass,
    css: /*#__PURE__*/css([style$2, getFlavorCss(flavor, statusColor), shape === ButtonShape.rectangular && !removeShapeStyles && rectangularCss, shape === ButtonShape.rounded && !removeShapeStyles && roundedCss, __css], ";label:Button;")
  }, dataProps, {
    disabled: disabled,
    onClick: onClick
  }, checkedAriaProps, {
    role: role,
    ref: ref
  }), children);
});
Button.propTypes = propTypes$2;
Button.shape = ButtonShape;
Button.flavor = ButtonFlavor;
Button.statusColor = ButtonStatusColor$1;
Button.defaultProps = {
  shape: ButtonShape.rectangular,
  statusColor: ButtonStatusColor$1.primary,
  flavor: ButtonFlavor.solid,
  additionalClassName: '',
  disabled: false,
  selected: false
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "shape": {
      "defaultValue": {
        "value": "'RECTANGULAR'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"RECTANGULAR\"",
          "computed": false
        }, {
          "value": "\"ROUNDED\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "Shape of the button. rectangle has built\nin padding and depening on the flavor a\nborder or background color. rounded is the\nsame only rounded."
    },
    "statusColor": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"danger\"",
          "computed": false
        }, {
          "value": "\"primary\"",
          "computed": false
        }, {
          "value": "\"secondary\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "StatusColor dictates the color of the button\ncan be."
    },
    "flavor": {
      "defaultValue": {
        "value": "'SOLID'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"FLAT\"",
          "computed": false
        }, {
          "value": "\"HOLLOW\"",
          "computed": false
        }, {
          "value": "\"INCOGNITO\"",
          "computed": false
        }, {
          "value": "\"LINK\"",
          "computed": false
        }, {
          "value": "\"SOLID\"",
          "computed": false
        }]
      },
      "required": false,
      "description": "Flavor of button. options are available in the ButtonFlavors enum above"
    },
    "additionalClassName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Is the button disabled"
    },
    "selected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Is the button in a state indicating that is is selected\nand its influence is actively being applied"
    },
    "ariaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Maps directly to aria attributes"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Maps directly to data attributes"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "OnClick event to be fired when the button is clicked"
    },
    "role": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Accessability prop that maps directly to html attribute\nrole"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var svgContainer = {
  width: '46px',
  height: '51px'
};
var svgText = {
  fontFamily: 'Circular-Bold,Circular',
  fontSize: 12,
  fontWeight: 'bold',
  lineSpacing: 30
};
var multiItemSVGProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Pass ariaProps an object containing aria attributes.
   * If you have set the href prop you want to apply aria attributes directly to the anchor tag, use ariaAnchorProps.
   *
   * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
   *
   * **Example**:
   * `ariaProps = {{
   * 'aria-label' : 'some-value',
   * 'aria-pressed : 'some-value'
   * }}`
   *
   */
  ariaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
   * number of items included within the lesson spark bundle.
   * This should correspond with the meta data.
   */
  multiItemCount: propTypes.number
});
var MultiItemSVG = function MultiItemSVG(props) {
  var multiItemCount = props.multiItemCount;
  var multiItemLabel = multiItemCount > 99 ? '99+' : multiItemCount;
  if (multiItemCount < 0) {
    return null;
  }
  var xPos = 20;
  if (multiItemCount < 10) {
    xPos = 30;
  }
  if (multiItemCount > 99) {
    xPos = 15;
  }
  return jsx("svg", _extends({
    css: /*#__PURE__*/css([svgContainer, props.__css], ";label:MultiItemSVG;")
  }, props.ariaProps), jsx("title", null, "MultiItemSVG"), jsx("desc", null, "Created with Sketch."), jsx("g", {
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, jsx("g", {
    transform: "translate(-12.000000, -47.000000)",
    fill: "#FFFFFF"
  }, jsx("g", {
    transform: "translate(12.000000, 47.000000)"
  }, jsx("path", {
    d: "M41.8784626,-2.05118941e-14 C44.1509828,-2.05118941e-14 46,1.85662653 46,4.13453665 L46,38.5080718 C46,40.7899133 44.1509828,42.6425833 41.8784626,42.6425833 L41.5686584,42.6425833 C41.8961065,42.1385651 42.1039477,41.5538033 42.1843616,40.9277623 C43.3980991,40.7702566 44.3510186,39.7681173 44.3510186,38.5100375 L44.3510186,4.13650232 C44.3510186,2.7681938 43.2431945,1.65380962 41.8784676,1.65380962 L15.5155666,1.65380962 C15.1489004,1.65380962 14.8097115,1.74634232 14.4939791,1.89006814 L12.0645966,1.89006814 C12.7998666,0.756027255 14.0685184,-2.05118941e-14 15.5155666,-2.05118941e-14 L41.8784626,-2.05118941e-14 Z M36.2354365,3.78008084 C38.5079567,3.78008084 40.3569739,5.63479714 40.3589315,7.91467293 L40.3589315,42.2861921 C40.3589315,44.5680335 38.5099143,46.4226692 36.2354365,46.4226692 L35.9256322,46.4226692 C36.2530803,45.9166853 36.4609216,45.3338891 36.5413355,44.7058825 C37.755073,44.5503475 38.7079925,43.5482031 38.7079925,42.2881577 L38.7079925,7.91462253 C38.7079925,6.546314 37.6001684,5.4338955 36.2354415,5.4338955 L9.87103462,5.4338955 C9.50436843,5.4338955 9.16517949,5.52446252 8.8494471,5.6681833 L6.42006462,5.6681833 C7.15533456,4.53414242 8.42594407,3.78008084 9.87103462,3.78008084 L36.2354365,3.78008084 Z M30.4824812,7.58786755 C32.7569591,7.58786755 34.6059763,9.44446888 34.6059763,11.7243447 L34.6059763,46.0978784 C34.6059763,48.3797198 32.7569591,50.23239 30.4824812,50.23239 L4.11958025,50.23239 C1.84705954,50.23239 0,48.3777541 0,46.0978784 L0,11.7243447 C0,9.44250321 1.84705954,7.58786755 4.11958025,7.58786755 L30.4824812,7.58786755 Z M32.9569899,46.0978789 L32.9569899,11.7243447 C32.9569899,10.3560361 31.8491658,9.24165197 30.4824812,9.24165197 L4.11958025,9.24165197 C2.75485288,9.24165197 1.64702877,10.3559857 1.64702877,11.7243447 L1.64702877,46.0978789 C1.64702877,47.4661874 2.75485288,48.5786059 4.11958025,48.5786059 L30.4824812,48.5786059 C31.8491658,48.5786059 32.9569899,47.4642721 32.9569899,46.0978789 Z"
  }), jsx("text", {
    css: svgText
  }, jsx("tspan", {
    x: "".concat(xPos, "%"),
    y: "65%"
  }, multiItemLabel))))));
};
MultiItemSVG.propTypes = multiItemSVGProps;
MultiItemSVG.defaultProps = {
  ariaProps: {}
};
MultiItemSVG.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MultiItemSVG",
  "props": {
    "ariaProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass ariaProps an object containing aria attributes.\nIf you have set the href prop you want to apply aria attributes directly to the anchor tag, use ariaAnchorProps.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`ariaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "multiItemCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of items included within the lesson spark bundle.\nThis should correspond with the meta data."
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var collectionCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * The amount of assets contained in the collection
   */
  assetCount: propTypes.number,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * what type of collection is dispaly on the card. It should not contain the word collection
   * as this component handles adding it
   */
  collectionType: propTypes.string,
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * the date the collection was published
   */
  datePublished: propTypes.string,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * Override the ContentType row
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
   * changes the wrapper on the card for more semantic html. See the Card component
   * for more details
   */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var CollectionCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  CollectionCard.displayName = 'CollectionCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var assetCount = props.assetCount,
    datePublished = props.datePublished,
    passThroughProps = _objectWithoutProperties3(props, _excluded8);
  var assetLabel = getAssetCountLanguage(assetCount);
  var metaData = [];
  if (assetCount) {
    metaData.push(assetLabel);
  }
  if (datePublished) {
    metaData.push(dateFormatted(datePublished));
  }
  return jsx(ContentCard, _extends({}, passThroughProps, {
    ref: ref,
    contentType: "Collection",
    metaData: metaData,
    imageOverlay: assetCount !== undefined && jsx("div", {
      css: /*#__PURE__*/css(_objectSpread3(_objectSpread3({}, defaultImageOverlayContainer), {}, {
        flexDirection: 'row-reverse'
      }), ";label:CollectionCard;")
    }, jsx("div", {
      css: props.isVertical ? verticalRightImageOverlay : horizontalRightImageOverlay
    }, jsx(MultiItemSVG, {
      multiItemCount: assetCount,
      ariaProps: {
        'aria-hidden': true
      }
    })))
  }));
});
CollectionCard.propTypes = collectionCardProps;
CollectionCard.defaultProps = {
  isVertical: ContentCard.defaultProps.isVertical
};
CollectionCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CollectionCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "ContentCard.defaultProps.isVertical",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "assetCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The amount of assets contained in the collection"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "collectionType": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "what type of collection is dispaly on the card. It should not contain the word collection\nas this component handles adding it"
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "the date the collection was published"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Override the ContentType row"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "changes the wrapper on the card for more semantic html. See the Card component\nfor more details"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var externalLinkFooterLinkText = _objectSpread3(_objectSpread3({
  fontFamily: 'Circular, Helvetica, Arial,sans-serif',
  fontWeight: '700'
}, heading6Obj), {}, {
  lineHeight: '0.875rem',
  color: 'white',
  marginLeft: '10px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
});
var externalLinkIcon = {
  width: '16px',
  height: '16px'
};
var buttonStylesGenerator = function buttonStylesGenerator(_ref18) {
  var flavor = _ref18.flavor,
    shape = _ref18.shape,
    statusColor = _ref18.statusColor;
  var getFlavorCss = function getFlavorCss(flavor, statusColor) {
    switch (flavor) {
      case 'solid':
        return solidCss(statusColor);
      case 'hollow':
        return hollowCss(statusColor);
      case 'flat':
        return flatCss(statusColor);
      case 'link':
        return linkCss;
      case 'incognito':
        return incognitoCss;
    }
  };
  var removeShapeStyles = flavor === 'incognito' || flavor === 'link';
  return [style$2, getFlavorCss(flavor, statusColor), shape === 'rectangular' && !removeShapeStyles && rectangularCss, shape === 'rounded' && !removeShapeStyles && roundedCss, {
    textDecoration: flavor === 'link' ? 'underline' : 'none'
  }];
};
function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
var _ref$1 = /*#__PURE__*/React.createElement("g", {
  fill: "#fefefe",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.907 7.102v3.108c0 .208.006.415-.021.621l.03-.239c-.028.2-.08.393-.157.58l.09-.214c-.078.18-.177.35-.296.506l.14-.18c-.12.153-.258.292-.411.411l.18-.14a2.3 2.3 0 01-.506.295l.213-.09c-.185.078-.378.13-.578.159l.238-.031c-.311.04-.637.02-.95.02H4.04c-.272 0-.543.002-.813 0-.104 0-.207-.007-.31-.02l.239.03a2.37 2.37 0 01-.58-.157l.215.09a2.358 2.358 0 01-.506-.296l.18.14a2.318 2.318 0 01-.412-.412l.14.18a2.3 2.3 0 01-.295-.505l.09.213a2.356 2.356 0 01-.159-.579l.031.24c-.04-.312-.02-.638-.02-.95V4.04c0-.272-.002-.543 0-.813 0-.104.007-.208.02-.31l-.03.238c.028-.2.08-.392.158-.578l-.09.213c.078-.18.176-.35.295-.506l-.14.18c.12-.153.258-.292.412-.411l-.18.14A2.3 2.3 0 012.79 1.9l-.214.09c.185-.078.379-.13.579-.159l-.239.031c.18-.024.363-.02.544-.02H6.645c.23 0 .47-.1.632-.263A.915.915 0 007.54.945c-.011-.231-.087-.47-.263-.632a.928.928 0 00-.632-.262H3.239a3.28 3.28 0 00-1.468.355A3.156 3.156 0 00.526 1.557a3.189 3.189 0 00-.475 1.67V10.521a3.22 3.22 0 00.424 1.587 3.21 3.21 0 002.753 1.59h7.137c.657 0 1.311-.131 1.867-.501.473-.313.89-.745 1.133-1.264.122-.263.23-.534.274-.823.031-.202.059-.403.059-.607v-3.4c0-.23-.1-.47-.263-.633a.915.915 0 00-.632-.262c-.232.01-.472.086-.633.262a.917.917 0 00-.263.631zM9.49 1.839h3.311c.23 0 .47-.1.633-.263a.915.915 0 00.262-.632c-.01-.232-.086-.472-.262-.633A.928.928 0 0012.8.05h-3.31c-.23 0-.47.1-.633.262a.915.915 0 00-.262.633c.01.231.086.471.262.632a.924.924 0 00.633.263z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.697 4.255V.944c0-.23-.1-.47-.263-.632a.915.915 0 00-.632-.263c-.232.011-.472.087-.633.263a.928.928 0 00-.262.632v3.311c0 .23.1.47.262.632.155.155.41.272.633.263.231-.011.471-.087.632-.263a.924.924 0 00.263-.632z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.517 7.493l5.19-5.19c.238-.238.48-.475.716-.716l.011-.01a.922.922 0 00.263-.633.904.904 0 00-.263-.633c-.17-.156-.394-.273-.632-.262a.931.931 0 00-.633.262L6.98 5.501c-.238.238-.481.476-.717.717l-.01.01a.922.922 0 00-.263.633c0 .22.096.481.262.632.17.156.394.273.633.263a.928.928 0 00.632-.263z"
}));
function SvgExternalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 14 14"
  }, props), _ref$1);
}
var css_248z$3 = "/* autoprefixer grid: autoplace */\n.style_fakeButton__3Gxh_ {\n  -ms-grid-row: 1;\n  -ms-grid-column: 1;\n  display: -ms-grid;\n  display: grid;\n                          grid-template-areas: \"icon text\";\n  grid-area: link;\n  /*temporary border-radius declaration. should be removed after angelou button update.*/\n  border-radius: 4px; }\n\n.style_icon__2_K6W {\n  -ms-grid-row: 1;\n  -ms-grid-column: 1;\n  grid-area: icon; }\n\n.style_linkText__1zlTb {\n  -ms-grid-row: 1;\n  -ms-grid-column: 2;\n  grid-area: text; }\n\n.style_gridWrapper__Od7Tr {\n  display: -ms-grid;\n  display: grid;\n                          grid-template-areas: \"link placeholder\";\n  -ms-grid-columns: auto 1fr;\n  grid-template-columns: auto 1fr; }\n\n.style_placeholder__bytq1 {\n  -ms-grid-row: 1;\n  -ms-grid-column: 2;\n  grid-area: placeholder; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnNjc3MiLCI8bm8gc291cmNlPiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxpQ0FBaUM7QUFDakM7RUNEQSxnQkFBQTtFQUFBLG1CQUFBO0VERUUsaUJBQWE7RUFBYixhQUFhOzBCQUNiLGdDQUFnQztFQUNoQyxlQUFlO0VBQ2Ysc0ZBQXNGO0VBQ3RGLGtCQUFrQixFQUFFOztBQUV0QjtFQ1JBLGdCQUFBO0VBQUEsbUJBQUE7RURTRSxlQUFlLEVBQUU7O0FBRW5CO0VDWEEsZ0JBQUE7RUFBQSxtQkFBQTtFRFlFLGVBQWUsRUFBRTs7QUFFbkI7RUFDRSxpQkFBYTtFQUFiLGFBQWE7MEJBQ2IsdUNBQXVDO0VBQ3ZDLDBCQUErQjtFQUEvQiwrQkFBK0IsRUFBRTs7QUFFbkM7RUNuQkEsZ0JBQUE7RUFBQSxtQkFBQTtFRG9CRSxzQkFBc0IsRUFBRSIsImZpbGUiOiJzdHlsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLyogYXV0b3ByZWZpeGVyIGdyaWQ6IGF1dG9wbGFjZSAqL1xuLmZha2VCdXR0b24ge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWFyZWFzOiBcImljb24gdGV4dFwiO1xuICBncmlkLWFyZWE6IGxpbms7XG4gIC8qdGVtcG9yYXJ5IGJvcmRlci1yYWRpdXMgZGVjbGFyYXRpb24uIHNob3VsZCBiZSByZW1vdmVkIGFmdGVyIGFuZ2Vsb3UgYnV0dG9uIHVwZGF0ZS4qL1xuICBib3JkZXItcmFkaXVzOiA0cHg7IH1cblxuLmljb24ge1xuICBncmlkLWFyZWE6IGljb247IH1cblxuLmxpbmtUZXh0IHtcbiAgZ3JpZC1hcmVhOiB0ZXh0OyB9XG5cbi5ncmlkV3JhcHBlciB7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtYXJlYXM6IFwibGluayBwbGFjZWhvbGRlclwiO1xuICBncmlkLXRlbXBsYXRlLWNvbHVtbnM6IGF1dG8gMWZyOyB9XG5cbi5wbGFjZWhvbGRlciB7XG4gIGdyaWQtYXJlYTogcGxhY2Vob2xkZXI7IH1cbiIsbnVsbF19 */";
var gridStyles = {
  "fakeButton": "style_fakeButton__3Gxh_",
  "icon": "style_icon__2_K6W",
  "linkText": "style_linkText__1zlTb",
  "gridWrapper": "style_gridWrapper__Od7Tr",
  "placeholder": "style_placeholder__bytq1"
};
styleInject(css_248z$3);
var externalLinkCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * aria attributes passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date published of the link content
   */
  datePublished: propTypes.string,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3(_objectSpread3({}, imgProps), {}, {
    ariaProps: propTypes.object
  })),
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * Will be passed with props via ref forwarding
   */
  ref: propTypes.object,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * source of the link
   */
  source: propTypes.string
});
/**
  Pass an object with desired button styles to the externalLinkFooterGenerator function to make
  the rendered footer component look and behave like Angelou buttons.
 *
 * **Example:**
 *
 * const buttonStyleProps = {
    flavor: 'solid',
    shape: 'rectangular',
    statusColor: 'primary'
  };

 *`footer={ExternalLinkCard.externalLinkFooterGenerator({ href, source, buttonStyleProps })}`
 */

var ExternalLinkFooterGenerator = function ExternalLinkFooterGenerator(props) {
  var _props$buttonStylePro = props.buttonStyleProps,
    buttonStyleProps = _props$buttonStylePro === void 0 ? {
      flavor: 'solid',
      shape: 'rectangular',
      statusColor: 'primary'
    } : _props$buttonStylePro,
    href = props.href,
    saveButton = props.saveButton,
    source = props.source,
    __renderCustomLink = props.__renderCustomLink;
  var children = jsx(React__default.Fragment, null, jsx(SvgExternalIcon, {
    css: externalLinkIcon,
    className: gridStyles.icon
  }), jsx("span", {
    className: gridStyles.linkText,
    css: externalLinkFooterLinkText
  }, "Visit ", source));
  return jsx("div", {
    className: gridStyles.gridWrapper
  }, " ", __renderCustomLink ? __renderCustomLink({
    children: children,
    className: gridStyles.fakeButton,
    css: buttonStylesGenerator(buttonStyleProps),
    href: href,
    rel: 'noopener noreferrer',
    target: '_blank'
  }) : jsx("a", {
    css: buttonStylesGenerator(buttonStyleProps),
    className: gridStyles.fakeButton,
    href: href,
    rel: "noopener noreferrer",
    target: "_blank"
  }, children), jsx("div", {
    className: gridStyles.placeholder
  }, saveButton));
};
var ExternalLinkCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  ExternalLinkCard.displayName = 'ExternalLinkCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var anchorAriaProps = props.anchorAriaProps,
    datePublished = props.datePublished,
    source = props.source,
    passThroughProps = _objectWithoutProperties3(props, _excluded9);
  var metaData = datePublished ? [source, dateFormatted(datePublished)] : [source];
  var externalLinkAriaProps = _objectSpread3({
    target: '_blank',
    rel: 'noopener noreferrer'
  }, anchorAriaProps);
  return jsx(ContentCard, _extends({}, passThroughProps, {
    anchorAriaProps: externalLinkAriaProps,
    contentType: "External Link",
    metaData: metaData,
    ref: ref
  }));
});
ExternalLinkCard.propTypes = externalLinkCardProps;
ExternalLinkCard.defaultProps = {
  __renderCustomWrapper: function __renderCustomWrapper(cardProps, children) {
    return jsx("div", cardProps, children);
  }
};
ExternalLinkCard.externalLinkFooterGenerator = ExternalLinkFooterGenerator;
ExternalLinkCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ExternalLinkCard",
  "props": {
    "__renderCustomWrapper": {
      "defaultValue": {
        "value": "(cardProps, children) => (\n  <div {...cardProps}>\n    {children}\n  </div>\n)",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "aria attributes passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date published of the link content"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {
          "ariaProps": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "isVertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "ref": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Will be passed with props via ref forwarding"
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "source": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "source of the link"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var InfographicCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * Pass datePublished a string.
   *
   * **Example**
   * `datePublished='02/24/2020'`
   */
  datePublished: propTypes.string,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
  * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseLeave={() => console.log('mouseLeft')}`
  */
  onMouseLeave: propTypes.func,
  /**
  * Pass the source prop a string.
  *
  * **Example**:
  * `source='Barons'`
  */
  source: propTypes.string,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles.
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var InfographicCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  InfographicCard.displayName = 'InfographicCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var datePublished = props.datePublished,
    source = props.source,
    passThroughProps = _objectWithoutProperties3(props, _excluded10);
  var metaData = datePublished ? [source, dateFormatted(datePublished)] : [source];
  return jsx(ContentCard, _extends({}, passThroughProps, {
    contentType: "Infographic",
    metaData: metaData,
    ref: ref
  }));
});
InfographicCard.propTypes = InfographicCardProps;
InfographicCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfographicCard",
  "props": {
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass datePublished a string.\n\n**Example**\n`datePublished='02/24/2020'`"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "isVertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "source": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass the source prop a string.\n\n**Example**:\n`source='Barons'`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles."
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var multiItemOverlayContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: 0.75,
  borderRadius: '4px',
  backgroundColor: brand.black['500']
};
var imageTextOverlay = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  marginLeft: '40px',
  marginRight: 0,
  width: 'auto',
  maxWidth: 'min-content',
  minWidth: 0,
  display: 'inline-block'
};
var multiItemAmount = {
  margin: 'auto',
  width: '32px',
  maxWidth: '100%',
  height: '22px',
  fontFamily: 'Circular',
  fontSize: '1.66rem',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '49px',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: ui.white['100']
};
var css_248z$4 = "/* autoprefixer grid: autoplace */\n.imageOverlay_container__3SWQQ {\n  display: -ms-grid;\n  display: grid;\n                          grid-template-areas: \". . rightSide\" \"metaData . rightSide\";\n  -ms-grid-columns: minmax(0, -webkit-min-content) auto minmax(-webkit-min-content, 70px);\n  -ms-grid-columns: minmax(0, min-content) auto minmax(min-content, 70px);\n  grid-template-columns: minmax(0, -webkit-min-content) auto minmax(-webkit-min-content, 70px);\n  grid-template-columns: minmax(0, min-content) auto minmax(min-content, 70px);\n  -ms-grid-rows: 1fr auto;\n  grid-template-rows: 1fr auto;\n  width: 100%;\n  height: 100%; }\n\n.imageOverlay_metaData__ozU-B {\n  -ms-grid-row: 2;\n  -ms-grid-column: 1;\n  grid-area: metaData; }\n\n.imageOverlay_right__3Ah8Y {\n  -ms-grid-row: 1;\n  -ms-grid-row-span: 2;\n  -ms-grid-column: 3;\n  grid-area: rightSide; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImltYWdlT3ZlcmxheS5zY3NzIiwiPG5vIHNvdXJjZT4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsaUNBQWlDO0FBQ2pDO0VBQ0UsaUJBQWE7RUFBYixhQUFhOzBCQUNiLDJEQUEyRDtFQUMzRCx1RkFBNEU7RUFBNUUsdUVBQTRFO0VBQTVFLDRGQUE0RTtFQUE1RSw0RUFBNEU7RUFDNUUsdUJBQTRCO0VBQTVCLDRCQUE0QjtFQUM1QixXQUFXO0VBQ1gsWUFBWSxFQUFFOztBQUVoQjtFQ1RBLGdCQUFBO0VBQUEsbUJBQUE7RURVRSxtQkFBbUIsRUFBRTs7QUFFdkI7RUNaQSxnQkFBQTtFQUFBLHFCQUFBO0VBQUEsbUJBQUE7RURhRSxvQkFBb0IsRUFBRSIsImZpbGUiOiJpbWFnZU92ZXJsYXkuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi8qIGF1dG9wcmVmaXhlciBncmlkOiBhdXRvcGxhY2UgKi9cbi5jb250YWluZXIge1xuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLXRlbXBsYXRlLWFyZWFzOiBcIi4gLiByaWdodFNpZGVcIiBcIm1ldGFEYXRhIC4gcmlnaHRTaWRlXCI7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogbWlubWF4KDAsIG1pbi1jb250ZW50KSBhdXRvIG1pbm1heChtaW4tY29udGVudCwgNzBweCk7XG4gIGdyaWQtdGVtcGxhdGUtcm93czogMWZyIGF1dG87XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7IH1cblxuLm1ldGFEYXRhIHtcbiAgZ3JpZC1hcmVhOiBtZXRhRGF0YTsgfVxuXG4ucmlnaHQge1xuICBncmlkLWFyZWE6IHJpZ2h0U2lkZTsgfVxuIixudWxsXX0= */";
var gridStyles$1 = {
  "container": "imageOverlay_container__3SWQQ",
  "metaData": "imageOverlay_metaData__ozU-B",
  "right": "imageOverlay_right__3Ah8Y"
};
styleInject(css_248z$4);
var lessonSparkCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  /**
   * number of total items included within the lesson spark bundle.
   */
  assetCount: propTypes.number,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date that the lesson spark was published
   */
  datePublished: propTypes.string,
  /**
   * amount of time (in minutes) to teach the lesson spark
   */
  duration: propTypes.number,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
   * render a custom wrapper for the card
   */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
  * render prop to create image overlays.
  */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var LessonSparkCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  LessonSparkCard.displayName = 'LessonSparkCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var assetCount = props.assetCount,
    datePublished = props.datePublished,
    duration = props.duration,
    passThroughProps = _objectWithoutProperties3(props, _excluded11);
  var assetLabel = getAssetCountLanguage(assetCount);
  var metaData = [];
  if (assetCount >= 0) {
    metaData.push(assetLabel);
  }
  if (datePublished) {
    metaData.push(dateFormatted(datePublished));
  }
  return jsx(ContentCard, _extends({}, passThroughProps, {
    contentType: "Lesson Spark",
    imageOverlay: jsx("div", {
      className: gridStyles$1.container
    }, duration !== undefined && jsx("div", {
      className: gridStyles$1.metaData,
      css: /*#__PURE__*/css([imageOverlayTextStyle(true), imageTextOverlay], ";label:LessonSparkCard;")
    }, "".concat(duration, " MINUTES")), assetCount !== undefined && jsx("div", {
      className: gridStyles$1.right,
      css: multiItemOverlayContainer
    }, jsx(MultiItemSVG, {
      multiItemCount: assetCount,
      ariaProps: {
        'aria-hidden': true
      }
    }))),
    isVertical: true,
    metaData: metaData,
    ref: ref
  }));
});
LessonSparkCard.propTypes = lessonSparkCardProps;
LessonSparkCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LessonSparkCard",
  "props": {
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "assetCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of total items included within the lesson spark bundle."
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date that the lesson spark was published"
    },
    "duration": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "amount of time (in minutes) to teach the lesson spark"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render a custom wrapper for the card"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var FOCUS_GROUP = 'data-focus-lock';
var FOCUS_DISABLED = 'data-focus-lock-disabled';
var FOCUS_ALLOW = 'data-no-focus-lock';
var FOCUS_AUTO = 'data-autofocus-inside';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
  var ref = React.useState(function () {
    return {
      // value
      value: initialValue,
      // last callback
      callback: callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  // update callback
  ref.callback = callback;
  return ref.facade;
}

/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(defaultValue, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}
var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};
var InFocusGuard = function InFocusGuard(_ref) {
  var children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && React.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.defaultProps = {
  children: null
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign2 = function __assign() {
  _assign2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign2.apply(this, arguments);
};
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function read() {
      if (assigned) {
        throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function useMedium(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function assignSyncMedium(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function push(x) {
          return cb(x);
        },
        filter: function filter() {
          return buffer;
        }
      };
    },
    assignMedium: function assignMedium(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function executeQueue() {
        var cbs = pendingQueue;
        pendingQueue = [];
        cbs.forEach(cb);
      };
      var cycle = function cycle() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function push(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function filter(_filter) {
          pendingQueue = pendingQueue.filter(_filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = _assign2({
    async: true,
    ssr: false
  }, options);
  return medium;
}
var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
    currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
});
var emptyArray = [];
var FocusLock = React.forwardRef(function (props, parentRef) {
  var _extends2;
  var _React$useState = React.useState(),
    realObserved = _React$useState[0],
    setObserved = _React$useState[1];
  var observed = React.useRef();
  var isActive = React.useRef(false);
  var originalFocusedElement = React.useRef(null);
  var children = props.children,
    disabled = props.disabled,
    noFocusGuards = props.noFocusGuards,
    persistentFocus = props.persistentFocus,
    crossFrame = props.crossFrame,
    autoFocus = props.autoFocus,
    allowTextSelection = props.allowTextSelection,
    group = props.group,
    className = props.className,
    whiteList = props.whiteList,
    _props$shards = props.shards,
    shards = _props$shards === void 0 ? emptyArray : _props$shards,
    _props$as = props.as,
    Container = _props$as === void 0 ? 'div' : _props$as,
    _props$lockProps = props.lockProps,
    containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
    SideCar = props.sideCar,
    shouldReturnFocus = props.returnFocus,
    onActivationCallback = props.onActivation,
    onDeactivationCallback = props.onDeactivation;
  var _React$useState2 = React.useState({}),
    id = _React$useState2[0]; // SIDE EFFECT CALLBACKS

  var onActivation = React.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React.useCallback(function () {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  var returnFocus = React.useCallback(function (allowDefer) {
    var current = originalFocusedElement.current;
    if (Boolean(shouldReturnFocus) && current && current.focus) {
      var focusOptions = typeof shouldReturnFocus === 'object' ? shouldReturnFocus : undefined;
      originalFocusedElement.current = null;
      if (allowDefer) {
        // React might return focus after update
        // it's safer to defer the action
        Promise.resolve().then(function () {
          return current.focus(focusOptions);
        });
      } else {
        current.focus(focusOptions);
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = React.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = React.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  {
    if (typeof allowTextSelection !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
    }
    React.useEffect(function () {
      if (!observed.current) {
        // eslint-disable-next-line no-console
        console.error('FocusLock: could not obtain ref to internal node');
      }
    }, []);
  }
  var lockProps = _extends$4((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return React.createElement(React.Fragment, null, hasLeadingGuards && [React.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }),
  // nearest focus guard
  React.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  })], !disabled && React.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus
  }), React.createElement(Container, _extends$4({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && React.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};
function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }
    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }
  return function wrap(WrappedComponent) {
    {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }
    var SideEffect = /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose$1(SideEffect, _PureComponent);
      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };
      var _proto = SideEffect.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };
      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect;
    }(React.PureComponent);
    _defineProperty$3(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    return SideEffect;
  };
}
var toArray = function toArray(a) {
  var ret = Array(a.length);
  for (var i = 0; i < a.length; ++i) {
    ret[i] = a[i];
  }
  return ret;
};
var arrayFind = function arrayFind(array, search) {
  return array.filter(function (a) {
    return a === search;
  })[0];
};
var asArray = function asArray(a) {
  return Array.isArray(a) ? a : [a];
};
var tabSort = function tabSort(a, b) {
  var tabDiff = a.tabIndex - b.tabIndex;
  var indexDiff = a.index - b.index;
  if (tabDiff) {
    if (!a.tabIndex) return 1;
    if (!b.tabIndex) return -1;
  }
  return tabDiff || indexDiff;
};
var orderByTabIndex = function orderByTabIndex(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function (node, index) {
    return {
      node: node,
      index: index,
      tabIndex: keepGuards && node.tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : node.tabIndex
    };
  }).filter(function (data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};
var tabbables = ['button:enabled:not([readonly])', 'select:enabled:not([readonly])', 'textarea:enabled:not([readonly])', 'input:enabled:not([readonly])', 'a[href]', 'area[href]', 'iframe', 'object', 'embed', '[tabindex]', '[contenteditable]', '[autofocus]'];
var queryTabbables = tabbables.join(',');
var queryGuardTabbables = queryTabbables + ', [data-focus-guard]';
var getFocusables = function getFocusables(parents, withGuards) {
  return parents.reduce(function (acc, parent) {
    return acc.concat(
    // add all tabbables inside
    toArray(parent.querySelectorAll(withGuards ? queryGuardTabbables : queryTabbables)),
    // add if node is tabble itself
    parent.parentNode ? toArray(parent.parentNode.querySelectorAll(tabbables.join(','))).filter(function (node) {
      return node === parent;
    }) : []);
  }, []);
};
var getParentAutofocusables = function getParentAutofocusables(parent) {
  var parentFocus = parent.querySelectorAll('[' + FOCUS_AUTO + ']');
  return toArray(parentFocus).map(function (node) {
    return getFocusables([node]);
  }).reduce(function (acc, nodes) {
    return acc.concat(nodes);
  }, []);
};
var isElementHidden = function isElementHidden(computedStyle) {
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var isVisible = function isVisible(node) {
  return !node || node === document || node.nodeType === Node.DOCUMENT_NODE || !isElementHidden(window.getComputedStyle(node, null)) && isVisible(node.parentNode);
};
var notHiddenInput = function notHiddenInput(node) {
  return !((node.tagName === 'INPUT' || node.tagName === 'BUTTON') && (node.type === 'hidden' || node.disabled));
};
var getParents = function getParents(node) {
  var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  parents.push(node);
  if (node.parentNode) {
    getParents(node.parentNode, parents);
  }
  return parents;
};
var getCommonParent = function getCommonParent(nodea, nodeb) {
  var parentsA = getParents(nodea);
  var parentsB = getParents(nodeb);
  for (var i = 0; i < parentsA.length; i += 1) {
    var currentParent = parentsA[i];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var filterFocusable = function filterFocusable(nodes) {
  return toArray(nodes).filter(function (node) {
    return isVisible(node);
  }).filter(function (node) {
    return notHiddenInput(node);
  });
};
var getTabbableNodes = function getTabbableNodes(topNodes, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards)), true, withGuards);
};
var getAllTabbableNodes = function getAllTabbableNodes(topNodes) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes)), false);
};
var parentAutofocusables = function parentAutofocusables(topNode) {
  return filterFocusable(getParentAutofocusables(topNode));
};
var isRadio = function isRadio(node) {
  return node.tagName === 'INPUT' && node.type === 'radio';
};
var findSelectedRadio = function findSelectedRadio(node, nodes) {
  return nodes.filter(isRadio).filter(function (el) {
    return el.name === node.name;
  }).filter(function (el) {
    return el.checked;
  })[0] || node;
};
var pickFirstFocus = function pickFirstFocus(nodes) {
  if (nodes[0] && nodes.length > 1) {
    if (isRadio(nodes[0]) && nodes[0].name) {
      return findSelectedRadio(nodes[0], nodes);
    }
  }
  return nodes[0];
};
var pickFocusable = function pickFocusable(nodes, index) {
  if (nodes.length > 1) {
    if (isRadio(nodes[index]) && nodes[index].name) {
      return nodes.indexOf(findSelectedRadio(nodes[index], nodes));
    }
  }
  return index;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var filterNested = function filterNested(nodes) {
  var l = nodes.length;
  for (var i = 0; i < l; i += 1) {
    var _loop = function _loop(j) {
      if (i !== j) {
        if (nodes[i].contains(nodes[j])) {
          return {
            v: filterNested(nodes.filter(function (x) {
              return x !== nodes[j];
            }))
          };
        }
      }
    };
    for (var j = 0; j < l; j += 1) {
      var _ret = _loop(j);
      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }
  return nodes;
};
var getTopParent = function getTopParent(node) {
  return node.parentNode ? getTopParent(node.parentNode) : node;
};
var getAllAffectedNodes = function getAllAffectedNodes(node) {
  var nodes = asArray(node);
  return nodes.filter(Boolean).reduce(function (acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll('[' + FOCUS_GROUP + '="' + group + '"]:not([' + FOCUS_DISABLED + '="disabled"])'))) : [currentNode]);
    return acc;
  }, []);
};
var findAutoFocused = function findAutoFocused(autoFocusables) {
  return function (node) {
    return !!node.autofocus || node.dataset && !!node.dataset.autofocus || autoFocusables.indexOf(node) >= 0;
  };
};
var isGuard = function isGuard(node) {
  return node && node.dataset && node.dataset.focusGuard;
};
var notAGuard = function notAGuard(node) {
  return !isGuard(node);
};
var newFocus = function newFocus(innerNodes, outerNodes, activeElement, lastNode, autoFocused) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);

  // focus is inside
  if (innerNodes.indexOf(activeElement) >= 0) {
    return undefined;
  }
  var activeIndex = outerNodes.indexOf(activeElement);
  var lastIndex = outerNodes.indexOf(lastNode || activeIndex);
  var lastNodeInside = innerNodes.indexOf(lastNode);
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var returnFirstNode = pickFocusable(innerNodes, 0);
  var returnLastNode = pickFocusable(innerNodes, cnt - 1);

  // new focus
  if (activeIndex === -1 || lastNodeInside === -1) {
    return innerNodes.indexOf(autoFocused && autoFocused.length ? pickFirstFocus(autoFocused) : pickFirstFocus(innerNodes));
  }
  // old focus
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  // first element
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  // last element
  if (activeIndex >= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  // jump out, but not on the guard
  if (indexDiff && Math.abs(indexDiff) > 1) {
    return lastNodeInside;
  }
  // focus above lock
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  // focus below lock
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  // index is inside tab order, but outside Lock
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  // do nothing
  return undefined;
};
var getTopCommonParent = function getTopCommonParent(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = null;
  leftEntries.filter(Boolean).forEach(function (entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function (subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || common.contains(topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};
var allParentAutofocusables = function allParentAutofocusables(entries) {
  return entries.reduce(function (acc, node) {
    return acc.concat(parentAutofocusables(node));
  }, []);
};
var reorderNodes = function reorderNodes(srcNodes, dstNodes) {
  var remap = new Map();
  // no Set(dstNodes) for IE11 :(
  dstNodes.forEach(function (entity) {
    return remap.set(entity.node, entity);
  });
  // remap to dstNodes
  return srcNodes.map(function (node) {
    return remap.get(node);
  }).filter(Boolean);
};
var getFocusabledIn = function getFocusabledIn(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var outerNodes = getTabbableNodes([commonParent], true);
  var innerElements = getTabbableNodes(entries).filter(function (_ref) {
    var node = _ref.node;
    return notAGuard(node);
  }).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  });
  return outerNodes.map(function (_ref3) {
    var node = _ref3.node,
      index = _ref3.index;
    return {
      node: node,
      index: index,
      lockItem: innerElements.indexOf(node) >= 0,
      guard: isGuard(node)
    };
  });
};
var getFocusMerge = function getFocusMerge(topNode, lastNode) {
  var activeElement = document && document.activeElement;
  var entries = getAllAffectedNodes(topNode).filter(notAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
  var innerElements = getTabbableNodes(entries).filter(function (_ref4) {
    var node = _ref4.node;
    return notAGuard(node);
  });
  if (!innerElements[0]) {
    innerElements = getAllTabbableNodes(entries).filter(function (_ref5) {
      var node = _ref5.node;
      return notAGuard(node);
    });
    if (!innerElements[0]) {
      return undefined;
    }
  }
  var outerNodes = getTabbableNodes([commonParent]).map(function (_ref6) {
    var node = _ref6.node;
    return node;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function (_ref7) {
    var node = _ref7.node;
    return node;
  });
  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode, innerNodes.filter(findAutoFocused(allParentAutofocusables(entries))));
  if (newId === undefined) {
    return newId;
  }
  return orderedInnerElements[newId];
};
var focusInFrame = function focusInFrame(frame) {
  return frame === document.activeElement;
};
var focusInsideIframe = function focusInsideIframe(topNode) {
  return !!arrayFind(toArray(topNode.querySelectorAll('iframe')), focusInFrame);
};
var focusInside = function focusInside(topNode) {
  var activeElement = document && document.activeElement;
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).reduce(function (result, node) {
    return result || node.contains(activeElement) || focusInsideIframe(node);
  }, false);
};
var focusIsHidden = function focusIsHidden() {
  return document && toArray(document.querySelectorAll('[' + FOCUS_ALLOW + ']')).some(function (node) {
    return node.contains(document.activeElement);
  });
};
var focusOn = function focusOn(target) {
  target.focus();
  if (target.contentWindow) {
    target.contentWindow.focus();
  }
};
var guardCount = 0;
var lockDisabled = false;
var setFocus = function setFocus(topNode, lastNode) {
  var focusable = getFocusMerge(topNode, lastNode);
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    if (guardCount > 2) {
      // eslint-disable-next-line no-console
      console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' + 'See https://github.com/theKashey/focus-lock/#focus-fighting');
      lockDisabled = true;
      setTimeout(function () {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node);
    guardCount--;
  }
};
function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
    setImmediate = _window.setImmediate;
  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}
var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist() {
  return true;
};
var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;
  do {
    var item = allNodes[i];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho

  return focusWasOutsideWindow === "meanwhile";
};
var activateTrap = function activateTrap() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
      observed = _lastActiveTrap.observed,
      persistentFocus = _lastActiveTrap.persistentFocus,
      autoFocus = _lastActiveTrap.autoFocus,
      shards = _lastActiveTrap.shards,
      crossFrame = _lastActiveTrap.crossFrame;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              activeElement.blur();
              document.body.focus();
            } else {
              result = setFocus(workingArea, lastActiveFocus);
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = getFocusabledIn(workingArea);
        var focusedItem = allNodes.find(function (_ref) {
          var node = _ref.node;
          return node === newActiveElement;
        });
        if (focusedItem) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
              node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          var focusedIndex = allNodes.indexOf(focusedItem);
          autoGuard(focusedIndex, allNodes.length, +1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher() {
  return null;
};
var FocusTrap = function FocusTrap(_ref4) {
  var children = _ref4.children;
  return React.createElement("div", {
    onBlur: onBlur,
    onFocus: onFocus
  }, children);
};
var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = "just"; // using setTimeout to set  this variable after React/sidecar reaction

  setTimeout(function () {
    focusWasOutsideWindow = "meanwhile";
  }, 0);
};
var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap, true);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};
var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap, true);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }
    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium

mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: setFocus,
    focusInside: focusInside
  });
});
var FocusTrap$1 = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = React.forwardRef(function (props, ref) {
  return React.createElement(FocusLock, _extends$4({
    sideCar: FocusTrap$1,
    ref: ref
  }, props));
});
var _ref$2 = FocusLock.propTypes || {},
  sideCar = _ref$2.sideCar;
var defaultParent = typeof document !== 'undefined' ? document.body : null;
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var hideOthers = function hideOthers(originalTarget, parentNode, markerName) {
  if (parentNode === void 0) {
    parentNode = defaultParent;
  }
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.isArray(originalTarget) ? originalTarget : [originalTarget];
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var deep = function deep(parent) {
    if (!parent || targets.indexOf(parent) >= 0) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node) {
      if (targets.some(function (target) {
        return node.contains(target);
      })) {
        deep(node);
      } else {
        var attr = node.getAttribute('aria-hidden');
        var alreadyHidden = attr !== null && attr !== 'false';
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenNodes.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node, true);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, 'true');
        }
        if (!alreadyHidden) {
          node.setAttribute('aria-hidden', 'true');
        }
      }
    });
  };
  deep(parentNode);
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute('aria-hidden');
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledNodes = new WeakMap();
      markerMap = {};
    }
  };
};
var bodyScrollLock_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    t(exports);
  }(commonjsGlobal, function (exports) {
    function i(e) {
      if (Array.isArray(e)) {
        for (var t = 0, o = Array(e.length); t < e.length; t++) o[t] = e[t];
        return o;
      }
      return Array.from(e);
    }
    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var l = !1;
    if ("undefined" != typeof window) {
      var e = {
        get passive() {
          l = !0;
        }
      };
      window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
    }
    function d(t) {
      return u.some(function (e) {
        return !(!e.options.allowTouchMove || !e.options.allowTouchMove(t));
      });
    }
    function c(e) {
      var t = e || window.event;
      return !!d(t.target) || 1 < t.touches.length || (t.preventDefault && t.preventDefault(), !1);
    }
    function o() {
      setTimeout(function () {
        void 0 !== m && (document.body.style.paddingRight = m, m = void 0), void 0 !== f && (document.body.style.overflow = f, f = void 0);
      });
    }
    var a = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && 1 < window.navigator.maxTouchPoints),
      u = [],
      s = !1,
      v = -1,
      f = void 0,
      m = void 0;
    exports.disableBodyScroll = function (r, e) {
      if (a) {
        if (!r) return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        if (r && !u.some(function (e) {
          return e.targetElement === r;
        })) {
          var t = {
            targetElement: r,
            options: e || {}
          };
          u = [].concat(i(u), [t]), r.ontouchstart = function (e) {
            1 === e.targetTouches.length && (v = e.targetTouches[0].clientY);
          }, r.ontouchmove = function (e) {
            var t, o, n, i;
            1 === e.targetTouches.length && (o = r, i = (t = e).targetTouches[0].clientY - v, d(t.target) || (o && 0 === o.scrollTop && 0 < i || (n = o) && n.scrollHeight - n.scrollTop <= n.clientHeight && i < 0 ? c(t) : t.stopPropagation()));
          }, s || (document.addEventListener("touchmove", c, l ? {
            passive: !1
          } : void 0), s = !0);
        }
      } else {
        n = e, setTimeout(function () {
          if (void 0 === m) {
            var e = !!n && !0 === n.reserveScrollBarGap,
              t = window.innerWidth - document.documentElement.clientWidth;
            e && 0 < t && (m = document.body.style.paddingRight, document.body.style.paddingRight = t + "px");
          }
          void 0 === f && (f = document.body.style.overflow, document.body.style.overflow = "hidden");
        });
        var o = {
          targetElement: r,
          options: e || {}
        };
        u = [].concat(i(u), [o]);
      }
      var n;
    }, exports.clearAllBodyScrollLocks = function () {
      a ? (u.forEach(function (e) {
        e.targetElement.ontouchstart = null, e.targetElement.ontouchmove = null;
      }), s && (document.removeEventListener("touchmove", c, l ? {
        passive: !1
      } : void 0), s = !1), u = [], v = -1) : (o(), u = []);
    }, exports.enableBodyScroll = function (t) {
      if (a) {
        if (!t) return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        t.ontouchstart = null, t.ontouchmove = null, u = u.filter(function (e) {
          return e.targetElement !== t;
        }), s && 0 === u.length && (document.removeEventListener("touchmove", c, l ? {
          passive: !1
        } : void 0), s = !1);
      } else (u = u.filter(function (e) {
        return e.targetElement !== t;
      })).length || o();
    };
  });
});
unwrapExports(bodyScrollLock_min);
var bodyScrollLock_min_1 = bodyScrollLock_min.disableBodyScroll;
var bodyScrollLock_min_2 = bodyScrollLock_min.clearAllBodyScrollLocks;
var fade = function fade(isActive) {
  return keyframes({
    from: {
      opacity: isActive ? 0 : 1
    },
    to: {
      opacity: isActive ? 1 : 0
    }
  });
};
var backgroundContainer = function backgroundContainer(isActive) {
  return {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    animation: "".concat(fade(isActive), " 200ms ease-in")
  };
};
var css_248z$5 = ".hideFocus_IKnowIShouldntButHideFocusRing__2CB3b:focus {\n  outline: none; }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImhpZGVGb2N1cy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBYSxFQUFFIiwiZmlsZSI6ImhpZGVGb2N1cy5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLklLbm93SVNob3VsZG50QnV0SGlkZUZvY3VzUmluZzpmb2N1cyB7XG4gIG91dGxpbmU6IG5vbmU7IH1cbiJdfQ== */";
var hideFocus = {
  "IKnowIShouldntButHideFocusRing": "hideFocus_IKnowIShouldntButHideFocusRing__2CB3b"
};
styleInject(css_248z$5);
function useKeyUp(key, onKeyUp) {
  var arr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  React.useEffect(function () {
    function keyUpHandler(e) {
      if (e.code && e.code.toLowerCase() === key.toLowerCase()) {
        onKeyUp(e);
      }
    }
    document.addEventListener('keyup', keyUpHandler);
    return function () {
      document.removeEventListener('keyup', keyUpHandler);
    };
  }, [key].concat(_toConsumableArray3(arr)));
}
var useModal = function useModal(active) {
  var _React$useState11 = React.useState(active),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isActive = _React$useState12[0],
    setActive = _React$useState12[1];
  var ref = React.useRef(null);
  return [{
    isActive: isActive,
    onEsc: function onEsc() {
      setActive(false);
    },
    triggerRef: ref
  }, setActive, ref];
};
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement); // eslint-disable-next-line no-undef

var SafeElement = canUseDOM ? Element : {};
var modalProps = {
  /**
   * passed down to the modal component. `aria-labelledby` and `aria-describedby`
   * are required for using this component. If labelId is provided it will be
   * applied to ariaProps['aria-labelledby']
   */
  ariaProps: propTypes.object,
  /**
   * Object that allows you to directly pass classNames down.
   */
  classes: propTypes.shape({
    root: propTypes.string
  }),
  /**
   * Pass dataProps an object containing data attributes.
   *
   * **Example**:
   * `dataProps = {{ 'data-qa-selector' : 'some-value' }}`
   */
  dataProps: propTypes.objectOf(propTypes.string),
  /**
   * indicates whether or not the Modal is presented
   */
  isActive: propTypes.bool,
  /**
   * This is use to label the modal. This or ariaProps with
   * aria-labelledby is required.
   */
  labelId: propTypes.string,
  /**
   * handler for when the onClick event is fired on the background of the modal.
   * Can be used to close the modal.
   */
  onBackgroundClick: propTypes.func,
  /**
   * handler for when the user presses the ESC key.
   * Can be used to close the modal.
   */
  onEsc: propTypes.func,
  /**
   * If the modal content does not have something to natively focus on
   * like a button or input, or if you want to focus on _not_ the first
   * focusable item you can pass a ref in here to bein focus when you
   * open the Modal. Note that if you pass somehting that can't natively
   * be focused we will assume it's a text node and apply a tabIndex of -1
   * and a class to hide the focus ring. If this is not provided and there
   * is no natively focusable element inside the modal we will attempt to
   * focus the element that is labelling the modal (provided by labelId)
   */
  onMountFocusRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.instanceOf(SafeElement)
  })]),
  /**
   * handler for when the onScroll event is fired.
   * Can be used to close the modal.
   */
  onScroll: propTypes.func,
  /**
   * ref to what initiated the launch of the modal. When
   * the modal is closed, the focus will be returned to this ref
   */
  triggerRef: propTypes.oneOfType([propTypes.func, propTypes.shape({
    current: propTypes.instanceOf(SafeElement)
  })])
};
/**
 * warnings and errors if consumer tries to ignore aria props or passes in a badly formatted
 * child. exporting so that we can test these showing up
 */

var ariaWarning = "Modal should have an aria-labelledBy or an aria-describedby prop\nhttps://www.w3.org/TR/wai-aria-practices-1.1/examples/dialog-modal/dialog.html";
var childrenError = "Due to the fact that we are cloning the child of the modal we require\nthat there be only one child element. (Dont use fragments to try and bypass this)";
/**
 * Given a node attempt to focus it. If we can we're done.
 * If not we assume it's a text node, apply a -1 tabIndex
 * and a class to hide the focus ring, then focus it.
 */

var checkAndApplyFocus = function checkAndApplyFocus(node) {
  node.focus();
  if (document.activeElement !== node) {
    node.setAttribute('tabIndex', -1);
    node.classList.add(hideFocus.IKnowIShouldntButHideFocusRing);
    node.focus();
  }
};
/**
 * We have this as its own component so that we can better handle cleanup effects and
 * dont have to rely on the consumer unmounting the modal to cleanup. This way the Modal component
 * itself actually handles mounting and unmounting the component and we can always ensure cleanup
 * takes place at the right time
 */

var ModalContent = function ModalContent(props) {
  var ariaProps = props.ariaProps,
    _props$classes2 = props.classes,
    classes = _props$classes2 === void 0 ? {} : _props$classes2,
    _props$dataProps = props.dataProps,
    dataProps = _props$dataProps === void 0 ? {} : _props$dataProps,
    isActive = props.isActive,
    onBackgroundClick = props.onBackgroundClick,
    onEsc = props.onEsc,
    onScroll = props.onScroll,
    triggerRef = props.triggerRef,
    onMountFocusRef = props.onMountFocusRef,
    labelId = props.labelId;
  useKeyUp('escape', function (e) {
    onEsc(e);
  }); // used for aria-hidden

  var backgroundRef = React.useRef(null);
  /**
   * Cleanup and reassign focus to the trigger Ref
   */

  React.useEffect(function () {
    // We need to handle initial focus inside the modal
    setTimeout(function () {
      // If they passed in a focus ref prioritize that
      if (onMountFocusRef && onMountFocusRef.current) {
        checkAndApplyFocus(onMountFocusRef.current);
      } else if (
      /**
       * They did not pass in a focus ref. let's see if something is already
       * in focus thanks to react-focus-lock, or if they passed in an id
       */
      !backgroundRef.current.contains(document.activeElement) && (labelId || ariaProps['aria-labelledby'])) {
        // nothing is focused but we have an id. lets find it and focus it
        var idToFocus = ariaProps['aria-labelledby'] || labelId;
        var focusElement = document.getElementById(idToFocus);
        if (focusElement) {
          checkAndApplyFocus(focusElement);
        }
      }
    }, 0);
    return function returnFocus() {
      /**
       * We need to use a zero timeout here per react-focus-lock
       * https://github.com/theKashey/react-focus-lock#unmounting-and-focus-management
       */
      setTimeout(function () {
        if (triggerRef && triggerRef.current) {
          triggerRef.current.focus();
        }
      }, 0);
    };
  }, [triggerRef.current, backgroundRef.current]);
  /**
   * lock scroll and clean it up
   */

  React.useEffect(function () {
    if (!onScroll) {
      bodyScrollLock_min_1(backgroundRef.current);
    }
    return function unlockScroll() {
      if (!onScroll) {
        bodyScrollLock_min_2();
      }
    };
  }, [backgroundRef]);
  /**
   * if they want an event (like closing) to happen on scroll
   * set up and clean up the listeners here
   */

  React.useEffect(function () {
    if (onScroll) {
      document.addEventListener('scroll', onScroll);
    }
    return function removeListener() {
      if (onScroll) {
        document.removeEventListener('scroll', onScroll);
      }
    };
  }, [onScroll]);
  React.useEffect(function () {
    var undo = hideOthers(backgroundRef.current);
    return function showAria() {
      undo();
    };
  }, []);
  React.useEffect(function () {}, [backgroundRef.current]);
  var child = /*#__PURE__*/React__default.cloneElement(props.children, _objectSpread3(_objectSpread3({
    'aria-modal': 'true',
    'aria-labelledby': labelId,
    role: 'dialog'
  }, ariaProps), {}, {
    onClick: function onClick(e) {
      if (props.children.props.onClick) {
        props.children.props.onClick();
      } // We dont want to trigger a click on the background

      e.stopPropagation();
    }
  }));
  return /*#__PURE__*/reactDom.createPortal(jsx(FocusLockCombination, {
    autoFocus: true
  }, jsx("div", _extends({
    className: classes.root ? classes.root : null,
    css: backgroundContainer(isActive),
    onClick: function onClick(e) {
      return onBackgroundClick ? onBackgroundClick(e) : null;
    },
    ref: backgroundRef
  }, dataProps), child)), document.body);
};
var Modal = function Modal(props) {
  var _props$ariaProps = props.ariaProps,
    ariaProps = _props$ariaProps === void 0 ? {} : _props$ariaProps,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    labelId = props.labelId;
  var labelledBy = labelId || ariaProps['aria-labelledby'];
  var describedBy = ariaProps['aria-describedby'];
  if (!labelledBy && !describedBy) {
    console.warn(ariaWarning);
  }
  if (React__default.Children.count(props.children) > 1) {
    console.error(childrenError);
  }
  var _React$useState13 = React.useState(isActive),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    showModal = _React$useState14[0],
    setShowModal = _React$useState14[1];
  React.useEffect(function () {
    if (!isActive && showModal) {
      setTimeout(function () {
        return setShowModal(false);
      }, 200);
    } else if (isActive && !showModal) {
      setShowModal(true);
    }
  }, [isActive]);
  return showModal ? jsx(React__default.Fragment, null, jsx(ModalContent, _extends({}, props, {
    ariaProps: ariaProps
  }), props.children)) : null;
};
Modal.propTypes = modalProps;
Modal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Modal",
  "props": {
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the modal component. `aria-labelledby` and `aria-describedby`\nare required for using this component. If labelId is provided it will be\napplied to ariaProps['aria-labelledby']"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "root": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "Object that allows you to directly pass classNames down."
    },
    "dataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass dataProps an object containing data attributes.\n\n**Example**:\n`dataProps = {{ 'data-qa-selector' : 'some-value' }}`"
    },
    "isActive": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates whether or not the Modal is presented"
    },
    "labelId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "This is use to label the modal. This or ariaProps with\naria-labelledby is required."
    },
    "onBackgroundClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when the onClick event is fired on the background of the modal.\nCan be used to close the modal."
    },
    "onEsc": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when the user presses the ESC key.\nCan be used to close the modal."
    },
    "onMountFocusRef": {
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "shape",
          "value": {
            "current": {
              "name": "instanceOf",
              "value": "SafeElement",
              "required": false
            }
          }
        }]
      },
      "required": false,
      "description": "If the modal content does not have something to natively focus on\nlike a button or input, or if you want to focus on _not_ the first\nfocusable item you can pass a ref in here to bein focus when you\nopen the Modal. Note that if you pass somehting that can't natively\nbe focused we will assume it's a text node and apply a tabIndex of -1\nand a class to hide the focus ring. If this is not provided and there\nis no natively focusable element inside the modal we will attempt to\nfocus the element that is labelling the modal (provided by labelId)"
    },
    "onScroll": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "handler for when the onScroll event is fired.\nCan be used to close the modal."
    },
    "triggerRef": {
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "shape",
          "value": {
            "current": {
              "name": "instanceOf",
              "value": "SafeElement",
              "required": false
            }
          }
        }]
      },
      "required": false,
      "description": "ref to what initiated the launch of the modal. When\nthe modal is closed, the focus will be returned to this ref"
    }
  }
};
var pollCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * A dom node that will be rendered on top of the image. The wrapping element
   * will be absolutely positioned
   */
  imageOverlay: propTypes.node,
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
  * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseEnter={() => console.log('mouseEntered')}`
  */
  onMouseEnter: propTypes.func,
  /**
  * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
  *
  * **Example**:
  * `onMouseLeave={() => console.log('mouseLeft')}`
  */
  onMouseLeave: propTypes.func,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles.
   */
  __renderImage: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func,
  /**
   * PollCards do not accept a metaData prop like most of the other components based on `ContentCards`.
   * Designs for the PollCard do not indicate metaData so it instead uses a default __renderMetaData prop to render nothing at all
   * so as not to render the LoadingShimmer.
   * This will not be called if __renderTextual is defined.
   *
   * **Example**:
   * `__renderMetaData: () => null`
   *
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var PollCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  PollCard.displayName = 'PollCard';
  return jsx(ContentCard, _extends({}, props, {
    contentType: "Poll",
    ref: ref
  }));
});
PollCard.propTypes = pollCardProps;
PollCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PollCard",
  "props": {
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "imageOverlay": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "A dom node that will be rendered on top of the image. The wrapping element\nwill be absolutely positioned"
    },
    "isVertical": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles."
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "PollCards do not accept a metaData prop like most of the other components based on `ContentCards`.\nDesigns for the PollCard do not indicate metaData so it instead uses a default __renderMetaData prop to render nothing at all\nso as not to render the LoadingShimmer.\nThis will not be called if __renderTextual is defined.\n\n**Example**:\n`__renderMetaData: () => null`"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var TextSetCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * ariaProps passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  /**
   * number of total items included within the lesson spark bundle.
   */
  assetCount: propTypes.number,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date that the lesson spark was published
   */
  datePublished: propTypes.string,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3({}, imgProps)),
  /**
   * Boolean value passed down to the ContentCard.
   */
  isVertical: propTypes.bool,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
   * render a custom wrapper for the card
   */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
  * render prop to create image overlays.
  */
  __renderImageOverlay: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to override the textual portion
   */
  __renderTextual: propTypes.func
});
var TextSetCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  TextSetCard.displayName = 'TextSetCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doing the work).
   * passThroughProps must be passed before any other props. This is because
   * we dont want to allow the consumers to override our props here.
   */

  var assetCount = props.assetCount,
    datePublished = props.datePublished,
    passThroughProps = _objectWithoutProperties3(props, _excluded12);
  var assetLabel = getAssetCountLanguage(assetCount);
  var metaData = [];
  if (assetCount >= 0) {
    metaData.push(assetLabel);
  }
  if (datePublished) {
    metaData.push(dateFormatted(datePublished));
  }
  return jsx(ContentCard, _extends({}, passThroughProps, {
    contentType: "Text Set",
    imageOverlay: assetCount !== undefined && jsx("div", {
      css: /*#__PURE__*/css(_objectSpread3(_objectSpread3({}, defaultImageOverlayContainer), {}, {
        flexDirection: 'row-reverse'
      }), ";label:TextSetCard;")
    }, jsx("div", {
      css: props.isVertical ? verticalRightImageOverlay : horizontalRightImageOverlay
    }, jsx(MultiItemSVG, {
      multiItemCount: assetCount,
      ariaProps: {
        'aria-hidden': true
      }
    }))),
    metaData: metaData,
    ref: ref
  }));
});
TextSetCard.propTypes = TextSetCardProps;
TextSetCard.defaultProps = {
  isVertical: ContentCard.defaultProps.isVertical
};
TextSetCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextSetCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "ContentCard.defaultProps.isVertical",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Boolean value passed down to the ContentCard."
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps passed to the a tag"
    },
    "assetCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of total items included within the lesson spark bundle."
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date that the lesson spark was published"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render a custom wrapper for the card"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderTextual": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the textual portion"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var baseStyle = /*#__PURE__*/css({
  width: '0.5rem',
  '> *': {
    fill: ui.greyLight[100]
  },
  margin: '0.1rem 0.25rem'
}, ";label:baseStyle;");
var upArrow = {
  name: "1fotunc-upArrow",
  styles: "transform:rotate(180deg);;label:upArrow;"
};
var sortingArrowsWrapper = {
  display: 'flex',
  flexDirection: 'column'
};
var sortedStyle = {
  '> *': {
    fill: ui.coreBlue[500]
  }
};
function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
var _ref$3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M12.368.957C12.187.675 11.846.5 11.477.5H1.523c-.37 0-.71.175-.891.456a.802.802 0 00.015.905l4.977 7.207c.186.268.518.432.876.432s.69-.164.875-.432l4.977-7.207a.802.802 0 00.016-.904z",
  fill: "#000"
});
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    viewBox: "0 0 13 10"
  }, props), _ref$3);
}
var sortingArrowsProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  classes: propTypes.shape({
    /**
     * class applied to the down arrow
     */
    downArrow: propTypes.string,
    /**
     * applied to the root element after additionalClassname
     */
    root: propTypes.string,
    /**
     * class applied to the sorted arrow
     */
    sortedArrow: propTypes.string,
    /**
     * class applied to the up arrow
     */
    upArrow: propTypes.string
  }),
  /**
   * are we currently sorting
   */
  isSorted: propTypes.bool,
  /**
   * are we sorting in descending order?
   */
  isSortedDesc: propTypes.bool
});
var SortingArrows = function SortingArrows(_ref19) {
  var isSorted = _ref19.isSorted,
    isSortedDesc = _ref19.isSortedDesc,
    additionalClassName = _ref19.additionalClassName,
    classes = _ref19.classes,
    __css = _ref19.__css;
  return jsx("div", {
    css: /*#__PURE__*/css([sortingArrowsWrapper, additionalClassName, __css], ";label:SortingArrows;")
  }, jsx(SvgArrowDown, {
    css: /*#__PURE__*/css([baseStyle, upArrow, isSorted && !isSortedDesc && sortedStyle, classes.upArrow, isSorted && !isSortedDesc && classes.sortedArrow], ";label:SortingArrows;")
  }), jsx(SvgArrowDown, {
    css: /*#__PURE__*/css([baseStyle, isSorted && isSortedDesc && sortedStyle, classes.downArrow, isSorted && !isSortedDesc && classes.sortedArrow], ";label:SortingArrows;")
  }));
};
SortingArrows.propTypes = sortingArrowsProps;
SortingArrows.defaultProps = {
  classes: {}
};
SortingArrows.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SortingArrows",
  "props": {
    "classes": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "shape",
        "value": {
          "downArrow": {
            "name": "string",
            "description": "class applied to the down arrow",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "applied to the root element after additionalClassname",
            "required": false
          },
          "sortedArrow": {
            "name": "string",
            "description": "class applied to the sorted arrow",
            "required": false
          },
          "upArrow": {
            "name": "string",
            "description": "class applied to the up arrow",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "isSorted": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "are we currently sorting"
    },
    "isSortedDesc": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "are we sorting in descending order?"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var style$3 = {
  backgroundColor: ui.orange[100],
  height: '100%',
  fontFamily: 'Circular, Helvetica, Arial, sans-serif',
  display: 'flex',
  flexDirection: 'column'
};
var cardContentStyle = function cardContentStyle(_ref20) {
  var isVertical = _ref20.isVertical;
  return {
    margin: "".concat(isVertical ? '24px' : '16px', " 24px 24px"),
    minHeight: isVertical ? '300px' : '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  };
};
var contentTypeStyle$1 = _objectSpread3(_objectSpread3({}, text4Obj), {}, {
  textTransform: 'uppercase',
  marginBottom: '8px'
});
var titleStyle$1 = function titleStyle$1(_ref21) {
  var isVertical = _ref21.isVertical;
  return _objectSpread3(_objectSpread3({}, heading4Obj), {}, {
    margin: isVertical ? '20px 0' : '8x 0',
    lineHeight: '1.2',
    fontWeight: 'normal',
    wordBreak: 'break-word'
  });
};
var descriptionStyle = _objectSpread3({
  lineHeight: '1.25',
  letterSpacing: '0.5px'
}, heading5Obj);
var metaDataStyle = {
  margin: '16px 0'
};
var smallHeight$1 = '91.5px';
var largeHeight$1 = '123px';
var horizHeight$1 = '61.5px';
var loadingShimmerWrapperStyle = function loadingShimmerWrapperStyle(_ref22) {
  var isVertical = _ref22.isVertical;
  return mobileFirstCss({
    display: 'flex',
    flexDirection: 'column',
    height: isVertical ? [smallHeight$1, smallHeight$1, largeHeight$1, largeHeight$1] : [horizHeight$1, horizHeight$1, horizHeight$1, horizHeight$1],
    marginTop: isVertical ? '8px' : '4px',
    '*': {
      marginBottom: isVertical ? '8px' : '4px'
    }
  });
};
var StandardCardProps = _objectSpread3(_objectSpread3({
  /**
     * Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want
     * to apply aria attributes directly to the anchor tag.
     *
     * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
     *
     * **Example**:
     * `anchorAriaProps = {{
     * 'aria-label' : 'some-value',
     * 'aria-pressed : 'some-value'
     * }}`
     */
  anchorAriaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
   * Pass anchorDataProps an object containing data attributes if you have set the href prop and you want
   * to apply data attributes directly to the anchor tag.
   *
   * **Example**:
   * `anchorDataProps = {{ 'data-test' : 'some-value' }}`
   */
  anchorDataProps: propTypes.objectOf(propTypes.string)
}, AngelouProps), {}, {
  /**
   * Pass ariaProps an object containing aria attributes. These values will be passed down the <Card /> component.
   * If you have set the href prop you want to apply aria attributes directly to the anchor tag, use anchorAriaProps.
   *
   * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
   *
   * **Example**:
   * `ariaProps = {{
   * 'aria-label' : 'some-value',
   * 'aria-pressed : 'some-value'
   * }}`
   *
   */
  ariaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
   * Pass dataProps an object containing data attributes. These values will be passed down the <Card /> component.
   * If you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.
   *
   * **Example**:
   * `dataProps = {{ 'data-test' : 'some-value' }}`
   */
  dataProps: propTypes.objectOf(propTypes.string),
  /**
   * date the standard was published
   *
   * **Example**
   * `datePublished='Mon Apr 13 2020 15:06:39 GMT-0400 (Eastern Daylight Time)'
   */
  datePublished: propTypes.string,
  /**
   * Pass description a string to render the standards description.
   *
   * **Example**:
   * `description='Text describing a standard...etc.'`
   */
  description: propTypes.string,
  /**
   * Number of lines the description is allowed to be before being
   * truncated. Vertical cards default to 4 lines. Horizontal cards default to 2 lines.
   */
  descriptionLineNum: propTypes.number,
  /**
   * Pass gradeRange a string representing the grades to which this Standard applies.
   *
   * **Example**
   * `gradeRange="K-4"`
  */
  gradeRange: propTypes.string,
  /**
   * Pass the footer prop a node that will render in the footer section of the card.
   */
  footer: propTypes.node,
  /**
   * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
   * If rendering the card using a <Link />, an object can be passed.
   *
   * **String example**:
   * `href='http://newsela.com'`
   *
   * **Object example**:
   *  `href={{
          pathname: /path/to/url},
          state: {
            ...
          }
        }}`
   */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * Pass the isVertical prop a boolean value.
   *
   * **Example**:
   * `isVertical={true}`
   */
  isVertical: propTypes.bool,
  /**
   * Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />
   *
   * **Example**:
   * `loadingStateBackgroundColor="red"`
   */
  loadingStateBackgroundColor: propTypes.string,
  /**
   * Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />
   *
   * **Example**:
   * `loadingStateShimmerColor="blue"`
   */
  loadingStateShimmerColor: propTypes.string,
  /**
   * Pass the onClick prop a function.
   *
   * **Example**:
   * `onClick={() => console.log('clicked')}`
   */
  onClick: propTypes.func,
  /**
   * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseEnter={() => console.log('mouseEntered')}`
   */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * String representing the school subject for which this Standard applies.
   *
   * **Example**:
   * `subject='Social Studies'`
   */
  subject: propTypes.string,
  /**
     * Pass title a string to render the standards title.
     *
     * **Example**:
     * `title='9.5c.2'`
     */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * Pass __renderCustomWrapper a function to render the Card as something other than a div.
   *
   * **Example**:
   `__renderCustomWrapper={(linkTagWithChildren, cardProps) => (
     <article {...cardProps}>
        {linkTagWithChildren}
      </article>
   )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * Pass __renderCustomLink a function to render the Card with a React Router Link.
   *
   * **Example**:
    `__renderCustomLink={(clickableCardStyle, href) => (
      <Link
        href={href}
        css={linkStyle}
      />
    )}`
  */
  __renderCustomLink: propTypes.func,
  /**
   * Pass __renderMetaData a function that will override our default use of the CardMetaData component.
   *
   * **Example**:
   *  `__renderMetaData={(css) => (
        <div {...css}>Item 1 | Item 2 | Item 3 | Item 4</div>
      )}`
   */
  __renderMetaData: propTypes.func
});
var StandardCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  StandardCard.displayName = 'StandardCard';
  var additionalClassName = props.additionalClassName,
    anchorAriaProps = props.anchorAriaProps,
    anchorDataProps = props.anchorDataProps,
    ariaProps = props.ariaProps,
    contentType = props.contentType,
    dataProps = props.dataProps,
    datePublished = props.datePublished,
    description = props.description,
    descriptionLineNum = props.descriptionLineNum,
    footer = props.footer,
    gradeRange = props.gradeRange,
    href = props.href,
    isVertical = props.isVertical,
    loadingStateBackgroundColor = props.loadingStateBackgroundColor,
    loadingStateShimmerColor = props.loadingStateShimmerColor,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    subject = props.subject,
    title = props.title,
    titleLineNum = props.titleLineNum,
    __css = props.__css,
    __renderCustomLink = props.__renderCustomLink,
    __renderCustomWrapper = props.__renderCustomWrapper,
    __renderMetaData = props.__renderMetaData;
  var renderContentType = function renderContentType() {
    return jsx("div", {
      css: contentTypeStyle$1
    }, contentType);
  };
  var renderTitle = function renderTitle() {
    var clampedTitle = jsx(LineClamp, {
      css: titleStyle$1({
        isVertical: isVertical
      }),
      innerElement: "h2",
      text: title,
      lines: titleLineNum
    });
    var shimmerTitle = jsx("div", {
      css: loadingTitleWrapper({
        isVertical: isVertical
      })
    }, jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }), jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }), jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }));
    return title ? clampedTitle : shimmerTitle;
  };
  var renderDescription = function renderDescription() {
    var clampedDescription = jsx(LineClamp, {
      css: descriptionStyle,
      lines: descriptionLineNum || (isVertical ? 5 : 2),
      text: description
    });
    var shimmerDescription = jsx("div", {
      css: loadingShimmerWrapperStyle({
        isVertical: isVertical
      })
    }, jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }), jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }), jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }), isVertical && jsx(LoadingShimmer, {
      backgroundColor: loadingStateBackgroundColor,
      shimmerColor: loadingStateShimmerColor
    }));
    return description ? clampedDescription : shimmerDescription;
  };
  var metaData = function metaData() {
    var metaDataArr = [];
    if (subject) {
      metaDataArr.push(subject);
    }
    if (gradeRange) {
      metaDataArr.push(gradeRange);
    }
    if (datePublished) {
      metaDataArr.push(dateFormatted(datePublished));
    }
    return metaDataArr;
  };
  var renderMetaData = function renderMetaData() {
    return __renderMetaData ? __renderMetaData({
      css: metaDataStyle
    }, jsx(CardMetaData, null)) : jsx(CardMetaData, {
      css: metaDataStyle,
      metaData: metaData()
    });
  };
  var renderStandardCardContent = function renderStandardCardContent() {
    return jsx("div", {
      css: cardContentStyle({
        isVertical: isVertical
      })
    }, jsx("div", null, renderContentType(), renderTitle(), renderDescription()), jsx("div", null, renderMetaData(), footer && footer));
  };
  return jsx(Card, {
    additionalClassName: additionalClassName,
    anchorAriaProps: _objectSpread3({
      'aria-label': "".concat(contentType, " - ").concat(title)
    }, anchorAriaProps),
    anchorDataProps: anchorDataProps,
    ariaProps: ariaProps,
    contentType: contentType,
    dataProps: dataProps,
    footer: footer,
    href: href,
    isVertical: isVertical,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    ref: ref,
    __css: [style$3, cardHoverTitle, focusStyleTitle, __css],
    __renderCustomLink: __renderCustomLink,
    __renderCustomWrapper: __renderCustomWrapper
  }, renderStandardCardContent());
});
StandardCard.propTypes = StandardCardProps;
StandardCard.defaultProps = {
  contentType: 'Standard',
  isVertical: true,
  loadingStateBackgroundColor: ui.greyExtraLight[100],
  loadingStateShimmerColor: ui.orange[100],
  titleLineNum: 2,
  __renderCustomWrapper: function __renderCustomWrapper(props, linkTagWithChildren) {
    return jsx("article", props, linkTagWithChildren);
  }
};
StandardCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StandardCard",
  "props": {
    "contentType": {
      "defaultValue": {
        "value": "'Standard'",
        "computed": false
      },
      "required": false
    },
    "isVertical": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Pass the isVertical prop a boolean value.\n\n**Example**:\n`isVertical={true}`"
    },
    "loadingStateBackgroundColor": {
      "defaultValue": {
        "value": "ui.greyExtraLight[100]",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />\n\n**Example**:\n`loadingStateBackgroundColor=\"red\"`"
    },
    "loadingStateShimmerColor": {
      "defaultValue": {
        "value": "ui.orange[100]",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />\n\n**Example**:\n`loadingStateShimmerColor=\"blue\"`"
    },
    "titleLineNum": {
      "defaultValue": {
        "value": "2",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderCustomWrapper": {
      "defaultValue": {
        "value": "(props, linkTagWithChildren) => {\n  return (\n    <article {...props}>\n      {linkTagWithChildren}\n    </article>\n  );\n}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n   `__renderCustomWrapper={(linkTagWithChildren, cardProps) => (\n     <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n   )}`"
    },
    "anchorAriaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want\nto apply aria attributes directly to the anchor tag.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`anchorAriaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "anchorDataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass anchorDataProps an object containing data attributes if you have set the href prop and you want\nto apply data attributes directly to the anchor tag.\n\n**Example**:\n`anchorDataProps = {{ 'data-test' : 'some-value' }}`"
    },
    "ariaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass ariaProps an object containing aria attributes. These values will be passed down the <Card /> component.\nIf you have set the href prop you want to apply aria attributes directly to the anchor tag, use anchorAriaProps.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`ariaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "dataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass dataProps an object containing data attributes. These values will be passed down the <Card /> component.\nIf you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.\n\n**Example**:\n`dataProps = {{ 'data-test' : 'some-value' }}`"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date the standard was published\n\n**Example**\n`datePublished='Mon Apr 13 2020 15:06:39 GMT-0400 (Eastern Daylight Time)'"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass description a string to render the standards description.\n\n**Example**:\n`description='Text describing a standard...etc.'`"
    },
    "descriptionLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of lines the description is allowed to be before being\ntruncated. Vertical cards default to 4 lines. Horizontal cards default to 2 lines."
    },
    "gradeRange": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass gradeRange a string representing the grades to which this Standard applies.\n\n**Example**\n`gradeRange=\"K-4\"`"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Pass the footer prop a node that will render in the footer section of the card."
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n          pathname: /path/to/url},\n          state: {\n            ...\n          }\n        }}`"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onClick prop a function.\n\n**Example**:\n`onClick={() => console.log('clicked')}`"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "subject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String representing the school subject for which this Standard applies.\n\n**Example**:\n`subject='Social Studies'`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass title a string to render the standards title.\n\n**Example**:\n`title='9.5c.2'`"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomLink a function to render the Card with a React Router Link.\n\n**Example**:\n    `__renderCustomLink={(clickableCardStyle, href) => (\n      <Link\n        href={href}\n        css={linkStyle}\n      />\n    )}`"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderMetaData a function that will override our default use of the CardMetaData component.\n\n**Example**:\n `__renderMetaData={(css) => (\n        <div {...css}>Item 1 | Item 2 | Item 3 | Item 4</div>\n      )}`"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var reactTable_production_min = createCommonjsModule(function (module, exports) {
  !function (e, t) {
    t(exports, React__default);
  }(commonjsGlobal, function (e, t) {
    function n(e, t, n, o, r, i, u) {
      try {
        var l = e[i](u),
          a = l.value;
      } catch (e) {
        return void n(e);
      }
      l.done ? t(a) : Promise.resolve(a).then(o, r);
    }
    function o(e) {
      return function () {
        var t = this,
          o = arguments;
        return new Promise(function (r, i) {
          var u = e.apply(t, o);
          function l(e) {
            n(u, r, i, l, a, "next", e);
          }
          function a(e) {
            n(u, r, i, l, a, "throw", e);
          }
          l(void 0);
        });
      };
    }
    function r() {
      return (r = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
      }).apply(this, arguments);
    }
    function i(e, t) {
      if (null == e) return {};
      var n,
        o,
        r = {},
        i = Object.keys(e);
      for (o = 0; o < i.length; o++) n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
      return r;
    }
    function u(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var o = n.call(e, t || "default");
          if ("object" != typeof o) return o;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
      },
      a = {
        Cell: function Cell(e) {
          var t = e.value;
          return void 0 === t ? "" : t;
        },
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
      };
    function s() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      return t.reduce(function (e, t) {
        var n = t.style,
          o = t.className;
        return e = r({}, e, {}, i(t, ["style", "className"])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
      }, {});
    }
    var c = function c(e, t) {
        return void 0 === t && (t = {}), function (n) {
          return void 0 === n && (n = {}), [].concat(e, [n]).reduce(function (e, o) {
            return function e(t, n, o) {
              return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? s.apply(void 0, [t].concat(n)) : s(t, n);
            }(e, o, r({}, t, {
              userProps: n
            }));
          }, {});
        };
      },
      d = function d(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function (e, t) {
          var r = t(e, n);
          if (!o && void 0 === r) throw console.info(t), new Error("React Table: A reducer hook ☝️ just returned undefined! This is not allowed.");
          return r;
        }, t);
      },
      f = function f(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function (e) {
          var o = e(t, n);
          if (void 0 !== o) throw console.info(e, o), new Error("React Table: A loop-type hook ☝️ just returned a value! This is not allowed.");
        });
      };
    function p(e, t, n, o) {
      if (o) throw new Error('Defining plugins in the "after" section of ensurePluginOrder is no longer supported (see plugin ' + n + ")");
      var r = e.findIndex(function (e) {
        return e.pluginName === n;
      });
      if (-1 === r && "production" !== "development") throw new Error('The plugin "' + n + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + n + ".pluginName = '" + n + "'\n");
      t.forEach(function (t) {
        var o = e.findIndex(function (e) {
          return e.pluginName === t;
        });
        if (o > -1 && o > r && "production" !== "development") throw new Error("React Table: The " + n + " plugin hook must be placed after the " + t + " plugin hook!");
      });
    }
    function g(e, t) {
      return "function" == typeof e ? e(t) : e;
    }
    function v(e) {
      var n = t.useRef();
      return n.current = e, t.useCallback(function () {
        return n.current;
      }, []);
    }
    var m = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function h(e, n) {
      var o = t.useRef(!1);
      m(function () {
        o.current && e(), o.current = !0;
      }, n);
    }
    function y(e, t, n) {
      return void 0 === n && (n = {}), function (o, i) {
        void 0 === i && (i = {});
        var u = "string" == typeof o ? t[o] : o;
        if (void 0 === u) throw console.info(t), new Error("Renderer Error ☝️");
        return w(u, r({}, e, {
          column: t
        }, n, {}, i));
      };
    }
    function w(e, n) {
      return function (e) {
        return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        var t;
      }(o = e) || "function" == typeof o || function (e) {
        return "object" == typeof e && "symbol" == typeof e.$$typeof && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
      }(o) ? t.createElement(e, n) : e;
      var o;
    }
    function R(e, t, n) {
      return void 0 === n && (n = 0), e.map(function (e) {
        return S(e = r({}, e, {
          parent: t,
          depth: n
        })), e.columns && (e.columns = R(e.columns, e, n + 1)), e;
      });
    }
    function b(e) {
      return I(e, "columns");
    }
    function S(e) {
      var t = e.id,
        n = e.accessor,
        o = e.Header;
      if ("string" == typeof n) {
        t = t || n;
        var r = n.split(".");
        n = function n(e) {
          return function (e, t, n) {
            if (!t) return e;
            var o,
              r = "function" == typeof t ? t : JSON.stringify(t),
              i = P.get(r) || function () {
                var e = function (e) {
                  return function e(t, n) {
                    void 0 === n && (n = []);
                    if (Array.isArray(t)) for (var o = 0; o < t.length; o += 1) e(t[o], n);else n.push(t);
                    return n;
                  }(e).map(function (e) {
                    return String(e).replace(".", "_");
                  }).join(".").replace(T, ".").replace(O, "").split(".");
                }(t);
                return P.set(r, e), e;
              }();
            try {
              o = i.reduce(function (e, t) {
                return e[t];
              }, e);
            } catch (e) {}
            return void 0 !== o ? o : n;
          }(e, r);
        };
      }
      if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
      if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e, {
        id: t,
        accessor: n
      }), e;
    }
    function C(e, n) {
      if (!n) throw new Error();
      return Object.assign(e, r({
        Header: function Header() {
          return t.createElement(t.Fragment, null, " ");
        },
        Footer: function Footer() {
          return t.createElement(t.Fragment, null, " ");
        }
      }, a, {}, n, {}, e)), e;
    }
    function x(e, t) {
      for (var n = [], o = e, i = 0, u = function u() {
          return i++;
        }, l = function l() {
          var e = {
              headers: []
            },
            i = [],
            l = o.some(function (e) {
              return e.parent;
            });
          o.forEach(function (n) {
            var o,
              a = [].concat(i).reverse()[0];
            if (l) {
              if (n.parent) o = r({}, n.parent, {
                originalId: n.parent.id,
                id: n.parent.id + "_" + u(),
                headers: [n]
              });else o = C({
                originalId: n.id + "_placeholder",
                id: n.id + "_placeholder_" + u(),
                placeholderOf: n,
                headers: [n]
              }, t);
              a && a.originalId === o.originalId ? a.headers.push(n) : i.push(o);
            }
            e.headers.push(n);
          }), n.push(e), o = i;
        }; o.length;) l();
      return n.reverse();
    }
    var P = new Map();
    function E() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      for (var o = 0; o < t.length; o += 1) if (void 0 !== t[o]) return t[o];
    }
    function B(e) {
      if ("function" == typeof e) return e;
    }
    function I(e, t) {
      var n = [];
      return function e(o) {
        o.forEach(function (o) {
          o[t] ? e(o[t]) : n.push(o);
        });
      }(e), n;
    }
    function F(e, t) {
      var n = t.manualExpandedKey,
        o = t.expanded,
        r = t.expandSubRows,
        i = void 0 === r || r,
        u = [];
      return e.forEach(function e(t) {
        t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, u.push(t), i && t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(e);
      }), u;
    }
    function G(e, t, n) {
      return B(e) || t[e] || n[e] || n.text;
    }
    function k(e, t, n) {
      return e ? e(t, n) : void 0 === t;
    }
    function H() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var A = null;
    var T = /\[/g,
      O = /\]/g;
    var W = function W(e) {
        return r({
          role: "table"
        }, e);
      },
      z = function z(e) {
        return r({
          role: "rowgroup"
        }, e);
      },
      M = function M(e, t) {
        var n = t.column;
        return r({
          key: "header_" + n.id,
          colSpan: n.totalVisibleHeaderCount,
          role: "columnheader"
        }, e);
      },
      N = function N(e, t) {
        var n = t.column;
        return r({
          key: "footer_" + n.id,
          colSpan: n.totalVisibleHeaderCount
        }, e);
      },
      j = function j(e, t) {
        return r({
          key: "headerGroup_" + t.index,
          role: "row"
        }, e);
      },
      D = function D(e, t) {
        return r({
          key: "footerGroup_" + t.index
        }, e);
      },
      V = function V(e, t) {
        return r({
          key: "row_" + t.row.id,
          role: "row"
        }, e);
      },
      _ = function _(e, t) {
        var n = t.cell;
        return r({
          key: "cell_" + n.row.id + "_" + n.column.id,
          role: "cell"
        }, e);
      };
    function L() {
      return {
        useOptions: [],
        stateReducers: [],
        useControlledState: [],
        columns: [],
        columnsDeps: [],
        allColumns: [],
        allColumnsDeps: [],
        accessValue: [],
        materializedColumns: [],
        materializedColumnsDeps: [],
        useInstanceAfterData: [],
        visibleColumns: [],
        visibleColumnsDeps: [],
        headerGroups: [],
        headerGroupsDeps: [],
        useInstanceBeforeDimensions: [],
        useInstance: [],
        prepareRow: [],
        getTableProps: [W],
        getTableBodyProps: [z],
        getHeaderGroupProps: [j],
        getFooterGroupProps: [D],
        getHeaderProps: [M],
        getFooterProps: [N],
        getRowProps: [V],
        getCellProps: [_],
        useFinalInstance: []
      };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var X = function X(e) {
      e.getToggleHiddenProps = [q], e.getToggleHideAllColumnsProps = [K], e.stateReducers.push(U), e.useInstanceBeforeDimensions.push($), e.headerGroupsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.hiddenColumns]);
      }), e.useInstance.push(J);
    };
    X.pluginName = "useColumnVisibility";
    var q = function q(e, t) {
        var n = t.column;
        return [e, {
          onChange: function onChange(e) {
            n.toggleHidden(!e.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: n.isVisible,
          title: "Toggle Column Visible"
        }];
      },
      K = function K(e, t) {
        var n = t.instance;
        return [e, {
          onChange: function onChange(e) {
            n.toggleHideAllColumns(!e.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
          title: "Toggle All Columns Hidden",
          indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
        }];
      };
    function U(e, t, n, o) {
      if (t.type === l.init) return r({
        hiddenColumns: []
      }, e);
      if (t.type === l.resetHiddenColumns) return r({}, e, {
        hiddenColumns: o.initialState.hiddenColumns || []
      });
      if (t.type === l.toggleHideColumn) {
        var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [t.columnId]) : e.hiddenColumns.filter(function (e) {
          return e !== t.columnId;
        });
        return r({}, e, {
          hiddenColumns: i
        });
      }
      return t.type === l.setHiddenColumns ? r({}, e, {
        hiddenColumns: g(t.value, e.hiddenColumns)
      }) : t.type === l.toggleHideAllColumns ? r({}, e, {
        hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function (e) {
          return e.id;
        }) : []
      }) : void 0;
    }
    function $(e) {
      var n = e.headers,
        o = e.state.hiddenColumns;
      t.useRef(!1).current;
      var r = 0;
      n.forEach(function (e) {
        return r += function e(t, n) {
          t.isVisible = n && !o.includes(t.id);
          var r = 0;
          return t.headers && t.headers.length ? t.headers.forEach(function (n) {
            return r += e(n, t.isVisible);
          }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
        }(e, !0);
      });
    }
    function J(e) {
      var n = e.columns,
        o = e.flatHeaders,
        r = e.dispatch,
        i = e.allColumns,
        u = e.getHooks,
        a = e.state.hiddenColumns,
        s = e.autoResetHiddenColumns,
        d = void 0 === s || s,
        f = v(e),
        p = i.length === a.length,
        g = t.useCallback(function (e, t) {
          return r({
            type: l.toggleHideColumn,
            columnId: e,
            value: t
          });
        }, [r]),
        m = t.useCallback(function (e) {
          return r({
            type: l.setHiddenColumns,
            value: e
          });
        }, [r]),
        y = t.useCallback(function (e) {
          return r({
            type: l.toggleHideAllColumns,
            value: e
          });
        }, [r]),
        w = c(u().getToggleHideAllColumnsProps, {
          instance: f()
        });
      o.forEach(function (e) {
        e.toggleHidden = function (t) {
          r({
            type: l.toggleHideColumn,
            columnId: e.id,
            value: t
          });
        }, e.getToggleHiddenProps = c(u().getToggleHiddenProps, {
          instance: f(),
          column: e
        });
      });
      var R = v(d);
      h(function () {
        R() && r({
          type: l.resetHiddenColumns
        });
      }, [r, n]), Object.assign(e, {
        allColumnsHidden: p,
        toggleHideColumn: g,
        setHiddenColumns: m,
        toggleHideAllColumns: y,
        getToggleHideAllColumnsProps: w
      });
    }
    var Y = {},
      Q = {},
      Z = function Z(e, t, n) {
        return e;
      },
      ee = function ee(e, t) {
        return e.subRows || [];
      },
      te = function te(e, t, n) {
        return "" + (n ? [n.id, t].join(".") : t);
      },
      ne = function ne(e) {
        return e;
      };
    function oe(e) {
      var t = e.initialState,
        n = void 0 === t ? Y : t,
        o = e.defaultColumn,
        u = void 0 === o ? Q : o,
        l = e.getSubRows,
        a = void 0 === l ? ee : l,
        s = e.getRowId,
        c = void 0 === s ? te : s,
        d = e.stateReducer,
        f = void 0 === d ? Z : d,
        p = e.useControlledState,
        g = void 0 === p ? ne : p;
      return r({}, i(e, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), {
        initialState: n,
        defaultColumn: u,
        getSubRows: a,
        getRowId: c,
        stateReducer: f,
        useControlledState: g
      });
    }
    function re(e, t) {
      void 0 === t && (t = 0);
      var n = 0,
        o = 0,
        r = 0,
        i = 0;
      return e.forEach(function (e) {
        var u = e.headers;
        if (e.totalLeft = t, u && u.length) {
          var l = re(u, t),
            a = l[0],
            s = l[1],
            c = l[2],
            d = l[3];
          e.totalMinWidth = a, e.totalWidth = s, e.totalMaxWidth = c, e.totalFlexWidth = d;
        } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
        e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
      }), [n, o, r, i];
    }
    function ie(e) {
      var t = e.data,
        n = e.rows,
        o = e.flatRows,
        r = e.rowsById,
        i = e.column,
        u = e.getRowId,
        l = e.getSubRows,
        a = e.accessValueHooks,
        s = e.getInstance;
      t.forEach(function (e, t) {
        return function e(t, n, c, f, p) {
          void 0 === c && (c = 0);
          var g = t,
            v = u(t, n, f),
            m = r[v];
          if (m) m.subRows && m.originalSubRows.forEach(function (t, n) {
            return e(t, n, c + 1, m);
          });else if ((m = {
            id: v,
            original: g,
            index: n,
            depth: c,
            cells: [{}]
          }).cells.map = H, m.cells.filter = H, m.cells.forEach = H, m.cells[0].getCellProps = H, m.values = {}, p.push(m), o.push(m), r[v] = m, m.originalSubRows = l(t, n), m.originalSubRows) {
            var h = [];
            m.originalSubRows.forEach(function (t, n) {
              return e(t, n, c + 1, m, h);
            }), m.subRows = h;
          }
          i.accessor && (m.values[i.id] = i.accessor(t, n, m)), m.values[i.id] = d(a, m.values[i.id], {
            row: m,
            column: i,
            instance: s()
          }, !0);
        }(e, t, 0, void 0, n);
      });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var ue = function ue(e) {
      e.getToggleAllRowsExpandedProps = [le], e.getToggleRowExpandedProps = [ae], e.stateReducers.push(se), e.useInstance.push(ce), e.prepareRow.push(de);
    };
    ue.pluginName = "useExpanded";
    var le = function le(e, t) {
        var n = t.instance;
        return [e, {
          onClick: function onClick(e) {
            n.toggleAllRowsExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle All Rows Expanded"
        }];
      },
      ae = function ae(e, t) {
        var n = t.row;
        return [e, {
          onClick: function onClick() {
            n.toggleRowExpanded();
          },
          style: {
            cursor: "pointer"
          },
          title: "Toggle Row Expanded"
        }];
      };
    function se(e, t, n, o) {
      if (t.type === l.init) return r({
        expanded: {}
      }, e);
      if (t.type === l.resetExpanded) return r({}, e, {
        expanded: o.initialState.expanded || {}
      });
      if (t.type === l.toggleAllRowsExpanded) {
        var a = t.value,
          s = o.isAllRowsExpanded,
          c = o.rowsById;
        if (void 0 !== a ? a : !s) {
          var d = {};
          return Object.keys(c).forEach(function (e) {
            d[e] = !0;
          }), r({}, e, {
            expanded: d
          });
        }
        return r({}, e, {
          expanded: {}
        });
      }
      if (t.type === l.toggleRowExpanded) {
        var f,
          p = t.id,
          g = t.value,
          v = e.expanded[p],
          m = void 0 !== g ? g : !v;
        if (!v && m) return r({}, e, {
          expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
        });
        if (v && !m) {
          var h = e.expanded;
          h[p];
          return r({}, e, {
            expanded: i(h, [p].map(u))
          });
        }
        return e;
      }
    }
    function ce(e) {
      var n = e.data,
        o = e.rows,
        r = e.rowsById,
        i = e.manualExpandedKey,
        u = void 0 === i ? "expanded" : i,
        a = e.paginateExpandedRows,
        s = void 0 === a || a,
        d = e.expandSubRows,
        f = void 0 === d || d,
        g = e.autoResetExpanded,
        m = void 0 === g || g,
        y = e.getHooks,
        w = e.plugins,
        R = e.state.expanded,
        b = e.dispatch;
      p(w, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S = v(m),
        C = Boolean(Object.keys(r).length && Object.keys(R).length);
      C && Object.keys(r).some(function (e) {
        return !R[e];
      }) && (C = !1), h(function () {
        S() && b({
          type: l.resetExpanded
        });
      }, [b, n]);
      var x = t.useCallback(function (e, t) {
          b({
            type: l.toggleRowExpanded,
            id: e,
            value: t
          });
        }, [b]),
        P = t.useCallback(function (e) {
          return b({
            type: l.toggleAllRowsExpanded,
            value: e
          });
        }, [b]),
        E = t.useMemo(function () {
          return s ? F(o, {
            manualExpandedKey: u,
            expanded: R,
            expandSubRows: f
          }) : o;
        }, [s, o, u, R, f]),
        B = t.useMemo(function () {
          return function (e) {
            var t = 0;
            return Object.keys(e).forEach(function (e) {
              var n = e.split(".");
              t = Math.max(t, n.length);
            }), t;
          }(R);
        }, [R]),
        I = v(e),
        G = c(y().getToggleAllRowsExpandedProps, {
          instance: I()
        });
      Object.assign(e, {
        preExpandedRows: o,
        expandedRows: E,
        rows: E,
        expandedDepth: B,
        isAllRowsExpanded: C,
        toggleRowExpanded: x,
        toggleAllRowsExpanded: P,
        getToggleAllRowsExpandedProps: G
      });
    }
    function de(e, t) {
      var n = t.instance.getHooks,
        o = t.instance;
      e.toggleRowExpanded = function (t) {
        return o.toggleRowExpanded(e.id, t);
      }, e.getToggleRowExpandedProps = c(n().getToggleRowExpandedProps, {
        instance: o,
        row: e
      });
    }
    var fe = function fe(e, t, n) {
      return e = e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return String(o).toLowerCase().includes(String(n).toLowerCase());
        });
      });
    };
    fe.autoRemove = function (e) {
      return !e;
    };
    var pe = function pe(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
        });
      });
    };
    pe.autoRemove = function (e) {
      return !e;
    };
    var ge = function ge(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return void 0 === o || String(o) === String(n);
        });
      });
    };
    ge.autoRemove = function (e) {
      return !e;
    };
    var ve = function ve(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t].includes(n);
        });
      });
    };
    ve.autoRemove = function (e) {
      return !e || !e.length;
    };
    var me = function me(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return o && o.length && n.every(function (e) {
            return o.includes(e);
          });
        });
      });
    };
    me.autoRemove = function (e) {
      return !e || !e.length;
    };
    var he = function he(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return o && o.length && n.some(function (e) {
            return o.includes(e);
          });
        });
      });
    };
    he.autoRemove = function (e) {
      return !e || !e.length;
    };
    var ye = function ye(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          var o = e.values[t];
          return n.includes(o);
        });
      });
    };
    ye.autoRemove = function (e) {
      return !e || !e.length;
    };
    var we = function we(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t] === n;
        });
      });
    };
    we.autoRemove = function (e) {
      return void 0 === e;
    };
    var Re = function Re(e, t, n) {
      return e.filter(function (e) {
        return t.some(function (t) {
          return e.values[t] == n;
        });
      });
    };
    Re.autoRemove = function (e) {
      return null == e;
    };
    var be = function be(e, t, n) {
      var o = n || [],
        r = o[0],
        i = o[1];
      if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
        var u = r;
        r = i, i = u;
      }
      return e.filter(function (e) {
        return t.some(function (t) {
          var n = e.values[t];
          return n >= r && n <= i;
        });
      });
    };
    be.autoRemove = function (e) {
      return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var Se = Object.freeze({
      __proto__: null,
      text: fe,
      exactText: pe,
      exactTextCase: ge,
      includes: ve,
      includesAll: me,
      includesSome: he,
      includesValue: ye,
      exact: we,
      equals: Re,
      between: be
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Ce = function Ce(e) {
      e.stateReducers.push(xe), e.useInstance.push(Pe);
    };
    function xe(e, t, n, o) {
      if (t.type === l.init) return r({
        filters: []
      }, e);
      if (t.type === l.resetFilters) return r({}, e, {
        filters: o.initialState.filters || []
      });
      if (t.type === l.setFilter) {
        var i = t.columnId,
          u = t.filterValue,
          a = o.allColumns,
          s = o.filterTypes,
          c = a.find(function (e) {
            return e.id === i;
          });
        if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
        var d = G(c.filter, s || {}, Se),
          f = e.filters.find(function (e) {
            return e.id === i;
          }),
          p = g(u, f && f.value);
        return k(d.autoRemove, p, c) ? r({}, e, {
          filters: e.filters.filter(function (e) {
            return e.id !== i;
          })
        }) : r({}, e, f ? {
          filters: e.filters.map(function (e) {
            return e.id === i ? {
              id: i,
              value: p
            } : e;
          })
        } : {
          filters: [].concat(e.filters, [{
            id: i,
            value: p
          }])
        });
      }
      if (t.type === l.setAllFilters) {
        var v = t.filters,
          m = o.allColumns,
          h = o.filterTypes;
        return r({}, e, {
          filters: g(v, e.filters).filter(function (e) {
            var t = m.find(function (t) {
              return t.id === e.id;
            });
            return !k(G(t.filter, h || {}, Se).autoRemove, e.value, t);
          })
        });
      }
    }
    function Pe(e) {
      var n = e.data,
        o = e.rows,
        r = e.flatRows,
        i = e.rowsById,
        u = e.allColumns,
        a = e.filterTypes,
        s = e.manualFilters,
        c = e.defaultCanFilter,
        d = void 0 !== c && c,
        f = e.disableFilters,
        p = e.state.filters,
        g = e.dispatch,
        m = e.autoResetFilters,
        y = void 0 === m || m,
        w = t.useCallback(function (e, t) {
          g({
            type: l.setFilter,
            columnId: e,
            filterValue: t
          });
        }, [g]),
        R = t.useCallback(function (e) {
          g({
            type: l.setAllFilters,
            filters: e
          });
        }, [g]);
      u.forEach(function (e) {
        var t = e.id,
          n = e.accessor,
          o = e.defaultCanFilter,
          r = e.disableFilters;
        e.canFilter = n ? E(!0 !== r && void 0, !0 !== f && void 0, !0) : E(o, d, !1), e.setFilter = function (t) {
          return w(e.id, t);
        };
        var i = p.find(function (e) {
          return e.id === t;
        });
        e.filterValue = i && i.value;
      });
      var b = t.useMemo(function () {
          if (s || !p.length) return [o, r, i];
          var e = [],
            t = {};
          return [function n(o, r) {
            void 0 === r && (r = 0);
            var i = o;
            return (i = p.reduce(function (e, t) {
              var n = t.id,
                o = t.value,
                i = u.find(function (e) {
                  return e.id === n;
                });
              if (!i) return e;
              0 === r && (i.preFilteredRows = e);
              var l = G(i.filter, a || {}, Se);
              return l ? (i.filteredRows = l(e, [n], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
            }, o)).forEach(function (o) {
              e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
            }), i;
          }(o), e, t];
        }, [s, p, o, r, i, u, a]),
        S = b[0],
        C = b[1],
        x = b[2];
      t.useMemo(function () {
        u.filter(function (e) {
          return !p.find(function (t) {
            return t.id === e.id;
          });
        }).forEach(function (e) {
          e.preFilteredRows = S, e.filteredRows = S;
        });
      }, [S, p, u]);
      var P = v(y);
      h(function () {
        P() && g({
          type: l.resetFilters
        });
      }, [g, s ? null : n]), Object.assign(e, {
        preFilteredRows: o,
        preFilteredFlatRows: r,
        preFilteredRowsById: i,
        filteredRows: S,
        filteredFlatRows: C,
        filteredRowsById: x,
        rows: S,
        flatRows: C,
        rowsById: x,
        setFilter: w,
        setAllFilters: R
      });
    }
    Ce.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ee = function Ee(e) {
      e.stateReducers.push(Be), e.useInstance.push(Ie);
    };
    function Be(e, t, n, o) {
      if (t.type === l.resetGlobalFilter) return r({}, e, {
        globalFilter: o.initialState.globalFilter || void 0
      });
      if (t.type === l.setGlobalFilter) {
        var u = t.filterValue,
          a = o.userFilterTypes,
          s = G(o.globalFilter, a || {}, Se),
          c = g(u, e.globalFilter);
        if (k(s.autoRemove, c)) {
          e.globalFilter;
          return i(e, ["globalFilter"]);
        }
        return r({}, e, {
          globalFilter: c
        });
      }
    }
    function Ie(e) {
      var n = e.data,
        o = e.rows,
        r = e.flatRows,
        i = e.rowsById,
        u = e.allColumns,
        a = e.filterTypes,
        s = e.globalFilter,
        c = e.manualGlobalFilter,
        d = e.state.globalFilter,
        f = e.dispatch,
        p = e.autoResetGlobalFilter,
        g = void 0 === p || p,
        m = e.disableGlobalFilter,
        y = t.useCallback(function (e) {
          f({
            type: l.setGlobalFilter,
            filterValue: e
          });
        }, [f]),
        w = t.useMemo(function () {
          if (c || void 0 === d) return [o, r, i];
          var e = [],
            t = {},
            n = G(s, a || {}, Se);
          if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
          u.forEach(function (e) {
            var t = e.disableGlobalFilter;
            e.canFilter = E(!0 !== t && void 0, !0 !== m && void 0, !0);
          });
          var l = u.filter(function (e) {
            return !0 === e.canFilter;
          });
          return [function o(r) {
            return (r = n(r, l.map(function (e) {
              return e.id;
            }), d)).forEach(function (n) {
              e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
            }), r;
          }(o), e, t];
        }, [c, d, s, a, u, o, r, i, m]),
        R = w[0],
        b = w[1],
        S = w[2],
        C = v(g);
      h(function () {
        C() && f({
          type: l.resetGlobalFilter
        });
      }, [f, c ? null : n]), Object.assign(e, {
        preGlobalFilteredRows: o,
        preGlobalFilteredFlatRows: r,
        preGlobalFilteredRowsById: i,
        globalFilteredRows: R,
        globalFilteredFlatRows: b,
        globalFilteredRowsById: S,
        rows: R,
        flatRows: b,
        rowsById: S,
        setGlobalFilter: y,
        disableGlobalFilter: m
      });
    }
    function Fe(e, t) {
      return t.reduce(function (e, t) {
        return e + ("number" == typeof t ? t : 0);
      }, 0);
    }
    Ee.pluginName = "useGlobalFilter";
    var Ge = Object.freeze({
        __proto__: null,
        sum: Fe,
        min: function min(e) {
          var t = 0;
          return e.forEach(function (e) {
            "number" == typeof e && (t = Math.min(t, e));
          }), t;
        },
        max: function max(e) {
          var t = 0;
          return e.forEach(function (e) {
            "number" == typeof e && (t = Math.max(t, e));
          }), t;
        },
        minMax: function minMax(e) {
          var t = 0,
            n = 0;
          return e.forEach(function (e) {
            "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
          }), t + ".." + n;
        },
        average: function average(e) {
          return Fe(0, e) / e.length;
        },
        median: function median(e) {
          if (!e.length) return null;
          var t = 0,
            n = 0;
          return e.forEach(function (e) {
            "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
          }), (t + n) / 2;
        },
        unique: function unique(e) {
          return [].concat(new Set(e).values());
        },
        uniqueCount: function uniqueCount(e) {
          return new Set(e).size;
        },
        count: function count(e) {
          return e.length;
        }
      }),
      ke = [],
      He = {};
    l.resetGroupBy = "resetGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var Ae = function Ae(e) {
      e.getGroupByToggleProps = [Te], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.groupBy]);
      }), e.visibleColumns.push(We), e.useInstance.push(Me), e.prepareRow.push(Ne);
    };
    Ae.pluginName = "useGroupBy";
    var Te = function Te(e, t) {
      var n = t.header;
      return [e, {
        onClick: n.canGroupBy ? function (e) {
          e.persist(), n.toggleGroupBy();
        } : void 0,
        style: {
          cursor: n.canGroupBy ? "pointer" : void 0
        },
        title: "Toggle GroupBy"
      }];
    };
    function Oe(e, t, n, o) {
      if (t.type === l.init) return r({
        groupBy: []
      }, e);
      if (t.type === l.resetGroupBy) return r({}, e, {
        groupBy: o.initialState.groupBy || []
      });
      if (t.type === l.toggleGroupBy) {
        var i = t.columnId,
          u = t.value,
          a = void 0 !== u ? u : !e.groupBy.includes(i);
        return r({}, e, a ? {
          groupBy: [].concat(e.groupBy, [i])
        } : {
          groupBy: e.groupBy.filter(function (e) {
            return e !== i;
          })
        });
      }
    }
    function We(e, t) {
      var n = t.instance.state.groupBy,
        o = n.map(function (t) {
          return e.find(function (e) {
            return e.id === t;
          });
        }).filter(Boolean),
        r = e.filter(function (e) {
          return !n.includes(e.id);
        });
      return (e = [].concat(o, r)).forEach(function (e) {
        e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
      }), e;
    }
    var ze = {};
    function Me(e) {
      var n = e.data,
        o = e.rows,
        r = e.flatRows,
        i = e.rowsById,
        u = e.allColumns,
        a = e.flatHeaders,
        s = e.groupByFn,
        d = void 0 === s ? je : s,
        f = e.manualGroupBy,
        g = e.aggregations,
        m = void 0 === g ? ze : g,
        y = e.plugins,
        w = e.state.groupBy,
        R = e.dispatch,
        b = e.autoResetGroupBy,
        S = void 0 === b || b,
        C = e.disableGroupBy,
        x = e.defaultCanGroupBy,
        P = e.getHooks;
      p(y, ["useFilters"], "useGroupBy");
      var B = v(e);
      u.forEach(function (t) {
        var n = t.accessor,
          o = t.defaultGroupBy,
          r = t.disableGroupBy;
        t.canGroupBy = n ? E(t.canGroupBy, !0 !== r && void 0, !0 !== C && void 0, !0) : E(t.canGroupBy, o, x, !1), t.canGroupBy && (t.toggleGroupBy = function () {
          return e.toggleGroupBy(t.id);
        }), t.Aggregated = t.Aggregated || t.Cell;
      });
      var F = t.useCallback(function (e, t) {
        R({
          type: l.toggleGroupBy,
          columnId: e,
          value: t
        });
      }, [R]);
      a.forEach(function (e) {
        e.getGroupByToggleProps = c(P().getGroupByToggleProps, {
          instance: B(),
          header: e
        });
      });
      var G = t.useMemo(function () {
          if (f || !w.length) return [o, r, i, ke, He, r, i];
          var e = w.filter(function (e) {
              return u.find(function (t) {
                return t.id === e;
              });
            }),
            t = [],
            n = {},
            l = [],
            a = {},
            s = [],
            c = {},
            p = function o(r, i, f) {
              if (void 0 === i && (i = 0), i === e.length) return r;
              var p = e[i],
                g = d(r, p);
              return Object.entries(g).map(function (r, d) {
                var g = r[0],
                  v = r[1],
                  h = p + ":" + g,
                  y = o(v, i + 1, h = f ? f + ">" + h : h),
                  w = i ? I(v, "leafRows") : v,
                  R = function (t, n, o) {
                    var r = {};
                    return u.forEach(function (i) {
                      if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;else {
                        var u = n.map(function (e) {
                            return e.values[i.id];
                          }),
                          l = t.map(function (e) {
                            var t = e.values[i.id];
                            if (!o && i.aggregateValue) {
                              var n = "function" == typeof i.aggregateValue ? i.aggregateValue : m[i.aggregateValue] || Ge[i.aggregateValue];
                              if (!n) throw console.info({
                                column: i
                              }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                              t = n(t, e, i);
                            }
                            return t;
                          }),
                          a = "function" == typeof i.aggregate ? i.aggregate : m[i.aggregate] || Ge[i.aggregate];
                        if (a) r[i.id] = a(l, u);else {
                          if (i.aggregate) throw console.info({
                            column: i
                          }), new Error("React Table: Invalid column.aggregate option for column listed above");
                          r[i.id] = null;
                        }
                      }
                    }), r;
                  }(w, v, i),
                  b = {
                    id: h,
                    isGrouped: !0,
                    groupByID: p,
                    groupByVal: g,
                    values: R,
                    subRows: y,
                    leafRows: w,
                    depth: i,
                    index: d
                  };
                return y.forEach(function (e) {
                  t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (s.push(e), c[e.id] = e);
                }), b;
              });
            }(o);
          return p.forEach(function (e) {
            t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (s.push(e), c[e.id] = e);
          }), [p, t, n, l, a, s, c];
        }, [f, w, o, r, i, u, m, d]),
        k = G[0],
        H = G[1],
        A = G[2],
        T = G[3],
        O = G[4],
        W = G[5],
        z = G[6],
        M = v(S);
      h(function () {
        M() && R({
          type: l.resetGroupBy
        });
      }, [R, f ? null : n]), Object.assign(e, {
        preGroupedRows: o,
        preGroupedFlatRow: r,
        preGroupedRowsById: i,
        groupedRows: k,
        groupedFlatRows: H,
        groupedRowsById: A,
        onlyGroupedFlatRows: T,
        onlyGroupedRowsById: O,
        nonGroupedFlatRows: W,
        nonGroupedRowsById: z,
        rows: k,
        flatRows: H,
        rowsById: A,
        toggleGroupBy: F
      });
    }
    function Ne(e) {
      e.allCells.forEach(function (t) {
        t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && e.canExpand;
      });
    }
    function je(e, t) {
      return e.reduce(function (e, n, o) {
        var r = "" + n.values[t];
        return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
      }, {});
    }
    var De = /([0-9]+)/gm;
    function Ve(e, t) {
      return e === t ? 0 : e > t ? 1 : -1;
    }
    function _e(e, t) {
      return e.values[t];
    }
    function Le(e) {
      return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Xe = Object.freeze({
      __proto__: null,
      alphanumeric: function alphanumeric(e, t, n) {
        var o = _e(e, n),
          r = _e(t, n);
        for (o = Le(o), r = Le(r), o = o.split(De).filter(Boolean), r = r.split(De).filter(Boolean); o.length && r.length;) {
          var i = o.shift(),
            u = r.shift(),
            l = parseInt(i, 10),
            a = parseInt(u, 10),
            s = [l, a].sort();
          if (isNaN(s[0])) {
            if (i > u) return 1;
            if (u > i) return -1;
          } else {
            if (isNaN(s[1])) return isNaN(l) ? -1 : 1;
            if (l > a) return 1;
            if (a > l) return -1;
          }
        }
        return o.length - r.length;
      },
      datetime: function datetime(e, t, n) {
        var o = _e(e, n),
          r = _e(t, n);
        return Ve(o = o.getTime(), r = r.getTime());
      },
      basic: function basic(e, t, n) {
        return Ve(_e(e, n), _e(t, n));
      }
    });
    l.resetSortBy = "resetSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", a.sortType = "alphanumeric", a.sortDescFirst = !1;
    var qe = function qe(e) {
      e.getSortByToggleProps = [Ke], e.stateReducers.push(Ue), e.useInstance.push($e);
    };
    qe.pluginName = "useSortBy";
    var Ke = function Ke(e, t) {
      var n = t.instance,
        o = t.column,
        r = n.isMultiSortEvent,
        i = void 0 === r ? function (e) {
          return e.shiftKey;
        } : r;
      return [e, {
        onClick: o.canSort ? function (e) {
          e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
        } : void 0,
        style: {
          cursor: o.canSort ? "pointer" : void 0
        },
        title: o.canSort ? "Toggle SortBy" : void 0
      }];
    };
    function Ue(e, t, n, o) {
      if (t.type === l.init) return r({
        sortBy: []
      }, e);
      if (t.type === l.resetSortBy) return r({}, e, {
        sortBy: o.initialState.sortBy || []
      });
      if (t.type === l.clearSortBy) return r({}, e, {
        sortBy: e.sortBy.filter(function (e) {
          return e.id !== t.columnId;
        })
      });
      if (t.type === l.toggleSortBy) {
        var i,
          u = t.columnId,
          a = t.desc,
          s = t.multi,
          c = o.allColumns,
          d = o.disableMultiSort,
          f = o.disableSortRemove,
          p = o.disableMultiRemove,
          g = o.maxMultiSortColCount,
          v = void 0 === g ? Number.MAX_SAFE_INTEGER : g,
          m = e.sortBy,
          h = c.find(function (e) {
            return e.id === u;
          }).sortDescFirst,
          y = m.find(function (e) {
            return e.id === u;
          }),
          w = m.findIndex(function (e) {
            return e.id === u;
          }),
          R = null != a,
          b = [];
        return "toggle" !== (i = !d && s ? y ? "toggle" : "add" : w !== m.length - 1 ? "replace" : y ? "toggle" : "replace") || f || R || s && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [{
          id: u,
          desc: R ? a : h
        }] : "add" === i ? (b = [].concat(m, [{
          id: u,
          desc: R ? a : h
        }])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function (e) {
          return e.id === u ? r({}, e, {
            desc: R ? a : !y.desc
          }) : e;
        }) : "remove" === i && (b = m.filter(function (e) {
          return e.id !== u;
        })), r({}, e, {
          sortBy: b
        });
      }
    }
    function $e(e) {
      var n = e.data,
        o = e.rows,
        r = e.flatRows,
        i = e.allColumns,
        u = e.orderByFn,
        a = void 0 === u ? Je : u,
        s = e.sortTypes,
        d = e.manualSortBy,
        f = e.defaultCanSort,
        g = e.disableSortBy,
        m = e.flatHeaders,
        y = e.state.sortBy,
        w = e.dispatch,
        R = e.plugins,
        b = e.getHooks,
        S = e.autoResetSortBy,
        C = void 0 === S || S;
      p(R, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var x = t.useCallback(function (e, t, n) {
          w({
            type: l.toggleSortBy,
            columnId: e,
            desc: t,
            multi: n
          });
        }, [w]),
        P = v(e);
      m.forEach(function (e) {
        var t = e.accessor,
          n = e.canSort,
          o = e.disableSortBy,
          r = e.id,
          i = t ? E(!0 !== o && void 0, !0 !== g && void 0, !0) : E(f, n, !1);
        e.canSort = i, e.canSort && (e.toggleSortBy = function (t, n) {
          return x(e.id, t, n);
        }, e.clearSortBy = function () {
          w({
            type: l.clearSortBy,
            columnId: e.id
          });
        }), e.getSortByToggleProps = c(b().getSortByToggleProps, {
          instance: P(),
          column: e
        });
        var u = y.find(function (e) {
          return e.id === r;
        });
        e.isSorted = !!u, e.sortedIndex = y.findIndex(function (e) {
          return e.id === r;
        }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
      });
      var I = t.useMemo(function () {
          if (d || !y.length) return [o, r];
          var e = [],
            t = y.filter(function (e) {
              return i.find(function (t) {
                return t.id === e.id;
              });
            });
          return [function n(o) {
            var r = a(o, t.map(function (e) {
              var t = i.find(function (t) {
                return t.id === e.id;
              });
              if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
              var n = t.sortType,
                o = B(n) || (s || {})[n] || Xe[n];
              if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
              return function (t, n) {
                return o(t, n, e.id, e.desc);
              };
            }), t.map(function (e) {
              var t = i.find(function (t) {
                return t.id === e.id;
              });
              return t && t.sortInverted ? e.desc : !e.desc;
            }));
            return r.forEach(function (t) {
              e.push(t), !t.subRows || t.subRows.length <= 1 || (t.subRows = n(t.subRows));
            }), r;
          }(o), e];
        }, [d, y, o, r, i, a, s]),
        F = I[0],
        G = I[1],
        k = v(C);
      h(function () {
        k() && w({
          type: l.resetSortBy
        });
      }, [d ? null : n]), Object.assign(e, {
        preSortedRows: o,
        preSortedFlatRows: r,
        sortedRows: F,
        sortedFlatRows: G,
        rows: F,
        flatRows: G,
        toggleSortBy: x
      });
    }
    function Je(e, t, n) {
      return [].concat(e).sort(function (e, o) {
        for (var r = 0; r < t.length; r += 1) {
          var i = t[r],
            u = !1 === n[r] || "desc" === n[r],
            l = i(e, o);
          if (0 !== l) return u ? -l : l;
        }
        return n[0] ? e.index - o.index : o.index - e.index;
      });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ye = function Ye(e) {
      e.stateReducers.push(Qe), e.useInstance.push(Ze);
    };
    function Qe(e, t, n, o) {
      if (t.type === l.init) return r({
        pageSize: 10,
        pageIndex: 0
      }, e);
      if (t.type === l.resetPage) return r({}, e, {
        pageIndex: o.initialState.pageIndex || 0
      });
      if (t.type === l.gotoPage) {
        var i = o.pageCount,
          u = o.page,
          a = g(t.pageIndex, e.pageIndex),
          s = !1;
        return a > e.pageIndex ? s = -1 === i ? u.length >= e.pageSize : a < i : a < e.pageIndex && (s = a > -1), s ? r({}, e, {
          pageIndex: a
        }) : e;
      }
      if (t.type === l.setPageSize) {
        var c = t.pageSize,
          d = e.pageSize * e.pageIndex;
        return r({}, e, {
          pageIndex: Math.floor(d / c),
          pageSize: c
        });
      }
    }
    function Ze(e) {
      var n = e.rows,
        o = e.autoResetPage,
        r = void 0 === o || o,
        i = e.manualExpandedKey,
        u = void 0 === i ? "expanded" : i,
        a = e.plugins,
        s = e.pageCount,
        c = e.paginateExpandedRows,
        d = void 0 === c || c,
        f = e.expandSubRows,
        g = void 0 === f || f,
        m = e.state,
        y = m.pageSize,
        w = m.pageIndex,
        R = m.expanded,
        b = m.globalFilter,
        S = m.filters,
        C = m.groupBy,
        x = m.sortBy,
        P = e.dispatch,
        E = e.data,
        B = e.manualPagination;
      p(a, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I = v(r);
      h(function () {
        I() && P({
          type: l.resetPage
        });
      }, [P, B ? null : E, b, S, C, x]);
      var G = B ? s : Math.ceil(n.length / y),
        k = t.useMemo(function () {
          return G > 0 ? [].concat(new Array(G)).fill(null).map(function (e, t) {
            return t;
          }) : [];
        }, [G]),
        H = t.useMemo(function () {
          var e;
          if (B) e = n;else {
            var t = y * w,
              o = t + y;
            e = n.slice(t, o);
          }
          return d ? e : F(e, {
            manualExpandedKey: u,
            expanded: R,
            expandSubRows: g
          });
        }, [g, R, u, B, w, y, d, n]),
        A = w > 0,
        T = -1 === G ? H.length >= y : w < G - 1,
        O = t.useCallback(function (e) {
          P({
            type: l.gotoPage,
            pageIndex: e
          });
        }, [P]),
        W = t.useCallback(function () {
          return O(function (e) {
            return e - 1;
          });
        }, [O]),
        z = t.useCallback(function () {
          return O(function (e) {
            return e + 1;
          });
        }, [O]),
        M = t.useCallback(function (e) {
          P({
            type: l.setPageSize,
            pageSize: e
          });
        }, [P]);
      Object.assign(e, {
        pageOptions: k,
        pageCount: G,
        page: H,
        canPreviousPage: A,
        canNextPage: T,
        gotoPage: O,
        previousPage: W,
        nextPage: z,
        setPageSize: M
      });
    }
    Ye.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var et = function et(e) {
      e.getPivotToggleProps = [nt], e.stateReducers.push(ot), e.useInstanceAfterData.push(rt), e.allColumns.push(it), e.accessValue.push(ut), e.materializedColumns.push(lt), e.materializedColumnsDeps.push(at), e.visibleColumns.push(st), e.visibleColumnsDeps.push(ct), e.useInstance.push(dt), e.prepareRow.push(ft);
    };
    et.pluginName = "usePivotColumns";
    var tt = [],
      nt = function nt(e, t) {
        var n = t.header;
        return [e, {
          onClick: n.canPivot ? function (e) {
            e.persist(), n.togglePivot();
          } : void 0,
          style: {
            cursor: n.canPivot ? "pointer" : void 0
          },
          title: "Toggle Pivot"
        }];
      };
    function ot(e, t, n, o) {
      if (t.type === l.init) return r({
        pivotColumns: tt
      }, e);
      if (t.type === l.resetPivot) return r({}, e, {
        pivotColumns: o.initialState.pivotColumns || tt
      });
      if (t.type === l.togglePivot) {
        var i = t.columnId,
          u = t.value,
          a = void 0 !== u ? u : !e.pivotColumns.includes(i);
        return r({}, e, a ? {
          pivotColumns: [].concat(e.pivotColumns, [i])
        } : {
          pivotColumns: e.pivotColumns.filter(function (e) {
            return e !== i;
          })
        });
      }
    }
    function rt(e) {
      e.allColumns.forEach(function (t) {
        t.isPivotSource = e.state.pivotColumns.includes(t.id);
      });
    }
    function it(e, t) {
      var n = t.instance;
      return e.forEach(function (e) {
        e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set();
      }), e;
    }
    function ut(e, t) {
      var n = t.column;
      return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function lt(e, t) {
      var n = t.instance,
        o = n.allColumns,
        i = n.state;
      if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
      var u = i.pivotColumns.map(function (e) {
          return o.find(function (t) {
            return t.id === e;
          });
        }).filter(Boolean),
        l = o.filter(function (e) {
          return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }),
        a = b(function e(t, n, o) {
          void 0 === t && (t = 0), void 0 === o && (o = []);
          var i = u[t];
          return i ? Array.from(i.uniqueValues).sort().map(function (u) {
            var l = r({}, i, {
              Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
              isPivotGroup: !0,
              parent: n,
              depth: t,
              id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
              pivotValue: u
            });
            return l.columns = e(t + 1, l, [].concat(o, [function (e) {
              return e.values[i.id] === u;
            }])), l;
          }) : l.map(function (e) {
            return r({}, e, {
              canPivot: !1,
              isPivoted: !0,
              parent: n,
              depth: t,
              id: "" + (n ? n.id + "." + e.id : e.id),
              accessor: function accessor(t, n, r) {
                if (o.every(function (e) {
                  return e(r);
                })) return r.values[e.id];
              }
            });
          });
        }());
      return [].concat(e, a);
    }
    function at(e, t) {
      var n = t.instance.state,
        o = n.pivotColumns,
        r = n.groupBy;
      return [].concat(e, [o, r]);
    }
    function st(e, t) {
      var n = t.instance.state;
      return e = e.filter(function (e) {
        return !e.isPivotSource;
      }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function (e) {
        return e.isGrouped || e.isPivoted;
      })), e;
    }
    function ct(e, t) {
      var n = t.instance;
      return [].concat(e, [n.state.pivotColumns, n.state.groupBy]);
    }
    function dt(e) {
      var t = e.columns,
        n = e.allColumns,
        o = e.flatHeaders,
        r = e.getHooks,
        i = e.plugins,
        u = e.dispatch,
        a = e.autoResetPivot,
        s = void 0 === a || a,
        d = e.manaulPivot,
        f = e.disablePivot,
        g = e.defaultCanPivot;
      p(i, ["useGroupBy"], "usePivotColumns");
      var m = v(e);
      n.forEach(function (t) {
        var n = t.accessor,
          o = t.defaultPivot,
          r = t.disablePivot;
        t.canPivot = n ? E(t.canPivot, !0 !== r && void 0, !0 !== f && void 0, !0) : E(t.canPivot, o, g, !1), t.canPivot && (t.togglePivot = function () {
          return e.togglePivot(t.id);
        }), t.Aggregated = t.Aggregated || t.Cell;
      });
      o.forEach(function (e) {
        e.getPivotToggleProps = c(r().getPivotToggleProps, {
          instance: m(),
          header: e
        });
      });
      var y = v(s);
      h(function () {
        y() && u({
          type: l.resetPivot
        });
      }, [u, d ? null : t]), Object.assign(e, {
        togglePivot: function togglePivot(e, t) {
          u({
            type: l.togglePivot,
            columnId: e,
            value: t
          });
        }
      });
    }
    function ft(e) {
      e.allCells.forEach(function (e) {
        e.isPivoted = e.column.isPivoted;
      });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected";
    var pt = function pt(e) {
      e.getToggleRowSelectedProps = [gt], e.getToggleAllRowsSelectedProps = [vt], e.stateReducers.push(mt), e.useInstance.push(ht), e.prepareRow.push(yt);
    };
    pt.pluginName = "useRowSelect";
    var gt = function gt(e, t) {
        var n = t.instance,
          o = t.row,
          r = n.manualRowSelectedKey,
          i = void 0 === r ? "isSelected" : r;
        return [e, {
          onChange: function onChange(e) {
            o.toggleRowSelected(e.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: !(!o.original || !o.original[i]) || o.isSelected,
          title: "Toggle Row Selected",
          indeterminate: o.isSomeSelected
        }];
      },
      vt = function vt(e, t) {
        var n = t.instance;
        return [e, {
          onChange: function onChange(e) {
            n.toggleAllRowsSelected(e.target.checked);
          },
          style: {
            cursor: "pointer"
          },
          checked: n.isAllRowsSelected,
          title: "Toggle All Rows Selected",
          indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
        }];
      };
    function mt(e, t, n, o) {
      if (t.type === l.init) return r({
        selectedRowIds: {}
      }, e);
      if (t.type === l.resetSelectedRows) return r({}, e, {
        selectedRowIds: o.initialState.selectedRowIds || {}
      });
      if (t.type === l.toggleAllRowsSelected) {
        var i = t.value,
          u = o.isAllRowsSelected,
          a = o.rowsById,
          s = o.nonGroupedRowsById,
          c = void 0 === s ? a : s,
          d = void 0 !== i ? i : !u,
          f = Object.assign({}, e.selectedRowIds);
        return d ? Object.keys(c).forEach(function (e) {
          f[e] = !0;
        }) : Object.keys(c).forEach(function (e) {
          delete f[e];
        }), r({}, e, {
          selectedRowIds: f
        });
      }
      if (t.type === l.toggleRowSelected) {
        var p = t.id,
          g = t.value,
          v = o.rowsById,
          m = o.selectSubRows,
          h = void 0 === m || m,
          y = v[p].isSelected,
          w = void 0 !== g ? g : !y;
        if (y === w) return e;
        var R = r({}, e.selectedRowIds);
        return function e(t) {
          var n = v[t];
          if (n.isGrouped || (w ? R[t] = !0 : delete R[t]), h && n.subRows) return n.subRows.forEach(function (t) {
            return e(t.id);
          });
        }(p), r({}, e, {
          selectedRowIds: R
        });
      }
    }
    function ht(e) {
      var n = e.data,
        o = e.rows,
        r = e.getHooks,
        i = e.plugins,
        u = e.rowsById,
        a = e.nonGroupedRowsById,
        s = void 0 === a ? u : a,
        d = e.autoResetSelectedRows,
        f = void 0 === d || d,
        g = e.state.selectedRowIds,
        m = e.selectSubRows,
        y = void 0 === m || m,
        w = e.dispatch;
      p(i, ["useFilters", "useGroupBy", "useSortBy"], "useRowSelect");
      var R = t.useMemo(function () {
          var e = [];
          return o.forEach(function (t) {
            var n = y ? function e(t, n) {
              if (n[t.id]) return !0;
              if (t.subRows && t.subRows.length) {
                var o = !0,
                  r = !1;
                return t.subRows.forEach(function (t) {
                  r && !o || (e(t, n) ? r = !0 : o = !1);
                }), !!o || !!r && null;
              }
              return !1;
            }(t, g) : !!g[t.id];
            t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
          }), e;
        }, [o, y, g]),
        b = Boolean(Object.keys(s).length && Object.keys(g).length);
      b && Object.keys(s).some(function (e) {
        return !g[e];
      }) && (b = !1);
      var S = v(f);
      h(function () {
        S() && w({
          type: l.resetSelectedRows
        });
      }, [w, n]);
      var C = t.useCallback(function (e) {
          return w({
            type: l.toggleAllRowsSelected,
            value: e
          });
        }, [w]),
        x = t.useCallback(function (e, t) {
          return w({
            type: l.toggleRowSelected,
            id: e,
            value: t
          });
        }, [w]),
        P = v(e),
        E = c(r().getToggleAllRowsSelectedProps, {
          instance: P()
        });
      Object.assign(e, {
        selectedFlatRows: R,
        isAllRowsSelected: b,
        toggleRowSelected: x,
        toggleAllRowsSelected: C,
        getToggleAllRowsSelectedProps: E
      });
    }
    function yt(e, t) {
      var n = t.instance;
      e.toggleRowSelected = function (t) {
        return n.toggleRowSelected(e.id, t);
      }, e.getToggleRowSelectedProps = c(n.getHooks().getToggleRowSelectedProps, {
        instance: n,
        row: e
      });
    }
    var wt = function wt(e) {
        return {};
      },
      Rt = function Rt(e) {
        return {};
      };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var bt = function bt(e) {
      e.stateReducers.push(St), e.useInstance.push(Ct), e.prepareRow.push(xt);
    };
    function St(e, t, n, o) {
      var i = o.initialRowStateAccessor,
        u = void 0 === i ? wt : i,
        a = o.initialCellStateAccessor,
        s = void 0 === a ? Rt : a,
        c = o.rowsById;
      if (t.type === l.init) return r({
        rowState: {}
      }, e);
      if (t.type === l.resetRowState) return r({}, e, {
        rowState: o.initialState.rowState || {}
      });
      if (t.type === l.setRowState) {
        var d,
          f = t.rowId,
          p = t.value,
          v = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f].original);
        return r({}, e, {
          rowState: r({}, e.rowState, (d = {}, d[f] = g(p, v), d))
        });
      }
      if (t.type === l.setCellState) {
        var m,
          h,
          y,
          w = t.rowId,
          R = t.columnId,
          b = t.value,
          S = void 0 !== e.rowState[w] ? e.rowState[w] : u(c[w].original),
          C = void 0 !== (null == S ? void 0 : null == (m = S.cellState) ? void 0 : m[R]) ? S.cellState[R] : s(c[w].original);
        return r({}, e, {
          rowState: r({}, e.rowState, (y = {}, y[w] = r({}, S, {
            cellState: r({}, S.cellState || {}, (h = {}, h[R] = g(b, C), h))
          }), y))
        });
      }
    }
    function Ct(e) {
      var n = e.autoResetRowState,
        o = void 0 === n || n,
        r = e.data,
        i = e.dispatch,
        u = t.useCallback(function (e, t) {
          return i({
            type: l.setRowState,
            rowId: e,
            value: t
          });
        }, [i]),
        a = t.useCallback(function (e, t, n) {
          return i({
            type: l.setCellState,
            rowId: e,
            columnId: t,
            value: n
          });
        }, [i]),
        s = v(o);
      h(function () {
        s() && i({
          type: l.resetRowState
        });
      }, [r]), Object.assign(e, {
        setRowState: u,
        setCellState: a
      });
    }
    function xt(e, t) {
      var n = t.instance,
        o = n.initialRowStateAccessor,
        r = void 0 === o ? wt : o,
        i = n.initialCellStateAccessor,
        u = void 0 === i ? Rt : i,
        l = n.state.rowState;
      e.original && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e.original), e.setState = function (t) {
        return n.setRowState(e.id, t);
      }, e.cells.forEach(function (t) {
        e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(e.original), t.setState = function (o) {
          return n.setCellState(e.id, t.column.id, o);
        };
      }));
    }
    bt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var Pt = function Pt(e) {
      e.stateReducers.push(Et), e.visibleColumnsDeps.push(function (e, t) {
        var n = t.instance;
        return [].concat(e, [n.state.columnOrder]);
      }), e.visibleColumns.push(Bt), e.useInstance.push(It);
    };
    function Et(e, t, n, o) {
      return t.type === l.init ? r({
        columnOrder: []
      }, e) : t.type === l.resetColumnOrder ? r({}, e, {
        columnOrder: o.initialState.columnOrder || []
      }) : t.type === l.setColumnOrder ? r({}, e, {
        columnOrder: g(t.columnOrder, e.columnOrder)
      }) : void 0;
    }
    function Bt(e, t) {
      var n = t.instance.state.columnOrder;
      if (!n || !n.length) return e;
      for (var o = [].concat(n), r = [].concat(e), i = [], u = function u() {
          var e = o.shift(),
            t = r.findIndex(function (t) {
              return t.id === e;
            });
          t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;) u();
      return [].concat(i, r);
    }
    function It(e) {
      var n = e.dispatch;
      e.setColumnOrder = t.useCallback(function (e) {
        return n({
          type: l.setColumnOrder,
          columnOrder: e
        });
      }, [n]);
    }
    Pt.pluginName = "useColumnOrder", a.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing";
    var Ft = function Ft(e) {
        e.getResizerProps = [Gt], e.getHeaderProps.push({
          style: {
            position: "relative"
          }
        }), e.stateReducers.push(kt), e.useInstance.push(At), e.useInstanceBeforeDimensions.push(Ht);
      },
      Gt = function Gt(e, t) {
        var n = t.instance,
          o = t.header,
          r = n.dispatch,
          i = function i(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
              if (e.touches && e.touches.length > 1) return;
              n = !0;
            }
            var o = function (e) {
                var t = [];
                return function e(n) {
                  n.columns && n.columns.length && n.columns.map(e);
                  t.push(n);
                }(e), t;
              }(t).map(function (e) {
                return [e.id, e.totalWidth];
              }),
              i = n ? Math.round(e.touches[0].clientX) : e.clientX,
              u = function u(e) {
                r({
                  type: l.columnResizing,
                  clientX: e
                });
              },
              a = function a() {
                return r({
                  type: l.columnDoneResizing
                });
              },
              s = {
                mouse: {
                  moveEvent: "mousemove",
                  moveHandler: function moveHandler(e) {
                    return u(e.clientX);
                  },
                  upEvent: "mouseup",
                  upHandler: function upHandler(e) {
                    document.removeEventListener("mousemove", s.mouse.moveHandler), document.removeEventListener("mouseup", s.mouse.upHandler), a();
                  }
                },
                touch: {
                  moveEvent: "touchmove",
                  moveHandler: function moveHandler(e) {
                    return e.cancelable && (e.preventDefault(), e.stopPropagation()), u(e.touches[0].clientX), !1;
                  },
                  upEvent: "touchend",
                  upHandler: function upHandler(e) {
                    document.removeEventListener(s.touch.moveEvent, s.touch.moveHandler), document.removeEventListener(s.touch.upEvent, s.touch.moveHandler), a();
                  }
                }
              },
              c = n ? s.touch : s.mouse,
              d = !!function () {
                if ("boolean" == typeof A) return A;
                var e = !1;
                try {
                  var t = {
                    get passive() {
                      return e = !0, !1;
                    }
                  };
                  window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                  e = !1;
                }
                return A = e;
              }() && {
                passive: !1
              };
            document.addEventListener(c.moveEvent, c.moveHandler, d), document.addEventListener(c.upEvent, c.upHandler, d), r({
              type: l.columnStartResizing,
              columnId: t.id,
              columnWidth: t.totalWidth,
              headerIdWidths: o,
              clientX: i
            });
          };
        return [e, {
          onMouseDown: function onMouseDown(e) {
            return e.persist() || i(e, o);
          },
          onTouchStart: function onTouchStart(e) {
            return e.persist() || i(e, o);
          },
          style: {
            cursor: "ew-resize"
          },
          draggable: !1,
          role: "separator"
        }];
      };
    function kt(e, t) {
      if (t.type === l.init) return r({
        columnResizing: {
          columnWidths: {}
        }
      }, e);
      if (t.type === l.columnStartResizing) {
        var n = t.clientX,
          o = t.columnId,
          i = t.columnWidth,
          u = t.headerIdWidths;
        return r({}, e, {
          columnResizing: r({}, e.columnResizing, {
            startX: n,
            headerIdWidths: u,
            columnWidth: i,
            isResizingColumn: o
          })
        });
      }
      if (t.type === l.columnResizing) {
        var a = t.clientX,
          s = e.columnResizing,
          c = s.startX,
          d = s.columnWidth,
          f = s.headerIdWidths,
          p = (a - c) / d,
          g = {};
        return f.forEach(function (e) {
          var t = e[0],
            n = e[1];
          g[t] = Math.max(n + n * p, 0);
        }), r({}, e, {
          columnResizing: r({}, e.columnResizing, {
            columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
          })
        });
      }
      return t.type === l.columnDoneResizing ? r({}, e, {
        columnResizing: r({}, e.columnResizing, {
          startX: null,
          isResizingColumn: null
        })
      }) : void 0;
    }
    Ft.pluginName = "useResizeColumns";
    var Ht = function Ht(e) {
      var t = e.flatHeaders,
        n = e.disableResizing,
        o = e.getHooks,
        r = e.state.columnResizing,
        i = v(e);
      t.forEach(function (e) {
        var t = E(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
        e.canResize = t, e.width = r.columnWidths[e.id] || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = c(o().getResizerProps, {
          instance: i(),
          header: e
        }));
      });
    };
    function At(e) {
      p(e.plugins, ["useAbsoluteLayout"], "useResizeColumns");
    }
    var Tt = {
        position: "absolute",
        top: 0
      },
      Ot = function Ot(e) {
        e.getTableBodyProps.push(Wt), e.getRowProps.push(Wt), e.getHeaderGroupProps.push(Wt), e.getFooterGroupProps.push(Wt), e.getHeaderProps.push(function (e, t) {
          var n = t.column;
          return [e, {
            style: r({}, Tt, {
              left: n.totalLeft + "px",
              width: n.totalWidth + "px"
            })
          }];
        }), e.getCellProps.push(function (e, t) {
          var n = t.cell;
          return [e, {
            style: r({}, Tt, {
              left: n.column.totalLeft + "px",
              width: n.column.totalWidth + "px"
            })
          }];
        }), e.getFooterProps.push(function (e, t) {
          var n = t.column;
          return [e, {
            style: r({}, Tt, {
              left: n.totalLeft + "px",
              width: n.totalWidth + "px"
            })
          }];
        });
      };
    Ot.pluginName = "useAbsoluteLayout";
    var Wt = function Wt(e, t) {
        return [e, {
          style: {
            position: "relative",
            width: t.instance.totalColumnsWidth + "px"
          }
        }];
      },
      zt = {
        display: "inline-block",
        boxSizing: "border-box"
      },
      Mt = function Mt(e, t) {
        return [e, {
          style: {
            display: "flex",
            width: t.instance.totalColumnsWidth + "px"
          }
        }];
      },
      Nt = function Nt(e) {
        e.getRowProps.push(Mt), e.getHeaderGroupProps.push(Mt), e.getFooterGroupProps.push(Mt), e.getHeaderProps.push(function (e, t) {
          var n = t.column;
          return [e, {
            style: r({}, zt, {
              width: n.totalWidth + "px"
            })
          }];
        }), e.getCellProps.push(function (e, t) {
          var n = t.cell;
          return [e, {
            style: r({}, zt, {
              width: n.column.totalWidth + "px"
            })
          }];
        }), e.getFooterProps.push(function (e, t) {
          var n = t.column;
          return [e, {
            style: r({}, zt, {
              width: n.totalWidth + "px"
            })
          }];
        });
      };
    function jt(e) {
      e.getTableProps.push(Dt), e.getRowProps.push(Vt), e.getHeaderGroupProps.push(Vt), e.getFooterGroupProps.push(Vt), e.getHeaderProps.push(_t), e.getCellProps.push(Lt), e.getFooterProps.push(Xt);
    }
    Nt.pluginName = "useBlockLayout", jt.pluginName = "useFlexLayout";
    var Dt = function Dt(e, t) {
        return [e, {
          style: {
            minWidth: t.instance.totalColumnsWidth + "px"
          }
        }];
      },
      Vt = function Vt(e, t) {
        return [e, {
          style: {
            display: "flex",
            flex: "1 0 auto",
            minWidth: t.instance.totalColumnsMinWidth + "px"
          }
        }];
      },
      _t = function _t(e, t) {
        var n = t.column;
        return [e, {
          style: {
            boxSizing: "border-box",
            flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
            minWidth: n.totalMinWidth + "px",
            width: n.totalWidth + "px"
          }
        }];
      },
      Lt = function Lt(e, t) {
        var n = t.cell;
        return [e, {
          style: {
            boxSizing: "border-box",
            flex: n.column.totalFlexWidth + " 0 auto",
            minWidth: n.column.totalMinWidth + "px",
            width: n.column.totalWidth + "px"
          }
        }];
      },
      Xt = function Xt(e, t) {
        var n = t.column;
        return [e, {
          style: {
            boxSizing: "border-box",
            flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
            minWidth: n.totalMinWidth + "px",
            width: n.totalWidth + "px"
          }
        }];
      };
    e._UNSTABLE_usePivotColumns = et, e.actions = l, e.defaultColumn = a, e.defaultGroupByFn = je, e.defaultOrderByFn = Je, e.ensurePluginOrder = p, e.flexRender = w, e.functionalUpdate = g, e.loopHooks = f, e.makePropGetter = c, e.makeRenderer = y, e.reduceHooks = d, e.safeUseLayoutEffect = m, e.useAbsoluteLayout = Ot, e.useAsyncDebounce = function (e, n) {
      void 0 === n && (n = 0);
      var r = t.useRef({}),
        i = v(e),
        u = v(n);
      return t.useCallback(function () {
        var e = o(_regeneratorRuntime.mark(function e() {
          var t,
            n,
            l,
            a = arguments;
          return _regeneratorRuntime.wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                for (t = a.length, n = new Array(t), l = 0; l < t; l++) n[l] = a[l];
                return r.current.promise || (r.current.promise = new Promise(function (e, t) {
                  r.current.resolve = e, r.current.reject = t;
                })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(_regeneratorRuntime.mark(function e() {
                  return _regeneratorRuntime.wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return delete r.current.timeout, e.prev = 1, e.t0 = r.current, e.next = 5, i().apply(void 0, n);
                      case 5:
                        e.t1 = e.sent, e.t0.resolve.call(e.t0, e.t1), e.next = 12;
                        break;
                      case 9:
                        e.prev = 9, e.t2 = e.catch(1), r.current.reject(e.t2);
                      case 12:
                        return e.prev = 12, delete r.current.promise, e.finish(12);
                      case 15:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 9, 12, 15]]);
                })), u()), e.abrupt("return", r.current.promise);
              case 5:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }(), [i, u]);
    }, e.useBlockLayout = Nt, e.useColumnOrder = Pt, e.useExpanded = ue, e.useFilters = Ce, e.useFlexLayout = jt, e.useGetLatest = v, e.useGlobalFilter = Ee, e.useGroupBy = Ae, e.useMountedLayoutEffect = h, e.usePagination = Ye, e.useResizeColumns = Ft, e.useRowSelect = pt, e.useRowState = bt, e.useSortBy = qe, e.useTable = function (e) {
      for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];
      e = oe(e), o = [X].concat(o);
      var u = t.useRef({}),
        a = v(u.current);
      Object.assign(a(), r({}, e, {
        plugins: o,
        hooks: L()
      })), o.filter(Boolean).forEach(function (e) {
        e(a().hooks);
      });
      var s = v(a().hooks);
      a().getHooks = s, delete a().hooks, Object.assign(a(), d(s().useOptions, oe(e)));
      var p = a(),
        g = p.data,
        m = p.columns,
        h = p.initialState,
        w = p.defaultColumn,
        P = p.getSubRows,
        E = p.getRowId,
        B = p.stateReducer,
        I = p.useControlledState,
        F = v(B),
        G = t.useCallback(function (e, t) {
          if (!t.type) throw console.info({
            action: t
          }), new Error("Unknown Action 👆");
          return [].concat(s().stateReducers, Array.isArray(F()) ? F() : [F()]).reduce(function (n, o) {
            return o(n, t, e, a()) || n;
          }, e);
        }, [s, F, a]),
        k = t.useReducer(G, void 0, function () {
          return G(h, {
            type: l.init
          });
        }),
        H = k[0],
        A = k[1],
        T = d([].concat(s().useControlledState, [I]), H, {
          instance: a()
        });
      Object.assign(a(), {
        state: T,
        dispatch: A
      });
      var O = t.useMemo(function () {
        return R(d(s().columns, m, {
          instance: a()
        }));
      }, [s, a, m].concat(d(s().columnsDeps, [], {
        instance: a()
      })));
      a().columns = O;
      var W = t.useMemo(function () {
        return d(s().allColumns, b(O), {
          instance: a()
        }).map(S);
      }, [O, s, a].concat(d(s().allColumnsDeps, [], {
        instance: a()
      })));
      a().allColumns = W;
      var z = t.useMemo(function () {
          for (var e = [], t = [], n = {}, o = [].concat(W); o.length;) {
            var r = o.shift();
            ie({
              data: g,
              rows: e,
              flatRows: t,
              rowsById: n,
              column: r,
              getRowId: E,
              getSubRows: P,
              accessValueHooks: s().accessValue,
              getInstance: a
            });
          }
          return [e, t, n];
        }, [W, g, E, P, s, a]),
        M = z[0],
        N = z[1],
        j = z[2];
      Object.assign(a(), {
        rows: M,
        initialRows: [].concat(M),
        flatRows: N,
        rowsById: j
      }), f(s().useInstanceAfterData, a());
      var D = t.useMemo(function () {
        return d(s().visibleColumns, W, {
          instance: a()
        }).map(function (e) {
          return C(e, w);
        });
      }, [s, W, a, w].concat(d(s().visibleColumnsDeps, [], {
        instance: a()
      })));
      if (W = t.useMemo(function () {
        var e = [].concat(D);
        return W.forEach(function (t) {
          e.find(function (e) {
            return e.id === t.id;
          }) || e.push(t);
        }), e;
      }, [W, D]), a().allColumns = W, "production" !== "development") {
        var V = W.filter(function (e, t) {
          return W.findIndex(function (t) {
            return t.id === e.id;
          }) !== t;
        });
        if (V.length) throw console.info(W), new Error('Duplicate columns were found with ids: "' + V.map(function (e) {
          return e.id;
        }).join(", ") + '" in the columns array above');
      }
      var _ = t.useMemo(function () {
        return d(s().headerGroups, x(D, w), a());
      }, [s, D, w, a].concat(d(s().headerGroupsDeps, [], {
        instance: a()
      })));
      a().headerGroups = _;
      var q = t.useMemo(function () {
        return _.length ? _[0].headers : [];
      }, [_]);
      a().headers = q, a().flatHeaders = _.reduce(function (e, t) {
        return [].concat(e, t.headers);
      }, []), f(s().useInstanceBeforeDimensions, a());
      var K = D.filter(function (e) {
        return e.isVisible;
      }).map(function (e) {
        return e.id;
      }).sort().join("_");
      D = t.useMemo(function () {
        return D.filter(function (e) {
          return e.isVisible;
        });
      }, [D, K]), a().visibleColumns = D;
      var U = re(q),
        $ = U[0],
        J = U[1],
        Y = U[2];
      return a().totalColumnsMinWidth = $, a().totalColumnsWidth = J, a().totalColumnsMaxWidth = Y, f(s().useInstance, a()), [].concat(a().flatHeaders, a().allColumns).forEach(function (e) {
        e.render = y(a(), e), e.getHeaderProps = c(s().getHeaderProps, {
          instance: a(),
          column: e
        }), e.getFooterProps = c(s().getFooterProps, {
          instance: a(),
          column: e
        });
      }), a().headerGroups = t.useMemo(function () {
        return _.filter(function (e, t) {
          return e.headers = e.headers.filter(function (e) {
            return e.headers ? function e(t) {
              return t.filter(function (t) {
                return t.headers ? e(t.headers) : t.isVisible;
              }).length;
            }(e.headers) : e.isVisible;
          }), !!e.headers.length && (e.getHeaderGroupProps = c(s().getHeaderGroupProps, {
            instance: a(),
            headerGroup: e,
            index: t
          }), e.getFooterGroupProps = c(s().getFooterGroupProps, {
            instance: a(),
            headerGroup: e,
            index: t
          }), !0);
        });
      }, [_, a, s]), a().footerGroups = [].concat(a().headerGroups).reverse(), a().prepareRow = t.useCallback(function (e) {
        e.getRowProps = c(s().getRowProps, {
          instance: a(),
          row: e
        }), e.allCells = W.map(function (t) {
          var n = e.values[t.id],
            o = {
              column: t,
              row: e,
              value: n
            };
          return o.getCellProps = c(s().getCellProps, {
            instance: a(),
            cell: o
          }), o.render = y(a(), t, {
            row: e,
            cell: o,
            value: n
          }), o;
        }), e.cells = D.map(function (t) {
          return e.allCells.find(function (e) {
            return e.column.id === t.id;
          });
        }), f(s().prepareRow, e, {
          instance: a()
        });
      }, [s, a, W, D]), a().getTableProps = c(s().getTableProps, {
        instance: a()
      }), a().getTableBodyProps = c(s().getTableBodyProps, {
        instance: a()
      }), f(s().useFinalInstance, a()), a();
    }, Object.defineProperty(e, "__esModule", {
      value: !0
    });
  });
});
unwrapExports(reactTable_production_min);
var reactTable_development = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory(exports, React__default);
  })(commonjsGlobal, function (exports, React) {
    React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;
    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }
      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }
    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
          args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);
          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }
          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }
          _next(undefined);
        });
      };
    }
    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      return _extends.apply(this, arguments);
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;
      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }
      return target;
    }
    function _toPrimitive(input, hint) {
      if (typeof input !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
      var key = _toPrimitive(arg, "string");
      return typeof key === "symbol" ? key : String(key);
    }
    var renderErr = 'Renderer Error ☝️';
    var actions = {
      init: 'init'
    };
    var defaultColumn = {
      Cell: function Cell(_ref) {
        var _ref$value = _ref.value,
          value = _ref$value === void 0 ? '' : _ref$value;
        return value;
      },
      width: 150,
      minWidth: 0,
      maxWidth: Number.MAX_SAFE_INTEGER
    };
    function mergeProps() {
      for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
        propList[_key] = arguments[_key];
      }
      return propList.reduce(function (props, next) {
        var style = next.style,
          className = next.className,
          rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);
        props = _extends({}, props, {}, rest);
        if (style) {
          props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
        }
        if (className) {
          props.className = props.className ? props.className + ' ' + className : className;
        }
        if (props.className === '') {
          delete props.className;
        }
        return props;
      }, {});
    }
    function handlePropGetter(prevProps, userProps, meta) {
      // Handle a lambda, pass it the previous props
      if (typeof userProps === 'function') {
        return handlePropGetter({}, userProps(prevProps, meta));
      } // Handle an array, merge each item as separate props

      if (Array.isArray(userProps)) {
        return mergeProps.apply(void 0, [prevProps].concat(userProps));
      } // Handle an object by default, merge the two objects

      return mergeProps(prevProps, userProps);
    }
    var makePropGetter = function makePropGetter(hooks, meta) {
      if (meta === void 0) {
        meta = {};
      }
      return function (userProps) {
        if (userProps === void 0) {
          userProps = {};
        }
        return [].concat(hooks, [userProps]).reduce(function (prev, next) {
          return handlePropGetter(prev, next, _extends({}, meta, {
            userProps: userProps
          }));
        }, {});
      };
    };
    var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
      if (meta === void 0) {
        meta = {};
      }
      return hooks.reduce(function (prev, next) {
        var nextValue = next(prev, meta);
        {
          if (!allowUndefined && typeof nextValue === 'undefined') {
            console.info(next);
            throw new Error('React Table: A reducer hook ☝️ just returned undefined! This is not allowed.');
          }
        }
        return nextValue;
      }, initial);
    };
    var loopHooks = function loopHooks(hooks, context, meta) {
      if (meta === void 0) {
        meta = {};
      }
      return hooks.forEach(function (hook) {
        var nextValue = hook(context, meta);
        {
          if (typeof nextValue !== 'undefined') {
            console.info(hook, nextValue);
            throw new Error('React Table: A loop-type hook ☝️ just returned a value! This is not allowed.');
          }
        }
      });
    };
    function ensurePluginOrder(plugins, befores, pluginName, afters) {
      if (afters) {
        throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
      }
      var pluginIndex = plugins.findIndex(function (plugin) {
        return plugin.pluginName === pluginName;
      });
      if (pluginIndex === -1) {
        {
          throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
        }
      }
      befores.forEach(function (before) {
        var beforeIndex = plugins.findIndex(function (plugin) {
          return plugin.pluginName === before;
        });
        if (beforeIndex > -1 && beforeIndex > pluginIndex) {
          {
            throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
          }
        }
      });
    }
    function functionalUpdate(updater, old) {
      return typeof updater === 'function' ? updater(old) : updater;
    }
    function useGetLatest(obj) {
      var ref = React.useRef();
      ref.current = obj;
      return React.useCallback(function () {
        return ref.current;
      }, []);
    } // SSR has issues with useLayoutEffect still, so use useEffect during SSR

    var safeUseLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;
    function useMountedLayoutEffect(fn, deps) {
      var mountedRef = React.useRef(false);
      safeUseLayoutEffect(function () {
        if (mountedRef.current) {
          fn();
        }
        mountedRef.current = true; // eslint-disable-next-line
      }, deps);
    }
    function useAsyncDebounce(defaultFn, defaultWait) {
      if (defaultWait === void 0) {
        defaultWait = 0;
      }
      var debounceRef = React.useRef({});
      var getDefaultFn = useGetLatest(defaultFn);
      var getDefaultWait = useGetLatest(defaultWait);
      return React.useCallback( /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          var _len2,
            args,
            _key2,
            _args2 = arguments;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = _args2[_key2];
                  }
                  if (!debounceRef.current.promise) {
                    debounceRef.current.promise = new Promise(function (resolve, reject) {
                      debounceRef.current.resolve = resolve;
                      debounceRef.current.reject = reject;
                    });
                  }
                  if (debounceRef.current.timeout) {
                    clearTimeout(debounceRef.current.timeout);
                  }
                  debounceRef.current.timeout = setTimeout( /*#__PURE__*/
                  _asyncToGenerator( /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            delete debounceRef.current.timeout;
                            _context.prev = 1;
                            _context.t0 = debounceRef.current;
                            _context.next = 5;
                            return getDefaultFn().apply(void 0, args);
                          case 5:
                            _context.t1 = _context.sent;
                            _context.t0.resolve.call(_context.t0, _context.t1);
                            _context.next = 12;
                            break;
                          case 9:
                            _context.prev = 9;
                            _context.t2 = _context["catch"](1);
                            debounceRef.current.reject(_context.t2);
                          case 12:
                            _context.prev = 12;
                            delete debounceRef.current.promise;
                            return _context.finish(12);
                          case 15:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[1, 9, 12, 15]]);
                  })), getDefaultWait());
                  return _context2.abrupt("return", debounceRef.current.promise);
                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function () {
          return _ref2.apply(this, arguments);
        };
      }(), [getDefaultFn, getDefaultWait]);
    }
    function makeRenderer(instance, column, meta) {
      if (meta === void 0) {
        meta = {};
      }
      return function (type, userProps) {
        if (userProps === void 0) {
          userProps = {};
        }
        var Comp = typeof type === 'string' ? column[type] : type;
        if (typeof Comp === 'undefined') {
          console.info(column);
          throw new Error(renderErr);
        }
        return flexRender(Comp, _extends({}, instance, {
          column: column
        }, meta, {}, userProps));
      };
    }
    function flexRender(Comp, props) {
      return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
    }
    function isReactComponent(component) {
      return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
    }
    function isClassComponent(component) {
      return typeof component === 'function' && function () {
        var proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
      }();
    }
    function isExoticComponent(component) {
      return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
    }
    function linkColumnStructure(columns, parent, depth) {
      if (depth === void 0) {
        depth = 0;
      }
      return columns.map(function (column) {
        column = _extends({}, column, {
          parent: parent,
          depth: depth
        });
        assignColumnAccessor(column);
        if (column.columns) {
          column.columns = linkColumnStructure(column.columns, column, depth + 1);
        }
        return column;
      });
    }
    function flattenColumns(columns) {
      return flattenBy(columns, 'columns');
    }
    function assignColumnAccessor(column) {
      // First check for string accessor
      var id = column.id,
        accessor = column.accessor,
        Header = column.Header;
      if (typeof accessor === 'string') {
        id = id || accessor;
        var accessorPath = accessor.split('.');
        accessor = function accessor(row) {
          return getBy(row, accessorPath);
        };
      }
      if (!id && typeof Header === 'string' && Header) {
        id = Header;
      }
      if (!id && column.columns) {
        console.error(column);
        throw new Error('A column ID (or unique "Header" value) is required!');
      }
      if (!id) {
        console.error(column);
        throw new Error('A column ID (or string accessor) is required!');
      }
      Object.assign(column, {
        id: id,
        accessor: accessor
      });
      return column;
    }
    function decorateColumn(column, userDefaultColumn) {
      if (!userDefaultColumn) {
        throw new Error();
      }
      Object.assign(column, _extends({
        // Make sure there is a fallback header, just in case
        Header: function Header() {
          return React.createElement(React.Fragment, null, "\xA0");
        },
        Footer: function Footer() {
          return React.createElement(React.Fragment, null, "\xA0");
        }
      }, defaultColumn, {}, userDefaultColumn, {}, column));
      return column;
    } // Build the header groups from the bottom up

    function makeHeaderGroups(allColumns, defaultColumn) {
      var headerGroups = [];
      var scanColumns = allColumns;
      var uid = 0;
      var getUID = function getUID() {
        return uid++;
      };
      var _loop = function _loop() {
        // The header group we are creating
        var headerGroup = {
          headers: []
        }; // The parent columns we're going to scan next

        var parentColumns = [];
        var hasParents = scanColumns.some(function (d) {
          return d.parent;
        }); // Scan each column for parents

        scanColumns.forEach(function (column) {
          // What is the latest (last) parent column?
          var latestParentColumn = [].concat(parentColumns).reverse()[0];
          var newParent;
          if (hasParents) {
            // If the column has a parent, add it if necessary
            if (column.parent) {
              newParent = _extends({}, column.parent, {
                originalId: column.parent.id,
                id: column.parent.id + "_" + getUID(),
                headers: [column]
              });
            } else {
              // If other columns have parents, we'll need to add a place holder if necessary
              var originalId = column.id + "_placeholder";
              newParent = decorateColumn({
                originalId: originalId,
                id: column.id + "_placeholder_" + getUID(),
                placeholderOf: column,
                headers: [column]
              }, defaultColumn);
            } // If the resulting parent columns are the same, just add
            // the column and increment the header span

            if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
              latestParentColumn.headers.push(column);
            } else {
              parentColumns.push(newParent);
            }
          }
          headerGroup.headers.push(column);
        });
        headerGroups.push(headerGroup); // Start scanning the parent columns

        scanColumns = parentColumns;
      };
      while (scanColumns.length) {
        _loop();
      }
      return headerGroups.reverse();
    }
    var pathObjCache = new Map();
    function getBy(obj, path, def) {
      if (!path) {
        return obj;
      }
      var cacheKey = typeof path === 'function' ? path : JSON.stringify(path);
      var pathObj = pathObjCache.get(cacheKey) || function () {
        var pathObj = makePathArray(path);
        pathObjCache.set(cacheKey, pathObj);
        return pathObj;
      }();
      var val;
      try {
        val = pathObj.reduce(function (cursor, pathPart) {
          return cursor[pathPart];
        }, obj);
      } catch (e) {// continue regardless of error
      }
      return typeof val !== 'undefined' ? val : def;
    }
    function getFirstDefined() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      for (var i = 0; i < args.length; i += 1) {
        if (typeof args[i] !== 'undefined') {
          return args[i];
        }
      }
    }
    function isFunction(a) {
      if (typeof a === 'function') {
        return a;
      }
    }
    function flattenBy(arr, key) {
      var flat = [];
      var recurse = function recurse(arr) {
        arr.forEach(function (d) {
          if (!d[key]) {
            flat.push(d);
          } else {
            recurse(d[key]);
          }
        });
      };
      recurse(arr);
      return flat;
    }
    function expandRows(rows, _ref) {
      var manualExpandedKey = _ref.manualExpandedKey,
        expanded = _ref.expanded,
        _ref$expandSubRows = _ref.expandSubRows,
        expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
      var expandedRows = [];
      var handleRow = function handleRow(row) {
        row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
        row.canExpand = row.subRows && !!row.subRows.length;
        expandedRows.push(row);
        if (expandSubRows && row.subRows && row.subRows.length && row.isExpanded) {
          row.subRows.forEach(handleRow);
        }
      };
      rows.forEach(handleRow);
      return expandedRows;
    }
    function getFilterMethod(filter, userFilterTypes, filterTypes) {
      return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
    }
    function shouldAutoRemoveFilter(autoRemove, value, column) {
      return autoRemove ? autoRemove(value, column) : typeof value === 'undefined';
    }
    function unpreparedAccessWarning() {
      throw new Error('React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.');
    }
    var passiveSupported = null;
    function passiveEventSupported() {
      // memoize support to avoid adding multiple test events
      if (typeof passiveSupported === 'boolean') return passiveSupported;
      var supported = false;
      try {
        var options = {
          get passive() {
            supported = true;
            return false;
          }
        };
        window.addEventListener('test', null, options);
        window.removeEventListener('test', null, options);
      } catch (err) {
        supported = false;
      }
      passiveSupported = supported;
      return passiveSupported;
    } //

    var reOpenBracket = /\[/g;
    var reCloseBracket = /\]/g;
    function makePathArray(obj) {
      return flattenDeep(obj) // remove all periods in parts
      .map(function (d) {
        return String(d).replace('.', '_');
      }) // join parts using period
      .join('.') // replace brackets with periods
      .replace(reOpenBracket, '.').replace(reCloseBracket, '') // split it back out on periods
      .split('.');
    }
    function flattenDeep(arr, newArr) {
      if (newArr === void 0) {
        newArr = [];
      }
      if (!Array.isArray(arr)) {
        newArr.push(arr);
      } else {
        for (var i = 0; i < arr.length; i += 1) {
          flattenDeep(arr[i], newArr);
        }
      }
      return newArr;
    }
    var defaultGetTableProps = function defaultGetTableProps(props) {
      return _extends({
        role: 'table'
      }, props);
    };
    var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
      return _extends({
        role: 'rowgroup'
      }, props);
    };
    var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
      var column = _ref.column;
      return _extends({
        key: "header_" + column.id,
        colSpan: column.totalVisibleHeaderCount,
        role: 'columnheader'
      }, props);
    };
    var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
      var column = _ref2.column;
      return _extends({
        key: "footer_" + column.id,
        colSpan: column.totalVisibleHeaderCount
      }, props);
    };
    var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
      var index = _ref3.index;
      return _extends({
        key: "headerGroup_" + index,
        role: 'row'
      }, props);
    };
    var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
      var index = _ref4.index;
      return _extends({
        key: "footerGroup_" + index
      }, props);
    };
    var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
      var row = _ref5.row;
      return _extends({
        key: "row_" + row.id,
        role: 'row'
      }, props);
    };
    var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
      var cell = _ref6.cell;
      return _extends({
        key: "cell_" + cell.row.id + "_" + cell.column.id,
        role: 'cell'
      }, props);
    };
    function makeDefaultPluginHooks() {
      return {
        useOptions: [],
        stateReducers: [],
        useControlledState: [],
        columns: [],
        columnsDeps: [],
        allColumns: [],
        allColumnsDeps: [],
        accessValue: [],
        materializedColumns: [],
        materializedColumnsDeps: [],
        useInstanceAfterData: [],
        visibleColumns: [],
        visibleColumnsDeps: [],
        headerGroups: [],
        headerGroupsDeps: [],
        useInstanceBeforeDimensions: [],
        useInstance: [],
        prepareRow: [],
        getTableProps: [defaultGetTableProps],
        getTableBodyProps: [defaultGetTableBodyProps],
        getHeaderGroupProps: [defaultGetHeaderGroupProps],
        getFooterGroupProps: [defaultGetFooterGroupProps],
        getHeaderProps: [defaultGetHeaderProps],
        getFooterProps: [defaultGetFooterProps],
        getRowProps: [defaultGetRowProps],
        getCellProps: [defaultGetCellProps],
        useFinalInstance: []
      };
    }
    actions.resetHiddenColumns = 'resetHiddenColumns';
    actions.toggleHideColumn = 'toggleHideColumn';
    actions.setHiddenColumns = 'setHiddenColumns';
    actions.toggleHideAllColumns = 'toggleHideAllColumns';
    var useColumnVisibility = function useColumnVisibility(hooks) {
      hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
      hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
      hooks.stateReducers.push(reducer);
      hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
      hooks.headerGroupsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.hiddenColumns]);
      });
      hooks.useInstance.push(useInstance);
    };
    useColumnVisibility.pluginName = 'useColumnVisibility';
    var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
      var column = _ref2.column;
      return [props, {
        onChange: function onChange(e) {
          column.toggleHidden(!e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: column.isVisible,
        title: 'Toggle Column Visible'
      }];
    };
    var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
      var instance = _ref3.instance;
      return [props, {
        onChange: function onChange(e) {
          instance.toggleHideAllColumns(!e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
        title: 'Toggle All Columns Hidden',
        indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
      }];
    };
    function reducer(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          hiddenColumns: []
        }, state);
      }
      if (action.type === actions.resetHiddenColumns) {
        return _extends({}, state, {
          hiddenColumns: instance.initialState.hiddenColumns || []
        });
      }
      if (action.type === actions.toggleHideColumn) {
        var should = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.includes(action.columnId);
        var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function (d) {
          return d !== action.columnId;
        });
        return _extends({}, state, {
          hiddenColumns: hiddenColumns
        });
      }
      if (action.type === actions.setHiddenColumns) {
        return _extends({}, state, {
          hiddenColumns: functionalUpdate(action.value, state.hiddenColumns)
        });
      }
      if (action.type === actions.toggleHideAllColumns) {
        var shouldAll = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.length;
        return _extends({}, state, {
          hiddenColumns: shouldAll ? instance.allColumns.map(function (d) {
            return d.id;
          }) : []
        });
      }
    }
    function useInstanceBeforeDimensions(instance) {
      var headers = instance.headers,
        hiddenColumns = instance.state.hiddenColumns;
      var isMountedRef = React.useRef(false);
      if (!isMountedRef.current) ;
      var handleColumn = function handleColumn(column, parentVisible) {
        column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
        var totalVisibleHeaderCount = 0;
        if (column.headers && column.headers.length) {
          column.headers.forEach(function (subColumn) {
            return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
          });
        } else {
          totalVisibleHeaderCount = column.isVisible ? 1 : 0;
        }
        column.totalVisibleHeaderCount = totalVisibleHeaderCount;
        return totalVisibleHeaderCount;
      };
      var totalVisibleHeaderCount = 0;
      headers.forEach(function (subHeader) {
        return totalVisibleHeaderCount += handleColumn(subHeader, true);
      });
    }
    function useInstance(instance) {
      var columns = instance.columns,
        flatHeaders = instance.flatHeaders,
        dispatch = instance.dispatch,
        allColumns = instance.allColumns,
        getHooks = instance.getHooks,
        hiddenColumns = instance.state.hiddenColumns,
        _instance$autoResetHi = instance.autoResetHiddenColumns,
        autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
      var getInstance = useGetLatest(instance);
      var allColumnsHidden = allColumns.length === hiddenColumns.length;
      var toggleHideColumn = React.useCallback(function (columnId, value) {
        return dispatch({
          type: actions.toggleHideColumn,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      var setHiddenColumns = React.useCallback(function (value) {
        return dispatch({
          type: actions.setHiddenColumns,
          value: value
        });
      }, [dispatch]);
      var toggleHideAllColumns = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleHideAllColumns,
          value: value
        });
      }, [dispatch]);
      var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
        instance: getInstance()
      });
      flatHeaders.forEach(function (column) {
        column.toggleHidden = function (value) {
          dispatch({
            type: actions.toggleHideColumn,
            columnId: column.id,
            value: value
          });
        };
        column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
          instance: getInstance(),
          column: column
        });
      });
      var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
      useMountedLayoutEffect(function () {
        if (getAutoResetHiddenColumns()) {
          dispatch({
            type: actions.resetHiddenColumns
          });
        }
      }, [dispatch, columns]);
      Object.assign(instance, {
        allColumnsHidden: allColumnsHidden,
        toggleHideColumn: toggleHideColumn,
        setHiddenColumns: setHiddenColumns,
        toggleHideAllColumns: toggleHideAllColumns,
        getToggleHideAllColumnsProps: getToggleHideAllColumnsProps
      });
    }
    var defaultInitialState = {};
    var defaultColumnInstance = {};
    var defaultReducer = function defaultReducer(state, action, prevState) {
      return state;
    };
    var defaultGetSubRows = function defaultGetSubRows(row, index) {
      return row.subRows || [];
    };
    var defaultGetRowId = function defaultGetRowId(row, index, parent) {
      return "" + (parent ? [parent.id, index].join('.') : index);
    };
    var defaultUseControlledState = function defaultUseControlledState(d) {
      return d;
    };
    function applyDefaults(props) {
      var _props$initialState = props.initialState,
        initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
        _props$defaultColumn = props.defaultColumn,
        defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
        _props$getSubRows = props.getSubRows,
        getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
        _props$getRowId = props.getRowId,
        getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
        _props$stateReducer = props.stateReducer,
        stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
        _props$useControlledS = props.useControlledState,
        useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
        rest = _objectWithoutPropertiesLoose(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);
      return _extends({}, rest, {
        initialState: initialState,
        defaultColumn: defaultColumn,
        getSubRows: getSubRows,
        getRowId: getRowId,
        stateReducer: stateReducer,
        useControlledState: useControlledState
      });
    }
    var useTable = function useTable(props) {
      for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        plugins[_key - 1] = arguments[_key];
      }

      // Apply default props
      props = applyDefaults(props); // Add core plugins

      plugins = [useColumnVisibility].concat(plugins); // Create the table instance

      var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

      var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

      Object.assign(getInstance(), _extends({}, props, {
        plugins: plugins,
        hooks: makeDefaultPluginHooks()
      })); // Allow plugins to register hooks as early as possible

      plugins.filter(Boolean).forEach(function (plugin) {
        plugin(getInstance().hooks);
      }); // Consume all hooks and make a getter for them

      var getHooks = useGetLatest(getInstance().hooks);
      getInstance().getHooks = getHooks;
      delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

      Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));
      var _getInstance = getInstance(),
        data = _getInstance.data,
        userColumns = _getInstance.columns,
        initialState = _getInstance.initialState,
        defaultColumn = _getInstance.defaultColumn,
        getSubRows = _getInstance.getSubRows,
        getRowId = _getInstance.getRowId,
        stateReducer = _getInstance.stateReducer,
        useControlledState = _getInstance.useControlledState; // Setup user reducer ref

      var getStateReducer = useGetLatest(stateReducer); // Build the reducer

      var reducer = React.useCallback(function (state, action) {
        // Detect invalid actions
        if (!action.type) {
          console.info({
            action: action
          });
          throw new Error('Unknown Action 👆');
        } // Reduce the state from all plugin reducers

        return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function (s, handler) {
          return handler(s, action, state, getInstance()) || s;
        }, state);
      }, [getHooks, getStateReducer, getInstance]); // Start the reducer

      var _React$useReducer = React.useReducer(reducer, undefined, function () {
          return reducer(initialState, {
            type: actions.init
          });
        }),
        reducerState = _React$useReducer[0],
        dispatch = _React$useReducer[1]; // Allow the user to control the final state with hooks

      var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
        instance: getInstance()
      });
      Object.assign(getInstance(), {
        state: state,
        dispatch: dispatch
      }); // Decorate All the columns

      var columns = React.useMemo(function () {
        return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
          instance: getInstance()
        }));
      }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
        instance: getInstance()
      })));
      getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
      // those columns (and trigger this memoization via deps)

      var allColumns = React.useMemo(function () {
        return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
          instance: getInstance()
        }).map(assignColumnAccessor);
      }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
        instance: getInstance()
      })));
      getInstance().allColumns = allColumns; // Access the row model using initial columns

      var _React$useMemo = React.useMemo(function () {
          var rows = [];
          var flatRows = [];
          var rowsById = {};
          var allColumnsQueue = [].concat(allColumns);
          while (allColumnsQueue.length) {
            var column = allColumnsQueue.shift();
            accessRowsForColumn({
              data: data,
              rows: rows,
              flatRows: flatRows,
              rowsById: rowsById,
              column: column,
              getRowId: getRowId,
              getSubRows: getSubRows,
              accessValueHooks: getHooks().accessValue,
              getInstance: getInstance
            });
          }
          return [rows, flatRows, rowsById];
        }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]),
        rows = _React$useMemo[0],
        flatRows = _React$useMemo[1],
        rowsById = _React$useMemo[2];
      Object.assign(getInstance(), {
        rows: rows,
        initialRows: [].concat(rows),
        flatRows: flatRows,
        rowsById: rowsById // materializedColumns,
      });

      loopHooks(getHooks().useInstanceAfterData, getInstance()); // Get the flat list of all columns AFTER the rows
      // have been access, and allow hooks to decorate
      // those columns (and trigger this memoization via deps)

      var visibleColumns = React.useMemo(function () {
        return reduceHooks(getHooks().visibleColumns, allColumns, {
          instance: getInstance()
        }).map(function (d) {
          return decorateColumn(d, defaultColumn);
        });
      }, [getHooks, allColumns, getInstance, defaultColumn].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
        instance: getInstance()
      }))); // Combine new visible columns with all columns

      allColumns = React.useMemo(function () {
        var columns = [].concat(visibleColumns);
        allColumns.forEach(function (column) {
          if (!columns.find(function (d) {
            return d.id === column.id;
          })) {
            columns.push(column);
          }
        });
        return columns;
      }, [allColumns, visibleColumns]);
      getInstance().allColumns = allColumns;
      {
        var duplicateColumns = allColumns.filter(function (column, i) {
          return allColumns.findIndex(function (d) {
            return d.id === column.id;
          }) !== i;
        });
        if (duplicateColumns.length) {
          console.info(allColumns);
          throw new Error("Duplicate columns were found with ids: \"" + duplicateColumns.map(function (d) {
            return d.id;
          }).join(', ') + "\" in the columns array above");
        }
      } // Make the headerGroups

      var headerGroups = React.useMemo(function () {
        return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
      }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
        instance: getInstance()
      })));
      getInstance().headerGroups = headerGroups; // Get the first level of headers

      var headers = React.useMemo(function () {
        return headerGroups.length ? headerGroups[0].headers : [];
      }, [headerGroups]);
      getInstance().headers = headers; // Provide a flat header list for utilities

      getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
        return [].concat(all, headerGroup.headers);
      }, []);
      loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

      var visibleColumnsDep = visibleColumns.filter(function (d) {
        return d.isVisible;
      }).map(function (d) {
        return d.id;
      }).sort().join('_');
      visibleColumns = React.useMemo(function () {
        return visibleColumns.filter(function (d) {
          return d.isVisible;
        });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [visibleColumns, visibleColumnsDep]);
      getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

      var _calculateHeaderWidth = calculateHeaderWidths(headers),
        totalColumnsMinWidth = _calculateHeaderWidth[0],
        totalColumnsWidth = _calculateHeaderWidth[1],
        totalColumnsMaxWidth = _calculateHeaderWidth[2];
      getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
      getInstance().totalColumnsWidth = totalColumnsWidth;
      getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
      loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
      // prop getter properties here.
      ;

      [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function (column) {
        // Give columns/headers rendering power
        column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

        column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
          instance: getInstance(),
          column: column
        }); // Give columns/headers a default getFooterProps

        column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
          instance: getInstance(),
          column: column
        });
      });
      getInstance().headerGroups = React.useMemo(function () {
        return headerGroups.filter(function (headerGroup, i) {
          // Filter out any headers and headerGroups that don't have visible columns
          headerGroup.headers = headerGroup.headers.filter(function (column) {
            var recurse = function recurse(headers) {
              return headers.filter(function (column) {
                if (column.headers) {
                  return recurse(column.headers);
                }
                return column.isVisible;
              }).length;
            };
            if (column.headers) {
              return recurse(column.headers);
            }
            return column.isVisible;
          }); // Give headerGroups getRowProps

          if (headerGroup.headers.length) {
            headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
              instance: getInstance(),
              headerGroup: headerGroup,
              index: i
            });
            headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
              instance: getInstance(),
              headerGroup: headerGroup,
              index: i
            });
            return true;
          }
          return false;
        });
      }, [headerGroups, getInstance, getHooks]);
      getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
      // any rows the user wishes to be displayed.

      getInstance().prepareRow = React.useCallback(function (row) {
        row.getRowProps = makePropGetter(getHooks().getRowProps, {
          instance: getInstance(),
          row: row
        }); // Build the visible cells for each row

        row.allCells = allColumns.map(function (column) {
          var value = row.values[column.id];
          var cell = {
            column: column,
            row: row,
            value: value
          }; // Give each cell a getCellProps base

          cell.getCellProps = makePropGetter(getHooks().getCellProps, {
            instance: getInstance(),
            cell: cell
          }); // Give each cell a renderer function (supports multiple renderers)

          cell.render = makeRenderer(getInstance(), column, {
            row: row,
            cell: cell,
            value: value
          });
          return cell;
        });
        row.cells = visibleColumns.map(function (column) {
          return row.allCells.find(function (cell) {
            return cell.column.id === column.id;
          });
        }); // need to apply any row specific hooks (useExpanded requires this)

        loopHooks(getHooks().prepareRow, row, {
          instance: getInstance()
        });
      }, [getHooks, getInstance, allColumns, visibleColumns]);
      getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
        instance: getInstance()
      });
      getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
        instance: getInstance()
      });
      loopHooks(getHooks().useFinalInstance, getInstance());
      return getInstance();
    };
    function calculateHeaderWidths(headers, left) {
      if (left === void 0) {
        left = 0;
      }
      var sumTotalMinWidth = 0;
      var sumTotalWidth = 0;
      var sumTotalMaxWidth = 0;
      var sumTotalFlexWidth = 0;
      headers.forEach(function (header) {
        var subHeaders = header.headers;
        header.totalLeft = left;
        if (subHeaders && subHeaders.length) {
          var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left),
            totalMinWidth = _calculateHeaderWidth2[0],
            totalWidth = _calculateHeaderWidth2[1],
            totalMaxWidth = _calculateHeaderWidth2[2],
            totalFlexWidth = _calculateHeaderWidth2[3];
          header.totalMinWidth = totalMinWidth;
          header.totalWidth = totalWidth;
          header.totalMaxWidth = totalMaxWidth;
          header.totalFlexWidth = totalFlexWidth;
        } else {
          header.totalMinWidth = header.minWidth;
          header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
          header.totalMaxWidth = header.maxWidth;
          header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
        }
        if (header.isVisible) {
          left += header.totalWidth;
          sumTotalMinWidth += header.totalMinWidth;
          sumTotalWidth += header.totalWidth;
          sumTotalMaxWidth += header.totalMaxWidth;
          sumTotalFlexWidth += header.totalFlexWidth;
        }
      });
      return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
    }
    function accessRowsForColumn(_ref) {
      var data = _ref.data,
        rows = _ref.rows,
        flatRows = _ref.flatRows,
        rowsById = _ref.rowsById,
        column = _ref.column,
        getRowId = _ref.getRowId,
        getSubRows = _ref.getSubRows,
        accessValueHooks = _ref.accessValueHooks,
        getInstance = _ref.getInstance;

      // Access the row's data column-by-column
      // We do it this way so we can incrementally add materialized
      // columns after the first pass and avoid excessive looping
      var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
        if (depth === void 0) {
          depth = 0;
        }

        // Keep the original reference around
        var original = originalRow;
        var id = getRowId(originalRow, rowIndex, parent);
        var row = rowsById[id]; // If the row hasn't been created, let's make it

        if (!row) {
          row = {
            id: id,
            original: original,
            index: rowIndex,
            depth: depth,
            cells: [{}] // This is a dummy cell
          }; // Override common array functions (and the dummy cell's getCellProps function)
          // to show an error if it is accessed without calling prepareRow

          row.cells.map = unpreparedAccessWarning;
          row.cells.filter = unpreparedAccessWarning;
          row.cells.forEach = unpreparedAccessWarning;
          row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

          row.values = {}; // Push this row into the parentRows array

          parentRows.push(row); // Keep track of every row in a flat array

          flatRows.push(row); // Also keep track of every row by its ID

          rowsById[id] = row; // Get the original subrows

          row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

          if (row.originalSubRows) {
            var subRows = [];
            row.originalSubRows.forEach(function (d, i) {
              return accessRow(d, i, depth + 1, row, subRows);
            }); // Keep the new subRows array on the row

            row.subRows = subRows;
          }
        } else if (row.subRows) {
          // If the row exists, then it's already been accessed
          // Keep recursing, but don't worry about passing the
          // accumlator array (those rows already exist)
          row.originalSubRows.forEach(function (d, i) {
            return accessRow(d, i, depth + 1, row);
          });
        } // If the column has an accessor, use it to get a value

        if (column.accessor) {
          row.values[column.id] = column.accessor(originalRow, rowIndex, row);
        } // Allow plugins to manipulate the column value

        row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
          row: row,
          column: column,
          instance: getInstance()
        }, true);
      };
      data.forEach(function (originalRow, rowIndex) {
        return accessRow(originalRow, rowIndex, 0, undefined, rows);
      });
    }
    actions.resetExpanded = 'resetExpanded';
    actions.toggleRowExpanded = 'toggleRowExpanded';
    actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';
    var useExpanded = function useExpanded(hooks) {
      hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
      hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
      hooks.stateReducers.push(reducer$1);
      hooks.useInstance.push(useInstance$1);
      hooks.prepareRow.push(prepareRow);
    };
    useExpanded.pluginName = 'useExpanded';
    var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        onClick: function onClick(e) {
          instance.toggleAllRowsExpanded();
        },
        style: {
          cursor: 'pointer'
        },
        title: 'Toggle All Rows Expanded'
      }];
    };
    var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
      var row = _ref2.row;
      return [props, {
        onClick: function onClick() {
          row.toggleRowExpanded();
        },
        style: {
          cursor: 'pointer'
        },
        title: 'Toggle Row Expanded'
      }];
    }; // Reducer

    function reducer$1(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          expanded: {}
        }, state);
      }
      if (action.type === actions.resetExpanded) {
        return _extends({}, state, {
          expanded: instance.initialState.expanded || {}
        });
      }
      if (action.type === actions.toggleAllRowsExpanded) {
        var value = action.value;
        var isAllRowsExpanded = instance.isAllRowsExpanded,
          rowsById = instance.rowsById;
        var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;
        if (expandAll) {
          var expanded = {};
          Object.keys(rowsById).forEach(function (rowId) {
            expanded[rowId] = true;
          });
          return _extends({}, state, {
            expanded: expanded
          });
        }
        return _extends({}, state, {
          expanded: {}
        });
      }
      if (action.type === actions.toggleRowExpanded) {
        var id = action.id,
          setExpanded = action.value;
        var exists = state.expanded[id];
        var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;
        if (!exists && shouldExist) {
          var _extends2;
          return _extends({}, state, {
            expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2))
          });
        } else if (exists && !shouldExist) {
          var _state$expanded = state.expanded,
            _ = _state$expanded[id],
            rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));
          return _extends({}, state, {
            expanded: rest
          });
        } else {
          return state;
        }
      }
    }
    function useInstance$1(instance) {
      var data = instance.data,
        rows = instance.rows,
        rowsById = instance.rowsById,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$autoResetEx = instance.autoResetExpanded,
        autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        expanded = instance.state.expanded,
        dispatch = instance.dispatch;
      ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
      var getAutoResetExpanded = useGetLatest(autoResetExpanded);
      var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);
      if (isAllRowsExpanded) {
        if (Object.keys(rowsById).some(function (id) {
          return !expanded[id];
        })) {
          isAllRowsExpanded = false;
        }
      } // Bypass any effects from firing when this changes

      useMountedLayoutEffect(function () {
        if (getAutoResetExpanded()) {
          dispatch({
            type: actions.resetExpanded
          });
        }
      }, [dispatch, data]);
      var toggleRowExpanded = React.useCallback(function (id, value) {
        dispatch({
          type: actions.toggleRowExpanded,
          id: id,
          value: value
        });
      }, [dispatch]);
      var toggleAllRowsExpanded = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleAllRowsExpanded,
          value: value
        });
      }, [dispatch]);
      var expandedRows = React.useMemo(function () {
        if (paginateExpandedRows) {
          return expandRows(rows, {
            manualExpandedKey: manualExpandedKey,
            expanded: expanded,
            expandSubRows: expandSubRows
          });
        }
        return rows;
      }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
      var expandedDepth = React.useMemo(function () {
        return findExpandedDepth(expanded);
      }, [expanded]);
      var getInstance = useGetLatest(instance);
      var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
        instance: getInstance()
      });
      Object.assign(instance, {
        preExpandedRows: rows,
        expandedRows: expandedRows,
        rows: expandedRows,
        expandedDepth: expandedDepth,
        isAllRowsExpanded: isAllRowsExpanded,
        toggleRowExpanded: toggleRowExpanded,
        toggleAllRowsExpanded: toggleAllRowsExpanded,
        getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
      });
    }
    function prepareRow(row, _ref3) {
      var getHooks = _ref3.instance.getHooks,
        instance = _ref3.instance;
      row.toggleRowExpanded = function (set) {
        return instance.toggleRowExpanded(row.id, set);
      };
      row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
        instance: instance,
        row: row
      });
    }
    function findExpandedDepth(expanded) {
      var maxDepth = 0;
      Object.keys(expanded).forEach(function (id) {
        var splitId = id.split('.');
        maxDepth = Math.max(maxDepth, splitId.length);
      });
      return maxDepth;
    }
    var text = function text(rows, ids, filterValue) {
      rows = rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
        });
      });
      return rows;
    };
    text.autoRemove = function (val) {
      return !val;
    };
    var exactText = function exactText(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
        });
      });
    };
    exactText.autoRemove = function (val) {
      return !val;
    };
    var exactTextCase = function exactTextCase(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue) === String(filterValue) : true;
        });
      });
    };
    exactTextCase.autoRemove = function (val) {
      return !val;
    };
    var includes = function includes(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue.includes(filterValue);
        });
      });
    };
    includes.autoRemove = function (val) {
      return !val || !val.length;
    };
    var includesAll = function includesAll(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue && rowValue.length && filterValue.every(function (val) {
            return rowValue.includes(val);
          });
        });
      });
    };
    includesAll.autoRemove = function (val) {
      return !val || !val.length;
    };
    var includesSome = function includesSome(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue && rowValue.length && filterValue.some(function (val) {
            return rowValue.includes(val);
          });
        });
      });
    };
    includesSome.autoRemove = function (val) {
      return !val || !val.length;
    };
    var includesValue = function includesValue(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return filterValue.includes(rowValue);
        });
      });
    };
    includesValue.autoRemove = function (val) {
      return !val || !val.length;
    };
    var exact = function exact(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue === filterValue;
        });
      });
    };
    exact.autoRemove = function (val) {
      return typeof val === 'undefined';
    };
    var equals = function equals(rows, ids, filterValue) {
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id]; // eslint-disable-next-line eqeqeq

          return rowValue == filterValue;
        });
      });
    };
    equals.autoRemove = function (val) {
      return val == null;
    };
    var between = function between(rows, ids, filterValue) {
      var _ref = filterValue || [],
        min = _ref[0],
        max = _ref[1];
      min = typeof min === 'number' ? min : -Infinity;
      max = typeof max === 'number' ? max : Infinity;
      if (min > max) {
        var temp = min;
        min = max;
        max = temp;
      }
      return rows.filter(function (row) {
        return ids.some(function (id) {
          var rowValue = row.values[id];
          return rowValue >= min && rowValue <= max;
        });
      });
    };
    between.autoRemove = function (val) {
      return !val || typeof val[0] !== 'number' && typeof val[1] !== 'number';
    };
    var filterTypes = /*#__PURE__*/Object.freeze({
      __proto__: null,
      text: text,
      exactText: exactText,
      exactTextCase: exactTextCase,
      includes: includes,
      includesAll: includesAll,
      includesSome: includesSome,
      includesValue: includesValue,
      exact: exact,
      equals: equals,
      between: between
    });
    actions.resetFilters = 'resetFilters';
    actions.setFilter = 'setFilter';
    actions.setAllFilters = 'setAllFilters';
    var useFilters = function useFilters(hooks) {
      hooks.stateReducers.push(reducer$2);
      hooks.useInstance.push(useInstance$2);
    };
    useFilters.pluginName = 'useFilters';
    function reducer$2(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          filters: []
        }, state);
      }
      if (action.type === actions.resetFilters) {
        return _extends({}, state, {
          filters: instance.initialState.filters || []
        });
      }
      if (action.type === actions.setFilter) {
        var columnId = action.columnId,
          filterValue = action.filterValue;
        var allColumns = instance.allColumns,
          userFilterTypes = instance.filterTypes;
        var column = allColumns.find(function (d) {
          return d.id === columnId;
        });
        if (!column) {
          throw new Error("React-Table: Could not find a column with id: " + columnId);
        }
        var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
        var previousfilter = state.filters.find(function (d) {
          return d.id === columnId;
        });
        var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value); //

        if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) {
          return _extends({}, state, {
            filters: state.filters.filter(function (d) {
              return d.id !== columnId;
            })
          });
        }
        if (previousfilter) {
          return _extends({}, state, {
            filters: state.filters.map(function (d) {
              if (d.id === columnId) {
                return {
                  id: columnId,
                  value: newFilter
                };
              }
              return d;
            })
          });
        }
        return _extends({}, state, {
          filters: [].concat(state.filters, [{
            id: columnId,
            value: newFilter
          }])
        });
      }
      if (action.type === actions.setAllFilters) {
        var filters = action.filters;
        var _allColumns = instance.allColumns,
          _userFilterTypes = instance.filterTypes;
        return _extends({}, state, {
          // Filter out undefined values
          filters: functionalUpdate(filters, state.filters).filter(function (filter) {
            var column = _allColumns.find(function (d) {
              return d.id === filter.id;
            });
            var filterMethod = getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes);
            if (shouldAutoRemoveFilter(filterMethod.autoRemove, filter.value, column)) {
              return false;
            }
            return true;
          })
        });
      }
    }
    function useInstance$2(instance) {
      var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        manualFilters = instance.manualFilters,
        _instance$defaultCanF = instance.defaultCanFilter,
        defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF,
        disableFilters = instance.disableFilters,
        filters = instance.state.filters,
        dispatch = instance.dispatch,
        _instance$autoResetFi = instance.autoResetFilters,
        autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
      var setFilter = React.useCallback(function (columnId, filterValue) {
        dispatch({
          type: actions.setFilter,
          columnId: columnId,
          filterValue: filterValue
        });
      }, [dispatch]);
      var setAllFilters = React.useCallback(function (filters) {
        dispatch({
          type: actions.setAllFilters,
          filters: filters
        });
      }, [dispatch]);
      allColumns.forEach(function (column) {
        var id = column.id,
          accessor = column.accessor,
          columnDefaultCanFilter = column.defaultCanFilter,
          columnDisableFilters = column.disableFilters; // Determine if a column is filterable

        column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : undefined, disableFilters === true ? false : undefined, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false); // Provide the column a way of updating the filter value

        column.setFilter = function (val) {
          return setFilter(column.id, val);
        }; // Provide the current filter value to the column for
        // convenience

        var found = filters.find(function (d) {
          return d.id === id;
        });
        column.filterValue = found && found.value;
      });
      var _React$useMemo = React.useMemo(function () {
          if (manualFilters || !filters.length) {
            return [rows, flatRows, rowsById];
          }
          var filteredFlatRows = [];
          var filteredRowsById = {}; // Filters top level and nested rows

          var filterRows = function filterRows(rows, depth) {
            if (depth === void 0) {
              depth = 0;
            }
            var filteredRows = rows;
            filteredRows = filters.reduce(function (filteredSoFar, _ref) {
              var columnId = _ref.id,
                filterValue = _ref.value;
              // Find the filters column
              var column = allColumns.find(function (d) {
                return d.id === columnId;
              });
              if (!column) {
                return filteredSoFar;
              }
              if (depth === 0) {
                column.preFilteredRows = filteredSoFar;
              }
              var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
              if (!filterMethod) {
                console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
                return filteredSoFar;
              } // Pass the rows, id, filterValue and column to the filterMethod
              // to get the filtered rows back

              column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
              return column.filteredRows;
            }, rows); // Apply the filter to any subRows
            // We technically could do this recursively in the above loop,
            // but that would severely hinder the API for the user, since they
            // would be required to do that recursion in some scenarios

            filteredRows.forEach(function (row) {
              filteredFlatRows.push(row);
              filteredRowsById[row.id] = row;
              if (!row.subRows) {
                return;
              }
              row.subRows = row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows;
            });
            return filteredRows;
          };
          return [filterRows(rows), filteredFlatRows, filteredRowsById];
        }, [manualFilters, filters, rows, flatRows, rowsById, allColumns, userFilterTypes]),
        filteredRows = _React$useMemo[0],
        filteredFlatRows = _React$useMemo[1],
        filteredRowsById = _React$useMemo[2];
      React.useMemo(function () {
        // Now that each filtered column has it's partially filtered rows,
        // lets assign the final filtered rows to all of the other columns
        var nonFilteredColumns = allColumns.filter(function (column) {
          return !filters.find(function (d) {
            return d.id === column.id;
          });
        }); // This essentially enables faceted filter options to be built easily
        // using every column's preFilteredRows value

        nonFilteredColumns.forEach(function (column) {
          column.preFilteredRows = filteredRows;
          column.filteredRows = filteredRows;
        });
      }, [filteredRows, filters, allColumns]);
      var getAutoResetFilters = useGetLatest(autoResetFilters);
      useMountedLayoutEffect(function () {
        if (getAutoResetFilters()) {
          dispatch({
            type: actions.resetFilters
          });
        }
      }, [dispatch, manualFilters ? null : data]);
      Object.assign(instance, {
        preFilteredRows: rows,
        preFilteredFlatRows: flatRows,
        preFilteredRowsById: rowsById,
        filteredRows: filteredRows,
        filteredFlatRows: filteredFlatRows,
        filteredRowsById: filteredRowsById,
        rows: filteredRows,
        flatRows: filteredFlatRows,
        rowsById: filteredRowsById,
        setFilter: setFilter,
        setAllFilters: setAllFilters
      });
    }
    actions.resetGlobalFilter = 'resetGlobalFilter';
    actions.setGlobalFilter = 'setGlobalFilter';
    var useGlobalFilter = function useGlobalFilter(hooks) {
      hooks.stateReducers.push(reducer$3);
      hooks.useInstance.push(useInstance$3);
    };
    useGlobalFilter.pluginName = 'useGlobalFilter';
    function reducer$3(state, action, previousState, instance) {
      if (action.type === actions.resetGlobalFilter) {
        return _extends({}, state, {
          globalFilter: instance.initialState.globalFilter || undefined
        });
      }
      if (action.type === actions.setGlobalFilter) {
        var filterValue = action.filterValue;
        var userFilterTypes = instance.userFilterTypes;
        var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
        var newFilter = functionalUpdate(filterValue, state.globalFilter); //

        if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
          var globalFilter = state.globalFilter,
            stateWithoutGlobalFilter = _objectWithoutPropertiesLoose(state, ["globalFilter"]);
          return stateWithoutGlobalFilter;
        }
        return _extends({}, state, {
          globalFilter: newFilter
        });
      }
    }
    function useInstance$3(instance) {
      var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        globalFilter = instance.globalFilter,
        manualGlobalFilter = instance.manualGlobalFilter,
        globalFilterValue = instance.state.globalFilter,
        dispatch = instance.dispatch,
        _instance$autoResetGl = instance.autoResetGlobalFilter,
        autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl,
        disableGlobalFilter = instance.disableGlobalFilter;
      var setGlobalFilter = React.useCallback(function (filterValue) {
        dispatch({
          type: actions.setGlobalFilter,
          filterValue: filterValue
        });
      }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
      // This gets pretty complicated pretty fast, since you have to maintain a
      // cache for each row group (top-level rows, and each row's recursive subrows)
      // This would make multi-filtering a lot faster though. Too far?

      var _React$useMemo = React.useMemo(function () {
          if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
            return [rows, flatRows, rowsById];
          }
          var filteredFlatRows = [];
          var filteredRowsById = {};
          var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);
          if (!filterMethod) {
            console.warn("Could not find a valid 'globalFilter' option.");
            return rows;
          }
          allColumns.forEach(function (column) {
            var columnDisableGlobalFilter = column.disableGlobalFilter;
            column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : undefined, disableGlobalFilter === true ? false : undefined, true);
          });
          var filterableColumns = allColumns.filter(function (c) {
            return c.canFilter === true;
          }); // Filters top level and nested rows

          var filterRows = function filterRows(filteredRows) {
            filteredRows = filterMethod(filteredRows, filterableColumns.map(function (d) {
              return d.id;
            }), globalFilterValue);
            filteredRows.forEach(function (row) {
              filteredFlatRows.push(row);
              filteredRowsById[row.id] = row;
              row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
            });
            return filteredRows;
          };
          return [filterRows(rows), filteredFlatRows, filteredRowsById];
        }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns, rows, flatRows, rowsById, disableGlobalFilter]),
        globalFilteredRows = _React$useMemo[0],
        globalFilteredFlatRows = _React$useMemo[1],
        globalFilteredRowsById = _React$useMemo[2];
      var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
      useMountedLayoutEffect(function () {
        if (getAutoResetGlobalFilter()) {
          dispatch({
            type: actions.resetGlobalFilter
          });
        }
      }, [dispatch, manualGlobalFilter ? null : data]);
      Object.assign(instance, {
        preGlobalFilteredRows: rows,
        preGlobalFilteredFlatRows: flatRows,
        preGlobalFilteredRowsById: rowsById,
        globalFilteredRows: globalFilteredRows,
        globalFilteredFlatRows: globalFilteredFlatRows,
        globalFilteredRowsById: globalFilteredRowsById,
        rows: globalFilteredRows,
        flatRows: globalFilteredFlatRows,
        rowsById: globalFilteredRowsById,
        setGlobalFilter: setGlobalFilter,
        disableGlobalFilter: disableGlobalFilter
      });
    }
    function sum(values, aggregatedValues) {
      // It's faster to just add the aggregations together instead of
      // process leaf nodes individually
      return aggregatedValues.reduce(function (sum, next) {
        return sum + (typeof next === 'number' ? next : 0);
      }, 0);
    }
    function min(values) {
      var min = 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          min = Math.min(min, value);
        }
      });
      return min;
    }
    function max(values) {
      var max = 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          max = Math.max(max, value);
        }
      });
      return max;
    }
    function minMax(values) {
      var min = 0;
      var max = 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          min = Math.min(min, value);
          max = Math.max(max, value);
        }
      });
      return min + ".." + max;
    }
    function average(values) {
      return sum(null, values) / values.length;
    }
    function median(values) {
      if (!values.length) {
        return null;
      }
      var min = 0;
      var max = 0;
      values.forEach(function (value) {
        if (typeof value === 'number') {
          min = Math.min(min, value);
          max = Math.max(max, value);
        }
      });
      return (min + max) / 2;
    }
    function unique(values) {
      return [].concat(new Set(values).values());
    }
    function uniqueCount(values) {
      return new Set(values).size;
    }
    function count(values) {
      return values.length;
    }
    var aggregations = /*#__PURE__*/Object.freeze({
      __proto__: null,
      sum: sum,
      min: min,
      max: max,
      minMax: minMax,
      average: average,
      median: median,
      unique: unique,
      uniqueCount: uniqueCount,
      count: count
    });
    var emptyArray = [];
    var emptyObject = {}; // Actions

    actions.resetGroupBy = 'resetGroupBy';
    actions.toggleGroupBy = 'toggleGroupBy';
    var useGroupBy = function useGroupBy(hooks) {
      hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
      hooks.stateReducers.push(reducer$4);
      hooks.visibleColumnsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.groupBy]);
      });
      hooks.visibleColumns.push(visibleColumns);
      hooks.useInstance.push(useInstance$4);
      hooks.prepareRow.push(prepareRow$1);
    };
    useGroupBy.pluginName = 'useGroupBy';
    var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
      var header = _ref2.header;
      return [props, {
        onClick: header.canGroupBy ? function (e) {
          e.persist();
          header.toggleGroupBy();
        } : undefined,
        style: {
          cursor: header.canGroupBy ? 'pointer' : undefined
        },
        title: 'Toggle GroupBy'
      }];
    }; // Reducer

    function reducer$4(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          groupBy: []
        }, state);
      }
      if (action.type === actions.resetGroupBy) {
        return _extends({}, state, {
          groupBy: instance.initialState.groupBy || []
        });
      }
      if (action.type === actions.toggleGroupBy) {
        var columnId = action.columnId,
          setGroupBy = action.value;
        var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);
        if (resolvedGroupBy) {
          return _extends({}, state, {
            groupBy: [].concat(state.groupBy, [columnId])
          });
        }
        return _extends({}, state, {
          groupBy: state.groupBy.filter(function (d) {
            return d !== columnId;
          })
        });
      }
    }
    function visibleColumns(columns, _ref3) {
      var groupBy = _ref3.instance.state.groupBy;
      // Sort grouped columns to the start of the column list
      // before the headers are built
      var groupByColumns = groupBy.map(function (g) {
        return columns.find(function (col) {
          return col.id === g;
        });
      }).filter(Boolean);
      var nonGroupByColumns = columns.filter(function (col) {
        return !groupBy.includes(col.id);
      });
      columns = [].concat(groupByColumns, nonGroupByColumns);
      columns.forEach(function (column) {
        column.isGrouped = groupBy.includes(column.id);
        column.groupedIndex = groupBy.indexOf(column.id);
      });
      return columns;
    }
    var defaultUserAggregations = {};
    function useInstance$4(instance) {
      var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        _instance$groupByFn = instance.groupByFn,
        groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
        manualGroupBy = instance.manualGroupBy,
        _instance$aggregation = instance.aggregations,
        userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
        plugins = instance.plugins,
        groupBy = instance.state.groupBy,
        dispatch = instance.dispatch,
        _instance$autoResetGr = instance.autoResetGroupBy,
        autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
        disableGroupBy = instance.disableGroupBy,
        defaultCanGroupBy = instance.defaultCanGroupBy,
        getHooks = instance.getHooks;
      ensurePluginOrder(plugins, ['useFilters'], 'useGroupBy');
      var getInstance = useGetLatest(instance);
      allColumns.forEach(function (column) {
        var accessor = column.accessor,
          defaultColumnGroupBy = column.defaultGroupBy,
          columnDisableGroupBy = column.disableGroupBy;
        column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);
        if (column.canGroupBy) {
          column.toggleGroupBy = function () {
            return instance.toggleGroupBy(column.id);
          };
        }
        column.Aggregated = column.Aggregated || column.Cell;
      });
      var toggleGroupBy = React.useCallback(function (columnId, value) {
        dispatch({
          type: actions.toggleGroupBy,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      flatHeaders.forEach(function (header) {
        header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
          instance: getInstance(),
          header: header
        });
      });
      var _React$useMemo = React.useMemo(function () {
          if (manualGroupBy || !groupBy.length) {
            return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
          } // Ensure that the list of filtered columns exist

          var existingGroupBy = groupBy.filter(function (g) {
            return allColumns.find(function (col) {
              return col.id === g;
            });
          }); // Find the columns that can or are aggregating
          // Uses each column to aggregate rows into a single value

          var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
            var values = {};
            allColumns.forEach(function (column) {
              // Don't aggregate columns that are in the groupBy
              if (existingGroupBy.includes(column.id)) {
                values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
                return;
              } // Get the columnValues to aggregate

              var groupedValues = groupedRows.map(function (row) {
                return row.values[column.id];
              }); // Get the columnValues to aggregate

              var leafValues = leafRows.map(function (row) {
                var columnValue = row.values[column.id];
                if (!depth && column.aggregateValue) {
                  var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];
                  if (!aggregateValueFn) {
                    console.info({
                      column: column
                    });
                    throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
                  }
                  columnValue = aggregateValueFn(columnValue, row, column);
                }
                return columnValue;
              }); // Aggregate the values

              var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];
              if (aggregateFn) {
                values[column.id] = aggregateFn(leafValues, groupedValues);
              } else if (column.aggregate) {
                console.info({
                  column: column
                });
                throw new Error("React Table: Invalid column.aggregate option for column listed above");
              } else {
                values[column.id] = null;
              }
            });
            return values;
          };
          var groupedFlatRows = [];
          var groupedRowsById = {};
          var onlyGroupedFlatRows = [];
          var onlyGroupedRowsById = {};
          var nonGroupedFlatRows = [];
          var nonGroupedRowsById = {}; // Recursively group the data

          var groupUpRecursively = function groupUpRecursively(rows, depth, parentId) {
            if (depth === void 0) {
              depth = 0;
            }

            // This is the last level, just return the rows
            if (depth === existingGroupBy.length) {
              return rows;
            }
            var columnId = existingGroupBy[depth]; // Group the rows together for this level

            var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

            var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
              var groupByVal = _ref4[0],
                groupedRows = _ref4[1];
              var id = columnId + ":" + groupByVal;
              id = parentId ? parentId + ">" + id : id; // First, Recurse to group sub rows before aggregation

              var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

              var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
              var values = aggregateRowsToValues(leafRows, groupedRows, depth);
              var row = {
                id: id,
                isGrouped: true,
                groupByID: columnId,
                groupByVal: groupByVal,
                values: values,
                subRows: subRows,
                leafRows: leafRows,
                depth: depth,
                index: index
              };
              subRows.forEach(function (subRow) {
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
                if (subRow.isGrouped) {
                  onlyGroupedFlatRows.push(subRow);
                  onlyGroupedRowsById[subRow.id] = subRow;
                } else {
                  nonGroupedFlatRows.push(subRow);
                  nonGroupedRowsById[subRow.id] = subRow;
                }
              });
              return row;
            });
            return aggregatedGroupedRows;
          };
          var groupedRows = groupUpRecursively(rows);
          groupedRows.forEach(function (subRow) {
            groupedFlatRows.push(subRow);
            groupedRowsById[subRow.id] = subRow;
            if (subRow.isGrouped) {
              onlyGroupedFlatRows.push(subRow);
              onlyGroupedRowsById[subRow.id] = subRow;
            } else {
              nonGroupedFlatRows.push(subRow);
              nonGroupedRowsById[subRow.id] = subRow;
            }
          }); // Assign the new data

          return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
        }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
        groupedRows = _React$useMemo[0],
        groupedFlatRows = _React$useMemo[1],
        groupedRowsById = _React$useMemo[2],
        onlyGroupedFlatRows = _React$useMemo[3],
        onlyGroupedRowsById = _React$useMemo[4],
        nonGroupedFlatRows = _React$useMemo[5],
        nonGroupedRowsById = _React$useMemo[6];
      var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
      useMountedLayoutEffect(function () {
        if (getAutoResetGroupBy()) {
          dispatch({
            type: actions.resetGroupBy
          });
        }
      }, [dispatch, manualGroupBy ? null : data]);
      Object.assign(instance, {
        preGroupedRows: rows,
        preGroupedFlatRow: flatRows,
        preGroupedRowsById: rowsById,
        groupedRows: groupedRows,
        groupedFlatRows: groupedFlatRows,
        groupedRowsById: groupedRowsById,
        onlyGroupedFlatRows: onlyGroupedFlatRows,
        onlyGroupedRowsById: onlyGroupedRowsById,
        nonGroupedFlatRows: nonGroupedFlatRows,
        nonGroupedRowsById: nonGroupedRowsById,
        rows: groupedRows,
        flatRows: groupedFlatRows,
        rowsById: groupedRowsById,
        toggleGroupBy: toggleGroupBy
      });
    }
    function prepareRow$1(row) {
      row.allCells.forEach(function (cell) {
        // Grouped cells are in the groupBy and the pivot cell for the row
        cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

        cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

        cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && row.canExpand;
      });
    }
    function defaultGroupByFn(rows, columnId) {
      return rows.reduce(function (prev, row, i) {
        // TODO: Might want to implement a key serializer here so
        // irregular column values can still be grouped if needed?
        var resKey = "" + row.values[columnId];
        prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
        prev[resKey].push(row);
        return prev;
      }, {});
    }
    var reSplitAlphaNumeric = /([0-9]+)/gm; // Mixed sorting is slow, but very inclusive of many edge cases.
    // It handles numbers, mixed alphanumeric combinations, and even
    // null, undefined, and Infinity

    var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
      var a = getRowValueByColumnID(rowA, columnId);
      var b = getRowValueByColumnID(rowB, columnId); // Force to strings (or "" for unsupported types)

      a = toString(a);
      b = toString(b); // Split on number groups, but keep the delimiter
      // Then remove falsey split values

      a = a.split(reSplitAlphaNumeric).filter(Boolean);
      b = b.split(reSplitAlphaNumeric).filter(Boolean); // While

      while (a.length && b.length) {
        var aa = a.shift();
        var bb = b.shift();
        var an = parseInt(aa, 10);
        var bn = parseInt(bb, 10);
        var combo = [an, bn].sort(); // Both are string

        if (isNaN(combo[0])) {
          if (aa > bb) {
            return 1;
          }
          if (bb > aa) {
            return -1;
          }
          continue;
        } // One is a string, one is a number

        if (isNaN(combo[1])) {
          return isNaN(an) ? -1 : 1;
        } // Both are numbers

        if (an > bn) {
          return 1;
        }
        if (bn > an) {
          return -1;
        }
      }
      return a.length - b.length;
    };
    function datetime(rowA, rowB, columnId) {
      var a = getRowValueByColumnID(rowA, columnId);
      var b = getRowValueByColumnID(rowB, columnId);
      a = a.getTime();
      b = b.getTime();
      return compareBasic(a, b);
    }
    function basic(rowA, rowB, columnId) {
      var a = getRowValueByColumnID(rowA, columnId);
      var b = getRowValueByColumnID(rowB, columnId);
      return compareBasic(a, b);
    } // Utils

    function compareBasic(a, b) {
      return a === b ? 0 : a > b ? 1 : -1;
    }
    function getRowValueByColumnID(row, columnId) {
      return row.values[columnId];
    }
    function toString(a) {
      if (typeof a === 'number') {
        if (isNaN(a) || a === Infinity || a === -Infinity) {
          return '';
        }
        return String(a);
      }
      if (typeof a === 'string') {
        return a;
      }
      return '';
    }
    var sortTypes = /*#__PURE__*/Object.freeze({
      __proto__: null,
      alphanumeric: alphanumeric,
      datetime: datetime,
      basic: basic
    });
    actions.resetSortBy = 'resetSortBy';
    actions.toggleSortBy = 'toggleSortBy';
    actions.clearSortBy = 'clearSortBy';
    defaultColumn.sortType = 'alphanumeric';
    defaultColumn.sortDescFirst = false;
    var useSortBy = function useSortBy(hooks) {
      hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
      hooks.stateReducers.push(reducer$5);
      hooks.useInstance.push(useInstance$5);
    };
    useSortBy.pluginName = 'useSortBy';
    var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
      var instance = _ref.instance,
        column = _ref.column;
      var _instance$isMultiSort = instance.isMultiSortEvent,
        isMultiSortEvent = _instance$isMultiSort === void 0 ? function (e) {
          return e.shiftKey;
        } : _instance$isMultiSort;
      return [props, {
        onClick: column.canSort ? function (e) {
          e.persist();
          column.toggleSortBy(undefined, !instance.disableMultiSort && isMultiSortEvent(e));
        } : undefined,
        style: {
          cursor: column.canSort ? 'pointer' : undefined
        },
        title: column.canSort ? 'Toggle SortBy' : undefined
      }];
    }; // Reducer

    function reducer$5(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          sortBy: []
        }, state);
      }
      if (action.type === actions.resetSortBy) {
        return _extends({}, state, {
          sortBy: instance.initialState.sortBy || []
        });
      }
      if (action.type === actions.clearSortBy) {
        var sortBy = state.sortBy;
        var newSortBy = sortBy.filter(function (d) {
          return d.id !== action.columnId;
        });
        return _extends({}, state, {
          sortBy: newSortBy
        });
      }
      if (action.type === actions.toggleSortBy) {
        var columnId = action.columnId,
          desc = action.desc,
          multi = action.multi;
        var allColumns = instance.allColumns,
          disableMultiSort = instance.disableMultiSort,
          disableSortRemove = instance.disableSortRemove,
          disableMultiRemove = instance.disableMultiRemove,
          _instance$maxMultiSor = instance.maxMultiSortColCount,
          maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
        var _sortBy = state.sortBy; // Find the column for this columnId

        var column = allColumns.find(function (d) {
          return d.id === columnId;
        });
        var sortDescFirst = column.sortDescFirst; // Find any existing sortBy for this column

        var existingSortBy = _sortBy.find(function (d) {
          return d.id === columnId;
        });
        var existingIndex = _sortBy.findIndex(function (d) {
          return d.id === columnId;
        });
        var hasDescDefined = typeof desc !== 'undefined' && desc !== null;
        var _newSortBy = []; // What should we do with this sort action?

        var sortAction;
        if (!disableMultiSort && multi) {
          if (existingSortBy) {
            sortAction = 'toggle';
          } else {
            sortAction = 'add';
          }
        } else {
          // Normal mode
          if (existingIndex !== _sortBy.length - 1) {
            sortAction = 'replace';
          } else if (existingSortBy) {
            sortAction = 'toggle';
          } else {
            sortAction = 'replace';
          }
        } // Handle toggle states that will remove the sortBy

        if (sortAction === 'toggle' &&
        // Must be toggling
        !disableSortRemove &&
        // If disableSortRemove, disable in general
        !hasDescDefined && (
        // Must not be setting desc
        multi ? !disableMultiRemove : true) && (
        // If multi, don't allow if disableMultiRemove
        existingSortBy &&
        // Finally, detect if it should indeed be removed
        existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
          sortAction = 'remove';
        }
        if (sortAction === 'replace') {
          _newSortBy = [{
            id: columnId,
            desc: hasDescDefined ? desc : sortDescFirst
          }];
        } else if (sortAction === 'add') {
          _newSortBy = [].concat(_sortBy, [{
            id: columnId,
            desc: hasDescDefined ? desc : sortDescFirst
          }]); // Take latest n columns

          _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
        } else if (sortAction === 'toggle') {
          // This flips (or sets) the
          _newSortBy = _sortBy.map(function (d) {
            if (d.id === columnId) {
              return _extends({}, d, {
                desc: hasDescDefined ? desc : !existingSortBy.desc
              });
            }
            return d;
          });
        } else if (sortAction === 'remove') {
          _newSortBy = _sortBy.filter(function (d) {
            return d.id !== columnId;
          });
        }
        return _extends({}, state, {
          sortBy: _newSortBy
        });
      }
    }
    function useInstance$5(instance) {
      var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        allColumns = instance.allColumns,
        _instance$orderByFn = instance.orderByFn,
        orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn,
        userSortTypes = instance.sortTypes,
        manualSortBy = instance.manualSortBy,
        defaultCanSort = instance.defaultCanSort,
        disableSortBy = instance.disableSortBy,
        flatHeaders = instance.flatHeaders,
        sortBy = instance.state.sortBy,
        dispatch = instance.dispatch,
        plugins = instance.plugins,
        getHooks = instance.getHooks,
        _instance$autoResetSo = instance.autoResetSortBy,
        autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
      ensurePluginOrder(plugins, ['useFilters', 'useGlobalFilter', 'useGroupBy', 'usePivotColumns'], 'useSortBy'); // Updates sorting based on a columnId, desc flag and multi flag

      var toggleSortBy = React.useCallback(function (columnId, desc, multi) {
        dispatch({
          type: actions.toggleSortBy,
          columnId: columnId,
          desc: desc,
          multi: multi
        });
      }, [dispatch]); // use reference to avoid memory leak in #1608

      var getInstance = useGetLatest(instance); // Add the getSortByToggleProps method to columns and headers

      flatHeaders.forEach(function (column) {
        var accessor = column.accessor,
          defaultColumnCanSort = column.canSort,
          columnDisableSortBy = column.disableSortBy,
          id = column.id;
        var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : undefined, disableSortBy === true ? false : undefined, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
        column.canSort = canSort;
        if (column.canSort) {
          column.toggleSortBy = function (desc, multi) {
            return toggleSortBy(column.id, desc, multi);
          };
          column.clearSortBy = function () {
            dispatch({
              type: actions.clearSortBy,
              columnId: column.id
            });
          };
        }
        column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
          instance: getInstance(),
          column: column
        });
        var columnSort = sortBy.find(function (d) {
          return d.id === id;
        });
        column.isSorted = !!columnSort;
        column.sortedIndex = sortBy.findIndex(function (d) {
          return d.id === id;
        });
        column.isSortedDesc = column.isSorted ? columnSort.desc : undefined;
      });
      var _React$useMemo = React.useMemo(function () {
          if (manualSortBy || !sortBy.length) {
            return [rows, flatRows];
          }
          var sortedFlatRows = []; // Filter out sortBys that correspond to non existing columns

          var availableSortBy = sortBy.filter(function (sort) {
            return allColumns.find(function (col) {
              return col.id === sort.id;
            });
          });
          var sortData = function sortData(rows) {
            // Use the orderByFn to compose multiple sortBy's together.
            // This will also perform a stable sorting using the row index
            // if needed.
            var sortedData = orderByFn(rows, availableSortBy.map(function (sort) {
              // Support custom sorting methods for each column
              var column = allColumns.find(function (d) {
                return d.id === sort.id;
              });
              if (!column) {
                throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
              }
              var sortType = column.sortType; // Look up sortBy functions in this order:
              // column function
              // column string lookup on user sortType
              // column string lookup on built-in sortType
              // default function
              // default string lookup on user sortType
              // default string lookup on built-in sortType

              var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];
              if (!sortMethod) {
                throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
              } // Return the correct sortFn.
              // This function should always return in ascending order

              return function (a, b) {
                return sortMethod(a, b, sort.id, sort.desc);
              };
            }),
            // Map the directions
            availableSortBy.map(function (sort) {
              // Detect and use the sortInverted option
              var column = allColumns.find(function (d) {
                return d.id === sort.id;
              });
              if (column && column.sortInverted) {
                return sort.desc;
              }
              return !sort.desc;
            })); // If there are sub-rows, sort them

            sortedData.forEach(function (row) {
              sortedFlatRows.push(row);
              if (!row.subRows || row.subRows.length <= 1) {
                return;
              }
              row.subRows = sortData(row.subRows);
            });
            return sortedData;
          };
          return [sortData(rows), sortedFlatRows];
        }, [manualSortBy, sortBy, rows, flatRows, allColumns, orderByFn, userSortTypes]),
        sortedRows = _React$useMemo[0],
        sortedFlatRows = _React$useMemo[1];
      var getAutoResetSortBy = useGetLatest(autoResetSortBy);
      useMountedLayoutEffect(function () {
        if (getAutoResetSortBy()) {
          dispatch({
            type: actions.resetSortBy
          });
        }
      }, [manualSortBy ? null : data]);
      Object.assign(instance, {
        preSortedRows: rows,
        preSortedFlatRows: flatRows,
        sortedRows: sortedRows,
        sortedFlatRows: sortedFlatRows,
        rows: sortedRows,
        flatRows: sortedFlatRows,
        toggleSortBy: toggleSortBy
      });
    }
    function defaultOrderByFn(arr, funcs, dirs) {
      return [].concat(arr).sort(function (rowA, rowB) {
        for (var i = 0; i < funcs.length; i += 1) {
          var sortFn = funcs[i];
          var desc = dirs[i] === false || dirs[i] === 'desc';
          var sortInt = sortFn(rowA, rowB);
          if (sortInt !== 0) {
            return desc ? -sortInt : sortInt;
          }
        }
        return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
      });
    }
    var pluginName = 'usePagination'; // Actions

    actions.resetPage = 'resetPage';
    actions.gotoPage = 'gotoPage';
    actions.setPageSize = 'setPageSize';
    var usePagination = function usePagination(hooks) {
      hooks.stateReducers.push(reducer$6);
      hooks.useInstance.push(useInstance$6);
    };
    usePagination.pluginName = pluginName;
    function reducer$6(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          pageSize: 10,
          pageIndex: 0
        }, state);
      }
      if (action.type === actions.resetPage) {
        return _extends({}, state, {
          pageIndex: instance.initialState.pageIndex || 0
        });
      }
      if (action.type === actions.gotoPage) {
        var pageCount = instance.pageCount,
          page = instance.page;
        var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);
        var canNavigate = false;
        if (newPageIndex > state.pageIndex) {
          // next page
          canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
        } else if (newPageIndex < state.pageIndex) {
          // prev page
          canNavigate = newPageIndex > -1;
        }
        if (!canNavigate) {
          return state;
        }
        return _extends({}, state, {
          pageIndex: newPageIndex
        });
      }
      if (action.type === actions.setPageSize) {
        var pageSize = action.pageSize;
        var topRowIndex = state.pageSize * state.pageIndex;
        var pageIndex = Math.floor(topRowIndex / pageSize);
        return _extends({}, state, {
          pageIndex: pageIndex,
          pageSize: pageSize
        });
      }
    }
    function useInstance$6(instance) {
      var rows = instance.rows,
        _instance$autoResetPa = instance.autoResetPage,
        autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        plugins = instance.plugins,
        userPageCount = instance.pageCount,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$state = instance.state,
        pageSize = _instance$state.pageSize,
        pageIndex = _instance$state.pageIndex,
        expanded = _instance$state.expanded,
        globalFilter = _instance$state.globalFilter,
        filters = _instance$state.filters,
        groupBy = _instance$state.groupBy,
        sortBy = _instance$state.sortBy,
        dispatch = instance.dispatch,
        data = instance.data,
        manualPagination = instance.manualPagination;
      ensurePluginOrder(plugins, ['useGlobalFilter', 'useFilters', 'useGroupBy', 'useSortBy', 'useExpanded'], 'usePagination');
      var getAutoResetPage = useGetLatest(autoResetPage);
      useMountedLayoutEffect(function () {
        if (getAutoResetPage()) {
          dispatch({
            type: actions.resetPage
          });
        }
      }, [dispatch, manualPagination ? null : data, globalFilter, filters, groupBy, sortBy]);
      var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
      var pageOptions = React.useMemo(function () {
        return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function (d, i) {
          return i;
        }) : [];
      }, [pageCount]);
      var page = React.useMemo(function () {
        var page;
        if (manualPagination) {
          page = rows;
        } else {
          var pageStart = pageSize * pageIndex;
          var pageEnd = pageStart + pageSize;
          page = rows.slice(pageStart, pageEnd);
        }
        if (paginateExpandedRows) {
          return page;
        }
        return expandRows(page, {
          manualExpandedKey: manualExpandedKey,
          expanded: expanded,
          expandSubRows: expandSubRows
        });
      }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
      var canPreviousPage = pageIndex > 0;
      var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
      var gotoPage = React.useCallback(function (pageIndex) {
        dispatch({
          type: actions.gotoPage,
          pageIndex: pageIndex
        });
      }, [dispatch]);
      var previousPage = React.useCallback(function () {
        return gotoPage(function (old) {
          return old - 1;
        });
      }, [gotoPage]);
      var nextPage = React.useCallback(function () {
        return gotoPage(function (old) {
          return old + 1;
        });
      }, [gotoPage]);
      var setPageSize = React.useCallback(function (pageSize) {
        dispatch({
          type: actions.setPageSize,
          pageSize: pageSize
        });
      }, [dispatch]);
      Object.assign(instance, {
        pageOptions: pageOptions,
        pageCount: pageCount,
        page: page,
        canPreviousPage: canPreviousPage,
        canNextPage: canNextPage,
        gotoPage: gotoPage,
        previousPage: previousPage,
        nextPage: nextPage,
        setPageSize: setPageSize
      });
    }
    actions.resetPivot = 'resetPivot';
    actions.togglePivot = 'togglePivot';
    var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
      hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
      hooks.stateReducers.push(reducer$7);
      hooks.useInstanceAfterData.push(useInstanceAfterData);
      hooks.allColumns.push(allColumns);
      hooks.accessValue.push(accessValue);
      hooks.materializedColumns.push(materializedColumns);
      hooks.materializedColumnsDeps.push(materializedColumnsDeps);
      hooks.visibleColumns.push(visibleColumns$1);
      hooks.visibleColumnsDeps.push(visibleColumnsDeps);
      hooks.useInstance.push(useInstance$7);
      hooks.prepareRow.push(prepareRow$2);
    };
    _UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
    var defaultPivotColumns = [];
    var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
      var header = _ref.header;
      return [props, {
        onClick: header.canPivot ? function (e) {
          e.persist();
          header.togglePivot();
        } : undefined,
        style: {
          cursor: header.canPivot ? 'pointer' : undefined
        },
        title: 'Toggle Pivot'
      }];
    }; // Reducer

    function reducer$7(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          pivotColumns: defaultPivotColumns
        }, state);
      }
      if (action.type === actions.resetPivot) {
        return _extends({}, state, {
          pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
        });
      }
      if (action.type === actions.togglePivot) {
        var columnId = action.columnId,
          setPivot = action.value;
        var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);
        if (resolvedPivot) {
          return _extends({}, state, {
            pivotColumns: [].concat(state.pivotColumns, [columnId])
          });
        }
        return _extends({}, state, {
          pivotColumns: state.pivotColumns.filter(function (d) {
            return d !== columnId;
          })
        });
      }
    }
    function useInstanceAfterData(instance) {
      instance.allColumns.forEach(function (column) {
        column.isPivotSource = instance.state.pivotColumns.includes(column.id);
      });
    }
    function allColumns(columns, _ref2) {
      var instance = _ref2.instance;
      columns.forEach(function (column) {
        column.isPivotSource = instance.state.pivotColumns.includes(column.id);
        column.uniqueValues = new Set();
      });
      return columns;
    }
    function accessValue(value, _ref3) {
      var column = _ref3.column;
      if (column.uniqueValues && typeof value !== 'undefined') {
        column.uniqueValues.add(value);
      }
      return value;
    }
    function materializedColumns(materialized, _ref4) {
      var instance = _ref4.instance;
      var allColumns = instance.allColumns,
        state = instance.state;
      if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
        return materialized;
      }
      var pivotColumns = state.pivotColumns.map(function (id) {
        return allColumns.find(function (d) {
          return d.id === id;
        });
      }).filter(Boolean);
      var sourceColumns = allColumns.filter(function (d) {
        return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
      });
      var buildPivotColumns = function buildPivotColumns(depth, parent, pivotFilters) {
        if (depth === void 0) {
          depth = 0;
        }
        if (pivotFilters === void 0) {
          pivotFilters = [];
        }
        var pivotColumn = pivotColumns[depth];
        if (!pivotColumn) {
          return sourceColumns.map(function (sourceColumn) {
            // TODO: We could offer support here for renesting pivoted
            // columns inside copies of their header groups. For now,
            // that seems like it would be (1) overkill on nesting, considering
            // you already get nesting for every pivot level and (2)
            // really hard. :)
            return _extends({}, sourceColumn, {
              canPivot: false,
              isPivoted: true,
              parent: parent,
              depth: depth,
              id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
              accessor: function accessor(originalRow, i, row) {
                if (pivotFilters.every(function (filter) {
                  return filter(row);
                })) {
                  return row.values[sourceColumn.id];
                }
              }
            });
          });
        }
        var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
        return uniqueValues.map(function (uniqueValue) {
          var columnGroup = _extends({}, pivotColumn, {
            Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
            isPivotGroup: true,
            parent: parent,
            depth: depth,
            id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
            pivotValue: uniqueValue
          });
          columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function (row) {
            return row.values[pivotColumn.id] === uniqueValue;
          }]));
          return columnGroup;
        });
      };
      var newMaterialized = flattenColumns(buildPivotColumns());
      return [].concat(materialized, newMaterialized);
    }
    function materializedColumnsDeps(deps, _ref5) {
      var _ref5$instance$state = _ref5.instance.state,
        pivotColumns = _ref5$instance$state.pivotColumns,
        groupBy = _ref5$instance$state.groupBy;
      return [].concat(deps, [pivotColumns, groupBy]);
    }
    function visibleColumns$1(visibleColumns, _ref6) {
      var state = _ref6.instance.state;
      visibleColumns = visibleColumns.filter(function (d) {
        return !d.isPivotSource;
      });
      if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
        visibleColumns = visibleColumns.filter(function (column) {
          return column.isGrouped || column.isPivoted;
        });
      }
      return visibleColumns;
    }
    function visibleColumnsDeps(deps, _ref7) {
      var instance = _ref7.instance;
      return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
    }
    function useInstance$7(instance) {
      var columns = instance.columns,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        dispatch = instance.dispatch,
        _instance$autoResetPi = instance.autoResetPivot,
        autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
        manaulPivot = instance.manaulPivot,
        disablePivot = instance.disablePivot,
        defaultCanPivot = instance.defaultCanPivot;
      ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
      var getInstance = useGetLatest(instance);
      allColumns.forEach(function (column) {
        var accessor = column.accessor,
          defaultColumnPivot = column.defaultPivot,
          columnDisablePivot = column.disablePivot;
        column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);
        if (column.canPivot) {
          column.togglePivot = function () {
            return instance.togglePivot(column.id);
          };
        }
        column.Aggregated = column.Aggregated || column.Cell;
      });
      var togglePivot = function togglePivot(columnId, value) {
        dispatch({
          type: actions.togglePivot,
          columnId: columnId,
          value: value
        });
      };
      flatHeaders.forEach(function (header) {
        header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
          instance: getInstance(),
          header: header
        });
      });
      var getAutoResetPivot = useGetLatest(autoResetPivot);
      useMountedLayoutEffect(function () {
        if (getAutoResetPivot()) {
          dispatch({
            type: actions.resetPivot
          });
        }
      }, [dispatch, manaulPivot ? null : columns]);
      Object.assign(instance, {
        togglePivot: togglePivot
      });
    }
    function prepareRow$2(row) {
      row.allCells.forEach(function (cell) {
        // Grouped cells are in the pivotColumns and the pivot cell for the row
        cell.isPivoted = cell.column.isPivoted;
      });
    }
    var pluginName$1 = 'useRowSelect'; // Actions

    actions.resetSelectedRows = 'resetSelectedRows';
    actions.toggleAllRowsSelected = 'toggleAllRowsSelected';
    actions.toggleRowSelected = 'toggleRowSelected';
    var useRowSelect = function useRowSelect(hooks) {
      hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
      hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
      hooks.stateReducers.push(reducer$8);
      hooks.useInstance.push(useInstance$8);
      hooks.prepareRow.push(prepareRow$3);
    };
    useRowSelect.pluginName = pluginName$1;
    var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
      var instance = _ref.instance,
        row = _ref.row;
      var _instance$manualRowSe = instance.manualRowSelectedKey,
        manualRowSelectedKey = _instance$manualRowSe === void 0 ? 'isSelected' : _instance$manualRowSe;
      var checked = false;
      if (row.original && row.original[manualRowSelectedKey]) {
        checked = true;
      } else {
        checked = row.isSelected;
      }
      return [props, {
        onChange: function onChange(e) {
          row.toggleRowSelected(e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: checked,
        title: 'Toggle Row Selected',
        indeterminate: row.isSomeSelected
      }];
    };
    var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
      var instance = _ref2.instance;
      return [props, {
        onChange: function onChange(e) {
          instance.toggleAllRowsSelected(e.target.checked);
        },
        style: {
          cursor: 'pointer'
        },
        checked: instance.isAllRowsSelected,
        title: 'Toggle All Rows Selected',
        indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
      }];
    };
    function reducer$8(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          selectedRowIds: {}
        }, state);
      }
      if (action.type === actions.resetSelectedRows) {
        return _extends({}, state, {
          selectedRowIds: instance.initialState.selectedRowIds || {}
        });
      }
      if (action.type === actions.toggleAllRowsSelected) {
        var setSelected = action.value;
        var isAllRowsSelected = instance.isAllRowsSelected,
          rowsById = instance.rowsById,
          _instance$nonGroupedR = instance.nonGroupedRowsById,
          nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
        var selectAll = typeof setSelected !== 'undefined' ? setSelected : !isAllRowsSelected; // Only remove/add the rows that are visible on the screen
        //  Leave all the other rows that are selected alone.

        var selectedRowIds = Object.assign({}, state.selectedRowIds);
        if (selectAll) {
          Object.keys(nonGroupedRowsById).forEach(function (rowId) {
            selectedRowIds[rowId] = true;
          });
        } else {
          Object.keys(nonGroupedRowsById).forEach(function (rowId) {
            delete selectedRowIds[rowId];
          });
        }
        return _extends({}, state, {
          selectedRowIds: selectedRowIds
        });
      }
      if (action.type === actions.toggleRowSelected) {
        var id = action.id,
          _setSelected = action.value;
        var _rowsById = instance.rowsById,
          _instance$selectSubRo = instance.selectSubRows,
          selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo; // Join the ids of deep rows
        // to make a key, then manage all of the keys
        // in a flat object

        var row = _rowsById[id];
        var isSelected = row.isSelected;
        var shouldExist = typeof _setSelected !== 'undefined' ? _setSelected : !isSelected;
        if (isSelected === shouldExist) {
          return state;
        }
        var newSelectedRowIds = _extends({}, state.selectedRowIds);
        var handleRowById = function handleRowById(id) {
          var row = _rowsById[id];
          if (!row.isGrouped) {
            if (shouldExist) {
              newSelectedRowIds[id] = true;
            } else {
              delete newSelectedRowIds[id];
            }
          }
          if (selectSubRows && row.subRows) {
            return row.subRows.forEach(function (row) {
              return handleRowById(row.id);
            });
          }
        };
        handleRowById(id);
        return _extends({}, state, {
          selectedRowIds: newSelectedRowIds
        });
      }
    }
    function useInstance$8(instance) {
      var data = instance.data,
        rows = instance.rows,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        rowsById = instance.rowsById,
        _instance$nonGroupedR2 = instance.nonGroupedRowsById,
        nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2,
        _instance$autoResetSe = instance.autoResetSelectedRows,
        autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe,
        selectedRowIds = instance.state.selectedRowIds,
        _instance$selectSubRo2 = instance.selectSubRows,
        selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2,
        dispatch = instance.dispatch;
      ensurePluginOrder(plugins, ['useFilters', 'useGroupBy', 'useSortBy'], 'useRowSelect');
      var selectedFlatRows = React.useMemo(function () {
        var selectedFlatRows = [];
        rows.forEach(function (row) {
          var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds) : !!selectedRowIds[row.id];
          row.isSelected = !!isSelected;
          row.isSomeSelected = isSelected === null;
          if (isSelected) {
            selectedFlatRows.push(row);
          }
        });
        return selectedFlatRows;
      }, [rows, selectSubRows, selectedRowIds]);
      var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
      if (isAllRowsSelected) {
        if (Object.keys(nonGroupedRowsById).some(function (id) {
          return !selectedRowIds[id];
        })) {
          isAllRowsSelected = false;
        }
      }
      var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
      useMountedLayoutEffect(function () {
        if (getAutoResetSelectedRows()) {
          dispatch({
            type: actions.resetSelectedRows
          });
        }
      }, [dispatch, data]);
      var toggleAllRowsSelected = React.useCallback(function (value) {
        return dispatch({
          type: actions.toggleAllRowsSelected,
          value: value
        });
      }, [dispatch]);
      var toggleRowSelected = React.useCallback(function (id, value) {
        return dispatch({
          type: actions.toggleRowSelected,
          id: id,
          value: value
        });
      }, [dispatch]);
      var getInstance = useGetLatest(instance);
      var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
        instance: getInstance()
      });
      Object.assign(instance, {
        selectedFlatRows: selectedFlatRows,
        isAllRowsSelected: isAllRowsSelected,
        toggleRowSelected: toggleRowSelected,
        toggleAllRowsSelected: toggleAllRowsSelected,
        getToggleAllRowsSelectedProps: getToggleAllRowsSelectedProps
      });
    }
    function prepareRow$3(row, _ref3) {
      var instance = _ref3.instance;
      row.toggleRowSelected = function (set) {
        return instance.toggleRowSelected(row.id, set);
      };
      row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
        instance: instance,
        row: row
      });
    }
    function getRowIsSelected(row, selectedRowIds) {
      if (selectedRowIds[row.id]) {
        return true;
      }
      if (row.subRows && row.subRows.length) {
        var allChildrenSelected = true;
        var someSelected = false;
        row.subRows.forEach(function (subRow) {
          // Bail out early if we know both of these
          if (someSelected && !allChildrenSelected) {
            return;
          }
          if (getRowIsSelected(subRow, selectedRowIds)) {
            someSelected = true;
          } else {
            allChildrenSelected = false;
          }
        });
        return allChildrenSelected ? true : someSelected ? null : false;
      }
      return false;
    }
    var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(originalRow) {
      return {};
    };
    var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(originalRow) {
      return {};
    }; // Actions

    actions.setRowState = 'setRowState';
    actions.setCellState = 'setCellState';
    actions.resetRowState = 'resetRowState';
    var useRowState = function useRowState(hooks) {
      hooks.stateReducers.push(reducer$9);
      hooks.useInstance.push(useInstance$9);
      hooks.prepareRow.push(prepareRow$4);
    };
    useRowState.pluginName = 'useRowState';
    function reducer$9(state, action, previousState, instance) {
      var _instance$initialRowS = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
        _instance$initialCell = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
        rowsById = instance.rowsById;
      if (action.type === actions.init) {
        return _extends({
          rowState: {}
        }, state);
      }
      if (action.type === actions.resetRowState) {
        return _extends({}, state, {
          rowState: instance.initialState.rowState || {}
        });
      }
      if (action.type === actions.setRowState) {
        var _extends2;
        var rowId = action.rowId,
          value = action.value;
        var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId].original);
        return _extends({}, state, {
          rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2))
        });
      }
      if (action.type === actions.setCellState) {
        var _oldRowState$cellStat, _extends3, _extends4;
        var _rowId = action.rowId,
          columnId = action.columnId,
          _value = action.value;
        var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId].original);
        var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor(rowsById[_rowId].original);
        return _extends({}, state, {
          rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, {
            cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3))
          }), _extends4))
        });
      }
    }
    function useInstance$9(instance) {
      var _instance$autoResetRo = instance.autoResetRowState,
        autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
        data = instance.data,
        dispatch = instance.dispatch;
      var setRowState = React.useCallback(function (rowId, value) {
        return dispatch({
          type: actions.setRowState,
          rowId: rowId,
          value: value
        });
      }, [dispatch]);
      var setCellState = React.useCallback(function (rowId, columnId, value) {
        return dispatch({
          type: actions.setCellState,
          rowId: rowId,
          columnId: columnId,
          value: value
        });
      }, [dispatch]);
      var getAutoResetRowState = useGetLatest(autoResetRowState);
      useMountedLayoutEffect(function () {
        if (getAutoResetRowState()) {
          dispatch({
            type: actions.resetRowState
          });
        }
      }, [data]);
      Object.assign(instance, {
        setRowState: setRowState,
        setCellState: setCellState
      });
    }
    function prepareRow$4(row, _ref) {
      var instance = _ref.instance;
      var _instance$initialRowS2 = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
        _instance$initialCell2 = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
        rowState = instance.state.rowState;
      if (row.original) {
        row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row.original);
        row.setState = function (updater) {
          return instance.setRowState(row.id, updater);
        };
        row.cells.forEach(function (cell) {
          if (!row.state.cellState) {
            row.state.cellState = {};
          }
          cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(row.original);
          cell.setState = function (updater) {
            return instance.setCellState(row.id, cell.column.id, updater);
          };
        });
      }
    }
    actions.resetColumnOrder = 'resetColumnOrder';
    actions.setColumnOrder = 'setColumnOrder';
    var useColumnOrder = function useColumnOrder(hooks) {
      hooks.stateReducers.push(reducer$a);
      hooks.visibleColumnsDeps.push(function (deps, _ref) {
        var instance = _ref.instance;
        return [].concat(deps, [instance.state.columnOrder]);
      });
      hooks.visibleColumns.push(visibleColumns$2);
      hooks.useInstance.push(useInstance$a);
    };
    useColumnOrder.pluginName = 'useColumnOrder';
    function reducer$a(state, action, previousState, instance) {
      if (action.type === actions.init) {
        return _extends({
          columnOrder: []
        }, state);
      }
      if (action.type === actions.resetColumnOrder) {
        return _extends({}, state, {
          columnOrder: instance.initialState.columnOrder || []
        });
      }
      if (action.type === actions.setColumnOrder) {
        return _extends({}, state, {
          columnOrder: functionalUpdate(action.columnOrder, state.columnOrder)
        });
      }
    }
    function visibleColumns$2(columns, _ref2) {
      var columnOrder = _ref2.instance.state.columnOrder;

      // If there is no order, return the normal columns
      if (!columnOrder || !columnOrder.length) {
        return columns;
      }
      var columnOrderCopy = [].concat(columnOrder); // If there is an order, make a copy of the columns

      var columnsCopy = [].concat(columns); // And make a new ordered array of the columns

      var columnsInOrder = []; // Loop over the columns and place them in order into the new array

      var _loop = function _loop() {
        var targetColumnId = columnOrderCopy.shift();
        var foundIndex = columnsCopy.findIndex(function (d) {
          return d.id === targetColumnId;
        });
        if (foundIndex > -1) {
          columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
        }
      };
      while (columnsCopy.length && columnOrderCopy.length) {
        _loop();
      } // If there are any columns left, add them to the end

      return [].concat(columnsInOrder, columnsCopy);
    }
    function useInstance$a(instance) {
      var dispatch = instance.dispatch;
      instance.setColumnOrder = React.useCallback(function (columnOrder) {
        return dispatch({
          type: actions.setColumnOrder,
          columnOrder: columnOrder
        });
      }, [dispatch]);
    }
    defaultColumn.canResize = true; // Actions

    actions.columnStartResizing = 'columnStartResizing';
    actions.columnResizing = 'columnResizing';
    actions.columnDoneResizing = 'columnDoneResizing';
    var useResizeColumns = function useResizeColumns(hooks) {
      hooks.getResizerProps = [defaultGetResizerProps];
      hooks.getHeaderProps.push({
        style: {
          position: 'relative'
        }
      });
      hooks.stateReducers.push(reducer$b);
      hooks.useInstance.push(useInstance$b);
      hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
    };
    var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
      var instance = _ref.instance,
        header = _ref.header;
      var dispatch = instance.dispatch;
      var onResizeStart = function onResizeStart(e, header) {
        var isTouchEvent = false;
        if (e.type === 'touchstart') {
          // lets not respond to multiple touches (e.g. 2 or 3 fingers)
          if (e.touches && e.touches.length > 1) {
            return;
          }
          isTouchEvent = true;
        }
        var headersToResize = getLeafHeaders(header);
        var headerIdWidths = headersToResize.map(function (d) {
          return [d.id, d.totalWidth];
        });
        var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;
        var dispatchMove = function dispatchMove(clientXPos) {
          dispatch({
            type: actions.columnResizing,
            clientX: clientXPos
          });
        };
        var dispatchEnd = function dispatchEnd() {
          return dispatch({
            type: actions.columnDoneResizing
          });
        };
        var handlersAndEvents = {
          mouse: {
            moveEvent: 'mousemove',
            moveHandler: function moveHandler(e) {
              return dispatchMove(e.clientX);
            },
            upEvent: 'mouseup',
            upHandler: function upHandler(e) {
              document.removeEventListener('mousemove', handlersAndEvents.mouse.moveHandler);
              document.removeEventListener('mouseup', handlersAndEvents.mouse.upHandler);
              dispatchEnd();
            }
          },
          touch: {
            moveEvent: 'touchmove',
            moveHandler: function moveHandler(e) {
              if (e.cancelable) {
                e.preventDefault();
                e.stopPropagation();
              }
              dispatchMove(e.touches[0].clientX);
              return false;
            },
            upEvent: 'touchend',
            upHandler: function upHandler(e) {
              document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
              document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
              dispatchEnd();
            }
          }
        };
        var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
        var passiveIfSupported = passiveEventSupported() ? {
          passive: false
        } : false;
        document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
        document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
        dispatch({
          type: actions.columnStartResizing,
          columnId: header.id,
          columnWidth: header.totalWidth,
          headerIdWidths: headerIdWidths,
          clientX: clientX
        });
      };
      return [props, {
        onMouseDown: function onMouseDown(e) {
          return e.persist() || onResizeStart(e, header);
        },
        onTouchStart: function onTouchStart(e) {
          return e.persist() || onResizeStart(e, header);
        },
        style: {
          cursor: 'ew-resize'
        },
        draggable: false,
        role: 'separator'
      }];
    };
    useResizeColumns.pluginName = 'useResizeColumns';
    function reducer$b(state, action) {
      if (action.type === actions.init) {
        return _extends({
          columnResizing: {
            columnWidths: {}
          }
        }, state);
      }
      if (action.type === actions.columnStartResizing) {
        var clientX = action.clientX,
          columnId = action.columnId,
          columnWidth = action.columnWidth,
          headerIdWidths = action.headerIdWidths;
        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            startX: clientX,
            headerIdWidths: headerIdWidths,
            columnWidth: columnWidth,
            isResizingColumn: columnId
          })
        });
      }
      if (action.type === actions.columnResizing) {
        var _clientX = action.clientX;
        var _state$columnResizing = state.columnResizing,
          startX = _state$columnResizing.startX,
          _columnWidth = _state$columnResizing.columnWidth,
          _headerIdWidths = _state$columnResizing.headerIdWidths;
        var deltaX = _clientX - startX;
        var percentageDeltaX = deltaX / _columnWidth;
        var newColumnWidths = {};
        _headerIdWidths.forEach(function (_ref2) {
          var headerId = _ref2[0],
            headerWidth = _ref2[1];
          newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
        });
        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths)
          })
        });
      }
      if (action.type === actions.columnDoneResizing) {
        return _extends({}, state, {
          columnResizing: _extends({}, state.columnResizing, {
            startX: null,
            isResizingColumn: null
          })
        });
      }
    }
    var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
      var flatHeaders = instance.flatHeaders,
        disableResizing = instance.disableResizing,
        getHooks = instance.getHooks,
        columnResizing = instance.state.columnResizing;
      var getInstance = useGetLatest(instance);
      flatHeaders.forEach(function (header) {
        var canResize = getFirstDefined(header.disableResizing === true ? false : undefined, disableResizing === true ? false : undefined, true);
        header.canResize = canResize;
        header.width = columnResizing.columnWidths[header.id] || header.width;
        header.isResizing = columnResizing.isResizingColumn === header.id;
        if (canResize) {
          header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
            instance: getInstance(),
            header: header
          });
        }
      });
    };
    function useInstance$b(_ref3) {
      var plugins = _ref3.plugins;
      ensurePluginOrder(plugins, ['useAbsoluteLayout'], 'useResizeColumns');
    }
    function getLeafHeaders(header) {
      var leafHeaders = [];
      var recurseHeader = function recurseHeader(header) {
        if (header.columns && header.columns.length) {
          header.columns.map(recurseHeader);
        }
        leafHeaders.push(header);
      };
      recurseHeader(header);
      return leafHeaders;
    }
    var cellStyles = {
      position: 'absolute',
      top: 0
    };
    var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
      hooks.getTableBodyProps.push(getRowStyles);
      hooks.getRowProps.push(getRowStyles);
      hooks.getHeaderGroupProps.push(getRowStyles);
      hooks.getFooterGroupProps.push(getRowStyles);
      hooks.getHeaderProps.push(function (props, _ref) {
        var column = _ref.column;
        return [props, {
          style: _extends({}, cellStyles, {
            left: column.totalLeft + "px",
            width: column.totalWidth + "px"
          })
        }];
      });
      hooks.getCellProps.push(function (props, _ref2) {
        var cell = _ref2.cell;
        return [props, {
          style: _extends({}, cellStyles, {
            left: cell.column.totalLeft + "px",
            width: cell.column.totalWidth + "px"
          })
        }];
      });
      hooks.getFooterProps.push(function (props, _ref3) {
        var column = _ref3.column;
        return [props, {
          style: _extends({}, cellStyles, {
            left: column.totalLeft + "px",
            width: column.totalWidth + "px"
          })
        }];
      });
    };
    useAbsoluteLayout.pluginName = 'useAbsoluteLayout';
    var getRowStyles = function getRowStyles(props, _ref4) {
      var instance = _ref4.instance;
      return [props, {
        style: {
          position: 'relative',
          width: instance.totalColumnsWidth + "px"
        }
      }];
    };
    var cellStyles$1 = {
      display: 'inline-block',
      boxSizing: 'border-box'
    };
    var getRowStyles$1 = function getRowStyles(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        style: {
          display: 'flex',
          width: instance.totalColumnsWidth + "px"
        }
      }];
    };
    var useBlockLayout = function useBlockLayout(hooks) {
      hooks.getRowProps.push(getRowStyles$1);
      hooks.getHeaderGroupProps.push(getRowStyles$1);
      hooks.getFooterGroupProps.push(getRowStyles$1);
      hooks.getHeaderProps.push(function (props, _ref2) {
        var column = _ref2.column;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: column.totalWidth + "px"
          })
        }];
      });
      hooks.getCellProps.push(function (props, _ref3) {
        var cell = _ref3.cell;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: cell.column.totalWidth + "px"
          })
        }];
      });
      hooks.getFooterProps.push(function (props, _ref4) {
        var column = _ref4.column;
        return [props, {
          style: _extends({}, cellStyles$1, {
            width: column.totalWidth + "px"
          })
        }];
      });
    };
    useBlockLayout.pluginName = 'useBlockLayout';
    function useFlexLayout(hooks) {
      hooks.getTableProps.push(getTableProps);
      hooks.getRowProps.push(getRowStyles$2);
      hooks.getHeaderGroupProps.push(getRowStyles$2);
      hooks.getFooterGroupProps.push(getRowStyles$2);
      hooks.getHeaderProps.push(getHeaderProps);
      hooks.getCellProps.push(getCellProps);
      hooks.getFooterProps.push(getFooterProps);
    }
    useFlexLayout.pluginName = 'useFlexLayout';
    var getTableProps = function getTableProps(props, _ref) {
      var instance = _ref.instance;
      return [props, {
        style: {
          minWidth: instance.totalColumnsWidth + "px"
        }
      }];
    };
    var getRowStyles$2 = function getRowStyles(props, _ref2) {
      var instance = _ref2.instance;
      return [props, {
        style: {
          display: 'flex',
          flex: '1 0 auto',
          minWidth: instance.totalColumnsMinWidth + "px"
        }
      }];
    };
    var getHeaderProps = function getHeaderProps(props, _ref3) {
      var column = _ref3.column;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
          minWidth: column.totalMinWidth + "px",
          width: column.totalWidth + "px"
        }
      }];
    };
    var getCellProps = function getCellProps(props, _ref4) {
      var cell = _ref4.cell;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: cell.column.totalFlexWidth + " 0 auto",
          minWidth: cell.column.totalMinWidth + "px",
          width: cell.column.totalWidth + "px"
        }
      }];
    };
    var getFooterProps = function getFooterProps(props, _ref5) {
      var column = _ref5.column;
      return [props, {
        style: {
          boxSizing: 'border-box',
          flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
          minWidth: column.totalMinWidth + "px",
          width: column.totalWidth + "px"
        }
      }];
    };
    exports._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
    exports.actions = actions;
    exports.defaultColumn = defaultColumn;
    exports.defaultGroupByFn = defaultGroupByFn;
    exports.defaultOrderByFn = defaultOrderByFn;
    exports.ensurePluginOrder = ensurePluginOrder;
    exports.flexRender = flexRender;
    exports.functionalUpdate = functionalUpdate;
    exports.loopHooks = loopHooks;
    exports.makePropGetter = makePropGetter;
    exports.makeRenderer = makeRenderer;
    exports.reduceHooks = reduceHooks;
    exports.safeUseLayoutEffect = safeUseLayoutEffect;
    exports.useAbsoluteLayout = useAbsoluteLayout;
    exports.useAsyncDebounce = useAsyncDebounce;
    exports.useBlockLayout = useBlockLayout;
    exports.useColumnOrder = useColumnOrder;
    exports.useExpanded = useExpanded;
    exports.useFilters = useFilters;
    exports.useFlexLayout = useFlexLayout;
    exports.useGetLatest = useGetLatest;
    exports.useGlobalFilter = useGlobalFilter;
    exports.useGroupBy = useGroupBy;
    exports.useMountedLayoutEffect = useMountedLayoutEffect;
    exports.usePagination = usePagination;
    exports.useResizeColumns = useResizeColumns;
    exports.useRowSelect = useRowSelect;
    exports.useRowState = useRowState;
    exports.useSortBy = useSortBy;
    exports.useTable = useTable;
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
  });
});
unwrapExports(reactTable_development);
var reactTable = createCommonjsModule(function (module) {
  {
    module.exports = reactTable_development;
  }
});
var reactTable_1 = reactTable.useTable;
var reactTable_2 = reactTable.useSortBy;
var reactTable_3 = reactTable.useFilters;
var reactTable_4 = reactTable.useGlobalFilter;
var reactTable_5 = reactTable.usePagination;
var cellBorder = "1px solid ".concat(ui.greyLight[100]);
var sortedCellBorder = "3px solid ".concat(ui.coreBlue[500]);
var scrollShadowWidth = '10px';
var white = ui.white[100];
var transparent = 'rgba(255, 255, 255, 0)';
var fontFamily = 'Circular, Helvetica, Arial, sans-serif';
var scrollerStyle = function scrollerStyle(colWidth, paginationHeight) {
  var margin = paginationHeight > 0 ? {
    marginBottom: "".concat(paginationHeight, "px")
  } : {};
  return _objectSpread3({
    overflowX: 'scroll',
    backgroundImage: "\n    // covers the shadows\n  linear-gradient(\n      to right,\n      ".concat(white, " 0%,\n      ").concat(white, " calc(").concat(colWidth, "px + ").concat(scrollShadowWidth, "),\n      ").concat(transparent, " calc(").concat(colWidth, "px + (2 * ").concat(scrollShadowWidth, "))\n    ),\n    linear-gradient(\n      to left,\n      ").concat(white, " 0%,\n      ").concat(white, " ").concat(scrollShadowWidth, ",\n      ").concat(transparent, " calc(2 * ").concat(scrollShadowWidth, ")\n    ),\n    // Scroll shadows\n  linear-gradient(\n      to right,\n      ").concat(white, " 0%,\n      ").concat(white, " ").concat(colWidth, "px,\n      ").concat(ui.greyLight[100], " ").concat(colWidth, "px,\n      ").concat(transparent, " calc(").concat(colWidth, "px + ").concat(scrollShadowWidth, ")\n    ),\n    linear-gradient(\n      to left,\n      ").concat(ui.greyLight[100], " 0%,\n      ").concat(transparent, " ").concat(scrollShadowWidth, "\n    )\n    "),
    backgroundAttachment: 'local, local, scroll, scroll',
    backgroundColor: white
  }, margin);
};
var borderWidth = 1;
var borderStyle = function borderStyle(topHeightOffset, tableHeight) {
  return {
    position: 'relative',
    '&:after': {
      content: "''",
      position: 'absolute',
      left: -1 * borderWidth,
      top: topHeightOffset - borderWidth,
      border: "".concat(borderWidth, "px solid ").concat(ui.greyLight[500]),
      width: '100%',
      boxSizing: 'content-box',
      height: "calc(100% - ".concat(topHeightOffset, "px)"),
      pointerEvents: 'none'
    }
  };
};
var tableStyles = {
  borderCollapse: 'separate',
  borderSpacing: 0
};
var selectedColTd = {
  backgroundColor: 'rgba(221, 221, 221, 0.3)'
};
var tdStyle = {
  padding: 0,
  margin: 0,
  borderBottom: cellBorder
};
var stickyStyle = {
  left: 0,
  zIndex: 1,
  position: 'sticky',
  backgroundColor: white
};
var paginationWrapper = {
  position: 'absolute',
  width: '100%'
};
var selectedColTh = /*#__PURE__*/css({
  fontWeight: 700,
  borderBottom: sortedCellBorder,
  backgroundColor: 'rgba(221, 221, 221, 0.3)'
}, ";label:selectedColTh;");
var thStyles = /*#__PURE__*/css({
  fontFamily: 'Circular, Helvetica, Arial, sans-serif',
  fontWeight: 400,
  borderBottom: cellBorder
}, ";label:thStyles;");
var tableHeaderProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * column object passed through from the table component.
   */
  column: propTypes.object.isRequired,
  /**
   * generated by react-table and passed through to be spread
   * on the th tag
   */
  thProps: propTypes.object,
  /**
   * generated by react-table if the table is sortable.
   * not to be confused with column.onClick which is user defined
   */
  onClick: propTypes.func
});
var sortDirections = {
  none: 'none',
  ascending: 'ascending',
  descending: 'descending'
};
var generateAriaLabel = function generateAriaLabel(label, currentSortingOrder) {
  if (currentSortingOrder === sortDirections.none) {
    return "sort by ".concat(label, " ascending");
  }
  if (currentSortingOrder === sortDirections.ascending) {
    return "sort by ".concat(label, " descending");
  }
  if (currentSortingOrder === sortDirections.descending) {
    return "stop sorting by ".concat(label);
  }
};
var TableHeader = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  TableHeader.displayName = 'TableHeader';
  var _onClick = props.onClick,
    column = props.column,
    thProps = props.thProps;
  var alignAttr = {};
  var refProp = {};
  if (column.fixed) {
    alignAttr.align = 'left';
    refProp.ref = ref;
  }
  var ariaProps = _objectSpread3({}, column.ariaProps);
  var ariaSorted = {};
  if (!column.disabledSortBy) {
    var currentSort = column.isSorted ? column.isSortedDesc ? sortDirections.descending : sortDirections.ascending : sortDirections.none;
    ariaSorted['aria-sort'] = currentSort;
    /** button aria props */

    if (!ariaProps['aria-label']) {
      if (typeof column.Header === 'string') {
        ariaProps['aria-label'] = generateAriaLabel(column.Header, currentSort);
      } else {
        if (column.label) {
          ariaProps['aria-label'] = generateAriaLabel(column.label, currentSort);
        }
      }
    }
  }
  var title = thProps.title,
    strippedThProps = _objectWithoutProperties3(thProps, _excluded13);
  return jsx("th", _extends({}, strippedThProps, {
    css: /*#__PURE__*/css([thStyles, column.isSorted && selectedColTh, column.fixed && stickyStyle], ";label:TableHeader;")
  }, alignAttr, refProp, {
    scope: "col"
  }, ariaSorted, {
    role: "columnheader"
  }), _onClick || column.onClick ? jsx(Button, {
    flavor: Button.flavor.incognito,
    onClick: function onClick(e) {
      if (column.onClick) {
        column.onClick(e);
      }
      if (_onClick) {
        _onClick(e);
      }
    },
    ariaProps: ariaProps,
    __css: {
      display: 'inline-flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    dataProps: column.dataProps,
    ref: column.ref
  }, column.render('Header'), !column.disableSortBy && jsx(SortingArrows, {
    isSorted: column.isSorted,
    isSortedDesc: column.isSortedDesc
  })) : column.render('Header'));
});
TableHeader.propTypes = tableHeaderProps;
TableHeader.defaultProps = {
  thProps: {}
};
TableHeader.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableHeader",
  "props": {
    "thProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "generated by react-table and passed through to be spread\non the th tag"
    },
    "column": {
      "type": {
        "name": "object"
      },
      "required": true,
      "description": "column object passed through from the table component."
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "generated by react-table if the table is sortable.\nnot to be confused with column.onClick which is user defined"
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var tableAriaLiveProps = {
  sortBy: propTypes.arrayOf(propTypes.shape({
    desc: propTypes.bool,
    id: propTypes.string
  }))
};
var generateSortByText = function generateSortByText() {
  var sortBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var text = 'Not currently sorted';
  if (sortBy.length > 0) {
    var joiner = ', ';
    var desc = sortBy.filter(function (col) {
      return col.desc;
    }).map(function (col) {
      return col.id;
    }).join(joiner);
    var ascending = sortBy.filter(function (col) {
      return !col.desc;
    }).map(function (col) {
      return col.id;
    }).join(joiner);
    if (desc.length > 0 && ascending.length > 0) {
      text = "Currently sorted by ".concat(desc, " in descending order and ").concat(ascending, " in ascending order.");
    } else if (desc.length > 0) {
      text = "Currently sorted by ".concat(desc, " in descending order.");
    } else {
      text = "Currently sorted by ".concat(ascending, " in ascending order.");
    }
  }
  return text;
};
var TableAriaLive = function TableAriaLive(props) {
  var text = props.text;
  return jsx("span", {
    "aria-live": "polite",
    css: hiddenStyle
  }, text);
};
TableAriaLive.propTypes = tableAriaLiveProps;
TableAriaLive.defaultProps = {
  sortBy: [],
  filterColumns: []
};
TableAriaLive.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableAriaLive",
  "props": {
    "sortBy": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "desc": {
              "name": "bool",
              "required": false
            },
            "id": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "filterColumns": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "required": false
    }
  }
};
var controlWrapperStyle = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  left: 0,
  backgroundColor: 'white',
  position: 'sticky',
  paddingBottom: '8px'
};
var tableLabelStyle = _objectSpread3({
  fontFamily: fontFamily,
  margin: 0,
  color: ui.greyDark[700],
  lineHeight: 1.2
}, heading4Obj);
var tableDescStyle = _objectSpread3({
  fontFamily: fontFamily,
  margin: '4px 0 0',
  color: ui.greyDark[700],
  lineHeight: 1.5
}, heading5Obj);
var tableFilterContainer = function tableFilterContainer(reverse) {
  var _ref23;
  return _ref23 = {
    display: 'flex',
    flexDirection: 'column'
  }, _defineProperty3(_ref23, mediaQuery.downTo(BreakpointNames.xs), {
    flexDirection: reverse ? 'row-reverse' : 'row',
    justifyContent: 'space-between'
  }), _defineProperty3(_ref23, "marginTop", '16px'), _ref23;
};
var resultSummary = _objectSpread3({
  fontFamily: fontFamily,
  marginTop: '16px',
  color: ui.greyDark[700]
}, heading5Obj);
var tableControlPanelProps = {
  /**
   * String to be placed in the aria live region for fiters.
   * Should have information for both global and column filters.
   */
  ariaLiveFilterString: propTypes.string,
  /**
   * array of column filter components. They will be cloned and
   * given keys
   */
  colFilters: propTypes.arrayOf(propTypes.node),
  /**
   * ref that should be placed on the wrapping div. passed
   * in from the table component
   */
  controlsRef: propTypes.shape({
    current: propTypes.any
  }),
  /**
   * description for the table. It will be rendered inside an h3
   */
  description: propTypes.string,
  /**
   * String to be applied as the title for the table
   */
  title: propTypes.string,
  /**
   * Id to be applied to the h2 title. This is used by the Table
   * component to properly apply aria-labelledby
   */
  titleId: propTypes.string,
  /**
   * string represnting the total results for the table
   */
  totalResults: propTypes.string,
  /**
   * function to render the column filters. It will be passed
   * an array of components representing filters
   */
  __renderColumnFilters: propTypes.func,
  /**
   * override function to render the description
   */
  __renderDescription: propTypes.func,
  /**
   * a function that is in charge of rendering the global filters.
   * This will be passed functions from react-table in Table.jsx
   */
  __renderGlobalFilters: propTypes.func,
  /**
   * function that will override the table label
   */
  __renderTitle: propTypes.func
};
var TableControlPanel = function TableControlPanel(props) {
  var ariaLiveFilterString = props.ariaLiveFilterString,
    colFilters = props.colFilters,
    controlsRef = props.controlsRef,
    description = props.description,
    titleId = props.titleId,
    title = props.title,
    totalResults = props.totalResults,
    __renderColumnFilters = props.__renderColumnFilters,
    __renderGlobalFilters = props.__renderGlobalFilters,
    __renderDescription = props.__renderDescription,
    __renderTitle = props.__renderTitle;
  return jsx("div", {
    ref: controlsRef,
    css: /*#__PURE__*/css([controlWrapperStyle], ";label:TableControlPanel;")
  }, __renderTitle ? __renderTitle({
    id: titleId,
    css: tableLabelStyle
  }) : jsx("h2", {
    id: titleId,
    css: tableLabelStyle
  }, title), __renderDescription ? __renderDescription({
    css: tableDescStyle
  }) : description && jsx("h3", {
    css: tableDescStyle
  }, description), jsx("div", {
    css: tableFilterContainer(colFilters.length > 0 || __renderColumnFilters)
  }, jsx("div", null, __renderGlobalFilters && __renderGlobalFilters()), jsx("div", null, __renderColumnFilters ? __renderColumnFilters(colFilters) : React__default.Children.map(colFilters, function (filter, index) {
    return /*#__PURE__*/React__default.cloneElement(filter, {
      key: "filter_column_".concat(index)
    });
  })), jsx(TableAriaLive, {
    text: ariaLiveFilterString
  })), jsx("div", {
    "aria-live": "polite",
    css: resultSummary
  }, totalResults));
};
TableControlPanel.propTypes = tableControlPanelProps;
TableControlPanel.defaultProps = {
  colFilters: []
};
TableControlPanel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableControlPanel",
  "props": {
    "colFilters": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "node"
        }
      },
      "required": false,
      "description": "array of column filter components. They will be cloned and\ngiven keys"
    },
    "ariaLiveFilterString": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to be placed in the aria live region for fiters.\nShould have information for both global and column filters."
    },
    "controlsRef": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "any",
            "required": false
          }
        }
      },
      "required": false,
      "description": "ref that should be placed on the wrapping div. passed\nin from the table component"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "description for the table. It will be rendered inside an h3"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String to be applied as the title for the table"
    },
    "titleId": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Id to be applied to the h2 title. This is used by the Table\ncomponent to properly apply aria-labelledby"
    },
    "totalResults": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "string represnting the total results for the table"
    },
    "__renderColumnFilters": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function to render the column filters. It will be passed\nan array of components representing filters"
    },
    "__renderDescription": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "override function to render the description"
    },
    "__renderGlobalFilters": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "a function that is in charge of rendering the global filters.\nThis will be passed functions from react-table in Table.jsx"
    },
    "__renderTitle": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will override the table label"
    }
  }
};
var tableProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * ariaProps applied to the outermost wrapper
   */
  ariaProps: propTypes.object,
  /**
   * the columns for the headers. To have a column be fixed
   * pass `fixed: true` to the column obj. see react-table
   * for more information
   */
  columns: propTypes.array.isRequired,
  /**
   * reference to the scroll container. if it is large enough
   * to scroll it will have a tab index of 0 applied to it
   */
  containerRef: propTypes.shape({
    current: propTypes.any
  }),
  /**
   * reference to the controls container.
   */
  controlsRef: propTypes.shape({
    current: propTypes.any
  }),
  /**
   * The data to be rendered in the table. See react-table
   * for more information
   */
  data: propTypes.array.isRequired,
  /**
   * data props applied to the outermost wrapper
   */
  dataProps: propTypes.object,
  /**
   * a string that will render below the title of the table.
   */
  description: propTypes.string,
  /**
   * Function that will be passed both global and local filters and should return a string
   * to be rendered in our aria-live region. The second parameter passed will be the
   * props returned from useTable
   */
  generateAriaLiveFilter: propTypes.func,
  /**
   * function that will be passed pagination state along with table props returned from react-table.
   * it should return a string
   */
  generateAriaLivePagination: propTypes.func,
  /**
   * function that will be passed flatRows length
   * see https://github.com/tannerlinsley/react-table/blob/master/docs/api/useTable.md#table-options
   * for more information.
   * Note: if you are doing server side rendering you will likely just get this data from the server
   */
  generateTotalResults: propTypes.func,
  /**
   * intial state of the react table
   * https://github.com/tannerlinsley/react-table/blob/master/docs/api/useTable.md#table-options
   */
  initialState: propTypes.object,
  /**
   * Overrides for server side controls
   * These will "turn off" client side controls.
   * To keep cognitive load light for devs we're
   * opting to say if you want one control to be
   * server side you need to have all of them be
   * server side. Otherwise they may forget to set
   * one of them and it could lead to a hard to track
   * bug. For example setting autoResetFilters to false
   * to stop retriggering the callback when a control
   * updates.
   */
  manualControls: propTypes.bool,
  /**
   * function that fires everytime the internal state of react-table updates
   * use this to assist with server side controls
   */
  onControlsUpdate: propTypes.func,
  /**
   * number of pages in the table. this is needed if manualControls is set to true
   */
  pageCount: propTypes.number,
  /**
   * expose useTable's hook prop for adding extra functionality
   */
  reactTableHooks: propTypes.array,
  /**
   * expose useTable's options prop for adding extra functionality
   */
  reactTableOptions: propTypes.object,
  /**
   * aria props applied to the table itself
   */
  tableAriaProps: propTypes.object,
  /**
   * data props applied to the table itself
   */
  tableDataProps: propTypes.object,
  /**
   * a string that appropriately labels the table
   */
  title: propTypes.oneOfType([propTypes.string]),
  /**
   * a function that will allow you to render something above the table. it will
   * be passed the object returned from useTable. Useful if used in conjunction with
   * reactTableHooks
   */
  __renderAboveTable: propTypes.func,
  /**
   * a function that will allow you to render something below the table. it will
   * be passed the object returned from useTable. Useful if used in conjunction with
   * reactTableHooks
   */
  __renderBelowTable: propTypes.func,
  /**
   * overrides our h3 description
   */
  __renderDescription: propTypes.func,
  /**
   * Function that renders column filters. currently we just blindly throw all
   * the filters into the dom with little to no styling so if you are using filters
   * you will likely want to set this.
   */
  __renderColumnFilters: propTypes.func,
  /**
   * Function that renders the global filters. If you are using global Filters you will need
   * to use this function.
   */
  __renderGlobalFilters: propTypes.func,
  /**
   * function that renders pagination controls. If you use pagination you will need to use this
   */
  __renderPagination: propTypes.func,
  /**
   * override our h2 title.
   */
  __renderTitle: propTypes.func
});
var labelWarning = 'The table requires a title that can be easily read by screen readers. please either provide a string for the title or use __renderTitle';
var Table = function Table(props) {
  /**
   * react-table requires that the data and columns be memoized
   */
  var columns = React.useMemo(function () {
    return props.columns;
  }, [props.columns]);
  var data = React.useMemo(function () {
    return props.data;
  }, [props.data]);
  /**
   * to ensure unique ids we use lodash.
   */

  var _React$useState15 = React.useState(uniqueId('table-label-')),
    _React$useState16 = _slicedToArray(_React$useState15, 1),
    labelId = _React$useState16[0];
  /**
   * need the size of the fixed column to get shadows to
   * work the way we want
   */

  var _React$useState17 = React.useState(-1),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    fixedColWidth = _React$useState18[0],
    setFixedColWidth = _React$useState18[1];
  /**
   * needed for sizing the after element which will mock our table's
   * borders
   */

  var _React$useState19 = React.useState(-1),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    captionHeight = _React$useState20[0],
    setCaptionHeight = _React$useState20[1];
  /**
   * needed for sizing the after element which will mock our table's
   * borders
   */

  var _React$useState21 = React.useState(-1),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    tableHeight = _React$useState22[0],
    setTableHeight = _React$useState22[1];
  var _React$useState23 = React.useState(-1),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    paginationHeight = _React$useState24[0],
    setPaginationHeight = _React$useState24[1];
  /**
   * used to set tab index if scrolling is necessary
   */

  var _React$useState25 = React.useState(null),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    tabIndex = _React$useState26[0],
    setTabIndex = _React$useState26[1];
  var windowSize = useWindowSize();
  /**
   * create the necessary refs
   */

  var stickyRef = React.useRef(null);
  var containerRef = props.containerRef ? props.containerRef : React.useRef(null);
  var controlsRef = props.controlsRef ? props.controlsRef : React.useRef(null);
  var tableRef = React.useRef(null);
  var paginationRef = React.useRef(null);
  /**
   * USELAYOUTEFFECT:
   * we're mutating the DOM here so we want to do useLayoutEffect
   * effect instead of useEffect
   *
   * Update the width of the column for shadows
   */

  React.useLayoutEffect(function () {
    if (stickyRef.current) {
      setFixedColWidth(stickyRef.current.getBoundingClientRect().width);
    }
  }, [windowSize.width, stickyRef.current]);
  /**
   * to make the caption not be inside the table border we need to get the height
   */

  React.useLayoutEffect(function () {
    setCaptionHeight(controlsRef.current.getBoundingClientRect().height);
  }, [windowSize.width, controlsRef.current]);
  React.useLayoutEffect(function () {
    setTableHeight(tableRef.current.getBoundingClientRect().height);
  }, [windowSize.width, windowSize.height, tableRef.current]);
  /**
   * because the pagination is at the bottom of the table but still within the
   * scrollable group controls, we need to absolutely position it. This breaks it
   * from the flow of the dom so to account for this we set a margin on
   * the bottom of the group so that outisde elements resepct the pagination controls
   */

  React.useLayoutEffect(function () {
    if (usesPagination) {
      setPaginationHeight(paginationRef.current.getBoundingClientRect().height);
    }
  }, [windowSize.width, paginationRef.current]);
  /**
   * update tab index if the table is scrollable or not
   */

  React.useEffect(function () {
    var clientWidth = containerRef.current.clientWidth;
    var scrollWidth = tableRef.current.scrollWidth;
    var scrollable = scrollWidth > clientWidth;
    setTabIndex(scrollable ? '0' : null);
  }, [windowSize, containerRef.current]);
  /**
   * figure out what's going on with the table label
   * and warn if there is no explicit label
   */

  if (!props.title && !props.__renderTitle) {
    console.warn(labelWarning);
  }
  /**
   * THIS WILL BE REPLACED WHEN ANGELOU HAS OPINIONS ON WHAT
   * PAGINATION LOOKS LIKE
   */

  var usesPagination = !!props.__renderPagination;
  /**
   * Overrides for server side controls
   * These will "turn off" client side controls.
   * To keep cognitive load light for devs we're
   * opting to say if you want one control to be
   * server side you need to have all of them be
   * server side. Otherwise they may forget to set
   * one of them and it could lead to a hard to track
   * bug. For example setting autoResetFilters to false
   * to stop retriggering the callback when a control
   * updates.
   */

  var manualControls = props.useManualControls ? {
    manualFilters: true,
    manualGlobalFilter: true,
    manualSortBy: true,
    manualPagination: true
  } : {};
  var hooks = [reactTable_3, reactTable_4, reactTable_2, usesPagination ? reactTable_5 : null].concat(_toConsumableArray3(props.reactTableHooks)).filter(function (hook) {
    return !!hook;
  });
  var rawTableProps = reactTable_1.apply(void 0, [_objectSpread3(_objectSpread3({
    columns: columns,
    data: data
  }, manualControls), {}, {
    // Required if manualPagination is set to true
    pageCount: props.pageCount,
    initialState: props.initialState
  }, props.reactTableOptions)].concat(_toConsumableArray3(hooks)));
  var getTableProps = rawTableProps.getTableProps,
    getTableBodyProps = rawTableProps.getTableBodyProps,
    headerGroups = rawTableProps.headerGroups,
    rows = rawTableProps.rows,
    page = rawTableProps.page,
    prepareRow = rawTableProps.prepareRow,
    preGlobalFilteredRows = rawTableProps.preGlobalFilteredRows,
    setGlobalFilter = rawTableProps.setGlobalFilter,
    state = rawTableProps.state;
  var pageIndex = state.pageIndex,
    pageSize = state.pageSize,
    sortBy = state.sortBy,
    filters = state.filters,
    globalFilter = state.globalFilter;
  /**
   * if they use pagination then we map the over the page, otherwise we map
   * over the rows
   */

  var rowDataToMap = usesPagination ? page : rows;
  /**
   * This is a slick trick I found to not run on initial render, and
   * not using state which would cause an additional render;
   * https://stackoverflow.com/questions/53253940/make-react-useeffect-hook-not-run-on-initial-render
   */

  var initialRender = React.useRef(true);
  React.useEffect(function () {
    if (props.onControlsUpdate) {
      if (initialRender.current) {
        initialRender.current = false;
      } else {
        props.onControlsUpdate({
          pageIndex: pageIndex,
          pageSize: pageSize,
          sortBy: sortBy,
          filters: filters,
          globalFilter: globalFilter
        });
      }
    }
  }, [pageIndex, pageSize, sortBy, filters, globalFilter]);
  var colFilters = rawTableProps.columns.filter(function (column) {
    return column.canFilter && column.Filter;
  }).map(function (column) {
    return column.render('Filter');
  });
  var ariaLiveFilterString = props.generateAriaLiveFilter ? props.generateAriaLiveFilter({
    filters: filters,
    globalFilter: globalFilter
  }, rawTableProps) : null;
  var ariaLivePaginationString = usesPagination && props.generateAriaLivePagination ? props.generateAriaLivePagination({
    pageIndex: pageIndex,
    pageSize: pageSize
  }, rawTableProps) : null;
  var totalResults = props.generateTotalResults ? props.generateTotalResults(rawTableProps.flatRows.length, rawTableProps) : null;
  var _getTableBodyProps = getTableBodyProps(),
    role = _getTableBodyProps.role,
    tBodyProps = _objectWithoutProperties3(_getTableBodyProps, _excluded14);
  return jsx("div", null, props.__renderAboveTable && props.__renderAboveTable(rawTableProps), jsx("div", _extends({
    css: /*#__PURE__*/css([borderStyle(captionHeight), props.__css && props.__css], ";label:Table;"),
    className: props.additionalClassName
  }, props.dataProps, props.ariaProps), jsx("div", {
    ref: containerRef,
    "aria-labelledby": labelId,
    role: "group",
    css: /*#__PURE__*/css([scrollerStyle(fixedColWidth, paginationHeight)], ";label:Table;"),
    tabIndex: tabIndex
  }, jsx(TableControlPanel, {
    ariaLiveFilterString: ariaLiveFilterString,
    controlsRef: controlsRef,
    title: props.title,
    titleId: labelId,
    description: props.description,
    colFilters: colFilters,
    totalResults: totalResults,
    __renderColumnFilters: props.__renderColumnFilters,
    __renderGlobalFilters: function __renderGlobalFilters() {
      return props.__renderGlobalFilters ? props.__renderGlobalFilters({
        preGlobalFilteredRows: preGlobalFilteredRows,
        setGlobalFilter: setGlobalFilter,
        globalFilter: globalFilter
      }) : null;
    },
    __renderTitle: props.__renderTitle,
    __renderDescription: props.__renderTableDescription
  }), jsx("table", _extends({}, getTableProps(), {
    css: /*#__PURE__*/css([tableStyles], ";label:Table;")
  }, props.tableDataProps, {
    "aria-labelledby": labelId
  }, props.tableAriaProps, {
    ref: tableRef
  }), jsx("thead", null, headerGroups.map(function (headerGroup, groupIndex) {
    return jsx("tr", _extends({
      role: "row",
      key: "group_".concat(groupIndex)
    }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column, colIndex) {
      var _column$getHeaderProp = column.getHeaderProps(column.getSortByToggleProps({
          title: column.label ? column.label : typeof column.Header === 'string' ? column.Header : column.id
        })),
        onClick = _column$getHeaderProp.onClick,
        key = _column$getHeaderProp.key,
        thProps = _objectWithoutProperties3(_column$getHeaderProp, _excluded15);
      return jsx(TableHeader, {
        column: column,
        onClick: onClick,
        key: key,
        thProps: thProps,
        ref: stickyRef
      });
    }));
  })), jsx("tbody", tBodyProps, rowDataToMap.map(function (row, rowIndex) {
    prepareRow(row);
    return jsx("tr", _extends({
      role: "row",
      key: "row_".concat(rowIndex)
    }, row.getRowProps()), row.cells.map(function (cell, cellIndex) {
      var cellProps = _objectSpread3({
        key: "row_".concat(rowIndex, "_cell_").concat(cellIndex),
        css: [tdStyle, cell.column.isSorted && selectedColTd, cell.column.fixed && stickyStyle]
      }, cell.getCellProps());
      return cell.column.fixed ? jsx("th", _extends({
        align: "left"
      }, cellProps, {
        role: "rowheader",
        scope: "row"
      }), cell.render('Cell')) : jsx("td", _extends({
        role: "cell"
      }, cellProps), cell.render('Cell'));
    }));
  }))), jsx("div", {
    css: paginationWrapper,
    ref: paginationRef
  }, usesPagination && props.__renderPagination && props.__renderPagination(rawTableProps, {
    pageIndex: pageIndex,
    pageSize: pageSize
  })), jsx(TableAriaLive, {
    text: generateSortByText(sortBy)
  }), jsx(TableAriaLive, {
    text: ariaLivePaginationString
  }))), props.__renderBelowTable && props.__renderBelowTable(rawTableProps));
};
Table.propTypes = tableProps;
Table.defaultProps = {
  reactTableHooks: []
};
Table.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Table",
  "props": {
    "reactTableHooks": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "expose useTable's hook prop for adding extra functionality"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "ariaProps applied to the outermost wrapper"
    },
    "columns": {
      "type": {
        "name": "array"
      },
      "required": true,
      "description": "the columns for the headers. To have a column be fixed\npass `fixed: true` to the column obj. see react-table\nfor more information"
    },
    "containerRef": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "any",
            "required": false
          }
        }
      },
      "required": false,
      "description": "reference to the scroll container. if it is large enough\nto scroll it will have a tab index of 0 applied to it"
    },
    "controlsRef": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "any",
            "required": false
          }
        }
      },
      "required": false,
      "description": "reference to the controls container."
    },
    "data": {
      "type": {
        "name": "array"
      },
      "required": true,
      "description": "The data to be rendered in the table. See react-table\nfor more information"
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "data props applied to the outermost wrapper"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "a string that will render below the title of the table."
    },
    "generateAriaLiveFilter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function that will be passed both global and local filters and should return a string\nto be rendered in our aria-live region. The second parameter passed will be the\nprops returned from useTable"
    },
    "generateAriaLivePagination": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will be passed pagination state along with table props returned from react-table.\nit should return a string"
    },
    "generateTotalResults": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will be passed flatRows length\nsee https://github.com/tannerlinsley/react-table/blob/master/docs/api/useTable.md#table-options\nfor more information.\nNote: if you are doing server side rendering you will likely just get this data from the server"
    },
    "initialState": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "intial state of the react table\nhttps://github.com/tannerlinsley/react-table/blob/master/docs/api/useTable.md#table-options"
    },
    "manualControls": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Overrides for server side controls\nThese will \"turn off\" client side controls.\nTo keep cognitive load light for devs we're\nopting to say if you want one control to be\nserver side you need to have all of them be\nserver side. Otherwise they may forget to set\none of them and it could lead to a hard to track\nbug. For example setting autoResetFilters to false\nto stop retriggering the callback when a control\nupdates."
    },
    "onControlsUpdate": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that fires everytime the internal state of react-table updates\nuse this to assist with server side controls"
    },
    "pageCount": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of pages in the table. this is needed if manualControls is set to true"
    },
    "reactTableOptions": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "expose useTable's options prop for adding extra functionality"
    },
    "tableAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "aria props applied to the table itself"
    },
    "tableDataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "data props applied to the table itself"
    },
    "title": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }]
      },
      "required": false,
      "description": "a string that appropriately labels the table"
    },
    "__renderAboveTable": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "a function that will allow you to render something above the table. it will\nbe passed the object returned from useTable. Useful if used in conjunction with\nreactTableHooks"
    },
    "__renderBelowTable": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "a function that will allow you to render something below the table. it will\nbe passed the object returned from useTable. Useful if used in conjunction with\nreactTableHooks"
    },
    "__renderDescription": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "overrides our h3 description"
    },
    "__renderColumnFilters": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function that renders column filters. currently we just blindly throw all\nthe filters into the dom with little to no styling so if you are using filters\nyou will likely want to set this."
    },
    "__renderGlobalFilters": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function that renders the global filters. If you are using global Filters you will need\nto use this function."
    },
    "__renderPagination": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that renders pagination controls. If you use pagination you will need to use this"
    },
    "__renderTitle": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "override our h2 title."
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var propTypes$4 = {
  // Corresponds to player state from video-react.
  playerState: propTypes.shape({
    isFullscreen: propTypes.bool,
    paused: propTypes.bool,
    userActivity: propTypes.bool
  }).isRequired,
  children: propTypes.node
};
var FullscreenOverlay = function FullscreenOverlay(_ref24) {
  var playerState = _ref24.playerState,
    children = _ref24.children;
  var isFullscreen = playerState.isFullscreen,
    paused = playerState.paused,
    userActivity = playerState.userActivity; // Do not put anything onto the DOM until / unless there are contents for the
  // overlay and the video player is in fullscreen mode

  var overlayExists = children && isFullscreen;
  if (!overlayExists) return null; // Auto-hide the overlay when the player is playing and there has been no
  // recent user activity, mimicking video-react's logic for auto-hiding the
  // control bar.

  var overlayInvisible = !paused && !userActivity;
  return jsx("h2", {
    css: /*#__PURE__*/css([heading2, fullscreenOverlay, overlayInvisible && fullscreenOverlayInvisible], ";label:FullscreenOverlay;")
  }, children);
};
FullscreenOverlay.propTypes = propTypes$4;
FullscreenOverlay.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FullscreenOverlay",
  "props": {
    "playerState": {
      "type": {
        "name": "shape",
        "value": {
          "isFullscreen": {
            "name": "bool",
            "required": false
          },
          "paused": {
            "name": "bool",
            "required": false
          },
          "userActivity": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": true,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
var videoProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * Path for the video source URL
   */
  src: propTypes.string,
  /**
   * Array of caption data (src, srcLang, label)
   */
  captions: propTypes.arrayOf(propTypes.shape({
    src: propTypes.string,
    srcLang: propTypes.string,
    label: propTypes.string
  })),
  audioDescriptions: propTypes.arrayOf(propTypes.shape({
    src: propTypes.string,
    srcLang: propTypes.string,
    label: propTypes.string
  })),
  /**
   * Content to display in the top overlay when in fullscreen mode.
   */
  fullscreenOverlayContents: propTypes.node,
  /**
   * Still image to display before the video has begun.
   */
  poster: propTypes.string
});
var VideoPlayer = /*#__PURE__*/React__default.forwardRef(function (props, externalRef) {
  var _React$useState27 = React.useState({}),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    playerState = _React$useState28[0],
    setPlayerState = _React$useState28[1];
  var isFullscreen = playerState.isFullscreen,
    muted = playerState.muted,
    paused = playerState.paused,
    userActivity = playerState.userActivity,
    hasStarted = playerState.hasStarted;
  var internalRef = React.useRef();
  var mergedRef = useMergedRefs(internalRef, externalRef);
  var actions = internalRef.current ? internalRef.current.actions : null;
  React.useEffect(function () {
    return internalRef.current.subscribeToStateChange(setPlayerState);
  }, []);
  var hideControlBar = !hasStarted || !paused && !userActivity;
  return jsx(ClassNames, null, function (_ref25) {
    var css = _ref25.css,
      cx = _ref25.cx;
    return jsx(lib_1, {
      playsInline: true,
      fluid: true,
      src: props.src,
      type: lib_1.mediaType.video,
      poster: props.poster,
      ref: mergedRef,
      crossOrigin: "anonymous"
    }, jsx(FullscreenOverlay, {
      playerState: playerState
    }, props.fullscreenOverlayContents), jsx(lib_5, {
      className: css(bigPlayButton),
      position: "center"
    }), props.captions && props.captions.map(function (_ref26) {
      var src = _ref26.src,
        srcLang = _ref26.srcLang,
        label = _ref26.label;
      return jsx("track", {
        key: src,
        kind: "captions",
        src: src,
        srcLang: srcLang,
        label: label,
        default: true
      });
    }), jsx(lib_16, {
      audioDescriptions: props.audioDescriptions,
      className: css(audioDescription)
    }), jsx(lib_15, {
      className: css(overlay)
    }), jsx(lib_2, {
      className: cx(css(toolBar), _defineProperty3({}, css(toolBarInvisible), hideControlBar)),
      disableDefaultControls: true
    }, jsx(lib_9, {
      className: css(progressBar)
    }), jsx("div", {
      className: css(displayFlex)
    }, jsx(Tooltip, {
      message: paused ? 'Play Video' : 'Pause Video',
      tooltipAlign: "left",
      tooltipHorizontalOffset: 25,
      additionalClassName: tooltipBorderRadius
    }, jsx(lib_6, {
      player: playerState,
      actions: actions,
      className: css(smallPlayButton)
    })), jsx(lib_10, {
      player: playerState,
      className: css(timeDisplay)
    }), jsx(lib_11, {
      player: playerState,
      className: css(timeDisplay, timeDivider)
    }), jsx(lib_12, {
      player: playerState,
      className: css(timeDisplay, timeDuration)
    }), jsx(Tooltip, {
      message: "Rewind 15 Seconds",
      hasRoundedCorners: true
    }, jsx(lib_4, {
      seconds: 15,
      actions: actions,
      className: css(replayIcon)
    })), muted ? jsx(Tooltip, {
      message: "Unmute",
      additionalClassName: tooltipBorderRadius
    }, jsx(lib_7, {
      player: playerState,
      actions: actions,
      vertical: true,
      className: css(volumeOffIcon)
    }, jsx(lib_14, {
      className: css(volumeBar)
    }))) : jsx(lib_7, {
      vertical: true,
      player: playerState,
      actions: actions,
      className: css(volumeOnIcon)
    }, jsx(lib_14, {
      className: css(volumeBar)
    }))), jsx("div", {
      className: css(displayFlex)
    }, jsx(Tooltip, {
      message: isFullscreen ? 'Exit Full Screen' : 'Full Screen',
      additionalClassName: tooltipBorderRadius
    }, jsx(lib_13, {
      player: playerState,
      actions: actions,
      className: isFullscreen ? css(fullscreenCollapseIcon) : css(fullscreenExpandIcon)
    })), jsx(Tooltip, {
      message: "Audio and CC",
      additionalClassName: tooltipBorderRadius,
      tooltipAlign: "right",
      tooltipHorizontalOffset: -30
    }, jsx(lib_3, {
      actions: actions,
      className: css(optionsIcon)
    })))));
  });
});
VideoPlayer.propTypes = videoProps;
VideoPlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "props": {
    "src": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Path for the video source URL"
    },
    "captions": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "src": {
              "name": "string",
              "required": false
            },
            "srcLang": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": "Array of caption data (src, srcLang, label)"
    },
    "audioDescriptions": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "src": {
              "name": "string",
              "required": false
            },
            "srcLang": {
              "name": "string",
              "required": false
            },
            "label": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": false,
      "description": ""
    },
    "fullscreenOverlayContents": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Content to display in the top overlay when in fullscreen mode."
    },
    "poster": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Still image to display before the video has begun."
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var playIcon = {
  height: '2em',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  fill: ui.white['100']
};
function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
var _ref$4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 0C7.175 0 0 7.175 0 16s7.175 16 16 16 16-7.175 16-16S24.825 0 16 0zm5.966 16.808l-7.633 5.024c-.647.439-1.533-.034-1.533-.809V10.977c0-.776.886-1.247 1.533-.809l7.632 5.023c.58.37.58 1.247.001 1.617z"
});
function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 32 32"
  }, props), _ref$4);
}
var videoCardProps = _objectSpread3(_objectSpread3({}, AngelouProps), {}, {
  /**
   * passed down to the card component
   */
  ariaProps: propTypes.object,
  /**
   * aria attributes passed to the a tag
   */
  anchorAriaProps: propTypes.object,
  classes: propTypes.shape({
    /**
     * classname applied to the footer wrapper
     */
    footer: propTypes.string,
    /**
     * classname applied to the card wrapper
    */
    root: propTypes.string,
    /**
     * classes object passed to the ContentCardTextual
     * see ContentCardVisual for more information
     */
    textual: propTypes.object,
    visual: propTypes.shape({
      root: propTypes.string,
      img: propTypes.string,
      overlay: propTypes.string
    })
  }),
  /**
   * passed down to the Card component
   */
  dataProps: propTypes.object,
  /**
   * date published of the video
   */
  datePublished: propTypes.string,
  /**
   * Video duration of the Card.
   */
  duration: propTypes.number,
  /**
   * react component/html that will render in the footer section of the card
   */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
   * props passed through to the BackgroundImage component.
   * we set a default for the aria-label, which you can override
   * by setting the img.ariaProps['aria-label']. For more information
   * see BackgroundImage
   */
  img: propTypes.shape(_objectSpread3(_objectSpread3({}, imgProps), {}, {
    ariaProps: propTypes.object
  })),
  /**
   * is the card vertical or not?
   */
  isVertical: propTypes.bool,
  /**
   * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseEnter={() => console.log('mouseEntered')}`
   */
  onMouseEnter: propTypes.func,
  /**
   * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
   *
   * **Example**:
   * `onMouseLeave={() => console.log('mouseLeft')}`
   */
  onMouseLeave: propTypes.func,
  /**
   * source of the video
   */
  source: propTypes.string,
  /**
   * title of the Card. This is also used for
   * default aria props
   */
  title: propTypes.string,
  /**
   * number of lines the title is allowed to be before being
   * truncated. defaults to 3.
   */
  titleLineNum: propTypes.number,
  /**
   * render prop to override the ContentType section. This will not
   * be called if __renderTextual is defined
   */
  __renderContentType: propTypes.func,
  /**
   * pass through to the Card component
   */
  __renderCustomLink: propTypes.func,
  /**
  * Pass __renderCustomWrapper a function to render the Card as something other than a div.
  *
  * **Example**:
  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (
      <article {...cardProps}>
        {linkTagWithChildren}
      </article>
  )}`
  */
  __renderCustomWrapper: propTypes.func,
  /**
   * allows you to override our rendering of the image component.
   * it will be passed a prop that can be spread on your container
   * in order to get the appropriate styles. If you set this you
   * take charge of the imageOverlay rendering as well
   */
  __renderImage: propTypes.func,
  /**
   * render prop to override the metaData. This will not
   * be called if __renderTextual is defined
   */
  __renderMetaData: propTypes.func,
  /**
   * render prop to create image overlays.
   */
  __renderImageOverlay: propTypes.func
});
var VideoCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  VideoCard.displayName = 'VideoCard';
  /**
   * We use passThroughProps here as a way to easily add new
   * props to all content cards. If the base component ContentCard
   * adds a new prop, we now only need to make sure to add it in one file
   * (of course we'll update the propTypes of other cards and their
   * readme's but lets lighten the cognitive load of the part that's
   * actually doint the work).
   * One thing to note though, make sure that passThroughProps goes
   * first when calling the component so the consumer props, cant override
   * ours.
   */

  var datePublished = props.datePublished,
    duration = props.duration,
    source = props.source,
    passThroughProps = _objectWithoutProperties3(props, _excluded16);
  var metaData = datePublished ? [source, dateFormatted(datePublished)] : [source];
  var durationObj = durationFormatted(duration);
  return jsx(ContentCard, _extends({}, passThroughProps, {
    ref: ref,
    contentType: "Video",
    imageOverlay: jsx("div", {
      css: /*#__PURE__*/css(_objectSpread3({
        flexDirection: 'column-reverse'
      }, defaultImageOverlayContainer), ";label:VideoCard;")
    }, jsx(SvgPlayIcon, {
      "aria-hidden": "true",
      css: playIcon
    }), duration && jsx("div", {
      css: imageOverlayTextStyle(passThroughProps.isVertical)
    }, jsx("span", {
      css: hiddenStyle
    }, durationObj.aria), jsx("span", {
      "aria-hidden": "true"
    }, durationObj.visual))),
    metaData: metaData
  }));
});
VideoCard.defaultProps = {
  isVertical: ContentCard.defaultProps.isVertical
};
VideoCard.propTypes = videoCardProps;
VideoCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "ContentCard.defaultProps.isVertical",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "is the card vertical or not?"
    },
    "ariaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the card component"
    },
    "anchorAriaProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "aria attributes passed to the a tag"
    },
    "classes": {
      "type": {
        "name": "shape",
        "value": {
          "footer": {
            "name": "string",
            "description": "classname applied to the footer wrapper",
            "required": false
          },
          "root": {
            "name": "string",
            "description": "classname applied to the card wrapper",
            "required": false
          },
          "textual": {
            "name": "object",
            "description": "classes object passed to the ContentCardTextual\nsee ContentCardVisual for more information",
            "required": false
          },
          "visual": {
            "name": "shape",
            "value": {
              "root": {
                "name": "string",
                "required": false
              },
              "img": {
                "name": "string",
                "required": false
              },
              "overlay": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "dataProps": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "passed down to the Card component"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date published of the video"
    },
    "duration": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Video duration of the Card."
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "react component/html that will render in the footer section of the card"
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "img": {
      "type": {
        "name": "shape",
        "value": {
          "ariaProps": {
            "name": "object",
            "required": false
          }
        }
      },
      "required": false,
      "description": "props passed through to the BackgroundImage component.\nwe set a default for the aria-label, which you can override\nby setting the img.ariaProps['aria-label']. For more information\nsee BackgroundImage"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "source": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "source of the video"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "title of the Card. This is also used for\ndefault aria props"
    },
    "titleLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "__renderContentType": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the ContentType section. This will not\nbe called if __renderTextual is defined"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "pass through to the Card component"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n  `__renderCustomWrapper={(cardProps, linkTagWithChildren) => (\n      <article {...cardProps}>\n        {linkTagWithChildren}\n      </article>\n  )}`"
    },
    "__renderImage": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "allows you to override our rendering of the image component.\nit will be passed a prop that can be spread on your container\nin order to get the appropriate styles. If you set this you\ntake charge of the imageOverlay rendering as well"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to override the metaData. This will not\nbe called if __renderTextual is defined"
    },
    "__renderImageOverlay": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "render prop to create image overlays."
    }
  },
  "composes": ["interfaces/angelouProps"]
};
var style$4 = {
  backgroundColor: ui.yellow['100']
};
var worksheetCardProps = _objectSpread3(_objectSpread3({
  /**
     * Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want
     * to apply aria attributes directly to the anchor tag.
     *
     * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
     *
     * **Example**:
     * `anchorAriaProps = {{
     * 'aria-label' : 'some-value',
     * 'aria-pressed : 'some-value'
     * }}`
     */
  anchorAriaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
     * Pass anchorDataProps an object containing data attributes if you have set the href prop and you want
     * to apply data attributes directly to the anchor tag.
     *
     * **Example**:
     * `anchorDataProps = {{ 'data-test' : 'some-value' }}`
     */
  anchorDataProps: propTypes.objectOf(propTypes.string)
}, AngelouProps), {}, {
  /**
     * Pass ariaProps an object containing aria attributes. These values will be passed down the <Card /> component.
     * If you have set the href prop you want to apply aria attributes directly to the anchor tag, use anchorAriaProps.
     *
     * Setting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.
     *
     * **Example**:
     * `ariaProps = {{
     * 'aria-label' : 'some-value',
     * 'aria-pressed : 'some-value'
     * }}`
     *
     */
  ariaProps: propTypes.objectOf(propTypes.oneOfType([propTypes.string, propTypes.bool])),
  /**
     * Pass dataProps an object containing data attributes. These values will be passed down the <Card /> component.
     * If you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.
     *
     * **Example**:
     * `dataProps = {{ 'data-test' : 'some-value' }}`
     */
  dataProps: propTypes.objectOf(propTypes.string),
  /**
     * date the Worksheet was published
     *
     * **Example**
     * `datePublished='Mon Apr 13 2020 15:06:39 GMT-0400 (Eastern Daylight Time)'
     */
  datePublished: propTypes.string,
  /**
     * Pass description a string to render the Worksheet description.
     *
     * **Example**:
     * `description='Text describing a worksheet...etc.'`
     */
  description: propTypes.string,
  /**
     * Number of lines the description is allowed to be before being
     * truncated. Vertical cards default to 4 lines. Horizontal cards default to 2 lines.
     */
  descriptionLineNum: propTypes.number,
  /**
     * Pass gradeRange a string representing the grades to which this Worksheet applies.
     *
     * **Example**
     * `gradeRange="K-4"`
    */
  gradeRange: propTypes.string,
  /**
     * Pass the footer prop a node that will render in the footer section of the card.
     */
  footer: propTypes.node,
  /**
     * Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.
     * If rendering the card using a <Link />, an object can be passed.
     *
     * **String example**:
     * `href='http://newsela.com'`
     *
     * **Object example**:
     *  `href={{
            pathname: /path/to/url},
            state: {
              ...
            }
          }}`
     */
  href: propTypes.oneOfType([propTypes.string, propTypes.object]),
  /**
     * Pass the isVertical prop a boolean value.
     *
     * **Example**:
     * `isVertical={true}`
     */
  isVertical: propTypes.bool,
  /**
     * Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />
     *
     * **Example**:
     * `loadingStateBackgroundColor="red"`
     */
  loadingStateBackgroundColor: propTypes.string,
  /**
     * Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />
     *
     * **Example**:
     * `loadingStateShimmerColor="blue"`
     */
  loadingStateShimmerColor: propTypes.string,
  /**
   * Pass the onClick prop a function.
   *
   * **Example**:
   * `onClick={() => console.log('clicked')}`
   */
  onClick: propTypes.func,
  /**
     * Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.
     *
     * **Example**:
     * `onMouseEnter={() => console.log('mouseEntered')}`
     */
  onMouseEnter: propTypes.func,
  /**
     * Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.
     *
     * **Example**:
     * `onMouseLeave={() => console.log('mouseLeft')}`
     */
  onMouseLeave: propTypes.func,
  /**
   * String representing the school subject for which this Worksheet applies.
   *
   * **Example**:
   * `subject='Social Studies'`
   */
  subject: propTypes.string,
  /**
       * Pass title a string to render the Workheet title.
       *
       * **Example**:
       * `title='History of Labor Unions Reading Guide`
       */
  title: propTypes.string,
  /**
     * number of lines the title is allowed to be before being
     * truncated. defaults to 3.
     */
  titleLineNum: propTypes.number,
  /**
     * Pass __renderCustomWrapper a function to render the Card as something other than a div.
     *
     * **Example**:
     `__renderCustomWrapper={(linkTagWithChildren, cardProps) => (
       <article {...cardProps}>
          {linkTagWithChildren}
        </article>
     )}`
    */
  __renderCustomWrapper: propTypes.func,
  /**
     * Pass __renderCustomLink a function to render the Card with a React Router Link.
     *
     * **Example**:
      `__renderCustomLink={(clickableCardStyle, href) => (
        <Link
          href={href}
          css={linkStyle}
        />
      )}`
    */
  __renderCustomLink: propTypes.func,
  /**
   * Pass __renderMetaData a function that will override our default use of the CardMetaData component.
   *
   * **Example**:
   *  `__renderMetaData={(css) => (
        <div {...css}>Item 1 | Item 2 | Item 3 | Item 4</div>
      )}`
   */
  __renderMetaData: propTypes.func
});
var WorksheetCard = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  /**
   * Explicitly setting the display name because creating components
   * using React.forwardRef strips the component name from React devtools.
   */
  WorksheetCard.displayName = 'WorksheetCard';
  var additionalClassName = props.additionalClassName,
    anchorAriaProps = props.anchorAriaProps,
    anchorDataProps = props.anchorDataProps,
    ariaProps = props.ariaProps,
    dataProps = props.dataProps,
    datePublished = props.datePublished,
    description = props.description,
    descriptionLineNum = props.descriptionLineNum,
    footer = props.footer,
    gradeRange = props.gradeRange,
    href = props.href,
    isVertical = props.isVertical,
    loadingStateBackgroundColor = props.loadingStateBackgroundColor,
    loadingStateShimmerColor = props.loadingStateShimmerColor,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    subject = props.subject,
    title = props.title,
    titleLineNum = props.titleLineNum,
    __css = props.__css,
    __renderCustomLink = props.__renderCustomLink,
    __renderCustomWrapper = props.__renderCustomWrapper,
    __renderMetaData = props.__renderMetaData;
  return jsx(StandardCard, {
    additionalClassName: additionalClassName,
    anchorAriaProps: anchorAriaProps,
    anchorDataProps: anchorDataProps,
    ariaProps: ariaProps,
    contentType: "Worksheet",
    dataProps: dataProps,
    datePublished: datePublished,
    description: description,
    descriptionLineNum: descriptionLineNum,
    footer: footer,
    gradeRange: gradeRange,
    href: href,
    isVertical: isVertical,
    loadingStateBackgroundColor: loadingStateBackgroundColor,
    loadingStateShimmerColor: loadingStateShimmerColor,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    subject: subject,
    __css: [style$4, __css],
    ref: ref,
    title: title,
    titleLineNum: titleLineNum,
    __renderCustomLink: __renderCustomLink,
    __renderCustomWrapper: __renderCustomWrapper,
    __renderMetaData: __renderMetaData
  });
});
WorksheetCard.propTypes = worksheetCardProps;
WorksheetCard.defaultProps = {
  isVertical: true,
  titleLineNum: 3,
  loadingStateBackgroundColor: ui.greyExtraLight[100],
  loadingStateShimmerColor: ui.yellow['100']
};
WorksheetCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WorksheetCard",
  "props": {
    "isVertical": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Pass the isVertical prop a boolean value.\n\n**Example**:\n`isVertical={true}`"
    },
    "titleLineNum": {
      "defaultValue": {
        "value": "3",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "number of lines the title is allowed to be before being\ntruncated. defaults to 3."
    },
    "loadingStateBackgroundColor": {
      "defaultValue": {
        "value": "ui.greyExtraLight[100]",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />\n\n**Example**:\n`loadingStateBackgroundColor=\"red\"`"
    },
    "loadingStateShimmerColor": {
      "defaultValue": {
        "value": "ui.yellow['100']",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass this prop a color string. The value gets passed down to the <LoadingShimmerComponent />\n\n**Example**:\n`loadingStateShimmerColor=\"blue\"`"
    },
    "anchorAriaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass anchorAriaProps an object containing aria attributes if you have set the href prop and you want\nto apply aria attributes directly to the anchor tag.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`anchorAriaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "anchorDataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass anchorDataProps an object containing data attributes if you have set the href prop and you want\nto apply data attributes directly to the anchor tag.\n\n**Example**:\n`anchorDataProps = {{ 'data-test' : 'some-value' }}`"
    },
    "ariaProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "bool"
          }]
        }
      },
      "required": false,
      "description": "Pass ariaProps an object containing aria attributes. These values will be passed down the <Card /> component.\nIf you have set the href prop you want to apply aria attributes directly to the anchor tag, use anchorAriaProps.\n\nSetting aria attributes is important for making components accessible to users needing assistive technologies like screenreaders.\n\n**Example**:\n`ariaProps = {{\n'aria-label' : 'some-value',\n'aria-pressed : 'some-value'\n}}`"
    },
    "dataProps": {
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": "Pass dataProps an object containing data attributes. These values will be passed down the <Card /> component.\nIf you have set the href prop you want to apply data information directly to the anchor tag, use anchorDataProps.\n\n**Example**:\n`dataProps = {{ 'data-test' : 'some-value' }}`"
    },
    "datePublished": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "date the Worksheet was published\n\n**Example**\n`datePublished='Mon Apr 13 2020 15:06:39 GMT-0400 (Eastern Daylight Time)'"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass description a string to render the Worksheet description.\n\n**Example**:\n`description='Text describing a worksheet...etc.'`"
    },
    "descriptionLineNum": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of lines the description is allowed to be before being\ntruncated. Vertical cards default to 4 lines. Horizontal cards default to 2 lines."
    },
    "gradeRange": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass gradeRange a string representing the grades to which this Worksheet applies.\n\n**Example**\n`gradeRange=\"K-4\"`"
    },
    "footer": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "Pass the footer prop a node that will render in the footer section of the card."
    },
    "href": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Pass the href prop a URL string or object. When rendering the card with an anchor tag, use a string.\nIf rendering the card using a <Link />, an object can be passed.\n\n**String example**:\n`href='http://newsela.com'`\n\n**Object example**:\n `href={{\n            pathname: /path/to/url},\n            state: {\n              ...\n            }\n          }}`"
    },
    "onClick": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onClick prop a function.\n\n**Example**:\n`onClick={() => console.log('clicked')}`"
    },
    "onMouseEnter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseEnter prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseEnter={() => console.log('mouseEntered')}`"
    },
    "onMouseLeave": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the onMouseLeave prop a function. This function could trigger style changes, data tracking, etc.\n\n**Example**:\n`onMouseLeave={() => console.log('mouseLeft')}`"
    },
    "subject": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "String representing the school subject for which this Worksheet applies.\n\n**Example**:\n`subject='Social Studies'`"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Pass title a string to render the Workheet title.\n\n**Example**:\n`title='History of Labor Unions Reading Guide`"
    },
    "__renderCustomWrapper": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomWrapper a function to render the Card as something other than a div.\n\n**Example**:\n     `__renderCustomWrapper={(linkTagWithChildren, cardProps) => (\n       <article {...cardProps}>\n          {linkTagWithChildren}\n        </article>\n     )}`"
    },
    "__renderCustomLink": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderCustomLink a function to render the Card with a React Router Link.\n\n**Example**:\n      `__renderCustomLink={(clickableCardStyle, href) => (\n        <Link\n          href={href}\n          css={linkStyle}\n        />\n      )}`"
    },
    "__renderMetaData": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass __renderMetaData a function that will override our default use of the CardMetaData component.\n\n**Example**:\n `__renderMetaData={(css) => (\n        <div {...css}>Item 1 | Item 2 | Item 3 | Item 4</div>\n      )}`"
    }
  },
  "composes": ["interfaces/angelouProps"]
};

// The exports from this file define the shared constants and components of
var index$1 = {
  constants: constants,
  // components
  ArticleCard: ArticleCard,
  AudioCard: AudioCard,
  AudioPlayer: AudioPlayer,
  BackgroundImg: BackgroundImg,
  BiographyCard: BiographyCard,
  Button: Button,
  Card: Card,
  CardMetaData: CardMetaData,
  CollectionCard: CollectionCard,
  ContentCard: ContentCard,
  ExternalLinkCard: ExternalLinkCard,
  InfographicCard: InfographicCard,
  LessonSparkCard: LessonSparkCard,
  LineClamp: LineClamp,
  LoadingShimmer: LoadingShimmer,
  Modal: Modal,
  MultiItemSVG: MultiItemSVG,
  TextSetCard: TextSetCard,
  PollCard: PollCard,
  SortingArrows: SortingArrows,
  StandardCard: StandardCard,
  Table: Table,
  TableHeader: TableHeader,
  VideoCard: VideoCard,
  VideoPlayer: VideoPlayer,
  WorksheetCard: WorksheetCard,
  // hooks
  useKeyUp: useKeyUp,
  useModal: useModal,
  useWindowSize: useWindowSize,
  useMergedRefs: useMergedRefs,
  // styles
  mediaQueryStyles: mediaQueryStyles,
  typographyStyles: typographyStyles,
  visuallyHiddenStyles: visuallyHiddenStyles
};
module.exports = index$1;